const t = '0.5.4',
  e = 0,
  i = 1,
  s = 2,
  n = 3,
  r = 4,
  a = 5,
  o = 6,
  h = 7,
  l = 8,
  c = {
    [e]: 'data',
    [i]: 'shcoef',
    [s]: 'environment',
    [n]: 'collision',
    [r]: 'index',
    [a]: 'meta',
    [o]: 'lutscale',
    [h]: 'lutsh',
    [l]: 'semantic',
  },
  u = 0,
  d = 1,
  f = 2,
  p = 3,
  m = '0-0',
  g = 0,
  y = 1,
  x = 0,
  v = 1,
  b = 2,
  w = {
    1: '\n        data:image/png;base64,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\n    ',
  },
  S = 0,
  M = 1,
  C = 1,
  E = 'Unknown',
  D = 'Windows',
  A = 'MacOS',
  F = 'Linux',
  P = 'Android',
  T = 'IOS',
  I = 'Desktop',
  _ = 'Mobile',
  R = 'Unknown',
  N = 'Edge',
  B = 'Chrome',
  k = 'Firefox',
  z = 'Safari',
  L = 'Opera',
  O = 'IE',
  H = 'MicroMessenger',
  j = 'Feishu',
  q = 'DingTalk',
  V = 'Bytedance',
  U = 'NewsArticle',
  K = 'Zhihu',
  G = 'Weibo',
  W = 'AlipayClient',
  Q = 'MQQBrowser',
  X = 'Unknown',
  Y = 'NVIDIA',
  Z = 'AMD',
  J = 'APPLE',
  $ = 128,
  tt = 1e-5,
  et = 1024,
  it = [
    [1, 0.75, 0],
    [0, 1, 0.5],
    [0, 0.5, 1],
    [1, 0.25, 1],
    [0.5, 0.5, 0.5],
    [0.5, 0, 1],
    [1, 1, 0.5],
    [0, 0.75, 0.75],
    [0, 1, 0],
    [0.5, 0.25, 0.25],
    [0.75, 0, 1],
    [1, 0.25, 0.5],
    [0.75, 0.5, 1],
    [1, 0.5, 0.5],
    [0.5, 1, 0],
    [1, 0.25, 0.25],
    [1, 1, 0.75],
    [0.5, 0.75, 0.75],
    [0.5, 0.25, 1],
    [0, 0, 1],
    [1, 1, 0],
    [1, 0.5, 0],
    [0.25, 1, 0.75],
    [1, 0.25, 0.75],
    [0.5, 1, 0.5],
    [0, 0.5, 0.75],
    [0, 0.25, 1],
    [1, 0, 0.5],
    [1, 0, 0.25],
    [0.25, 0.25, 0.25],
    [1, 0, 1],
    [0, 0.75, 0.5],
    [0, 1, 0.25],
    [0.25, 0.25, 1],
    [1, 1, 0.25],
    [1, 0.5, 0.75],
    [0.5, 0.5, 1],
    [0.25, 1, 0.25],
    [0.75, 0, 0.25],
    [1, 0.25, 0],
    [0.75, 1, 0.25],
    [1, 0.75, 0.25],
    [1, 0.5, 0.25],
    [1, 0, 0.75],
    [0.5, 1, 0.25],
    [0.75, 0.25, 1],
    [0.25, 0.5, 1],
    [0.75, 0, 0.5],
    [0.25, 1, 1],
    [0.25, 1, 0],
    [1, 0.5, 0.3],
    [0.75, 1, 0.5],
    [1, 0.75, 0.5],
    [1, 0.5, 1],
    [0.75, 1, 0],
    [0.25, 0, 1],
    [0.5, 0, 0],
    [0.25, 0.5, 0.75],
    [0.75, 0.5, 0],
    [0.25, 0.75, 0.75],
    [0.75, 0.75, 0.75],
    [0, 0, 0.5],
    [0.75, 1, 0.75],
    [0.25, 0.75, 0.25],
    [1, 0.75, 0.75],
    [0.25, 0, 0],
    [1, 0.75, 1],
    [0.25, 0, 0.25],
    [0.75, 0.75, 1],
    [0.5, 0.75, 1],
    [0.25, 0.75, 0.5],
    [0.25, 0.5, 0.5],
    [0.75, 0.25, 0.25],
    [0.75, 0.5, 0.25],
    [0.25, 0, 0.75],
    [0.75, 0.75, 0.25],
    [0.25, 0.5, 0.25],
    [0.5, 0.25, 0.5],
    [0.25, 0.5, 0],
    [0.75, 0.25, 0.5],
    [0.75, 0.5, 0.5],
    [0.5, 0.5, 0.25],
    [0.5, 0.25, 0.75],
    [0.75, 0.25, 0.75],
    [0.75, 0, 0],
    [0.5, 0, 0.5],
    [0.25, 0, 0.5],
    [0, 0.25, 0.5],
    [0.5, 0, 0.75],
    [0, 0.5, 0.5],
    [0, 0.5, 0.25],
    [0.75, 0, 0.75],
    [0.5, 0.5, 0],
    [0.5, 0.25, 0],
    [0.25, 0.25, 0],
    [0.75, 0.25, 0],
    [0.25, 0.75, 1],
    [0, 0.25, 0],
    [0.5, 0.75, 0.25],
    [0.25, 0, 0.5],
  ];
class st {
  constructor(t = 0, e = 0, i = 0, s = 1) {
    ((st.prototype.isVector4 = !0), (this.x = t), (this.y = e), (this.z = i), (this.w = s));
  }
  get width() {
    return this.z;
  }
  set width(t) {
    this.z = t;
  }
  get height() {
    return this.w;
  }
  set height(t) {
    this.w = t;
  }
  set(t, e, i, s) {
    return ((this.x = t), (this.y = e), (this.z = i), (this.w = s), this);
  }
  setScalar(t) {
    return ((this.x = t), (this.y = t), (this.z = t), (this.w = t), this);
  }
  setX(t) {
    return ((this.x = t), this);
  }
  setY(t) {
    return ((this.y = t), this);
  }
  setZ(t) {
    return ((this.z = t), this);
  }
  setW(t) {
    return ((this.w = t), this);
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      case 3:
        this.w = e;
        break;
      default:
        throw new Error('index is out of range: ' + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error('index is out of range: ' + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(t) {
    return ((this.x = t.x), (this.y = t.y), (this.z = t.z), (this.w = void 0 !== t.w ? t.w : 1), this);
  }
  add(t) {
    return ((this.x += t.x), (this.y += t.y), (this.z += t.z), (this.w += t.w), this);
  }
  addScalar(t) {
    return ((this.x += t), (this.y += t), (this.z += t), (this.w += t), this);
  }
  addVectors(t, e) {
    return ((this.x = t.x + e.x), (this.y = t.y + e.y), (this.z = t.z + e.z), (this.w = t.w + e.w), this);
  }
  addScaledVector(t, e) {
    return ((this.x += t.x * e), (this.y += t.y * e), (this.z += t.z * e), (this.w += t.w * e), this);
  }
  sub(t) {
    return ((this.x -= t.x), (this.y -= t.y), (this.z -= t.z), (this.w -= t.w), this);
  }
  subScalar(t) {
    return ((this.x -= t), (this.y -= t), (this.z -= t), (this.w -= t), this);
  }
  subVectors(t, e) {
    return ((this.x = t.x - e.x), (this.y = t.y - e.y), (this.z = t.z - e.z), (this.w = t.w - e.w), this);
  }
  multiply(t) {
    return ((this.x *= t.x), (this.y *= t.y), (this.z *= t.z), (this.w *= t.w), this);
  }
  multiplyScalar(t) {
    return ((this.x *= t), (this.y *= t), (this.z *= t), (this.w *= t), this);
  }
  applyMatrix4(t) {
    const e = this.x,
      i = this.y,
      s = this.z,
      n = this.w,
      r = t.elements;
    return (
      (this.x = r[0] * e + r[4] * i + r[8] * s + r[12] * n),
      (this.y = r[1] * e + r[5] * i + r[9] * s + r[13] * n),
      (this.z = r[2] * e + r[6] * i + r[10] * s + r[14] * n),
      (this.w = r[3] * e + r[7] * i + r[11] * s + r[15] * n),
      this
    );
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  setAxisAngleFromQuaternion(t) {
    this.w = 2 * Math.acos(t.w);
    const e = Math.sqrt(1 - t.w * t.w);
    return (
      e < 1e-4
        ? ((this.x = 1), (this.y = 0), (this.z = 0))
        : ((this.x = t.x / e), (this.y = t.y / e), (this.z = t.z / e)),
      this
    );
  }
  setAxisAngleFromRotationMatrix(t) {
    let e, i, s, n;
    const r = 0.01,
      a = 0.1,
      o = t.elements,
      h = o[0],
      l = o[4],
      c = o[8],
      u = o[1],
      d = o[5],
      f = o[9],
      p = o[2],
      m = o[6],
      g = o[10];
    if (Math.abs(l - u) < r && Math.abs(c - p) < r && Math.abs(f - m) < r) {
      if (Math.abs(l + u) < a && Math.abs(c + p) < a && Math.abs(f + m) < a && Math.abs(h + d + g - 3) < a)
        return (this.set(1, 0, 0, 0), this);
      e = Math.PI;
      const t = (h + 1) / 2,
        o = (d + 1) / 2,
        y = (g + 1) / 2,
        x = (l + u) / 4,
        v = (c + p) / 4,
        b = (f + m) / 4;
      return (
        t > o && t > y
          ? t < r
            ? ((i = 0), (s = 0.707106781), (n = 0.707106781))
            : ((i = Math.sqrt(t)), (s = x / i), (n = v / i))
          : o > y
            ? o < r
              ? ((i = 0.707106781), (s = 0), (n = 0.707106781))
              : ((s = Math.sqrt(o)), (i = x / s), (n = b / s))
            : y < r
              ? ((i = 0.707106781), (s = 0.707106781), (n = 0))
              : ((n = Math.sqrt(y)), (i = v / n), (s = b / n)),
        this.set(i, s, n, e),
        this
      );
    }
    let y = Math.sqrt((m - f) * (m - f) + (c - p) * (c - p) + (u - l) * (u - l));
    return (
      Math.abs(y) < 0.001 && (y = 1),
      (this.x = (m - f) / y),
      (this.y = (c - p) / y),
      (this.z = (u - l) / y),
      (this.w = Math.acos((h + d + g - 1) / 2)),
      this
    );
  }
  setFromMatrixPosition(t) {
    const e = t.elements;
    return ((this.x = e[12]), (this.y = e[13]), (this.z = e[14]), (this.w = e[15]), this);
  }
  min(t) {
    return (
      (this.x = Math.min(this.x, t.x)),
      (this.y = Math.min(this.y, t.y)),
      (this.z = Math.min(this.z, t.z)),
      (this.w = Math.min(this.w, t.w)),
      this
    );
  }
  max(t) {
    return (
      (this.x = Math.max(this.x, t.x)),
      (this.y = Math.max(this.y, t.y)),
      (this.z = Math.max(this.z, t.z)),
      (this.w = Math.max(this.w, t.w)),
      this
    );
  }
  clamp(t, e) {
    return (
      (this.x = Math.max(t.x, Math.min(e.x, this.x))),
      (this.y = Math.max(t.y, Math.min(e.y, this.y))),
      (this.z = Math.max(t.z, Math.min(e.z, this.z))),
      (this.w = Math.max(t.w, Math.min(e.w, this.w))),
      this
    );
  }
  clampScalar(t, e) {
    return (
      (this.x = Math.max(t, Math.min(e, this.x))),
      (this.y = Math.max(t, Math.min(e, this.y))),
      (this.z = Math.max(t, Math.min(e, this.z))),
      (this.w = Math.max(t, Math.min(e, this.w))),
      this
    );
  }
  clampLength(t, e) {
    const i = this.length();
    return this.divideScalar(i || 1).multiplyScalar(Math.max(t, Math.min(e, i)));
  }
  floor() {
    return (
      (this.x = Math.floor(this.x)),
      (this.y = Math.floor(this.y)),
      (this.z = Math.floor(this.z)),
      (this.w = Math.floor(this.w)),
      this
    );
  }
  ceil() {
    return (
      (this.x = Math.ceil(this.x)),
      (this.y = Math.ceil(this.y)),
      (this.z = Math.ceil(this.z)),
      (this.w = Math.ceil(this.w)),
      this
    );
  }
  round() {
    return (
      (this.x = Math.round(this.x)),
      (this.y = Math.round(this.y)),
      (this.z = Math.round(this.z)),
      (this.w = Math.round(this.w)),
      this
    );
  }
  roundToZero() {
    return (
      (this.x = Math.trunc(this.x)),
      (this.y = Math.trunc(this.y)),
      (this.z = Math.trunc(this.z)),
      (this.w = Math.trunc(this.w)),
      this
    );
  }
  negate() {
    return ((this.x = -this.x), (this.y = -this.y), (this.z = -this.z), (this.w = -this.w), this);
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return (
      (this.x += (t.x - this.x) * e),
      (this.y += (t.y - this.y) * e),
      (this.z += (t.z - this.z) * e),
      (this.w += (t.w - this.w) * e),
      this
    );
  }
  lerpVectors(t, e, i) {
    return (
      (this.x = t.x + (e.x - t.x) * i),
      (this.y = t.y + (e.y - t.y) * i),
      (this.z = t.z + (e.z - t.z) * i),
      (this.w = t.w + (e.w - t.w) * i),
      this
    );
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
  }
  equalsApproximately(t, e = 1e-10) {
    return (
      Math.abs(t.x - this.x) < e &&
      Math.abs(t.y - this.y) < e &&
      Math.abs(t.z - this.z) < e &&
      Math.abs(t.w - this.w) < e
    );
  }
  fromArray(t, e = 0) {
    return ((this.x = t[e]), (this.y = t[e + 1]), (this.z = t[e + 2]), (this.w = t[e + 3]), this);
  }
  toArray(t = [], e = 0) {
    return ((t[e] = this.x), (t[e + 1] = this.y), (t[e + 2] = this.z), (t[e + 3] = this.w), t);
  }
  fromBufferAttribute(t, e) {
    return ((this.x = t.getX(e)), (this.y = t.getY(e)), (this.z = t.getZ(e)), (this.w = t.getW(e)), this);
  }
  random() {
    return (
      (this.x = Math.random()),
      (this.y = Math.random()),
      (this.z = Math.random()),
      (this.w = Math.random()),
      this
    );
  }
  *[Symbol.iterator]() {
    (yield this.x, yield this.y, yield this.z, yield this.w);
  }
}
const nt = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '0a',
  '0b',
  '0c',
  '0d',
  '0e',
  '0f',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '1a',
  '1b',
  '1c',
  '1d',
  '1e',
  '1f',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '2a',
  '2b',
  '2c',
  '2d',
  '2e',
  '2f',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '3a',
  '3b',
  '3c',
  '3d',
  '3e',
  '3f',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '4a',
  '4b',
  '4c',
  '4d',
  '4e',
  '4f',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
  '5a',
  '5b',
  '5c',
  '5d',
  '5e',
  '5f',
  '60',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '6a',
  '6b',
  '6c',
  '6d',
  '6e',
  '6f',
  '70',
  '71',
  '72',
  '73',
  '74',
  '75',
  '76',
  '77',
  '78',
  '79',
  '7a',
  '7b',
  '7c',
  '7d',
  '7e',
  '7f',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '87',
  '88',
  '89',
  '8a',
  '8b',
  '8c',
  '8d',
  '8e',
  '8f',
  '90',
  '91',
  '92',
  '93',
  '94',
  '95',
  '96',
  '97',
  '98',
  '99',
  '9a',
  '9b',
  '9c',
  '9d',
  '9e',
  '9f',
  'a0',
  'a1',
  'a2',
  'a3',
  'a4',
  'a5',
  'a6',
  'a7',
  'a8',
  'a9',
  'aa',
  'ab',
  'ac',
  'ad',
  'ae',
  'af',
  'b0',
  'b1',
  'b2',
  'b3',
  'b4',
  'b5',
  'b6',
  'b7',
  'b8',
  'b9',
  'ba',
  'bb',
  'bc',
  'bd',
  'be',
  'bf',
  'c0',
  'c1',
  'c2',
  'c3',
  'c4',
  'c5',
  'c6',
  'c7',
  'c8',
  'c9',
  'ca',
  'cb',
  'cc',
  'cd',
  'ce',
  'cf',
  'd0',
  'd1',
  'd2',
  'd3',
  'd4',
  'd5',
  'd6',
  'd7',
  'd8',
  'd9',
  'da',
  'db',
  'dc',
  'dd',
  'de',
  'df',
  'e0',
  'e1',
  'e2',
  'e3',
  'e4',
  'e5',
  'e6',
  'e7',
  'e8',
  'e9',
  'ea',
  'eb',
  'ec',
  'ed',
  'ee',
  'ef',
  'f0',
  'f1',
  'f2',
  'f3',
  'f4',
  'f5',
  'f6',
  'f7',
  'f8',
  'f9',
  'fa',
  'fb',
  'fc',
  'fd',
  'fe',
  'ff',
];
let rt = 1234567;
const at = Math.PI / 180,
  ot = 180 / Math.PI;
function ht(t, e, i) {
  return Math.max(e, Math.min(i, t));
}
function lt(t, e) {
  return ((t % e) + e) % e;
}
function ct(t, e, i) {
  return (1 - i) * t + i * e;
}
const ut = {
  DEG2RAD: at,
  RAD2DEG: ot,
  generateUUID: function () {
    const t = (4294967295 * Math.random()) | 0,
      e = (4294967295 * Math.random()) | 0,
      i = (4294967295 * Math.random()) | 0,
      s = (4294967295 * Math.random()) | 0;
    return (
      nt[255 & t] +
      nt[(t >> 8) & 255] +
      nt[(t >> 16) & 255] +
      nt[(t >> 24) & 255] +
      '-' +
      nt[255 & e] +
      nt[(e >> 8) & 255] +
      '-' +
      nt[((e >> 16) & 15) | 64] +
      nt[(e >> 24) & 255] +
      '-' +
      nt[(63 & i) | 128] +
      nt[(i >> 8) & 255] +
      '-' +
      nt[(i >> 16) & 255] +
      nt[(i >> 24) & 255] +
      nt[255 & s] +
      nt[(s >> 8) & 255] +
      nt[(s >> 16) & 255] +
      nt[(s >> 24) & 255]
    ).toLowerCase();
  },
  clamp: ht,
  euclideanModulo: lt,
  mapLinear: function (t, e, i, s, n) {
    return s + ((t - e) * (n - s)) / (i - e);
  },
  inverseLerp: function (t, e, i) {
    return t !== e ? (i - t) / (e - t) : 0;
  },
  lerp: ct,
  damp: function (t, e, i, s) {
    return ct(t, e, 1 - Math.exp(-i * s));
  },
  pingpong: function (t, e = 1) {
    return e - Math.abs(lt(t, 2 * e) - e);
  },
  smoothstep: function (t, e, i) {
    return t <= e ? 0 : t >= i ? 1 : (t = (t - e) / (i - e)) * t * (3 - 2 * t);
  },
  smootherstep: function (t, e, i) {
    return t <= e ? 0 : t >= i ? 1 : (t = (t - e) / (i - e)) * t * t * (t * (6 * t - 15) + 10);
  },
  randInt: function (t, e) {
    return t + Math.floor(Math.random() * (e - t + 1));
  },
  randFloat: function (t, e) {
    return t + Math.random() * (e - t);
  },
  randFloatSpread: function (t) {
    return t * (0.5 - Math.random());
  },
  seededRandom: function (t) {
    void 0 !== t && (rt = t);
    let e = (rt += 1831565813);
    return (
      (e = Math.imul(e ^ (e >>> 15), 1 | e)),
      (e ^= e + Math.imul(e ^ (e >>> 7), 61 | e)),
      ((e ^ (e >>> 14)) >>> 0) / 4294967296
    );
  },
  degToRad: function (t) {
    return t * at;
  },
  radToDeg: function (t) {
    return t * ot;
  },
  isPowerOfTwo: function (t) {
    return !(t & (t - 1)) && 0 !== t;
  },
  ceilPowerOfTwo: function (t) {
    return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
  },
  floorPowerOfTwo: function (t) {
    return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
  },
  setQuaternionFromProperEuler: function (t, e, i, s, n) {
    const r = Math.cos,
      a = Math.sin,
      o = r(i / 2),
      h = a(i / 2),
      l = r((e + s) / 2),
      c = a((e + s) / 2),
      u = r((e - s) / 2),
      d = a((e - s) / 2),
      f = r((s - e) / 2),
      p = a((s - e) / 2);
    switch (n) {
      case 'XYX':
        t.set(o * c, h * u, h * d, o * l);
        break;
      case 'YZY':
        t.set(h * d, o * c, h * u, o * l);
        break;
      case 'ZXZ':
        t.set(h * u, h * d, o * c, o * l);
        break;
      case 'XZX':
        t.set(o * c, h * p, h * f, o * l);
        break;
      case 'YXY':
        t.set(h * f, o * c, h * p, o * l);
        break;
      case 'ZYZ':
        t.set(h * p, h * f, o * c, o * l);
        break;
      default:
        console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + n);
    }
  },
  normalize: function (t, e) {
    switch (e.constructor) {
      case Float32Array:
        return t;
      case Uint32Array:
        return Math.round(4294967295 * t);
      case Uint16Array:
        return Math.round(65535 * t);
      case Uint8Array:
        return Math.round(255 * t);
      case Int32Array:
        return Math.round(2147483647 * t);
      case Int16Array:
        return Math.round(32767 * t);
      case Int8Array:
        return Math.round(127 * t);
      default:
        throw new Error('Invalid component type.');
    }
  },
  denormalize: function (t, e) {
    switch (e.constructor) {
      case Float32Array:
        return t;
      case Uint32Array:
        return t / 4294967295;
      case Uint16Array:
        return t / 65535;
      case Uint8Array:
        return t / 255;
      case Int32Array:
        return Math.max(t / 2147483647, -1);
      case Int16Array:
        return Math.max(t / 32767, -1);
      case Int8Array:
        return Math.max(t / 127, -1);
      default:
        throw new Error('Invalid component type.');
    }
  },
};
class dt {
  constructor(t = 0, e = 0, i = 0, s = 1) {
    ((this.isQuaternion = !0), (this._x = t), (this._y = e), (this._z = i), (this._w = s));
  }
  static slerpFlat(t, e, i, s, n, r, a) {
    let o = i[s + 0],
      h = i[s + 1],
      l = i[s + 2],
      c = i[s + 3];
    const u = n[r + 0],
      d = n[r + 1],
      f = n[r + 2],
      p = n[r + 3];
    if (0 === a) return ((t[e + 0] = o), (t[e + 1] = h), (t[e + 2] = l), void (t[e + 3] = c));
    if (1 === a) return ((t[e + 0] = u), (t[e + 1] = d), (t[e + 2] = f), void (t[e + 3] = p));
    if (c !== p || o !== u || h !== d || l !== f) {
      let t = 1 - a;
      const e = o * u + h * d + l * f + c * p,
        i = e >= 0 ? 1 : -1,
        s = 1 - e * e;
      if (s > Number.EPSILON) {
        const n = Math.sqrt(s),
          r = Math.atan2(n, e * i);
        ((t = Math.sin(t * r) / n), (a = Math.sin(a * r) / n));
      }
      const n = a * i;
      if (((o = o * t + u * n), (h = h * t + d * n), (l = l * t + f * n), (c = c * t + p * n), t === 1 - a)) {
        const t = 1 / Math.sqrt(o * o + h * h + l * l + c * c);
        ((o *= t), (h *= t), (l *= t), (c *= t));
      }
    }
    ((t[e] = o), (t[e + 1] = h), (t[e + 2] = l), (t[e + 3] = c));
  }
  static multiplyQuaternionsFlat(t, e, i, s, n, r) {
    const a = i[s],
      o = i[s + 1],
      h = i[s + 2],
      l = i[s + 3],
      c = n[r],
      u = n[r + 1],
      d = n[r + 2],
      f = n[r + 3];
    return (
      (t[e] = a * f + l * c + o * d - h * u),
      (t[e + 1] = o * f + l * u + h * c - a * d),
      (t[e + 2] = h * f + l * d + a * u - o * c),
      (t[e + 3] = l * f - a * c - o * u - h * d),
      t
    );
  }
  get x() {
    return this._x;
  }
  set x(t) {
    ((this._x = t), this._onChangeCallback());
  }
  get y() {
    return this._y;
  }
  set y(t) {
    ((this._y = t), this._onChangeCallback());
  }
  get z() {
    return this._z;
  }
  set z(t) {
    ((this._z = t), this._onChangeCallback());
  }
  get w() {
    return this._w;
  }
  set w(t) {
    ((this._w = t), this._onChangeCallback());
  }
  set(t, e, i, s) {
    return ((this._x = t), (this._y = e), (this._z = i), (this._w = s), this._onChangeCallback(), this);
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(t) {
    return ((this._x = t.x), (this._y = t.y), (this._z = t.z), (this._w = t.w), this._onChangeCallback(), this);
  }
  setFromEuler(t, e = !0) {
    const i = t._x,
      s = t._y,
      n = t._z,
      r = t._order,
      a = Math.cos,
      o = Math.sin,
      h = a(i / 2),
      l = a(s / 2),
      c = a(n / 2),
      u = o(i / 2),
      d = o(s / 2),
      f = o(n / 2);
    switch (r) {
      case 'XYZ':
        ((this._x = u * l * c + h * d * f),
          (this._y = h * d * c - u * l * f),
          (this._z = h * l * f + u * d * c),
          (this._w = h * l * c - u * d * f));
        break;
      case 'YXZ':
        ((this._x = u * l * c + h * d * f),
          (this._y = h * d * c - u * l * f),
          (this._z = h * l * f - u * d * c),
          (this._w = h * l * c + u * d * f));
        break;
      case 'ZXY':
        ((this._x = u * l * c - h * d * f),
          (this._y = h * d * c + u * l * f),
          (this._z = h * l * f + u * d * c),
          (this._w = h * l * c - u * d * f));
        break;
      case 'ZYX':
        ((this._x = u * l * c - h * d * f),
          (this._y = h * d * c + u * l * f),
          (this._z = h * l * f - u * d * c),
          (this._w = h * l * c + u * d * f));
        break;
      case 'YZX':
        ((this._x = u * l * c + h * d * f),
          (this._y = h * d * c + u * l * f),
          (this._z = h * l * f - u * d * c),
          (this._w = h * l * c - u * d * f));
        break;
      case 'XZY':
        ((this._x = u * l * c - h * d * f),
          (this._y = h * d * c - u * l * f),
          (this._z = h * l * f + u * d * c),
          (this._w = h * l * c + u * d * f));
        break;
      default:
        console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + r);
    }
    return (!0 === e && this._onChangeCallback(), this);
  }
  setFromAxisAngle(t, e) {
    const i = e / 2,
      s = Math.sin(i);
    return (
      (this._x = t.x * s),
      (this._y = t.y * s),
      (this._z = t.z * s),
      (this._w = Math.cos(i)),
      this._onChangeCallback(),
      this
    );
  }
  setFromRotationMatrix(t) {
    const e = t.elements,
      i = e[0],
      s = e[4],
      n = e[8],
      r = e[1],
      a = e[5],
      o = e[9],
      h = e[2],
      l = e[6],
      c = e[10],
      u = i + a + c;
    if (u > 0) {
      const t = 0.5 / Math.sqrt(u + 1);
      ((this._w = 0.25 / t), (this._x = (l - o) * t), (this._y = (n - h) * t), (this._z = (r - s) * t));
    } else if (i > a && i > c) {
      const t = 2 * Math.sqrt(1 + i - a - c);
      ((this._w = (l - o) / t), (this._x = 0.25 * t), (this._y = (s + r) / t), (this._z = (n + h) / t));
    } else if (a > c) {
      const t = 2 * Math.sqrt(1 + a - i - c);
      ((this._w = (n - h) / t), (this._x = (s + r) / t), (this._y = 0.25 * t), (this._z = (o + l) / t));
    } else {
      const t = 2 * Math.sqrt(1 + c - i - a);
      ((this._w = (r - s) / t), (this._x = (n + h) / t), (this._y = (o + l) / t), (this._z = 0.25 * t));
    }
    return (this._onChangeCallback(), this);
  }
  setFromUnitVectors(t, e) {
    let i = t.dot(e) + 1;
    return (
      i < Number.EPSILON
        ? ((i = 0),
          Math.abs(t.x) > Math.abs(t.z)
            ? ((this._x = -t.y), (this._y = t.x), (this._z = 0), (this._w = i))
            : ((this._x = 0), (this._y = -t.z), (this._z = t.y), (this._w = i)))
        : ((this._x = t.y * e.z - t.z * e.y),
          (this._y = t.z * e.x - t.x * e.z),
          (this._z = t.x * e.y - t.y * e.x),
          (this._w = i)),
      this.normalize()
    );
  }
  angleTo(t) {
    return 2 * Math.acos(Math.abs(ht(this.dot(t), -1, 1)));
  }
  rotateTowards(t, e) {
    const i = this.angleTo(t);
    if (0 === i) return this;
    const s = Math.min(1, e / i);
    return (this.slerp(t, s), this);
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return ((this._x *= -1), (this._y *= -1), (this._z *= -1), this._onChangeCallback(), this);
  }
  dot(t) {
    return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let t = this.length();
    return (
      0 === t
        ? ((this._x = 0), (this._y = 0), (this._z = 0), (this._w = 1))
        : ((t = 1 / t),
          (this._x = this._x * t),
          (this._y = this._y * t),
          (this._z = this._z * t),
          (this._w = this._w * t)),
      this._onChangeCallback(),
      this
    );
  }
  multiply(t) {
    return this.multiplyQuaternions(this, t);
  }
  premultiply(t) {
    return this.multiplyQuaternions(t, this);
  }
  multiplyQuaternions(t, e) {
    const i = t._x,
      s = t._y,
      n = t._z,
      r = t._w,
      a = e._x,
      o = e._y,
      h = e._z,
      l = e._w;
    return (
      (this._x = i * l + r * a + s * h - n * o),
      (this._y = s * l + r * o + n * a - i * h),
      (this._z = n * l + r * h + i * o - s * a),
      (this._w = r * l - i * a - s * o - n * h),
      this._onChangeCallback(),
      this
    );
  }
  slerp(t, e) {
    if (0 === e) return this;
    if (1 === e) return this.copy(t);
    const i = this._x,
      s = this._y,
      n = this._z,
      r = this._w;
    let a = r * t._w + i * t._x + s * t._y + n * t._z;
    if (
      (a < 0 ? ((this._w = -t._w), (this._x = -t._x), (this._y = -t._y), (this._z = -t._z), (a = -a)) : this.copy(t),
      a >= 1)
    )
      return ((this._w = r), (this._x = i), (this._y = s), (this._z = n), this);
    const o = 1 - a * a;
    if (o <= Number.EPSILON) {
      const t = 1 - e;
      return (
        (this._w = t * r + e * this._w),
        (this._x = t * i + e * this._x),
        (this._y = t * s + e * this._y),
        (this._z = t * n + e * this._z),
        this.normalize(),
        this
      );
    }
    const h = Math.sqrt(o),
      l = Math.atan2(h, a),
      c = Math.sin((1 - e) * l) / h,
      u = Math.sin(e * l) / h;
    return (
      (this._w = r * c + this._w * u),
      (this._x = i * c + this._x * u),
      (this._y = s * c + this._y * u),
      (this._z = n * c + this._z * u),
      this._onChangeCallback(),
      this
    );
  }
  slerpQuaternions(t, e, i) {
    return this.copy(t).slerp(e, i);
  }
  random() {
    const t = 2 * Math.PI * Math.random(),
      e = 2 * Math.PI * Math.random(),
      i = Math.random(),
      s = Math.sqrt(1 - i),
      n = Math.sqrt(i);
    return this.set(s * Math.sin(t), s * Math.cos(t), n * Math.sin(e), n * Math.cos(e));
  }
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
  }
  equalsApproximately(t, e = 1e-10) {
    return (
      Math.abs(t.x - this.x) < e &&
      Math.abs(t.y - this.y) < e &&
      Math.abs(t.z - this.z) < e &&
      Math.abs(t.w - this.w) < e
    );
  }
  fromArray(t, e = 0) {
    return (
      (this._x = t[e]),
      (this._y = t[e + 1]),
      (this._z = t[e + 2]),
      (this._w = t[e + 3]),
      this._onChangeCallback(),
      this
    );
  }
  toArray(t = [], e = 0) {
    return ((t[e] = this._x), (t[e + 1] = this._y), (t[e + 2] = this._z), (t[e + 3] = this._w), t);
  }
  fromBufferAttribute(t, e) {
    return (
      (this._x = t.getX(e)),
      (this._y = t.getY(e)),
      (this._z = t.getZ(e)),
      (this._w = t.getW(e)),
      this._onChangeCallback(),
      this
    );
  }
  fromCesiumMatrix4(t) {
    let e,
      i,
      s,
      n,
      r,
      a = [1, 2, 0],
      o = new Array(3);
    const h = t[0],
      l = t[5],
      c = t[10],
      u = h + l + c;
    if (u > 0)
      ((e = Math.sqrt(u + 1)),
        (r = 0.5 * e),
        (e = 0.5 / e),
        (i = (t[6] - t[9]) * e),
        (s = (t[8] - t[2]) * e),
        (n = (t[1] - t[4]) * e));
    else {
      const u = a;
      let d = 0;
      (l > h && (d = 1), c > h && c > l && (d = 2));
      const f = u[d],
        p = u[f];
      e = Math.sqrt(t[ft(d, d)] - t[ft(f, f)] - t[ft(p, p)] + 1);
      const m = o;
      ((m[d] = 0.5 * e),
        (e = 0.5 / e),
        (r = (t[ft(p, f)] - t[ft(f, p)]) * e),
        (m[f] = (t[ft(f, d)] + t[ft(d, f)]) * e),
        (m[p] = (t[ft(p, d)] + t[ft(d, p)]) * e),
        (i = -m[0]),
        (s = -m[1]),
        (n = -m[2]));
    }
    return ((this.x = i), (this.y = s), (this.z = n), (this.w = r), this);
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(t) {
    return ((this._onChangeCallback = t), this);
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    (yield this._x, yield this._y, yield this._z, yield this._w);
  }
}
function ft(t, e) {
  return 4 * t + e;
}
class pt {
  constructor(t = 0, e = 0, i = 0) {
    ((pt.prototype.isVector3 = !0), (this.x = t), (this.y = e), (this.z = i));
  }
  set(t, e, i) {
    return (void 0 === i && (i = this.z), (this.x = t), (this.y = e), (this.z = i), this);
  }
  setScalar(t) {
    return ((this.x = t), (this.y = t), (this.z = t), this);
  }
  setX(t) {
    return ((this.x = t), this);
  }
  setY(t) {
    return ((this.y = t), this);
  }
  setZ(t) {
    return ((this.z = t), this);
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      default:
        throw new Error('index is out of range: ' + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error('index is out of range: ' + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(t) {
    return ((this.x = t.x), (this.y = t.y), (this.z = t.z), this);
  }
  add(t) {
    return ((this.x += t.x), (this.y += t.y), (this.z += t.z), this);
  }
  addScalar(t) {
    return ((this.x += t), (this.y += t), (this.z += t), this);
  }
  addVectors(t, e) {
    return ((this.x = t.x + e.x), (this.y = t.y + e.y), (this.z = t.z + e.z), this);
  }
  addScaledVector(t, e) {
    return ((this.x += t.x * e), (this.y += t.y * e), (this.z += t.z * e), this);
  }
  sub(t) {
    return ((this.x -= t.x), (this.y -= t.y), (this.z -= t.z), this);
  }
  subScalar(t) {
    return ((this.x -= t), (this.y -= t), (this.z -= t), this);
  }
  subVectors(t, e) {
    return ((this.x = t.x - e.x), (this.y = t.y - e.y), (this.z = t.z - e.z), this);
  }
  multiply(t) {
    return ((this.x *= t.x), (this.y *= t.y), (this.z *= t.z), this);
  }
  multiplyScalar(t) {
    return ((this.x *= t), (this.y *= t), (this.z *= t), this);
  }
  multiplyVectors(t, e) {
    return ((this.x = t.x * e.x), (this.y = t.y * e.y), (this.z = t.z * e.z), this);
  }
  applyEuler(t) {
    return this.applyQuaternion(gt.setFromEuler(t));
  }
  applyAxisAngle(t, e) {
    return this.applyQuaternion(gt.setFromAxisAngle(t, e));
  }
  applyMatrix3(t) {
    const e = this.x,
      i = this.y,
      s = this.z,
      n = t.elements;
    return (
      (this.x = n[0] * e + n[3] * i + n[6] * s),
      (this.y = n[1] * e + n[4] * i + n[7] * s),
      (this.z = n[2] * e + n[5] * i + n[8] * s),
      this
    );
  }
  applyNormalMatrix(t) {
    return this.applyMatrix3(t).normalize();
  }
  applyMatrix4(t) {
    const e = this.x,
      i = this.y,
      s = this.z,
      n = t.elements,
      r = 1 / (n[3] * e + n[7] * i + n[11] * s + n[15]);
    return (
      (this.x = (n[0] * e + n[4] * i + n[8] * s + n[12]) * r),
      (this.y = (n[1] * e + n[5] * i + n[9] * s + n[13]) * r),
      (this.z = (n[2] * e + n[6] * i + n[10] * s + n[14]) * r),
      this
    );
  }
  applyQuaternion(t) {
    const e = this.x,
      i = this.y,
      s = this.z,
      n = t.x,
      r = t.y,
      a = t.z,
      o = t.w,
      h = 2 * (r * s - a * i),
      l = 2 * (a * e - n * s),
      c = 2 * (n * i - r * e);
    return (
      (this.x = e + o * h + r * c - a * l),
      (this.y = i + o * l + a * h - n * c),
      (this.z = s + o * c + n * l - r * h),
      this
    );
  }
  project(t) {
    return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
  }
  unproject(t) {
    return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
  }
  transformDirection(t) {
    const e = this.x,
      i = this.y,
      s = this.z,
      n = t.elements;
    return (
      (this.x = n[0] * e + n[4] * i + n[8] * s),
      (this.y = n[1] * e + n[5] * i + n[9] * s),
      (this.z = n[2] * e + n[6] * i + n[10] * s),
      this.normalize()
    );
  }
  transformDirectionWithoutNormlize(t) {
    const e = this.x,
      i = this.y,
      s = this.z,
      n = t.elements;
    return (
      (this.x = n[0] * e + n[4] * i + n[8] * s),
      (this.y = n[1] * e + n[5] * i + n[9] * s),
      (this.z = n[2] * e + n[6] * i + n[10] * s),
      this
    );
  }
  divide(t) {
    return ((this.x /= t.x), (this.y /= t.y), (this.z /= t.z), this);
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  min(t) {
    return ((this.x = Math.min(this.x, t.x)), (this.y = Math.min(this.y, t.y)), (this.z = Math.min(this.z, t.z)), this);
  }
  max(t) {
    return ((this.x = Math.max(this.x, t.x)), (this.y = Math.max(this.y, t.y)), (this.z = Math.max(this.z, t.z)), this);
  }
  clamp(t, e) {
    return (
      (this.x = Math.max(t.x, Math.min(e.x, this.x))),
      (this.y = Math.max(t.y, Math.min(e.y, this.y))),
      (this.z = Math.max(t.z, Math.min(e.z, this.z))),
      this
    );
  }
  clampScalar(t, e) {
    return (
      (this.x = Math.max(t, Math.min(e, this.x))),
      (this.y = Math.max(t, Math.min(e, this.y))),
      (this.z = Math.max(t, Math.min(e, this.z))),
      this
    );
  }
  clampLength(t, e) {
    const i = this.length();
    return this.divideScalar(i || 1).multiplyScalar(Math.max(t, Math.min(e, i)));
  }
  floor() {
    return ((this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), (this.z = Math.floor(this.z)), this);
  }
  ceil() {
    return ((this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), (this.z = Math.ceil(this.z)), this);
  }
  round() {
    return ((this.x = Math.round(this.x)), (this.y = Math.round(this.y)), (this.z = Math.round(this.z)), this);
  }
  roundToZero() {
    return ((this.x = Math.trunc(this.x)), (this.y = Math.trunc(this.y)), (this.z = Math.trunc(this.z)), this);
  }
  negate() {
    return ((this.x = -this.x), (this.y = -this.y), (this.z = -this.z), this);
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return ((this.x += (t.x - this.x) * e), (this.y += (t.y - this.y) * e), (this.z += (t.z - this.z) * e), this);
  }
  lerpVectors(t, e, i) {
    return ((this.x = t.x + (e.x - t.x) * i), (this.y = t.y + (e.y - t.y) * i), (this.z = t.z + (e.z - t.z) * i), this);
  }
  cross(t) {
    return this.crossVectors(this, t);
  }
  crossVectors(t, e) {
    const i = t.x,
      s = t.y,
      n = t.z,
      r = e.x,
      a = e.y,
      o = e.z;
    return ((this.x = s * o - n * a), (this.y = n * r - i * o), (this.z = i * a - s * r), this);
  }
  projectOnVector(t) {
    const e = t.lengthSq();
    if (0 === e) return this.set(0, 0, 0);
    const i = t.dot(this) / e;
    return this.copy(t).multiplyScalar(i);
  }
  projectOnPlane(t) {
    return (mt.copy(this).projectOnVector(t), this.sub(mt));
  }
  reflect(t) {
    return this.sub(mt.copy(t).multiplyScalar(2 * this.dot(t)));
  }
  angleTo(t) {
    const e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (0 === e) return Math.PI / 2;
    const i = this.dot(t) / e;
    return Math.acos(ht(i, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const e = this.x - t.x,
      i = this.y - t.y,
      s = this.z - t.z;
    return e * e + i * i + s * s;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
  }
  setFromSpherical(t) {
    return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
  }
  setFromSphericalCoords(t, e, i) {
    const s = Math.sin(e) * t;
    return ((this.x = s * Math.sin(i)), (this.y = Math.cos(e) * t), (this.z = s * Math.cos(i)), this);
  }
  setFromCylindrical(t) {
    return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
  }
  setFromCylindricalCoords(t, e, i) {
    return ((this.x = t * Math.sin(e)), (this.y = i), (this.z = t * Math.cos(e)), this);
  }
  setFromMatrixPosition(t) {
    const e = t.elements;
    return ((this.x = e[12]), (this.y = e[13]), (this.z = e[14]), this);
  }
  setFromMatrixScale(t) {
    const e = this.setFromMatrixColumn(t, 0).length(),
      i = this.setFromMatrixColumn(t, 1).length(),
      s = this.setFromMatrixColumn(t, 2).length();
    return ((this.x = e), (this.y = i), (this.z = s), this);
  }
  setFromMatrixColumn(t, e) {
    return this.fromArray(t.elements, 4 * e);
  }
  setFromMatrix3Column(t, e) {
    return this.fromArray(t.elements, 3 * e);
  }
  setFromEuler(t) {
    return ((this.x = t._x), (this.y = t._y), (this.z = t._z), this);
  }
  setFromColor(t) {
    return ((this.x = t.r), (this.y = t.g), (this.z = t.b), this);
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z;
  }
  equalsApproximately(t, e = 1e-10) {
    return Math.abs(t.x - this.x) < e && Math.abs(t.y - this.y) < e && Math.abs(t.z - this.z) < e;
  }
  fromArray(t, e = 0) {
    return ((this.x = t[e]), (this.y = t[e + 1]), (this.z = t[e + 2]), this);
  }
  toArray(t = [], e = 0) {
    return ((t[e] = this.x), (t[e + 1] = this.y), (t[e + 2] = this.z), t);
  }
  fromBufferAttribute(t, e) {
    return ((this.x = t.getX(e)), (this.y = t.getY(e)), (this.z = t.getZ(e)), this);
  }
  random() {
    return ((this.x = Math.random()), (this.y = Math.random()), (this.z = Math.random()), this);
  }
  randomDirection() {
    const t = Math.random() * Math.PI * 2,
      e = 2 * Math.random() - 1,
      i = Math.sqrt(1 - e * e);
    return ((this.x = i * Math.cos(t)), (this.y = e), (this.z = i * Math.sin(t)), this);
  }
  *[Symbol.iterator]() {
    (yield this.x, yield this.y, yield this.z);
  }
}
const mt = new pt(),
  gt = new dt();
function yt(t) {
  if (t) return t instanceof ArrayBuffer ? t : t.buffer;
}
function xt(t, ...e) {
  try {
    t?.(...e);
  } catch (t) {
    console.error('Callback threw an error:', t);
  }
}
function vt(t, e, i = 1e-5) {
  return Math.abs(t.x - e.x) < i && Math.abs(t.y - e.y) < i && Math.abs(t.z - e.z) < i;
}
function bt(t) {
  const e = atob(t),
    i = new Uint8Array(e.length);
  for (let t = 0; t < e.length; t++) i[t] = e.charCodeAt(t);
  return new TextDecoder('utf-8').decode(i);
}
function wt(t) {
  return null == t;
}
function St(t, e) {
  return Mt(t) && t >= e;
}
function Mt(t) {
  return 'number' == typeof t && Number.isFinite(t);
}
function Ct(t) {
  return !Mt(t);
}
function Et(t, e, i = 8) {
  let s = Math.sqrt(t),
    n = Math.floor(s / i) * i;
  0 === n && (n = i);
  let r = Math.ceil(t / n);
  if (n > e || r > e) throw new Error('texture oversize !!!');
  return { x: n, y: r };
}
function Dt(t, e, i) {
  if (i <= 1) return [[t, e]];
  const s = [],
    n = Math.floor(i / 2);
  let r = t - n,
    a = e + n;
  const o = [1, 0, -1, 0],
    h = [0, -1, 0, 1];
  for (let t = 0; t < 4; t++) for (let e = 0; e < i - 1; e++) (s.push([r, a]), (r += o[t]), (a += h[t]));
  return s;
}
function At(t) {
  if (!t) return 0;
  const e = Math.log2(t);
  return ((e + 1) * e) / 2;
}
function Ft(t, e) {
  if (!e[t]) return;
  const i = new pt(),
    s = e[t];
  if (Array.isArray(s) && 3 === s.length) ((i.x = s[0]), (i.y = s[1]), (i.z = s[2]));
  else {
    if (void 0 === s?.x || void 0 === s?.y || void 0 === s?.z)
      return void console.error(`Set clip box ${t} failed, plase input [x, y, z] or {x, y, z}`);
    ((i.x = s.x), (i.y = s.y), (i.z = s.z));
  }
  return i;
}
function Pt(t, e) {
  let i, s;
  const n = e.x,
    r = e.y;
  if (t) {
    const e = t.getBoundingClientRect(),
      a = e.left,
      o = e.top;
    ((i = (n - a) / e.width), (s = (r - o) / e.height));
  } else
    ((i = n / window.innerWidth),
      (s = r / window.innerHeight),
      console.warn('没有传入canvas, 计算依据window窗口大小!'));
  return new pt(2 * i - 1, 2 * -s + 1, 0.5);
}
class Tt {
  type = E;
  version = 'Unknown';
  devType = I;
  cores = 0;
  realWith = 0;
  realHeight = 0;
  hasTouch = !1;
}
class It {
  type = X;
  series = 'Unknown';
  model = 0;
  textureSize = 0;
  textureUnitsCount = 0;
  limitLoadSplatCount = 0;
}
class _t {
  type = R;
  version = 'Unknown';
}
class Rt {
  browser;
  gpu;
  os;
  libType;
  constructor(t) {
    ((this.browser = this.#t()), (this.gpu = this.#e()), (this.os = this.#i()), (this.libType = this.#s(t)));
  }
  #s(t) {
    let e = b;
    return (t && (t.BufferGeometry ? (e = x) : t.Cartesian3 && (e = v)), console.log('engine type: ' + e), e);
  }
  #e() {
    const t = new It(),
      e = document.createElement('canvas').getContext('experimental-webgl');
    if (!e) return (console.log('WebGL not supported'), t);
    const i = e.getExtension('WEBGL_debug_renderer_info');
    if (i) {
      const s = e.getParameter(i.UNMASKED_RENDERER_WEBGL),
        n = e.getParameter(i.UNMASKED_VENDOR_WEBGL);
      if ((console.log(`GPU Renderer: ${s}`), console.log(`GPU Vendor: ${n}`), /NVIDIA/.test(n))) {
        if (((t.type = Y), s)) {
          const e = s.match(/(?:GT|GTX|RTX)\s(\d+)/);
          if (e) {
            const i = e[0],
              s = e[1];
            ((t.series = i), (t.model = this.#n(s) ? Number(s) : s));
          }
        }
      } else if (/AMD/.test(n)) {
        if (((t.type = Z), s)) {
          const e = s.match(/(?:RX|HD|R7|R5)\s(\d+)/);
          if (e) {
            const i = e[0],
              s = e[1];
            ((t.series = i), (t.model = this.#n(s) ? Number(s) : s));
          }
        }
      } else if (/Apple/.test(n) && ((t.type = J), s)) {
        const e = s.match(/Apple\s+(M[12])/);
        if (e) {
          const i = e[0],
            s = e[1];
          ((t.series = i), (t.model = this.#n(s) ? Number(s) : s));
        }
      }
    } else console.log('WEBGL_debug_renderer_info not available');
    return (
      (t.textureUnitsCount = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS)),
      (t.textureSize = e.getParameter(e.MAX_TEXTURE_SIZE)),
      (t.limitLoadSplatCount = (t.textureSize * t.textureSize) / 4),
      console.log('gpu: ', t.type, ',', t.series, ',', t.model),
      console.log('gl: ', t.textureUnitsCount, t.textureSize, t.limitLoadSplatCount),
      t
    );
  }
  #i() {
    const t = navigator.userAgent.toLowerCase();
    let e = E,
      i = 'Unknown',
      s = I,
      n = navigator.hardwareConcurrency || 0;
    if (t.includes('windows nt')) {
      e = D;
      const s = t.match(/windows nt (\d+\.\d+)/);
      s && s[1] && (i = s[1]);
    } else if (t.includes('macintosh') || t.includes('mac os x'))
      if (t.includes('iphone') || t.includes('ipad')) {
        e = T;
        const s = t.match(/(iphone|cpu) os (\d+[._]\d+[._]?\d*)/);
        ((i = s.join('&')), s && s[2] && (i = s[2].replace(/_/g, '.')));
      } else {
        e = A;
        const s = t.match(/mac os x (\d+[._]\d+)/);
        s && s[1] && (i = s[1].replace('_', '.'));
      }
    else if (t.includes('android')) {
      e = P;
      const s = t.match(/android (\d+(\.\d+)?)/);
      s && s[1] && (i = s[1]);
    } else t.includes('linux') && (e = F);
    ((e != P && e != T) || (s = _), console.log('os: ' + e + '/' + i + ', ' + n + ' (' + s + ')'));
    const r = new Tt();
    return (
      (r.type = e),
      (r.version = i),
      (r.devType = s),
      (r.cores = Mt(n) ? n : 0),
      (r.realWith = screen.width * window.devicePixelRatio),
      (r.realHeight = screen.height * window.devicePixelRatio),
      (r.hasTouch = 'ontouchstart' in window),
      r
    );
  }
  #t() {
    console.log('userAgent: ', window.navigator.userAgent);
    const t = navigator.userAgent.toLowerCase();
    let e = R,
      i = 'Unknown';
    if (
      /Feishu|DingTalk|MicroMessenger|Bytedance|NewsArticle|Zhihu|Weibo|AlipayClient|MQQBrowser/.test(
        navigator.userAgent,
      )
    ) {
      let t = navigator.userAgent.match(
        /Feishu|DingTalk|MicroMessenger|Bytedance|NewsArticle|Zhihu|Weibo|AlipayClient|MQQBrowser/,
      );
      ((t = t && t[0] ? t[0] : 'Unknown'),
        'Feishu' === t
          ? (e = j)
          : 'DingTalk' === t
            ? (e = q)
            : 'MicroMessenger' === t
              ? (e = H)
              : 'Bytedance' === t
                ? (e = V)
                : 'NewsArticle' === t
                  ? (e = U)
                  : 'Zhihu' === t
                    ? (e = K)
                    : 'Weibo' === t
                      ? (e = G)
                      : 'AlipayClient' === t
                        ? (e = W)
                        : 'MQQBrowser' === t && (e = Q),
        (i = navigator.userAgent.match(
          /(?:Feishu|DingTalk|MicroMessenger|Bytedance|NewsArticle|Zhihu|Weibo|AlipayClient|MQQBrowser)\/([\d.]+)/,
        )),
        (i = i && i[1] ? i[1] : 'Unknown'));
    } else
      /edg\//.test(t)
        ? ((e = N), (i = t.match(/edg\/(\d+)/)), (i = i && i[1] ? i[1] : 'Unknown'))
        : /chrome|crios\//.test(t) && !/edg\//.test(t)
          ? ((e = B), (i = t.match(/(?:chrome|crios)\/(\d+)/)), (i = i && i[1] ? i[1] : 'Unknown'))
          : /firefox|fxios\//.test(t)
            ? ((e = k), (i = t.match(/(?:firefox|fxios)\/(\d+)/)), (i = i && i[1] ? i[1] : 'Unknown'))
            : /safari/.test(t) && !/chrome/.test(t)
              ? ((e = z), (i = t.match(/version\/(\d+)/)), (i = i && i[1] ? i[1] : 'Unknown'))
              : /opr\//.test(t) || /opera/.test(t)
                ? ((e = L), (i = t.match(/opr\/(\d+)/)), (i = i && i[1] ? i[1] : 'Unknown'))
                : (/msie/.test(t) || /trident/.test(t)) &&
                  ((e = O), (i = t.match(/(msie|rv:)(\d+)/)), (i = i && i[2] ? i[2] : 'Unknown'));
    console.log('browser: ', e, i);
    const s = new _t();
    return ((s.type = e), (s.version = i), s);
  }
  #n(t) {
    return /^-?\d+(\.\d+)?$/.test(t);
  }
}
class Nt {
  MaxCPUCacheSize = void 0;
  MaxGPUCacheSize = void 0;
}
class Bt {
  MaxCPUCacheSize = 1610612736;
  MaxGPUCacheSize = 3221225472;
  MaxCPUCollCacheSize = 524288e3;
  MaxGPUCollCacheSize = 524288e3;
  MaxIndexDBCacheSize = 10737418240;
  CollBuildThreadNum = 2;
  DecompressThreadNum = 4;
  LocalCacheNum = 2;
  constructor(t, e) {
    if (!t) return;
    const i = t.os,
      s = t.gpu;
    (t.browser,
      i.devType == _
        ? ((this.MaxCPUCacheSize = 125829120),
          (this.MaxGPUCacheSize = 209715200),
          (this.MaxCPUCollCacheSize = 104857600),
          (this.MaxGPUCollCacheSize = 209715200),
          (this.MaxIndexDBCacheSize = 4294967296),
          (this.CollBuildThreadNum = 1),
          (this.DecompressThreadNum = 2))
        : (i.cores < 9 || s.type == X) &&
          ((this.MaxCPUCacheSize = 1073741824),
          (this.MaxGPUCacheSize = 1073741824),
          (this.MaxCPUCollCacheSize = 262144e3),
          (this.MaxGPUCollCacheSize = 262144e3),
          (this.CollBuildThreadNum = 2),
          (this.DecompressThreadNum = 3)),
      e &&
        (Mt(e.MaxCPUCacheSize) && (this.MaxCPUCacheSize = e.MaxCPUCacheSize),
        Mt(e.MaxGPUCacheSize) && (this.MaxGPUCacheSize = e.MaxGPUCacheSize),
        (Mt(e.MaxCPUCacheSize) || Mt(e.MaxGPUCacheSize)) && console.log('use external config: ', e)));
  }
}
class kt {
  TextureSize = 1024;
  LodStrategy = C;
  MaxLodDistance = 200;
  LodStepDistance = 20;
  MinValidSplatsInUnit = 100;
  MinValidSplatsInNode = 50;
  LodLevelUpSpatsInNode = 2e6;
  MergeSplatsReqThreshold = 8192;
  MergeSplatsReqEnable = !1;
  GloballHeight = 20;
  CpuSortThreadNum = 6;
  GpuMaxUploadBytes = 31457280;
  GpuMaxUploadCount = 100;
  MeshCanShowThreshold = 2;
  CameraPosChangedSortThreshold = 0.3;
  CameraAngleChangedSortThreshold = Math.cos((10 * Math.PI) / 180);
  TemporaryUnlimitReqiredSplatCount = 3e6;
  sortDrawCallCount = 100;
  WebglSortingEnable = !1;
  AlwaysDownloadAround = !0;
  enableDepthSorting = !1;
  useLccCompress = !1;
  gridDelta = 0;
  gridSize = 0;
  hasSemantic = !1;
  semanticType = u;
  semanticDataSize = 0;
  semanticFileOffset = 0;
  dataSize = 32;
  shDataSize = 64;
  hasSH = !0;
  shFileOffset = 0;
  MinLodUsed = 1;
  MaxLodUsed = 16;
  MaxDistaneLimit = 200;
  maxLoadSplatCount = 3e6;
  skipScreenSpaceErrorFactor = 16;
  useSH = !1;
  useEnv = !0;
  useEdgeCrop = !1;
  useClipPlane = !1;
  useClipBox = !1;
  useLodLevelUp = !0;
  useLodAutoOptimization = !1;
  useLoadingEffect = !1;
  loadingEffectCenter = null;
  useSemantic = !1;
  pointsOnly = !1;
  visible = !0;
  alpha = 1;
  pointsColor = M;
  gpuAcceleration = !1;
  fullRenderLod = 0;
  fullRendering = !1;
  constructor(t) {
    if (!t) return;
    const e = t.os,
      i = t.gpu,
      s = t.browser;
    ((this.TextureSize = i.textureSize),
      e.type === D
        ? i.type != X
          ? s.type !== k &&
            (i.type === Y && Mt(i.model)
              ? i.model < 1050
                ? (this.maxLoadSplatCount = 1e6)
                : i.model < 2060 && (this.maxLoadSplatCount = 2e6)
              : i.type === Z &&
                Mt(i.model) &&
                (i.model < 560 ? (this.maxLoadSplatCount = 1e6) : i.model < 5600 && (this.maxLoadSplatCount = 2e6)))
          : (this.maxLoadSplatCount = 2e6)
        : e.type === A && (this.maxLoadSplatCount = 25e5),
      e.devType == _
        ? ((this.maxLoadSplatCount = 1e6),
          (this.MaxLodDistance = 30),
          (this.LodLevelUpSpatsInNode = 5e5),
          (this.CpuSortThreadNum = 2),
          (this.MinLodUsed = 1),
          (this.MaxDistaneLimit = 100),
          (this.GpuMaxUploadBytes = 4194304),
          (this.GpuMaxUploadCount = 30))
        : (e.cores < 9 || i.type == X) &&
          ((this.LodLevelUpSpatsInNode = 9e5), (this.GpuMaxUploadBytes = 4194304), (this.GpuMaxUploadCount = 30)),
      (this.maxLoadSplatCount = Math.min(i.limitLoadSplatCount, this.maxLoadSplatCount)),
      console.log('m: ', this.maxLoadSplatCount, this.LodLevelUpSpatsInNode));
  }
  getUserConfig() {
    return {
      useSH: this.useSH,
      useEnv: this.useEnv,
      pointsOnly: this.pointsOnly,
      pointsColor: this.pointsColor === S ? 'default' : 'rainbow',
      maxLoadSplatCount: this.maxLoadSplatCount,
      visible: this.visible,
    };
  }
  setUserConfig(t) {
    ('boolean' == typeof t?.useSH && (this.useSH = t.useSH),
      'boolean' == typeof t?.useEnv && (this.useEnv = t.useEnv),
      'boolean' == typeof t?.pointsOnly && (this.pointsOnly = t.pointsOnly),
      ('default' !== t?.pointsColor && 'rainbow' !== t?.pointsColor) ||
        (this.pointsColor = 'default' === t?.pointsColor ? S : M),
      'number' == typeof t?.maxLoadSplatCount && (this.maxLoadSplatCount = t.maxLoadSplatCount),
      'boolean' == typeof t?.visible && (this.visible = t.visible));
  }
}
const zt = 2e3,
  Lt = 2001;
class Ot {
  constructor(t, e, i, s, n, r, a, o, h, l, c, u, d, f, p, m) {
    ((Ot.prototype.isMatrix4 = !0),
      (this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      void 0 !== t && this.set(t, e, i, s, n, r, a, o, h, l, c, u, d, f, p, m));
  }
  set(t, e, i, s, n, r, a, o, h, l, c, u, d, f, p, m) {
    const g = this.elements;
    return (
      (g[0] = t),
      (g[4] = e),
      (g[8] = i),
      (g[12] = s),
      (g[1] = n),
      (g[5] = r),
      (g[9] = a),
      (g[13] = o),
      (g[2] = h),
      (g[6] = l),
      (g[10] = c),
      (g[14] = u),
      (g[3] = d),
      (g[7] = f),
      (g[11] = p),
      (g[15] = m),
      this
    );
  }
  identity() {
    return (this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this);
  }
  clone() {
    return new Ot().fromArray(this.elements);
  }
  copy(t) {
    const e = this.elements,
      i = t.elements;
    return (
      (e[0] = i[0]),
      (e[1] = i[1]),
      (e[2] = i[2]),
      (e[3] = i[3]),
      (e[4] = i[4]),
      (e[5] = i[5]),
      (e[6] = i[6]),
      (e[7] = i[7]),
      (e[8] = i[8]),
      (e[9] = i[9]),
      (e[10] = i[10]),
      (e[11] = i[11]),
      (e[12] = i[12]),
      (e[13] = i[13]),
      (e[14] = i[14]),
      (e[15] = i[15]),
      this
    );
  }
  copyPosition(t) {
    const e = this.elements,
      i = t.elements;
    return ((e[12] = i[12]), (e[13] = i[13]), (e[14] = i[14]), this);
  }
  setFromMatrix3(t) {
    const e = t.elements;
    return (this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this);
  }
  extractBasis(t, e, i) {
    return (t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this);
  }
  makeBasis(t, e, i) {
    return (this.set(t.x, e.x, i.x, 0, t.y, e.y, i.y, 0, t.z, e.z, i.z, 0, 0, 0, 0, 1), this);
  }
  extractRotation(t) {
    const e = this.elements,
      i = t.elements,
      s = 1 / Ht.setFromMatrixColumn(t, 0).length(),
      n = 1 / Ht.setFromMatrixColumn(t, 1).length(),
      r = 1 / Ht.setFromMatrixColumn(t, 2).length();
    return (
      (e[0] = i[0] * s),
      (e[1] = i[1] * s),
      (e[2] = i[2] * s),
      (e[3] = 0),
      (e[4] = i[4] * n),
      (e[5] = i[5] * n),
      (e[6] = i[6] * n),
      (e[7] = 0),
      (e[8] = i[8] * r),
      (e[9] = i[9] * r),
      (e[10] = i[10] * r),
      (e[11] = 0),
      (e[12] = 0),
      (e[13] = 0),
      (e[14] = 0),
      (e[15] = 1),
      this
    );
  }
  makeRotationFromEuler(t) {
    const e = this.elements,
      i = t.x,
      s = t.y,
      n = t.z,
      r = Math.cos(i),
      a = Math.sin(i),
      o = Math.cos(s),
      h = Math.sin(s),
      l = Math.cos(n),
      c = Math.sin(n);
    if ('XYZ' === t.order) {
      const t = r * l,
        i = r * c,
        s = a * l,
        n = a * c;
      ((e[0] = o * l),
        (e[4] = -o * c),
        (e[8] = h),
        (e[1] = i + s * h),
        (e[5] = t - n * h),
        (e[9] = -a * o),
        (e[2] = n - t * h),
        (e[6] = s + i * h),
        (e[10] = r * o));
    } else if ('YXZ' === t.order) {
      const t = o * l,
        i = o * c,
        s = h * l,
        n = h * c;
      ((e[0] = t + n * a),
        (e[4] = s * a - i),
        (e[8] = r * h),
        (e[1] = r * c),
        (e[5] = r * l),
        (e[9] = -a),
        (e[2] = i * a - s),
        (e[6] = n + t * a),
        (e[10] = r * o));
    } else if ('ZXY' === t.order) {
      const t = o * l,
        i = o * c,
        s = h * l,
        n = h * c;
      ((e[0] = t - n * a),
        (e[4] = -r * c),
        (e[8] = s + i * a),
        (e[1] = i + s * a),
        (e[5] = r * l),
        (e[9] = n - t * a),
        (e[2] = -r * h),
        (e[6] = a),
        (e[10] = r * o));
    } else if ('ZYX' === t.order) {
      const t = r * l,
        i = r * c,
        s = a * l,
        n = a * c;
      ((e[0] = o * l),
        (e[4] = s * h - i),
        (e[8] = t * h + n),
        (e[1] = o * c),
        (e[5] = n * h + t),
        (e[9] = i * h - s),
        (e[2] = -h),
        (e[6] = a * o),
        (e[10] = r * o));
    } else if ('YZX' === t.order) {
      const t = r * o,
        i = r * h,
        s = a * o,
        n = a * h;
      ((e[0] = o * l),
        (e[4] = n - t * c),
        (e[8] = s * c + i),
        (e[1] = c),
        (e[5] = r * l),
        (e[9] = -a * l),
        (e[2] = -h * l),
        (e[6] = i * c + s),
        (e[10] = t - n * c));
    } else if ('XZY' === t.order) {
      const t = r * o,
        i = r * h,
        s = a * o,
        n = a * h;
      ((e[0] = o * l),
        (e[4] = -c),
        (e[8] = h * l),
        (e[1] = t * c + n),
        (e[5] = r * l),
        (e[9] = i * c - s),
        (e[2] = s * c - i),
        (e[6] = a * l),
        (e[10] = n * c + t));
    }
    return ((e[3] = 0), (e[7] = 0), (e[11] = 0), (e[12] = 0), (e[13] = 0), (e[14] = 0), (e[15] = 1), this);
  }
  makeRotationFromQuaternion(t) {
    return this.compose(qt, t, Vt);
  }
  lookAt(t, e, i) {
    const s = this.elements;
    return (
      Gt.subVectors(t, e),
      0 === Gt.lengthSq() && (Gt.z = 1),
      Gt.normalize(),
      Ut.crossVectors(i, Gt),
      0 === Ut.lengthSq() &&
        (1 === Math.abs(i.z) ? (Gt.x += 1e-4) : (Gt.z += 1e-4), Gt.normalize(), Ut.crossVectors(i, Gt)),
      Ut.normalize(),
      Kt.crossVectors(Gt, Ut),
      (s[0] = Ut.x),
      (s[4] = Kt.x),
      (s[8] = Gt.x),
      (s[1] = Ut.y),
      (s[5] = Kt.y),
      (s[9] = Gt.y),
      (s[2] = Ut.z),
      (s[6] = Kt.z),
      (s[10] = Gt.z),
      this
    );
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, e) {
    const i = t.elements,
      s = e.elements,
      n = this.elements,
      r = i[0],
      a = i[4],
      o = i[8],
      h = i[12],
      l = i[1],
      c = i[5],
      u = i[9],
      d = i[13],
      f = i[2],
      p = i[6],
      m = i[10],
      g = i[14],
      y = i[3],
      x = i[7],
      v = i[11],
      b = i[15],
      w = s[0],
      S = s[4],
      M = s[8],
      C = s[12],
      E = s[1],
      D = s[5],
      A = s[9],
      F = s[13],
      P = s[2],
      T = s[6],
      I = s[10],
      _ = s[14],
      R = s[3],
      N = s[7],
      B = s[11],
      k = s[15];
    return (
      (n[0] = r * w + a * E + o * P + h * R),
      (n[4] = r * S + a * D + o * T + h * N),
      (n[8] = r * M + a * A + o * I + h * B),
      (n[12] = r * C + a * F + o * _ + h * k),
      (n[1] = l * w + c * E + u * P + d * R),
      (n[5] = l * S + c * D + u * T + d * N),
      (n[9] = l * M + c * A + u * I + d * B),
      (n[13] = l * C + c * F + u * _ + d * k),
      (n[2] = f * w + p * E + m * P + g * R),
      (n[6] = f * S + p * D + m * T + g * N),
      (n[10] = f * M + p * A + m * I + g * B),
      (n[14] = f * C + p * F + m * _ + g * k),
      (n[3] = y * w + x * E + v * P + b * R),
      (n[7] = y * S + x * D + v * T + b * N),
      (n[11] = y * M + x * A + v * I + b * B),
      (n[15] = y * C + x * F + v * _ + b * k),
      this
    );
  }
  multiplyScalar(t) {
    const e = this.elements;
    return (
      (e[0] *= t),
      (e[4] *= t),
      (e[8] *= t),
      (e[12] *= t),
      (e[1] *= t),
      (e[5] *= t),
      (e[9] *= t),
      (e[13] *= t),
      (e[2] *= t),
      (e[6] *= t),
      (e[10] *= t),
      (e[14] *= t),
      (e[3] *= t),
      (e[7] *= t),
      (e[11] *= t),
      (e[15] *= t),
      this
    );
  }
  determinant() {
    const t = this.elements,
      e = t[0],
      i = t[4],
      s = t[8],
      n = t[12],
      r = t[1],
      a = t[5],
      o = t[9],
      h = t[13],
      l = t[2],
      c = t[6],
      u = t[10],
      d = t[14];
    return (
      t[3] * (+n * o * c - s * h * c - n * a * u + i * h * u + s * a * d - i * o * d) +
      t[7] * (+e * o * d - e * h * u + n * r * u - s * r * d + s * h * l - n * o * l) +
      t[11] * (+e * h * c - e * a * d - n * r * c + i * r * d + n * a * l - i * h * l) +
      t[15] * (-s * a * l - e * o * c + e * a * u + s * r * c - i * r * u + i * o * l)
    );
  }
  transpose() {
    const t = this.elements;
    let e;
    return (
      (e = t[1]),
      (t[1] = t[4]),
      (t[4] = e),
      (e = t[2]),
      (t[2] = t[8]),
      (t[8] = e),
      (e = t[6]),
      (t[6] = t[9]),
      (t[9] = e),
      (e = t[3]),
      (t[3] = t[12]),
      (t[12] = e),
      (e = t[7]),
      (t[7] = t[13]),
      (t[13] = e),
      (e = t[11]),
      (t[11] = t[14]),
      (t[14] = e),
      this
    );
  }
  setPosition(t, e, i) {
    const s = this.elements;
    return (
      t.isVector3 ? ((s[12] = t.x), (s[13] = t.y), (s[14] = t.z)) : ((s[12] = t), (s[13] = e), (s[14] = i)),
      this
    );
  }
  invert() {
    const t = this.elements,
      e = t[0],
      i = t[1],
      s = t[2],
      n = t[3],
      r = t[4],
      a = t[5],
      o = t[6],
      h = t[7],
      l = t[8],
      c = t[9],
      u = t[10],
      d = t[11],
      f = t[12],
      p = t[13],
      m = t[14],
      g = t[15],
      y = c * m * h - p * u * h + p * o * d - a * m * d - c * o * g + a * u * g,
      x = f * u * h - l * m * h - f * o * d + r * m * d + l * o * g - r * u * g,
      v = l * p * h - f * c * h + f * a * d - r * p * d - l * a * g + r * c * g,
      b = f * c * o - l * p * o - f * a * u + r * p * u + l * a * m - r * c * m,
      w = e * y + i * x + s * v + n * b;
    if (0 === w) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const S = 1 / w;
    return (
      (t[0] = y * S),
      (t[1] = (p * u * n - c * m * n - p * s * d + i * m * d + c * s * g - i * u * g) * S),
      (t[2] = (a * m * n - p * o * n + p * s * h - i * m * h - a * s * g + i * o * g) * S),
      (t[3] = (c * o * n - a * u * n - c * s * h + i * u * h + a * s * d - i * o * d) * S),
      (t[4] = x * S),
      (t[5] = (l * m * n - f * u * n + f * s * d - e * m * d - l * s * g + e * u * g) * S),
      (t[6] = (f * o * n - r * m * n - f * s * h + e * m * h + r * s * g - e * o * g) * S),
      (t[7] = (r * u * n - l * o * n + l * s * h - e * u * h - r * s * d + e * o * d) * S),
      (t[8] = v * S),
      (t[9] = (f * c * n - l * p * n - f * i * d + e * p * d + l * i * g - e * c * g) * S),
      (t[10] = (r * p * n - f * a * n + f * i * h - e * p * h - r * i * g + e * a * g) * S),
      (t[11] = (l * a * n - r * c * n - l * i * h + e * c * h + r * i * d - e * a * d) * S),
      (t[12] = b * S),
      (t[13] = (l * p * s - f * c * s + f * i * u - e * p * u - l * i * m + e * c * m) * S),
      (t[14] = (f * a * s - r * p * s - f * i * o + e * p * o + r * i * m - e * a * m) * S),
      (t[15] = (r * c * s - l * a * s + l * i * o - e * c * o - r * i * u + e * a * u) * S),
      this
    );
  }
  scale(t) {
    const e = this.elements,
      i = t.x,
      s = t.y,
      n = t.z;
    return (
      (e[0] *= i),
      (e[4] *= s),
      (e[8] *= n),
      (e[1] *= i),
      (e[5] *= s),
      (e[9] *= n),
      (e[2] *= i),
      (e[6] *= s),
      (e[10] *= n),
      (e[3] *= i),
      (e[7] *= s),
      (e[11] *= n),
      this
    );
  }
  getMaxScaleOnAxis() {
    const t = this.elements,
      e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2],
      i = t[4] * t[4] + t[5] * t[5] + t[6] * t[6],
      s = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
    return Math.sqrt(Math.max(e, i, s));
  }
  makeTranslation(t, e, i) {
    return (
      t.isVector3
        ? this.set(1, 0, 0, t.x, 0, 1, 0, t.y, 0, 0, 1, t.z, 0, 0, 0, 1)
        : this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1),
      this
    );
  }
  makeRotationX(t) {
    const e = Math.cos(t),
      i = Math.sin(t);
    return (this.set(1, 0, 0, 0, 0, e, -i, 0, 0, i, e, 0, 0, 0, 0, 1), this);
  }
  makeRotationY(t) {
    const e = Math.cos(t),
      i = Math.sin(t);
    return (this.set(e, 0, i, 0, 0, 1, 0, 0, -i, 0, e, 0, 0, 0, 0, 1), this);
  }
  makeRotationZ(t) {
    const e = Math.cos(t),
      i = Math.sin(t);
    return (this.set(e, -i, 0, 0, i, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this);
  }
  makeRotationAxis(t, e) {
    const i = Math.cos(e),
      s = Math.sin(e),
      n = 1 - i,
      r = t.x,
      a = t.y,
      o = t.z,
      h = n * r,
      l = n * a;
    return (
      this.set(
        h * r + i,
        h * a - s * o,
        h * o + s * a,
        0,
        h * a + s * o,
        l * a + i,
        l * o - s * r,
        0,
        h * o - s * a,
        l * o + s * r,
        n * o * o + i,
        0,
        0,
        0,
        0,
        1,
      ),
      this
    );
  }
  makeScale(t, e, i) {
    return (this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this);
  }
  makeShear(t, e, i, s, n, r) {
    return (this.set(1, i, n, 0, t, 1, r, 0, e, s, 1, 0, 0, 0, 0, 1), this);
  }
  compose(t, e, i) {
    const s = this.elements,
      n = e._x,
      r = e._y,
      a = e._z,
      o = e._w,
      h = n + n,
      l = r + r,
      c = a + a,
      u = n * h,
      d = n * l,
      f = n * c,
      p = r * l,
      m = r * c,
      g = a * c,
      y = o * h,
      x = o * l,
      v = o * c,
      b = i.x,
      w = i.y,
      S = i.z;
    return (
      (s[0] = (1 - (p + g)) * b),
      (s[1] = (d + v) * b),
      (s[2] = (f - x) * b),
      (s[3] = 0),
      (s[4] = (d - v) * w),
      (s[5] = (1 - (u + g)) * w),
      (s[6] = (m + y) * w),
      (s[7] = 0),
      (s[8] = (f + x) * S),
      (s[9] = (m - y) * S),
      (s[10] = (1 - (u + p)) * S),
      (s[11] = 0),
      (s[12] = t.x),
      (s[13] = t.y),
      (s[14] = t.z),
      (s[15] = 1),
      this
    );
  }
  decompose(t, e, i) {
    const s = this.elements;
    let n = Ht.set(s[0], s[1], s[2]).length();
    const r = Ht.set(s[4], s[5], s[6]).length(),
      a = Ht.set(s[8], s[9], s[10]).length();
    (this.determinant() < 0 && (n = -n), (t.x = s[12]), (t.y = s[13]), (t.z = s[14]), jt.copy(this));
    const o = 1 / n,
      h = 1 / r,
      l = 1 / a;
    return (
      (jt.elements[0] *= o),
      (jt.elements[1] *= o),
      (jt.elements[2] *= o),
      (jt.elements[4] *= h),
      (jt.elements[5] *= h),
      (jt.elements[6] *= h),
      (jt.elements[8] *= l),
      (jt.elements[9] *= l),
      (jt.elements[10] *= l),
      e.setFromRotationMatrix(jt),
      (i.x = n),
      (i.y = r),
      (i.z = a),
      this
    );
  }
  makePerspective(t, e, i, s, n, r, a = 2e3) {
    const o = this.elements,
      h = (2 * n) / (e - t),
      l = (2 * n) / (i - s),
      c = (e + t) / (e - t),
      u = (i + s) / (i - s);
    let d, f;
    if (a === zt) ((d = -(r + n) / (r - n)), (f = (-2 * r * n) / (r - n)));
    else {
      if (a !== Lt) throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + a);
      ((d = -r / (r - n)), (f = (-r * n) / (r - n)));
    }
    return (
      (o[0] = h),
      (o[4] = 0),
      (o[8] = c),
      (o[12] = 0),
      (o[1] = 0),
      (o[5] = l),
      (o[9] = u),
      (o[13] = 0),
      (o[2] = 0),
      (o[6] = 0),
      (o[10] = d),
      (o[14] = f),
      (o[3] = 0),
      (o[7] = 0),
      (o[11] = -1),
      (o[15] = 0),
      this
    );
  }
  makeOrthographic(t, e, i, s, n, r, a = 2e3) {
    const o = this.elements,
      h = 1 / (e - t),
      l = 1 / (i - s),
      c = 1 / (r - n),
      u = (e + t) * h,
      d = (i + s) * l;
    let f, p;
    if (a === zt) ((f = (r + n) * c), (p = -2 * c));
    else {
      if (a !== Lt) throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + a);
      ((f = n * c), (p = -1 * c));
    }
    return (
      (o[0] = 2 * h),
      (o[4] = 0),
      (o[8] = 0),
      (o[12] = -u),
      (o[1] = 0),
      (o[5] = 2 * l),
      (o[9] = 0),
      (o[13] = -d),
      (o[2] = 0),
      (o[6] = 0),
      (o[10] = p),
      (o[14] = -f),
      (o[3] = 0),
      (o[7] = 0),
      (o[11] = 0),
      (o[15] = 1),
      this
    );
  }
  equals(t) {
    const e = this.elements,
      i = t.elements;
    for (let t = 0; t < 16; t++) if (e[t] !== i[t]) return !1;
    return !0;
  }
  fromArray(t, e = 0) {
    for (let i = 0; i < 16; i++) this.elements[i] = t[i + e];
    return this;
  }
  toArray(t = [], e = 0) {
    const i = this.elements;
    return (
      (t[e] = i[0]),
      (t[e + 1] = i[1]),
      (t[e + 2] = i[2]),
      (t[e + 3] = i[3]),
      (t[e + 4] = i[4]),
      (t[e + 5] = i[5]),
      (t[e + 6] = i[6]),
      (t[e + 7] = i[7]),
      (t[e + 8] = i[8]),
      (t[e + 9] = i[9]),
      (t[e + 10] = i[10]),
      (t[e + 11] = i[11]),
      (t[e + 12] = i[12]),
      (t[e + 13] = i[13]),
      (t[e + 14] = i[14]),
      (t[e + 15] = i[15]),
      t
    );
  }
  fromCesiumMatrix4(t) {
    return (t && this.fromArray(t), this);
  }
  toCesiumMatrix4(t) {
    if (t) {
      const e = this.elements.length;
      for (let i = 0; i < e; i++) t[i] = this.elements[i];
    }
    return t;
  }
}
const Ht = new pt(),
  jt = new Ot(),
  qt = new pt(0, 0, 0),
  Vt = new pt(1, 1, 1),
  Ut = new pt(),
  Kt = new pt(),
  Gt = new pt();
class Wt {
  constructor() {}
  get maxLoadSplatCount() {
    throw new Error('Must be implemented by subclass');
  }
  set maxLoadSplatCount(t) {
    throw new Error('Must be implemented by subclass');
  }
  dispose() {
    throw new Error('Must be implemented by subclass');
  }
  update(t) {
    throw new Error('Must be implemented by subclass');
  }
  load(t, e, i, s) {
    throw new Error('Must be implemented by subclass');
  }
  getInstancedMesh() {
    throw new Error('Must be implemented by subclass');
  }
  getEnvInstancedMesh() {
    throw new Error('Must be implemented by subclass');
  }
  getBounds() {
    throw new Error('Must be implemented by subclass');
  }
  togglePointsDisplayMode() {
    throw new Error('Must be implemented by subclass');
  }
  useEnvironment(t) {
    throw new Error('Must be implemented by subclass');
  }
  useShcoef(t, e) {
    throw new Error('Must be implemented by subclass');
  }
  hasShcoef() {
    throw new Error('Must be implemented by subclass');
  }
  setPointsColor(t) {
    throw new Error('Must be implemented by subclass');
  }
  setVisible(t) {
    throw new Error('Must be implemented by subclass');
  }
  setAlpha(t) {
    throw new Error('Must be implemented by subclass');
  }
  setStartLod(t) {
    throw new Error('Must be implemented by subclass');
  }
  setMaxDistance(t) {
    throw new Error('Must be implemented by subclass');
  }
  setMaxSplats(t) {
    throw new Error('Must be implemented by subclass');
  }
  setClipBox(t) {
    throw new Error('Must be implemented by subclass');
  }
  setClipPlane(t, e) {
    throw new Error('Must be implemented by subclass');
  }
  getCurrentConfig() {
    throw new Error('Must be implemented by subclass');
  }
  updateCurrentConfig(t) {
    throw new Error('Must be implemented by subclass');
  }
  raycast(t) {
    throw new Error('Must be implemented by subclass');
  }
  raycastFromOrigin(t) {
    throw new Error('Must be implemented by subclass');
  }
  hasCollision() {
    throw new Error('Must be implemented by subclass');
  }
  intersectsRayExt(t) {
    throw new Error('Must be implemented by subclass');
  }
  intersectsRayFromOriginExt(t) {
    throw new Error('Must be implemented by subclass');
  }
  intersectsSphere(t) {
    throw new Error('Must be implemented by subclass');
  }
  intersectsCapsule(t) {
    throw new Error('Must be implemented by subclass');
  }
  toggleLodAutoUp() {
    throw new Error('Must be implemented by subclass');
  }
}
class Qt {
  constructor(t, e, i) {
    ((this.prev = null), (this.next = null), (this.id = t), (this.obj = e), (this.size = i), (this.refCnt = 0));
  }
  dispose() {
    ((this.prev = null), (this.next = null), (this.id = 0), (this.obj = null), (this.size = 0));
  }
}
class Xt {
  #r;
  #a;
  #o;
  #h;
  #l;
  #c;
  #u;
  constructor(t, e, i = null) {
    ((this.#r = new Qt(0, null, 0)),
      (this.#r.prev = this.#r),
      (this.#r.next = this.#r),
      (this.#a = Object.create(null)),
      (this.#o = 0),
      (this.#h = 0),
      (this.#l = e),
      (this.#c = i),
      (this.#u = t || ''));
  }
  elements() {
    return this.#o;
  }
  contains(t) {
    return !!this.#a[t];
  }
  get(t, e = !0) {
    let i = this.#a[t];
    return i
      ? (e &&
          ((i.prev.next = i.next),
          (i.next.prev = i.prev),
          (i.prev = this.#r),
          (i.next = this.#r.next),
          (this.#r.next.prev = i),
          (this.#r.next = i)),
        i.obj)
      : null;
  }
  add(t, e, i) {
    if (this.contains(t)) return !1;
    let s = new Qt(t, e, i);
    return (
      (this.#a[t] = s),
      this.#o++,
      (this.#h += i),
      (s.prev = this.#r),
      (s.next = this.#r.next),
      (this.#r.next.prev = s),
      (this.#r.next = s),
      !0
    );
  }
  flush(t, e, i) {
    let s = this.#a[t];
    if (!s) return !1;
    let n = i - s.size;
    return ((s.obj = e), (s.size = i), (this.#h += n), !0);
  }
  remove(t) {
    let e = this.#a[t];
    return !!e && (this.#d(e), !0);
  }
  #d(t) {
    ((t.prev.next = t.next),
      (t.next.prev = t.prev),
      this.#o--,
      (this.#h -= t.size),
      delete this.#a[t.id],
      this.#c && this.#c(t.id, t.obj, this.#u),
      t.dispose());
  }
  clear() {
    for (; this.#r.prev != this.#r; ) {
      let t = this.#r.prev;
      this.#d(t);
    }
  }
  ref(t) {
    let e = this.#a[t];
    e && (e.refCnt += 1);
  }
  unref(t) {
    let e = this.#a[t];
    e && e.refCnt > 0 && (e.refCnt -= 1);
  }
  freeMemory() {
    if (this.#o <= 1 || this.#h < this.#l) return;
    const t = this.#l - Math.min(3e8, 0.7 * this.#l);
    let e = 0,
      i = 0,
      s = this.#r.prev;
    for (; this.#h > t; ) {
      let t = s;
      if (((s = s.prev), t == this.#r)) {
        console.warn('you should never see this. (LRU free memory)');
        break;
      }
      t.refCnt > 0 || ((i += t.size), (e += 1), this.#d(t));
    }
    e > 0 && console.log('LRU ' + this.#u + ' free memory(MB): ', e, (i / 1048576).toFixed(1));
  }
  dispose() {
    (this.clear(), (this.#a = {}), this.#r.dispose(), console.log('LRU ' + this.#u + ' dispose !!!'));
  }
  toString() {
    let t = '{ ',
      e = this.#r.next;
    for (; e != this.#r; ) ((t += e.id), e.next != this.#r && (t += ', '), (e = e.next));
    return ((t += '}'), (t += '(' + this.#o + ')'), t);
  }
}
class Yt {
  #f = !1;
  #p = 0;
  #m;
  #g = {};
  #y = {};
  #x = {};
  #v = {};
  #b = {};
  #l;
  #c;
  constructor(t, e) {
    ((this.#l = t), (this.#c = e), (this.#m = new Xt('CPU', t, e)));
  }
  #w(t, e) {
    return `${t}_${e}`;
  }
  pushEnv(t, e, i, s, n) {
    return !this.#f && ((this.#g[t] = { splatCounts: e, data: i, sh: s, pos: n, size: 0 }), !0);
  }
  queryEnv(t) {
    return this.#f ? null : this.#g[t];
  }
  getLutTransferFlag(t, e) {
    return !this.#f && (e == o ? !!this.#v[t] : e == h && !!this.#b[t]);
  }
  setLutTransferFlag(t, e, i) {
    this.#f || (e == o ? (this.#v[t] = i) : e == h && (this.#b[t] = i));
  }
  pushLut(t, e, i) {
    if (this.#f) return !1;
    if (e == o) this.#y[t] = { data: i };
    else {
      if (e != h) return (console.error('pushLut not support type'), !1);
      this.#x[t] = { data: i };
    }
    return !0;
  }
  queryLut(t, e) {
    return this.#f
      ? null
      : e == o
        ? this.#y[t]
        : e == h
          ? this.#x[t]
          : (console.error('queryLut not support type'), null);
  }
  pushData(t, e, i, s, n) {
    if (this.#f) return !1;
    let r = this.#w(t, e),
      a = this.#m.get(r, !1);
    if (a) {
      if (a.data) return !1;
      let t = a.size;
      return ((a.data = i), (a.pos = n), (a.size = t + s), this.#m.flush(r, a, a.size), !0);
    }
    return ((a = { data: i, sh: null, pos: n, size: s }), this.#m.add(r, a, s), !0);
  }
  pushSH(t, e, i, s) {
    if (this.#f) return !1;
    let n = this.#w(t, e),
      r = this.#m.get(n, !1);
    if (r) {
      if (r.sh) return !1;
      let t = r.size;
      return ((r.sh = i), (r.size = t + s), this.#m.flush(n, r, r.size), !0);
    }
    return ((r = { data: null, sh: i, pos: null, size: s }), this.#m.add(n, r, s), !0);
  }
  pushSem(t, e, i, s) {
    if (this.#f) return !1;
    let n = this.#w(t, e),
      r = this.#m.get(n, !1);
    if (r) {
      if (r.sem) return !1;
      let t = r.size;
      return ((r.sem = i), (r.size = t + s), this.#m.flush(n, r, r.size), !0);
    }
    return ((r = { data: null, sh: null, pos: null, sem: i, size: s }), this.#m.add(n, r, s), !0);
  }
  queryOne(t, e, i = !0) {
    if (this.#f) return null;
    let s = this.#w(t, e);
    return this.#m.get(s, i);
  }
  hasData(t, e) {
    if (this.#f) return !1;
    let i = this.#w(t, e),
      s = this.#m.get(i, !1);
    return s && s.data;
  }
  hasSH(t, e) {
    if (this.#f) return !1;
    let i = this.#w(t, e),
      s = this.#m.get(i, !1);
    return s && s.sh;
  }
  hasSem(t, e) {
    if (this.#f) return !1;
    let i = this.#w(t, e),
      s = this.#m.get(i, !1);
    return s && s.sem;
  }
  clear(t, e) {
    if (this.#f) return !1;
    Array.isArray(e)
      ? (e.forEach((e) => {
          let i = this.#w(t, e);
          this.#m.remove(i);
        }),
        (this.#g[t] = void 0),
        (this.#y[t] = void 0),
        (this.#x[t] = void 0))
      : console.warn('nodeIDs must be Array !!!');
  }
  dispose() {
    ((this.#f = !0),
      this.#m.dispose(),
      Object.keys(this.#g).forEach((t) => {
        this.#c && this.#c(t, this.#g[t]);
      }),
      (this.#g = {}),
      (this.#y = {}),
      (this.#x = {}));
  }
  update(t) {
    this.#f || this.#m.freeMemory();
  }
}
function Zt(t, e, i, s = {}) {
  return new Promise((n, r) => {
    'bigint' == typeof e && (e = Number(e));
    let a = { ...s };
    if (('number' == typeof e || 'bigint' == typeof e) && 'number' == typeof i) {
      const t = `bytes=${e}-${e + i - 1}`;
      a.Range = t;
    }
    const o = new Request(`${t}`, { headers: a });
    try {
      fetch(o)
        .then((t) => {
          try {
            if (!t.ok) throw new Error(`HTTP error! Status: ${t.status}`);
            t.arrayBuffer().then((t) => {
              n(t);
            });
          } catch (t) {
            r(t);
          }
        })
        .catch(() => {
          r();
        });
    } catch (t) {
      r();
    }
  });
}
class Jt {
  constructor() {
    this.items = [];
  }
  traverse(t) {
    this.items.forEach((e) => {
      t(e);
    });
  }
  get isEmpty() {
    return 0 === this.items.length;
  }
  get length() {
    return this.items.length;
  }
  enqueue(t) {
    this.items.push(t);
  }
  dequeue() {
    return this.isEmpty ? null : this.items.shift();
  }
  peek() {
    return this.isEmpty ? null : this.items[0];
  }
  filter(t) {
    return ((this.items = this.items.filter(t)), this);
  }
}
async function $t(t) {
  function e(t, e, i, s = {}) {
    return new Promise((n, r) => {
      'bigint' == typeof e && (e = Number(e));
      let a = { ...s };
      if (('number' == typeof e || 'bigint' == typeof e) && 'number' == typeof i) {
        const t = `bytes=${e}-${e + i - 1}`;
        a.Range = t;
      }
      const o = new Request(`${t}`, { headers: a });
      try {
        fetch(o)
          .then((t) => {
            try {
              if (!t.ok) throw new Error(`HTTP error! Status: ${t.status}`);
              t.arrayBuffer().then((t) => {
                n(t);
              });
            } catch (t) {
              (console.error('catch: ', t), n(void 0));
            }
          })
          .catch(() => {
            n(void 0);
          });
      } catch (t) {
        n(void 0);
      }
    });
  }
  const { flag: i, renderID: s } = t.data;
  if ('Clean' === i) return void (self.payloads = self.payloads.filter((t) => t.renderID !== s));
  self.payloads = t.data;
  const n = async function () {
    const t = [],
      i = self.payloads.splice(0, 5);
    for (let s = 0; s < i.length; ++s) {
      const { index: n, path: r, offset: a, size: o, headers: h } = i[s],
        l = e(r, a, o, h);
      t.push(l);
    }
    const s = t.map((t, e) =>
      t
        .then((t) => {
          if (t) {
            i[e].data = t;
            const s = [i[e]],
              n = [t];
            postMessage({ payloads: s, data: n, isFinished: !1 }, n);
          }
        })
        .catch((t) => {}),
    );
    (await Promise.all(s),
      postMessage({ payloads: [], data: [], isFinished: 0 === self.payloads.length }),
      self.payloads.length > 0 && requestAnimationFrame(n));
  };
  n();
}
class te {
  static GlobalID = 0;
  isNode = !0;
  #S;
  #M = 32;
  #C = 64;
  #E = 0;
  #D = 0;
  #A = 0;
  #F;
  #P = -1;
  #T = null;
  #I = !1;
  #_ = !1;
  #R = !1;
  #N = !1;
  #B = !1;
  #k = !1;
  visibleID = 0;
  visibleAroundID = 0;
  #z = !1;
  #L = !1;
  #O;
  #H;
  #j;
  #q;
  #V;
  #U;
  get id() {
    return this.#S;
  }
  get level() {
    return this.#P;
  }
  get points() {
    return this.#F.points;
  }
  get offset() {
    return this.#F.offset;
  }
  get size() {
    return this.#F.size;
  }
  get shOffset() {
    return BigInt((Number(this.offset) / this.#M) * this.#C + this.#A);
  }
  get shSize() {
    return this.#F.points * this.#C;
  }
  get semOffset() {
    return BigInt((Number(this.offset) / this.#M) * this.#E + this.#D);
  }
  get semSize() {
    return this.#F.points * this.#E;
  }
  get parent() {
    return this.#T;
  }
  set parent(t) {
    this.#T = t;
  }
  get renderID() {
    return this.#T.renderID;
  }
  get unitID() {
    return this.#T.id;
  }
  get initReady() {
    return this.#L;
  }
  set initReady(t) {
    ((this.#L = t), this.#T && (this.#T.initOneNodeReady = this.#T.initOneNodeReady || t));
  }
  getOffset(t) {
    return t === e ? this.offset : t === l ? this.semOffset : this.shOffset;
  }
  getSize(t) {
    return t === e ? this.size : t === l ? this.semSize : this.shSize;
  }
  getQuanBBox() {
    return this.#T.getQuanBBox();
  }
  isDownloading(t) {
    return t === e ? this.#I : t === l ? this.#R : this.#_;
  }
  setDownloading(t, i) {
    t === e ? (this.#I = i) : t === l ? (this.#R = i) : (this.#_ = i);
  }
  isDecompressing(t) {
    return t === e ? this.#N : t === l ? this.#k : this.#B;
  }
  setDecompressing(t, i) {
    t === e ? (this.#N = i) : t === l ? (this.#k = i) : (this.#B = i);
  }
  isDownloadingOrDecompressing(t) {
    return t === e ? this.#I || this.#N : t === l ? this.#R || this.#k : this.#_ || this.#B;
  }
  isCache(t) {
    let i = this.#T.cpuCache,
      s = this.#T.renderID;
    return t === e ? i.hasData(s, this.id) : t === l ? i.hasSem(s, this.id) : i.hasSH(s, this.id);
  }
  queryCache() {
    let t = this.#T.cpuCache,
      e = this.#T.renderID;
    return t.queryOne(e, this.id, !0);
  }
  constructor(t, s, n, r) {
    ((this.#S = te.GlobalID++),
      (this.#M = t.dataSize),
      (this.#C = t.shDataSize),
      (this.#E = t.semanticDataSize),
      (this.#D = t.semanticFileOffset),
      (this.#A = t.shFileOffset),
      (this.#F = s),
      (this.#T = r),
      (this.#P = n),
      (this.#O = `${Number(this.offset)}-${Number(this.offset) + Number(this.size)}`),
      (this.#H = `${Number(this.shOffset)}-${Number(this.shOffset) + Number(this.shSize)}`),
      (this.#j = `${Number(this.semOffset)}-${Number(this.semOffset) + Number(this.semSize)}`),
      (this.#q = this.#T?.localCacheMgr?.getTableName(this.#T?.guid, e)),
      (this.#V = this.#T?.localCacheMgr?.getTableName(this.#T?.guid, i)),
      (this.#U = this.#T?.localCacheMgr?.getTableName(this.#T?.guid, l)));
  }
  getLocalCacheInfo(t) {
    return t === e
      ? { id: this.#O, tablename: this.#q }
      : t === l
        ? { id: this.#j, tablename: this.#U }
        : { id: this.#H, tablename: this.#V };
  }
  isLocalCache(t) {
    return t === e
      ? this.#T.localCacheMgr.checkDataExist(this.#q, this.#O)
      : t === l
        ? this.#T.localCacheMgr.checkDataExist(this.#U, this.#j)
        : this.#T.localCacheMgr.checkDataExist(this.#V, this.#H);
  }
  dispose() {
    this.#T = null;
  }
}
class ee {
  constructor(t = 0, e = 0) {
    ((ee.prototype.isVector2 = !0), (this.x = t), (this.y = e));
  }
  get width() {
    return this.x;
  }
  set width(t) {
    this.x = t;
  }
  get height() {
    return this.y;
  }
  set height(t) {
    this.y = t;
  }
  set(t, e) {
    return ((this.x = t), (this.y = e), this);
  }
  setScalar(t) {
    return ((this.x = t), (this.y = t), this);
  }
  setX(t) {
    return ((this.x = t), this);
  }
  setY(t) {
    return ((this.y = t), this);
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      default:
        throw new Error('index is out of range: ' + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error('index is out of range: ' + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(t) {
    return ((this.x = t.x), (this.y = t.y), this);
  }
  add(t) {
    return ((this.x += t.x), (this.y += t.y), this);
  }
  addScalar(t) {
    return ((this.x += t), (this.y += t), this);
  }
  addVectors(t, e) {
    return ((this.x = t.x + e.x), (this.y = t.y + e.y), this);
  }
  addScaledVector(t, e) {
    return ((this.x += t.x * e), (this.y += t.y * e), this);
  }
  sub(t) {
    return ((this.x -= t.x), (this.y -= t.y), this);
  }
  subScalar(t) {
    return ((this.x -= t), (this.y -= t), this);
  }
  subVectors(t, e) {
    return ((this.x = t.x - e.x), (this.y = t.y - e.y), this);
  }
  multiply(t) {
    return ((this.x *= t.x), (this.y *= t.y), this);
  }
  multiplyScalar(t) {
    return ((this.x *= t), (this.y *= t), this);
  }
  divide(t) {
    return ((this.x /= t.x), (this.y /= t.y), this);
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  applyMatrix3(t) {
    const e = this.x,
      i = this.y,
      s = t.elements;
    return ((this.x = s[0] * e + s[3] * i + s[6]), (this.y = s[1] * e + s[4] * i + s[7]), this);
  }
  min(t) {
    return ((this.x = Math.min(this.x, t.x)), (this.y = Math.min(this.y, t.y)), this);
  }
  max(t) {
    return ((this.x = Math.max(this.x, t.x)), (this.y = Math.max(this.y, t.y)), this);
  }
  clamp(t, e) {
    return ((this.x = Math.max(t.x, Math.min(e.x, this.x))), (this.y = Math.max(t.y, Math.min(e.y, this.y))), this);
  }
  clampScalar(t, e) {
    return ((this.x = Math.max(t, Math.min(e, this.x))), (this.y = Math.max(t, Math.min(e, this.y))), this);
  }
  clampLength(t, e) {
    const i = this.length();
    return this.divideScalar(i || 1).multiplyScalar(Math.max(t, Math.min(e, i)));
  }
  floor() {
    return ((this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), this);
  }
  ceil() {
    return ((this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), this);
  }
  round() {
    return ((this.x = Math.round(this.x)), (this.y = Math.round(this.y)), this);
  }
  roundToZero() {
    return ((this.x = Math.trunc(this.x)), (this.y = Math.trunc(this.y)), this);
  }
  negate() {
    return ((this.x = -this.x), (this.y = -this.y), this);
  }
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  cross(t) {
    return this.x * t.y - this.y * t.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(t) {
    const e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (0 === e) return Math.PI / 2;
    const i = this.dot(t) / e;
    return Math.acos(ht(i, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const e = this.x - t.x,
      i = this.y - t.y;
    return e * e + i * i;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return ((this.x += (t.x - this.x) * e), (this.y += (t.y - this.y) * e), this);
  }
  lerpVectors(t, e, i) {
    return ((this.x = t.x + (e.x - t.x) * i), (this.y = t.y + (e.y - t.y) * i), this);
  }
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  equalsApproximately(t, e = 1e-10) {
    return Math.abs(t.x - this.x) < e && Math.abs(t.y - this.y) < e;
  }
  fromArray(t, e = 0) {
    return ((this.x = t[e]), (this.y = t[e + 1]), this);
  }
  toArray(t = [], e = 0) {
    return ((t[e] = this.x), (t[e + 1] = this.y), t);
  }
  fromBufferAttribute(t, e) {
    return ((this.x = t.getX(e)), (this.y = t.getY(e)), this);
  }
  rotateAround(t, e) {
    const i = Math.cos(e),
      s = Math.sin(e),
      n = this.x - t.x,
      r = this.y - t.y;
    return ((this.x = n * i - r * s + t.x), (this.y = n * s + r * i + t.y), this);
  }
  random() {
    return ((this.x = Math.random()), (this.y = Math.random()), this);
  }
  *[Symbol.iterator]() {
    (yield this.x, yield this.y);
  }
}
class ie {
  constructor(t = new pt(1 / 0, 1 / 0, 1 / 0), e = new pt(-1 / 0, -1 / 0, -1 / 0)) {
    ((this.isBox3 = !0), (this.min = t), (this.max = e));
  }
  set(t, e) {
    return (this.min.copy(t), this.max.copy(e), this);
  }
  setFromArray(t) {
    this.makeEmpty();
    for (let e = 0, i = t.length; e < i; e += 3) this.expandByPoint(ne.fromArray(t, e));
    return this;
  }
  setFromBufferAttribute(t) {
    this.makeEmpty();
    for (let e = 0, i = t.count; e < i; e++) this.expandByPoint(ne.fromBufferAttribute(t, e));
    return this;
  }
  setFromPoints(t) {
    this.makeEmpty();
    for (let e = 0, i = t.length; e < i; e++) this.expandByPoint(t[e]);
    return this;
  }
  setFromCenterAndSize(t, e) {
    const i = ne.copy(e).multiplyScalar(0.5);
    return (this.min.copy(t).sub(i), this.max.copy(t).add(i), this);
  }
  setFromObject(t, e = !1) {
    return (this.makeEmpty(), this.expandByObject(t, e));
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return (this.min.copy(t.min), this.max.copy(t.max), this);
  }
  makeEmpty() {
    return ((this.min.x = this.min.y = this.min.z = 1 / 0), (this.max.x = this.max.y = this.max.z = -1 / 0), this);
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
  }
  expandByPoint(t) {
    return (this.min.min(t), this.max.max(t), this);
  }
  expandByVector(t) {
    return (this.min.sub(t), this.max.add(t), this);
  }
  expandByScalar(t) {
    return (this.min.addScalar(-t), this.max.addScalar(t), this);
  }
  expandByObject(t, e = !1) {
    t.updateWorldMatrix(!1, !1);
    const i = t.geometry;
    if (void 0 !== i) {
      const s = i.getAttribute('position');
      if (!0 === e && void 0 !== s && !0 !== t.isInstancedMesh)
        for (let e = 0, i = s.count; e < i; e++)
          (!0 === t.isMesh ? t.getVertexPosition(e, ne) : ne.fromBufferAttribute(s, e),
            ne.applyMatrix4(t.matrixWorld),
            this.expandByPoint(ne));
      else
        (void 0 !== t.boundingBox
          ? (null === t.boundingBox && t.computeBoundingBox(), re.copy(t.boundingBox))
          : (null === i.boundingBox && i.computeBoundingBox(), re.copy(i.boundingBox)),
          re.applyMatrix4(t.matrixWorld),
          this.union(re));
    }
    const s = t.children;
    for (let t = 0, i = s.length; t < i; t++) this.expandByObject(s[t], e);
    return this;
  }
  containsPoint(t) {
    return (
      t.x >= this.min.x &&
      t.x <= this.max.x &&
      t.y >= this.min.y &&
      t.y <= this.max.y &&
      t.z >= this.min.z &&
      t.z <= this.max.z
    );
  }
  containsBox(t) {
    return (
      this.min.x <= t.min.x &&
      t.max.x <= this.max.x &&
      this.min.y <= t.min.y &&
      t.max.y <= this.max.y &&
      this.min.z <= t.min.z &&
      t.max.z <= this.max.z
    );
  }
  getParameter(t, e) {
    return e.set(
      (t.x - this.min.x) / (this.max.x - this.min.x),
      (t.y - this.min.y) / (this.max.y - this.min.y),
      (t.z - this.min.z) / (this.max.z - this.min.z),
    );
  }
  intersectsBox(t) {
    return (
      t.max.x >= this.min.x &&
      t.min.x <= this.max.x &&
      t.max.y >= this.min.y &&
      t.min.y <= this.max.y &&
      t.max.z >= this.min.z &&
      t.min.z <= this.max.z
    );
  }
  intersectsSphere(t) {
    return (this.clampPoint(t.center, ne), ne.distanceToSquared(t.center) <= t.radius * t.radius);
  }
  intersectsPlane(t) {
    let e, i;
    return (
      t.normal.x > 0
        ? ((e = t.normal.x * this.min.x), (i = t.normal.x * this.max.x))
        : ((e = t.normal.x * this.max.x), (i = t.normal.x * this.min.x)),
      t.normal.y > 0
        ? ((e += t.normal.y * this.min.y), (i += t.normal.y * this.max.y))
        : ((e += t.normal.y * this.max.y), (i += t.normal.y * this.min.y)),
      t.normal.z > 0
        ? ((e += t.normal.z * this.min.z), (i += t.normal.z * this.max.z))
        : ((e += t.normal.z * this.max.z), (i += t.normal.z * this.min.z)),
      e <= -t.constant && i >= -t.constant
    );
  }
  intersectsTriangle(t) {
    if (this.isEmpty()) return !1;
    (this.getCenter(de),
      fe.subVectors(this.max, de),
      ae.subVectors(t.a, de),
      oe.subVectors(t.b, de),
      he.subVectors(t.c, de),
      le.subVectors(oe, ae),
      ce.subVectors(he, oe),
      ue.subVectors(ae, he));
    let e = [
      0,
      -le.z,
      le.y,
      0,
      -ce.z,
      ce.y,
      0,
      -ue.z,
      ue.y,
      le.z,
      0,
      -le.x,
      ce.z,
      0,
      -ce.x,
      ue.z,
      0,
      -ue.x,
      -le.y,
      le.x,
      0,
      -ce.y,
      ce.x,
      0,
      -ue.y,
      ue.x,
      0,
    ];
    return (
      !!ge(e, ae, oe, he, fe) &&
      ((e = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
      !!ge(e, ae, oe, he, fe) && (pe.crossVectors(le, ce), (e = [pe.x, pe.y, pe.z]), ge(e, ae, oe, he, fe)))
    );
  }
  clampPoint(t, e) {
    return e.copy(t).clamp(this.min, this.max);
  }
  distanceToPoint(t) {
    return this.clampPoint(t, ne).distanceTo(t);
  }
  getBoundingSphere(t) {
    return (
      this.isEmpty() ? t.makeEmpty() : (this.getCenter(t.center), (t.radius = 0.5 * this.getSize(ne).length())),
      t
    );
  }
  intersect(t) {
    return (this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this);
  }
  union(t) {
    return (this.min.min(t.min), this.max.max(t.max), this);
  }
  applyMatrix4(t) {
    return (
      this.isEmpty() ||
        (se[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t),
        se[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t),
        se[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t),
        se[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t),
        se[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t),
        se[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t),
        se[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t),
        se[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t),
        this.setFromPoints(se)),
      this
    );
  }
  translate(t) {
    return (this.min.add(t), this.max.add(t), this);
  }
  equals(t) {
    return t.min.equals(this.min) && t.max.equals(this.max);
  }
}
const se = [new pt(), new pt(), new pt(), new pt(), new pt(), new pt(), new pt(), new pt()],
  ne = new pt(),
  re = new ie(),
  ae = new pt(),
  oe = new pt(),
  he = new pt(),
  le = new pt(),
  ce = new pt(),
  ue = new pt(),
  de = new pt(),
  fe = new pt(),
  pe = new pt(),
  me = new pt();
function ge(t, e, i, s, n) {
  for (let r = 0, a = t.length - 3; r <= a; r += 3) {
    me.fromArray(t, r);
    const a = n.x * Math.abs(me.x) + n.y * Math.abs(me.y) + n.z * Math.abs(me.z),
      o = e.dot(me),
      h = i.dot(me),
      l = s.dot(me);
    if (Math.max(-Math.max(o, h, l), Math.min(o, h, l)) > a) return !1;
  }
  return !0;
}
class ye {
  #f = !1;
  #p = 0;
  #m;
  #g = {};
  #l;
  #c;
  constructor(t, e) {
    ((this.#l = t), (this.#c = e), (this.#m = new Xt('GPU', t, e)));
  }
  #w(t, e) {
    return `${t}_${e}`;
  }
  pushMesh(t, e, i, s) {
    if (this.#f) return !1;
    let n = this.#w(t, e);
    return this.#m.add(n, i, s);
  }
  pushEnv(t, e) {
    return !this.#f && ((this.#g[t] = e), !0);
  }
  queryEnv(t) {
    return this.#f ? null : this.#g[t];
  }
  flushMesh(t, e, i, s) {
    if (this.#f) return !1;
    let n = this.#w(t, e);
    return this.#m.flush(n, i, s);
  }
  queryMesh(t, e, i = !1) {
    if (this.#f) return null;
    let s = this.#w(t, e);
    return this.#m.get(s, i);
  }
  touchMesh(t, e) {
    return this.queryMesh(t, e, !0);
  }
  hasMesh(t, e) {
    if (this.#f) return !1;
    let i = this.#w(t, e);
    return !!this.#m.get(i, !1);
  }
  clear(t, e) {
    if (this.#f) return !1;
    Array.isArray(e)
      ? (e.forEach((e) => {
          let i = this.#w(t, e);
          this.#m.remove(i);
        }),
        (this.#g[t] = void 0))
      : console.warn('nodeIDs must be Array !!!');
  }
  dispose() {
    ((this.#f = !0), this.#m.dispose(), (this.#g = {}));
  }
  update(t) {
    this.#f || this.#m.freeMemory();
  }
  test() {
    console.log('gpu lru info: ' + this.#m.toString());
  }
}
class xe {
  #f = !1;
  #K;
  #G;
  constructor(t, e, i, s) {
    ((this.#K = new Xt('CPU_COLL', t, e)), (this.#G = new Xt('GPU_COLL', i, s)));
  }
  #w(t, e) {
    return `${t}_${e}`;
  }
  pushMesh(t, e, i, s) {
    if (this.#f) return !1;
    let n = this.#w(t, e);
    return this.#G.add(n, i, s);
  }
  queryMesh(t, e, i = !0) {
    if (this.#f) return null;
    let s = this.#w(t, e);
    return this.#G.get(s, i);
  }
  hasMesh(t, e) {
    if (this.#f) return !1;
    let i = this.#w(t, e);
    return !!this.#G.get(i, !1);
  }
  pushData(t, e, i, s) {
    if (this.#f) return !1;
    let n = this.#w(t, e);
    return this.#K.add(n, i, s);
  }
  queryData(t, e, i = !0) {
    if (this.#f) return null;
    let s = this.#w(t, e);
    return this.#K.get(s, i);
  }
  hasData(t, e) {
    if (this.#f) return !1;
    let i = this.#w(t, e);
    return !!this.#K.get(i, !1);
  }
  clear(t, e) {
    if (this.#f) return !1;
    Array.isArray(e)
      ? e.forEach((e) => {
          let i = this.#w(t, e);
          (this.#K.remove(i), this.#G.remove(i));
        })
      : console.warn('collIDs must be Array !!!');
  }
  dispose() {
    ((this.#f = !0), this.#K.dispose(), this.#G.dispose());
  }
  update(t) {
    this.#f || (this.#K.freeMemory(), this.#G.freeMemory());
  }
  test() {
    (console.log('cpu_coll lru info: ' + this.#K.toString()), console.log('gpu_coll lru info: ' + this.#G.toString()));
  }
}
class ve {
  vertexes;
  faces;
  bvh;
  bvh_f32;
  bvh_u16;
  bvh_u32;
  vertexNum;
  faceNum;
  constructor(t, e, i, s, n) {
    ((this.vertexes = t),
      (this.faces = e),
      (this.bvh = i),
      (this.vertexNum = s),
      (this.faceNum = n),
      (this.bvh_f32 = new Float32Array(this.bvh)),
      (this.bvh_u16 = new Uint16Array(this.bvh)),
      (this.bvh_u32 = new Uint32Array(this.bvh)));
  }
}
class be {
  isColl = !0;
  #S;
  #T = null;
  #W;
  #Q;
  #X = 0;
  #Y = 0;
  #Z = 0;
  #J = !1;
  #$ = !1;
  #tt = !1;
  #et;
  #it;
  get offset() {
    return this.#W;
  }
  get size() {
    return this.#Q;
  }
  get parent() {
    return this.#T;
  }
  set parent(t) {
    this.#T = t;
  }
  get id() {
    return this.#T.id;
  }
  get renderID() {
    return this.#T.renderID;
  }
  get unitID() {
    return this.#T.id;
  }
  get vertexNum() {
    return this.#X;
  }
  get faceNum() {
    return this.#Y;
  }
  get preBvhSize() {
    return this.#Z;
  }
  get isRTK() {
    return this.#tt;
  }
  set isRTK(t) {
    this.#tt = t;
  }
  isDownloading(t) {
    return this.#J;
  }
  setDownloading(t, e) {
    this.#J = e;
  }
  isDecompressing(t) {
    return this.#$;
  }
  setDecompressing(t, e) {
    this.#$ = e;
  }
  isDownloadingOrDecompressing(t) {
    return this.#J || this.#$;
  }
  pushCacheData(t, e, i) {
    let s = this.#T.collCache,
      n = this.#T.renderID,
      r = t.byteLength + e.byteLength + i.byteLength,
      a = this.vertexNum,
      o = this.#Y,
      h = new ve(t, e, i, a, o);
    return s.pushData(n, this.id, h, r);
  }
  isCacheData() {
    let t = this.#T.collCache,
      e = this.#T.renderID;
    return t.hasData(e, this.id);
  }
  queryCacheData() {
    let t = this.#T.collCache,
      e = this.#T.renderID;
    return t.queryData(e, this.id, !0);
  }
  pushCacheMesh(t) {
    let e = this.#T.collCache,
      i = this.#T.renderID;
    return e.pushMesh(i, this.id, t, this.#Q);
  }
  isCacheMesh() {
    let t = this.#T.collCache,
      e = this.#T.renderID;
    return t.hasMesh(e, this.id);
  }
  queryCacheMesh() {
    let t = this.#T.collCache,
      e = this.#T.renderID;
    return t.queryMesh(e, this.id, !0);
  }
  constructor(t, e, i, s, r, a) {
    ((this.#W = t),
      (this.#Q = e),
      (this.#X = i),
      (this.#Y = s),
      (this.#Z = r),
      (this.parent = a),
      (this.#et = `${Number(this.offset)}-${Number(this.offset) + Number(this.size)}`),
      (this.#it = this.#T?.localCacheMgr?.getTableName(this.#T?.guid, n)));
  }
  getLocalCacheInfo(t) {
    return { id: this.#et, tablename: this.#it };
  }
  isLocalCache() {
    return this.#T.localCacheMgr.checkDataExist(this.#it, this.#et);
  }
  dispose() {
    this.#T = null;
  }
}
const RESOURCES_ENDPOINT = import.meta.env.VITE_RESOURCES_ENDPOINT;
// Patch Worker constructor to inject credentials only for resource-related workers
const credentialPatchScript = `
      var __RE__ = ${JSON.stringify(RESOURCES_ENDPOINT)};
      var __origFetch__ = self.fetch;
      self.fetch = function(input, init) {
        var url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
        if (url.startsWith(__RE__)) init = Object.assign({}, init, { credentials: 'include' });
        return __origFetch__.call(this, input, init);
      };
      if (typeof XMLHttpRequest !== 'undefined') {
        var __origOpen__ = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function() {
          __origOpen__.apply(this, arguments);
          if (typeof arguments[1] === 'string' && arguments[1].startsWith(__RE__)) this.withCredentials = true;
        };
      }
    `;
class PatchedWorker extends window.Worker {
  constructor(scriptURL, options) {
    const url = typeof scriptURL === 'string' ? scriptURL : scriptURL.toString();

    // Don’t trust console.log(options) — check the actual property
    const type = options?.type; // "classic" | "module" | undefined
    const abs = new URL(url, document.baseURI).toString();

    const loader = type === 'module' ? `import ${JSON.stringify(abs)};\n` : `importScripts(${JSON.stringify(abs)});\n`;

    const blob = new Blob([loader + credentialPatchScript], {
      type: 'application/javascript',
    });

    const blobUrl = URL.createObjectURL(blob);
    super(blobUrl, options);
  }
}
const we = function (t, e = 'application/javascript') {
    const i = `onmessage=${String(t)}`,
      s = URL.createObjectURL(new Blob([i], { type: e }));
    return new PatchedWorker(s);
  },
  Se = function (t) {
    return new PatchedWorker(
      URL.createObjectURL(new Blob(['(', t.toString(), ')(self)'], { type: 'application/javascript' })),
    );
  };
function Me(t) {
  const e = 'LCC_DB';
  var i = self.LCC_DB;
  const s = 1,
    n = 2,
    r = 3,
    a = 4,
    o = 5,
    h = '0-0';
  var l = (function () {
    var t = function (e, i) {
      return (
        (t =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (t, e) {
              t.__proto__ = e;
            }) ||
          function (t, e) {
            for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          }),
        t(e, i)
      );
    };
    var e = function () {
      return (
        (e =
          Object.assign ||
          function (t) {
            for (var e, i = 1, s = arguments.length; i < s; i++)
              for (var n in (e = arguments[i])) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            return t;
          }),
        e.apply(this, arguments)
      );
    };
    function i(t, e, i) {
      for (var s, n = 0, r = e.length; n < r; n++)
        (!s && n in e) || (s || (s = Array.prototype.slice.call(e, 0, n)), (s[n] = e[n]));
      return t.concat(s || Array.prototype.slice.call(e));
    }
    var s =
        'undefined' != typeof globalThis
          ? globalThis
          : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
              ? window
              : global,
      n = Object.keys,
      r = Array.isArray;
    function a(t, e) {
      return (
        'object' != typeof e ||
          n(e).forEach(function (i) {
            t[i] = e[i];
          }),
        t
      );
    }
    'undefined' == typeof Promise || s.Promise || (s.Promise = Promise);
    var o = Object.getPrototypeOf,
      h = {}.hasOwnProperty;
    function l(t, e) {
      return h.call(t, e);
    }
    function c(t, e) {
      ('function' == typeof e && (e = e(o(t))),
        ('undefined' == typeof Reflect ? n : Reflect.ownKeys)(e).forEach(function (i) {
          d(t, i, e[i]);
        }));
    }
    var u = Object.defineProperty;
    function d(t, e, i, s) {
      u(
        t,
        e,
        a(
          i && l(i, 'get') && 'function' == typeof i.get
            ? { get: i.get, set: i.set, configurable: !0 }
            : { value: i, configurable: !0, writable: !0 },
          s,
        ),
      );
    }
    function f(t) {
      return {
        from: function (e) {
          return (
            (t.prototype = Object.create(e.prototype)),
            d(t.prototype, 'constructor', t),
            { extend: c.bind(null, t.prototype) }
          );
        },
      };
    }
    var p = Object.getOwnPropertyDescriptor;
    function m(t, e) {
      var i;
      return p(t, e) || ((i = o(t)) && m(i, e));
    }
    var g = [].slice;
    function y(t, e, i) {
      return g.call(t, e, i);
    }
    function x(t, e) {
      return e(t);
    }
    function v(t) {
      if (!t) throw new Error('Assertion Failed');
    }
    function b(t) {
      s.setImmediate ? setImmediate(t) : setTimeout(t, 0);
    }
    function w(t, e) {
      if ('string' == typeof e && l(t, e)) return t[e];
      if (!e) return t;
      if ('string' != typeof e) {
        for (var i = [], s = 0, n = e.length; s < n; ++s) {
          var r = w(t, e[s]);
          i.push(r);
        }
        return i;
      }
      var a = e.indexOf('.');
      if (-1 !== a) {
        var o = t[e.substr(0, a)];
        return null == o ? void 0 : w(o, e.substr(a + 1));
      }
    }
    function S(t, e, i) {
      if (t && void 0 !== e && (!('isFrozen' in Object) || !Object.isFrozen(t)))
        if ('string' != typeof e && 'length' in e) {
          v('string' != typeof i && 'length' in i);
          for (var s = 0, n = e.length; s < n; ++s) S(t, e[s], i[s]);
        } else {
          var a = e.indexOf('.');
          if (-1 !== a) {
            var o = e.substr(0, a),
              h = e.substr(a + 1);
            if ('' === h) void 0 === i ? (r(t) && !isNaN(parseInt(o)) ? t.splice(o, 1) : delete t[o]) : (t[o] = i);
            else {
              var c = t[o];
              ((c && l(t, o)) || (c = t[o] = {}), S(c, h, i));
            }
          } else void 0 === i ? (r(t) && !isNaN(parseInt(e)) ? t.splice(e, 1) : delete t[e]) : (t[e] = i);
        }
    }
    function M(t) {
      var e = {};
      for (var i in t) l(t, i) && (e[i] = t[i]);
      return e;
    }
    var C = [].concat;
    function E(t) {
      return C.apply([], t);
    }
    var D =
        'BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey'
          .split(',')
          .concat(
            E(
              [8, 16, 32, 64].map(function (t) {
                return ['Int', 'Uint', 'Float'].map(function (e) {
                  return e + t + 'Array';
                });
              }),
            ),
          )
          .filter(function (t) {
            return s[t];
          }),
      A = new Set(
        D.map(function (t) {
          return s[t];
        }),
      );
    function F(t) {
      var e = {};
      for (var i in t)
        if (l(t, i)) {
          var s = t[i];
          e[i] = !s || 'object' != typeof s || A.has(s.constructor) ? s : F(s);
        }
      return e;
    }
    var P = null;
    function T(t) {
      P = new WeakMap();
      var e = I(t);
      return ((P = null), e);
    }
    function I(t) {
      if (!t || 'object' != typeof t) return t;
      var e = P.get(t);
      if (e) return e;
      if (r(t)) {
        ((e = []), P.set(t, e));
        for (var i = 0, s = t.length; i < s; ++i) e.push(I(t[i]));
      } else if (A.has(t.constructor)) e = t;
      else {
        var n = o(t);
        for (var a in ((e = n === Object.prototype ? {} : Object.create(n)), P.set(t, e), t))
          l(t, a) && (e[a] = I(t[a]));
      }
      return e;
    }
    var _ = {}.toString;
    function R(t) {
      return _.call(t).slice(8, -1);
    }
    var N = 'undefined' != typeof Symbol ? Symbol.iterator : '@@iterator',
      B =
        'symbol' == typeof N
          ? function (t) {
              var e;
              return null != t && (e = t[N]) && e.apply(t);
            }
          : function () {
              return null;
            };
    function k(t, e) {
      var i = t.indexOf(e);
      return (i >= 0 && t.splice(i, 1), i >= 0);
    }
    var z = {};
    function L(t) {
      var e, i, s, n;
      if (1 === arguments.length) {
        if (r(t)) return t.slice();
        if (this === z && 'string' == typeof t) return [t];
        if ((n = B(t))) {
          for (i = []; !(s = n.next()).done; ) i.push(s.value);
          return i;
        }
        if (null == t) return [t];
        if ('number' == typeof (e = t.length)) {
          for (i = new Array(e); e--; ) i[e] = t[e];
          return i;
        }
        return [t];
      }
      for (e = arguments.length, i = new Array(e); e--; ) i[e] = arguments[e];
      return i;
    }
    var O =
        'undefined' != typeof Symbol
          ? function (t) {
              return 'AsyncFunction' === t[Symbol.toStringTag];
            }
          : function () {
              return !1;
            },
      H = [
        'Unknown',
        'Constraint',
        'Data',
        'TransactionInactive',
        'ReadOnly',
        'Version',
        'NotFound',
        'InvalidState',
        'InvalidAccess',
        'Abort',
        'Timeout',
        'QuotaExceeded',
        'Syntax',
        'DataClone',
      ],
      j = [
        'Modify',
        'Bulk',
        'OpenFailed',
        'VersionChange',
        'Schema',
        'Upgrade',
        'InvalidTable',
        'MissingAPI',
        'NoSuchDatabase',
        'InvalidArgument',
        'SubTransaction',
        'Unsupported',
        'Internal',
        'DatabaseClosed',
        'PrematureCommit',
        'ForeignAwait',
      ].concat(H),
      q = {
        VersionChanged: 'Database version changed by other database connection',
        DatabaseClosed: 'Database has been closed',
        Abort: 'Transaction aborted',
        TransactionInactive: 'Transaction has already completed or failed',
        MissingAPI: 'IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb',
      };
    function V(t, e) {
      ((this.name = t), (this.message = e));
    }
    function U(t, e) {
      return (
        t +
        '. Errors: ' +
        Object.keys(e)
          .map(function (t) {
            return e[t].toString();
          })
          .filter(function (t, e, i) {
            return i.indexOf(t) === e;
          })
          .join('\n')
      );
    }
    function K(t, e, i, s) {
      ((this.failures = e), (this.failedKeys = s), (this.successCount = i), (this.message = U(t, e)));
    }
    function G(t, e) {
      ((this.name = 'BulkError'),
        (this.failures = Object.keys(e).map(function (t) {
          return e[t];
        })),
        (this.failuresByPos = e),
        (this.message = U(t, this.failures)));
    }
    (f(V)
      .from(Error)
      .extend({
        toString: function () {
          return this.name + ': ' + this.message;
        },
      }),
      f(K).from(V),
      f(G).from(V));
    var W = j.reduce(function (t, e) {
        return ((t[e] = e + 'Error'), t);
      }, {}),
      Q = V,
      X = j.reduce(function (t, e) {
        var i = e + 'Error';
        function s(t, s) {
          ((this.name = i),
            t
              ? 'string' == typeof t
                ? ((this.message = ''.concat(t).concat(s ? '\n ' + s : '')), (this.inner = s || null))
                : 'object' == typeof t && ((this.message = ''.concat(t.name, ' ').concat(t.message)), (this.inner = t))
              : ((this.message = q[e] || i), (this.inner = null)));
        }
        return (f(s).from(Q), (t[e] = s), t);
      }, {});
    ((X.Syntax = SyntaxError), (X.Type = TypeError), (X.Range = RangeError));
    var Y = H.reduce(function (t, e) {
      return ((t[e + 'Error'] = X[e]), t);
    }, {});
    var Z = j.reduce(function (t, e) {
      return (-1 === ['Syntax', 'Type', 'Range'].indexOf(e) && (t[e + 'Error'] = X[e]), t);
    }, {});
    function J() {}
    function $(t) {
      return t;
    }
    function tt(t, e) {
      return null == t || t === $
        ? e
        : function (i) {
            return e(t(i));
          };
    }
    function et(t, e) {
      return function () {
        (t.apply(this, arguments), e.apply(this, arguments));
      };
    }
    function it(t, e) {
      return t === J
        ? e
        : function () {
            var i = t.apply(this, arguments);
            void 0 !== i && (arguments[0] = i);
            var s = this.onsuccess,
              n = this.onerror;
            ((this.onsuccess = null), (this.onerror = null));
            var r = e.apply(this, arguments);
            return (
              s && (this.onsuccess = this.onsuccess ? et(s, this.onsuccess) : s),
              n && (this.onerror = this.onerror ? et(n, this.onerror) : n),
              void 0 !== r ? r : i
            );
          };
    }
    function st(t, e) {
      return t === J
        ? e
        : function () {
            t.apply(this, arguments);
            var i = this.onsuccess,
              s = this.onerror;
            ((this.onsuccess = this.onerror = null),
              e.apply(this, arguments),
              i && (this.onsuccess = this.onsuccess ? et(i, this.onsuccess) : i),
              s && (this.onerror = this.onerror ? et(s, this.onerror) : s));
          };
    }
    function nt(t, e) {
      return t === J
        ? e
        : function (i) {
            var s = t.apply(this, arguments);
            a(i, s);
            var n = this.onsuccess,
              r = this.onerror;
            ((this.onsuccess = null), (this.onerror = null));
            var o = e.apply(this, arguments);
            return (
              n && (this.onsuccess = this.onsuccess ? et(n, this.onsuccess) : n),
              r && (this.onerror = this.onerror ? et(r, this.onerror) : r),
              void 0 === s ? (void 0 === o ? void 0 : o) : a(s, o)
            );
          };
    }
    function rt(t, e) {
      return t === J
        ? e
        : function () {
            return !1 !== e.apply(this, arguments) && t.apply(this, arguments);
          };
    }
    function at(t, e) {
      return t === J
        ? e
        : function () {
            var i = t.apply(this, arguments);
            if (i && 'function' == typeof i.then) {
              for (var s = this, n = arguments.length, r = new Array(n); n--; ) r[n] = arguments[n];
              return i.then(function () {
                return e.apply(s, r);
              });
            }
            return e.apply(this, arguments);
          };
    }
    ((Z.ModifyError = K), (Z.DexieError = V), (Z.BulkError = G));
    var ot = 'undefined' != typeof location && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
    function ht(t, e) {
      ot = t;
    }
    var lt = {},
      ct = 100,
      ut =
        'undefined' == typeof Promise
          ? []
          : (function () {
              var t = Promise.resolve();
              if ('undefined' == typeof crypto || !crypto.subtle) return [t, o(t), t];
              var e = crypto.subtle.digest('SHA-512', new Uint8Array([0]));
              return [e, o(e), t];
            })(),
      dt = ut[0],
      ft = ut[1],
      pt = ut[2],
      mt = ft && ft.then,
      gt = dt && dt.constructor,
      yt = !!pt;
    var xt = function (t, e) {
        (Dt.push([t, e]), bt && (queueMicrotask(zt), (bt = !1)));
      },
      vt = !0,
      bt = !0,
      wt = [],
      St = [],
      Mt = $,
      Ct = { id: 'global', global: !0, ref: 0, unhandleds: [], onunhandled: J, pgp: !1, env: {}, finalize: J },
      Et = Ct,
      Dt = [],
      At = 0,
      Ft = [];
    function Pt(t) {
      if ('object' != typeof this) throw new TypeError('Promises must be constructed via new');
      ((this._listeners = []), (this._lib = !1));
      var e = (this._PSD = Et);
      if ('function' != typeof t) {
        if (t !== lt) throw new TypeError('Not a function');
        return (
          (this._state = arguments[1]),
          (this._value = arguments[2]),
          void (!1 === this._state && Rt(this, this._value))
        );
      }
      ((this._state = null), (this._value = null), ++e.ref, _t(this, t));
    }
    var Tt = {
      get: function () {
        var t = Et,
          e = Wt;
        function i(i, s) {
          var n = this,
            r = !t.global && (t !== Et || e !== Wt),
            a = r && !Zt(),
            o = new Pt(function (e, o) {
              Bt(n, new It(ne(i, t, r, a), ne(s, t, r, a), e, o, t));
            });
          return (this._consoleTask && (o._consoleTask = this._consoleTask), o);
        }
        return ((i.prototype = lt), i);
      },
      set: function (t) {
        d(
          this,
          'then',
          t && t.prototype === lt
            ? Tt
            : {
                get: function () {
                  return t;
                },
                set: Tt.set,
              },
        );
      },
    };
    function It(t, e, i, s, n) {
      ((this.onFulfilled = 'function' == typeof t ? t : null),
        (this.onRejected = 'function' == typeof e ? e : null),
        (this.resolve = i),
        (this.reject = s),
        (this.psd = n));
    }
    function _t(t, e) {
      try {
        e(
          function (e) {
            if (null === t._state) {
              if (e === t) throw new TypeError('A promise cannot be resolved with itself.');
              var i = t._lib && Lt();
              (e && 'function' == typeof e.then
                ? _t(t, function (t, i) {
                    e instanceof Pt ? e._then(t, i) : e.then(t, i);
                  })
                : ((t._state = !0), (t._value = e), Nt(t)),
                i && Ot());
            }
          },
          Rt.bind(null, t),
        );
      } catch (e) {
        Rt(t, e);
      }
    }
    function Rt(t, e) {
      if ((St.push(e), null === t._state)) {
        var i = t._lib && Lt();
        ((e = Mt(e)),
          (t._state = !1),
          (t._value = e),
          (function (t) {
            wt.some(function (e) {
              return e._value === t._value;
            }) || wt.push(t);
          })(t),
          Nt(t),
          i && Ot());
      }
    }
    function Nt(t) {
      var e = t._listeners;
      t._listeners = [];
      for (var i = 0, s = e.length; i < s; ++i) Bt(t, e[i]);
      var n = t._PSD;
      (--n.ref || n.finalize(),
        0 === At &&
          (++At,
          xt(function () {
            0 == --At && Ht();
          }, [])));
    }
    function Bt(t, e) {
      if (null !== t._state) {
        var i = t._state ? e.onFulfilled : e.onRejected;
        if (null === i) return (t._state ? e.resolve : e.reject)(t._value);
        (++e.psd.ref, ++At, xt(kt, [i, t, e]));
      } else t._listeners.push(e);
    }
    function kt(t, e, i) {
      try {
        var s,
          n = e._value;
        (!e._state && St.length && (St = []),
          (s =
            ot && e._consoleTask
              ? e._consoleTask.run(function () {
                  return t(n);
                })
              : t(n)),
          e._state ||
            -1 !== St.indexOf(n) ||
            (function (t) {
              var e = wt.length;
              for (; e; ) if (wt[--e]._value === t._value) return void wt.splice(e, 1);
            })(e),
          i.resolve(s));
      } catch (t) {
        i.reject(t);
      } finally {
        (0 == --At && Ht(), --i.psd.ref || i.psd.finalize());
      }
    }
    function zt() {
      se(Ct, function () {
        Lt() && Ot();
      });
    }
    function Lt() {
      var t = vt;
      return ((vt = !1), (bt = !1), t);
    }
    function Ot() {
      var t, e, i;
      do {
        for (; Dt.length > 0; )
          for (t = Dt, Dt = [], i = t.length, e = 0; e < i; ++e) {
            var s = t[e];
            s[0].apply(null, s[1]);
          }
      } while (Dt.length > 0);
      ((vt = !0), (bt = !0));
    }
    function Ht() {
      var t = wt;
      ((wt = []),
        t.forEach(function (t) {
          t._PSD.onunhandled.call(null, t._value, t);
        }));
      for (var e = Ft.slice(0), i = e.length; i; ) e[--i]();
    }
    function jt(t) {
      return new Pt(lt, !1, t);
    }
    function qt(t, e) {
      var i = Et;
      return function () {
        var s = Lt(),
          n = Et;
        try {
          return (ee(i, !0), t.apply(this, arguments));
        } catch (t) {
          e && e(t);
        } finally {
          (ee(n, !1), s && Ot());
        }
      };
    }
    (c(Pt.prototype, {
      then: Tt,
      _then: function (t, e) {
        Bt(this, new It(null, null, t, e, Et));
      },
      catch: function (t) {
        if (1 === arguments.length) return this.then(null, t);
        var e = arguments[0],
          i = arguments[1];
        return 'function' == typeof e
          ? this.then(null, function (t) {
              return t instanceof e ? i(t) : jt(t);
            })
          : this.then(null, function (t) {
              return t && t.name === e ? i(t) : jt(t);
            });
      },
      finally: function (t) {
        return this.then(
          function (e) {
            return Pt.resolve(t()).then(function () {
              return e;
            });
          },
          function (e) {
            return Pt.resolve(t()).then(function () {
              return jt(e);
            });
          },
        );
      },
      timeout: function (t, e) {
        var i = this;
        return t < 1 / 0
          ? new Pt(function (s, n) {
              var r = setTimeout(function () {
                return n(new X.Timeout(e));
              }, t);
              i.then(s, n).finally(clearTimeout.bind(null, r));
            })
          : this;
      },
    }),
      'undefined' != typeof Symbol && Symbol.toStringTag && d(Pt.prototype, Symbol.toStringTag, 'Dexie.Promise'),
      (Ct.env = ie()),
      c(Pt, {
        all: function () {
          var t = L.apply(null, arguments).map(Jt);
          return new Pt(function (e, i) {
            0 === t.length && e([]);
            var s = t.length;
            t.forEach(function (n, r) {
              return Pt.resolve(n).then(function (i) {
                ((t[r] = i), --s || e(t));
              }, i);
            });
          });
        },
        resolve: function (t) {
          return t instanceof Pt
            ? t
            : t && 'function' == typeof t.then
              ? new Pt(function (e, i) {
                  t.then(e, i);
                })
              : new Pt(lt, !0, t);
        },
        reject: jt,
        race: function () {
          var t = L.apply(null, arguments).map(Jt);
          return new Pt(function (e, i) {
            t.map(function (t) {
              return Pt.resolve(t).then(e, i);
            });
          });
        },
        PSD: {
          get: function () {
            return Et;
          },
          set: function (t) {
            return (Et = t);
          },
        },
        totalEchoes: {
          get: function () {
            return Wt;
          },
        },
        newPSD: Xt,
        usePSD: se,
        scheduler: {
          get: function () {
            return xt;
          },
          set: function (t) {
            xt = t;
          },
        },
        rejectionMapper: {
          get: function () {
            return Mt;
          },
          set: function (t) {
            Mt = t;
          },
        },
        follow: function (t, e) {
          return new Pt(function (i, s) {
            return Xt(
              function (e, i) {
                var s = Et;
                ((s.unhandleds = []),
                  (s.onunhandled = i),
                  (s.finalize = et(function () {
                    var t = this;
                    !(function (t) {
                      function e() {
                        (t(), Ft.splice(Ft.indexOf(e), 1));
                      }
                      (Ft.push(e),
                        ++At,
                        xt(function () {
                          0 == --At && Ht();
                        }, []));
                    })(function () {
                      0 === t.unhandleds.length ? e() : i(t.unhandleds[0]);
                    });
                  }, s.finalize)),
                  t());
              },
              e,
              i,
              s,
            );
          });
        },
      }),
      gt &&
        (gt.allSettled &&
          d(Pt, 'allSettled', function () {
            var t = L.apply(null, arguments).map(Jt);
            return new Pt(function (e) {
              0 === t.length && e([]);
              var i = t.length,
                s = new Array(i);
              t.forEach(function (t, n) {
                return Pt.resolve(t)
                  .then(
                    function (t) {
                      return (s[n] = { status: 'fulfilled', value: t });
                    },
                    function (t) {
                      return (s[n] = { status: 'rejected', reason: t });
                    },
                  )
                  .then(function () {
                    return --i || e(s);
                  });
              });
            });
          }),
        gt.any &&
          'undefined' != typeof AggregateError &&
          d(Pt, 'any', function () {
            var t = L.apply(null, arguments).map(Jt);
            return new Pt(function (e, i) {
              0 === t.length && i(new AggregateError([]));
              var s = t.length,
                n = new Array(s);
              t.forEach(function (t, r) {
                return Pt.resolve(t).then(
                  function (t) {
                    return e(t);
                  },
                  function (t) {
                    ((n[r] = t), --s || i(new AggregateError(n)));
                  },
                );
              });
            });
          }),
        gt.withResolvers && (Pt.withResolvers = gt.withResolvers)));
    var Vt = { awaits: 0, echoes: 0, id: 0 },
      Ut = 0,
      Kt = [],
      Gt = 0,
      Wt = 0,
      Qt = 0;
    function Xt(t, e, i, s) {
      var n = Et,
        r = Object.create(n);
      ((r.parent = n),
        (r.ref = 0),
        (r.global = !1),
        (r.id = ++Qt),
        Ct.env,
        (r.env = yt
          ? {
              Promise: Pt,
              PromiseProp: { value: Pt, configurable: !0, writable: !0 },
              all: Pt.all,
              race: Pt.race,
              allSettled: Pt.allSettled,
              any: Pt.any,
              resolve: Pt.resolve,
              reject: Pt.reject,
            }
          : {}),
        e && a(r, e),
        ++n.ref,
        (r.finalize = function () {
          --this.parent.ref || this.parent.finalize();
        }));
      var o = se(r, t, i, s);
      return (0 === r.ref && r.finalize(), o);
    }
    function Yt() {
      return (Vt.id || (Vt.id = ++Ut), ++Vt.awaits, (Vt.echoes += ct), Vt.id);
    }
    function Zt() {
      return !!Vt.awaits && (0 == --Vt.awaits && (Vt.id = 0), (Vt.echoes = Vt.awaits * ct), !0);
    }
    function Jt(t) {
      return Vt.echoes && t && t.constructor === gt
        ? (Yt(),
          t.then(
            function (t) {
              return (Zt(), t);
            },
            function (t) {
              return (Zt(), ae(t));
            },
          ))
        : t;
    }
    function $t(t) {
      (++Wt, (Vt.echoes && 0 != --Vt.echoes) || (Vt.echoes = Vt.awaits = Vt.id = 0), Kt.push(Et), ee(t, !0));
    }
    function te() {
      var t = Kt[Kt.length - 1];
      (Kt.pop(), ee(t, !1));
    }
    function ee(t, e) {
      var i = Et;
      if (
        ((e ? !Vt.echoes || (Gt++ && t === Et) : !Gt || (--Gt && t === Et)) ||
          queueMicrotask(e ? $t.bind(null, t) : te),
        t !== Et && ((Et = t), i === Ct && (Ct.env = ie()), yt))
      ) {
        var n = Ct.env.Promise,
          r = t.env;
        (i.global || t.global) &&
          (Object.defineProperty(s, 'Promise', r.PromiseProp),
          (n.all = r.all),
          (n.race = r.race),
          (n.resolve = r.resolve),
          (n.reject = r.reject),
          r.allSettled && (n.allSettled = r.allSettled),
          r.any && (n.any = r.any));
      }
    }
    function ie() {
      var t = s.Promise;
      return yt
        ? {
            Promise: t,
            PromiseProp: Object.getOwnPropertyDescriptor(s, 'Promise'),
            all: t.all,
            race: t.race,
            allSettled: t.allSettled,
            any: t.any,
            resolve: t.resolve,
            reject: t.reject,
          }
        : {};
    }
    function se(t, e, i, s, n) {
      var r = Et;
      try {
        return (ee(t, !0), e(i, s, n));
      } finally {
        ee(r, !1);
      }
    }
    function ne(t, e, i, s) {
      return 'function' != typeof t
        ? t
        : function () {
            var n = Et;
            (i && Yt(), ee(e, !0));
            try {
              return t.apply(this, arguments);
            } finally {
              (ee(n, !1), s && queueMicrotask(Zt));
            }
          };
    }
    function re(t) {
      Promise === gt && 0 === Vt.echoes ? (0 === Gt ? t() : enqueueNativeMicroTask(t)) : setTimeout(t, 0);
    }
    -1 === ('' + mt).indexOf('[native code]') && (Yt = Zt = J);
    var ae = Pt.reject;
    function oe(t, e, i, s) {
      if (t.idbdb && (t._state.openComplete || Et.letThrough || t._vip)) {
        var n = t._createTransaction(e, i, t._dbSchema);
        try {
          (n.create(), (t._state.PR1398_maxLoop = 3));
        } catch (n) {
          return n.name === W.InvalidState && t.isOpen() && --t._state.PR1398_maxLoop > 0
            ? (console.warn('Dexie: Need to reopen db'),
              t.close({ disableAutoOpen: !1 }),
              t.open().then(function () {
                return oe(t, e, i, s);
              }))
            : ae(n);
        }
        return n
          ._promise(e, function (t, e) {
            return Xt(function () {
              return ((Et.trans = n), s(t, e, n));
            });
          })
          .then(function (t) {
            if ('readwrite' === e)
              try {
                n.idbtrans.commit();
              } catch (t) {}
            return 'readonly' === e
              ? t
              : n._completion.then(function () {
                  return t;
                });
          });
      }
      if (t._state.openComplete) return ae(new X.DatabaseClosed(t._state.dbOpenError));
      if (!t._state.isBeingOpened) {
        if (!t._state.autoOpen) return ae(new X.DatabaseClosed());
        t.open().catch(J);
      }
      return t._state.dbReadyPromise.then(function () {
        return oe(t, e, i, s);
      });
    }
    var he = '4.0.11',
      le = String.fromCharCode(65535),
      ce = -1 / 0,
      ue = 'Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.',
      de = 'String expected.',
      fe = [],
      pe = '__dbnames',
      me = 'readonly',
      ge = 'readwrite';
    function ye(t, e) {
      return t
        ? e
          ? function () {
              return t.apply(this, arguments) && e.apply(this, arguments);
            }
          : t
        : e;
    }
    var xe = { type: 3, lower: -1 / 0, lowerOpen: !1, upper: [[]], upperOpen: !1 };
    function ve(t) {
      return 'string' != typeof t || /\./.test(t)
        ? function (t) {
            return t;
          }
        : function (e) {
            return (void 0 === e[t] && t in e && delete (e = T(e))[t], e);
          };
    }
    function be() {
      throw X.Type();
    }
    function we(t, e) {
      try {
        var i = Se(t),
          s = Se(e);
        if (i !== s)
          return 'Array' === i
            ? 1
            : 'Array' === s
              ? -1
              : 'binary' === i
                ? 1
                : 'binary' === s
                  ? -1
                  : 'string' === i
                    ? 1
                    : 'string' === s
                      ? -1
                      : 'Date' === i
                        ? 1
                        : 'Date' !== s
                          ? NaN
                          : -1;
        switch (i) {
          case 'number':
          case 'Date':
          case 'string':
            return t > e ? 1 : t < e ? -1 : 0;
          case 'binary':
            return (function (t, e) {
              for (var i = t.length, s = e.length, n = i < s ? i : s, r = 0; r < n; ++r)
                if (t[r] !== e[r]) return t[r] < e[r] ? -1 : 1;
              return i === s ? 0 : i < s ? -1 : 1;
            })(Me(t), Me(e));
          case 'Array':
            return (function (t, e) {
              for (var i = t.length, s = e.length, n = i < s ? i : s, r = 0; r < n; ++r) {
                var a = we(t[r], e[r]);
                if (0 !== a) return a;
              }
              return i === s ? 0 : i < s ? -1 : 1;
            })(t, e);
        }
      } catch (t) {}
      return NaN;
    }
    function Se(t) {
      var e = typeof t;
      if ('object' !== e) return e;
      if (ArrayBuffer.isView(t)) return 'binary';
      var i = R(t);
      return 'ArrayBuffer' === i ? 'binary' : i;
    }
    function Me(t) {
      return t instanceof Uint8Array
        ? t
        : ArrayBuffer.isView(t)
          ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength)
          : new Uint8Array(t);
    }
    var Ce = (function () {
      function e() {}
      return (
        (e.prototype._trans = function (t, e, i) {
          var s = this._tx || Et.trans,
            n = this.name,
            r =
              ot &&
              'undefined' != typeof console &&
              console.createTask &&
              console.createTask('Dexie: '.concat('readonly' === t ? 'read' : 'write', ' ').concat(this.name));
          function a(t, i, s) {
            if (!s.schema[n]) throw new X.NotFound('Table ' + n + ' not part of transaction');
            return e(s.idbtrans, s);
          }
          var o = Lt();
          try {
            var h =
              s && s.db._novip === this.db._novip
                ? s === Et.trans
                  ? s._promise(t, a, i)
                  : Xt(
                      function () {
                        return s._promise(t, a, i);
                      },
                      { trans: s, transless: Et.transless || Et },
                    )
                : oe(this.db, t, [this.name], a);
            return (
              r &&
                ((h._consoleTask = r),
                (h = h.catch(function (t) {
                  return (console.trace(t), ae(t));
                }))),
              h
            );
          } finally {
            o && Ot();
          }
        }),
        (e.prototype.get = function (t, e) {
          var i = this;
          return t && t.constructor === Object
            ? this.where(t).first(e)
            : null == t
              ? ae(new X.Type('Invalid argument to Table.get()'))
              : this._trans('readonly', function (e) {
                  return i.core.get({ trans: e, key: t }).then(function (t) {
                    return i.hook.reading.fire(t);
                  });
                }).then(e);
        }),
        (e.prototype.where = function (t) {
          if ('string' == typeof t) return new this.db.WhereClause(this, t);
          if (r(t)) return new this.db.WhereClause(this, '['.concat(t.join('+'), ']'));
          var e = n(t);
          if (1 === e.length) return this.where(e[0]).equals(t[e[0]]);
          var i = this.schema.indexes
            .concat(this.schema.primKey)
            .filter(function (t) {
              if (
                t.compound &&
                e.every(function (e) {
                  return t.keyPath.indexOf(e) >= 0;
                })
              ) {
                for (var i = 0; i < e.length; ++i) if (-1 === e.indexOf(t.keyPath[i])) return !1;
                return !0;
              }
              return !1;
            })
            .sort(function (t, e) {
              return t.keyPath.length - e.keyPath.length;
            })[0];
          if (i && this.db._maxKey !== le) {
            var s = i.keyPath.slice(0, e.length);
            return this.where(s).equals(
              s.map(function (e) {
                return t[e];
              }),
            );
          }
          !i &&
            ot &&
            console.warn(
              'The query '.concat(JSON.stringify(t), ' on ').concat(this.name, ' would benefit from a ') +
                'compound index ['.concat(e.join('+'), ']'),
            );
          var a = this.schema.idxByName;
          function o(t, e) {
            return 0 === we(t, e);
          }
          var h = e.reduce(
              function (e, i) {
                var s = e[0],
                  n = e[1],
                  h = a[i],
                  l = t[i];
                return [
                  s || h,
                  s || !h
                    ? ye(
                        n,
                        h && h.multi
                          ? function (t) {
                              var e = w(t, i);
                              return (
                                r(e) &&
                                e.some(function (t) {
                                  return o(l, t);
                                })
                              );
                            }
                          : function (t) {
                              return o(l, w(t, i));
                            },
                      )
                    : n,
                ];
              },
              [null, null],
            ),
            l = h[0],
            c = h[1];
          return l ? this.where(l.name).equals(t[l.keyPath]).filter(c) : i ? this.filter(c) : this.where(e).equals('');
        }),
        (e.prototype.filter = function (t) {
          return this.toCollection().and(t);
        }),
        (e.prototype.count = function (t) {
          return this.toCollection().count(t);
        }),
        (e.prototype.offset = function (t) {
          return this.toCollection().offset(t);
        }),
        (e.prototype.limit = function (t) {
          return this.toCollection().limit(t);
        }),
        (e.prototype.each = function (t) {
          return this.toCollection().each(t);
        }),
        (e.prototype.toArray = function (t) {
          return this.toCollection().toArray(t);
        }),
        (e.prototype.toCollection = function () {
          return new this.db.Collection(new this.db.WhereClause(this));
        }),
        (e.prototype.orderBy = function (t) {
          return new this.db.Collection(new this.db.WhereClause(this, r(t) ? '['.concat(t.join('+'), ']') : t));
        }),
        (e.prototype.reverse = function () {
          return this.toCollection().reverse();
        }),
        (e.prototype.mapToClass = function (e) {
          var i = this.db,
            s = this.name;
          ((this.schema.mappedClass = e),
            e.prototype instanceof be &&
              (e = (function (e) {
                function n() {
                  return (null !== e && e.apply(this, arguments)) || this;
                }
                return (
                  (function (e, i) {
                    if ('function' != typeof i && null !== i)
                      throw new TypeError('Class extends value ' + String(i) + ' is not a constructor or null');
                    function s() {
                      this.constructor = e;
                    }
                    (t(e, i), (e.prototype = null === i ? Object.create(i) : ((s.prototype = i.prototype), new s())));
                  })(n, e),
                  Object.defineProperty(n.prototype, 'db', {
                    get: function () {
                      return i;
                    },
                    enumerable: !1,
                    configurable: !0,
                  }),
                  (n.prototype.table = function () {
                    return s;
                  }),
                  n
                );
              })(e)));
          for (var n = new Set(), r = e.prototype; r; r = o(r))
            Object.getOwnPropertyNames(r).forEach(function (t) {
              return n.add(t);
            });
          var a = function (t) {
            if (!t) return t;
            var i = Object.create(e.prototype);
            for (var s in t)
              if (!n.has(s))
                try {
                  i[s] = t[s];
                } catch (t) {}
            return i;
          };
          return (
            this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook),
            (this.schema.readHook = a),
            this.hook('reading', a),
            e
          );
        }),
        (e.prototype.defineClass = function () {
          return this.mapToClass(function (t) {
            a(this, t);
          });
        }),
        (e.prototype.add = function (t, e) {
          var i = this,
            s = this.schema.primKey,
            n = s.auto,
            r = s.keyPath,
            a = t;
          return (
            r && n && (a = ve(r)(t)),
            this._trans('readwrite', function (t) {
              return i.core.mutate({ trans: t, type: 'add', keys: null != e ? [e] : null, values: [a] });
            })
              .then(function (t) {
                return t.numFailures ? Pt.reject(t.failures[0]) : t.lastResult;
              })
              .then(function (e) {
                if (r)
                  try {
                    S(t, r, e);
                  } catch (t) {}
                return e;
              })
          );
        }),
        (e.prototype.update = function (t, e) {
          if ('object' != typeof t || r(t)) return this.where(':id').equals(t).modify(e);
          var i = w(t, this.schema.primKey.keyPath);
          return void 0 === i
            ? ae(new X.InvalidArgument('Given object does not contain its primary key'))
            : this.where(':id').equals(i).modify(e);
        }),
        (e.prototype.put = function (t, e) {
          var i = this,
            s = this.schema.primKey,
            n = s.auto,
            r = s.keyPath,
            a = t;
          return (
            r && n && (a = ve(r)(t)),
            this._trans('readwrite', function (t) {
              return i.core.mutate({ trans: t, type: 'put', values: [a], keys: null != e ? [e] : null });
            })
              .then(function (t) {
                return t.numFailures ? Pt.reject(t.failures[0]) : t.lastResult;
              })
              .then(function (e) {
                if (r)
                  try {
                    S(t, r, e);
                  } catch (t) {}
                return e;
              })
          );
        }),
        (e.prototype.delete = function (t) {
          var e = this;
          return this._trans('readwrite', function (i) {
            return e.core.mutate({ trans: i, type: 'delete', keys: [t] });
          }).then(function (t) {
            return t.numFailures ? Pt.reject(t.failures[0]) : void 0;
          });
        }),
        (e.prototype.clear = function () {
          var t = this;
          return this._trans('readwrite', function (e) {
            return t.core.mutate({ trans: e, type: 'deleteRange', range: xe });
          }).then(function (t) {
            return t.numFailures ? Pt.reject(t.failures[0]) : void 0;
          });
        }),
        (e.prototype.bulkGet = function (t) {
          var e = this;
          return this._trans('readonly', function (i) {
            return e.core.getMany({ keys: t, trans: i }).then(function (t) {
              return t.map(function (t) {
                return e.hook.reading.fire(t);
              });
            });
          });
        }),
        (e.prototype.bulkAdd = function (t, e, i) {
          var s = this,
            n = Array.isArray(e) ? e : void 0,
            r = (i = i || (n ? void 0 : e)) ? i.allKeys : void 0;
          return this._trans('readwrite', function (e) {
            var i = s.schema.primKey,
              a = i.auto,
              o = i.keyPath;
            if (o && n) throw new X.InvalidArgument('bulkAdd(): keys argument invalid on tables with inbound keys');
            if (n && n.length !== t.length)
              throw new X.InvalidArgument('Arguments objects and keys must have the same length');
            var h = t.length,
              l = o && a ? t.map(ve(o)) : t;
            return s.core.mutate({ trans: e, type: 'add', keys: n, values: l, wantResults: r }).then(function (t) {
              var e = t.numFailures,
                i = t.results,
                n = t.lastResult,
                a = t.failures;
              if (0 === e) return r ? i : n;
              throw new G(''.concat(s.name, '.bulkAdd(): ').concat(e, ' of ').concat(h, ' operations failed'), a);
            });
          });
        }),
        (e.prototype.bulkPut = function (t, e, i) {
          var s = this,
            n = Array.isArray(e) ? e : void 0,
            r = (i = i || (n ? void 0 : e)) ? i.allKeys : void 0;
          return this._trans('readwrite', function (e) {
            var i = s.schema.primKey,
              a = i.auto,
              o = i.keyPath;
            if (o && n) throw new X.InvalidArgument('bulkPut(): keys argument invalid on tables with inbound keys');
            if (n && n.length !== t.length)
              throw new X.InvalidArgument('Arguments objects and keys must have the same length');
            var h = t.length,
              l = o && a ? t.map(ve(o)) : t;
            return s.core.mutate({ trans: e, type: 'put', keys: n, values: l, wantResults: r }).then(function (t) {
              var e = t.numFailures,
                i = t.results,
                n = t.lastResult,
                a = t.failures;
              if (0 === e) return r ? i : n;
              throw new G(''.concat(s.name, '.bulkPut(): ').concat(e, ' of ').concat(h, ' operations failed'), a);
            });
          });
        }),
        (e.prototype.bulkUpdate = function (t) {
          var e = this,
            i = this.core,
            s = t.map(function (t) {
              return t.key;
            }),
            n = t.map(function (t) {
              return t.changes;
            }),
            r = [];
          return this._trans('readwrite', function (a) {
            return i.getMany({ trans: a, keys: s, cache: 'clone' }).then(function (o) {
              var h = [],
                l = [];
              t.forEach(function (t, i) {
                var s = t.key,
                  n = t.changes,
                  a = o[i];
                if (a) {
                  for (var c = 0, u = Object.keys(n); c < u.length; c++) {
                    var d = u[c],
                      f = n[d];
                    if (d === e.schema.primKey.keyPath) {
                      if (0 !== we(f, s)) throw new X.Constraint('Cannot update primary key in bulkUpdate()');
                    } else S(a, d, f);
                  }
                  (r.push(i), h.push(s), l.push(a));
                }
              });
              var c = h.length;
              return i
                .mutate({ trans: a, type: 'put', keys: h, values: l, updates: { keys: s, changeSpecs: n } })
                .then(function (t) {
                  var i = t.numFailures,
                    s = t.failures;
                  if (0 === i) return c;
                  for (var n = 0, a = Object.keys(s); n < a.length; n++) {
                    var o = a[n],
                      h = r[Number(o)];
                    if (null != h) {
                      var l = s[o];
                      (delete s[o], (s[h] = l));
                    }
                  }
                  throw new G(
                    ''.concat(e.name, '.bulkUpdate(): ').concat(i, ' of ').concat(c, ' operations failed'),
                    s,
                  );
                });
            });
          });
        }),
        (e.prototype.bulkDelete = function (t) {
          var e = this,
            i = t.length;
          return this._trans('readwrite', function (i) {
            return e.core.mutate({ trans: i, type: 'delete', keys: t });
          }).then(function (t) {
            var s = t.numFailures,
              n = t.lastResult,
              r = t.failures;
            if (0 === s) return n;
            throw new G(''.concat(e.name, '.bulkDelete(): ').concat(s, ' of ').concat(i, ' operations failed'), r);
          });
        }),
        e
      );
    })();
    function Ee(t) {
      var e = {},
        i = function (i, s) {
          if (s) {
            for (var n = arguments.length, r = new Array(n - 1); --n; ) r[n - 1] = arguments[n];
            return (e[i].subscribe.apply(null, r), t);
          }
          if ('string' == typeof i) return e[i];
        };
      i.addEventType = o;
      for (var s = 1, a = arguments.length; s < a; ++s) o(arguments[s]);
      return i;
      function o(t, s, a) {
        if ('object' != typeof t) {
          var h;
          (s || (s = rt), a || (a = J));
          var l = {
            subscribers: [],
            fire: a,
            subscribe: function (t) {
              -1 === l.subscribers.indexOf(t) && (l.subscribers.push(t), (l.fire = s(l.fire, t)));
            },
            unsubscribe: function (t) {
              ((l.subscribers = l.subscribers.filter(function (e) {
                return e !== t;
              })),
                (l.fire = l.subscribers.reduce(s, a)));
            },
          };
          return ((e[t] = i[t] = l), l);
        }
        n((h = t)).forEach(function (t) {
          var e = h[t];
          if (r(e)) o(t, h[t][0], h[t][1]);
          else {
            if ('asap' !== e) throw new X.InvalidArgument('Invalid event config');
            var i = o(t, $, function () {
              for (var t = arguments.length, e = new Array(t); t--; ) e[t] = arguments[t];
              i.subscribers.forEach(function (t) {
                b(function () {
                  t.apply(null, e);
                });
              });
            });
          }
        });
      }
    }
    function De(t, e) {
      return (f(e).from({ prototype: t }), e);
    }
    function Ae(t, e) {
      return !(t.filter || t.algorithm || t.or) && (e ? t.justLimit : !t.replayFilter);
    }
    function Fe(t, e) {
      t.filter = ye(t.filter, e);
    }
    function Pe(t, e, i) {
      var s = t.replayFilter;
      ((t.replayFilter = s
        ? function () {
            return ye(s(), e());
          }
        : e),
        (t.justLimit = i && !s));
    }
    function Te(t, e) {
      if (t.isPrimKey) return e.primaryKey;
      var i = e.getIndexByKeyPath(t.index);
      if (!i) throw new X.Schema('KeyPath ' + t.index + ' on object store ' + e.name + ' is not indexed');
      return i;
    }
    function Ie(t, e, i) {
      var s = Te(t, e.schema);
      return e.openCursor({
        trans: i,
        values: !t.keysOnly,
        reverse: 'prev' === t.dir,
        unique: !!t.unique,
        query: { index: s, range: t.range },
      });
    }
    function _e(t, e, i, s) {
      var n = t.replayFilter ? ye(t.filter, t.replayFilter()) : t.filter;
      if (t.or) {
        var r = {},
          a = function (t, i, s) {
            if (
              !n ||
              n(
                i,
                s,
                function (t) {
                  return i.stop(t);
                },
                function (t) {
                  return i.fail(t);
                },
              )
            ) {
              var a = i.primaryKey,
                o = '' + a;
              ('[object ArrayBuffer]' === o && (o = '' + new Uint8Array(a)), l(r, o) || ((r[o] = !0), e(t, i, s)));
            }
          };
        return Promise.all([t.or._iterate(a, i), Re(Ie(t, s, i), t.algorithm, a, !t.keysOnly && t.valueMapper)]);
      }
      return Re(Ie(t, s, i), ye(t.algorithm, n), e, !t.keysOnly && t.valueMapper);
    }
    function Re(t, e, i, s) {
      var n = qt(
        s
          ? function (t, e, n) {
              return i(s(t), e, n);
            }
          : i,
      );
      return t.then(function (t) {
        if (t)
          return t.start(function () {
            var i = function () {
              return t.continue();
            };
            ((e &&
              !e(
                t,
                function (t) {
                  return (i = t);
                },
                function (e) {
                  (t.stop(e), (i = J));
                },
                function (e) {
                  (t.fail(e), (i = J));
                },
              )) ||
              n(t.value, t, function (t) {
                return (i = t);
              }),
              i());
          });
      });
    }
    var Ne = (function () {
        function t(t) {
          this['@@propmod'] = t;
        }
        return (
          (t.prototype.execute = function (t) {
            var e,
              s = this['@@propmod'];
            if (void 0 !== s.add) {
              var n = s.add;
              if (r(n)) return i(i([], r(t) ? t : []), n).sort();
              if ('number' == typeof n) return (Number(t) || 0) + n;
              if ('bigint' == typeof n)
                try {
                  return BigInt(t) + n;
                } catch (t) {
                  return BigInt(0) + n;
                }
              throw new TypeError('Invalid term '.concat(n));
            }
            if (void 0 !== s.remove) {
              var a = s.remove;
              if (r(a))
                return r(t)
                  ? t
                      .filter(function (t) {
                        return !a.includes(t);
                      })
                      .sort()
                  : [];
              if ('number' == typeof a) return Number(t) - a;
              if ('bigint' == typeof a)
                try {
                  return BigInt(t) - a;
                } catch (t) {
                  return BigInt(0) - a;
                }
              throw new TypeError('Invalid subtrahend '.concat(a));
            }
            var o = null === (e = s.replacePrefix) || void 0 === e ? void 0 : e[0];
            return o && 'string' == typeof t && t.startsWith(o) ? s.replacePrefix[1] + t.substring(o.length) : t;
          }),
          t
        );
      })(),
      Be = (function () {
        function t() {}
        return (
          (t.prototype._read = function (t, e) {
            var i = this._ctx;
            return i.error ? i.table._trans(null, ae.bind(null, i.error)) : i.table._trans('readonly', t).then(e);
          }),
          (t.prototype._write = function (t) {
            var e = this._ctx;
            return e.error ? e.table._trans(null, ae.bind(null, e.error)) : e.table._trans('readwrite', t, 'locked');
          }),
          (t.prototype._addAlgorithm = function (t) {
            var e = this._ctx;
            e.algorithm = ye(e.algorithm, t);
          }),
          (t.prototype._iterate = function (t, e) {
            return _e(this._ctx, t, e, this._ctx.table.core);
          }),
          (t.prototype.clone = function (t) {
            var e = Object.create(this.constructor.prototype),
              i = Object.create(this._ctx);
            return (t && a(i, t), (e._ctx = i), e);
          }),
          (t.prototype.raw = function () {
            return ((this._ctx.valueMapper = null), this);
          }),
          (t.prototype.each = function (t) {
            var e = this._ctx;
            return this._read(function (i) {
              return _e(e, t, i, e.table.core);
            });
          }),
          (t.prototype.count = function (t) {
            var e = this;
            return this._read(function (t) {
              var i = e._ctx,
                s = i.table.core;
              if (Ae(i, !0))
                return s.count({ trans: t, query: { index: Te(i, s.schema), range: i.range } }).then(function (t) {
                  return Math.min(t, i.limit);
                });
              var n = 0;
              return _e(
                i,
                function () {
                  return (++n, !1);
                },
                t,
                s,
              ).then(function () {
                return n;
              });
            }).then(t);
          }),
          (t.prototype.sortBy = function (t, e) {
            var i = t.split('.').reverse(),
              s = i[0],
              n = i.length - 1;
            function r(t, e) {
              return e ? r(t[i[e]], e - 1) : t[s];
            }
            var a = 'next' === this._ctx.dir ? 1 : -1;
            function o(t, e) {
              return we(r(t, n), r(e, n)) * a;
            }
            return this.toArray(function (t) {
              return t.sort(o);
            }).then(e);
          }),
          (t.prototype.toArray = function (t) {
            var e = this;
            return this._read(function (t) {
              var i = e._ctx;
              if ('next' === i.dir && Ae(i, !0) && i.limit > 0) {
                var s = i.valueMapper,
                  n = Te(i, i.table.core.schema);
                return i.table.core
                  .query({ trans: t, limit: i.limit, values: !0, query: { index: n, range: i.range } })
                  .then(function (t) {
                    var e = t.result;
                    return s ? e.map(s) : e;
                  });
              }
              var r = [];
              return _e(
                i,
                function (t) {
                  return r.push(t);
                },
                t,
                i.table.core,
              ).then(function () {
                return r;
              });
            }, t);
          }),
          (t.prototype.offset = function (t) {
            var e = this._ctx;
            return (
              t <= 0 ||
                ((e.offset += t),
                Ae(e)
                  ? Pe(e, function () {
                      var e = t;
                      return function (t, i) {
                        return (
                          0 === e ||
                          (1 === e
                            ? (--e, !1)
                            : (i(function () {
                                (t.advance(e), (e = 0));
                              }),
                              !1))
                        );
                      };
                    })
                  : Pe(e, function () {
                      var e = t;
                      return function () {
                        return --e < 0;
                      };
                    })),
              this
            );
          }),
          (t.prototype.limit = function (t) {
            return (
              (this._ctx.limit = Math.min(this._ctx.limit, t)),
              Pe(
                this._ctx,
                function () {
                  var e = t;
                  return function (t, i, s) {
                    return (--e <= 0 && i(s), e >= 0);
                  };
                },
                !0,
              ),
              this
            );
          }),
          (t.prototype.until = function (t, e) {
            return (
              Fe(this._ctx, function (i, s, n) {
                return !t(i.value) || (s(n), e);
              }),
              this
            );
          }),
          (t.prototype.first = function (t) {
            return this.limit(1)
              .toArray(function (t) {
                return t[0];
              })
              .then(t);
          }),
          (t.prototype.last = function (t) {
            return this.reverse().first(t);
          }),
          (t.prototype.filter = function (t) {
            var e, i;
            return (
              Fe(this._ctx, function (e) {
                return t(e.value);
              }),
              (e = this._ctx),
              (i = t),
              (e.isMatch = ye(e.isMatch, i)),
              this
            );
          }),
          (t.prototype.and = function (t) {
            return this.filter(t);
          }),
          (t.prototype.or = function (t) {
            return new this.db.WhereClause(this._ctx.table, t, this);
          }),
          (t.prototype.reverse = function () {
            return (
              (this._ctx.dir = 'prev' === this._ctx.dir ? 'next' : 'prev'),
              this._ondirectionchange && this._ondirectionchange(this._ctx.dir),
              this
            );
          }),
          (t.prototype.desc = function () {
            return this.reverse();
          }),
          (t.prototype.eachKey = function (t) {
            var e = this._ctx;
            return (
              (e.keysOnly = !e.isMatch),
              this.each(function (e, i) {
                t(i.key, i);
              })
            );
          }),
          (t.prototype.eachUniqueKey = function (t) {
            return ((this._ctx.unique = 'unique'), this.eachKey(t));
          }),
          (t.prototype.eachPrimaryKey = function (t) {
            var e = this._ctx;
            return (
              (e.keysOnly = !e.isMatch),
              this.each(function (e, i) {
                t(i.primaryKey, i);
              })
            );
          }),
          (t.prototype.keys = function (t) {
            var e = this._ctx;
            e.keysOnly = !e.isMatch;
            var i = [];
            return this.each(function (t, e) {
              i.push(e.key);
            })
              .then(function () {
                return i;
              })
              .then(t);
          }),
          (t.prototype.primaryKeys = function (t) {
            var e = this._ctx;
            if ('next' === e.dir && Ae(e, !0) && e.limit > 0)
              return this._read(function (t) {
                var i = Te(e, e.table.core.schema);
                return e.table.core.query({
                  trans: t,
                  values: !1,
                  limit: e.limit,
                  query: { index: i, range: e.range },
                });
              })
                .then(function (t) {
                  return t.result;
                })
                .then(t);
            e.keysOnly = !e.isMatch;
            var i = [];
            return this.each(function (t, e) {
              i.push(e.primaryKey);
            })
              .then(function () {
                return i;
              })
              .then(t);
          }),
          (t.prototype.uniqueKeys = function (t) {
            return ((this._ctx.unique = 'unique'), this.keys(t));
          }),
          (t.prototype.firstKey = function (t) {
            return this.limit(1)
              .keys(function (t) {
                return t[0];
              })
              .then(t);
          }),
          (t.prototype.lastKey = function (t) {
            return this.reverse().firstKey(t);
          }),
          (t.prototype.distinct = function () {
            var t = this._ctx,
              e = t.index && t.table.schema.idxByName[t.index];
            if (!e || !e.multi) return this;
            var i = {};
            return (
              Fe(this._ctx, function (t) {
                var e = t.primaryKey.toString(),
                  s = l(i, e);
                return ((i[e] = !0), !s);
              }),
              this
            );
          }),
          (t.prototype.modify = function (t) {
            var e = this,
              i = this._ctx;
            return this._write(function (s) {
              var r;
              if ('function' == typeof t) r = t;
              else {
                var a = n(t),
                  o = a.length;
                r = function (e) {
                  for (var i = !1, s = 0; s < o; ++s) {
                    var n = a[s],
                      r = t[n],
                      h = w(e, n);
                    r instanceof Ne ? (S(e, n, r.execute(h)), (i = !0)) : h !== r && (S(e, n, r), (i = !0));
                  }
                  return i;
                };
              }
              var h = i.table.core,
                l = h.schema.primaryKey,
                c = l.outbound,
                u = l.extractKey,
                d = 200,
                f = e.db._options.modifyChunkSize;
              f && (d = 'object' == typeof f ? f[h.name] || f['*'] || 200 : f);
              var p = [],
                m = 0,
                g = [],
                y = function (t, e) {
                  var i = e.failures,
                    s = e.numFailures;
                  m += t - s;
                  for (var r = 0, a = n(i); r < a.length; r++) {
                    var o = a[r];
                    p.push(i[o]);
                  }
                };
              return e
                .clone()
                .primaryKeys()
                .then(function (e) {
                  var n = Ae(i) &&
                      i.limit === 1 / 0 &&
                      ('function' != typeof t || t === ke) && { index: i.index, range: i.range },
                    a = function (i) {
                      var o = Math.min(d, e.length - i);
                      return h.getMany({ trans: s, keys: e.slice(i, i + o), cache: 'immutable' }).then(function (l) {
                        for (var f = [], p = [], m = c ? [] : null, g = [], x = 0; x < o; ++x) {
                          var v = l[x],
                            b = { value: T(v), primKey: e[i + x] };
                          !1 !== r.call(b, b.value, b) &&
                            (null == b.value
                              ? g.push(e[i + x])
                              : c || 0 === we(u(v), u(b.value))
                                ? (p.push(b.value), c && m.push(e[i + x]))
                                : (g.push(e[i + x]), f.push(b.value)));
                        }
                        return Promise.resolve(
                          f.length > 0 &&
                            h.mutate({ trans: s, type: 'add', values: f }).then(function (t) {
                              for (var e in t.failures) g.splice(parseInt(e), 1);
                              y(f.length, t);
                            }),
                        )
                          .then(function () {
                            return (
                              (p.length > 0 || (n && 'object' == typeof t)) &&
                              h
                                .mutate({
                                  trans: s,
                                  type: 'put',
                                  keys: m,
                                  values: p,
                                  criteria: n,
                                  changeSpec: 'function' != typeof t && t,
                                  isAdditionalChunk: i > 0,
                                })
                                .then(function (t) {
                                  return y(p.length, t);
                                })
                            );
                          })
                          .then(function () {
                            return (
                              (g.length > 0 || (n && t === ke)) &&
                              h
                                .mutate({ trans: s, type: 'delete', keys: g, criteria: n, isAdditionalChunk: i > 0 })
                                .then(function (t) {
                                  return y(g.length, t);
                                })
                            );
                          })
                          .then(function () {
                            return e.length > i + o && a(i + d);
                          });
                      });
                    };
                  return a(0).then(function () {
                    if (p.length > 0) throw new K('Error modifying one or more objects', p, m, g);
                    return e.length;
                  });
                });
            });
          }),
          (t.prototype.delete = function () {
            var t = this._ctx,
              e = t.range;
            return Ae(t) && (t.isPrimKey || 3 === e.type)
              ? this._write(function (i) {
                  var s = t.table.core.schema.primaryKey,
                    n = e;
                  return t.table.core.count({ trans: i, query: { index: s, range: n } }).then(function (e) {
                    return t.table.core.mutate({ trans: i, type: 'deleteRange', range: n }).then(function (t) {
                      var i = t.failures;
                      (t.lastResult, t.results);
                      var s = t.numFailures;
                      if (s)
                        throw new K(
                          'Could not delete some values',
                          Object.keys(i).map(function (t) {
                            return i[t];
                          }),
                          e - s,
                        );
                      return e - s;
                    });
                  });
                })
              : this.modify(ke);
          }),
          t
        );
      })(),
      ke = function (t, e) {
        return (e.value = null);
      };
    function ze(t, e) {
      return t < e ? -1 : t === e ? 0 : 1;
    }
    function Le(t, e) {
      return t > e ? -1 : t === e ? 0 : 1;
    }
    function Oe(t, e, i) {
      var s = t instanceof Ke ? new t.Collection(t) : t;
      return ((s._ctx.error = i ? new i(e) : new TypeError(e)), s);
    }
    function He(t) {
      return new t.Collection(t, function () {
        return Ue('');
      }).limit(0);
    }
    function je(t, e, i, s, n, r) {
      for (var a = Math.min(t.length, s.length), o = -1, h = 0; h < a; ++h) {
        var l = e[h];
        if (l !== s[h])
          return n(t[h], i[h]) < 0
            ? t.substr(0, h) + i[h] + i.substr(h + 1)
            : n(t[h], s[h]) < 0
              ? t.substr(0, h) + s[h] + i.substr(h + 1)
              : o >= 0
                ? t.substr(0, o) + e[o] + i.substr(o + 1)
                : null;
        n(t[h], l) < 0 && (o = h);
      }
      return a < s.length && 'next' === r
        ? t + i.substr(t.length)
        : a < t.length && 'prev' === r
          ? t.substr(0, i.length)
          : o < 0
            ? null
            : t.substr(0, o) + s[o] + i.substr(o + 1);
    }
    function qe(t, e, i, s) {
      var n,
        r,
        a,
        o,
        h,
        l,
        c,
        u = i.length;
      if (
        !i.every(function (t) {
          return 'string' == typeof t;
        })
      )
        return Oe(t, de);
      function d(t) {
        ((n = (function (t) {
          return 'next' === t
            ? function (t) {
                return t.toUpperCase();
              }
            : function (t) {
                return t.toLowerCase();
              };
        })(t)),
          (r = (function (t) {
            return 'next' === t
              ? function (t) {
                  return t.toLowerCase();
                }
              : function (t) {
                  return t.toUpperCase();
                };
          })(t)),
          (a = 'next' === t ? ze : Le));
        var e = i
          .map(function (t) {
            return { lower: r(t), upper: n(t) };
          })
          .sort(function (t, e) {
            return a(t.lower, e.lower);
          });
        ((o = e.map(function (t) {
          return t.upper;
        })),
          (h = e.map(function (t) {
            return t.lower;
          })),
          (l = t),
          (c = 'next' === t ? '' : s));
      }
      d('next');
      var f = new t.Collection(t, function () {
        return Ve(o[0], h[u - 1] + s);
      });
      f._ondirectionchange = function (t) {
        d(t);
      };
      var p = 0;
      return (
        f._addAlgorithm(function (t, i, s) {
          var n = t.key;
          if ('string' != typeof n) return !1;
          var d = r(n);
          if (e(d, h, p)) return !0;
          for (var f = null, m = p; m < u; ++m) {
            var g = je(n, d, o[m], h[m], a, l);
            null === g && null === f ? (p = m + 1) : (null === f || a(f, g) > 0) && (f = g);
          }
          return (
            i(
              null !== f
                ? function () {
                    t.continue(f + c);
                  }
                : s,
            ),
            !1
          );
        }),
        f
      );
    }
    function Ve(t, e, i, s) {
      return { type: 2, lower: t, upper: e, lowerOpen: i, upperOpen: s };
    }
    function Ue(t) {
      return { type: 1, lower: t, upper: t };
    }
    var Ke = (function () {
      function t() {}
      return (
        Object.defineProperty(t.prototype, 'Collection', {
          get: function () {
            return this._ctx.table.db.Collection;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.between = function (t, e, i, s) {
          ((i = !1 !== i), (s = !0 === s));
          try {
            return this._cmp(t, e) > 0 || (0 === this._cmp(t, e) && (i || s) && (!i || !s))
              ? He(this)
              : new this.Collection(this, function () {
                  return Ve(t, e, !i, !s);
                });
          } catch (t) {
            return Oe(this, ue);
          }
        }),
        (t.prototype.equals = function (t) {
          return null == t
            ? Oe(this, ue)
            : new this.Collection(this, function () {
                return Ue(t);
              });
        }),
        (t.prototype.above = function (t) {
          return null == t
            ? Oe(this, ue)
            : new this.Collection(this, function () {
                return Ve(t, void 0, !0);
              });
        }),
        (t.prototype.aboveOrEqual = function (t) {
          return null == t
            ? Oe(this, ue)
            : new this.Collection(this, function () {
                return Ve(t, void 0, !1);
              });
        }),
        (t.prototype.below = function (t) {
          return null == t
            ? Oe(this, ue)
            : new this.Collection(this, function () {
                return Ve(void 0, t, !1, !0);
              });
        }),
        (t.prototype.belowOrEqual = function (t) {
          return null == t
            ? Oe(this, ue)
            : new this.Collection(this, function () {
                return Ve(void 0, t);
              });
        }),
        (t.prototype.startsWith = function (t) {
          return 'string' != typeof t ? Oe(this, de) : this.between(t, t + le, !0, !0);
        }),
        (t.prototype.startsWithIgnoreCase = function (t) {
          return '' === t
            ? this.startsWith(t)
            : qe(
                this,
                function (t, e) {
                  return 0 === t.indexOf(e[0]);
                },
                [t],
                le,
              );
        }),
        (t.prototype.equalsIgnoreCase = function (t) {
          return qe(
            this,
            function (t, e) {
              return t === e[0];
            },
            [t],
            '',
          );
        }),
        (t.prototype.anyOfIgnoreCase = function () {
          var t = L.apply(z, arguments);
          return 0 === t.length
            ? He(this)
            : qe(
                this,
                function (t, e) {
                  return -1 !== e.indexOf(t);
                },
                t,
                '',
              );
        }),
        (t.prototype.startsWithAnyOfIgnoreCase = function () {
          var t = L.apply(z, arguments);
          return 0 === t.length
            ? He(this)
            : qe(
                this,
                function (t, e) {
                  return e.some(function (e) {
                    return 0 === t.indexOf(e);
                  });
                },
                t,
                le,
              );
        }),
        (t.prototype.anyOf = function () {
          var t = this,
            e = L.apply(z, arguments),
            i = this._cmp;
          try {
            e.sort(i);
          } catch (t) {
            return Oe(this, ue);
          }
          if (0 === e.length) return He(this);
          var s = new this.Collection(this, function () {
            return Ve(e[0], e[e.length - 1]);
          });
          s._ondirectionchange = function (s) {
            ((i = 'next' === s ? t._ascending : t._descending), e.sort(i));
          };
          var n = 0;
          return (
            s._addAlgorithm(function (t, s, r) {
              for (var a = t.key; i(a, e[n]) > 0; ) if (++n === e.length) return (s(r), !1);
              return (
                0 === i(a, e[n]) ||
                (s(function () {
                  t.continue(e[n]);
                }),
                !1)
              );
            }),
            s
          );
        }),
        (t.prototype.notEqual = function (t) {
          return this.inAnyRange(
            [
              [ce, t],
              [t, this.db._maxKey],
            ],
            { includeLowers: !1, includeUppers: !1 },
          );
        }),
        (t.prototype.noneOf = function () {
          var t = L.apply(z, arguments);
          if (0 === t.length) return new this.Collection(this);
          try {
            t.sort(this._ascending);
          } catch (t) {
            return Oe(this, ue);
          }
          var e = t.reduce(function (t, e) {
            return t ? t.concat([[t[t.length - 1][1], e]]) : [[ce, e]];
          }, null);
          return (
            e.push([t[t.length - 1], this.db._maxKey]),
            this.inAnyRange(e, { includeLowers: !1, includeUppers: !1 })
          );
        }),
        (t.prototype.inAnyRange = function (t, e) {
          var i = this,
            s = this._cmp,
            n = this._ascending,
            r = this._descending,
            a = this._min,
            o = this._max;
          if (0 === t.length) return He(this);
          if (
            !t.every(function (t) {
              return void 0 !== t[0] && void 0 !== t[1] && n(t[0], t[1]) <= 0;
            })
          )
            return Oe(
              this,
              'First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower',
              X.InvalidArgument,
            );
          var h = !e || !1 !== e.includeLowers,
            l = e && !0 === e.includeUppers;
          var c,
            u = n;
          function d(t, e) {
            return u(t[0], e[0]);
          }
          try {
            ((c = t.reduce(function (t, e) {
              for (var i = 0, n = t.length; i < n; ++i) {
                var r = t[i];
                if (s(e[0], r[1]) < 0 && s(e[1], r[0]) > 0) {
                  ((r[0] = a(r[0], e[0])), (r[1] = o(r[1], e[1])));
                  break;
                }
              }
              return (i === n && t.push(e), t);
            }, [])),
              c.sort(d));
          } catch (t) {
            return Oe(this, ue);
          }
          var f = 0,
            p = l
              ? function (t) {
                  return n(t, c[f][1]) > 0;
                }
              : function (t) {
                  return n(t, c[f][1]) >= 0;
                },
            m = h
              ? function (t) {
                  return r(t, c[f][0]) > 0;
                }
              : function (t) {
                  return r(t, c[f][0]) >= 0;
                };
          var g = p,
            y = new this.Collection(this, function () {
              return Ve(c[0][0], c[c.length - 1][1], !h, !l);
            });
          return (
            (y._ondirectionchange = function (t) {
              ('next' === t ? ((g = p), (u = n)) : ((g = m), (u = r)), c.sort(d));
            }),
            y._addAlgorithm(function (t, e, s) {
              for (var r = t.key; g(r); ) if (++f === c.length) return (e(s), !1);
              return (
                !!(function (t) {
                  return !p(t) && !m(t);
                })(r) ||
                (0 === i._cmp(r, c[f][1]) ||
                  0 === i._cmp(r, c[f][0]) ||
                  e(function () {
                    u === n ? t.continue(c[f][0]) : t.continue(c[f][1]);
                  }),
                !1)
              );
            }),
            y
          );
        }),
        (t.prototype.startsWithAnyOf = function () {
          var t = L.apply(z, arguments);
          return t.every(function (t) {
            return 'string' == typeof t;
          })
            ? 0 === t.length
              ? He(this)
              : this.inAnyRange(
                  t.map(function (t) {
                    return [t, t + le];
                  }),
                )
            : Oe(this, 'startsWithAnyOf() only works with strings');
        }),
        t
      );
    })();
    function Ge(t) {
      return qt(function (e) {
        return (We(e), t(e.target.error), !1);
      });
    }
    function We(t) {
      (t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault());
    }
    var Qe = 'storagemutated',
      Xe = 'x-storagemutated-1',
      Ye = Ee(null, Qe),
      Ze = (function () {
        function t() {}
        return (
          (t.prototype._lock = function () {
            return (
              v(!Et.global),
              ++this._reculock,
              1 !== this._reculock || Et.global || (Et.lockOwnerFor = this),
              this
            );
          }),
          (t.prototype._unlock = function () {
            if ((v(!Et.global), 0 == --this._reculock))
              for (Et.global || (Et.lockOwnerFor = null); this._blockedFuncs.length > 0 && !this._locked(); ) {
                var t = this._blockedFuncs.shift();
                try {
                  se(t[1], t[0]);
                } catch (t) {}
              }
            return this;
          }),
          (t.prototype._locked = function () {
            return this._reculock && Et.lockOwnerFor !== this;
          }),
          (t.prototype.create = function (t) {
            var e = this;
            if (!this.mode) return this;
            var i = this.db.idbdb,
              s = this.db._state.dbOpenError;
            if ((v(!this.idbtrans), !t && !i))
              switch (s && s.name) {
                case 'DatabaseClosedError':
                  throw new X.DatabaseClosed(s);
                case 'MissingAPIError':
                  throw new X.MissingAPI(s.message, s);
                default:
                  throw new X.OpenFailed(s);
              }
            if (!this.active) throw new X.TransactionInactive();
            return (
              v(null === this._completion._state),
              ((t = this.idbtrans =
                t ||
                (this.db.core
                  ? this.db.core.transaction(this.storeNames, this.mode, {
                      durability: this.chromeTransactionDurability,
                    })
                  : i.transaction(this.storeNames, this.mode, {
                      durability: this.chromeTransactionDurability,
                    }))).onerror = qt(function (i) {
                (We(i), e._reject(t.error));
              })),
              (t.onabort = qt(function (i) {
                (We(i), e.active && e._reject(new X.Abort(t.error)), (e.active = !1), e.on('abort').fire(i));
              })),
              (t.oncomplete = qt(function () {
                ((e.active = !1), e._resolve(), 'mutatedParts' in t && Ye.storagemutated.fire(t.mutatedParts));
              })),
              this
            );
          }),
          (t.prototype._promise = function (t, e, i) {
            var s = this;
            if ('readwrite' === t && 'readwrite' !== this.mode) return ae(new X.ReadOnly('Transaction is readonly'));
            if (!this.active) return ae(new X.TransactionInactive());
            if (this._locked())
              return new Pt(function (n, r) {
                s._blockedFuncs.push([
                  function () {
                    s._promise(t, e, i).then(n, r);
                  },
                  Et,
                ]);
              });
            if (i)
              return Xt(function () {
                var t = new Pt(function (t, i) {
                  s._lock();
                  var n = e(t, i, s);
                  n && n.then && n.then(t, i);
                });
                return (
                  t.finally(function () {
                    return s._unlock();
                  }),
                  (t._lib = !0),
                  t
                );
              });
            var n = new Pt(function (t, i) {
              var n = e(t, i, s);
              n && n.then && n.then(t, i);
            });
            return ((n._lib = !0), n);
          }),
          (t.prototype._root = function () {
            return this.parent ? this.parent._root() : this;
          }),
          (t.prototype.waitFor = function (t) {
            var e = this._root(),
              i = Pt.resolve(t);
            if (e._waitingFor)
              e._waitingFor = e._waitingFor.then(function () {
                return i;
              });
            else {
              ((e._waitingFor = i), (e._waitingQueue = []));
              var s = e.idbtrans.objectStore(e.storeNames[0]);
              !(function t() {
                for (++e._spinCount; e._waitingQueue.length; ) e._waitingQueue.shift()();
                e._waitingFor && (s.get(-1 / 0).onsuccess = t);
              })();
            }
            var n = e._waitingFor;
            return new Pt(function (t, s) {
              i.then(
                function (i) {
                  return e._waitingQueue.push(qt(t.bind(null, i)));
                },
                function (t) {
                  return e._waitingQueue.push(qt(s.bind(null, t)));
                },
              ).finally(function () {
                e._waitingFor === n && (e._waitingFor = null);
              });
            });
          }),
          (t.prototype.abort = function () {
            this.active && ((this.active = !1), this.idbtrans && this.idbtrans.abort(), this._reject(new X.Abort()));
          }),
          (t.prototype.table = function (t) {
            var e = this._memoizedTables || (this._memoizedTables = {});
            if (l(e, t)) return e[t];
            var i = this.schema[t];
            if (!i) throw new X.NotFound('Table ' + t + ' not part of transaction');
            var s = new this.db.Table(t, i, this);
            return ((s.core = this.db.core.table(t)), (e[t] = s), s);
          }),
          t
        );
      })();
    function Je(t, e, i, s, n, r, a) {
      return {
        name: t,
        keyPath: e,
        unique: i,
        multi: s,
        auto: n,
        compound: r,
        src: (i && !a ? '&' : '') + (s ? '*' : '') + (n ? '++' : '') + $e(e),
      };
    }
    function $e(t) {
      return 'string' == typeof t ? t : t ? '[' + [].join.call(t, '+') + ']' : '';
    }
    function ti(t, e, i) {
      return {
        name: t,
        primKey: e,
        indexes: i,
        mappedClass: null,
        idxByName:
          ((s = i),
          (n = function (t) {
            return [t.name, t];
          }),
          s.reduce(function (t, e, i) {
            var s = n(e, i);
            return (s && (t[s[0]] = s[1]), t);
          }, {})),
      };
      var s, n;
    }
    var ei = function (t) {
      try {
        return (
          t.only([[]]),
          (ei = function () {
            return [[]];
          }),
          [[]]
        );
      } catch (t) {
        return (
          (ei = function () {
            return le;
          }),
          le
        );
      }
    };
    function ii(t) {
      return null == t
        ? function () {}
        : 'string' == typeof t
          ? (function (t) {
              var e = t.split('.');
              return 1 === e.length
                ? function (e) {
                    return e[t];
                  }
                : function (e) {
                    return w(e, t);
                  };
            })(t)
          : function (e) {
              return w(e, t);
            };
    }
    function si(t) {
      return [].slice.call(t);
    }
    var ni = 0;
    function ri(t) {
      return null == t ? ':id' : 'string' == typeof t ? t : '['.concat(t.join('+'), ']');
    }
    function ai(t, e, i) {
      function s(t) {
        if (3 === t.type) return null;
        if (4 === t.type) throw new Error('Cannot convert never type to IDBKeyRange');
        var i = t.lower,
          s = t.upper,
          n = t.lowerOpen,
          r = t.upperOpen;
        return void 0 === i
          ? void 0 === s
            ? null
            : e.upperBound(s, !!r)
          : void 0 === s
            ? e.lowerBound(i, !!n)
            : e.bound(i, s, !!n, !!r);
      }
      var n = (function (t, e) {
          var i = si(t.objectStoreNames);
          return {
            schema: {
              name: t.name,
              tables: i
                .map(function (t) {
                  return e.objectStore(t);
                })
                .map(function (t) {
                  var e = t.keyPath,
                    i = t.autoIncrement,
                    s = r(e),
                    n = null == e,
                    a = {},
                    o = {
                      name: t.name,
                      primaryKey: {
                        name: null,
                        isPrimaryKey: !0,
                        outbound: n,
                        compound: s,
                        keyPath: e,
                        autoIncrement: i,
                        unique: !0,
                        extractKey: ii(e),
                      },
                      indexes: si(t.indexNames)
                        .map(function (e) {
                          return t.index(e);
                        })
                        .map(function (t) {
                          var e = t.name,
                            i = t.unique,
                            s = t.multiEntry,
                            n = t.keyPath,
                            o = { name: e, compound: r(n), keyPath: n, unique: i, multiEntry: s, extractKey: ii(n) };
                          return ((a[ri(n)] = o), o);
                        }),
                      getIndexByKeyPath: function (t) {
                        return a[ri(t)];
                      },
                    };
                  return ((a[':id'] = o.primaryKey), null != e && (a[ri(e)] = o.primaryKey), o);
                }),
            },
            hasGetAll:
              i.length > 0 &&
              'getAll' in e.objectStore(i[0]) &&
              !(
                'undefined' != typeof navigator &&
                /Safari/.test(navigator.userAgent) &&
                !/(Chrome\/|Edge\/)/.test(navigator.userAgent) &&
                [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604
              ),
          };
        })(t, i),
        a = n.schema,
        o = n.hasGetAll,
        h = a.tables.map(function (t) {
          return (function (t) {
            var e = t.name;
            return {
              name: e,
              schema: t,
              mutate: function (t) {
                var i = t.trans,
                  n = t.type,
                  r = t.keys,
                  a = t.values,
                  o = t.range;
                return new Promise(function (t, h) {
                  t = qt(t);
                  var l = i.objectStore(e),
                    c = null == l.keyPath,
                    u = 'put' === n || 'add' === n;
                  if (!u && 'delete' !== n && 'deleteRange' !== n) throw new Error('Invalid operation type: ' + n);
                  var d,
                    f = (r || a || { length: 1 }).length;
                  if (r && a && r.length !== a.length)
                    throw new Error('Given keys array must have same length as given values array.');
                  if (0 === f) return t({ numFailures: 0, failures: {}, results: [], lastResult: void 0 });
                  var p = [],
                    m = [],
                    g = 0,
                    y = function (t) {
                      (++g, We(t));
                    };
                  if ('deleteRange' === n) {
                    if (4 === o.type) return t({ numFailures: g, failures: m, results: [], lastResult: void 0 });
                    3 === o.type ? p.push((d = l.clear())) : p.push((d = l.delete(s(o))));
                  } else {
                    var x = u ? (c ? [a, r] : [a, null]) : [r, null],
                      v = x[0],
                      b = x[1];
                    if (u)
                      for (var w = 0; w < f; ++w)
                        (p.push((d = b && void 0 !== b[w] ? l[n](v[w], b[w]) : l[n](v[w]))), (d.onerror = y));
                    else for (w = 0; w < f; ++w) (p.push((d = l[n](v[w]))), (d.onerror = y));
                  }
                  var S = function (e) {
                    var i = e.target.result;
                    (p.forEach(function (t, e) {
                      return null != t.error && (m[e] = t.error);
                    }),
                      t({
                        numFailures: g,
                        failures: m,
                        results:
                          'delete' === n
                            ? r
                            : p.map(function (t) {
                                return t.result;
                              }),
                        lastResult: i,
                      }));
                  };
                  ((d.onerror = function (t) {
                    (y(t), S(t));
                  }),
                    (d.onsuccess = S));
                });
              },
              getMany: function (t) {
                var i = t.trans,
                  s = t.keys;
                return new Promise(function (t, n) {
                  t = qt(t);
                  for (
                    var r,
                      a = i.objectStore(e),
                      o = s.length,
                      h = new Array(o),
                      l = 0,
                      c = 0,
                      u = function (e) {
                        var i = e.target;
                        ((h[i._pos] = i.result), ++c === l && t(h));
                      },
                      d = Ge(n),
                      f = 0;
                    f < o;
                    ++f
                  )
                    null != s[f] && (((r = a.get(s[f]))._pos = f), (r.onsuccess = u), (r.onerror = d), ++l);
                  0 === l && t(h);
                });
              },
              get: function (t) {
                var i = t.trans,
                  s = t.key;
                return new Promise(function (t, n) {
                  t = qt(t);
                  var r = i.objectStore(e).get(s);
                  ((r.onsuccess = function (e) {
                    return t(e.target.result);
                  }),
                    (r.onerror = Ge(n)));
                });
              },
              query: (function (t) {
                return function (i) {
                  return new Promise(function (n, r) {
                    n = qt(n);
                    var a = i.trans,
                      o = i.values,
                      h = i.limit,
                      l = i.query,
                      c = h === 1 / 0 ? void 0 : h,
                      u = l.index,
                      d = l.range,
                      f = a.objectStore(e),
                      p = u.isPrimaryKey ? f : f.index(u.name),
                      m = s(d);
                    if (0 === h) return n({ result: [] });
                    if (t) {
                      var g = o ? p.getAll(m, c) : p.getAllKeys(m, c);
                      ((g.onsuccess = function (t) {
                        return n({ result: t.target.result });
                      }),
                        (g.onerror = Ge(r)));
                    } else {
                      var y = 0,
                        x = o || !('openKeyCursor' in p) ? p.openCursor(m) : p.openKeyCursor(m),
                        v = [];
                      ((x.onsuccess = function (t) {
                        var e = x.result;
                        return e
                          ? (v.push(o ? e.value : e.primaryKey), ++y === h ? n({ result: v }) : void e.continue())
                          : n({ result: v });
                      }),
                        (x.onerror = Ge(r)));
                    }
                  });
                };
              })(o),
              openCursor: function (t) {
                var i = t.trans,
                  n = t.values,
                  r = t.query,
                  a = t.reverse,
                  o = t.unique;
                return new Promise(function (t, h) {
                  t = qt(t);
                  var l = r.index,
                    c = r.range,
                    u = i.objectStore(e),
                    d = l.isPrimaryKey ? u : u.index(l.name),
                    f = a ? (o ? 'prevunique' : 'prev') : o ? 'nextunique' : 'next',
                    p = n || !('openKeyCursor' in d) ? d.openCursor(s(c), f) : d.openKeyCursor(s(c), f);
                  ((p.onerror = Ge(h)),
                    (p.onsuccess = qt(function (e) {
                      var s = p.result;
                      if (s) {
                        ((s.___id = ++ni), (s.done = !1));
                        var n = s.continue.bind(s),
                          r = s.continuePrimaryKey;
                        r && (r = r.bind(s));
                        var a = s.advance.bind(s),
                          o = function () {
                            throw new Error('Cursor not stopped');
                          };
                        ((s.trans = i),
                          (s.stop =
                            s.continue =
                            s.continuePrimaryKey =
                            s.advance =
                              function () {
                                throw new Error('Cursor not started');
                              }),
                          (s.fail = qt(h)),
                          (s.next = function () {
                            var t = this,
                              e = 1;
                            return this.start(function () {
                              return e-- ? t.continue() : t.stop();
                            }).then(function () {
                              return t;
                            });
                          }),
                          (s.start = function (t) {
                            var e = new Promise(function (t, e) {
                                ((t = qt(t)),
                                  (p.onerror = Ge(e)),
                                  (s.fail = e),
                                  (s.stop = function (e) {
                                    ((s.stop = s.continue = s.continuePrimaryKey = s.advance = o), t(e));
                                  }));
                              }),
                              i = function () {
                                if (p.result)
                                  try {
                                    t();
                                  } catch (t) {
                                    s.fail(t);
                                  }
                                else
                                  ((s.done = !0),
                                    (s.start = function () {
                                      throw new Error('Cursor behind last entry');
                                    }),
                                    s.stop());
                              };
                            return (
                              (p.onsuccess = qt(function (t) {
                                ((p.onsuccess = i), i());
                              })),
                              (s.continue = n),
                              (s.continuePrimaryKey = r),
                              (s.advance = a),
                              i(),
                              e
                            );
                          }),
                          t(s));
                      } else t(null);
                    }, h)));
                });
              },
              count: function (t) {
                var i = t.query,
                  n = t.trans,
                  r = i.index,
                  a = i.range;
                return new Promise(function (t, i) {
                  var o = n.objectStore(e),
                    h = r.isPrimaryKey ? o : o.index(r.name),
                    l = s(a),
                    c = l ? h.count(l) : h.count();
                  ((c.onsuccess = qt(function (e) {
                    return t(e.target.result);
                  })),
                    (c.onerror = Ge(i)));
                });
              },
            };
          })(t);
        }),
        l = {};
      return (
        h.forEach(function (t) {
          return (l[t.name] = t);
        }),
        {
          stack: 'dbcore',
          transaction: t.transaction.bind(t),
          table: function (t) {
            if (!l[t]) throw new Error("Table '".concat(t, "' not found"));
            return l[t];
          },
          MIN_KEY: -1 / 0,
          MAX_KEY: ei(e),
          schema: a,
        }
      );
    }
    function oi(t, i, s, n) {
      var r = s.IDBKeyRange;
      s.indexedDB;
      var a = (function (t, i) {
        return i.reduce(function (t, i) {
          var s = i.create;
          return e(e({}, t), s(t));
        }, t);
      })(ai(i, r, n), t.dbcore);
      return { dbcore: a };
    }
    function hi(t, e) {
      var i = e.db,
        s = oi(t._middlewares, i, t._deps, e);
      ((t.core = s.dbcore),
        t.tables.forEach(function (e) {
          var i = e.name;
          t.core.schema.tables.some(function (t) {
            return t.name === i;
          }) && ((e.core = t.core.table(i)), t[i] instanceof t.Table && (t[i].core = e.core));
        }));
    }
    function li(t, e, i, s) {
      i.forEach(function (i) {
        var n = s[i];
        e.forEach(function (e) {
          var s = m(e, i);
          (!s || ('value' in s && void 0 === s.value)) &&
            (e === t.Transaction.prototype || e instanceof t.Transaction
              ? d(e, i, {
                  get: function () {
                    return this.table(i);
                  },
                  set: function (t) {
                    u(this, i, { value: t, writable: !0, configurable: !0, enumerable: !0 });
                  },
                })
              : (e[i] = new t.Table(i, n)));
        });
      });
    }
    function ci(t, e) {
      e.forEach(function (e) {
        for (var i in e) e[i] instanceof t.Table && delete e[i];
      });
    }
    function ui(t, e) {
      return t._cfg.version - e._cfg.version;
    }
    function di(t, e, i, s) {
      var r = t._dbSchema;
      i.objectStoreNames.contains('$meta') &&
        !r.$meta &&
        ((r.$meta = ti('$meta', vi('')[0], [])), t._storeNames.push('$meta'));
      var a = t._createTransaction('readwrite', t._storeNames, r);
      (a.create(i), a._completion.catch(s));
      var o = a._reject.bind(a),
        h = Et.transless || Et;
      Xt(function () {
        if (((Et.trans = a), (Et.transless = h), 0 !== e))
          return (
            hi(t, i),
            (function (t, e, i) {
              return e.storeNames.includes('$meta')
                ? e
                    .table('$meta')
                    .get('version')
                    .then(function (t) {
                      return null != t ? t : i;
                    })
                : Pt.resolve(i);
            })(0, a, e)
              .then(function (e) {
                return (function (t, e, i, s) {
                  var r = [],
                    a = t._versions,
                    o = (t._dbSchema = yi(t, t.idbdb, s)),
                    h = a.filter(function (t) {
                      return t._cfg.version >= e;
                    });
                  if (0 === h.length) return Pt.resolve();
                  function l() {
                    return r.length ? Pt.resolve(r.shift()(i.idbtrans)).then(l) : Pt.resolve();
                  }
                  return (
                    h.forEach(function (a) {
                      (r.push(function () {
                        var r = o,
                          h = a._cfg.dbschema;
                        (xi(t, r, s), xi(t, h, s), (o = t._dbSchema = h));
                        var l = fi(r, h);
                        (l.add.forEach(function (t) {
                          pi(s, t[0], t[1].primKey, t[1].indexes);
                        }),
                          l.change.forEach(function (t) {
                            if (t.recreate) throw new X.Upgrade('Not yet support for changing primary key');
                            var e = s.objectStore(t.name);
                            (t.add.forEach(function (t) {
                              return gi(e, t);
                            }),
                              t.change.forEach(function (t) {
                                (e.deleteIndex(t.name), gi(e, t));
                              }),
                              t.del.forEach(function (t) {
                                return e.deleteIndex(t);
                              }));
                          }));
                        var c = a._cfg.contentUpgrade;
                        if (c && a._cfg.version > e) {
                          (hi(t, s), (i._memoizedTables = {}));
                          var u = M(h);
                          (l.del.forEach(function (t) {
                            u[t] = r[t];
                          }),
                            ci(t, [t.Transaction.prototype]),
                            li(t, [t.Transaction.prototype], n(u), u),
                            (i.schema = u));
                          var d,
                            f = O(c);
                          f && Yt();
                          var p = Pt.follow(function () {
                            if ((d = c(i)) && f) {
                              var t = Zt.bind(null, null);
                              d.then(t, t);
                            }
                          });
                          return d && 'function' == typeof d.then
                            ? Pt.resolve(d)
                            : p.then(function () {
                                return d;
                              });
                        }
                      }),
                        r.push(function (e) {
                          (!(function (t, e) {
                            [].slice.call(e.db.objectStoreNames).forEach(function (i) {
                              return null == t[i] && e.db.deleteObjectStore(i);
                            });
                          })(a._cfg.dbschema, e),
                            ci(t, [t.Transaction.prototype]),
                            li(t, [t.Transaction.prototype], t._storeNames, t._dbSchema),
                            (i.schema = t._dbSchema));
                        }),
                        r.push(function (e) {
                          t.idbdb.objectStoreNames.contains('$meta') &&
                            (Math.ceil(t.idbdb.version / 10) === a._cfg.version
                              ? (t.idbdb.deleteObjectStore('$meta'),
                                delete t._dbSchema.$meta,
                                (t._storeNames = t._storeNames.filter(function (t) {
                                  return '$meta' !== t;
                                })))
                              : e.objectStore('$meta').put(a._cfg.version, 'version'));
                        }));
                    }),
                    l().then(function () {
                      mi(o, s);
                    })
                  );
                })(t, e, a, i);
              })
              .catch(o)
          );
        (n(r).forEach(function (t) {
          pi(i, t, r[t].primKey, r[t].indexes);
        }),
          hi(t, i),
          Pt.follow(function () {
            return t.on.populate.fire(a);
          }).catch(o));
      });
    }
    function fi(t, e) {
      var i,
        s = { del: [], add: [], change: [] };
      for (i in t) e[i] || s.del.push(i);
      for (i in e) {
        var n = t[i],
          r = e[i];
        if (n) {
          var a = { name: i, def: r, recreate: !1, del: [], add: [], change: [] };
          if ('' + (n.primKey.keyPath || '') != '' + (r.primKey.keyPath || '') || n.primKey.auto !== r.primKey.auto)
            ((a.recreate = !0), s.change.push(a));
          else {
            var o = n.idxByName,
              h = r.idxByName,
              l = void 0;
            for (l in o) h[l] || a.del.push(l);
            for (l in h) {
              var c = o[l],
                u = h[l];
              c ? c.src !== u.src && a.change.push(u) : a.add.push(u);
            }
            (a.del.length > 0 || a.add.length > 0 || a.change.length > 0) && s.change.push(a);
          }
        } else s.add.push([i, r]);
      }
      return s;
    }
    function pi(t, e, i, s) {
      var n = t.db.createObjectStore(
        e,
        i.keyPath ? { keyPath: i.keyPath, autoIncrement: i.auto } : { autoIncrement: i.auto },
      );
      return (
        s.forEach(function (t) {
          return gi(n, t);
        }),
        n
      );
    }
    function mi(t, e) {
      n(t).forEach(function (i) {
        e.db.objectStoreNames.contains(i) ||
          (ot && console.debug('Dexie: Creating missing table', i), pi(e, i, t[i].primKey, t[i].indexes));
      });
    }
    function gi(t, e) {
      t.createIndex(e.name, e.keyPath, { unique: e.unique, multiEntry: e.multi });
    }
    function yi(t, e, i) {
      var s = {};
      return (
        y(e.objectStoreNames, 0).forEach(function (t) {
          for (
            var e = i.objectStore(t),
              n = e.keyPath,
              r = Je($e(n), n || '', !0, !1, !!e.autoIncrement, n && 'string' != typeof n, !0),
              a = [],
              o = 0;
            o < e.indexNames.length;
            ++o
          ) {
            var h = e.index(e.indexNames[o]);
            n = h.keyPath;
            var l = Je(h.name, n, !!h.unique, !!h.multiEntry, !1, n && 'string' != typeof n, !1);
            a.push(l);
          }
          s[t] = ti(t, r, a);
        }),
        s
      );
    }
    function xi(t, e, i) {
      for (var n = i.db.objectStoreNames, r = 0; r < n.length; ++r) {
        var a = n[r],
          o = i.objectStore(a);
        t._hasGetAll = 'getAll' in o;
        for (var h = 0; h < o.indexNames.length; ++h) {
          var l = o.indexNames[h],
            c = o.index(l).keyPath,
            u = 'string' == typeof c ? c : '[' + y(c).join('+') + ']';
          if (e[a]) {
            var d = e[a].idxByName[u];
            d && ((d.name = l), delete e[a].idxByName[u], (e[a].idxByName[l] = d));
          }
        }
      }
      'undefined' != typeof navigator &&
        /Safari/.test(navigator.userAgent) &&
        !/(Chrome\/|Edge\/)/.test(navigator.userAgent) &&
        s.WorkerGlobalScope &&
        s instanceof s.WorkerGlobalScope &&
        [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 &&
        (t._hasGetAll = !1);
    }
    function vi(t) {
      return t.split(',').map(function (t, e) {
        var i = (t = t.trim()).replace(/([&*]|\+\+)/g, ''),
          s = /^\[/.test(i) ? i.match(/^\[(.*)\]$/)[1].split('+') : i;
        return Je(i, s || null, /\&/.test(t), /\*/.test(t), /\+\+/.test(t), r(s), 0 === e);
      });
    }
    var bi,
      wi = (function () {
        function t() {}
        return (
          (t.prototype._parseStoresSpec = function (t, e) {
            n(t).forEach(function (i) {
              if (null !== t[i]) {
                var s = vi(t[i]),
                  n = s.shift();
                if (((n.unique = !0), n.multi)) throw new X.Schema('Primary key cannot be multi-valued');
                (s.forEach(function (t) {
                  if (t.auto) throw new X.Schema('Only primary key can be marked as autoIncrement (++)');
                  if (!t.keyPath) throw new X.Schema('Index must have a name and cannot be an empty string');
                }),
                  (e[i] = ti(i, n, s)));
              }
            });
          }),
          (t.prototype.stores = function (t) {
            var e = this.db;
            this._cfg.storesSource = this._cfg.storesSource ? a(this._cfg.storesSource, t) : t;
            var i = e._versions,
              s = {},
              r = {};
            return (
              i.forEach(function (t) {
                (a(s, t._cfg.storesSource), (r = t._cfg.dbschema = {}), t._parseStoresSpec(s, r));
              }),
              (e._dbSchema = r),
              ci(e, [e._allTables, e, e.Transaction.prototype]),
              li(e, [e._allTables, e, e.Transaction.prototype, this._cfg.tables], n(r), r),
              (e._storeNames = n(r)),
              this
            );
          }),
          (t.prototype.upgrade = function (t) {
            return ((this._cfg.contentUpgrade = at(this._cfg.contentUpgrade || J, t)), this);
          }),
          t
        );
      })();
    function Si(t, e) {
      var i = t._dbNamesDB;
      return (
        i ||
          (i = t._dbNamesDB = new us(pe, { addons: [], indexedDB: t, IDBKeyRange: e }))
            .version(1)
            .stores({ dbnames: 'name' }),
        i.table('dbnames')
      );
    }
    function Mi(t) {
      return t && 'function' == typeof t.databases;
    }
    function Ci(t) {
      return Xt(function () {
        return ((Et.letThrough = !0), t());
      });
    }
    function Ei() {
      var t;
      return !navigator.userAgentData &&
        /Safari\//.test(navigator.userAgent) &&
        !/Chrom(e|ium)\//.test(navigator.userAgent) &&
        indexedDB.databases
        ? new Promise(function (e) {
            var i = function () {
              return indexedDB.databases().finally(e);
            };
            ((t = setInterval(i, 100)), i());
          }).finally(function () {
            return clearInterval(t);
          })
        : Promise.resolve();
    }
    function Di(t) {
      return !('from' in t);
    }
    var Ai = function (t, e) {
      if (!this) {
        var i = new Ai();
        return (t && 'd' in t && a(i, t), i);
      }
      a(this, arguments.length ? { d: 1, from: t, to: arguments.length > 1 ? e : t } : { d: 0 });
    };
    function Fi(t, e, i) {
      var s = we(e, i);
      if (!isNaN(s)) {
        if (s > 0) throw RangeError();
        if (Di(t)) return a(t, { from: e, to: i, d: 1 });
        var n = t.l,
          r = t.r;
        if (we(i, t.from) < 0) return (n ? Fi(n, e, i) : (t.l = { from: e, to: i, d: 1, l: null, r: null }), _i(t));
        if (we(e, t.to) > 0) return (r ? Fi(r, e, i) : (t.r = { from: e, to: i, d: 1, l: null, r: null }), _i(t));
        (we(e, t.from) < 0 && ((t.from = e), (t.l = null), (t.d = r ? r.d + 1 : 1)),
          we(i, t.to) > 0 && ((t.to = i), (t.r = null), (t.d = t.l ? t.l.d + 1 : 1)));
        var o = !t.r;
        (n && !t.l && Pi(t, n), r && o && Pi(t, r));
      }
    }
    function Pi(t, e) {
      Di(e) ||
        (function t(e, i) {
          var s = i.from,
            n = i.to,
            r = i.l,
            a = i.r;
          (Fi(e, s, n), r && t(e, r), a && t(e, a));
        })(t, e);
    }
    function Ti(t, e) {
      var i = Ii(e),
        s = i.next();
      if (s.done) return !1;
      for (var n = s.value, r = Ii(t), a = r.next(n.from), o = a.value; !s.done && !a.done; ) {
        if (we(o.from, n.to) <= 0 && we(o.to, n.from) >= 0) return !0;
        we(n.from, o.from) < 0 ? (n = (s = i.next(o.from)).value) : (o = (a = r.next(n.from)).value);
      }
      return !1;
    }
    function Ii(t) {
      var e = Di(t) ? null : { s: 0, n: t };
      return {
        next: function (t) {
          for (var i = arguments.length > 0; e; )
            switch (e.s) {
              case 0:
                if (((e.s = 1), i)) for (; e.n.l && we(t, e.n.from) < 0; ) e = { up: e, n: e.n.l, s: 1 };
                else for (; e.n.l; ) e = { up: e, n: e.n.l, s: 1 };
              case 1:
                if (((e.s = 2), !i || we(t, e.n.to) <= 0)) return { value: e.n, done: !1 };
              case 2:
                if (e.n.r) {
                  ((e.s = 3), (e = { up: e, n: e.n.r, s: 0 }));
                  continue;
                }
              case 3:
                e = e.up;
            }
          return { done: !0 };
        },
      };
    }
    function _i(t) {
      var i,
        s,
        n =
          ((null === (i = t.r) || void 0 === i ? void 0 : i.d) || 0) -
          ((null === (s = t.l) || void 0 === s ? void 0 : s.d) || 0),
        r = n > 1 ? 'r' : n < -1 ? 'l' : '';
      if (r) {
        var a = 'r' === r ? 'l' : 'r',
          o = e({}, t),
          h = t[r];
        ((t.from = h.from), (t.to = h.to), (t[r] = h[r]), (o[r] = h[a]), (t[a] = o), (o.d = Ri(o)));
      }
      t.d = Ri(t);
    }
    function Ri(t) {
      var e = t.r,
        i = t.l;
      return (e ? (i ? Math.max(e.d, i.d) : e.d) : i ? i.d : 0) + 1;
    }
    function Ni(t, e) {
      return (
        n(e).forEach(function (i) {
          t[i] ? Pi(t[i], e[i]) : (t[i] = F(e[i]));
        }),
        t
      );
    }
    function Bi(t, e) {
      return (
        t.all ||
        e.all ||
        Object.keys(t).some(function (i) {
          return e[i] && Ti(e[i], t[i]);
        })
      );
    }
    c(
      Ai.prototype,
      ((bi = {
        add: function (t) {
          return (Pi(this, t), this);
        },
        addKey: function (t) {
          return (Fi(this, t, t), this);
        },
        addKeys: function (t) {
          var e = this;
          return (
            t.forEach(function (t) {
              return Fi(e, t, t);
            }),
            this
          );
        },
        hasKey: function (t) {
          var e = Ii(this).next(t).value;
          return e && we(e.from, t) <= 0 && we(e.to, t) >= 0;
        },
      }),
      (bi[N] = function () {
        return Ii(this);
      }),
      bi),
    );
    var ki = {},
      zi = {},
      Li = !1;
    function Oi(t, e) {
      (Ni(zi, t),
        Li ||
          ((Li = !0),
          setTimeout(function () {
            Li = !1;
            var t = zi;
            ((zi = {}), Hi(t, !1));
          }, 0)));
    }
    function Hi(t, e) {
      void 0 === e && (e = !1);
      var i = new Set();
      if (t.all)
        for (var s = 0, n = Object.values(ki); s < n.length; s++) {
          ji((o = n[s]), t, i, e);
        }
      else
        for (var r in t) {
          var a = /^idb\:\/\/(.*)\/(.*)\//.exec(r);
          if (a) {
            var o,
              h = a[1],
              l = a[2];
            (o = ki['idb://'.concat(h, '/').concat(l)]) && ji(o, t, i, e);
          }
        }
      i.forEach(function (t) {
        return t();
      });
    }
    function ji(t, e, i, s) {
      for (var n = [], r = 0, a = Object.entries(t.queries.query); r < a.length; r++) {
        for (var o = a[r], h = o[0], l = [], c = 0, u = o[1]; c < u.length; c++) {
          var d = u[c];
          Bi(e, d.obsSet)
            ? d.subscribers.forEach(function (t) {
                return i.add(t);
              })
            : s && l.push(d);
        }
        s && n.push([h, l]);
      }
      if (s)
        for (var f = 0, p = n; f < p.length; f++) {
          var m = p[f];
          ((h = m[0]), (l = m[1]));
          t.queries.query[h] = l;
        }
    }
    function qi(t) {
      var e = t._state,
        i = t._deps.indexedDB;
      if (e.isBeingOpened || t.idbdb)
        return e.dbReadyPromise.then(function () {
          return e.dbOpenError ? ae(e.dbOpenError) : t;
        });
      ((e.isBeingOpened = !0), (e.dbOpenError = null), (e.openComplete = !1));
      var s = e.openCanceller,
        r = Math.round(10 * t.verno),
        a = !1;
      function o() {
        if (e.openCanceller !== s) throw new X.DatabaseClosed('db.open() was cancelled');
      }
      var h = e.dbReadyResolve,
        l = null,
        c = !1,
        u = function () {
          return new Pt(function (s, h) {
            if ((o(), !i)) throw new X.MissingAPI();
            var d = t.name,
              f = e.autoSchema || !r ? i.open(d) : i.open(d, r);
            if (!f) throw new X.MissingAPI();
            ((f.onerror = Ge(h)),
              (f.onblocked = qt(t._fireOnBlocked)),
              (f.onupgradeneeded = qt(function (s) {
                if (((l = f.transaction), e.autoSchema && !t._options.allowEmptyDB)) {
                  ((f.onerror = We), l.abort(), f.result.close());
                  var n = i.deleteDatabase(d);
                  n.onsuccess = n.onerror = qt(function () {
                    h(new X.NoSuchDatabase('Database '.concat(d, ' doesnt exist')));
                  });
                } else {
                  l.onerror = Ge(h);
                  var r = s.oldVersion > Math.pow(2, 62) ? 0 : s.oldVersion;
                  ((c = r < 1),
                    (t.idbdb = f.result),
                    a &&
                      (function (t, e) {
                        (mi(t._dbSchema, e),
                          e.db.version % 10 != 0 ||
                            e.objectStoreNames.contains('$meta') ||
                            e.db.createObjectStore('$meta').add(Math.ceil(e.db.version / 10 - 1), 'version'));
                        var i = yi(0, t.idbdb, e);
                        xi(t, t._dbSchema, e);
                        for (
                          var s = function (t) {
                              if (t.change.length || t.recreate)
                                return (
                                  console.warn(
                                    'Unable to patch indexes of table '.concat(
                                      t.name,
                                      ' because it has changes on the type of index or primary key.',
                                    ),
                                  ),
                                  { value: void 0 }
                                );
                              var i = e.objectStore(t.name);
                              t.add.forEach(function (e) {
                                (ot &&
                                  console.debug(
                                    'Dexie upgrade patch: Creating missing index '.concat(t.name, '.').concat(e.src),
                                  ),
                                  gi(i, e));
                              });
                            },
                            n = 0,
                            r = fi(i, t._dbSchema).change;
                          n < r.length;
                          n++
                        ) {
                          var a = s(r[n]);
                          if ('object' == typeof a) return a.value;
                        }
                      })(t, l),
                    di(t, r / 10, l, h));
                }
              }, h)),
              (f.onsuccess = qt(function () {
                l = null;
                var i,
                  o = (t.idbdb = f.result),
                  h = y(o.objectStoreNames);
                if (h.length > 0)
                  try {
                    var p = o.transaction(1 === (i = h).length ? i[0] : i, 'readonly');
                    if (e.autoSchema)
                      !(function (t, e, i) {
                        t.verno = e.version / 10;
                        var s = (t._dbSchema = yi(0, e, i));
                        ((t._storeNames = y(e.objectStoreNames, 0)), li(t, [t._allTables], n(s), s));
                      })(t, o, p);
                    else if (
                      (xi(t, t._dbSchema, p),
                      !(function (t, e) {
                        var i = fi(yi(0, t.idbdb, e), t._dbSchema);
                        return !(
                          i.add.length ||
                          i.change.some(function (t) {
                            return t.add.length || t.change.length;
                          })
                        );
                      })(t, p) && !a)
                    )
                      return (
                        console.warn(
                          'Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.',
                        ),
                        o.close(),
                        (r = o.version + 1),
                        (a = !0),
                        s(u())
                      );
                    hi(t, p);
                  } catch (t) {}
                (fe.push(t),
                  (o.onversionchange = qt(function (i) {
                    ((e.vcFired = !0), t.on('versionchange').fire(i));
                  })),
                  (o.onclose = qt(function (e) {
                    t.on('close').fire(e);
                  })),
                  c &&
                    (function (t, e) {
                      var i = t.indexedDB,
                        s = t.IDBKeyRange;
                      !Mi(i) && e !== pe && Si(i, s).put({ name: e }).catch(J);
                    })(t._deps, d),
                  s());
              }, h)));
          }).catch(function (t) {
            switch (null == t ? void 0 : t.name) {
              case 'UnknownError':
                if (e.PR1398_maxLoop > 0)
                  return (e.PR1398_maxLoop--, console.warn('Dexie: Workaround for Chrome UnknownError on open()'), u());
                break;
              case 'VersionError':
                if (r > 0) return ((r = 0), u());
            }
            return Pt.reject(t);
          });
        };
      return Pt.race([s, ('undefined' == typeof navigator ? Pt.resolve() : Ei()).then(u)])
        .then(function () {
          return (
            o(),
            (e.onReadyBeingFired = []),
            Pt.resolve(
              Ci(function () {
                return t.on.ready.fire(t.vip);
              }),
            ).then(function i() {
              if (e.onReadyBeingFired.length > 0) {
                var s = e.onReadyBeingFired.reduce(at, J);
                return (
                  (e.onReadyBeingFired = []),
                  Pt.resolve(
                    Ci(function () {
                      return s(t.vip);
                    }),
                  ).then(i)
                );
              }
            })
          );
        })
        .finally(function () {
          e.openCanceller === s && ((e.onReadyBeingFired = null), (e.isBeingOpened = !1));
        })
        .catch(function (i) {
          e.dbOpenError = i;
          try {
            l && l.abort();
          } catch (t) {}
          return (s === e.openCanceller && t._close(), ae(i));
        })
        .finally(function () {
          ((e.openComplete = !0), h());
        })
        .then(function () {
          if (c) {
            var e = {};
            (t.tables.forEach(function (i) {
              (i.schema.indexes.forEach(function (s) {
                s.name && (e['idb://'.concat(t.name, '/').concat(i.name, '/').concat(s.name)] = new Ai(-1 / 0, [[[]]]));
              }),
                (e['idb://'.concat(t.name, '/').concat(i.name, '/')] = e[
                  'idb://'.concat(t.name, '/').concat(i.name, '/:dels')
                ] =
                  new Ai(-1 / 0, [[[]]])));
            }),
              Ye(Qe).fire(e),
              Hi(e, !0));
          }
          return t;
        });
    }
    function Vi(t) {
      var e = function (e) {
          return t.next(e);
        },
        i = n(e),
        s = n(function (e) {
          return t.throw(e);
        });
      function n(t) {
        return function (e) {
          var n = t(e),
            a = n.value;
          return n.done ? a : a && 'function' == typeof a.then ? a.then(i, s) : r(a) ? Promise.all(a).then(i, s) : i(a);
        };
      }
      return n(e)();
    }
    function Ui(t, e, i) {
      var s = arguments.length;
      if (s < 2) throw new X.InvalidArgument('Too few arguments');
      for (var n = new Array(s - 1); --s; ) n[s - 1] = arguments[s];
      return ((i = n.pop()), [t, E(n), i]);
    }
    function Ki(t, e, i, s, n) {
      return Pt.resolve().then(function () {
        var r = Et.transless || Et,
          a = t._createTransaction(e, i, t._dbSchema, s);
        a.explicit = !0;
        var o = { trans: a, transless: r };
        if (s) a.idbtrans = s.idbtrans;
        else
          try {
            (a.create(), (a.idbtrans._explicit = !0), (t._state.PR1398_maxLoop = 3));
          } catch (s) {
            return s.name === W.InvalidState && t.isOpen() && --t._state.PR1398_maxLoop > 0
              ? (console.warn('Dexie: Need to reopen db'),
                t.close({ disableAutoOpen: !1 }),
                t.open().then(function () {
                  return Ki(t, e, i, null, n);
                }))
              : ae(s);
          }
        var h,
          l = O(n);
        l && Yt();
        var c = Pt.follow(function () {
          if ((h = n.call(a, a)))
            if (l) {
              var t = Zt.bind(null, null);
              h.then(t, t);
            } else 'function' == typeof h.next && 'function' == typeof h.throw && (h = Vi(h));
        }, o);
        return (
          h && 'function' == typeof h.then
            ? Pt.resolve(h).then(function (t) {
                return a.active
                  ? t
                  : ae(new X.PrematureCommit('Transaction committed too early. See http://bit.ly/2kdckMn'));
              })
            : c.then(function () {
                return h;
              })
        )
          .then(function (t) {
            return (
              s && a._resolve(),
              a._completion.then(function () {
                return t;
              })
            );
          })
          .catch(function (t) {
            return (a._reject(t), ae(t));
          });
      });
    }
    function Gi(t, e, i) {
      for (var s = r(t) ? t.slice() : [t], n = 0; n < i; ++n) s.push(e);
      return s;
    }
    var Wi = {
      stack: 'dbcore',
      name: 'VirtualIndexMiddleware',
      level: 1,
      create: function (t) {
        return e(e({}, t), {
          table: function (i) {
            var s = t.table(i),
              n = s.schema,
              r = {},
              a = [];
            function o(t, i, s) {
              var n = ri(t),
                h = (r[n] = r[n] || []),
                l = null == t ? 0 : 'string' == typeof t ? 1 : t.length,
                c = i > 0,
                u = e(e({}, s), {
                  name: c ? ''.concat(n, '(virtual-from:').concat(s.name, ')') : s.name,
                  lowLevelIndex: s,
                  isVirtual: c,
                  keyTail: i,
                  keyLength: l,
                  extractKey: ii(t),
                  unique: !c && s.unique,
                });
              (h.push(u), u.isPrimaryKey || a.push(u), l > 1) && o(2 === l ? t[0] : t.slice(0, l - 1), i + 1, s);
              return (
                h.sort(function (t, e) {
                  return t.keyTail - e.keyTail;
                }),
                u
              );
            }
            var h = o(n.primaryKey.keyPath, 0, n.primaryKey);
            r[':id'] = [h];
            for (var l = 0, c = n.indexes; l < c.length; l++) {
              var u = c[l];
              o(u.keyPath, 0, u);
            }
            function d(i) {
              var s,
                n,
                r = i.query.index;
              return r.isVirtual
                ? e(e({}, i), {
                    query: {
                      index: r.lowLevelIndex,
                      range:
                        ((s = i.query.range),
                        (n = r.keyTail),
                        {
                          type: 1 === s.type ? 2 : s.type,
                          lower: Gi(s.lower, s.lowerOpen ? t.MAX_KEY : t.MIN_KEY, n),
                          lowerOpen: !0,
                          upper: Gi(s.upper, s.upperOpen ? t.MIN_KEY : t.MAX_KEY, n),
                          upperOpen: !0,
                        }),
                    },
                  })
                : i;
            }
            var f = e(e({}, s), {
              schema: e(e({}, n), {
                primaryKey: h,
                indexes: a,
                getIndexByKeyPath: function (t) {
                  var e = r[ri(t)];
                  return e && e[0];
                },
              }),
              count: function (t) {
                return s.count(d(t));
              },
              query: function (t) {
                return s.query(d(t));
              },
              openCursor: function (e) {
                var i = e.query.index,
                  n = i.keyTail,
                  r = i.isVirtual,
                  a = i.keyLength;
                if (!r) return s.openCursor(e);
                return s.openCursor(d(e)).then(function (i) {
                  return (
                    i &&
                    (function (i) {
                      var s = Object.create(i, {
                        continue: {
                          value: function (s) {
                            null != s
                              ? i.continue(Gi(s, e.reverse ? t.MAX_KEY : t.MIN_KEY, n))
                              : e.unique
                                ? i.continue(i.key.slice(0, a).concat(e.reverse ? t.MIN_KEY : t.MAX_KEY, n))
                                : i.continue();
                          },
                        },
                        continuePrimaryKey: {
                          value: function (e, s) {
                            i.continuePrimaryKey(Gi(e, t.MAX_KEY, n), s);
                          },
                        },
                        primaryKey: {
                          get: function () {
                            return i.primaryKey;
                          },
                        },
                        key: {
                          get: function () {
                            var t = i.key;
                            return 1 === a ? t[0] : t.slice(0, a);
                          },
                        },
                        value: {
                          get: function () {
                            return i.value;
                          },
                        },
                      });
                      return s;
                    })(i)
                  );
                });
              },
            });
            return f;
          },
        });
      },
    };
    function Qi(t, e, i, s) {
      return (
        (i = i || {}),
        (s = s || ''),
        n(t).forEach(function (n) {
          if (l(e, n)) {
            var r = t[n],
              a = e[n];
            if ('object' == typeof r && 'object' == typeof a && r && a) {
              var o = R(r);
              o !== R(a) ? (i[s + n] = e[n]) : 'Object' === o ? Qi(r, a, i, s + n + '.') : r !== a && (i[s + n] = e[n]);
            } else r !== a && (i[s + n] = e[n]);
          } else i[s + n] = void 0;
        }),
        n(e).forEach(function (n) {
          l(t, n) || (i[s + n] = e[n]);
        }),
        i
      );
    }
    function Xi(t, e) {
      return 'delete' === e.type ? e.keys : e.keys || e.values.map(t.extractKey);
    }
    var Yi = {
      stack: 'dbcore',
      name: 'HooksMiddleware',
      level: 2,
      create: function (t) {
        return e(e({}, t), {
          table: function (s) {
            var n = t.table(s),
              r = n.schema.primaryKey,
              a = e(e({}, n), {
                mutate: function (t) {
                  var a = Et.trans,
                    o = a.table(s).hook,
                    h = o.deleting,
                    c = o.creating,
                    u = o.updating;
                  switch (t.type) {
                    case 'add':
                      if (c.fire === J) break;
                      return a._promise(
                        'readwrite',
                        function () {
                          return d(t);
                        },
                        !0,
                      );
                    case 'put':
                      if (c.fire === J && u.fire === J) break;
                      return a._promise(
                        'readwrite',
                        function () {
                          return d(t);
                        },
                        !0,
                      );
                    case 'delete':
                      if (h.fire === J) break;
                      return a._promise(
                        'readwrite',
                        function () {
                          return d(t);
                        },
                        !0,
                      );
                    case 'deleteRange':
                      if (h.fire === J) break;
                      return a._promise(
                        'readwrite',
                        function () {
                          return (function (t) {
                            return f(t.trans, t.range, 1e4);
                          })(t);
                        },
                        !0,
                      );
                  }
                  return n.mutate(t);
                  function d(t) {
                    var s = Et.trans,
                      a = t.keys || Xi(r, t);
                    if (!a) throw new Error('Keys missing');
                    return (
                      'delete' !==
                        (t = 'add' === t.type || 'put' === t.type ? e(e({}, t), { keys: a }) : e({}, t)).type &&
                        (t.values = i([], t.values)),
                      t.keys && (t.keys = i([], t.keys)),
                      (function (t, e, i) {
                        return 'add' === e.type
                          ? Promise.resolve([])
                          : t.getMany({ trans: e.trans, keys: i, cache: 'immutable' });
                      })(n, t, a).then(function (e) {
                        var i = a.map(function (i, n) {
                          var a = e[n],
                            o = { onerror: null, onsuccess: null };
                          if ('delete' === t.type) h.fire.call(o, i, a, s);
                          else if ('add' === t.type || void 0 === a) {
                            var d = c.fire.call(o, i, t.values[n], s);
                            null == i &&
                              null != d &&
                              ((i = d), (t.keys[n] = i), r.outbound || S(t.values[n], r.keyPath, i));
                          } else {
                            var f = Qi(a, t.values[n]),
                              p = u.fire.call(o, f, i, a, s);
                            if (p) {
                              var m = t.values[n];
                              Object.keys(p).forEach(function (t) {
                                l(m, t) ? (m[t] = p[t]) : S(m, t, p[t]);
                              });
                            }
                          }
                          return o;
                        });
                        return n
                          .mutate(t)
                          .then(function (s) {
                            for (
                              var n = s.failures, r = s.results, o = s.numFailures, h = s.lastResult, l = 0;
                              l < a.length;
                              ++l
                            ) {
                              var c = r ? r[l] : a[l],
                                u = i[l];
                              null == c
                                ? u.onerror && u.onerror(n[l])
                                : u.onsuccess && u.onsuccess('put' === t.type && e[l] ? t.values[l] : c);
                            }
                            return { failures: n, results: r, numFailures: o, lastResult: h };
                          })
                          .catch(function (t) {
                            return (
                              i.forEach(function (e) {
                                return e.onerror && e.onerror(t);
                              }),
                              Promise.reject(t)
                            );
                          });
                      })
                    );
                  }
                  function f(t, i, s) {
                    return n
                      .query({ trans: t, values: !1, query: { index: r, range: i }, limit: s })
                      .then(function (n) {
                        var r = n.result;
                        return d({ type: 'delete', keys: r, trans: t }).then(function (n) {
                          return n.numFailures > 0
                            ? Promise.reject(n.failures[0])
                            : r.length < s
                              ? { failures: [], numFailures: 0, lastResult: void 0 }
                              : f(t, e(e({}, i), { lower: r[r.length - 1], lowerOpen: !0 }), s);
                        });
                      });
                  }
                },
              });
            return a;
          },
        });
      },
    };
    function Zi(t, e, i) {
      try {
        if (!e) return null;
        if (e.keys.length < t.length) return null;
        for (var s = [], n = 0, r = 0; n < e.keys.length && r < t.length; ++n)
          0 === we(e.keys[n], t[r]) && (s.push(i ? T(e.values[n]) : e.values[n]), ++r);
        return s.length === t.length ? s : null;
      } catch (t) {
        return null;
      }
    }
    var Ji = {
      stack: 'dbcore',
      level: -1,
      create: function (t) {
        return {
          table: function (i) {
            var s = t.table(i);
            return e(e({}, s), {
              getMany: function (t) {
                if (!t.cache) return s.getMany(t);
                var e = Zi(t.keys, t.trans._cache, 'clone' === t.cache);
                return e
                  ? Pt.resolve(e)
                  : s.getMany(t).then(function (e) {
                      return ((t.trans._cache = { keys: t.keys, values: 'clone' === t.cache ? T(e) : e }), e);
                    });
              },
              mutate: function (t) {
                return ('add' !== t.type && (t.trans._cache = null), s.mutate(t));
              },
            });
          },
        };
      },
    };
    function $i(t, e) {
      return (
        'readonly' === t.trans.mode &&
        !!t.subscr &&
        !t.trans.explicit &&
        'disabled' !== t.trans.db._options.cache &&
        !e.schema.primaryKey.outbound
      );
    }
    function ts(t, e) {
      switch (t) {
        case 'query':
          return e.values && !e.unique;
        case 'get':
        case 'getMany':
        case 'count':
        case 'openCursor':
          return !1;
      }
    }
    var es = {
      stack: 'dbcore',
      level: 0,
      name: 'Observability',
      create: function (t) {
        var i = t.schema.name,
          s = new Ai(t.MIN_KEY, t.MAX_KEY);
        return e(e({}, t), {
          transaction: function (e, i, s) {
            if (Et.subscr && 'readonly' !== i)
              throw new X.ReadOnly('Readwrite transaction in liveQuery context. Querier source: '.concat(Et.querier));
            return t.transaction(e, i, s);
          },
          table: function (a) {
            var o = t.table(a),
              h = o.schema,
              l = h.primaryKey,
              c = h.indexes,
              u = l.extractKey,
              d = l.outbound,
              f =
                l.autoIncrement &&
                c.filter(function (t) {
                  return t.compound && t.keyPath.includes(l.keyPath);
                }),
              p = e(e({}, o), {
                mutate: function (e) {
                  var n,
                    c,
                    u = e.trans,
                    d = e.mutatedParts || (e.mutatedParts = {}),
                    p = function (t) {
                      var e = 'idb://'.concat(i, '/').concat(a, '/').concat(t);
                      return d[e] || (d[e] = new Ai());
                    },
                    m = p(''),
                    g = p(':dels'),
                    y = e.type,
                    x =
                      'deleteRange' === e.type
                        ? [e.range]
                        : 'delete' === e.type
                          ? [e.keys]
                          : e.values.length < 50
                            ? [
                                Xi(l, e).filter(function (t) {
                                  return t;
                                }),
                                e.values,
                              ]
                            : [],
                    v = x[0],
                    b = x[1],
                    w = e.trans._cache;
                  if (r(v)) {
                    m.addKeys(v);
                    var S = 'delete' === y || v.length === b.length ? Zi(v, w) : null;
                    (S || g.addKeys(v),
                      (S || b) &&
                        (function (t, e, i, s) {
                          function n(e) {
                            var n = t(e.name || '');
                            function a(t) {
                              return null != t ? e.extractKey(t) : null;
                            }
                            var o = function (t) {
                              return e.multiEntry && r(t)
                                ? t.forEach(function (t) {
                                    return n.addKey(t);
                                  })
                                : n.addKey(t);
                            };
                            (i || s).forEach(function (t, e) {
                              var n = i && a(i[e]),
                                r = s && a(s[e]);
                              0 !== we(n, r) && (null != n && o(n), null != r && o(r));
                            });
                          }
                          e.indexes.forEach(n);
                        })(p, h, S, b));
                  } else if (v) {
                    var M = {
                      from: null !== (n = v.lower) && void 0 !== n ? n : t.MIN_KEY,
                      to: null !== (c = v.upper) && void 0 !== c ? c : t.MAX_KEY,
                    };
                    (g.add(M), m.add(M));
                  } else
                    (m.add(s),
                      g.add(s),
                      h.indexes.forEach(function (t) {
                        return p(t.name).add(s);
                      }));
                  return o.mutate(e).then(function (t) {
                    return (
                      !v ||
                        ('add' !== e.type && 'put' !== e.type) ||
                        (m.addKeys(t.results),
                        f &&
                          f.forEach(function (i) {
                            for (
                              var s = e.values.map(function (t) {
                                  return i.extractKey(t);
                                }),
                                n = i.keyPath.findIndex(function (t) {
                                  return t === l.keyPath;
                                }),
                                r = 0,
                                a = t.results.length;
                              r < a;
                              ++r
                            )
                              s[r][n] = t.results[r];
                            p(i.name).addKeys(s);
                          })),
                      (u.mutatedParts = Ni(u.mutatedParts || {}, d)),
                      t
                    );
                  });
                },
              }),
              m = function (e) {
                var i,
                  s,
                  n = e.query,
                  r = n.index,
                  a = n.range;
                return [
                  r,
                  new Ai(
                    null !== (i = a.lower) && void 0 !== i ? i : t.MIN_KEY,
                    null !== (s = a.upper) && void 0 !== s ? s : t.MAX_KEY,
                  ),
                ];
              },
              g = {
                get: function (t) {
                  return [l, new Ai(t.key)];
                },
                getMany: function (t) {
                  return [l, new Ai().addKeys(t.keys)];
                },
                count: m,
                query: m,
                openCursor: m,
              };
            return (
              n(g).forEach(function (t) {
                p[t] = function (n) {
                  var r = Et.subscr,
                    h = !!r,
                    l = $i(Et, o) && ts(t, n) ? (n.obsSet = {}) : r;
                  if (h) {
                    var c = function (t) {
                        var e = 'idb://'.concat(i, '/').concat(a, '/').concat(t);
                        return l[e] || (l[e] = new Ai());
                      },
                      f = c(''),
                      p = c(':dels'),
                      m = g[t](n),
                      y = m[0],
                      x = m[1];
                    if (
                      ('query' === t && y.isPrimaryKey && !n.values ? p.add(x) : c(y.name || '').add(x),
                      !y.isPrimaryKey)
                    ) {
                      if ('count' !== t) {
                        var v = 'query' === t && d && n.values && o.query(e(e({}, n), { values: !1 }));
                        return o[t].apply(this, arguments).then(function (e) {
                          if ('query' === t) {
                            if (d && n.values)
                              return v.then(function (t) {
                                var i = t.result;
                                return (f.addKeys(i), e);
                              });
                            var i = n.values ? e.result.map(u) : e.result;
                            n.values ? f.addKeys(i) : p.addKeys(i);
                          } else if ('openCursor' === t) {
                            var s = e,
                              r = n.values;
                            return (
                              s &&
                              Object.create(s, {
                                key: {
                                  get: function () {
                                    return (p.addKey(s.primaryKey), s.key);
                                  },
                                },
                                primaryKey: {
                                  get: function () {
                                    var t = s.primaryKey;
                                    return (p.addKey(t), t);
                                  },
                                },
                                value: {
                                  get: function () {
                                    return (r && f.addKey(s.primaryKey), s.value);
                                  },
                                },
                              })
                            );
                          }
                          return e;
                        });
                      }
                      p.add(s);
                    }
                  }
                  return o[t].apply(this, arguments);
                };
              }),
              p
            );
          },
        });
      },
    };
    function is(t, i, s) {
      if (0 === s.numFailures) return i;
      if ('deleteRange' === i.type) return null;
      var n = i.keys ? i.keys.length : 'values' in i && i.values ? i.values.length : 1;
      if (s.numFailures === n) return null;
      var a = e({}, i);
      return (
        r(a.keys) &&
          (a.keys = a.keys.filter(function (t, e) {
            return !(e in s.failures);
          })),
        'values' in a &&
          r(a.values) &&
          (a.values = a.values.filter(function (t, e) {
            return !(e in s.failures);
          })),
        a
      );
    }
    function ss(t, e) {
      return (
        (function (t, e) {
          return void 0 === e.lower || (e.lowerOpen ? we(t, e.lower) > 0 : we(t, e.lower) >= 0);
        })(t, e) &&
        (function (t, e) {
          return void 0 === e.upper || (e.upperOpen ? we(t, e.upper) < 0 : we(t, e.upper) <= 0);
        })(t, e)
      );
    }
    function ns(t, e, i, s, n, a) {
      if (!i || 0 === i.length) return t;
      var o = e.query.index,
        h = o.multiEntry,
        l = e.query.range,
        c = s.schema.primaryKey.extractKey,
        u = o.extractKey,
        d = (o.lowLevelIndex || o).extractKey,
        f = i.reduce(function (t, i) {
          var s = t,
            n = [];
          if ('add' === i.type || 'put' === i.type)
            for (var a = new Ai(), o = i.values.length - 1; o >= 0; --o) {
              var d = i.values[o],
                f = c(d);
              if (!a.hasKey(f)) {
                var p = u(d);
                (h && r(p)
                  ? p.some(function (t) {
                      return ss(t, l);
                    })
                  : ss(p, l)) && (a.addKey(f), n.push(d));
              }
            }
          switch (i.type) {
            case 'add':
              var m = new Ai().addKeys(
                e.values
                  ? t.map(function (t) {
                      return c(t);
                    })
                  : t,
              );
              s = t.concat(
                e.values
                  ? n.filter(function (t) {
                      var e = c(t);
                      return !m.hasKey(e) && (m.addKey(e), !0);
                    })
                  : n
                      .map(function (t) {
                        return c(t);
                      })
                      .filter(function (t) {
                        return !m.hasKey(t) && (m.addKey(t), !0);
                      }),
              );
              break;
            case 'put':
              var g = new Ai().addKeys(
                i.values.map(function (t) {
                  return c(t);
                }),
              );
              s = t
                .filter(function (t) {
                  return !g.hasKey(e.values ? c(t) : t);
                })
                .concat(
                  e.values
                    ? n
                    : n.map(function (t) {
                        return c(t);
                      }),
                );
              break;
            case 'delete':
              var y = new Ai().addKeys(i.keys);
              s = t.filter(function (t) {
                return !y.hasKey(e.values ? c(t) : t);
              });
              break;
            case 'deleteRange':
              var x = i.range;
              s = t.filter(function (t) {
                return !ss(c(t), x);
              });
          }
          return s;
        }, t);
      return f === t
        ? t
        : (f.sort(function (t, e) {
            return we(d(t), d(e)) || we(c(t), c(e));
          }),
          e.limit &&
            e.limit < 1 / 0 &&
            (f.length > e.limit ? (f.length = e.limit) : t.length === e.limit && f.length < e.limit && (n.dirty = !0)),
          a ? Object.freeze(f) : f);
    }
    function rs(t, e) {
      return (
        0 === we(t.lower, e.lower) &&
        0 === we(t.upper, e.upper) &&
        !!t.lowerOpen == !!e.lowerOpen &&
        !!t.upperOpen == !!e.upperOpen
      );
    }
    function as(t, e) {
      return (
        (function (t, e, i, s) {
          if (void 0 === t) return void 0 !== e ? -1 : 0;
          if (void 0 === e) return 1;
          var n = we(t, e);
          if (0 === n) {
            if (i && s) return 0;
            if (i) return 1;
            if (s) return -1;
          }
          return n;
        })(t.lower, e.lower, t.lowerOpen, e.lowerOpen) <= 0 &&
        (function (t, e, i, s) {
          if (void 0 === t) return void 0 !== e ? 1 : 0;
          if (void 0 === e) return -1;
          var n = we(t, e);
          if (0 === n) {
            if (i && s) return 0;
            if (i) return -1;
            if (s) return 1;
          }
          return n;
        })(t.upper, e.upper, t.upperOpen, e.upperOpen) >= 0
      );
    }
    function os(t, e, i, s) {
      (t.subscribers.add(i),
        s.addEventListener('abort', function () {
          (t.subscribers.delete(i),
            0 === t.subscribers.size &&
              (function (t, e) {
                setTimeout(function () {
                  0 === t.subscribers.size && k(e, t);
                }, 3e3);
              })(t, e));
        }));
    }
    var hs = {
      stack: 'dbcore',
      level: 0,
      name: 'Cache',
      create: function (t) {
        var i = t.schema.name,
          s = e(e({}, t), {
            transaction: function (e, s, n) {
              var r = t.transaction(e, s, n);
              if ('readwrite' === s) {
                var a = new AbortController(),
                  o = a.signal,
                  h = function (n) {
                    return function () {
                      if ((a.abort(), 'readwrite' === s)) {
                        for (var o = new Set(), h = 0, l = e; h < l.length; h++) {
                          var c = l[h],
                            u = ki['idb://'.concat(i, '/').concat(c)];
                          if (u) {
                            var d = t.table(c),
                              f = u.optimisticOps.filter(function (t) {
                                return t.trans === r;
                              });
                            if (r._explicit && n && r.mutatedParts)
                              for (var p = 0, m = Object.values(u.queries.query); p < m.length; p++)
                                for (var g = 0, y = (b = m[p]).slice(); g < y.length; g++) {
                                  Bi((M = y[g]).obsSet, r.mutatedParts) &&
                                    (k(b, M),
                                    M.subscribers.forEach(function (t) {
                                      return o.add(t);
                                    }));
                                }
                            else if (f.length > 0) {
                              u.optimisticOps = u.optimisticOps.filter(function (t) {
                                return t.trans !== r;
                              });
                              for (var x = 0, v = Object.values(u.queries.query); x < v.length; x++)
                                for (var b, w = 0, S = (b = v[x]).slice(); w < S.length; w++) {
                                  var M;
                                  if (null != (M = S[w]).res && r.mutatedParts)
                                    if (n && !M.dirty) {
                                      var C = Object.isFrozen(M.res),
                                        E = ns(M.res, M.req, f, d, M, C);
                                      M.dirty
                                        ? (k(b, M),
                                          M.subscribers.forEach(function (t) {
                                            return o.add(t);
                                          }))
                                        : E !== M.res && ((M.res = E), (M.promise = Pt.resolve({ result: E })));
                                    } else
                                      (M.dirty && k(b, M),
                                        M.subscribers.forEach(function (t) {
                                          return o.add(t);
                                        }));
                                }
                            }
                          }
                        }
                        o.forEach(function (t) {
                          return t();
                        });
                      }
                    };
                  };
                (r.addEventListener('abort', h(!1), { signal: o }),
                  r.addEventListener('error', h(!1), { signal: o }),
                  r.addEventListener('complete', h(!0), { signal: o }));
              }
              return r;
            },
            table: function (s) {
              var n = t.table(s),
                r = n.schema.primaryKey,
                a = e(e({}, n), {
                  mutate: function (t) {
                    var a = Et.trans;
                    if (
                      r.outbound ||
                      'disabled' === a.db._options.cache ||
                      a.explicit ||
                      'readwrite' !== a.idbtrans.mode
                    )
                      return n.mutate(t);
                    var o = ki['idb://'.concat(i, '/').concat(s)];
                    if (!o) return n.mutate(t);
                    var h = n.mutate(t);
                    return (
                      ('add' !== t.type && 'put' !== t.type) ||
                      !(
                        t.values.length >= 50 ||
                        Xi(r, t).some(function (t) {
                          return null == t;
                        })
                      )
                        ? (o.optimisticOps.push(t),
                          t.mutatedParts && Oi(t.mutatedParts),
                          h.then(function (e) {
                            if (e.numFailures > 0) {
                              k(o.optimisticOps, t);
                              var i = is(0, t, e);
                              (i && o.optimisticOps.push(i), t.mutatedParts && Oi(t.mutatedParts));
                            }
                          }),
                          h.catch(function () {
                            (k(o.optimisticOps, t), t.mutatedParts && Oi(t.mutatedParts));
                          }))
                        : h.then(function (i) {
                            var s = e(e({}, t), {
                                values: t.values.map(function (t, s) {
                                  var n;
                                  if (i.failures[s]) return t;
                                  var a = (null === (n = r.keyPath) || void 0 === n ? void 0 : n.includes('.'))
                                    ? T(t)
                                    : e({}, t);
                                  return (S(a, r.keyPath, i.results[s]), a);
                                }),
                              }),
                              n = is(0, s, i);
                            (o.optimisticOps.push(n),
                              queueMicrotask(function () {
                                return t.mutatedParts && Oi(t.mutatedParts);
                              }));
                          }),
                      h
                    );
                  },
                  query: function (t) {
                    var e;
                    if (!$i(Et, n) || !ts('query', t)) return n.query(t);
                    var r = 'immutable' === (null === (e = Et.trans) || void 0 === e ? void 0 : e.db._options.cache),
                      a = Et,
                      o = a.requery,
                      h = a.signal,
                      l = (function (t, e, i, s) {
                        var n = ki['idb://'.concat(t, '/').concat(e)];
                        if (!n) return [];
                        var r = n.queries[i];
                        if (!r) return [null, !1, n, null];
                        var a = r[(s.query ? s.query.index.name : null) || ''];
                        if (!a) return [null, !1, n, null];
                        switch (i) {
                          case 'query':
                            var o = a.find(function (t) {
                              return (
                                t.req.limit === s.limit &&
                                t.req.values === s.values &&
                                rs(t.req.query.range, s.query.range)
                              );
                            });
                            return o
                              ? [o, !0, n, a]
                              : [
                                  a.find(function (t) {
                                    return (
                                      ('limit' in t.req ? t.req.limit : 1 / 0) >= s.limit &&
                                      (!s.values || t.req.values) &&
                                      as(t.req.query.range, s.query.range)
                                    );
                                  }),
                                  !1,
                                  n,
                                  a,
                                ];
                          case 'count':
                            var h = a.find(function (t) {
                              return rs(t.req.query.range, s.query.range);
                            });
                            return [h, !!h, n, a];
                        }
                      })(i, s, 'query', t),
                      c = l[0],
                      u = l[1],
                      d = l[2],
                      f = l[3];
                    if (c && u) c.obsSet = t.obsSet;
                    else {
                      var p = n
                        .query(t)
                        .then(function (t) {
                          var e = t.result;
                          if ((c && (c.res = e), r)) {
                            for (var i = 0, s = e.length; i < s; ++i) Object.freeze(e[i]);
                            Object.freeze(e);
                          } else t.result = T(e);
                          return t;
                        })
                        .catch(function (t) {
                          return (f && c && k(f, c), Promise.reject(t));
                        });
                      ((c = { obsSet: t.obsSet, promise: p, subscribers: new Set(), type: 'query', req: t, dirty: !1 }),
                        f
                          ? f.push(c)
                          : ((f = [c]),
                            d ||
                              (d = ki['idb://'.concat(i, '/').concat(s)] =
                                {
                                  queries: { query: {}, count: {} },
                                  objs: new Map(),
                                  optimisticOps: [],
                                  unsignaledParts: {},
                                }),
                            (d.queries.query[t.query.index.name || ''] = f)));
                    }
                    return (
                      os(c, f, o, h),
                      c.promise.then(function (e) {
                        return { result: ns(e.result, t, null == d ? void 0 : d.optimisticOps, n, c, r) };
                      })
                    );
                  },
                });
              return a;
            },
          });
        return s;
      },
    };
    function ls(t, e) {
      return new Proxy(t, {
        get: function (t, i, s) {
          return 'db' === i ? e : Reflect.get(t, i, s);
        },
      });
    }
    var cs,
      us = (function () {
        function t(i, s) {
          var n = this;
          ((this._middlewares = {}), (this.verno = 0));
          var r = t.dependencies;
          ((this._options = s =
            e(
              { addons: t.addons, autoOpen: !0, indexedDB: r.indexedDB, IDBKeyRange: r.IDBKeyRange, cache: 'cloned' },
              s,
            )),
            (this._deps = { indexedDB: s.indexedDB, IDBKeyRange: s.IDBKeyRange }));
          var a = s.addons;
          ((this._dbSchema = {}),
            (this._versions = []),
            (this._storeNames = []),
            (this._allTables = {}),
            (this.idbdb = null),
            (this._novip = this));
          var o,
            h = {
              dbOpenError: null,
              isBeingOpened: !1,
              onReadyBeingFired: null,
              openComplete: !1,
              dbReadyResolve: J,
              dbReadyPromise: null,
              cancelOpen: J,
              openCanceller: null,
              autoSchema: !0,
              PR1398_maxLoop: 3,
              autoOpen: s.autoOpen,
            };
          ((h.dbReadyPromise = new Pt(function (t) {
            h.dbReadyResolve = t;
          })),
            (h.openCanceller = new Pt(function (t, e) {
              h.cancelOpen = e;
            })),
            (this._state = h),
            (this.name = i),
            (this.on = Ee(this, 'populate', 'blocked', 'versionchange', 'close', { ready: [at, J] })),
            (this.on.ready.subscribe = x(this.on.ready.subscribe, function (e) {
              return function (i, s) {
                t.vip(function () {
                  var t = n._state;
                  if (t.openComplete) (t.dbOpenError || Pt.resolve().then(i), s && e(i));
                  else if (t.onReadyBeingFired) (t.onReadyBeingFired.push(i), s && e(i));
                  else {
                    e(i);
                    var r = n;
                    s ||
                      e(function t() {
                        (r.on.ready.unsubscribe(i), r.on.ready.unsubscribe(t));
                      });
                  }
                });
              };
            })),
            (this.Collection =
              ((o = this),
              De(Be.prototype, function (t, e) {
                this.db = o;
                var i = xe,
                  s = null;
                if (e)
                  try {
                    i = e();
                  } catch (t) {
                    s = t;
                  }
                var n = t._ctx,
                  r = n.table,
                  a = r.hook.reading.fire;
                this._ctx = {
                  table: r,
                  index: n.index,
                  isPrimKey: !n.index || (r.schema.primKey.keyPath && n.index === r.schema.primKey.name),
                  range: i,
                  keysOnly: !1,
                  dir: 'next',
                  unique: '',
                  algorithm: null,
                  filter: null,
                  replayFilter: null,
                  justLimit: !0,
                  isMatch: null,
                  offset: 0,
                  limit: 1 / 0,
                  error: s,
                  or: n.or,
                  valueMapper: a !== $ ? a : null,
                };
              }))),
            (this.Table = (function (t) {
              return De(Ce.prototype, function (e, i, s) {
                ((this.db = t),
                  (this._tx = s),
                  (this.name = e),
                  (this.schema = i),
                  (this.hook = t._allTables[e]
                    ? t._allTables[e].hook
                    : Ee(null, { creating: [it, J], reading: [tt, $], updating: [nt, J], deleting: [st, J] })));
              });
            })(this)),
            (this.Transaction = (function (t) {
              return De(Ze.prototype, function (e, i, s, n, r) {
                var a = this;
                ((this.db = t),
                  (this.mode = e),
                  (this.storeNames = i),
                  (this.schema = s),
                  (this.chromeTransactionDurability = n),
                  (this.idbtrans = null),
                  (this.on = Ee(this, 'complete', 'error', 'abort')),
                  (this.parent = r || null),
                  (this.active = !0),
                  (this._reculock = 0),
                  (this._blockedFuncs = []),
                  (this._resolve = null),
                  (this._reject = null),
                  (this._waitingFor = null),
                  (this._waitingQueue = null),
                  (this._spinCount = 0),
                  (this._completion = new Pt(function (t, e) {
                    ((a._resolve = t), (a._reject = e));
                  })),
                  this._completion.then(
                    function () {
                      ((a.active = !1), a.on.complete.fire());
                    },
                    function (t) {
                      var e = a.active;
                      return (
                        (a.active = !1),
                        a.on.error.fire(t),
                        a.parent ? a.parent._reject(t) : e && a.idbtrans && a.idbtrans.abort(),
                        ae(t)
                      );
                    },
                  ));
              });
            })(this)),
            (this.Version = (function (t) {
              return De(wi.prototype, function (e) {
                ((this.db = t),
                  (this._cfg = { version: e, storesSource: null, dbschema: {}, tables: {}, contentUpgrade: null }));
              });
            })(this)),
            (this.WhereClause = (function (t) {
              return De(Ke.prototype, function (e, i, s) {
                if (
                  ((this.db = t),
                  (this._ctx = { table: e, index: ':id' === i ? null : i, or: s }),
                  (this._cmp = this._ascending = we),
                  (this._descending = function (t, e) {
                    return we(e, t);
                  }),
                  (this._max = function (t, e) {
                    return we(t, e) > 0 ? t : e;
                  }),
                  (this._min = function (t, e) {
                    return we(t, e) < 0 ? t : e;
                  }),
                  (this._IDBKeyRange = t._deps.IDBKeyRange),
                  !this._IDBKeyRange)
                )
                  throw new X.MissingAPI();
              });
            })(this)),
            this.on('versionchange', function (t) {
              (t.newVersion > 0
                ? console.warn(
                    "Another connection wants to upgrade database '".concat(
                      n.name,
                      "'. Closing db now to resume the upgrade.",
                    ),
                  )
                : console.warn(
                    "Another connection wants to delete database '".concat(
                      n.name,
                      "'. Closing db now to resume the delete request.",
                    ),
                  ),
                n.close({ disableAutoOpen: !1 }));
            }),
            this.on('blocked', function (t) {
              !t.newVersion || t.newVersion < t.oldVersion
                ? console.warn("Dexie.delete('".concat(n.name, "') was blocked"))
                : console.warn(
                    "Upgrade '"
                      .concat(n.name, "' blocked by other connection holding version ")
                      .concat(t.oldVersion / 10),
                  );
            }),
            (this._maxKey = ei(s.IDBKeyRange)),
            (this._createTransaction = function (t, e, i, s) {
              return new n.Transaction(t, e, i, n._options.chromeTransactionDurability, s);
            }),
            (this._fireOnBlocked = function (t) {
              (n.on('blocked').fire(t),
                fe
                  .filter(function (t) {
                    return t.name === n.name && t !== n && !t._state.vcFired;
                  })
                  .map(function (e) {
                    return e.on('versionchange').fire(t);
                  }));
            }),
            this.use(Ji),
            this.use(hs),
            this.use(es),
            this.use(Wi),
            this.use(Yi));
          var l = new Proxy(this, {
            get: function (t, e, i) {
              if ('_vip' === e) return !0;
              if ('table' === e)
                return function (t) {
                  return ls(n.table(t), l);
                };
              var s = Reflect.get(t, e, i);
              return s instanceof Ce
                ? ls(s, l)
                : 'tables' === e
                  ? s.map(function (t) {
                      return ls(t, l);
                    })
                  : '_createTransaction' === e
                    ? function () {
                        return ls(s.apply(this, arguments), l);
                      }
                    : s;
            },
          });
          ((this.vip = l),
            a.forEach(function (t) {
              return t(n);
            }));
        }
        return (
          (t.prototype.version = function (t) {
            if (isNaN(t) || t < 0.1) throw new X.Type('Given version is not a positive number');
            if (((t = Math.round(10 * t) / 10), this.idbdb || this._state.isBeingOpened))
              throw new X.Schema('Cannot add version when database is open');
            this.verno = Math.max(this.verno, t);
            var e = this._versions,
              i = e.filter(function (e) {
                return e._cfg.version === t;
              })[0];
            return (
              i || ((i = new this.Version(t)), e.push(i), e.sort(ui), i.stores({}), (this._state.autoSchema = !1), i)
            );
          }),
          (t.prototype._whenReady = function (t) {
            var e = this;
            return this.idbdb && (this._state.openComplete || Et.letThrough || this._vip)
              ? t()
              : new Pt(function (t, i) {
                  if (e._state.openComplete) return i(new X.DatabaseClosed(e._state.dbOpenError));
                  if (!e._state.isBeingOpened) {
                    if (!e._state.autoOpen) return void i(new X.DatabaseClosed());
                    e.open().catch(J);
                  }
                  e._state.dbReadyPromise.then(t, i);
                }).then(t);
          }),
          (t.prototype.use = function (t) {
            var e = t.stack,
              i = t.create,
              s = t.level,
              n = t.name;
            n && this.unuse({ stack: e, name: n });
            var r = this._middlewares[e] || (this._middlewares[e] = []);
            return (
              r.push({ stack: e, create: i, level: null == s ? 10 : s, name: n }),
              r.sort(function (t, e) {
                return t.level - e.level;
              }),
              this
            );
          }),
          (t.prototype.unuse = function (t) {
            var e = t.stack,
              i = t.name,
              s = t.create;
            return (
              e &&
                this._middlewares[e] &&
                (this._middlewares[e] = this._middlewares[e].filter(function (t) {
                  return s ? t.create !== s : !!i && t.name !== i;
                })),
              this
            );
          }),
          (t.prototype.open = function () {
            var t = this;
            return se(Ct, function () {
              return qi(t);
            });
          }),
          (t.prototype._close = function () {
            var t = this._state,
              e = fe.indexOf(this);
            if ((e >= 0 && fe.splice(e, 1), this.idbdb)) {
              try {
                this.idbdb.close();
              } catch (t) {}
              this.idbdb = null;
            }
            t.isBeingOpened ||
              ((t.dbReadyPromise = new Pt(function (e) {
                t.dbReadyResolve = e;
              })),
              (t.openCanceller = new Pt(function (e, i) {
                t.cancelOpen = i;
              })));
          }),
          (t.prototype.close = function (t) {
            var e = (void 0 === t ? { disableAutoOpen: !0 } : t).disableAutoOpen,
              i = this._state;
            e
              ? (i.isBeingOpened && i.cancelOpen(new X.DatabaseClosed()),
                this._close(),
                (i.autoOpen = !1),
                (i.dbOpenError = new X.DatabaseClosed()))
              : (this._close(),
                (i.autoOpen = this._options.autoOpen || i.isBeingOpened),
                (i.openComplete = !1),
                (i.dbOpenError = null));
          }),
          (t.prototype.delete = function (t) {
            var e = this;
            void 0 === t && (t = { disableAutoOpen: !0 });
            var i = arguments.length > 0 && 'object' != typeof arguments[0],
              s = this._state;
            return new Pt(function (n, r) {
              var a = function () {
                e.close(t);
                var i = e._deps.indexedDB.deleteDatabase(e.name);
                ((i.onsuccess = qt(function () {
                  (!(function (t, e) {
                    var i = t.indexedDB,
                      s = t.IDBKeyRange;
                    !Mi(i) && e !== pe && Si(i, s).delete(e).catch(J);
                  })(e._deps, e.name),
                    n());
                })),
                  (i.onerror = Ge(r)),
                  (i.onblocked = e._fireOnBlocked));
              };
              if (i) throw new X.InvalidArgument('Invalid closeOptions argument to db.delete()');
              s.isBeingOpened ? s.dbReadyPromise.then(a) : a();
            });
          }),
          (t.prototype.backendDB = function () {
            return this.idbdb;
          }),
          (t.prototype.isOpen = function () {
            return null !== this.idbdb;
          }),
          (t.prototype.hasBeenClosed = function () {
            var t = this._state.dbOpenError;
            return t && 'DatabaseClosed' === t.name;
          }),
          (t.prototype.hasFailed = function () {
            return null !== this._state.dbOpenError;
          }),
          (t.prototype.dynamicallyOpened = function () {
            return this._state.autoSchema;
          }),
          Object.defineProperty(t.prototype, 'tables', {
            get: function () {
              var t = this;
              return n(this._allTables).map(function (e) {
                return t._allTables[e];
              });
            },
            enumerable: !1,
            configurable: !0,
          }),
          (t.prototype.transaction = function () {
            var t = Ui.apply(this, arguments);
            return this._transaction.apply(this, t);
          }),
          (t.prototype._transaction = function (t, e, i) {
            var s = this,
              n = Et.trans;
            (n && n.db === this && -1 === t.indexOf('!')) || (n = null);
            var r,
              a,
              o = -1 !== t.indexOf('?');
            t = t.replace('!', '').replace('?', '');
            try {
              if (
                ((a = e.map(function (t) {
                  var e = t instanceof s.Table ? t.name : t;
                  if ('string' != typeof e)
                    throw new TypeError(
                      'Invalid table argument to Dexie.transaction(). Only Table or String are allowed',
                    );
                  return e;
                })),
                'r' == t || t === me)
              )
                r = me;
              else {
                if ('rw' != t && t != ge) throw new X.InvalidArgument('Invalid transaction mode: ' + t);
                r = ge;
              }
              if (n) {
                if (n.mode === me && r === ge) {
                  if (!o)
                    throw new X.SubTransaction(
                      'Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY',
                    );
                  n = null;
                }
                (n &&
                  a.forEach(function (t) {
                    if (n && -1 === n.storeNames.indexOf(t)) {
                      if (!o) throw new X.SubTransaction('Table ' + t + ' not included in parent transaction.');
                      n = null;
                    }
                  }),
                  o && n && !n.active && (n = null));
              }
            } catch (t) {
              return n
                ? n._promise(null, function (e, i) {
                    i(t);
                  })
                : ae(t);
            }
            var h = Ki.bind(null, this, r, a, n, i);
            return n
              ? n._promise(r, h, 'lock')
              : Et.trans
                ? se(Et.transless, function () {
                    return s._whenReady(h);
                  })
                : this._whenReady(h);
          }),
          (t.prototype.table = function (t) {
            if (!l(this._allTables, t)) throw new X.InvalidTable('Table '.concat(t, ' does not exist'));
            return this._allTables[t];
          }),
          t
        );
      })(),
      ds = 'undefined' != typeof Symbol && 'observable' in Symbol ? Symbol.observable : '@@observable',
      fs = (function () {
        function t(t) {
          this._subscribe = t;
        }
        return (
          (t.prototype.subscribe = function (t, e, i) {
            return this._subscribe(t && 'function' != typeof t ? t : { next: t, error: e, complete: i });
          }),
          (t.prototype[ds] = function () {
            return this;
          }),
          t
        );
      })();
    try {
      cs = {
        indexedDB: s.indexedDB || s.mozIndexedDB || s.webkitIndexedDB || s.msIndexedDB,
        IDBKeyRange: s.IDBKeyRange || s.webkitIDBKeyRange,
      };
    } catch (t) {
      cs = { indexedDB: null, IDBKeyRange: null };
    }
    function ps(t) {
      var e,
        i = !1,
        s = new fs(function (s) {
          var n = O(t);
          var r,
            a = !1,
            o = {},
            h = {},
            c = {
              get closed() {
                return a;
              },
              unsubscribe: function () {
                a || ((a = !0), r && r.abort(), u && Ye.storagemutated.unsubscribe(f));
              },
            };
          s.start && s.start(c);
          var u = !1,
            d = function () {
              return re(p);
            };
          var f = function (t) {
              (Ni(o, t), Bi(h, o) && d());
            },
            p = function () {
              if (!a && cs.indexedDB) {
                o = {};
                var c = {};
                (r && r.abort(), (r = new AbortController()));
                var p = { subscr: c, signal: r.signal, requery: d, querier: t, trans: null },
                  m = (function (e) {
                    var i = Lt();
                    try {
                      n && Yt();
                      var s = Xt(t, e);
                      return (n && (s = s.finally(Zt)), s);
                    } finally {
                      i && Ot();
                    }
                  })(p);
                Promise.resolve(m).then(
                  function (t) {
                    ((i = !0),
                      (e = t),
                      a ||
                        p.signal.aborted ||
                        ((o = {}),
                        (function (t) {
                          for (var e in t) if (l(t, e)) return !1;
                          return !0;
                        })((h = c)) ||
                          u ||
                          (Ye(Qe, f), (u = !0)),
                        re(function () {
                          return !a && s.next && s.next(t);
                        })));
                  },
                  function (t) {
                    ((i = !1),
                      ['DatabaseClosedError', 'AbortError'].includes(null == t ? void 0 : t.name) ||
                        a ||
                        re(function () {
                          a || (s.error && s.error(t));
                        }));
                  },
                );
              }
            };
          return (setTimeout(d, 0), c);
        });
      return (
        (s.hasValue = function () {
          return i;
        }),
        (s.getValue = function () {
          return e;
        }),
        s
      );
    }
    var ms = us;
    function gs(t) {
      var e = xs;
      try {
        ((xs = !0), Ye.storagemutated.fire(t), Hi(t, !0));
      } finally {
        xs = e;
      }
    }
    (c(
      ms,
      e(e({}, Z), {
        delete: function (t) {
          return new ms(t, { addons: [] }).delete();
        },
        exists: function (t) {
          return new ms(t, { addons: [] })
            .open()
            .then(function (t) {
              return (t.close(), !0);
            })
            .catch('NoSuchDatabaseError', function () {
              return !1;
            });
        },
        getDatabaseNames: function (t) {
          try {
            return (function (t) {
              var e = t.indexedDB,
                i = t.IDBKeyRange;
              return Mi(e)
                ? Promise.resolve(e.databases()).then(function (t) {
                    return t
                      .map(function (t) {
                        return t.name;
                      })
                      .filter(function (t) {
                        return t !== pe;
                      });
                  })
                : Si(e, i).toCollection().primaryKeys();
            })(ms.dependencies).then(t);
          } catch (t) {
            return ae(new X.MissingAPI());
          }
        },
        defineClass: function () {
          return function (t) {
            a(this, t);
          };
        },
        ignoreTransaction: function (t) {
          return Et.trans ? se(Et.transless, t) : t();
        },
        vip: Ci,
        async: function (t) {
          return function () {
            try {
              var e = Vi(t.apply(this, arguments));
              return e && 'function' == typeof e.then ? e : Pt.resolve(e);
            } catch (t) {
              return ae(t);
            }
          };
        },
        spawn: function (t, e, i) {
          try {
            var s = Vi(t.apply(i, e || []));
            return s && 'function' == typeof s.then ? s : Pt.resolve(s);
          } catch (t) {
            return ae(t);
          }
        },
        currentTransaction: {
          get: function () {
            return Et.trans || null;
          },
        },
        waitFor: function (t, e) {
          var i = Pt.resolve('function' == typeof t ? ms.ignoreTransaction(t) : t).timeout(e || 6e4);
          return Et.trans ? Et.trans.waitFor(i) : i;
        },
        Promise: Pt,
        debug: {
          get: function () {
            return ot;
          },
          set: function (t) {
            ht(t);
          },
        },
        derive: f,
        extend: a,
        props: c,
        override: x,
        Events: Ee,
        on: Ye,
        liveQuery: ps,
        extendObservabilitySet: Ni,
        getByKeyPath: w,
        setByKeyPath: S,
        delByKeyPath: function (t, e) {
          'string' == typeof e
            ? S(t, e, void 0)
            : 'length' in e &&
              [].map.call(e, function (e) {
                S(t, e, void 0);
              });
        },
        shallowClone: M,
        deepClone: T,
        getObjectDiff: Qi,
        cmp: we,
        asap: b,
        minKey: ce,
        addons: [],
        connections: fe,
        errnames: W,
        dependencies: cs,
        cache: ki,
        semVer: he,
        version: he
          .split('.')
          .map(function (t) {
            return parseInt(t);
          })
          .reduce(function (t, e, i) {
            return t + e / Math.pow(10, 2 * i);
          }),
      }),
    ),
      (ms.maxKey = ei(ms.dependencies.IDBKeyRange)),
      'undefined' != typeof dispatchEvent &&
        'undefined' != typeof addEventListener &&
        (Ye(Qe, function (t) {
          var e;
          xs || ((e = new CustomEvent(Xe, { detail: t })), (xs = !0), dispatchEvent(e), (xs = !1));
        }),
        addEventListener(Xe, function (t) {
          var e = t.detail;
          xs || gs(e);
        })));
    var ys,
      xs = !1,
      vs = function () {};
    return (
      'undefined' != typeof BroadcastChannel &&
        ((vs = function () {
          (ys = new BroadcastChannel(Xe)).onmessage = function (t) {
            return t.data && gs(t.data);
          };
        })(),
        'function' == typeof ys.unref && ys.unref(),
        Ye(Qe, function (t) {
          xs || ys.postMessage(t);
        })),
      'undefined' != typeof addEventListener &&
        (addEventListener('pagehide', function (t) {
          if (!us.disableBfCache && t.persisted) {
            (ot && console.debug('Dexie: handling persisted pagehide'), null == ys || ys.close());
            for (var e = 0, i = fe; e < i.length; e++) {
              i[e].close({ disableAutoOpen: !1 });
            }
          }
        }),
        addEventListener('pageshow', function (t) {
          !us.disableBfCache &&
            t.persisted &&
            (ot && console.debug('Dexie: handling persisted pageshow'), vs(), gs({ all: new Ai(-1 / 0, [[]]) }));
        })),
      (Pt.rejectionMapper = function (t, e) {
        if (!t || t instanceof V || t instanceof TypeError || t instanceof SyntaxError || !t.name || !Y[t.name])
          return t;
        var i = new Y[t.name](e || t.message, t);
        return (
          'stack' in t &&
            d(i, 'stack', {
              get: function () {
                return this.inner.stack;
              },
            }),
          i
        );
      }),
      ht(ot),
      e(
        us,
        Object.freeze({
          __proto__: null,
          Dexie: us,
          liveQuery: ps,
          Entity: be,
          cmp: we,
          PropModification: Ne,
          replacePrefix: function (t, e) {
            return new Ne({ replacePrefix: [t, e] });
          },
          add: function (t) {
            return new Ne({ add: t });
          },
          remove: function (t) {
            return new Ne({ remove: t });
          },
          default: us,
          RangeSet: Ai,
          mergeRanges: Pi,
          rangesOverlap: Ti,
        }),
        { default: us },
      ),
      us
    );
  })();
  function c(t) {
    try {
      return self.LCC_DB[t] || self.LCC_DB.table(t);
    } catch (t) {
      return;
    }
  }
  const u = t.data.accessType;
  var d;
  ((d = t.data),
  t.data.verno,
  self.LCC_DB || (self.LCC_DB = i = new l(e)),
  new Promise(async (t, s) => {
    try {
      if (d && d.accessType === r) {
        const { index: s, guid: n, accessType: r, libType: a, renderID: o } = d,
          {
            dataAlias: l,
            shcoefAlias: u,
            indexAlias: f,
            envAlias: p,
            collAlias: m,
            semAlias: g,
            lutScaleAlias: y,
            lutSHAlias: x,
            dataIndexAlias: v,
            shcoefIndexAlias: b,
            collIndexAlias: w,
            envIndexAlias: S,
            semIndexAlias: M,
            lutScaleIndexAlias: C,
            lutSHIndexAlias: E,
          } = (function (t, e) {
            const i = `${t}_${e}_data`,
              s = `${t}_${e}_shcoef`,
              n = `${t}_${e}_environment`,
              r = `${t}_${e}_collision`,
              a = `${t}_${e}_semantic`,
              o = `${t}_${e}_lutscale`,
              h = `${t}_${e}_lutsh`;
            return {
              dataAlias: i,
              shcoefAlias: s,
              indexAlias: `${t}_${e}_index`,
              envAlias: n,
              collAlias: r,
              semAlias: a,
              lutScaleAlias: o,
              lutSHAlias: h,
              dataIndexAlias: `${i}_index`,
              shcoefIndexAlias: `${s}_index`,
              collIndexAlias: `${r}_index`,
              envIndexAlias: `${n}_index`,
              semIndexAlias: `${a}_index`,
              lutScaleIndexAlias: `${o}_index`,
              lutSHIndexAlias: `${h}_index`,
            };
          })(n, a),
          D = await new Promise((t, i) => {
            const s = indexedDB.open(e);
            ((s.onsuccess = (e) => {
              const i = e.target.result,
                s = i.version,
                n = Array.from(i.objectStoreNames).filter((t) => t.indexOf('_0_') > -1 || t.indexOf('_1_') > -1);
              (i.close(), t({ version: s, storeNames: n }));
            }),
              (s.onerror = (t) => {
                i(t.target.error);
              }));
          }),
          A = D.storeNames.includes(l);
        await i.open();
        let F = {},
          P = [...D.storeNames],
          T = self.LCC_DB.verno || D.version / 10;
        A ||
          (P.push(l, u, f, p, m, v, b, w, S),
          (T += 1),
          P.forEach((t) => {
            F[t] = 'id';
          }),
          await i.close(),
          i.version(T).stores(F),
          await i.open(),
          console.log('update database version to:', i.verno));
        const I = await c(v)?.toCollection().primaryKeys(),
          _ = await c(b)?.toCollection().primaryKeys(),
          R = await c(w)?.toCollection().primaryKeys(),
          N = await c(p)?.get(h);
        let B, k, z;
        await c(f).put({ id: h, timestamp: Date.now() });
        let L = [];
        const O = [N, k, z];
        for (const t of O)
          t &&
            Object.values(t).forEach((t) => {
              const e = t?.buffer || t;
              e instanceof ArrayBuffer && L.push(e);
            });
        let H = { [l]: new Set(I), [u]: new Set(_), [m]: new Set(R), [g]: new Set(B), [y]: k, [x]: z, [p]: N };
        (postMessage({ index: s, guid: n, renderID: o, accessType: r, verno: i.verno, isCompleted: !0, indexes: H }, L),
          t());
      } else (self.LCC_DB.isOpen() || (await i.open()), t());
    } catch (t) {
      (console.error(t), s(!1));
    }
  }))
    .then(() => {
      if (s === u)
        !(async function ({ index: t, accessType: e, guid: s, payloads: n }) {
          let r = 0;
          const a = new Map();
          for (let t = 0; t < n.length; t++) {
            const e = n[t],
              { tablename: i, tid: s } = e;
            if (((r += e.size), a.has(i))) a.get(i).set(s, e);
            else {
              const t = new Map();
              (t.set(s, e), a.set(i, t));
            }
          }
          const o = [];
          let h = [];
          (Array.from(a.entries()).forEach(([t, e]) =>
            h.push(
              new Promise(async (s, n) => {
                i.transaction('r', t, async () => {
                  ((await c(t).bulkGet([...e.keys()])).forEach((t) => {
                    let i = e.get(t.id);
                    (i && (i.data = t),
                      Object.values(t).forEach((t) => {
                        const e = t?.buffer || t;
                        e instanceof ArrayBuffer && o.push(e);
                      }));
                  }),
                    s());
                });
              }),
            ),
          ),
            await Promise.allSettled(h),
            postMessage({ index: t, guid: s, accessType: e, isCompleted: !0, payloads: n }, o));
        })(t.data);
      else if (n === u) {
        const e = t.data.tablename;
        if (!e) return;
        !(async function (t, e) {
          const i = e.data,
            s = e.ids;
          try {
            let n;
            if (
              (await c(t).bulkPut(i),
              t.indexOf('environment') > -1 || t.indexOf('lutscale') > -1 || t.indexOf('lutsh') > -1)
            ) {
              const e = await c(t).get(h);
              n = { [t]: e };
            } else {
              const e = `${t}_index`;
              await c(e).bulkPut(s);
              const i = await c(e).toCollection().primaryKeys();
              n = { [t]: new Set(i) };
            }
            const r = [];
            (i.forEach((t) => {
              Object.values(t).forEach((t) => {
                const e = t?.buffer || t;
                e instanceof ArrayBuffer && r.push(e);
              });
            }),
              Object.values(n).forEach((t) => {
                const e = t?.buffer || t;
                e instanceof ArrayBuffer && r.push(e);
              }),
              (e.indexes = n),
              (e.ids = null),
              postMessage(e, [...new Set(r)]));
          } catch (t) {
            console.error('writeDB error: ', t);
            const s = [];
            (i.forEach((t) => {
              Object.values(t).forEach((t) => {
                const e = t?.buffer || t;
                e instanceof ArrayBuffer && s.push(e);
              });
            }),
              (e.indexes = {}),
              (e.ids = null),
              postMessage(e, [...new Set(s)]));
          }
        })(e, t.data);
      } else
        a === u
          ? (async function (t) {
              let e = [];
              (self.LCC_DB.tables.forEach((t) => {
                e.push(t.clear());
              }),
                await Promise.all(e),
                postMessage({ isClear: !0, ...t }));
            })(t.data)
          : o === u &&
            (async function (t) {
              const e = t.guid,
                i = t.indexDBCacheThreshold || 4294967296;
              let s = [],
                n = [];
              const r = new Map();
              self.LCC_DB.tables.forEach((t) => {
                const i = t.name.split('_');
                if (e === i[0]) return;
                'index' === i[3]
                  ? (n.push(t.name), s.push(t.toCollection().primaryKeys()))
                  : 'index' === i[2] && (n.push(t.name), s.push(t.toCollection().first()));
                const a = i[0] + '_' + i[1];
                r.has(a) ? r.get(a).tables.push(t) : r.set(a, { totalSize: 0, prefix: a, tables: [t] });
              });
              const a = await Promise.all(s);
              let o = 0;
              for (let t = 0; t < n.length; t++) {
                const e = n[t],
                  i = e.split('_'),
                  s = i[0] + '_' + i[1],
                  h = r.get(s),
                  l = a[t];
                if (l instanceof Array) {
                  const t = l.reduce((t, e) => {
                    const [i, s] = e.split('-');
                    return t + (Number(s) - Number(i));
                  }, 0);
                  ((h[e] = t), (h.totalSize += t), (o += t));
                } else h.timestamp = l?.timestamp || 0;
              }
              if (o < i) return;
              let h = [...r.values()].filter((t) => t.totalSize > 0);
              h.sort((t, e) => t.timestamp - e.timestamp);
              let l = [];
              for (let t = 0; t < h.length; t++) {
                const e = h[t];
                if (
                  (e.tables.forEach((t) => {
                    l.push(t.clear());
                  }),
                  (o -= e.totalSize),
                  o < i)
                )
                  break;
              }
              await Promise.all(l);
            })(t.data);
    })
    .catch((t) => {
      console.log('check db ', t);
    });
}
class Ce {
  constructor() {}
  id;
  data;
  timestamp;
  toTable() {
    return { ...this };
  }
}
class Ee extends Ce {
  constructor() {
    super();
  }
  vertexes;
  faces;
  bvh;
}
class De extends Ce {
  constructor() {
    super();
  }
  pos;
}
class Ae extends Ce {
  constructor() {
    super();
  }
  sh;
  pos;
  index;
}
class Fe {
  constructor() {}
  tablename;
  accessType;
  dataType;
  data;
  buffers;
  isDecompressed;
  callback;
}
class Pe {
  constructor() {}
  accessType = Te.WRITE;
  tables = [];
  ids = [];
  buffers = [];
  cacheParams = [];
  put(t) {
    (this.tables.push(t.data),
      this.ids.push({ id: t.data.id }),
      this.buffers.push(...t.buffers),
      this.cacheParams.push(t));
  }
  toTables() {
    return { tables: this.tables, ids: this.ids, buffers: [...new Set(this.buffers)] };
  }
  getCacheParams(t) {
    return this.cacheParams[t];
  }
}
const Te = { READ: 1, WRITE: 2, CHECK: 3, CLEAR: 4 };
class Ie {
  enabled = !0;
  #f = !1;
  #st;
  isInitialized = !1;
  isSupported = !1;
  #nt = {};
  #rt = {};
  #at = new Set();
  #ot = new Set();
  #ht = 0;
  #lt = [];
  #ct = [];
  #ut = [];
  #dt = 0;
  #ft = !0;
  #pt;
  #mt = new Map();
  #gt;
  #yt = !0;
  #xt = 0;
  #K;
  #G;
  #vt;
  #bt = [];
  libType;
  isEncrypted = !1;
  #wt = 0;
  constructor(t, e = 2, i, s, n, r) {
    ((this.libType = t),
      (this.#K = i),
      (this.#G = s),
      (this.#vt = n),
      this.#St()
        .then((t) => {
          ((this.isSupported = t),
            (this.isInitialized = !0),
            this.isSupported
              ? (this.#Mt(e), this.initialIndexDB(), console.log('IndexDB is supported !'))
              : console.log('IndexDB is unsupported !'));
        })
        .catch((t) => {
          console.log('Error during detection: ', t);
        }));
  }
  dispose() {
    ((this.isSupported = !1),
      (this.#f = !0),
      this.#lt.forEach((t) => {
        t.terminate();
      }),
      (this.#lt = []),
      (this.#ht = 0),
      (this.#ft = !1),
      this.#pt.terminate(),
      (this.#gt = void 0),
      (this.#yt = !0));
  }
  #St() {
    return new Promise((t, e) => {
      if (!window.indexedDB) return (console.log('This browser does not support IndexedDB !'), void t(!1));
      const i = 'test_lcc_db';
      let s;
      const n = window.indexedDB.open(i, 1);
      ((n.onupgradeneeded = function (t) {
        ((s = t.target.result), s.createObjectStore('testStore', { keyPath: 'id' }));
      }),
        (n.onsuccess = function (e) {
          (t(!0), (s = e.target.result), s.close());
          const n = window.indexedDB.deleteDatabase(i);
          ((n.onsuccess = function () {}),
            (n.onerror = function () {
              console.warn('test_lcc_db delete failure !');
            }));
        }),
        (n.onerror = function (e) {
          (console.log('Indexdb can not open !', e.target.error), t(!1));
        }));
    });
  }
  setMaxIndexDBCacheSize(t) {
    this.#st = t;
  }
  initialIndexDB(t, e, i) {
    if ((console.log('initial indexdb: ', this.enabled, t), this.enabled)) {
      if (t && !this.#rt[t]) {
        this.#rt[t] = { checked: !1, renderID: e };
        const s = { guid: t, renderID: e, accessType: Te.CHECK, callback: i };
        this.#bt.push(s);
      }
      if (this.isInitialized && !this.isSupported)
        return (
          this.#bt.forEach((t) => {
            (this.#rt[t.guid] && (this.#rt[t.guid].checked = !0), t.callback && t.callback(!1));
          }),
          void (this.#bt = [])
        );
      !this.isInitialized ||
        this.#bt.length < 1 ||
        (this.#ct.unshift(...this.#bt), (this.#bt = []), this.#ft && this.#Ct());
    } else i && i(!1);
  }
  #Et() {
    if (!this.enabled) return;
    if (this.#at.size < 1) return;
    let t = this.#at;
    ((this.#at = this.#ot), (this.#ot = t));
    let r = 0;
    for (const a of t) {
      const [t, c, u, d, f] = a.split('&'),
        p = Number(u);
      if (p === e) {
        if (r > 1) {
          this.#at.add(a);
          continue;
        }
        let e = this.#K.queryOne(t, c, !1);
        if (!e || !e.pos || !e.data) {
          this.#at.add(a);
          continue;
        }
        let i = { id: f, tablename: d, dataType: p, data: e.data.slice(), pos: e.pos.slice(), isDecompressed: !0 };
        (this.putCache(i, (t, e) => {}), r++);
      } else if (p === i) {
        if (r > 1) {
          this.#at.add(a);
          continue;
        }
        let e = this.#K.queryOne(t, c, !1);
        if (!e || !e.sh) {
          this.#at.add(a);
          continue;
        }
        let i = { id: f, tablename: d, dataType: p, data: e.sh.slice(), isDecompressed: !0 };
        (this.putCache(i, (t) => {}), r++);
      } else if (p === l) {
        if (r > 1) {
          this.#at.add(a);
          continue;
        }
        let e = this.#K.queryOne(t, c, !1);
        if (!e || !e.sem) {
          this.#at.add(a);
          continue;
        }
        let i = { id: f, tablename: d, dataType: p, data: e.sem.slice(), isDecompressed: !0 };
        (this.putCache(i, (t) => {}), r++);
      } else if (p === n) {
        let e = this.#vt.queryData(t, c, !1);
        if (!(e && e.vertexes && e.faces && e.bvh)) {
          this.#at.add(a);
          continue;
        }
        let i = e.vertexes?.slice(),
          s = e.faces?.slice(),
          n = e.bvh?.slice();
        this.putCache(
          { id: f, tablename: d, dataType: p, vertexes: i, faces: s, bvh: n, isDecompressed: !0 },
          () => {},
        );
      } else if (p === s) {
        if (!this.#G.queryEnv(t)) {
          this.#at.add(a);
          continue;
        }
        {
          let e = this.#K.queryEnv(t);
          const i = { id: f, tablename: d, dataType: p, data: e.data, pos: e.pos, sh: e.sh, isDecompressed: !0 };
          (this.putCache(i, (e, i, s) => {
            let n = this.#K.queryEnv(t);
            n && ((n.data = e), (n.pos = i), (n.sh = s));
          }),
            (e = null));
        }
      } else if (p === o || p === h) {
        const e = this.#K.queryLut(t, p),
          i = this.#K.getLutTransferFlag(t, p);
        if (!e || !i) {
          this.#at.add(a);
          continue;
        }
        {
          const t = { id: f, tablename: d, dataType: p, data: e.data, isDecompressed: !0 };
          this.putCache(t, (t) => {});
        }
      }
    }
    this.#ot.clear();
  }
  #Mt(t) {
    for (let e = 0; e < t; ++e) {
      const t = we(Me);
      t ? (this.#lt.push(t), this.#ht++) : console.error('create worker failed !!!');
    }
    (this.#lt.forEach((t) => {
      t.onmessage = (t) => {
        if (this.#f) return;
        let e = !0;
        if (Te.WRITE === t.data.accessType) return void this.#Dt(this.#gt, t);
        const i = t.data.index,
          s = this.#ut[i];
        this.#ut[i] = void 0;
        const n = t.data.accessType || s.accessType;
        if (Te.READ === n) e = this.#At(s, t);
        else if (Te.CHECK === n) {
          ((e = !0), (this.#xt = t.data.verno));
          const i = t.data.indexes;
          if (i) {
            let t = Object.keys(i);
            for (let e = 0; e < t.length; e++) this.#nt[t[e]] = i[t[e]];
          }
          (this.#rt[s.guid] && (this.#rt[s.guid].checked = !0),
            console.log('init indexdb finished !'),
            s.callback && s.callback(!0));
        } else Te.CLEAR === n && console.log('Indexdb clear success!');
        e && (this.#dt++, this.#dt >= this.#ut.length && (this.#ft = !0));
      };
    }),
      (this.#pt = this.#lt.pop()),
      (this.#ht = this.#lt.length),
      (this.#dt = this.#ht));
  }
  #Ct() {
    if (!this.enabled || !this.isSupported || !this.#ft || this.#ct.length < 1) return;
    const t = this.#ht;
    for (let e = 0; e < t && !(this.#ct.length < 1); e++) {
      const t = e;
      if (this.#ut[t]) continue;
      const i = (this.#ut[t] = this.#ct.shift()),
        s = this.#lt[t],
        n = i.accessType;
      let r,
        a = [];
      (Te.READ === n
        ? (r = { index: e, accessType: n, guid: i.guid, payloads: i.payloads })
        : Te.CHECK === n
          ? (r = { index: e, guid: i.guid, renderID: i.renderID, accessType: n })
          : Te.CLEAR === n && (r = { index: e, accessType: n }),
        r && ((r.verno = this.#xt), (r.libType = this.libType), s.postMessage(r, a), this.#dt--));
    }
    this.#ft = this.#dt > 0;
  }
  #Ft() {
    if (this.isSupported && this.#yt && this.#mt.size > 0) {
      this.#yt = !1;
      const [t, e] = this.#mt.entries().next().value;
      this.#mt.delete(t);
      const i = (this.#gt = e).accessType;
      if (Te.WRITE === i) {
        const { tables: s, ids: n, buffers: r } = e.toTables();
        let a = { index: 0, accessType: i, tablename: t, data: s, ids: n };
        a.verno = this.#xt;
        try {
          this.#pt.postMessage(a, r);
        } catch (t) {
          console.error(t);
        }
      }
    }
  }
  update(t) {
    !this.#f &&
      this.isSupported &&
      this.enabled &&
      (t % 5 == 0 && this.#Et(), t - this.#wt > 500 && (this.#Ft(), (this.#wt = t)), this.#Ct());
  }
  putCacheWithDelay(t, e, i, s, n) {
    this.enabled && this.#at.add(`${i}&${s}&${n}&${t}&${e}`);
  }
  putCache(t, r) {
    const a = t.dataType;
    let c = new Fe();
    ((c.accessType = Te.WRITE),
      (c.tablename = t.tablename),
      (c.dataType = t.dataType),
      (c.isDecompressed = !(!1 !== this.isEncrypted)));
    let u,
      d = this.#mt.get(c.tablename);
    d || ((d = new Pe()), this.#mt.set(c.tablename, d));
    let f = [];
    return (
      e === a
        ? ((u = new De()), (u.data = t.data), (u.pos = t.pos), f.push(t.data?.buffer || t.data, u.pos?.buffer))
        : i === a || l === a || o === a || h === a
          ? ((u = new Ce()), (u.data = t.data), f.push(u.data?.buffer || u.data))
          : n === a
            ? ((u = new Ee()),
              (u.data = t.data),
              f.push(t.data?.buffer || t.data),
              this.isEncrypted ||
                ((u.vertexes = t.vertexes),
                (u.faces = t.faces),
                (u.bvh = t.bvh),
                f.push(u.vertexes?.buffer, u.faces?.buffer, u.bvh?.buffer)))
            : s === a &&
              ((u = new Ae()),
              (u.data = t.data),
              f.push(t.data?.buffer || t.data),
              this.isEncrypted ||
                ((u.pos = t.pos), (u.sh = t.sh), f.push(t.sh?.buffer || t.sh, t.pos?.buffer || t.pos))),
      u &&
        ((u.id = t.id),
        (u.timestamp = Date.now()),
        (c.data = u.toTable()),
        (c.buffers = f.filter((t) => !!t)),
        (c.callback = r),
        d.put(c)),
      !0
    );
  }
  getCache({ guid: t, payloads: e }, i) {
    const s = { guid: t, accessType: Te.READ, payloads: e, cacheCallback: i };
    return (this.#ct.push(s), this.#ft && this.#Ct(), !0);
  }
  #At(t, e) {
    const { index: i, guid: s, accessType: n, payloads: r, isCompleted: a } = e.data;
    return (
      'function' == typeof t.cacheCallback
        ? t.cacheCallback(e)
        : console.error('payloads cacheCallback is undefined !'),
      a
    );
  }
  #Dt(t, r) {
    const { data: a, indexes: c } = r.data;
    for (let r = 0; r < a.length; r++) {
      const c = a[r],
        u = t.getCacheParams(r);
      if (u.dataType === e)
        if (this.isEncrypted) {
          const { data: t } = c;
          u.callback && u.callback(t);
        } else {
          const { data: t, pos: e } = c;
          u.callback && u.callback(t, e, void 0);
        }
      else if (u.dataType === s)
        if (this.isEncrypted) {
          const { data: t } = c;
          u.callback && u.callback(t);
        } else {
          const { data: t, sh: e, pos: i } = c;
          u.callback && u.callback(t, e, i);
        }
      else if (u.dataType === i) {
        const { data: t } = c;
        u.callback && u.callback(t);
      } else if (u.dataType === l) {
        const { data: t } = c;
        u.callback && u.callback(t);
      } else if (u.dataType === o || u.dataType === h) {
        const { data: t } = c;
        u.callback && u.callback(t);
      } else if (u.dataType === n)
        if (this.isEncrypted) {
          const { data: t } = c;
          u.callback && u.callback(t);
        } else {
          const { vertexes: t, faces: e, bvh: i } = c;
          u.callback && u.callback(t, e, i);
        }
    }
    if (c) {
      const t = Object.keys(c);
      for (let e = 0; e < t.length; e++) {
        const i = t[e];
        this.#nt[i] = c[t[e]];
      }
    }
    return ((this.#yt = !0), !0);
  }
  clearLCCIndexDB() {
    if ((console.log('clear index db'), !this.enabled || this.#f)) return;
    const t = { accessType: Te.CLEAR };
    this.#pt.postMessage(t);
  }
  unload(t) {
    this.#at.forEach((e) => {
      0 === e.indexOf(`${t}&`) && this.#at.delete(e);
    });
    const e = {};
    for (let i in this.#rt) {
      const s = this.#rt[i];
      s?.renderID !== t && (e[i] = s);
    }
    this.#rt = e;
  }
  checkDataExist(t, e) {
    return this.isSupported && this.#nt[t] && this.#nt[t].has(e);
  }
  getTableName(t, e) {
    const i = c[e];
    return `${t}_${this.libType}_${i}`;
  }
  getSpecialData(t) {
    return this.#nt[t];
  }
}
class _e {
  static GlobalID = 0;
  renderID;
  #Pt;
  cpuCache;
  gpuCache;
  collCache;
  localCacheMgr;
  #M = 32;
  #C = 64;
  isUnit = !0;
  #Tt;
  #It;
  #_t;
  #Rt;
  #h;
  #Nt;
  #Bt;
  #kt;
  #zt;
  #Lt;
  #Ot;
  #Ht;
  #jt;
  #qt = 0;
  #Vt = 0;
  #Ut = 0;
  nodes = [];
  id;
  #Kt;
  sequence;
  initOneNodeExpect = !1;
  initOneNodeReady = !1;
  initAroundLevel = -1;
  #Gt;
  #Wt;
  #Qt;
  #Xt;
  #Yt;
  #Zt;
  #Jt;
  bounding;
  get x() {
    return this.#Ot;
  }
  get y() {
    return this.#Ht;
  }
  get center() {
    return this.#jt;
  }
  get totalPoints() {
    return this.#It;
  }
  get startAddr() {
    return this.#_t;
  }
  get endAddr() {
    return this.#Rt;
  }
  get totalSize() {
    return this.#h;
  }
  get shStartAddr() {
    return this.#Nt;
  }
  get shEndAddr() {
    return this.#Bt;
  }
  get shTotalSize() {
    return this.#kt;
  }
  get distanceToCameraSq() {
    return this.#Vt;
  }
  get distance2dToCameraSq() {
    return this.#Ut;
  }
  get distance3dToCameraSq() {
    return this.#Jt;
  }
  get totalLevel() {
    return this.#qt;
  }
  get coll() {
    return this.#Kt;
  }
  get guid() {
    return this.#Pt?.meta?.guid;
  }
  setBounding(t) {
    this.bounding = t;
  }
  getLastNodePoints() {
    const t = this.nodes[this.nodes.length - 1];
    return t ? t.points : 0;
  }
  setCollInfo(t, e, i, s, n) {
    this.#Kt = new be(t, e, i, s, n, this);
  }
  updateDistanceToCamera(t) {
    this.#Vt = this.#jt.distanceToSquared(t);
    const e = this.#Gt.set(t.x, t.y),
      i = this.#Wt.set(this.#jt.x, this.#jt.y);
    ((this.#Ut = e.distanceToSquared(i)), this.#zt.clampPoint(t, this.#Qt), (this.#Jt = this.#Qt.distanceToSquared(t)));
  }
  getBBox() {
    return this.#zt;
  }
  getQuanBBox() {
    return this.#Lt;
  }
  searchNearestNode(t, e) {
    null == e && (e = this.nodes.length);
    for (let i = t; i < e; ++i) if (this.nodes[i]) return this.nodes[i];
    return null;
  }
  searchNearestNodeInverse(t, e = -1) {
    for (let i = t; i > e; --i) if (this.nodes[i]) return this.nodes[i];
    return null;
  }
  searchNearestNodeExt(t, e = void 0, i = 1, s = 2e7) {
    null == e && (e = this.nodes.length);
    for (let n = t; n < e; ++n) {
      const t = this.nodes[n];
      if (t && t.points <= s && t.points >= i) return t;
    }
    return null;
  }
  searchNearestNodeInverseExt(t, e = -1, i = 1, s = 2e7) {
    for (let n = t; n > e; --n) {
      const t = this.nodes[n];
      if (t && t.points <= s && t.points >= i) return t;
    }
    return null;
  }
  getNodeByLevel(t) {
    return t >= this.nodes.length || t < 0 ? null : this.nodes[t];
  }
  constructor(t, e, i, s, n) {
    ((this.renderID = t),
      (this.#Pt = e),
      (this.cpuCache = e.cpuCache),
      (this.gpuCache = e.gpuCache),
      (this.collCache = e.collCache),
      (this.localCacheMgr = e.localCacheMgr),
      (this.#Gt = new ee()),
      (this.#Wt = new ee()),
      (this.#Qt = new pt()),
      (this.id = _e.GlobalID++),
      (this.#Tt = i),
      (this.#Ot = i.x),
      (this.#Ht = i.y),
      (this.#zt = new ie(s, n)),
      (this.#jt = new pt()),
      this.#zt.getCenter(this.#jt));
    const r = this.#Pt.config.gridDelta;
    this.#Lt = new ie(new pt(s.x - r, s.y - r, s.z), new pt(n.x + r, n.y + r, n.z));
    const a = this.#zt.getSize(new pt());
    ((this.#Xt = 1.414 * a.x),
      (this.#Yt = 0.2 * a.z),
      (this.#Zt = 0.8 * a.z),
      (this.#It = 0),
      (this.#h = 0),
      (this.#_t = BigInt(-1)),
      (this.#qt = i.lods.length));
    for (let t = 0; t < i.lods.length; t++) {
      let s = i.lods[t];
      if (0 == s.points) {
        this.nodes[t] = null;
        continue;
      }
      this.#_t < 0 && (this.#_t = s.offset);
      let n = new te(e.config, s, t, this);
      ((this.nodes[t] = n), (this.#It += s.points), (this.#h += s.size));
    }
    ((this.#Rt = this.#_t + BigInt(this.#h)),
      (this.#kt = this.#It * this.#C),
      (this.#Nt = BigInt((Number(this.#_t) / this.#M) * this.#C)),
      (this.#Bt = this.#Nt + BigInt(this.#kt)));
  }
  dispose() {
    (this.nodes.forEach((t) => {
      t && ((t.parent = null), t.dispose());
    }),
      (this.nodes = []),
      (this.cpuCache = null),
      (this.gpuCache = null),
      (this.#Pt = null),
      this.#Kt?.dispose(),
      (this.#Kt = null));
  }
}
class Re {
  isUnitChunk = !0;
  renderID;
  #$t = [];
  #_t = 0n;
  #Rt = 0n;
  #h = 0;
  #Nt = 0n;
  #Bt = 0n;
  #kt = 0;
  #It = 0;
  #Vt = 0;
  #Ut = 0;
  get startAddr() {
    return this.#_t;
  }
  get endAddr() {
    return this.#Rt;
  }
  get totalSize() {
    return this.#h;
  }
  get shStartAddr() {
    return this.#Nt;
  }
  get shEndAddr() {
    return this.#Bt;
  }
  get shTotalSize() {
    return this.#kt;
  }
  get totalPoints() {
    return this.#It;
  }
  get distanceToCameraSq() {
    return this.#Vt;
  }
  get distance2dToCameraSq() {
    return this.#Ut;
  }
  get allUnits() {
    return this.#$t;
  }
  setDownloading(t, e) {
    this.#$t.forEach((i) => {
      const s = i.nodes;
      for (let i = 0; i < s.length; ++i) s[i] && s[i].setDownloading(t, e);
    });
  }
  setDecompressing(t, e) {
    this.#$t.forEach((i) => {
      const s = i.nodes;
      for (let i = 0; i < s.length; ++i) s[i] && s[i].setDecompressing(t, e);
    });
  }
  constructor(t, e) {
    if (!e || 0 == e.length) throw new Error('units is empty (UnitChunk)');
    ((this.renderID = t),
      (this.#$t = e),
      (this.#_t = e[0].startAddr),
      (this.#Rt = e[e.length - 1].endAddr),
      (this.#h = Number(this.#Rt - this.#_t)),
      (this.#Nt = e[0].shStartAddr),
      (this.#Bt = e[e.length - 1].shEndAddr),
      (this.#kt = Number(this.#Bt - this.#Nt)),
      (this.#Vt = e[0].distanceToCameraSq),
      (this.#Ut = e[0].distance2dToCameraSq),
      e.forEach((t) => {
        ((this.#It += t.totalPoints),
          (this.#Vt = Math.min(this.#Vt, t.distanceToCameraSq)),
          (this.#Ut = Math.min(this.#Ut, t.distance2dToCameraSq)));
      }));
  }
  isLocalCache() {
    return !1;
  }
  getLocalCacheInfo(t) {
    return { id: [], tablename: null };
  }
}
class Ne {
  constructor() {}
  dispose() {
    throw new Error('Must be implemented by subclass');
  }
  update(t) {
    throw new Error('Must be implemented by subclass');
  }
  decompress(t, e, i, s, n, r, a) {
    throw new Error('Must be implemented by subclass');
  }
}
function Be() {
  const t = Math.pow(2, -24),
    e = 32,
    i = 65535,
    s = 25,
    n = 20;
  function r() {
    return { boundingData: new Float32Array(6) };
  }
  function a(t) {
    return 'count' in t ? 1 : 1 + a(t.left) + a(t.right);
  }
  function o(t, e, i, s, n) {
    let r = 1 / 0,
      a = 1 / 0,
      o = 1 / 0,
      h = -1 / 0,
      l = -1 / 0,
      c = -1 / 0,
      u = 1 / 0,
      d = 1 / 0,
      f = 1 / 0,
      p = -1 / 0,
      m = -1 / 0,
      g = -1 / 0;
    for (let s = 6 * e, n = 6 * (e + i); s < n; s += 6) {
      const e = t[s + 0],
        i = t[s + 1],
        n = e - i,
        y = e + i;
      (n < r && (r = n), y > h && (h = y), e < u && (u = e), e > p && (p = e));
      const x = t[s + 2],
        v = t[s + 3],
        b = x - v,
        w = x + v;
      (b < a && (a = b), w > l && (l = w), x < d && (d = x), x > m && (m = x));
      const S = t[s + 4],
        M = t[s + 5],
        C = S - M,
        E = S + M;
      (C < o && (o = C), E > c && (c = E), S < f && (f = S), S > g && (g = S));
    }
    ((s[0] = r),
      (s[1] = a),
      (s[2] = o),
      (s[3] = h),
      (s[4] = l),
      (s[5] = c),
      (n[0] = u),
      (n[1] = d),
      (n[2] = f),
      (n[3] = p),
      (n[4] = m),
      (n[5] = g));
  }
  function h(h, l, c, u) {
    const d = (function (e, i, s) {
        let n = new Float32Array(6 * s);
        for (let r = 0; r < s; ++r) {
          let s = i[3 * r + 0],
            a = i[3 * r + 1],
            o = i[3 * r + 2],
            h = e[3 * s + 0],
            l = e[3 * s + 1],
            c = e[3 * s + 2],
            u = e[3 * a + 0],
            d = e[3 * a + 1],
            f = e[3 * a + 2],
            p = e[3 * o + 0],
            m = e[3 * o + 1],
            g = e[3 * o + 2],
            y = Math.min(h, Math.min(u, p)),
            x = Math.max(h, Math.max(u, p)),
            v = Math.min(l, Math.min(d, m)),
            b = Math.max(l, Math.max(d, m)),
            w = Math.min(c, Math.min(f, g)),
            S = (x - y) / 2,
            M = (b - v) / 2,
            C = (Math.max(c, Math.max(f, g)) - w) / 2;
          ((n[6 * r + 0] = y + S),
            (n[6 * r + 1] = S + (Math.abs(y) + S) * t),
            (n[6 * r + 2] = v + M),
            (n[6 * r + 3] = M + (Math.abs(v) + M) * t),
            (n[6 * r + 4] = w + C),
            (n[6 * r + 5] = C + (Math.abs(w) + C) * t));
        }
        return n;
      })(h, l, u),
      f = (function (t, e, i) {
        const a = r(),
          h = new Float32Array(6);
        return (
          o(t, 0, i, a.boundingData, h),
          (function i(a, l, c, u = null, d = 0) {
            if (c <= n || d >= s) return ((a.offset = l), (a.count = c), a);
            const f = (function (t, e, i, s, n, r) {
              let a = -1,
                o = 0;
              return (
                (a = (function (t) {
                  let e = -1,
                    i = -1 / 0;
                  for (let s = 0; s < 3; s++) {
                    const n = t[s + 3] - t[s];
                    n > i && ((i = n), (e = s));
                  }
                  return e;
                })(e)),
                -1 !== a && (o = (e[a] + e[a + 3]) / 2),
                { axis: a, pos: o }
              );
            })(a.boundingData, u);
            if (-1 === f.axis) return ((a.offset = l), (a.count = c), a);
            const p = (function (t, e, i, s, n) {
              let r = i,
                a = i + s - 1;
              const o = n.pos,
                h = 2 * n.axis;
              for (;;) {
                for (; r <= a && e[6 * r + h] < o; ) r++;
                for (; r <= a && e[6 * a + h] >= o; ) a--;
                if (!(r < a)) return r;
                for (let e = 0; e < 3; e++) {
                  let i = t[3 * r + e];
                  ((t[3 * r + e] = t[3 * a + e]), (t[3 * a + e] = i));
                }
                for (let t = 0; t < 6; t++) {
                  let i = e[6 * r + t];
                  ((e[6 * r + t] = e[6 * a + t]), (e[6 * a + t] = i));
                }
                (r++, a--);
              }
            })(e, t, l, c, f);
            if (p === l || p === l + c) ((a.offset = l), (a.count = c));
            else {
              a.splitAxis = f.axis;
              const e = r(),
                s = l,
                n = p - l;
              ((a.left = e), o(t, s, n, e.boundingData, h), i(e, s, n, h, d + 1));
              const u = r(),
                m = p,
                g = c - n;
              ((a.right = u), o(t, m, g, u.boundingData, h), i(u, m, g, h, d + 1));
            }
            return a;
          })(a, 0, i, h),
          a
        );
      })(d, l, u),
      p = a(f),
      m = new ArrayBuffer(e * p);
    return (
      (function (t, s) {
        let n = new Float32Array(s),
          r = new Uint32Array(s),
          a = new Uint16Array(s);
        (function t(s, o) {
          const h = s / 4,
            l = s / 2,
            c = 'count' in o,
            u = o.boundingData;
          for (let t = 0; t < 6; t++) n[h + t] = u[t];
          if (c) {
            const t = o.offset,
              n = o.count;
            return ((r[h + 6] = t), (a[l + 14] = n), (a[l + 15] = i), s + e);
          }
          {
            const i = o.left,
              n = o.right,
              a = o.splitAxis;
            let l = t(s + e, i);
            return ((r[h + 6] = l / 4), (l = t(l, n)), (r[h + 7] = a), l);
          }
        })(0, t);
      })(f, m),
      m
    );
  }
  self.onmessage = (t) => {
    const e = t.data.index,
      i = t.data.buffer,
      s = t.data.vertexNum,
      n = t.data.faceNum,
      r = t.data.preBvhSize;
    let {
      vertexes: a,
      faces: o,
      bvhBuffer: l,
    } = (function (t, e, i, s) {
      const n = new Float32Array(3 * e),
        r = new Uint32Array(3 * i);
      let a;
      const o = new Uint8Array(t),
        h = new Float32Array(t),
        l = new Uint32Array(t);
      for (let t = 0; t < e; ++t)
        ((n[3 * t + 0] = h[3 * t + 0]), (n[3 * t + 1] = h[3 * t + 1]), (n[3 * t + 2] = h[3 * t + 2]));
      for (let t = 0; t < i; ++t) {
        const i = 3 * (e + t);
        ((r[3 * t + 0] = l[i + 0]), (r[3 * t + 1] = l[i + 1]), (r[3 * t + 2] = l[i + 2]));
      }
      if (s > 16) {
        const t = n.byteLength + r.byteLength + 16,
          e = s - 16;
        let i = new Uint8Array(e);
        for (let s = 0; s < e; ++s) i[s] = o[t + s];
        a = i.buffer;
      }
      return { vertexes: n, faces: r, bvhBuffer: a };
    })(i, s, n, r);
    (l || (l = h(a, o, 0, n)),
      postMessage({ index: e, vertexesBuffer: a.buffer, facesBuffer: o.buffer, bvhBuffer: l }, [
        a.buffer,
        o.buffer,
        l,
      ]));
  };
}
class ke {
  buffer;
  vertexNum;
  faceNum;
  preBvhSize;
  meta;
  renderID;
  callback;
  isDeprecated = !1;
}
class ze {
  #f = !1;
  #ht = 0;
  #lt = [];
  #ct = [];
  #ut = [];
  #ft = !0;
  #te = 0;
  constructor(t = 2) {
    for (let e = 0; e < t; ++e) {
      const t = Se(Be);
      t ? (this.#lt.push(t), this.#ht++) : console.error('create worker failed !!!');
    }
    this.#lt.forEach((t) => {
      t.onmessage = (t) => {
        if (this.#f) return;
        const e = t.data.index,
          i = new Float32Array(t.data.vertexesBuffer),
          s = new Uint32Array(t.data.facesBuffer),
          n = t.data.bvhBuffer,
          r = this.#ut[e];
        (r.isDeprecated || r.callback(i, s, n, r.vertexNum, r.faceNum),
          (this.#ut[e] = void 0),
          this.#te--,
          this.#te < this.#ht && (this.#ft = !0));
      };
    });
  }
  dispose() {
    ((this.#f = !0),
      this.#lt.forEach((t) => {
        t.terminate();
      }),
      (this.#ut = []),
      (this.#ct = []),
      (this.#lt = []),
      (this.#ht = 0),
      (this.#ft = !1));
  }
  #Ct() {
    for (let t = 0; t < this.#ht && 0 !== this.#ct.length; ++t) {
      const e = t;
      if (this.#ut[e]) continue;
      const i = (this.#ut[e] = this.#ct.shift());
      (this.#lt[e].postMessage(
        { index: e, buffer: i.buffer, vertexNum: i.vertexNum, faceNum: i.faceNum, preBvhSize: i.preBvhSize },
        [i.buffer],
      ),
        this.#te++);
    }
    this.#ft = this.#te < this.#ht;
  }
  update(t) {
    this.#f || this.#Ct();
  }
  decompress(t, e, i, s, n, r, a) {
    let o = new ke();
    return (
      (o.renderID = r),
      (o.buffer = t),
      (o.vertexNum = e),
      (o.faceNum = i),
      (o.preBvhSize = s),
      (o.meta = n),
      (o.callback = a),
      this.#ct.push(o),
      this.#ft && this.#Ct(),
      !0
    );
  }
  unload(t) {
    ((this.#ct = this.#ct.filter((e) => e.renderID !== t)),
      this.#ut.forEach((e) => {
        e?.renderID === t && (e.isDeprecated = !0);
      }));
  }
}
function Le(t, e, i, s, n, r, a) {
  return r(e, i, s, n)
    .then((e) => ('function' == typeof a ? a(e, t) : { data: e }))
    .then((t) => {
      if (!t) throw new Error('null data');
      return t;
    })
    .catch((t) => {
      throw (console.error('fetch bin-custom Error:', t), t);
    });
}
function Oe(t, e, i, s, n, r, a) {
  return r(e, i, s, n)
    .then((e) => {
      if (!(e instanceof ArrayBuffer)) throw new Error('fetchFunc must return an ArrayBuffer');
      return 'function' == typeof a ? a(e, t) : { data: e };
    })
    .then((t) => {
      if (!t) throw new Error('null data');
      return new TextDecoder('utf-8').decode(t.data);
    })
    .catch((t) => {
      throw (console.error('fetch text-custom Error:', t), t);
    });
}
class He {
  renderID;
  url;
  filename;
  chunk;
  type;
  cpuCache;
  decompressor;
  collBuilder;
  header;
  offset;
  size;
  meta;
  #ee;
  tablename;
  tid;
  dataSource = g;
  constructor(t, i, s, n, r, a, o, h, l, c, u) {
    if (
      ((this.renderID = t),
      (this.url = s),
      (this.filename = i),
      (this.chunk = n),
      (this.type = r),
      (this.header = a),
      (this.cpuCache = o),
      (this.decompressor = h),
      (this.#ee = u),
      (this.collBuilder = l),
      (this.meta = c),
      this.chunk.isNode
        ? ((this.offset = this.chunk.getOffset(r)), (this.size = this.chunk.getSize(r)))
        : this.chunk.isUnitChunk
          ? ((this.offset = r === e ? this.chunk.startAddr : this.chunk.shStartAddr),
            (this.size = r === e ? this.chunk.totalSize : this.chunk.shTotalSize))
          : this.chunk.isColl
            ? ((this.offset = this.chunk.offset), (this.size = this.chunk.size))
            : console.error('unknow chunk.'),
      (this.dataSource = this.chunk.isLocalCache(this.type) ? y : g),
      this.chunk.isUnitChunk)
    )
      ((this.tablename = this.#ee.getTableName(c.guid, this.type)),
        (this.tid = `${this.offset}-${Number(this.offset) + Number(this.size)}`));
    else {
      const { tablename: t, id: e } = this.chunk.getLocalCacheInfo(this.type);
      ((this.tablename = t), (this.tid = e));
    }
  }
  dispose() {}
  checkDataSource() {
    this.dataSource = this.#ee.checkDataExist(this.tablename, this.tid) ? y : g;
  }
  setDownloadingStart() {
    this.chunk.setDownloading(this.type, !0);
  }
  setDownloadingEnd() {
    this.chunk.setDownloading(this.type, !1);
  }
  setPreprocessStart() {
    this.chunk.setDecompressing(this.type, !0);
  }
  setPreprocessEnd() {
    this.chunk.setDecompressing(this.type, !1);
  }
  setRequestMode(t) {
    this.dataSource = t;
  }
  requestData() {
    return new Promise((t, e) => {
      Zt(this.url, this.offset, this.size)
        .then((e) => {
          t(e);
        })
        .catch(() => {
          t(void 0);
        });
    });
  }
  processPayload(t, e, i = void 0) {
    (this.dataSource === g || i ? this.#ie(t, e) : this.#se(t, e),
      this.dataSource === g && this.#ee.enabled && this.#ne(i));
  }
  #ne(t) {
    if (t)
      if (this.chunk.isUnitChunk) {
        const i = this.chunk.allUnits,
          s = this.type === e ? this.chunk.startAddr : this.chunk.shStartAddr;
        i.forEach((i) => {
          const n = i.nodes;
          n &&
            n.forEach((i) => {
              const n = this.type === e ? i.offset : i.shOffset,
                r = this.type === e ? i.size : i.shSize,
                a = Number(n - s),
                o = t.slice(a, a + r),
                { tablename: h, id: l } = i.getLocalCacheInfo(this.type);
              this.#ee.putCache({ id: l, dataType: this.type, tablename: h, data: o });
            });
        });
      } else this.#ee.putCache({ id: this.tid, dataType: this.type, tablename: this.tablename, data: t });
    else if (this.chunk.isUnitChunk) {
      this.chunk.allUnits.forEach((t) => {
        const e = t.nodes;
        e &&
          e.forEach((t) => {
            const { tablename: e, id: i } = t.getLocalCacheInfo(this.type);
            this.#ee.putCacheWithDelay(e, i, this.renderID, t.id, this.type);
          });
      });
    } else this.#ee.putCacheWithDelay(this.tablename, this.tid, this.renderID, this.chunk.id, this.type);
  }
  #ie(t, s) {
    if (!t) return;
    const r = t.byteLength;
    if (this.chunk.isNode) {
      if (this.type === e)
        if (s) {
          const i = this.chunk.getQuanBBox();
          (this.chunk.setDecompressing(e, !0),
            this.decompressor.decompress(this.type, t, this.size, this.meta, this.renderID, i, (t, i, s) => {
              (this.chunk.setDecompressing(e, !1),
                this.cpuCache.pushData(this.renderID, this.chunk.id, t, this.size, i));
            }));
        } else {
          const e = new Uint32Array(t);
          this.cpuCache.pushData(this.renderID, this.chunk.id, e, this.size);
        }
      else
        this.type === i
          ? this.cpuCache.pushSH(this.renderID, this.chunk.id, t, this.size)
          : this.cpuCache.pushSem(this.renderID, this.chunk.id, t, this.size);
      this.size != r && console.warn('wrong data: ', this.chunk, this.size, r);
    } else if (this.chunk.isUnitChunk) {
      const i = this.type === e ? this.chunk.startAddr : this.chunk.shStartAddr,
        n = this.chunk.allUnits;
      let a = 0;
      (n.forEach((n) => {
        const r = n.nodes;
        r &&
          r.forEach((n) => {
            if (n && n.points > 0) {
              const r = n.id,
                o = this.type === e ? n.offset : n.shOffset,
                h = this.type === e ? n.size : n.shSize,
                l = Number(o - i),
                c = t.slice(l, l + h);
              if (this.type === e)
                if (s) {
                  const t = n.getQuanBBox();
                  (n.setDecompressing(e, !0),
                    this.decompressor.decompress(this.type, c, h, this.meta, this.renderID, t, (t, i, s) => {
                      (n.setDecompressing(e, !1), this.cpuCache.pushData(this.renderID, r, t, h, i));
                    }));
                } else {
                  const t = new Uint32Array(c);
                  this.cpuCache.pushData(this.renderID, r, t, h);
                }
              else this.cpuCache.pushSH(this.renderID, r, c, h);
              a += h;
            }
          });
      }),
        r != a && console.warn('wrong data2: ', this.chunk, a, r));
    } else if (this.chunk.isColl) {
      let e = this.chunk,
        i = 12 * e.vertexNum + 12 * e.faceNum;
      (i > t.byteLength && console.warn('wrong coll-data: ', i, t.byteLength),
        e.setDecompressing(n, !0),
        this.collBuilder.decompress(
          t,
          e.vertexNum,
          e.faceNum,
          e.preBvhSize,
          this.meta,
          this.renderID,
          (t, i, s, r, a) => {
            (e.setDecompressing(n, !1), e.pushCacheData(t, i, s));
          },
        ));
    } else console.error('unknow chunk.');
  }
  #se(t, s) {
    if (t)
      if (this.chunk.isNode)
        if (this.type === e) {
          const { data: e } = t;
          if (s) {
            const { pos: i } = t;
            this.cpuCache.pushData(this.renderID, this.chunk.id, e, this.size, i);
          } else this.cpuCache.pushData(this.renderID, this.chunk.id, e, this.size);
        } else if (this.type === i) {
          const { data: e } = t;
          this.cpuCache.pushSH(this.renderID, this.chunk.id, yt(e), this.size);
        } else {
          const { data: e } = t;
          this.cpuCache.pushSem(this.renderID, this.chunk.id, yt(e), this.size);
        }
      else if (this.chunk.isColl) {
        const { vertexes: e, faces: i, bvh: s } = t;
        this.chunk.pushCacheData(e, i, s);
      } else console.error('unknow chunk.');
  }
}
class je {
  #f = !1;
  #re = 5;
  #K;
  #ae;
  #oe;
  #he = !0;
  #le = !0;
  #ce = Object.create(null);
  #ue = new Jt();
  #de = new Jt();
  #fe = new Jt();
  #pe = new Jt();
  #me = !1;
  #ge = !1;
  #ye = !1;
  isDownloadCompleted = !1;
  #ee;
  #xe = new Set();
  constructor(t, e, i, s, n, r = !0, a = !0) {
    ((this.#K = t), (this.#ae = i), (this.#oe = e), (this.#ee = s), (this.#he = r), (this.#le = a));
  }
  setRenderInfoMeta(t, e, i) {
    ((this.#ce[t].meta = e), this.#ee.initialIndexDB(e.guid, t, i));
  }
  #ve(t) {
    let e,
      i,
      s,
      n = new URL(t);
    const r = [];
    (n.pathname.split('/').forEach((t) => {
      t.endsWith('.lcc')
        ? (i = t.substring(0, t.length - 4))
        : t.endsWith('.splat')
          ? (i = t.substring(0, t.length - 6))
          : r.push(t);
    }),
      (e = `${n.origin}${r.join('/')}`),
      (e = e.replace(/\/$/, '')));
    const a = new URLSearchParams(n.search).toString().match(/(?:token)=([^&]*)/i);
    return (a && (s = a[1]), { rootPath: e, metaName: i, token: s });
  }
  #be(t, s) {
    if (s === e) return this.#ce[t].dataUrl;
    if (s === i) return this.#ce[t].shUrl;
    if (s === n) return this.#ce[t].collisionUrl;
    if (s === l) return this.#ce[t].semanticUrl;
    throw new Error('Unkonwn type');
  }
  init(t, e, i = {}) {
    const s = {
      metaStatus: { isExist: !1, isNotDownloaded: !0 },
      indexStatus: { isExist: !1, isNotDownloaded: !0 },
      dataStatus: { isExist: !1, isNotDownloaded: !0 },
      shcoefStatus: { isExist: !1, isNotDownloaded: !0 },
      semanticStatus: { isExist: !1, isNotDownloaded: !0 },
      lutScaleStatus: { isExist: !1, isNotDownloaded: !0 },
      lutShStatus: { isExist: !1, isNotDownloaded: !0 },
      collisionStatus: { isExist: !1, isNotDownloaded: !0 },
      environmentStatus: { isExist: !1, isNotDownloaded: !0 },
    };
    if ('string' == typeof e) {
      let { rootPath: n, metaName: r, metaExtName: a, token: o } = this.#ve(e),
        h = n + '/meta.lcc',
        l = n + '/meta.splat',
        c = {};
      (o && (c = { Authorization: o }),
        r && ((h = n + '/' + r + '.lcc'), (l = n + '/' + r + '.splat')),
        (this.#ce[t] = {
          url: n,
          metaUrl: { filename: 'meta', url: h, header: c },
          metaUrl2: { filename: 'meta', url: l, header: c },
          indexUrl: { filename: 'index', url: n + '/index.bin', header: c },
          environmentUrl: { filename: 'environment', url: n + '/environment.bin', header: c },
          dataUrl: { filename: 'data', url: n + '/data.bin', header: c },
          shUrl: { filename: 'shcoef', url: n + '/shcoef.bin', header: c },
          semanticUrl: { filename: 'shcoef', url: n + '/shcoef.bin', header: c },
          lutScaleUrl: { filename: 'shcoef', url: n + '/shcoef.bin', header: c },
          lutShUrl: { filename: 'shcoef', url: n + '/shcoef.bin', header: c },
          collisionUrl: { filename: 'collision', url: n + '/collision.lci', header: c },
          meta: {},
          ...s,
          ...i,
        }));
    } else {
      const { meta: n, index: r, data: a, environment: o, collision: h, shcoef: l } = e;
      this.#ce[t] = {
        url: e,
        metaUrl: { filename: 'meta', url: n?.url, header: n?.header },
        metaUrl2: { filename: 'meta', url: n?.url, header: n?.header },
        indexUrl: { filename: 'index', url: r?.url, header: r?.header },
        environmentUrl: { filename: 'environment', url: o?.url, header: o?.header },
        dataUrl: { filename: 'data', url: a?.url, header: a?.header },
        shUrl: { filename: 'shcoef', url: l?.url, header: l?.header },
        semanticUrl: { filename: 'shcoef', url: l?.url, header: l?.header },
        lutScaleUrl: { filename: 'shcoef', url: l?.url, header: l?.header },
        lutShUrl: { filename: 'shcoef', url: l?.url, header: l?.header },
        collisionUrl: { filename: 'collision', url: h?.url, header: h?.header },
        meta: {},
        ...s,
        ...i,
      };
    }
  }
  dispose() {
    ((this.#f = !0),
      (this.#ce = {}),
      (this.#K = null),
      (this.#ae = null),
      (this.#oe = null),
      this.#fe.traverse((t) => {
        t.dispose();
      }),
      this.#pe.traverse((t) => {
        t.dispose();
      }),
      (this.#fe = new Jt()),
      (this.#pe = new Jt()),
      this.#xe.forEach((t) => {
        t.terminate();
      }),
      this.#xe.clear(),
      this.#ue.traverse((t) => {
        t.dispose();
      }),
      this.#de.traverse((t) => {
        t.dispose();
      }),
      (this.#ue = new Jt()),
      (this.#de = new Jt()));
  }
  unload(t) {
    (this.#fe.filter((e) => e.renderID !== t),
      this.#pe.filter((e) => e.renderID !== t),
      this.#ue.filter((e) => e.renderID !== t),
      this.#de.filter((e) => e.renderID !== t),
      this.#xe.forEach((e) => {
        e.postMessage({ flag: 'Clean', renderID: t });
      }),
      (this.#ce[t] = void 0),
      delete this.#ce[t]);
  }
  checkNetworkIdle() {
    return !(this.#me || this.#ge || this.#fe.length > 0 || this.#pe.length > 0);
  }
  async #we(t, e) {
    e ? (this.#me = !0) : (this.#ge = !0);
    const i = [],
      s = [],
      n = t.length;
    for (let e = 0; e < this.#re && e < n; ++e) {
      let e = t.dequeue();
      (s.push(e), i.push(e.requestData()));
    }
    const r = () => {
      this.#f ||
        (e ? (this.#me = !1) : (this.#ge = !1),
        s.forEach((t) => {
          t.setDownloadingEnd();
        }));
    };
    try {
      const t = i.map((t, e) =>
        t
          .then((t) => {
            t && !this.#f && ((this.#ye = !0), this.#Se(s[e], t));
          })
          .catch((t) => {}),
      );
      (await Promise.all(t), r());
    } catch (t) {
      (console.error(t), r());
    }
  }
  #Me(t, e) {
    const i = [],
      s = t.length;
    let n = 0;
    const r = [];
    let a = [],
      o = 0;
    for (let e = 0; e < s; e++) {
      let e = t.dequeue();
      (n > 52428800 && (r.push(a), (a = []), (n = 0)),
        (n += e.size),
        i.push(e),
        (o = e.meta?.guid),
        a.push({
          index: i.length - 1,
          guid: e.meta?.guid,
          filename: e.filename,
          dataType: e.type,
          path: e.url,
          offset: e.offset,
          size: e.size,
          headers: e.header,
          tablename: e.tablename,
          tid: e.tid,
          renderID: e.renderID,
        }));
    }
    a.length > 0 && r.push(a);
    const h = (t) => {
      const e = t.data.payloads;
      if (e)
        for (let t = 0; t < e.length; ++t) {
          const s = e[t],
            n = s.data,
            r = i[s.index];
          (r.setDownloadingEnd(), this.#ce[s.renderID] && this.#Se(r, n));
        }
    };
    for (let t = 0; t < r.length; t++) this.#ee.getCache({ guid: o, payloads: r[t] }, h);
  }
  #Ce(t, e) {
    e ? (this.#me = !0) : (this.#ge = !0);
    const i = [],
      s = [];
    for (let e = 0; e < 400 && 0 !== t.length; e++) {
      let n = t.dequeue();
      (i.push(n),
        s.push({
          index: e,
          filename: n.filename,
          path: n.url,
          offset: n.offset,
          size: n.size,
          headers: n.header,
          renderID: n.renderID,
        }));
    }
    const n = () => {
        this.#f ||
          (e ? (this.#me = !1) : (this.#ge = !1),
          i.forEach((t) => {
            t.setDownloadingEnd();
          }));
      },
      r = we($t);
    (this.#xe.add(r),
      r.addEventListener('message', (t) => {
        if (this.#f) return;
        const e = t.data.payloads,
          s = t.data.data,
          a = t.data.isFinished;
        if (s) {
          this.#ye = !0;
          for (let t = 0; t < e.length; ++t) {
            const s = e[t];
            if (!this.#ce[s.renderID]) continue;
            const n = s.data,
              r = i[s.index];
            this.#Se(r, n);
          }
        }
        a && (r.terminate(), this.#xe.delete(r), n());
      }),
      r.postMessage(s));
  }
  #Se(t, e) {
    if (this.#f || !t || !this.#ce[t.renderID]) return;
    const { preProcessFunc: i } = this.#ce[t.renderID];
    if (!i) return void t.processPayload(e, this.#he, void 0);
    let s = e.data || e;
    (s instanceof ArrayBuffer || (s = s.buffer),
      t.setPreprocessStart(),
      i(s, t.filename)
        .then((e) => {
          (t.setPreprocessEnd(), t.processPayload(e.data, this.#he, e.rawData));
        })
        .catch((e) => {
          (t.setPreprocessEnd(), console.error('preProcessFunc fail:', e));
        }));
  }
  #Ee() {
    (this.#ue.length > 0 && this.#Me(this.#ue, !0), this.#de.length > 0 && this.#Me(this.#de, !1));
  }
  #De() {
    (!this.#me && this.#fe.length > 0 && (this.#le ? this.#Ce(this.#fe, !0) : this.#we(this.#fe, !0)),
      !this.#ge && this.#pe.length > 0 && (this.#le ? this.#Ce(this.#pe, !1) : this.#we(this.#pe, !1)));
  }
  load(t, s, r = e) {
    const a = this.#ce[t].meta,
      o = a?.guid,
      h = this.#be(t, r),
      c = h?.url,
      u = h?.header,
      d = h?.filename;
    let f, p;
    for (let o = 0; o < s.length; ++o) {
      const h = new He(t, d, c, s[o], r, u, this.#K, this.#ae, this.#oe, a, this.#ee);
      (h.setDownloadingStart(),
        h.dataSource === g ? ((f = this.#fe), (p = this.#pe)) : ((f = this.#ue), (p = this.#de)),
        r === e || r === n ? f.enqueue(h) : (r !== i && r !== l) || p.enqueue(h));
    }
    this.#ce[t].environmentStatus.isNotDownloaded &&
      (this.#Ae(t, o)
        .then((e) => {
          e && !this.#f && this.#ce[t] && this.#Fe(t, e.data || e, this.#ce[t].meta.hasSH, e.rawData);
        })
        .catch((t) => {
          console.log(' load env false: ', t);
        }),
      (this.#ce[t].environmentStatus.isNotDownloaded = !1));
  }
  update(t) {
    this.#f ||
      (this.#ye ? ((this.#ye = !1), (this.isDownloadCompleted = !0)) : (this.isDownloadCompleted = !1),
      this.#Ee(),
      this.#De());
  }
  loadMetaIndex(t, e, i) {
    const s = (t, i, s) => {
        this.#f || xt(e, t, i, s);
      },
      n = () => {
        this.#f || xt(i);
      };
    this.#Pe(
      t,
      (e) => {
        this.#Te(
          t,
          (i) => {
            this.#Ie(
              t,
              (t) => {
                s(e, i, t);
              },
              () => {
                s(e, i, null);
              },
            );
          },
          () => {
            n();
          },
        );
      },
      () => {
        n();
      },
    );
  }
  #Pe(t, e, i) {
    const { metaUrl: s, metaUrl2: n } = this.#ce[t],
      r = this.#_e(t);
    if (!s.url && !n.url) return (console.warn('meta.lcc data is null !'), void i());
    Oe(s.filename, s.url, void 0, void 0, s.header, Zt, r)
      .then((t) => {
        e(t);
      })
      .catch((t) => {
        Oe(n.filename, n.url, void 0, void 0, n.header, Zt, r)
          .then((t) => {
            e(t);
          })
          .catch((t) => {
            (console.error('get meta failed', t), i());
          });
      });
  }
  #Te(t, e, i) {
    const s = this.#_e(t),
      n = this.#ce[t].indexUrl,
      r = n?.url,
      a = n?.header,
      o = n?.filename;
    if (!r) return (console.warn('index.bin data is null !'), void i());
    Le(o, r, void 0, void 0, a, Zt, s)
      .then((t) => {
        e(t.data);
      })
      .catch((t) => {
        (console.error('get index failed', t), i());
      });
  }
  loadLut(t, e, i, s) {
    const n = (t) => {
        !this.#f &&
          this.#ce[e] &&
          (this.#K.pushLut(e, i, t),
          console.log('load lut success: type=' + i + ',  size=' + t?.byteLength),
          xt(s, !0));
      },
      r = () => {
        !this.#f && this.#ce[e] && (console.log('load lut failure: type=' + i), xt(s, !1));
      };
    try {
      const s = this.#_e(e),
        a = i === o ? this.#ce[e].lutScaleUrl : this.#ce[e].lutShUrl,
        h = i === o ? 0 : 1572864,
        l = i === o ? 1572864 : 11796480,
        c = a?.url,
        u = a?.header,
        d = a?.filename;
      if (!c) return (console.warn('lut data is null !'), void r());
      const f = this.#ee.getTableName(t, i),
        p = this.#ee.getSpecialData(f);
      if (p) {
        const t = yt(p.data);
        if (!t) return (console.warn('lut table found, but data is null !'), void r());
        'function' == typeof s
          ? s(t, d)
              .then((t) => {
                t && t.data ? n(yt(t.data)) : r();
              })
              .catch((t) => {
                (console.warn('get lut failed', t), r());
              })
          : n(t);
      } else
        Le(d, c, h, l, u, Zt, s)
          .then((t) => {
            !this.#f &&
              this.#ce[e] &&
              (t
                ? ('function' == typeof s
                    ? t.rawData && this.#ee.putCache({ id: m, dataType: i, tablename: f, data: t.rawData })
                    : this.#ee.putCacheWithDelay(f, m, e, -1, i),
                  n(yt(t.data)))
                : r());
          })
          .catch((t) => {
            (console.warn('get lut failed', t), r());
          });
    } catch (t) {
      (console.error('download lut fail: ', t), r());
    }
  }
  #Ae(t, e) {
    return new Promise((i, n) => {
      try {
        const r = this.#_e(t),
          a = this.#ce[t].environmentUrl,
          o = a?.url,
          h = a?.header,
          l = a?.filename;
        if (!o) return (console.warn('environment.bin data is null !'), void n(null));
        const c = this.#ee.getTableName(e, s),
          u = this.#ee.getSpecialData(c);
        if (u)
          if ('function' == typeof r)
            if (this.#ce[t]) {
              r(yt(u.data), l)
                .then((t) => {
                  i(t);
                })
                .catch((t) => {
                  (console.warn('get env failed', t), n(null));
                });
            } else n(null);
          else {
            const { data: e, sh: s, pos: n } = u,
              r = n.byteLength / 4 / 3;
            (this.#K.pushEnv(t, r, e, s, n), i(null));
          }
        else
          Le(l, o, void 0, void 0, h, Zt, r)
            .then((t) => {
              i(t);
            })
            .catch((t) => {
              (console.warn('get env failed', t), n(null));
            });
      } catch (t) {
        (console.error(t), n(null));
      }
    });
  }
  #Fe(t, e, i, n) {
    const { preProcessFunc: r } = this.#ce[t];
    if (i) {
      const i = 96,
        n = e.byteLength / i;
      this.#ae.decompress(s, e, e.byteLength, this.#ce[t]?.meta, t, void 0, (e, i, s) => {
        this.#f || this.#K.pushEnv(t, n, e, s, i);
      });
    } else {
      const i = 32,
        n = e.byteLength / i;
      this.#ae.decompress(s, e, e.byteLength, this.#ce[t]?.meta, t, void 0, (e, i, s) => {
        this.#f || this.#K.pushEnv(t, n, e, s, i);
      });
    }
    const a = this.#ce[t].meta.guid,
      o = this.#ee.getTableName(a, s);
    this.#ee.getSpecialData(o) ||
      ('function' == typeof r
        ? n && this.#ee.putCache({ id: m, dataType: s, tablename: o, data: n })
        : this.#ee.putCacheWithDelay(o, m, t, -1, s));
  }
  #Ie(t, e, i) {
    const s = this.#_e(t),
      n = this.#ce[t].collisionUrl,
      r = n?.url,
      a = n?.header,
      o = n?.filename;
    if (!r) return (i(), void console.warn('collision.lci data is null !'));
    Le(o, r, 0, 4096, a, Zt, s)
      .then((t) => {
        const n = t.data;
        let h = new Uint32Array(n);
        if (h.length < 12) return (console.warn('invalid collision size'), void i());
        if (1819045731 !== h[0]) return (console.warn('invalid collision'), void i());
        let l = h[2];
        n.byteLength >= l
          ? e(n)
          : Le(o, r, 0, l, a, Zt, s)
              .then((t) => {
                const s = t.data;
                s.byteLength >= l ? e(s) : (console.warn('get collision-hdr failed-1'), i());
              })
              .catch((t) => {
                (console.warn('get collision-hdr failed-2'), i());
              });
      })
      .catch((t) => {
        (console.warn('get collision-hdr failed-3'), i());
      });
  }
  #_e(t) {
    const { preProcessFunc: e } = this.#ce[t];
    if (!e) return e;
    return (...i) => (this.#ce[t] ? e(...i) : (console.log('discard data !!!'), Promise.resolve(void 0)));
  }
}
class qe {
  constructor() {}
  dispose() {
    throw new Error('Must be implemented by subclass');
  }
  update() {
    throw new Error('Must be implemented by subclass');
  }
  createRenderer() {
    throw new Error('Must be implemented by subclass');
  }
  destroyRenderer(t) {
    throw new Error('Must be implemented by subclass');
  }
  getAllRenderers() {
    throw new Error('Must be implemented by subclass');
  }
  raycast(t) {
    throw new Error('Must be implemented by subclass');
  }
  raycastFromOrigin(t) {
    throw new Error('Must be implemented by subclass');
  }
}
class Ve {
  get isCameraChanged() {
    throw new Error('Must be implemented by subclass');
  }
  get fov() {
    throw new Error('Must be implemented by subclass');
  }
  get position() {
    throw new Error('Must be implemented by subclass');
  }
  get projectionMatrix() {
    throw new Error('Must be implemented by subclass');
  }
  get cam2WorldMatrix() {
    throw new Error('Must be implemented by subclass');
  }
  update(t) {
    throw new Error('Must be implemented by subclass');
  }
  dispose() {
    throw new Error('Must be implemented by subclass');
  }
}
let Ue = class extends Ve {
  #Re;
  #Ne;
  #Be;
  #ke;
  #ze;
  #Le;
  #Oe;
  #He;
  #je;
  #qe = !1;
  #Ve;
  constructor(t) {
    (super(),
      (this.#Ne = t.camera),
      (this.#Be = t.canvas),
      (this.#ke = t.renderer),
      (this.#Re = t),
      (this.#ze = this.#Ue(this.#Ne)),
      (this.#Le = this.#Be.width),
      (this.#Oe = this.#Be.height),
      (this.#He = this.#Ne.position.clone()),
      (this.#je = this.#Ne.quaternion.clone()),
      (this.#Ve = this.#Ne.projectionMatrix.clone()));
  }
  get isCameraChanged() {
    return this.#qe;
  }
  get fov() {
    return this.#ze;
  }
  get viewWidth() {
    return this.#Le;
  }
  get viewHeight() {
    return this.#Oe;
  }
  get position() {
    return this.#Ne.position.clone();
  }
  get projectionMatrix() {
    return this.#Ne.projectionMatrix;
  }
  get cam2WorldMatrix() {
    return this.#Ne.matrixWorld;
  }
  update(t) {
    (this.#Ne != this.#Re.camera && (console.log('change camera ...'), (this.#Ne = this.#Re.camera), (this.#qe = !0)),
      this.#Ne.updateMatrixWorld());
    let e = this.#Ne.position,
      i = this.#Ne.quaternion,
      s = this.#Ne.projectionMatrix,
      n = this.#Ue(this.#Ne),
      r = this.#Be.width,
      a = this.#Be.height;
    this.#qe = !1;
    const o = 1e-6;
    ((n > this.#ze + o || n < this.#ze - o) && ((this.#ze = n), (this.#qe = !0)),
      (r == this.#Le && a == this.#Oe) || ((this.#Le = r), (this.#Oe = a), (this.#qe = !0)),
      e.equals(this.#He) || (this.#He.copy(e), (this.#qe = !0)),
      i.equals(this.#je) || (this.#je.copy(i), (this.#qe = !0)),
      s.equals(this.#Ve) || (this.#Ve.copy(s), (this.#qe = !0)));
  }
  dispose() {}
  #Ue(t) {
    if (t.isOrthographicCamera) return 70;
    let e = t.projectionMatrix,
      i = Math.abs(1 / e.elements[5]),
      s = 2 * Math.atan(i);
    return ut.RAD2DEG * s;
  }
};
const Ke = new ie(),
  Ge = new pt(),
  We = new pt();
class Qe {
  constructor(t = new pt(), e = -1) {
    ((this.isSphere = !0), (this.center = t), (this.radius = e));
  }
  set(t, e) {
    return (this.center.copy(t), (this.radius = e), this);
  }
  setFromPoints(t, e) {
    const i = this.center;
    void 0 !== e ? i.copy(e) : Ke.setFromPoints(t).getCenter(i);
    let s = 0;
    for (let e = 0, n = t.length; e < n; e++) s = Math.max(s, i.distanceToSquared(t[e]));
    return ((this.radius = Math.sqrt(s)), this);
  }
  copy(t) {
    return (this.center.copy(t.center), (this.radius = t.radius), this);
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return (this.center.set(0, 0, 0), (this.radius = -1), this);
  }
  containsPoint(t) {
    return t.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(t) {
    return t.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(t) {
    const e = this.radius + t.radius;
    return t.center.distanceToSquared(this.center) <= e * e;
  }
  intersectsBox(t) {
    return t.intersectsSphere(this);
  }
  intersectsPlane(t) {
    return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(t, e) {
    const i = this.center.distanceToSquared(t);
    return (
      e.copy(t),
      i > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)),
      e
    );
  }
  getBoundingBox(t) {
    return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
  }
  applyMatrix4(t) {
    return (this.center.applyMatrix4(t), (this.radius = this.radius * t.getMaxScaleOnAxis()), this);
  }
  translate(t) {
    return (this.center.add(t), this);
  }
  expandByPoint(t) {
    if (this.isEmpty()) return (this.center.copy(t), (this.radius = 0), this);
    Ge.subVectors(t, this.center);
    const e = Ge.lengthSq();
    if (e > this.radius * this.radius) {
      const t = Math.sqrt(e),
        i = 0.5 * (t - this.radius);
      (this.center.addScaledVector(Ge, i / t), (this.radius += i));
    }
    return this;
  }
  union(t) {
    return t.isEmpty()
      ? this
      : this.isEmpty()
        ? (this.copy(t), this)
        : (!0 === this.center.equals(t.center)
            ? (this.radius = Math.max(this.radius, t.radius))
            : (We.subVectors(t.center, this.center).setLength(t.radius),
              this.expandByPoint(Ge.copy(t.center).add(We)),
              this.expandByPoint(Ge.copy(t.center).sub(We))),
          this);
  }
  equals(t) {
    return t.center.equals(this.center) && t.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Xe {
  constructor(t, e, i, s, n, r, a, o, h) {
    ((Xe.prototype.isMatrix3 = !0),
      (this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
      void 0 !== t && this.set(t, e, i, s, n, r, a, o, h));
  }
  set(t, e, i, s, n, r, a, o, h) {
    const l = this.elements;
    return (
      (l[0] = t),
      (l[1] = s),
      (l[2] = a),
      (l[3] = e),
      (l[4] = n),
      (l[5] = o),
      (l[6] = i),
      (l[7] = r),
      (l[8] = h),
      this
    );
  }
  identity() {
    return (this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this);
  }
  copy(t) {
    const e = this.elements,
      i = t.elements;
    return (
      (e[0] = i[0]),
      (e[1] = i[1]),
      (e[2] = i[2]),
      (e[3] = i[3]),
      (e[4] = i[4]),
      (e[5] = i[5]),
      (e[6] = i[6]),
      (e[7] = i[7]),
      (e[8] = i[8]),
      this
    );
  }
  extractBasis(t, e, i) {
    return (t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this);
  }
  setFromMatrix4(t) {
    const e = t.elements;
    return (this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this);
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, e) {
    const i = t.elements,
      s = e.elements,
      n = this.elements,
      r = i[0],
      a = i[3],
      o = i[6],
      h = i[1],
      l = i[4],
      c = i[7],
      u = i[2],
      d = i[5],
      f = i[8],
      p = s[0],
      m = s[3],
      g = s[6],
      y = s[1],
      x = s[4],
      v = s[7],
      b = s[2],
      w = s[5],
      S = s[8];
    return (
      (n[0] = r * p + a * y + o * b),
      (n[3] = r * m + a * x + o * w),
      (n[6] = r * g + a * v + o * S),
      (n[1] = h * p + l * y + c * b),
      (n[4] = h * m + l * x + c * w),
      (n[7] = h * g + l * v + c * S),
      (n[2] = u * p + d * y + f * b),
      (n[5] = u * m + d * x + f * w),
      (n[8] = u * g + d * v + f * S),
      this
    );
  }
  multiplyScalar(t) {
    const e = this.elements;
    return (
      (e[0] *= t),
      (e[3] *= t),
      (e[6] *= t),
      (e[1] *= t),
      (e[4] *= t),
      (e[7] *= t),
      (e[2] *= t),
      (e[5] *= t),
      (e[8] *= t),
      this
    );
  }
  determinant() {
    const t = this.elements,
      e = t[0],
      i = t[1],
      s = t[2],
      n = t[3],
      r = t[4],
      a = t[5],
      o = t[6],
      h = t[7],
      l = t[8];
    return e * r * l - e * a * h - i * n * l + i * a * o + s * n * h - s * r * o;
  }
  invert() {
    const t = this.elements,
      e = t[0],
      i = t[1],
      s = t[2],
      n = t[3],
      r = t[4],
      a = t[5],
      o = t[6],
      h = t[7],
      l = t[8],
      c = l * r - a * h,
      u = a * o - l * n,
      d = h * n - r * o,
      f = e * c + i * u + s * d;
    if (0 === f) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const p = 1 / f;
    return (
      (t[0] = c * p),
      (t[1] = (s * h - l * i) * p),
      (t[2] = (a * i - s * r) * p),
      (t[3] = u * p),
      (t[4] = (l * e - s * o) * p),
      (t[5] = (s * n - a * e) * p),
      (t[6] = d * p),
      (t[7] = (i * o - h * e) * p),
      (t[8] = (r * e - i * n) * p),
      this
    );
  }
  transpose() {
    let t;
    const e = this.elements;
    return (
      (t = e[1]),
      (e[1] = e[3]),
      (e[3] = t),
      (t = e[2]),
      (e[2] = e[6]),
      (e[6] = t),
      (t = e[5]),
      (e[5] = e[7]),
      (e[7] = t),
      this
    );
  }
  getNormalMatrix(t) {
    return this.setFromMatrix4(t).invert().transpose();
  }
  transposeIntoArray(t) {
    const e = this.elements;
    return (
      (t[0] = e[0]),
      (t[1] = e[3]),
      (t[2] = e[6]),
      (t[3] = e[1]),
      (t[4] = e[4]),
      (t[5] = e[7]),
      (t[6] = e[2]),
      (t[7] = e[5]),
      (t[8] = e[8]),
      this
    );
  }
  setUvTransform(t, e, i, s, n, r, a) {
    const o = Math.cos(n),
      h = Math.sin(n);
    return (
      this.set(i * o, i * h, -i * (o * r + h * a) + r + t, -s * h, s * o, -s * (-h * r + o * a) + a + e, 0, 0, 1),
      this
    );
  }
  scale(t, e) {
    return (this.premultiply(Ye.makeScale(t, e)), this);
  }
  rotate(t) {
    return (this.premultiply(Ye.makeRotation(-t)), this);
  }
  translate(t, e) {
    return (this.premultiply(Ye.makeTranslation(t, e)), this);
  }
  makeTranslation(t, e) {
    return (t.isVector2 ? this.set(1, 0, t.x, 0, 1, t.y, 0, 0, 1) : this.set(1, 0, t, 0, 1, e, 0, 0, 1), this);
  }
  makeRotation(t) {
    const e = Math.cos(t),
      i = Math.sin(t);
    return (this.set(e, -i, 0, i, e, 0, 0, 0, 1), this);
  }
  makeScale(t, e) {
    return (this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this);
  }
  equals(t) {
    const e = this.elements,
      i = t.elements;
    for (let t = 0; t < 9; t++) if (e[t] !== i[t]) return !1;
    return !0;
  }
  fromArray(t, e = 0) {
    for (let i = 0; i < 9; i++) this.elements[i] = t[i + e];
    return this;
  }
  toArray(t = [], e = 0) {
    const i = this.elements;
    return (
      (t[e] = i[0]),
      (t[e + 1] = i[1]),
      (t[e + 2] = i[2]),
      (t[e + 3] = i[3]),
      (t[e + 4] = i[4]),
      (t[e + 5] = i[5]),
      (t[e + 6] = i[6]),
      (t[e + 7] = i[7]),
      (t[e + 8] = i[8]),
      t
    );
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const Ye = new Xe(),
  Ze = new pt(),
  Je = new pt(),
  $e = new Xe();
class ti {
  constructor(t = new pt(1, 0, 0), e = 0) {
    ((this.isPlane = !0), (this.normal = t), (this.constant = e));
  }
  set(t, e) {
    return (this.normal.copy(t), (this.constant = e), this);
  }
  setComponents(t, e, i, s) {
    return (this.normal.set(t, e, i), (this.constant = s), this);
  }
  setFromNormalAndCoplanarPoint(t, e) {
    return (this.normal.copy(t), (this.constant = -e.dot(this.normal)), this);
  }
  setFromCoplanarPoints(t, e, i) {
    const s = Ze.subVectors(i, e).cross(Je.subVectors(t, e)).normalize();
    return (this.setFromNormalAndCoplanarPoint(s, t), this);
  }
  copy(t) {
    return (this.normal.copy(t.normal), (this.constant = t.constant), this);
  }
  normalize() {
    const t = 1 / this.normal.length();
    return (this.normal.multiplyScalar(t), (this.constant *= t), this);
  }
  negate() {
    return ((this.constant *= -1), this.normal.negate(), this);
  }
  distanceToPoint(t) {
    return this.normal.dot(t) + this.constant;
  }
  distanceToSphere(t) {
    return this.distanceToPoint(t.center) - t.radius;
  }
  projectPoint(t, e) {
    return e.copy(t).addScaledVector(this.normal, -this.distanceToPoint(t));
  }
  intersectLine(t, e) {
    const i = t.delta(Ze),
      s = this.normal.dot(i);
    if (0 === s) return 0 === this.distanceToPoint(t.start) ? e.copy(t.start) : null;
    const n = -(t.start.dot(this.normal) + this.constant) / s;
    return n < 0 || n > 1 ? null : e.copy(t.start).addScaledVector(i, n);
  }
  intersectsLine(t) {
    const e = this.distanceToPoint(t.start),
      i = this.distanceToPoint(t.end);
    return (e < 0 && i > 0) || (i < 0 && e > 0);
  }
  intersectsBox(t) {
    return t.intersectsPlane(this);
  }
  intersectsSphere(t) {
    return t.intersectsPlane(this);
  }
  coplanarPoint(t) {
    return t.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(t, e) {
    const i = e || $e.getNormalMatrix(t),
      s = this.coplanarPoint(Ze).applyMatrix4(t),
      n = this.normal.applyMatrix3(i).normalize();
    return ((this.constant = -s.dot(n)), this);
  }
  translate(t) {
    return ((this.constant -= t.dot(this.normal)), this);
  }
  equals(t) {
    return t.normal.equals(this.normal) && t.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const ei = new Qe(),
  ii = new pt();
class si {
  constructor(t = new ti(), e = new ti(), i = new ti(), s = new ti(), n = new ti(), r = new ti()) {
    this.planes = [t, e, i, s, n, r];
  }
  set(t, e, i, s, n, r) {
    const a = this.planes;
    return (a[0].copy(t), a[1].copy(e), a[2].copy(i), a[3].copy(s), a[4].copy(n), a[5].copy(r), this);
  }
  copy(t) {
    const e = this.planes;
    for (let i = 0; i < 6; i++) e[i].copy(t.planes[i]);
    return this;
  }
  setFromProjectionMatrix(t, e = 2e3) {
    const i = this.planes,
      s = t.elements,
      n = s[0],
      r = s[1],
      a = s[2],
      o = s[3],
      h = s[4],
      l = s[5],
      c = s[6],
      u = s[7],
      d = s[8],
      f = s[9],
      p = s[10],
      m = s[11],
      g = s[12],
      y = s[13],
      x = s[14],
      v = s[15];
    if (
      (i[0].setComponents(o - n, u - h, m - d, v - g).normalize(),
      i[1].setComponents(o + n, u + h, m + d, v + g).normalize(),
      i[2].setComponents(o + r, u + l, m + f, v + y).normalize(),
      i[3].setComponents(o - r, u - l, m - f, v - y).normalize(),
      i[4].setComponents(o - a, u - c, m - p, v - x).normalize(),
      e === zt)
    )
      i[5].setComponents(o + a, u + c, m + p, v + x).normalize();
    else {
      if (e !== Lt) throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + e);
      i[5].setComponents(a, c, p, x).normalize();
    }
    return this;
  }
  intersectsObject(t) {
    if (void 0 !== t.boundingSphere)
      (null === t.boundingSphere && t.computeBoundingSphere(), ei.copy(t.boundingSphere).applyMatrix4(t.matrixWorld));
    else {
      const e = t.geometry;
      (null === e.boundingSphere && e.computeBoundingSphere(), ei.copy(e.boundingSphere).applyMatrix4(t.matrixWorld));
    }
    return this.intersectsSphere(ei);
  }
  intersectsSprite(t) {
    return (
      ei.center.set(0, 0, 0),
      (ei.radius = 0.7071067811865476),
      ei.applyMatrix4(t.matrixWorld),
      this.intersectsSphere(ei)
    );
  }
  intersectsSphere(t) {
    const e = this.planes,
      i = t.center,
      s = -t.radius;
    for (let t = 0; t < 6; t++) {
      if (e[t].distanceToPoint(i) < s) return !1;
    }
    return !0;
  }
  intersectsBox(t) {
    const e = this.planes;
    for (let i = 0; i < 6; i++) {
      const s = e[i];
      if (
        ((ii.x = s.normal.x > 0 ? t.max.x : t.min.x),
        (ii.y = s.normal.y > 0 ? t.max.y : t.min.y),
        (ii.z = s.normal.z > 0 ? t.max.z : t.min.z),
        s.distanceToPoint(ii) < 0)
      )
        return !1;
    }
    return !0;
  }
  containsPoint(t) {
    const e = this.planes;
    for (let i = 0; i < 6; i++) if (e[i].distanceToPoint(t) < 0) return !1;
    return !0;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class ni {
  configCommon;
  config;
  lccParam;
  cpuCache;
  gpuCache;
  collCache;
  resources;
  resourcesScene;
  dataLoader;
  cameraMgr;
  platform;
  localCacheMgr;
  meta = {};
  renderID;
  isRTK = !1;
  modelMatrix = new Ot();
  dynamicState = {
    pointsOnly: !1,
    alpha: 1,
    visible: !0,
    useEnv: !0,
    useSH: !1,
    useCustomColor: !0,
    viewport: { x: 0, y: 0 },
    focal: 0,
    frustum: new si(),
    cmrPos: new pt(0, 0, 0),
    cmrForward: new pt(0, 0, 0),
    cmrPosLocal: new pt(0, 0, 0),
    cmrForwardLocal: new pt(0, 0, 0),
    cmrPosModelLocal: new pt(0, 0, 0),
    cmrProjMatrix: new Ot(),
    cmr2LocalMatrix: new Ot(),
    cmr2ModelLocalMatrix: new Ot(),
    clipPlane: new st(0, 0, 0, 0),
    clipBoxMatrixInv: new Ot(),
    clipBoxSide: 1,
    useClipPlane: !1,
    useClipBox: !1,
    useEdgeCrop: !1,
    ndc2local: new Ot(),
    useSemantic: !1,
    loadingReady: !1,
    scenePositionLocal: new pt(0, 0, 0),
    loadingSplatDistance: 0,
    loadingPointDistance: 0,
    loadingSwitch: 0,
    tick: 0,
  };
  performance = {
    meshNum: 0,
    totalPoints: 0,
    maxPoints: 0,
    minPoints: 0,
    fps: 0,
    drawcall: 0,
    bwLimitCount: 0,
    bwLimitSize: 0,
  };
  dispose() {}
}
class ri {
  #Ke = [];
  #Ge = 0;
  constructor(t) {
    t && (this.#Ke = t);
  }
  get length() {
    return this.#Ke.length - this.#Ge;
  }
  isEmpty() {
    return this.#Ge >= this.#Ke.length;
  }
  read() {
    if (this.isEmpty()) return null;
    let t = this.#Ke[this.#Ge];
    return ((this.#Ge += 1), t);
  }
}
class ai {
  #We = !1;
  #Qe = !0;
  #Xe;
  #Pt;
  #Ye;
  #K;
  #Ze = null;
  #ee = null;
  #Je;
  #$e = [];
  #ti;
  #zt;
  #ei = 300;
  #ii;
  #jt;
  #si = { x: 0, y: 0 };
  #$t = [];
  #ni = [];
  #ri = [];
  #ai = [];
  #oi = !1;
  #hi = 0;
  #li;
  #ci = 0;
  #ui = 0;
  #di = !1;
  #fi = !1;
  #pi = !1;
  #mi = -1;
  #gi = -1;
  #yi = {};
  #xi = void 0;
  #vi = void 0;
  #bi = void 0;
  #wi = void 0;
  #Si = void 0;
  #Mi = void 0;
  #Ci = void 0;
  #Ei = [];
  #Di = 0;
  #Ai = [];
  #Fi = [];
  #Pi = 0;
  #Ti = [];
  #Ii = 0;
  #_i = new pt();
  #Ri = 0;
  #Ni = 0;
  #Bi = new ri();
  #ki = 0;
  #zi = 0;
  #Li = 0;
  #Oi = 0;
  #Hi = 0;
  #ji = 0;
  #qi = 0;
  #Vi = 0;
  #Ui = 0;
  #Ki = 0;
  #Gi = !1;
  #Wi = !1;
  #Qi = !1;
  #Xi = !1;
  #Yi = 0;
  #Zi = 0;
  #Ji = !1;
  #$i = !1;
  #ts = !1;
  #es = !1;
  #is = !1;
  #ss = !1;
  #ns = void 0;
  #rs = 0;
  #as = 0;
  #Gt;
  #Wt;
  #os;
  #hs;
  #Yt;
  #Zt;
  #ls;
  #cs;
  #us = 1;
  #ds = !0;
  #fs = [];
  #ps = [];
  #ms = [];
  #gs;
  constructor(t, e, i) {
    ((this.#Gt = new ee()),
      (this.#Wt = new ee()),
      (this.#os = new pt()),
      (this.#hs = new pt()),
      (this.#yi[o] = !1),
      (this.#yi[h] = !1),
      (this.#Zi = Math.random()),
      (this.#Pt = t),
      (this.#Xe = this.#Pt.config),
      (this.#K = this.#Pt.cpuCache),
      (this.#Ye = e),
      (this.#Ze = i),
      (this.#li = this.#Pt.renderID),
      (this.#ee = this.#Pt.localCacheMgr),
      this.#Xe.useLoadingEffect && (this.#Pt.dynamicState.loadingSwitch = 1));
  }
  get #qt() {
    return this.#ti.totalLevel;
  }
  get #ys() {
    return 0;
  }
  get #xs() {
    return Math.min(this.#ti.totalLevel - 1, this.#Xe.MaxLodUsed);
  }
  get #vs() {
    return this.#ti.cellLengthX;
  }
  get #bs() {
    return this.#ti.cellLengthY;
  }
  get #ws() {
    return this.#ti.min;
  }
  get #Ss() {
    return this.#ti.max;
  }
  get #Ms() {
    return this.#ti.splats ? this.#ti.splats[0] : -1;
  }
  get #Cs() {
    return this.#ti.splats && this.#ti.splats[1] ? this.#ti.splats[1] : -1;
  }
  get isLoadingDirty() {
    return this.#pi;
  }
  get isFirstDataReady() {
    return this.#Ji;
  }
  get meta() {
    return this.#ti;
  }
  get center() {
    return this.#jt;
  }
  get bbox() {
    return this.#zt;
  }
  get bboxWithEnv() {
    return this.#ii;
  }
  get hasSH() {
    return this.#ti.hasSH;
  }
  get hasColl() {
    return this.#is;
  }
  get hasEnvironment() {
    return this.#ss;
  }
  get metaJson() {
    return this.#ns;
  }
  get minLimitLod() {
    let t = 0;
    const e = this.#ti?.splats;
    if (!e) return t;
    for (let i = 0; i < e.length && ((t = i), !(e[i] < this.#Xe.maxLoadSplatCount)); i++);
    return t;
  }
  getAllUnits() {
    const t = [];
    for (let e = 0; e <= this.#si.x; ++e)
      for (let i = 0; i <= this.#si.y; ++i) this.#ni[e] && this.#ni[e][i] && t.push(this.#ni[e][i]);
    return { units: t, maxIndex: this.#si };
  }
  getAllNodeID(t) {
    this.#$t.forEach((e) => {
      e.nodes.forEach((e) => {
        e && t.push(e.id);
      });
    });
  }
  getAllCollID(t) {
    this.#$t.forEach((e) => {
      e && e.coll && t.push(e.coll.id);
    });
  }
  getRenderNodes() {
    return this.#ri;
  }
  getRenderColls() {
    return this.#ai;
  }
  getLoadingNodes() {
    return this.#Ei;
  }
  getLoadingAroundNodes() {
    return this.#Ai;
  }
  #Es(t, e) {
    return this.#ni[t] && this.#ni[t][e] ? this.#ni[t][e] : null;
  }
  #Ds(t) {
    let e = Math.floor((t.x - this.#ws.x) / this.#vs),
      i = Math.floor((t.y - this.#ws.y) / this.#bs);
    return new ee(e, i);
  }
  #As(t, e) {
    const i = this.#ws,
      s = this.#Ss;
    if (e.x < i.x || t.x > s.x || e.y < i.y || t.y > s.y || e.z < i.z || t.z > s.z) return null;
    let n = Math.floor((t.x - this.#ws.x) / this.#vs),
      r = Math.floor((e.x - this.#ws.x) / this.#vs),
      a = Math.floor((t.y - this.#ws.y) / this.#bs),
      o = Math.floor((e.y - this.#ws.y) / this.#bs);
    return (
      (n = ut.clamp(n, 0, this.#si.x)),
      (r = ut.clamp(r, 0, this.#si.x)),
      (a = ut.clamp(a, 0, this.#si.y)),
      (o = ut.clamp(o, 0, this.#si.y)),
      { startX: n, endX: r, startY: a, endY: o }
    );
  }
  getUnitsFromBBox(t, e) {
    const i = [],
      s = this.#As(t, e);
    if (!s) return i;
    const { startX: n, endX: r, startY: a, endY: o } = s;
    for (let t = n; t <= r; ++t) for (let e = a; e <= o; ++e) this.#ni[t] && this.#ni[t][e] && i.push(this.#ni[t][e]);
    return i;
  }
  #Fs(t) {
    let e = Math.floor((t.x - this.#ws.x) / this.#vs),
      i = Math.floor((t.y - this.#ws.y) / this.#bs),
      s = e + 1,
      n = i - 1,
      r = i + 1,
      a = [];
    for (let t = e - 1; t <= s; ++t)
      for (let e = n; e <= r; ++e)
        t < 0 ||
          t > this.#si.x ||
          e < 0 ||
          e > this.#si.y ||
          (this.#ni[t] && this.#ni[t][e] && this.#ni[t][e].coll && a.push(this.#ni[t][e].coll));
    return a;
  }
  #Ps(t) {
    if (this.#oi) return this.#hi;
    let e = t.distance3dToCameraSq;
    this.#vs;
    const i = this.#Xe.MaxLodDistance * this.#Xe.MaxLodDistance,
      s = this.#Xe.LodStepDistance * this.#Xe.LodStepDistance,
      n = Math.min(this.#xs, this.#Xe.MinLodUsed),
      r = this.#xs;
    let a = r;
    return (e < i && (a = Math.round(Math.sqrt(e / s))), (a = ut.clamp(a, n, r)), a);
  }
  #Ts(t, i = e) {
    let s = [];
    return (
      t.forEach((t) => {
        t && (t.isDownloadingOrDecompressing(i) || t.isCache(i) || s.push(t));
      }),
      s
    );
  }
  #Is(t) {
    let e = [],
      i = 0;
    if (
      (t.forEach((t) => {
        const s = this.#Ps(t);
        let n = t.searchNearestNode(s);
        if (n && !(n.points < this.#Xe.MinValidSplatsInNode)) {
          if (!this.#oi && this.#Xe.useLodLevelUp)
            for (; n.points > this.#Xe.LodLevelUpSpatsInNode; ) {
              let e = t.searchNearestNode(n.level + 1);
              if (!e || e.points < 100) break;
              n = e;
            }
          (e.push(n), (i += n.points));
        }
      }),
      this.#oi || i <= this.#Xe.maxLoadSplatCount)
    )
      return e;
    let s = i - this.#Xe.maxLoadSplatCount;
    for (let t = e.length - 1; t >= 0; --t) {
      let i = e[t],
        n = i.parent,
        r = i.level,
        a = i.points,
        o = r;
      for (let t = r + 1; t <= this.#xs; ++t) {
        if (!n.nodes[t] || n.nodes[t].points > a) continue;
        if (((o = t), a - n.nodes[t].points > s)) break;
      }
      if (((e[t] = n.nodes[o]), (s -= e[t] ? a - e[t].points : a), s <= 0)) break;
    }
    let n = [],
      r = 0;
    for (let t = 0; t < e.length; ++t) {
      let i = e[t];
      if (i) {
        if (!this.#oi && r + i.points > this.#Xe.maxLoadSplatCount) break;
        (n.push(i), (r += i.points));
      }
    }
    return n;
  }
  #_s() {
    if (!this.#gs) {
      const t = this.#ti.splats;
      this.#gs = [...t];
    }
    this.#gs.fill(0);
  }
  #Rs(t) {
    for (let e = t.level - 1; e >= 0; e--) this.#gs[e] += t.parent?.nodes?.[e]?.points || 0;
  }
  #Ns(t) {
    let e = [],
      i = 0;
    const s = this.#Xe.maxLoadSplatCount;
    if (
      (t.forEach((t) => {
        const s = this.#Ps(t);
        let n = t.searchNearestNode(s);
        if (n) {
          if (!this.#oi && this.#Xe.useLodLevelUp && n.points > this.#Xe.LodLevelUpSpatsInNode) {
            let e = t.searchNearestNodeExt(
              n.level + 1,
              this.#qt,
              this.#Xe.MinValidSplatsInNode,
              this.#Xe.LodLevelUpSpatsInNode,
            );
            e && (n = e);
          }
          (e.push(n), (i += n.points), this.#Rs(n));
        }
      }),
      this.#oi)
    )
      return e;
    let n = i - s;
    if (n < 0) {
      if (this.#Xe.useLodAutoOptimization) {
        let t = this.#Xe.MinLodUsed;
        for (let e = this.#Xe.MinLodUsed; e < this.#ps.length; e++) {
          if (this.#ps[e] > this.#Xe.skipScreenSpaceErrorFactor) break;
          t = e;
        }
        t = Math.min(t, this.#xs);
        let i = t;
        for (let e = t; e < this.#gs.length; e++)
          if (this.#gs[e] < -n) {
            i = e;
            break;
          }
        for (let t = e.length - 1; t >= 0; t--) {
          const s = e[t];
          if (s.level > i) {
            const r = s.parent;
            let a;
            ((a = this.#Xe.useLodLevelUp
              ? r?.searchNearestNodeExt(i, s.level, 1, this.#Xe.LodLevelUpSpatsInNode)
              : r?.nodes?.[i]),
              a && ((e[t] = a), (n += a.points - s.points)));
          }
          if (n > 0) break;
        }
        if (t < i) {
          const s = Math.max(t, i - 1);
          for (let t = 0; t < e.length; t++) {
            const r = e[t];
            if (r.level >= i) {
              const i = r.parent;
              let a;
              ((a = this.#Xe.useLodLevelUp
                ? i?.searchNearestNodeExt(s, r.level, 1, this.#Xe.LodLevelUpSpatsInNode)
                : i?.nodes?.[s]),
                a && ((e[t] = a), (n += a.points - r.points)));
            }
            if (n > 0) break;
          }
        }
      }
      return e;
    }
    for (let t = e.length - 1; t >= 0; --t) {
      let i = e[t],
        s = i.parent,
        r = i.level,
        a = i.points,
        o = r;
      for (let t = r + 1; t <= this.#xs; ++t) {
        if (!s.nodes[t] || s.nodes[t].points > a) continue;
        if (((o = t), a - s.nodes[t].points > n)) break;
      }
      if (((e[t] = s.nodes[o]), (n -= e[t] ? a - e[t].points : a), n <= 0)) break;
    }
    let r = [],
      a = 0;
    for (let t = 0; t < e.length; ++t) {
      let i = e[t];
      if (i) {
        if (!this.#oi && a + i.points > s) break;
        (r.push(i), (a += i.points));
      }
    }
    return r;
  }
  #Bs(t, e, i = !0) {
    let s = [];
    return (
      t.forEach((t) => {
        const n = t.searchNearestNodeInverse(this.#xs);
        n && ((i && n.visibleID == this.#ci) || n.isDownloadingOrDecompressing(e) || n.isCache(e) || s.push(n));
      }),
      s
    );
  }
  #ks(t) {
    let e = [];
    return (
      t.forEach((t) => {
        const i = t.coll;
        i &&
          0 != i.faceNum &&
          (i.isDownloadingOrDecompressing(n) || i.isCacheData() || ((i.isRTK = this.#Pt.isRTK), e.push(i)));
      }),
      e
    );
  }
  #zs() {
    return (
      (this.#oi = !1),
      0 < this.#Ms && this.#Ms < this.#Xe.maxLoadSplatCount
        ? ((this.#hi = 0),
          (this.#oi = !0),
          (this.#Xe.fullRendering = this.#oi),
          void (this.#Xe.fullRenderLod = this.#hi))
        : 0 < this.#Cs && this.#Cs < this.#Xe.maxLoadSplatCount
          ? ((this.#hi = 1),
            (this.#oi = !0),
            (this.#Xe.fullRendering = this.#oi),
            void (this.#Xe.fullRenderLod = this.#hi))
          : 1 === this.#qt && 1 === this.#$t.length
            ? ((this.#hi = 0),
              (this.#oi = !0),
              (this.#Xe.fullRendering = this.#oi),
              void (this.#Xe.fullRenderLod = this.#hi))
            : void 0
    );
  }
  #Ls(t = !1, s = !1) {
    if ((this.#ci++, this.#ui++, 0 == this.#ni.length)) return;
    this.#zs();
    let r = this.#Pt.dynamicState.cmrPosModelLocal.clone(),
      a = this.#Pt.dynamicState.frustum;
    const o = this.#Xe.useSH && this.hasSH,
      h = this.hasColl,
      c = this.#Xe.useLccCompress && this.#Xe.hasSemantic && this.#Xe.useSemantic && !t;
    (this.#Os(r), this.#_s());
    let u = [],
      d = [],
      f = [];
    const p = this.#cs;
    (this.#$t.forEach((t) => {
      t.totalPoints < this.#Xe.MinValidSplatsInUnit ||
        (t.updateDistanceToCamera(r),
        t.distance3dToCameraSq < 1e4 && d.push(t),
        t.distance3dToCameraSq < 2500 && f.push(t),
        (!this.#oi && this.#ds && t.distance3dToCameraSq > p * p) || (a.intersectsBox(t.getBBox()) && u.push(t)));
    }),
      u.sort((t, e) => t.distanceToCameraSq - e.distanceToCameraSq));
    let m = this.#Ns(u);
    (m.forEach((t) => {
      t.visibleID = this.#ci;
    }),
      (this.#ri = m));
    let g = this.#Ts(m, e),
      y = [];
    o && (y = this.#Ts(m, i));
    let x = [];
    c && (x = this.#Ts(m, l));
    const v = !t;
    let b = this.#Bs(d, e, v);
    b.sort((t, e) => t.parent.distanceToCameraSq - e.parent.distanceToCameraSq);
    let w = [];
    if (
      (h && ((w = this.#ks(f)), w.sort((t, e) => t.parent.distanceToCameraSq - e.parent.distanceToCameraSq)),
      t &&
        (b.forEach((t) => {
          ((t.visibleAroundID = this.#ui), (t.parent.initAroundLevel = t.level));
        }),
        (g = g.filter((t) => t.visibleAroundID != this.#ui)),
        this.#Hs(r),
        this.#js(w, this.#Pt.configCommon.MaxCPUCollCacheSize),
        (this.#Ti = [...w]),
        (this.#Ai = [...b]),
        (this.#Ei = [...b, ...g]),
        (g = this.#Ei),
        this.#Ei.forEach((t, e, i) => {
          t.parent.initOneNodeExpect = !0;
        }),
        (this.#Ii = 0),
        this.#Ti.forEach((t, e, i) => {
          this.#Ii += t.size;
        }),
        (this.#Di = 0),
        this.#Ei.forEach((t, e, i) => {
          this.#Di += t.size;
        })),
      s && o)
    ) {
      let t = this.#Bs(d, i);
      (t.sort((t, e) => t.parent.distanceToCameraSq - e.parent.distanceToCameraSq),
        (this.#Fi = [...y, ...t]),
        (y = this.#Fi),
        (this.#Pi = 0),
        this.#Fi.forEach((t, e, i) => {
          this.#Pi += t.shSize;
        }));
    }
    let S = this.#qs(g, e);
    if ((this.#Ze.load(this.#li, S, e), o)) {
      let t = this.#qs(y, i);
      this.#Ze.load(this.#li, t, i);
    }
    (c && this.#Ze.load(this.#li, x, l),
      h && this.#Ze.load(this.#li, w, n),
      this.#Xe.AlwaysDownloadAround && !t && (this.#Bi = new ri(b)));
  }
  #js(t, e) {
    let i = 0;
    t.forEach((t) => (i += t.size));
    let s = i;
    for (; t.length > 0 && s > e; ) ((s -= t[t.length - 1].size), t.pop());
    i != s && console.warn('adjust coll size: ' + i + ' -> ' + s);
  }
  #Vs() {
    const t = this.#zt.getSize(new pt());
    this.#ls = Math.ceil(t.length());
    const e = [...this.#ti.splats];
    let i = this.#ls / Math.cbrt(e[0]);
    ((this.#fs = [i]), (this.#ms = [1]));
    for (let t = 1; t < e.length; t++) {
      const i = this.#ls / Math.cbrt(e[t]);
      (this.#fs.push(i), this.#ms.push(i / this.#fs[1]));
    }
    ((this.#Yt = 0.2 * t.z + this.#zt.min.z), (this.#Zt = 0.8 * t.z + this.#zt.min.z));
  }
  #Os(t) {
    const e = t.z,
      i = this.#Ye.viewHeight,
      s = this.#Ye.fov,
      n = this.#zt.getCenter(new pt()).distanceTo(t),
      r = 2 * Math.max(n) * Math.tan((s * ut.DEG2RAD) / 2),
      a = this.#ms;
    this.#ps.length = 0;
    for (let t = 0; t < this.#fs.length; t++) {
      const e = this.#fs[t] * a[t];
      this.#ps.push((e * i) / Math.max(r, 1));
    }
    ((this.#us = ut.clamp(Math.abs(e - this.#Yt) / (this.#Zt - this.#Yt), 0, 1)),
      (this.#cs = ut.lerp(this.#Xe.MaxDistaneLimit, this.#ls, this.#us)),
      (this.#ds = this.#us < 1));
  }
  #Us() {
    let t;
    for (; !this.#Bi.isEmpty(); ) {
      const i = this.#Bi.read();
      if (i && !i.isDownloadingOrDecompressing(e) && !i.isCache(e)) {
        t = i;
        break;
      }
    }
    t && this.#Ze.load(this.#li, [t], e);
  }
  #qs(t, e) {
    if (!this.#Xe.MergeSplatsReqEnable) {
      let e = [];
      return (
        t.forEach((t) => {
          e.push(t);
        }),
        e
      );
    }
    t.sort((t, e) => t.parent.sequence - e.parent.sequence);
    let i = [],
      s = 0,
      n = [];
    for (let r = 0; r < t.length; ++r) {
      const a = t[r],
        o = a.parent,
        h = o.totalPoints;
      if (n.length > 0) {
        (n[n.length - 1].parent.endAddr != o.startAddr ||
          s + h > this.#Xe.MergeSplatsReqThreshold ||
          a.isLocalCache(e)) &&
          (i.push(n), (n = []), (s = 0));
      }
      (n.push(a), (s += h));
    }
    0 != n.length && (i.push(n), (n = []));
    let r = [];
    return (
      i.forEach((t) => {
        if (1 == t.length) r.push(t[0]);
        else if (t.length > 1) {
          let e = [];
          (t.forEach((t) => {
            e.push(t.parent);
          }),
            r.push(new Re(this.#li, e)));
        }
      }),
      r.sort(
        (t, e) =>
          (t.isNode ? t.parent.distanceToCameraSq : t.distanceToCameraSq) -
          (e.isNode ? e.parent.distanceToCameraSq : e.distanceToCameraSq),
      ),
      r
    );
  }
  load(t = {}) {
    const {
      dataPath: e,
      metaSuccessFunc: i,
      successFunc: s,
      progressFunc: n,
      failureFunc: r,
      checkFuncSplats: a,
      preProcessFunc: o,
    } = t;
    if (!this.#Qe || !e) return;
    ((this.#Qe = !1),
      (this.#xi = s),
      (this.#vi = n),
      (this.#bi = r),
      (this.#wi = a),
      this.#Ze.init(this.#li, e, { preProcessFunc: o }));
    const h = (t, e, s) => {
      if (
        (this.#Ks(t),
        this.#Ze.setRenderInfoMeta(this.#li, this.#ti, () => {
          ((this.#$i = !0), this.setConfigDirty());
        }),
        this.#Vs(),
        this.#Gs(e),
        this.#Ws(s),
        (this.#$t = this.#Qs()),
        this.#zs(),
        this.#oi)
      ) {
        const t = 0 == this.#hi ? this.#Ms : this.#Cs;
        console.log('full rendering: ' + t);
      }
      ((this.#di = !0), i && i(this.meta), (this.#ts = !0), (this.#fi = !0));
    };
    this.#Ze.loadMetaIndex(
      this.#li,
      (t, e, i) => {
        if (!this.#We)
          try {
            h(t, e, i);
          } catch (t) {
            (console.error('parser failed: ', t), xt(r));
          }
      },
      () => {
        this.#We || xt(r);
      },
    );
  }
  #Xs(t) {
    this.#We ||
      (this.#Xe.useLccCompress &&
        this.#di &&
        this.#$i &&
        (t !== h || this.#Xe.hasSH) &&
        (this.#K.queryLut(this.#li, t) ||
          this.#yi[t] ||
          ((this.#yi[t] = !0),
          this.#Ze.loadLut(this.#ti.guid, this.#li, t, (e) => {
            this.#yi[t] = !1;
          }))));
  }
  #Ys() {
    if (!this.#zt) return void console.error('bbox is null');
    const t = this.#zt.min,
      e = this.#zt.max,
      i = new ee(t.x, t.y),
      s = new ee(t.x, e.y),
      n = new ee(e.x, t.y),
      r = new ee(e.x, t.y),
      a = i.dot(i),
      o = s.dot(s),
      h = n.dot(n),
      l = r.dot(r),
      c = Math.max(a, o, h, l);
    ((this.#ei = Math.sqrt(c)), console.log('maximum roaming distance: ', this.#ei));
  }
  loadSH(t, e, i) {
    return this.hasSH
      ? this.#Wi
        ? (console.error('loadSH is busy !!!'), void (i && i()))
        : ((this.#Si = t), (this.#Mi = e), (this.#Ci = i), (this.#es = !0), void (this.#fi = !0))
      : (console.log('no sh data'), e && e(1), void (t && t()));
  }
  #Qs() {
    let t = [],
      e = this.#ni.length;
    for (let i = 0; i < e; i++)
      if (this.#ni[i]) {
        let e = this.#ni[i].length;
        for (let s = 0; s < e; s++) this.#ni[i][s] && ((this.#ni[i][s].sequence = t.length), t.push(this.#ni[i][s]));
      }
    return t;
  }
  setConfigDirty() {
    this.#fi = !0;
  }
  update(t) {
    ((this.#pi = !1),
      this.#di &&
        this.#$i &&
        (this.#ts && this.#Xs(o),
        this.#es && this.#Xs(h),
        this.#Gi && (this.#Zs(), this.#Js()),
        this.#Wi && (this.#$s(), this.#tn()),
        (this.#Ye.isCameraChanged || this.#Ze.isDownloadCompleted || this.#fi) &&
          (this.#Ls(this.#ts, this.#es),
          this.#ts && ((this.#ts = !1), (this.#Gi = !0), (this.#zi = this.#ki = this.#Li = Date.now())),
          this.#es && ((this.#es = !1), (this.#Wi = !0), (this.#Hi = this.#Oi = this.#ji = Date.now()))),
        this.#Xe.AlwaysDownloadAround && this.#Ze.checkNetworkIdle() && this.#Us(),
        this.#ss || (this.#ss = !!this.#K.queryEnv(this.#li)),
        (this.#fi = !1)));
  }
  #en() {
    let t = Math.floor((this.#_i.x - this.#ws.x) / this.#vs),
      e = Math.floor((this.#_i.y - this.#ws.y) / this.#bs);
    ((t = ut.clamp(t, 0, this.#si.x)), (e = ut.clamp(e, 0, this.#si.y)));
    const i = this.#Xe.MinValidSplatsInUnit,
      s = this.#Xe.MinValidSplatsInNode;
    if (this.#ni[t] && this.#ni[t][e]) {
      const n = this.#ni[t][e];
      if (n.totalPoints >= i && n.getLastNodePoints() >= s && n.initOneNodeExpect && !n.initOneNodeReady) return 0;
    }
    const n = Math.max(this.#si.x, this.#si.y) + 1;
    let r = this.#Ni > 0 ? this.#Ni : 1;
    for (;;) {
      const a = r + 2;
      if (a > n) break;
      const o = Dt(t, e, a);
      if (0 == o.length) break;
      let h = !0;
      for (const [t, e] of o) {
        if (t < 0 || t > this.#si.x || e < 0 || e > this.#si.y) continue;
        if (!this.#ni[t] || !this.#ni[t][e]) continue;
        const n = this.#ni[t][e];
        if (!(n.totalPoints < i || n.getLastNodePoints() < s) && n.initOneNodeExpect && !n.initOneNodeReady) {
          h = !1;
          break;
        }
      }
      if (!h) break;
      r = a;
    }
    return ((this.#Ni = r), r * Math.min(this.#vs, this.#bs));
  }
  #Hs(t) {
    (this.#Xe.loadingEffectCenter
      ? this.#_i.copy(this.#Xe.loadingEffectCenter).clamp(this.#ws, this.#Ss)
      : this.#_i.copy(t).clamp(this.#ws, this.#Ss),
      this.#Pt.dynamicState.scenePositionLocal.copy(this.#_i));
    const e = Math.max(Math.abs(this.#ws.x - this.#_i.x), Math.abs(this.#Ss.x - this.#_i.x)),
      i = Math.max(Math.abs(this.#ws.y - this.#_i.y), Math.abs(this.#Ss.y - this.#_i.y));
    this.#Ri = Math.sqrt(e * e + i * i);
  }
  #Zs() {
    const t = this.#Xe.useLccCompress ? 1 : 0,
      i = this.#Ei.length + this.#Ti.length + t,
      s = this.#Di + this.#Ii,
      n = Date.now(),
      r = (n - this.#Li) / 1e3,
      a = (n - this.#ki) / 1e3;
    this.#Li = n;
    let h = 0;
    if (0 == i)
      return (
        console.log('total is 0 !!!'),
        this.#vi && this.#vi(1),
        this.#xi && this.#xi(),
        (this.#Gi = !1),
        (this.#Qi = !0),
        (this.#Pt.dynamicState.loadingSwitch = 0),
        (this.#pi = !0),
        void (this.#Ji = !0)
      );
    if (((0 == this.#Ei.length || this.#Ei[0].isCache(e)) && (this.#Ji = !0), this.#wi)) {
      let t = 0;
      (this.#Xe.useLccCompress && this.#K.queryLut(this.#li, o) && t++,
        this.#Ei.forEach((i) => {
          i.isCache(e) && t++;
        }),
        this.#Ti.forEach((e) => {
          e.isCacheData() && t++;
        }));
      let i = 0;
      if (
        (this.#Xe.useLccCompress && this.#K.queryLut(this.#li, o) && i++,
        this.#Ei.forEach((t) => {
          this.#wi(t) && i++;
        }),
        this.#Ti.forEach((t) => {
          this.#wi(t) && i++;
        }),
        (h = 0.7 * t + 0.3 * i),
        !this.#Qi)
      ) {
        let t = 0;
        (this.#Ai.forEach((e) => {
          (e.initReady || this.#wi(e)) && (t++, (e.initReady = !0));
        }),
          t >= this.#Ai.length && (this.#Qi = !0));
      }
    } else if (
      (this.#Xe.useLccCompress && this.#K.queryLut(this.#li, o) && h++,
      this.#Ei.forEach((t) => {
        t.isCache(e) && h++;
      }),
      this.#Ti.forEach((t) => {
        t.isCacheData() && h++;
      }),
      !this.#Qi)
    ) {
      let t = 0;
      (this.#Ai.forEach((i) => {
        (i.initReady || i.isCache(e)) && (t++, (i.initReady = !0));
      }),
        t >= this.#Ai.length && (this.#Qi = !0));
    }
    const l = Math.max((-0.9 / 50) * a + 1, 0.1),
      c = 0.7 * i,
      u = Math.max((-0.9 / c) * this.#Ui + 1, 0.1),
      d = Math.min(l, u),
      f = (1e6 * (0.8 + 0.4 * Math.random()) * d * r) / s;
    ((this.#Ui += i * f),
      (this.#Ui = Math.min(this.#Ui, 0.95 * i)),
      h > this.#Ui && (this.#Ui = h),
      (h = Math.max(h, this.#Ui)));
    let p = (1 * h) / i;
    if (this.#Pt.dynamicState.loadingSwitch) {
      const t = this.#Qi ? this.#Ri : this.#en(),
        e = 2,
        i = this.#Ri / e;
      let s = Math.min(Math.max(1, (t - this.#Pt.dynamicState.loadingPointDistance) / 10), i);
      this.#Pt.dynamicState.loadingPointDistance < 30 && (s = Math.min(5, s));
      const o = ut.clamp(a / e, 0, 1);
      ((this.#Pt.dynamicState.loadingPointDistance += r * s),
        (this.#Pt.dynamicState.loadingPointDistance = Math.min(this.#Pt.dynamicState.loadingPointDistance, t)));
      const h = 2,
        l = (2 * Math.min(150, this.#Ri)) / (h * h);
      let c = 0;
      if (a > 1 && this.#Qi && p > 0.7) {
        this.#Xi || ((this.#Xi = !0), (this.#Yi = n));
        const t = (n - this.#Yi) / 1e3;
        ((c = ut.clamp(t / h, 0, 1)), (this.#Pt.dynamicState.loadingSplatDistance = Math.min(3e4, 0.5 * l * t * t)));
      }
      (this.#mi == this.#Pt.dynamicState.loadingSplatDistance &&
        this.#gi == this.#Pt.dynamicState.loadingPointDistance) ||
        ((this.#pi = !0),
        (this.#mi = this.#Pt.dynamicState.loadingSplatDistance),
        (this.#gi = this.#Pt.dynamicState.loadingPointDistance));
      const u = 0.8 + 0.06 * (this.#Zi - 0.5),
        d = 0.02;
      p = p * u + o * d + c * (1 - u - d);
    }
    (p > 0.998 && (p = 1),
      (p - this.#qi >= 0.001 || 1 == p) && (this.#vi && this.#vi(p), (this.#qi = p)),
      p >= 1 &&
        (this.#xi && this.#xi(),
        (this.#Gi = !1),
        (this.#Qi = !0),
        (this.#Pt.dynamicState.loadingSwitch = 0),
        (this.#pi = !0),
        (this.#Ji = !0)));
  }
  #$s() {
    const t = this.#Xe.useLccCompress && this.#Xe.hasSH ? 1 : 0,
      e = this.#Fi.length + t,
      s = this.#Pi,
      n = Date.now(),
      r = (n - this.#ji) / 1e3,
      a = (n - this.#Oi) / 1e3;
    this.#ji = n;
    let o = 0;
    if (0 == e)
      return (console.log('total-sh is 0 !!!'), this.#Mi && this.#Mi(1), this.#Si && this.#Si(), void (this.#Wi = !1));
    (this.#Fi.forEach((t) => {
      t.isCache(i) && o++;
    }),
      this.#Xe.useLccCompress && this.#Xe.hasSH && this.#K.queryLut(this.#li, h) && o++);
    const l = Math.max((-0.9 / 50) * a + 1, 0.1),
      c = 0.7 * e,
      u = Math.max((-0.9 / c) * this.#Ki + 1, 0.1),
      d = Math.min(l, u),
      f = (1e6 * (0.8 + 0.4 * Math.random()) * d * r) / s;
    ((this.#Ki += e * f),
      (this.#Ki = Math.min(this.#Ki, 0.95 * e)),
      o > this.#Ki && (this.#Ki = o),
      (o = Math.max(o, this.#Ki)));
    let p = (1 * o) / e;
    (p > 0.99 && (p = 1),
      (p - this.#Vi >= 0.001 || 1 == p) && (this.#Mi && this.#Mi(p), (this.#Vi = p)),
      p >= 1 && (this.#Si && this.#Si(), (this.#Wi = !1)));
  }
  #Js() {
    if (!this.#Gi) return;
    const t = Date.now();
    if (t - this.#zi < 3e3) return;
    ((this.#zi = t), this.#Xs(o));
    let i = [];
    (this.#Ei.forEach((t) => {
      !t || t.isDownloadingOrDecompressing(e) || t.isCache(e) || i.push(t);
    }),
      i.length > 0 && (console.log('Recovering downloading data ...'), this.#Ze.load(this.#li, i, e)));
    let s = [];
    (this.#Ti.forEach((t) => {
      !t || t.isDownloadingOrDecompressing(n) || t.isCacheData(n) || s.push(t);
    }),
      s.length > 0 && (console.log('Recovering downloading coll ...'), this.#Ze.load(this.#li, s, n)));
  }
  #tn() {
    if (!this.#Wi) return;
    const t = Date.now();
    if (t - this.#Hi < 3e3) return;
    ((this.#Hi = t), this.#Xs(h));
    let e = [];
    (this.#Fi.forEach((t) => {
      !t || t.isDownloadingOrDecompressing(i) || t.isCache(i) || e.push(t);
    }),
      e.length > 0 && (console.log('Recovering downloading sh ...'), this.#Ze.load(this.#li, e, i)));
  }
  dispose() {
    this.#We = !0;
    for (let t = 0; t < this.#$t.length; ++t) this.#$t[t].dispose();
    ((this.#ri = []),
      (this.#$t = []),
      (this.#ni = []),
      (this.#Ze = null),
      (this.#K = null),
      (this.#Pt = null),
      (this.#Ye = null));
  }
  #Ws(t) {
    if (!t) return;
    let e = new DataView(t),
      i = new Uint32Array(t),
      s = new Float32Array(t);
    const n = i[1],
      r = new pt(s[3], s[4], s[5]),
      a = new pt(s[6], s[7], s[8]),
      o = s[9],
      h = s[10],
      l = i[11];
    console.log('coll version: ' + n);
    const c = 0.1;
    (Math.abs(o - this.#vs) > c || Math.abs(h - this.#bs) > c || !vt(r, this.#ws, c) || !vt(a, this.#Ss, c)) &&
      (console.warn('coll data does not match !!!'),
      console.warn('detail-1: ', r, a, o, h),
      console.warn('detail-2: ', this.#ws, this.#Ss, this.#vs, this.#bs));
    let u = 48;
    for (let t = 0; t < l; ++t) {
      let t = e.getUint32(u, !0);
      u += 4;
      let i = e.getUint32(u, !0);
      u += 4;
      let s = e.getBigUint64(u, !0);
      u += 8;
      let n = Number(e.getBigUint64(u, !0));
      u += 8;
      let r = e.getUint32(u, !0);
      u += 4;
      let a = e.getUint32(u, !0);
      u += 4;
      let o = e.getUint32(u, !0);
      if (((u += 4), (u += 4), this.#ni[t] && this.#ni[t][i])) {
        this.#ni[t][i].setCollInfo(s, n, r, a, o);
      }
    }
    this.#is = !0;
  }
  #in(t) {
    ((t.x > this.#si.x || t.y > this.#si.y) &&
      ((this.#si.x = Math.max(t.x, this.#si.x)), (this.#si.y = Math.max(t.y, this.#si.y))),
      this.#ni[t.x] || (this.#ni[t.x] = []));
    let e = this.#ws.clone();
    ((e.x += t.x * this.#vs), (e.y += t.y * this.#bs));
    let i = e.clone();
    ((i.x += this.#vs),
      (i.y += this.#bs),
      (i.z = this.#Ss.z),
      (this.#ni[t.x][t.y] = new _e(this.#li, this.#Pt, t, e, i)));
  }
  #Gs(t) {
    let e = 0,
      i = new DataView(t);
    for (; !(e > i.byteLength - 1); ) {
      let t = {};
      ((t.x = i.getInt16(e, !0)), (e += 2), (t.y = i.getInt16(e, !0)), (e += 2), (t.lods = []));
      for (let s = 0; s < this.#qt; s++) {
        let s = i.getInt32(e, !0);
        e += 4;
        let n = i.getBigInt64(e, !0);
        e += 8;
        let r = i.getInt32(e, !0);
        ((e += 4), t.lods.push({ points: s, offset: n, size: r }));
      }
      this.#in(t);
    }
  }
  #sn(t) {
    let e = 0,
      i = new DataView(t),
      s = 0,
      n = 0,
      r = 0;
    for (; !(e > i.byteLength - 1); ) {
      let t = {};
      ((t.x = i.getInt16(e, !0)),
        (e += 2),
        (t.y = i.getInt16(e, !0)),
        (e += 2),
        (r = Math.max(t.x, t.y, r)),
        (t.lods = []));
      for (let t = 0; t < this.#qt; t++) {
        let t = i.getInt32(e, !0);
        ((e += 4), i.getBigInt64(e, !0), (e += 8));
        let r = i.getInt32(e, !0);
        ((e += 4), (s += t), (n += r));
      }
    }
    let a = { x: 0, y: 0, lods: [{ points: s, offset: BigInt(0), size: n }] };
    ((this.#ti.cellLengthX *= r),
      (this.#ti.cellLengthY *= r),
      console.log('this.#cellLengthX this.#cellLengthX', this.#vs, this.#bs),
      this.#in(a));
  }
  #Ks(t) {
    t = t.replace(/,[\s\t\r\n]*}/g, '}');
    let e = JSON.parse(t);
    ((this.#ns = JSON.parse(t)),
      console.log('meta-ver: ', e.version),
      e.version &&
        (function (t, e) {
          const i = t.split('.').map(Number),
            s = e.split('.').map(Number),
            n = Math.max(i.length, s.length);
          for (let t = 0; t < n; t++) {
            const e = i[t] || 0,
              n = s[t] || 0;
            if (e > n) return !0;
            if (e < n) return !1;
          }
          return !0;
        })(e.version, '5.0') &&
        (this.#Xe.useEdgeCrop = !0),
      (e.min = new pt(e.boundingBox.min[0], e.boundingBox.min[1], e.boundingBox.min[2])),
      (e.max = new pt(e.boundingBox.max[0], e.boundingBox.max[1], e.boundingBox.max[2])));
    const i = {};
    e.attributes.forEach((t) => {
      i[t.name] = t;
    });
    const s = i.scale.min,
      n = i.scale.max,
      r = i.opacity.min,
      a = i.opacity.max,
      o = i.shcoef.min,
      h = i.shcoef.max,
      l = i.normal.min,
      c = i.normal.max,
      u = i.position.min,
      d = i.position.max,
      f = {
        compressedScaleMin: new pt(s[0], s[1], s[2]),
        compressedScaleMax: new pt(n[0], n[1], n[2]),
        compressedSHMin: new pt(o[0], o[1], o[2]),
        compressedSHMax: new pt(h[0], h[1], h[2]),
        compressedOpacityMin: r[0],
        compressedOpacityMax: a[0],
        compressedNormalMin: new pt(l[0], l[1], l[2]),
        compressedNormalMax: new pt(c[0], c[1], c[2]),
        positionMin: new pt(u[0], u[1], u[2]),
        positionMax: new pt(d[0], d[1], d[2]),
      };
    if ((this.#nn(i, f), Object.assign(e, { compressInfo: f }), this.#rn(e), this.#an(e), !e.guid)) {
      const i = (function (t, e = 0) {
        let i = e ^ t.length;
        for (let e = 0; e < t.length; e++) {
          let s = t.charCodeAt(e);
          ((s = Math.imul(s, 3432918353)),
            (s = (s << 15) | (s >>> 17)),
            (s = Math.imul(s, 461845907)),
            (i ^= s),
            (i = (i << 13) | (i >>> 19)),
            (i = Math.imul(i, 5) + 3864292196));
        }
        return (
          (i ^= t.length),
          (i ^= i >>> 16),
          (i = Math.imul(i, 2246822507)),
          (i ^= i >>> 13),
          (i = Math.imul(i, 3266489909)),
          (i ^= i >>> 16),
          (i >>> 0).toString(16)
        );
      })(t);
      e.guid = i;
    }
    ((this.#ti = e),
      (this.#Pt.meta = this.#ti),
      (this.#zt = new ie(e.min, e.max)),
      (this.#jt = new pt()),
      this.#zt.getCenter(this.#jt),
      (this.#ii = new ie(u, d)),
      (this.#rs = Math.abs(e.max.x - e.min.x)),
      (this.#as = Math.abs(e.max.y - e.min.y)),
      (this.#ti.webInfos = { data: {}, env: {} }),
      (this.#ti.webInfos.data.compressedScaleMax = f.compressedScaleMax || new pt(2, 2, 2)),
      (this.#ti.webInfos.data.compressedScaleMin = f.compressedScaleMin || new pt(1, 1, 1)),
      (this.#ti.webInfos.data.compressedSHMax = f.compressedSHMax || new pt(1, 1, 1)),
      (this.#ti.webInfos.data.compressedSHMin = f.compressedSHMin || new pt(0, 0, 0)),
      (this.#ti.webInfos.data.compressedNormalMax = f.compressedNormalMax || new pt(0, 0, 1)),
      (this.#ti.webInfos.data.compressedNormalMin = f.compressedNormalMin || new pt(0, 0, 1)),
      (this.#ti.webInfos.env.compressedScaleMax = f.compressedEnvScaleMax || this.#ti.webInfos.data.compressedScaleMax),
      (this.#ti.webInfos.env.compressedScaleMin = f.compressedEnvScaleMin || this.#ti.webInfos.data.compressedScaleMin),
      (this.#ti.webInfos.env.compressedSHMax = f.compressedEnvSHMax || this.#ti.webInfos.data.compressedSHMax),
      (this.#ti.webInfos.env.compressedSHMin = f.compressedEnvSHMin || this.#ti.webInfos.data.compressedSHMin),
      (this.#ti.webInfos.env.compressedNormalMax =
        f.compressedEnvNormalMax || this.#ti.webInfos.data.compressedNormalMax),
      (this.#ti.webInfos.env.compressedNormalMin =
        f.compressedEnvNormalMin || this.#ti.webInfos.data.compressedNormalMin));
  }
  #nn(t, e) {
    const i = t?.envscale;
    if (i) {
      const { min: t, max: s } = i;
      ((e.compressedEnvScaleMin = new pt(t[0], t[1], t[2])), (e.compressedEnvScaleMax = new pt(s[0], s[1], s[2])));
    }
    const s = t?.envshcoef;
    if (s) {
      const { min: t, max: i } = s;
      ((e.compressedEnvSHMin = new pt(t[0], t[1], t[2])), (e.compressedEnvSHMax = new pt(i[0], i[1], i[2])));
    }
    const n = t?.envnormal;
    if (n) {
      const { min: t, max: i } = n;
      ((e.compressedEnvNormalMin = new pt(t[0], t[1], t[2])), (e.compressedEnvNormalMax = new pt(i[0], i[1], i[2])));
    }
  }
  #rn(t) {
    t.hasSH = !0;
    const e = t.fileType;
    (e && 'Portable' === e && (t.hasSH = !1), (this.#Xe.hasSH = t.hasSH));
  }
  #an(t) {
    const e = t.environment;
    !e || ('Splat' !== e && 'Both' !== e) || (this.#ss = !0);
    const i = t.semanticType;
    (i &&
      ('Null' === i
        ? ((this.#Xe.semanticType = u), (this.#Xe.hasSemantic = !1))
        : 'Type' === i
          ? ((this.#Xe.semanticType = d), (this.#Xe.semanticDataSize = 2), (this.#Xe.hasSemantic = !0))
          : 'Instance' === i
            ? ((this.#Xe.semanticType = f), (this.#Xe.semanticDataSize = 2), (this.#Xe.hasSemantic = !0))
            : 'Both' === i &&
              ((this.#Xe.semanticType = p), (this.#Xe.semanticDataSize = 4), (this.#Xe.hasSemantic = !0)),
      null != t.semanticOffset && (this.#Xe.semanticFileOffset = t.semanticOffset)),
      t.gridDelta && (this.#Xe.gridDelta = t.gridDelta),
      t.gridSizeX && (this.#Xe.gridSize = t.gridSizeX));
  }
  #on() {
    const t = this.#Pt.lccParam.renderLib,
      e = this.#Pt.lccParam.scene,
      i = new t.PlaneGeometry(this.#vs, this.#bs),
      s = new t.MeshBasicMaterial({
        color: 65280,
        transparent: !0,
        opacity: 0.3,
        depthWrite: !1,
        depthTest: !1,
        side: t.DoubleSide,
      }),
      n = new t.Mesh(i, s),
      r = [16711680, 65280, 255];
    for (let t = 0; t < this.#$t.length; ++t) {
      const e = this.#$t[t].center,
        i = r[((this.#$t[t].x % r.length) + (this.#$t[t].y % r.length)) % r.length],
        a = n.clone();
      (a.position.set(e.x, e.y, 0.5), (a.material = s.clone()), a.material.color.set(i), this.#$e.push(a));
    }
    ((this.#Je = new t.Group()), (this.#Je.renderOrder = 1), e.add(this.#Je));
  }
  #hn(t) {
    (this.#Je.clear(),
      t.forEach((t) => {
        t && this.#Je.add(this.#$e[t.parent.sequence]);
      }));
  }
}
const oi = {
    modelMatrix: 'czm_model',
    projectionMatrix: 'czm_projection',
    modelViewMatrix: 'czm_modelView',
    gl_FragColor: 'out_FragColor',
  },
  hi = {
    modelMatrix: 'modelMatrix',
    projectionMatrix: 'projectionMatrix',
    modelViewMatrix: 'modelViewMatrix',
    viewMatrix: 'viewMatrix',
    gl_FragColor: 'gl_FragColor',
  };
function li(t) {
  const { vertexShaderCommon: e } = {
      vertexShaderCommon:
        '\n    precision highp int;\n    precision highp float;\n\n    uniform vec2 viewport;\n    uniform vec2 heightRange;\n    uniform vec3 cmrPos;\n    uniform vec3 scPos;\n\n    uniform vec4 use0;\n    uniform vec4 use1;\n    uniform vec4 use2;\n    uniform vec4 use3;\n    \n    uniform mat4 vmat;\n    uniform mat4 clipBoxMatrixInv;\n\n    uniform sampler2D customColors;\n\n    uniform sampler2D semanticColors;\n\n    #ifdef LCC_COMPRESSED\n        uniform sampler2D lutScaleTexture;\n        uniform sampler2D lutShTexture;\n\n        #ifdef HAS_NOT_ATTRIBUTE_POSITION\n            uniform sampler2D shRawTexture;\n            uniform sampler2D semanticTexture;\n        #else\n            uniform isampler2D shRawTexture;\n            uniform isampler2D semanticTexture;\n        #endif\n    #else\n        uniform vec3 compressedScaleMax;\n        uniform vec3 compressedScaleMin;\n        uniform vec3 compressedSHMin;\n        uniform vec3 compressedSHMax;\n\n        uniform sampler2D shRawTexture;\n    #endif\n\n    #ifdef HAS_NOT_ATTRIBUTE_POSITION\n        in vec3 position;\n        uniform sampler2D splatIndexesHost;\n        uniform sampler2D splatData;\n        #ifdef IS_RTK\n            uniform mat3 prj2ECEF;\n            uniform mat3 prj2ECEF_INV;\n        #endif\n    #else\n        uniform isampler2D splatIndexesHost;\n        uniform usampler2D splatData;\n        uniform mat4 ndc2local;\n    #endif\n\n \n    out vec3 vp;\n    out mediump vec4 vColor;\n    out mediump vec2 vPosition;\n\n    #ifdef LCC_RD\n        out vec4 vConic;\n        out vec2 vSplatCoord;\n    #endif\n    \n    const mediump vec4 discardVec = vec4(0.0, 0.0, 2.0, 1.0);\n    const float SQRT_2 = 1.414213562373095;\n    const float SQRT_2_inv = 0.7071067811865475;\n    const float COLOR_NORM = 1.0 / 255.0;\n    const float SCALE_NORM  = 1.0 / 65535.0;\n    const float ROT_NORM = 1.0 / 1023.0;\n    // const mediump vec4 effColor = vec4(1.0, 0.953, 0.2, 1.0);\n    // const mediump vec4 effColor = vec4(0.8, 0.8, 0.8, 0.8);\n    const mediump vec4 effColor = vec4(1.0, 1.0, 0.0, 1.0);\n    const float RENDER_MIN_ALPHA = 1.0f / 255.0f;\n\n    const mat4 QUAT_TAB = mat4(\n        3., 0., 1., 2.,\n        0., 3., 1., 2.,\n        0., 1., 3., 2.,\n        0., 1., 2., 3.\n    );\n\n    #ifdef LCC_COMPRESSED\n        const int LUT_SCALE_TEX_DIMENSION = 1024;\n        const int LUT_SH_TEX_DIMENSION = 4096;\n    #endif\n\n    mat3 calculateCov(in vec3 scale, in uint rotateEnc)\n    {\n        vec3 rotation = vec3((uvec3(rotateEnc) >> uvec3(0, 10, 20)) & 1023u) * ROT_NORM;\n        uint idx = (rotateEnc >> 30u) & 3u;\n        uvec4 seq = uvec4(QUAT_TAB[idx]);\n    \n        vec4 q;\n        q.xyz = vec3(rotation.xyz) * SQRT_2 - SQRT_2_inv;\n        q.w = sqrt(max(0.0, 1.0 - dot(q.xyz, q.xyz)));\n    \n        float x = q[seq[0]];\n        float y = q[seq[1]];\n        float z = q[seq[2]];\n        float w = q[seq[3]];\n        float sx = scale.x;\n        float sy = scale.y;\n        float sz = scale.z;\n\n        float x2 = x + x, y2 = y + y, z2 = z + z;\n        float xx = x * x2, yy = y * y2, zz = z * z2;\n        float xy = x * y2, xz = x * z2, yz = y * z2;\n        float wx = w * x2, wy = w * y2, wz = w * z2;\n\n        // scale * rot\n        mat3 ret = mat3(\n            sx * (1.0 - yy - zz),    sy * (xy - wz),          sz * (xz + wy),\n            sx * (xy + wz),          sy * (1.0 - xx - zz),    sz * (yz - wx),\n            sx * (xz - wy),          sy * (yz + wx),          sz * (1.0 - xx - yy)\n        );\n\n        #ifdef IS_RTK         \n            ret = ret * transpose(mat3(prj2ECEF));\n        #endif\n        ret = transpose(ret) * ret;\n    \n        return ret;\n    }\n\n    vec4 decodeColor(uint colorv) {\n        uvec4 rgba = (uvec4(colorv) >> uvec4(0, 8, 16, 24)) & 255u;\n        return vec4(rgba) * COLOR_NORM;\n    }\n\n    #ifdef LCC_COMPRESSED\n        mat3 decodeCov(uint scaleEnc, uint rotateEnc)\n        {\n            int scaleK = int((scaleEnc >> 14u) & 0x1FFFFu);\n            \n            ivec2 uv = ivec2(int(scaleK % LUT_SCALE_TEX_DIMENSION), int(scaleK / LUT_SCALE_TEX_DIMENSION));\n            vec3 scale = texelFetch(lutScaleTexture, uv, 0).xyz;\n\n            return calculateCov(scale, rotateEnc);\n        }\n\n        uint decodeSemantic(int idx)\n        {\n            int semDimensions = int(vmat[0][3]);\n\n            ivec2 semUV = ivec2(idx % semDimensions, idx / semDimensions);\n\n            #ifdef HAS_NOT_ATTRIBUTE_POSITION\n                uint k = floatBitsToUint(texelFetch(semanticTexture, semUV, 0).r);\n            #else\n                uint k = uint(texelFetch(semanticTexture, semUV, 0).r);\n            #endif\n\n            k = k & 65535u;\n\n            return k;\n        }\n    #else\n        mat3 decodeCov(uint r, uint g, uint b)\n        {\n            uvec3 value = uvec3(r, (r >> 16), g) & 65535u;\n            vec3 scale = mix(compressedScaleMin, compressedScaleMax, vec3(value) * SCALE_NORM);\n            uint rotateEnc = ((b & 65535u) << 16 ) | ((g >> 16) & 65535u);\n\n            return calculateCov(scale, rotateEnc);\n        }\n\n        uint decodeSemantic(uint b)\n        {\n            uint id = ((b >> 16) & 65535u);\n            return id;\n        }\n    #endif\n\n    float splatVsBox(vec3 pos, float clipBoxSide) {\n        vec3 localPos = (clipBoxMatrixInv * vec4(pos, 1.0)).xyz;\n        vec3 distance = abs(localPos) - vec3(0.5);\n        float outsideDist = length(max(distance, vec3(0.0)));\n        float insideDist = min(max(distance.x, max(distance.y, distance.z)), 0.0);\n        \n        return (outsideDist + insideDist) * clipBoxSide;\n    }\n\n    float fastHash(int id) {\n        uint x = uint(id);\n        x = (x ^ (x >> 16)) * 0x45d9f3bu;\n        x = (x ^ (x >> 16)) * 0x45d9f3bu;\n        x = x ^ (x >> 16);\n        return float(x) / 4294967296.0;\n    }\n\n    ',
    },
    { vertexShaderMain: i, vertexShaderPoints: s } = (function (t) {
      const { modelViewMatrix: e, projectionMatrix: i, viewMatrix: s, modelMatrix: n } = t;
      return {
        vertexShaderMain: `\n    int order = gl_InstanceID * int(vmat[3][1]) + int(position.z);\n    if (order >= int(splatCount)) {\n        gl_Position = discardVec;\n        return;\n    }\n    ivec2 splatUV = ivec2(order % dimensions, order / dimensions);\n\n    #ifdef HAS_NOT_ATTRIBUTE_POSITION\n        int idx = int(texelFetch(splatIndexesHost, splatUV, 0).r);\n    #else\n        int idx = texelFetch(splatIndexesHost, splatUV, 0).r;\n    #endif\n\n    #ifdef LCC_COMPRESSED\n        uint odd = uint(idx & 1);\n        int basePixel = (idx / 2) * 3;\n        ivec2 uv0 = ivec2(basePixel % dataDimensions, basePixel / dataDimensions);\n        ivec2 uv1 = ivec2((basePixel + 1) % dataDimensions, (basePixel + 1) / dataDimensions);\n        ivec2 uv2 = ivec2((basePixel + 2) % dataDimensions, (basePixel + 2) / dataDimensions);\n\n        #ifdef HAS_NOT_ATTRIBUTE_POSITION\n            vec4 pixel0 = texelFetch(splatData, uv0, 0);\n            vec4 pixel1 = texelFetch(splatData, uv1, 0);\n            vec4 pixel2 = texelFetch(splatData, uv2, 0);\n\n            vec3 sampledTransformA = pixel0.xyz;\n            uint scaleEncA = floatBitsToUint(pixel0.w);\n            uint rotateEncA = floatBitsToUint(pixel1.x);\n            uint colorA = floatBitsToUint(pixel1.y);\n\n            vec3 sampledTransformB = vec3(pixel1.zw, pixel2.x);\n            uint scaleEncB = floatBitsToUint(pixel2.y);\n            uint rotateEncB = floatBitsToUint(pixel2.z);\n            uint colorB = floatBitsToUint(pixel2.w);\n        #else\n            uvec4 pixel0 = texelFetch(splatData, uv0, 0);\n            uvec4 pixel1 = texelFetch(splatData, uv1, 0);\n            uvec4 pixel2 = texelFetch(splatData, uv2, 0);\n\n            vec3 sampledTransformA = uintBitsToFloat(pixel0.xyz);\n            uint scaleEncA = pixel0.w;\n            uint rotateEncA = pixel1.x;\n            uint colorA = pixel1.y;\n\n            vec3 sampledTransformB = uintBitsToFloat(uvec3(pixel1.zw, pixel2.x));\n            uint scaleEncB = pixel2.y;\n            uint rotateEncB = pixel2.z;\n            uint colorB = pixel2.w;\n        #endif\n\n        uint scaleEnc = scaleEncA * (1u - odd) + scaleEncB * odd;\n        uint rotateEnc = rotateEncA * (1u - odd) + rotateEncB * odd;\n        uint color = colorA * (1u - odd) + colorB * odd;\n        vec3 sampledTransform = mix(sampledTransformA, sampledTransformB, float(odd));\n    #else\n\n        int idxNew = idx * 2;\n        int x1 = idxNew % dataDimensions;\n        int y1 = idxNew / dataDimensions;\n\n        #ifdef HAS_NOT_ATTRIBUTE_POSITION\n            vec4 pixel0 = texelFetch(splatData, ivec2(x1, y1), 0);\n            vec3 sampledTransform = pixel0.xyz;\n            uint color = floatBitsToUint(pixel0.w);\n        #else\n            uvec4 pixel0 = texelFetch(splatData, ivec2(x1, y1), 0);\n            vec3 sampledTransform = uintBitsToFloat(pixel0.xyz);\n            uint color = pixel0.w;\n        #endif\n    #endif\n\n    vec4 viewCenter = ${e} * vec4(sampledTransform, 1.0);\n    vec4 clipCenter = ${i} * viewCenter;\n\n    float bounds = 1.2 * clipCenter.w;\n    vec2 absClip = abs(clipCenter.xy);\n    if (clipCenter.z < -clipCenter.w || max(absClip.x, absClip.y) > bounds) {\n        gl_Position = discardVec;\n        return;\n    }\n\n    if ((use1[0] > 0.5) && splatVsBox(sampledTransform, use1[1]) > 0.0) {\n         gl_Position = discardVec;\n         return;\n    }\n\n    #ifdef LCC_COMPRESSED\n        mat3 Vrk = decodeCov(scaleEnc, rotateEnc);\n    #else\n        #ifdef HAS_NOT_ATTRIBUTE_POSITION\n            uvec4 pixel1 = floatBitsToUint(texelFetch(splatData, ivec2(x1 + 1, y1), 0));\n        #else\n            uvec4 pixel1 = texelFetch(splatData, ivec2(x1 + 1, y1), 0);\n        #endif\n\n        mat3 Vrk = decodeCov(pixel1.r, pixel1.g, pixel1.b);\n    #endif\n\n\n    #ifdef HAS_NOT_ATTRIBUTE_POSITION\n        float focal = viewport.y / 2.0 * ${i}[1][1];\n        float s = 1.0 / (viewCenter.z * viewCenter.z);\n        mat3 J = mat3(\n            focal / viewCenter.z, 0., -(focal * viewCenter.x) * s,\n            0., focal / viewCenter.z, -(focal * viewCenter.y) * s,\n            0., 0., 0.\n        );\n\n    #else\n\n        mat3 J;\n        if (isOrthographic) {\n            float focal = viewport.x * 0.5 * ${i}[0][0];\n            J = mat3(\n                focal, 0., 0.,\n                0., focal, 0.,\n                0., 0., 0.\n            );\n        } else {\n            float focal = viewport.y / 2.0 * ${i}[1][1];\n            float s = 1.0 / (viewCenter.z * viewCenter.z);\n            J = mat3(\n                focal / viewCenter.z, 0., -(focal * viewCenter.x) * s,\n                0., focal / viewCenter.z, -(focal * viewCenter.y) * s,\n                0., 0., 0.\n            );\n        }\n    #endif\n    \n    mat3 W = transpose(mat3( ${e} ));\n    mat3 T = W * J;\n    mat3 cov2Dm = transpose(T) * Vrk * T;\n\n    float det_0 = cov2Dm[0][0] * cov2Dm[1][1] - cov2Dm[0][1] * cov2Dm[0][1];\n    #ifndef LCC_RD\n        if (det_0 <= 0.005) {\n            gl_Position = discardVec;\n            return;\n        }\n    #endif\n\n    cov2Dm[0][0] += 0.1;\n    cov2Dm[1][1] += 0.1;\n\n    vec3 cov2d = vec3(cov2Dm[0][0], cov2Dm[0][1], cov2Dm[1][1]);\n    float a = cov2d.x;\n    float b = cov2d.y;\n    float d = cov2d.z;\n    float mid = 0.5 * (a + d);\n    float radius = length(vec2((a - d) / 2.0, b));\n    float eigenValue1 = mid + radius;\n    float eigenValue2 = max(mid - radius, 0.1);\n\n    float det_1 = a * d - b * b;\n    float coef = sqrt(det_0 / (det_1 + 1e-6) + 1e-6);\n\n    vColor = decodeColor(color);\n    vColor.a *= coef;\n    if (vColor.a < RENDER_MIN_ALPHA) {\n        gl_Position = discardVec;\n        return;\n    }\n    \n    if (use2[3] > 0.5) {\n        #ifdef LCC_COMPRESSED\n            uint semid = decodeSemantic(idx);\n        #else\n            uint semid = decodeSemantic(pixel1.b);\n        #endif\n        vec4 semColor = texelFetch(semanticColors, ivec2(int(semid % 100u), 0), 0).rgba;\n        float semK = mix(0.0, 0.3, step(2.0, float(semid)));\n        vColor = mix(vColor, semColor, semK);\n    }\n\n    float transparentAdjust = step(0.00393, vColor.a);\n    // eigenValue2 = eigenValue2 * transparentAdjust;\n\n    float ssk1 = 0.0, ssk2 = 1.0, ssk3 = 1.0;\n    if (use3[0] > 0.5) {\n        vec3 sampledTransformLocal = sampledTransform.xyz;\n        #ifdef IS_RTK\n            sampledTransformLocal = prj2ECEF_INV * sampledTransformLocal;\n        #endif\n        vec3 sp = scPos - sampledTransformLocal;\n        float ss = dot(sp.xy, sp.xy) / 100.0;\n\n        float rel1 = sqrt(use3[1] * 100.0) + 0.15;\n        float rel2 = max(sqrt(use3[2] * 100.0) - 0.15, 0.0);\n        float thresh1 = rel1 * rel1 / 100.0;\n        float thresh2 = rel2 * rel2 / 100.0;\n\n        ssk1 = step(use3[1], ss);\n        ssk2 = step(ss, max(thresh1, use3[2]));\n        ssk3 = max(step(fastHash(gl_InstanceID % 1024), use3[3] / 1024.0), 1.0 - ssk1);\n\n        // float colorsel = (1.0 - ssk1) * step(rel * rel / 100.0, ss);\n        // vColor = mix(vColor, vColor + 0.2, colorsel);\n\n        float colorsel = ssk1 * step(ss, thresh1);\n        float colorsel2 = ssk1 * step(thresh2, ss);\n        vColor = mix(vColor, effColor, max(colorsel, colorsel2));\n    }\n\n    #ifndef LCC_RD\n        float k = min(1.0, sqrt(-log(1.0 / 255.0 / vColor.a)) / 2.0) * ssk2 * ssk3;\n        float l1 = 2.0 * min(sqrt(2.0 * eigenValue1), 1024.0) * transparentAdjust * k;\n        float l2 = 2.0 * min(sqrt(2.0 * eigenValue2), 1024.0) * transparentAdjust * k;\n        if (max(l1, l2) < 1.0) {\n            gl_Position = discardVec;\n            return;\n        }\n\n        vec2 eigenVector1 = normalize(vec2(b, eigenValue1 - a));\n        vec2 eigenVector2 = vec2(eigenVector1.y, -eigenVector1.x);\n\n        vec2 basisVector1 = eigenVector1 * l1;\n        vec2 basisVector2 = eigenVector2 * l2;\n\n        vec2 ndcOffset = vec2(position.x * basisVector1 + position.y * basisVector2) / viewport * 2.0;\n        vPosition = position.xy * 2.0 * k;\n\n        ndcOffset = mix(ndcOffset, position.xy * 0.0025, ssk1);\n        vColor.a = mix(vColor.a, 1.0, ssk1);\n\n        vec3 ndcCenter = clipCenter.xyz / clipCenter.w;\n        vec4 outputPos = vec4(ndcCenter.xy + ndcOffset, ndcCenter.z, 1.0) * clipCenter.w;\n\n    #else\n\n        float det_inv = 1.0 / det_1;\n        vConic = vec4(\n            cov2Dm[1][1] * det_inv,\n            -cov2Dm[0][1] * det_inv,\n            cov2Dm[0][0] * det_inv,\n            vColor.a\n        );\n        float tmp = 2.0 * log(1.0 / 255.0 / vColor.a) / (vConic.y * vConic.y - vConic.x * vConic.z);\n        float dx = min(sqrt(max(0.0, vConic.z * tmp)) + 0.01, 1024.);\n        float dy = min(sqrt(max(0.0, vConic.x * tmp)) + 0.01, 1024.);\n        vec2 ndcOffset = vec2(position.x * dx, position.y * dy) / viewport * 2.0;\n\n        ndcOffset = mix(ndcOffset, position.xy * 0.0025, ssk1);\n        vColor.a = mix(vColor.a, 1.0, ssk1);\n\n        vec3 ndcCenter = clipCenter.xyz / clipCenter.w;\n        vec4 outputPos = vec4(ndcCenter.xy + ndcOffset, ndcCenter.z, 1.0) * clipCenter.w;\n\n        vSplatCoord = (ndcCenter.xy * 0.5 + 0.5) * viewport;\n    #endif\n\n    \n    \n    #ifdef HAS_NOT_ATTRIBUTE_POSITION\n        vp =  (czm_inverseModelViewProjection * outputPos).xyz;\n    #else\n        vp = (ndc2local * outputPos).xyz;\n    #endif\n\n    gl_Position = outputPos;\n\n`,
        vertexShaderPoints: `\n    int order = gl_InstanceID * int(vmat[3][1]) + int(position.z);\n    if (order >= int(splatCount)) {\n        gl_Position = discardVec;\n        return;\n    }\n    ivec2 splatUV = ivec2(order % dimensions, order / dimensions);\n\n    #ifdef HAS_NOT_ATTRIBUTE_POSITION\n        int idx = int(texelFetch(splatIndexesHost, splatUV, 0).r);\n    #else\n        int idx = texelFetch(splatIndexesHost, splatUV, 0).r;\n    #endif\n\n    #ifdef LCC_COMPRESSED\n        uint odd = uint(idx & 1);\n        int basePixel = (idx / 2) * 3;\n        ivec2 uv0 = ivec2(basePixel % dataDimensions, basePixel / dataDimensions);\n        ivec2 uv1 = ivec2((basePixel + 1) % dataDimensions, (basePixel + 1) / dataDimensions);\n        ivec2 uv2 = ivec2((basePixel + 2) % dataDimensions, (basePixel + 2) / dataDimensions);\n\n        #ifdef HAS_NOT_ATTRIBUTE_POSITION\n            vec4 pixel0 = texelFetch(splatData, uv0, 0);\n            vec4 pixel1 = texelFetch(splatData, uv1, 0);\n            vec4 pixel2 = texelFetch(splatData, uv2, 0);\n\n            uint colorA = floatBitsToUint(pixel0.z);\n            vec3 sampledTransformA = vec3(pixel0.w, pixel1.xy);\n\n            uint colorB = floatBitsToUint(pixel2.x);\n            vec3 sampledTransformB = vec3(pixel2.yzw);\n        #else\n            uvec4 pixel0 = texelFetch(splatData, uv0, 0);\n            uvec4 pixel1 = texelFetch(splatData, uv1, 0);\n            uvec4 pixel2 = texelFetch(splatData, uv2, 0);\n\n            uint colorA = pixel0.z;\n            vec3 sampledTransformA = uintBitsToFloat(uvec3(pixel0.w, pixel1.xy));\n\n            uint colorB = pixel2.x;\n            vec3 sampledTransformB = uintBitsToFloat(pixel2.yzw);\n        #endif\n\n        uint color = colorA * (1u - odd) + colorB * odd;\n        vec3 sampledTransform = mix(sampledTransformA, sampledTransformB, float(odd));\n\n    #else\n\n        int idxNew = idx * 2;\n        int x1 = idxNew % dataDimensions;\n        int y1 = idxNew / dataDimensions;\n\n        #ifdef HAS_NOT_ATTRIBUTE_POSITION\n            vec4 pixel0 = texelFetch(splatData, ivec2(x1, y1), 0);\n            vec3 sampledTransform = pixel0.xyz;\n            uint color = floatBitsToUint(pixel0.w);\n        #else\n            uvec4 pixel0 = texelFetch(splatData, ivec2(x1, y1), 0);\n            vec3 sampledTransform = uintBitsToFloat(pixel0.xyz);\n            uint color = pixel0.w;\n        #endif\n    #endif\n\n    if ((use1[0] > 0.5) && splatVsBox(sampledTransform.xyz, use1[1]) > 0.0) {\n        gl_Position = discardVec;\n        return;\n    }\n\n    vec4 viewCenter = ${e} * vec4(sampledTransform.xyz, 1.0);\n    vec4 clipCenter = ${i} * viewCenter;\n\n    if (use0[2] > 0.0) {\n        vec3 sampledTransformLocal = sampledTransform.xyz;\n        #ifdef IS_RTK\n            sampledTransformLocal = prj2ECEF_INV * sampledTransformLocal;\n        #endif\n        float lerp = (sampledTransformLocal.z - heightRange.x) / (heightRange.y - heightRange.x) * 0.99;\n        vColor = vec4(texture(customColors, vec2(lerp, 0.4)));\n    } else {\n        vColor = decodeColor(color);\n    }\n\n    vp = vec3(0.);\n    vPosition = vec2(0., 0.);\n\n    vec3 ndcCenter = clipCenter.xyz / clipCenter.w;\n    gl_Position = vec4(ndcCenter.xy + position.xy * 0.001 , ndcCenter.z, 1.0) * clipCenter.w;\n\n`,
      };
    })(t),
    { modelMatrix: n } = t;
  return {
    vertexShaderSH: `\n    ${e}\n    \n    const float SH_C0 = 0.28209479177387814;\n    const float SH_C1 = 0.4886025119029199;\n    const float SH_C2[5] = float[5]( 1.0925484305920792, -1.0925484305920792, 0.31539156525252005, -1.0925484305920792, 0.5462742152960396 );\n    const float SH_C3[7] = float[7](-0.5900435899266435, 2.890611442640554, -0.4570457994644658, 0.3731763325901154, -0.4570457994644658, 1.445305721320277, -0.5900435899266435 );\n    \n    struct SH {\n        vec3 sh1;\n        vec3 sh2;\n        vec3 sh3;\n        vec3 sh4;\n        vec3 sh5;\n        vec3 sh6;\n        vec3 sh7;\n        vec3 sh8;\n        vec3 sh9;\n        vec3 sh10;\n        vec3 sh11;\n        vec3 sh12;\n        vec3 sh13;\n        vec3 sh14;\n        vec3 sh15;\n    };\n    \n    SH sh;\n\n    vec3 ShadeSH(vec3 dir)\n    {\n        float x = dir.x, y = dir.y, z = dir.z;\n    \n        vec3 result = vec3(0., 0., 0.);\n    \n        result += SH_C1 * (-sh.sh1 * y + sh.sh2 * z - sh.sh3 * x);\n    \n        float xx = x * x, yy = y * y, zz = z * z;\n        float xy = x * y, yz = y * z, xz = x * z;\n    \n        result +=\n            (SH_C2[0] * xy) * sh.sh4 +\n            (SH_C2[1] * yz) * sh.sh5 +\n            (SH_C2[2] * (2. * zz - xx - yy)) * sh.sh6 +\n            (SH_C2[3] * xz) * sh.sh7 +\n            (SH_C2[4] * (xx - yy)) * sh.sh8;\n    \n        result +=\n            (SH_C3[0] * y * (3. * xx - yy)) * sh.sh9 +\n            (SH_C3[1] * xy * z) * sh.sh10 +\n            (SH_C3[2] * y * (4. * zz - xx - yy)) * sh.sh11 +\n            (SH_C3[3] * z * (2. * zz - 3. * xx - 3. * yy)) * sh.sh12 +\n            (SH_C3[4] * x * (4. * zz - xx - yy)) * sh.sh13 +\n            (SH_C3[5] * z * (xx - yy)) * sh.sh14 +\n            (SH_C3[6] * x * (xx - 3. * yy)) * sh.sh15;\n    \n        return result;\n    }\n    \n    vec3 DecodePacked_11_10_11(uint enc)\n    {\n        return vec3(\n        float(enc & 2047u) / 2047.0,\n        float((enc >> 11u) & 1023u) / 1023.0,\n        float((enc >> 21u) & 2047u) / 2047.0);\n    }\n\n    #ifdef LCC_COMPRESSED\n        void handleSHRawData(int k)\n        {\n            int texWidth = LUT_SH_TEX_DIMENSION;\n\n            ivec2 uv1 = ivec2((k + 0) % texWidth, (k + 0) / texWidth);\n            ivec2 uv2 = ivec2((k + 1) % texWidth, (k + 1) / texWidth);\n            ivec2 uv3 = ivec2((k + 2) % texWidth, (k + 2) / texWidth);\n            ivec2 uv4 = ivec2((k + 3) % texWidth, (k + 3) / texWidth);\n            ivec2 uv5 = ivec2((k + 4) % texWidth, (k + 4) / texWidth);\n            ivec2 uv6 = ivec2((k + 5) % texWidth, (k + 5) / texWidth);\n            ivec2 uv7 = ivec2((k + 6) % texWidth, (k + 6) / texWidth);\n            ivec2 uv8 = ivec2((k + 7) % texWidth, (k + 7) / texWidth);\n            ivec2 uv9 = ivec2((k + 8) % texWidth, (k + 8) / texWidth);\n            ivec2 uv10 = ivec2((k + 9) % texWidth, (k + 9) / texWidth);\n            ivec2 uv11 = ivec2((k + 10) % texWidth, (k + 10) / texWidth);\n            ivec2 uv12 = ivec2((k + 11) % texWidth, (k + 11) / texWidth);\n            ivec2 uv13 = ivec2((k + 12) % texWidth, (k + 12) / texWidth);\n            ivec2 uv14 = ivec2((k + 13) % texWidth, (k + 13) / texWidth);\n            ivec2 uv15 = ivec2((k + 14) % texWidth, (k + 14) / texWidth);\n\n            sh.sh1 = texelFetch(lutShTexture, uv1, 0).xyz;\n            sh.sh2 = texelFetch(lutShTexture, uv2, 0).xyz;\n            sh.sh3 = texelFetch(lutShTexture, uv3, 0).xyz;\n            sh.sh4 = texelFetch(lutShTexture, uv4, 0).xyz;\n            sh.sh5 = texelFetch(lutShTexture, uv5, 0).xyz;\n            sh.sh6 = texelFetch(lutShTexture, uv6, 0).xyz;\n            sh.sh7 = texelFetch(lutShTexture, uv7, 0).xyz;\n            sh.sh8 = texelFetch(lutShTexture, uv8, 0).xyz;\n            sh.sh9 = texelFetch(lutShTexture, uv9, 0).xyz;\n            sh.sh10 = texelFetch(lutShTexture, uv10, 0).xyz;\n            sh.sh11 = texelFetch(lutShTexture, uv11, 0).xyz;\n            sh.sh12 = texelFetch(lutShTexture, uv12, 0).xyz;\n            sh.sh13 = texelFetch(lutShTexture, uv13, 0).xyz;\n            sh.sh14 = texelFetch(lutShTexture, uv14, 0).xyz;\n            sh.sh15 = texelFetch(lutShTexture, uv15, 0).xyz;\n        }\n    #else\n        void handleSHRawData(uvec4 raw0, uvec4 raw1, uvec4 raw2, uvec4 raw3)\n        {\n            uint sh1 = raw0.r;\n            uint sh2 = raw0.g;\n            uint sh3 = raw0.b;\n            uint sh4 = raw0.a;\n        \n            uint sh5 = raw1.r;\n            uint sh6 = raw1.g;\n            uint sh7 = raw1.b;\n            uint sh8 = raw1.a;\n        \n            uint sh9 = raw2.r;\n            uint sh10 = raw2.g;\n            uint sh11 = raw2.b;\n            uint sh12 = raw2.a;\n        \n            uint sh13 = raw3.r;\n            uint sh14 = raw3.g;\n            uint sh15 = raw3.b;\n        \n            sh.sh1 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh1));\n            sh.sh2 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh2));\n            sh.sh3 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh3));\n            sh.sh4 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh4));\n            sh.sh5 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh5));\n            sh.sh6 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh6));\n            sh.sh7 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh7));\n            sh.sh8 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh8));\n            sh.sh9 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh9));\n            sh.sh10 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh10));\n            sh.sh11 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh11));\n            sh.sh12 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh12));\n            sh.sh13 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh13));\n            sh.sh14 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh14));\n            sh.sh15 = mix(compressedSHMin, compressedSHMax, DecodePacked_11_10_11(sh15));\n        }\n    #endif\n\n    void main () {\n        int splatCount = int(vmat[3][0]);\n        int dimensions = int(vmat[0][0]);\n        int dataDimensions = int(vmat[0][1]);\n        int shDimensions = int(vmat[0][2]);\n\n        if(use0[0] > 0.0)\n        {   \n            ${s}\n        }\n        else\n        {\n            ${i}\n    \n            if(use0[1] > 0.0)\n            {\n                vec3 sampledTransformLocal = sampledTransform.xyz;\n                #ifdef IS_RTK\n                    sampledTransformLocal = prj2ECEF_INV * sampledTransformLocal;\n                #endif\n                vec3 viewDir = normalize(sampledTransformLocal.xyz -  cmrPos);\n\n                #ifdef LCC_COMPRESSED\n                    ivec2 shUV = ivec2(idx % shDimensions, idx / shDimensions);\n\n                    #ifdef HAS_NOT_ATTRIBUTE_POSITION\n                        uint k = floatBitsToUint(texelFetch(shRawTexture, shUV, 0).r);\n                    #else\n                        uint k = uint(texelFetch(shRawTexture, shUV, 0).r);\n                    #endif\n\n                    handleSHRawData(int(k) * 15);\n\n                #else\n\n                    int shIdxNew = idx * 4;\n                    int sh_x = shIdxNew % shDimensions;\n                    int sh_y = shIdxNew / shDimensions;\n\n                    uvec4 shRaw0 = floatBitsToUint(texelFetch(shRawTexture, ivec2(sh_x, sh_y), 0));\n                    uvec4 shRaw1 = floatBitsToUint(texelFetch(shRawTexture, ivec2(sh_x + 1, sh_y), 0));\n                    uvec4 shRaw2 = floatBitsToUint(texelFetch(shRawTexture, ivec2(sh_x + 2, sh_y), 0));\n                    uvec4 shRaw3 = floatBitsToUint(texelFetch(shRawTexture, ivec2(sh_x + 3, sh_y), 0));\n        \n                    handleSHRawData(uvec4(shRaw0), uvec4(shRaw1), uvec4(shRaw2), uvec4(shRaw3));\n                #endif\n    \n                vec3 shColor = ShadeSH(viewDir);\n                \n                vColor.rgb += shColor;\n                // vColor.rgb = clamp(vColor.rgb, 0., 1.);\n            }\n        }\n    }\n    `,
  };
}
function ci(t) {
  const { gl_FragColor: e } = t;
  return {
    fragmentShader: `\n        precision highp float;\n\n        uniform mat4 vmat;\n        uniform vec4 use2;\n        uniform vec4 clipPlane;\n        uniform vec2 viewport;\n\n        #ifdef IS_RTK\n            uniform mat4 pmat;\n        #endif\n\n        in mediump vec4 vColor;\n        in mediump vec2 vPosition;\n        #ifdef LCC_RD\n            in vec4 vConic;\n            in vec2 vSplatCoord;\n        #endif\n        in vec3 vp;\n\n        #ifdef HAS_NOT_ATTRIBUTE_POSITION\n            uniform vec4 czm_pickColor;\n        #endif\n\n        #ifdef DGBCOL\n        vec3 getDgbColor(vec3 incolor, int id) {\n            if (id < 0 || id >= 8)\n                return incolor;\n\n            vec3 colors[8];\n            colors[0] = vec3(1.0, 0.0, 0.0); // 红\n            colors[1] = vec3(0.0, 1.0, 0.0); // 绿\n            colors[2] = vec3(0.0, 0.0, 1.0); // 蓝\n            colors[3] = vec3(1.0, 1.0, 0.0); // 黄\n            colors[4] = vec3(1.0, 0.0, 1.0); // 品红\n            colors[5] = vec3(0.0, 1.0, 1.0); // 青\n            colors[6] = vec3(1.0, 0.5, 0.0); // 橙\n            colors[7] = vec3(0.5, 0.0, 1.0); // 紫\n            return colors[clamp(id, 0, 7)];\n        }\n        #endif\n\n        void main () {\n            #ifndef LCC_RD\n                mediump float A = -dot(vPosition, vPosition);\n                if (A < -4.0) discard;\n            #else\n                vec2 d = gl_FragCoord.xy - vSplatCoord.xy;\n                float A = -0.5 * (vConic.x * d.x * d.x + vConic.z * d.y * d.y) - vConic.y * d.x * d.y;\n                if (A > 0.0) discard;\n            #endif\n\n            vec3 color = vColor.rgb;\n            float alpha = vColor.a;\n            if (use2[1] > 0.5) {\n                #ifdef IS_RTK\n                    vec4 vpHomo = vec4(vp, 1.0);\n                    float ret = step(0.0, dot(pmat[0], vpHomo)) * step(0.0, dot(pmat[1], vpHomo)) *\n                                step(0.0, dot(pmat[2], vpHomo)) * step(0.0, dot(pmat[3], vpHomo));\n                    if (ret < 0.5) {\n                        discard;\n                    }\n                #else\n                    vec2 ret = step(vec2(vmat[1][0], vmat[1][1]), vp.xy) * step(vp.xy, vec2(vmat[2][0], vmat[2][1]));\n                    if (ret.x * ret.y < 0.5) {\n                        discard;\n                    }\n                #endif\n            }\n            if (use2[2] > 0.5) {\n                vec2 ndc_xy = (gl_FragCoord.xy / viewport) * 2.0 - 1.0;\n                vec3 ndc = vec3(ndc_xy.x, -ndc_xy.y, gl_FragCoord.z * 2.0 - 1.0);\n                if (dot(ndc, clipPlane.xyz) < clipPlane.w) {\n                    discard;\n                }\n            }\n            \n            A = exp(A) * alpha;\n            \n            // A = 1.0;\n\n            if (A < 0.00393) discard;\n\n            // A = 1.0;\n\n            #ifdef DGBCOL\n                color = mix(color, getDgbColor(color, int(vmat[3][3])), 0.3);\n            #endif\n\n            ${e} = vec4(color.rgb, A * use2[0]);\n       \n        }\n    `,
  };
}
let ui = class {
  #Re;
  #ln;
  #cn;
  #un;
  #dn;
  #fn;
  #pn;
  #mn;
  #gn;
  #yn;
  get tempTexFloatRed() {
    return this.#un;
  }
  get tempTexIntRed() {
    return this.#dn;
  }
  get tempTexFloatRGBA() {
    return this.#fn;
  }
  get tempTexIntRGBA() {
    return this.#pn;
  }
  get rainbowTex() {
    return this.#cn;
  }
  get baseGeometry() {
    return this.#mn;
  }
  get baseMaterial() {
    return this.#gn;
  }
  get baseMaterialCompress() {
    return this.#yn;
  }
  constructor(t) {
    ((this.#Re = t),
      (this.#ln = this.#Re.renderLib),
      this.#xn('rainbow', w[1]),
      this.#vn(),
      this.#bn(),
      this.#wn(),
      this.#Sn());
  }
  hasTexture(t) {
    return t === this.#cn || t === this.#un || t === this.#dn || t === this.#fn || t === this.#pn;
  }
  dispose() {
    (this.#cn?.dispose(),
      this.#mn.dispose(),
      this.#gn.dispose(),
      this.#yn.dispose(),
      this.#un.dispose(),
      (this.#un.image.data = null),
      (this.#un = null),
      this.#dn.dispose(),
      (this.#dn.image.data = null),
      (this.#dn = null),
      this.#fn.dispose(),
      (this.#fn.image.data = null),
      (this.#fn = null),
      this.#pn.dispose(),
      (this.#pn.image.data = null),
      (this.#pn = null));
  }
  #vn() {
    const t = 4,
      e = 4,
      i = new Float32Array(t * e);
    for (let t = 0; t < i.length; ++t) i[t] = 0;
    ((this.#un = new this.#ln.DataTexture(i, t, e, this.#ln.RedFormat, this.#ln.FloatType)),
      (this.#un.needsUpdate = !0),
      (this.#un.unpackAlignment = 4));
    const s = 4,
      n = 4,
      r = new Int32Array(s * n);
    for (let t = 0; t < i.length; ++t) r[t] = 0;
    ((this.#dn = new this.#ln.DataTexture(r, s, n, this.#ln.RedIntegerFormat, this.#ln.IntType)),
      (this.#dn.internalFormat = 'R32I'),
      (this.#dn.needsUpdate = !0),
      (this.#dn.unpackAlignment = 4));
    const a = 4,
      o = 4,
      h = new Float32Array(a * o * 4);
    for (let t = 0; t < h.length; ++t) h[t] = 0;
    ((this.#fn = new this.#ln.DataTexture(h, a, o, this.#ln.RGBAFormat, this.#ln.FloatType)),
      (this.#fn.needsUpdate = !0),
      (this.#fn.unpackAlignment = 4));
    const l = 4,
      c = 4,
      u = new Int32Array(l * c * 4);
    for (let t = 0; t < u.length; ++t) u[t] = 0;
    ((this.#pn = new this.#ln.DataTexture(u, l, c, this.#ln.RGBAIntegerFormat, this.#ln.IntType)),
      (this.#pn.internalFormat = 'RGBA32I'),
      (this.#pn.needsUpdate = !0),
      (this.#pn.unpackAlignment = 4));
  }
  #xn(t, e) {
    new this.#ln.TextureLoader().load(
      e,
      (e) => {
        ((this.#cn = e), (this.#cn.name = t));
      },
      void 0,
      (t) => {
        console.log('create texture failed: ', t);
      },
    );
  }
  #bn() {
    this.#mn = new this.#ln.BufferGeometry();
    {
      let t = new Float32Array(1536),
        e = new this.#ln.BufferAttribute(t, 3);
      this.#mn.setAttribute('position', e);
      let i = [];
      for (let t = 0; t < 128; ++t) {
        let s = 4 * t;
        (e.setXYZ(0 + s, 1, 1, t), e.setXYZ(1 + s, -1, 1, t), e.setXYZ(2 + s, -1, -1, t), e.setXYZ(3 + s, 1, -1, t));
        let n = [s + 0, s + 1, s + 2, s + 0, s + 2, s + 3];
        i.push(...n);
      }
      (this.#mn.setIndex(i), (e.needsUpdate = !0));
    }
  }
  #wn() {
    const t = !!this.#Re.writeDepth,
      e = t ? this.#ln.AlwaysDepth : this.#ln.LessEqualDepth,
      i = this.#Re.useLccPerf ? { LCC_RD: '' } : {};
    this.#gn = new this.#ln.ShaderMaterial({
      uniforms: {
        compressedScaleMin: { value: new this.#ln.Vector3(0, 0, 0) },
        compressedScaleMax: { value: new this.#ln.Vector3(0, 0, 0) },
        compressedSHMin: { value: new this.#ln.Vector3(0, 0, 0) },
        compressedSHMax: { value: new this.#ln.Vector3(0, 0, 0) },
        splatData: { value: null },
        splatIndexesHost: { value: null },
        shRawTexture: { value: null },
        customColors: { value: null },
        semanticColors: { value: null },
        vmat: { value: new this.#ln.Matrix4() },
        viewport: { value: new this.#ln.Vector2(0, 0) },
        cmrPos: { value: new this.#ln.Vector3(0, 0, 0) },
        scPos: { value: new this.#ln.Vector3(0, 0, 0) },
        heightRange: { value: new this.#ln.Vector2(0, 0) },
        clipPlane: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        clipBoxMatrixInv: { value: new this.#ln.Matrix4() },
        ndc2local: { value: new this.#ln.Matrix4() },
        use0: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        use1: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        use2: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        use3: { value: new this.#ln.Vector4(0, 0, 0, 0) },
      },
      vertexShader: li(hi).vertexShaderSH,
      fragmentShader: ci(hi).fragmentShader,
      transparent: !0,
      alphaTest: 1,
      blending: this.#ln.NormalBlending,
      depthTest: !0,
      depthWrite: t,
      depthFunc: e,
      side: this.#ln.DoubleSide,
      defines: { ...i },
    });
  }
  #Sn() {
    const t = !!this.#Re.writeDepth,
      e = t ? this.#ln.AlwaysDepth : this.#ln.LessEqualDepth,
      i = this.#Re.useLccPerf ? { LCC_RD: '' } : {};
    this.#yn = new this.#ln.ShaderMaterial({
      uniforms: {
        lutScaleTexture: { value: null },
        lutShTexture: { value: null },
        semanticTexture: { value: null },
        splatData: { value: null },
        splatIndexesHost: { value: null },
        shRawTexture: { value: null },
        customColors: { value: null },
        semanticColors: { value: null },
        vmat: { value: new this.#ln.Matrix4() },
        viewport: { value: new this.#ln.Vector2(0, 0) },
        cmrPos: { value: new this.#ln.Vector3(0, 0, 0) },
        scPos: { value: new this.#ln.Vector3(0, 0, 0) },
        heightRange: { value: new this.#ln.Vector2(0, 0) },
        clipPlane: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        clipBoxMatrixInv: { value: new this.#ln.Matrix4() },
        ndc2local: { value: new this.#ln.Matrix4() },
        use0: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        use1: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        use2: { value: new this.#ln.Vector4(0, 0, 0, 0) },
        use3: { value: new this.#ln.Vector4(0, 0, 0, 0) },
      },
      vertexShader: li(hi).vertexShaderSH,
      fragmentShader: ci(hi).fragmentShader,
      transparent: !0,
      alphaTest: 1,
      blending: this.#ln.NormalBlending,
      depthTest: !0,
      depthWrite: t,
      depthFunc: e,
      side: this.#ln.DoubleSide,
      defines: { LCC_COMPRESSED: '', ...i },
    });
  }
};
const di = new pt(),
  fi = new pt(),
  pi = new pt(),
  mi = new pt();
class gi {
  constructor(t = new pt(), e = new pt(0, 0, -1), i = 1 / 0) {
    ((this.origin = t), (this.direction = e), (this.length = i));
  }
  set(t, e, i = 1 / 0) {
    return (this.origin.copy(t), this.direction.copy(e), (this.length = i), this);
  }
  at(t, e) {
    return e.copy(this.origin).addScaledVector(this.direction, t);
  }
  copy(t) {
    return (this.origin.copy(t.origin), this.direction.copy(t.direction), (this.length = t.length), this);
  }
  intersectBox(t) {
    let e, i, s, n, r, a;
    const o = 1 / this.direction.x,
      h = 1 / this.direction.y,
      l = 1 / this.direction.z,
      c = this.origin;
    if (
      (o >= 0
        ? ((e = (t.min.x - c.x) * o), (i = (t.max.x - c.x) * o))
        : ((e = (t.max.x - c.x) * o), (i = (t.min.x - c.x) * o)),
      h >= 0
        ? ((s = (t.min.y - c.y) * h), (n = (t.max.y - c.y) * h))
        : ((s = (t.max.y - c.y) * h), (n = (t.min.y - c.y) * h)),
      e > n || s > i)
    )
      return null;
    if (
      ((s > e || isNaN(e)) && (e = s),
      (n < i || isNaN(i)) && (i = n),
      l >= 0
        ? ((r = (t.min.z - c.z) * l), (a = (t.max.z - c.z) * l))
        : ((r = (t.max.z - c.z) * l), (a = (t.min.z - c.z) * l)),
      e > a || r > i)
    )
      return null;
    if (((r > e || e != e) && (e = r), (a < i || i != i) && (i = a), i < 0)) return null;
    let u = Math.max(0, e);
    return { point: this.origin.clone().addScaledVector(this.direction, u), distance: u };
  }
  intersectBoxRange(t) {
    let e, i, s, n, r, a;
    const o = 1 / this.direction.x,
      h = 1 / this.direction.y,
      l = 1 / this.direction.z,
      c = this.origin;
    if (
      (o >= 0
        ? ((e = (t.min.x - c.x) * o), (i = (t.max.x - c.x) * o))
        : ((e = (t.max.x - c.x) * o), (i = (t.min.x - c.x) * o)),
      h >= 0
        ? ((s = (t.min.y - c.y) * h), (n = (t.max.y - c.y) * h))
        : ((s = (t.max.y - c.y) * h), (n = (t.min.y - c.y) * h)),
      e > n || s > i)
    )
      return null;
    if (
      ((s > e || isNaN(e)) && (e = s),
      (n < i || isNaN(i)) && (i = n),
      l >= 0
        ? ((r = (t.min.z - c.z) * l), (a = (t.max.z - c.z) * l))
        : ((r = (t.max.z - c.z) * l), (a = (t.min.z - c.z) * l)),
      e > a || r > i)
    )
      return null;
    if (((r > e || e != e) && (e = r), (a < i || i != i) && (i = a), i < 0)) return null;
    let u = e,
      d = i;
    return {
      tin: u,
      tout: d,
      pin: this.origin.clone().addScaledVector(this.direction, u),
      pout: this.origin.clone().addScaledVector(this.direction, d),
    };
  }
  intersectTriangle(t, e, i, s) {
    (fi.subVectors(e, t), pi.subVectors(i, t), mi.crossVectors(fi, pi));
    let n,
      r = this.direction.dot(mi);
    if (r > 0) {
      if (s) return null;
      n = 1;
    } else {
      if (!(r < 0)) return null;
      ((n = -1), (r = -r));
    }
    di.subVectors(this.origin, t);
    const a = n * this.direction.dot(pi.crossVectors(di, pi));
    if (a < 0) return null;
    const o = n * this.direction.dot(fi.cross(di));
    if (o < 0) return null;
    if (a + o > r) return null;
    const h = -n * di.dot(mi);
    if (h < 0) return null;
    const l = h / r;
    if (l > this.length) return null;
    return { point: this.origin.clone().addScaledVector(this.direction, l), distance: l, normal: mi.clone() };
  }
  applyMatrix4(t) {
    return (this.origin.applyMatrix4(t), this.direction.transformDirection(new Ot().extractRotation(t)), this);
  }
  equals(t) {
    return t.origin.equals(this.origin) && t.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
let yi = class {
  #Re;
  #ln;
  #Mn;
  #Cn;
  #En;
  #Dn;
  get semanticColorsTex() {
    return this.#Cn;
  }
  get lutScaleTex() {
    return this.#En;
  }
  get lutShTex() {
    return this.#Dn;
  }
  constructor(t) {
    ((this.#Re = t), (this.#ln = this.#Re.renderLib), this.#An());
  }
  dispose() {
    (this.#Cn != this.#Mn && this.#Fn(this.#Cn),
      this.#Fn(this.#Mn),
      this.#Fn(this.#En),
      this.#Fn(this.#Dn),
      (this.#Cn = null),
      (this.#Mn = null),
      (this.#En = null),
      (this.#Dn = null));
  }
  #Fn(t) {
    t && (t.dispose(), (t.image.data = null));
  }
  #An() {
    const t = it.length,
      e = new Float32Array(1 * t * 4);
    for (let i = 0; i < 1 * t; ++i)
      ((e[i + 0] = it[i][0]), (e[i + 1] = it[i][1]), (e[i + 2] = it[i][2]), (e[i + 2] = 1));
    let i = new this.#ln.DataTexture(e, t, 1, this.#ln.RGBAFormat, this.#ln.FloatType);
    ((i.needsUpdate = !0), (i.unpackAlignment = 4), (this.#Cn = this.#Mn = i));
  }
  updateSemanticColor(t) {
    const e = it.length,
      i = new Float32Array(1 * e * 4);
    for (let s = 0; s < 1 * e; ++s)
      s < t.length
        ? ((i[s + 0] = t[s][0]), (i[s + 1] = t[s][1]), (i[s + 2] = t[s][2]), (i[s + 2] = 1))
        : ((i[s + 0] = 0), (i[s + 1] = 0), (i[s + 2] = 0), (i[s + 2] = 1));
    let s = new this.#ln.DataTexture(i, e, 1, this.#ln.RGBAFormat, this.#ln.FloatType);
    ((s.needsUpdate = !0), (s.unpackAlignment = 4), this.resetSemanticColor(), (this.#Cn = s));
  }
  resetSemanticColor() {
    this.#Cn != this.#Mn && (this.#Fn(this.#Cn), (this.#Cn = this.#Mn));
  }
  setLutScale(t) {
    if (this.#En) return void console.error('repeat creating lut-scale');
    const e = new Float32Array(t),
      i = e.length / 3;
    3 * i != e.length && console.error('lut-scale size error: ', i, e.length);
    const s = 1024,
      n = Math.ceil(i / s);
    let r = new Float32Array(s * n * 4);
    for (let t = 0; t < i; ++t)
      ((r[4 * t + 0] = e[3 * t + 0]), (r[4 * t + 1] = e[3 * t + 1]), (r[4 * t + 2] = e[3 * t + 2]), (r[4 * t + 3] = 1));
    ((this.#En = new this.#ln.DataTexture(r, s, n, this.#ln.RGBAFormat, this.#ln.FloatType)),
      (this.#En.needsUpdate = !0),
      (this.#En.unpackAlignment = 4));
  }
  setLutSH(t) {
    if (this.#Dn) return void console.error('repeat creating lut-sh');
    const e = new Float32Array(t),
      i = e.length / 3;
    3 * i != e.length && console.error('lut-sh size error: ', i, e.length);
    const s = i / 15;
    15 * s != i && console.error('lut-sh size error2: ', i, s);
    const n = 4096,
      r = Math.ceil(i / n);
    let a = new Float32Array(n * r * 4);
    for (let t = 0; t < i; ++t)
      ((a[4 * t + 0] = e[3 * t + 0]), (a[4 * t + 1] = e[3 * t + 1]), (a[4 * t + 2] = e[3 * t + 2]), (a[4 * t + 3] = 1));
    ((this.#Dn = new this.#ln.DataTexture(a, n, r, this.#ln.RGBAFormat, this.#ln.FloatType)),
      (this.#Dn.needsUpdate = !0),
      (this.#Dn.unpackAlignment = 4));
  }
};
class xi {
  static GlobalID = 0;
  #f = !1;
  #Pt;
  #Xe;
  #Pn;
  #Tn;
  #ln;
  #S;
  #In = 0;
  #_n;
  #Rn;
  #Nn;
  #Bn;
  #kn;
  #zn;
  #Ln;
  #On;
  #Hn;
  #jn;
  #qn;
  #P;
  #jt;
  #Vn;
  #Un;
  #Kn;
  #Gn = new pt();
  #Wn = new pt();
  #Qn = 0;
  #Xn = new pt();
  #Yn = new pt();
  #Zn = 0;
  #Jn;
  #$n = !1;
  #tr = !1;
  #er = !1;
  #ir = !1;
  #sr = !1;
  #nr = !0;
  #rr;
  #ar = et;
  #or = !1;
  dimensions;
  dataDimensions;
  shDimensions;
  semDimensions;
  sortInfos;
  indexRT;
  isEnvMesh = !1;
  #zt = new ie();
  #hr = 0;
  #lr = 0;
  #cr = 0;
  #ur = 0;
  #dr = 0;
  #fr = 0;
  get isDispose() {
    return this.#f;
  }
  get id() {
    return this.#S;
  }
  get flushID() {
    return this.#In;
  }
  get object() {
    return this.#jn;
  }
  get node() {
    return this.#qn;
  }
  get size() {
    return this.#hr;
  }
  set isFirstSorted(t) {
    this.#er = t;
  }
  get isFirstSorted() {
    return this.#er;
  }
  set isSorting(t) {
    this.#ir = t;
  }
  get isSorting() {
    return this.#ir;
  }
  get splatCount() {
    return this.#Jn;
  }
  set pos(t) {
    this.#Vn = t;
  }
  get pos() {
    return this.#Vn;
  }
  set distances(t) {
    this.#Un = t;
  }
  get distances() {
    return this.#Un;
  }
  set indexes(t) {
    this.#Kn = t;
  }
  get indexes() {
    return this.#Kn;
  }
  get sortCmrPosLast() {
    return this.#Gn.clone();
  }
  get sortTickLast() {
    return this.#Qn;
  }
  get sortCmrPosPending() {
    return this.#Xn;
  }
  get transformsTexture() {
    return this.#On?.uniforms?.splatData?.value;
  }
  get hasUploadSH() {
    return this.#$n;
  }
  get hasUploadSem() {
    return this.#tr;
  }
  constructor(t, e, i, s, n, r) {
    ((this.#S = xi.GlobalID++),
      (this.#Pt = t),
      (this.#Xe = t.config),
      (this.#Pn = this.#Pt.resources),
      (this.#Tn = this.#Pt.resourcesScene),
      (this.#ln = this.#Pt.lccParam.renderLib),
      (this.#qn = e),
      (this.#jt = e?.parent?.center || new pt(0, 0, 0)),
      (this.#Jn = i));
    let a = t.meta;
    if (
      ((this.isEnvMesh = !e),
      (this.#P = this.isEnvMesh ? -1 : e.level),
      this.isEnvMesh
        ? (a.compressInfo.positionMin &&
            a.compressInfo.positionMax &&
            this.#zt.set(a.compressInfo.positionMin, a.compressInfo.positionMax),
          (this.#Nn = a.compressInfo.positionMax),
          (this.#Bn = a.compressInfo.positionMin),
          (this.#_n = a.compressInfo.compressedEnvScaleMax || a.compressInfo.compressedScaleMax),
          (this.#Rn = a.compressInfo.compressedEnvScaleMin || a.compressInfo.compressedScaleMin),
          (this.#kn = a.compressInfo.compressedEnvSHMax || a.compressInfo.compressedSHMax),
          (this.#zn = a.compressInfo.compressedEnvSHMin || a.compressInfo.compressedSHMin))
        : (this.#zt.copy(this.#qn.parent.getBBox()),
          (this.#Nn = a.max),
          (this.#Bn = a.min),
          (this.#_n = a.compressInfo.compressedScaleMax),
          (this.#Rn = a.compressInfo.compressedScaleMin),
          (this.#kn = a.compressInfo.compressedSHMax),
          (this.#zn = a.compressInfo.compressedSHMin)),
      (this.#or = this.#Xe.useLccCompress && !this.isEnvMesh),
      n)
    ) {
      this.#Vn = new Float32Array(n.length);
      for (let t = 0; t < n.length; ++t) this.#Vn[t] = n[t];
      ((this.#Un = new Int32Array(this.#Jn)), (this.#Kn = new Int32Array(this.#Jn)));
    }
    if (
      ((this.dimensions = Et(this.#Jn, this.#Pt.config.TextureSize)),
      (this.semDimensions = Et(this.#Jn, this.#Pt.config.TextureSize)),
      this.#or)
    ) {
      const t = Math.ceil(1.5 * (this.#Jn + 1));
      ((this.dataDimensions = Et(t, this.#Pt.config.TextureSize)),
        (this.shDimensions = Et(this.#Jn, this.#Pt.config.TextureSize)));
    } else
      ((this.dataDimensions = Et(2 * this.#Jn, this.#Pt.config.TextureSize)),
        (this.shDimensions = Et(4 * this.#Jn, this.#Pt.config.TextureSize)));
    let o = this.#pr(this.#Jn);
    ((this.sortInfos = {
      totalDrawCount: At(this.dimensions.x * this.dimensions.y),
      lastDrawCount: 0,
      maxCountOneTime: o,
    }),
      this.#mr(),
      this.#gr(),
      (this.#jn = new this.#ln.Mesh(this.#Ln, this.#On)),
      (this.#jn.frustumCulled = !1),
      (this.#jn.name = 'lccMesh'),
      this.#yr(),
      s && this.updateSplatDataTexture(s),
      r && this.updateSHTexture(r),
      0 === this.#hr && console.warn('has not update gpu size !!!'),
      (this.#jn.onAfterRender = () => {
        (this.#On.uniforms?.shRawTexture?.value?.image?.data &&
          (this.#On.uniforms.shRawTexture.value.image.data = null),
          this.#On.uniforms?.semanticTexture?.value?.image?.data &&
            (this.#On.uniforms.semanticTexture.value.image.data = null));
      }));
  }
  dispose() {
    ((this.#f = !0),
      (this.#Vn = null),
      this.#jn && (this.#jn.removeFromParent(), (this.#jn.onAfterRender = () => {}), (this.#jn = null)),
      this.#On &&
        (this.#On.uniforms.splatData?.value &&
          (this.#On.uniforms.splatData.value.dispose(),
          (this.#On.uniforms.splatData.value.image.data = null),
          (this.#On.uniforms.splatData.value = null)),
        this.#On.uniforms.splatIndexesHost?.value &&
          (this.#On.uniforms.splatIndexesHost.value.dispose(),
          (this.#On.uniforms.splatIndexesHost.value.image.data = null),
          (this.#On.uniforms.splatIndexesHost.value = null)),
        this.#On.uniforms.shRawTexture?.value &&
          !this.#Pn.hasTexture(this.#On.uniforms.shRawTexture.value) &&
          (this.#On.uniforms.shRawTexture.value.dispose(),
          (this.#On.uniforms.shRawTexture.value.image.data = null),
          (this.#On.uniforms.shRawTexture.value = null)),
        this.#On.uniforms.semanticTexture?.value &&
          !this.#Pn.hasTexture(this.#On.uniforms.semanticTexture.value) &&
          (this.#On.uniforms.semanticTexture.value.dispose(),
          (this.#On.uniforms.semanticTexture.value.image.data = null),
          (this.#On.uniforms.semanticTexture.value = null)),
        this.#On.dispose(),
        (this.#On = null)),
      this.#Ln && (this.#Ln.dispose(), (this.#Ln = null)),
      this.indexRT && (this.indexRT.texture.dispose(), this.indexRT.dispose(), (this.indexRT = null)));
  }
  #mr() {
    const t = this.#Pn.baseGeometry;
    this.#Ln = new this.#ln.InstancedBufferGeometry().copy(t);
    this.#Ln.instanceCount = Math.floor((this.#Jn + 128 - 1) / 128);
  }
  #gr() {
    this.#On = this.#or ? this.#Pn.baseMaterialCompress.clone() : this.#Pn.baseMaterial.clone();
  }
  #yr() {
    const t = this.dimensions,
      e = this.dataDimensions,
      i = this.shDimensions,
      s = this.semDimensions;
    if (this.#Pt.config.WebglSortingEnable) {
      const e = this.#ln.RGBAIntegerFormat,
        i = this.#ln.IntType,
        s = 'RGBA32I';
      ((this.indexRT = new this.#ln.WebGLRenderTarget(t.x, t.y, {
        count: 1,
        minFilter: this.#ln.NearestFilter,
        magFilter: this.#ln.NearestFilter,
        format: e,
        type: i,
        internalFormat: s,
        depthBuffer: !1,
        stencilBuffer: !1,
      })),
        (this.indexRT.texture.name = 'SortIndex'));
    }
    (this.#On.uniforms.vmat.value
      .set(
        t.x,
        e.x,
        i.x,
        s.x,
        this.#zt.min.x - tt,
        this.#zt.min.y - tt,
        this.#zt.min.z - tt,
        0,
        this.#zt.max.x + tt,
        this.#zt.max.y + tt,
        this.#zt.max.z + tt,
        0,
        this.#Jn,
        $,
        0,
        this.#P,
      )
      .transpose(),
      (this.#On.uniforms.heightRange.value = new this.#ln.Vector2(this.#Bn.z, this.#Nn.z)),
      this.#Rn &&
        this.#On.uniforms.compressedScaleMin &&
        (this.#On.uniforms.compressedScaleMin.value = new this.#ln.Vector3(this.#Rn.x, this.#Rn.y, this.#Rn.z)),
      this.#_n &&
        this.#On.uniforms.compressedScaleMax &&
        (this.#On.uniforms.compressedScaleMax.value = new this.#ln.Vector3(this.#_n.x, this.#_n.y, this.#_n.z)),
      this.#zn &&
        this.#On.uniforms.compressedSHMin &&
        (this.#On.uniforms.compressedSHMin.value = new this.#ln.Vector3(this.#zn.x, this.#zn.y, this.#zn.z)),
      this.#kn &&
        this.#On.uniforms.compressedSHMax &&
        (this.#On.uniforms.compressedSHMax.value = new this.#ln.Vector3(this.#kn.x, this.#kn.y, this.#kn.z)),
      (this.#On.uniforms.customColors.value = this.#Pn.rainbowTex),
      (this.#On.uniforms.semanticColors.value = this.#Tn.semanticColorsTex),
      this.#On.uniforms.semanticTexture && (this.#On.uniforms.semanticTexture.value = this.#Pn.tempTexIntRed),
      this.#On.uniforms.lutScaleTexture && (this.#On.uniforms.lutScaleTexture.value = this.#Tn.lutScaleTex),
      this.#On.uniforms.lutShTexture &&
        (this.#On.uniforms.lutShTexture.value = this.#Tn.lutShTex || this.#Pn.tempTexFloatRGBA));
    const n = new Uint32Array(e.x * e.y * 4);
    ((this.#Hn = n),
      (this.#On.uniforms.splatData.value = new this.#ln.DataTexture(
        n,
        e.x,
        e.y,
        this.#ln.RGBAIntegerFormat,
        this.#ln.UnsignedIntType,
      )),
      (this.#On.uniforms.splatData.value.needsUpdate = !0),
      (this.#On.uniforms.splatData.value.internalFormat = 'RGBA32UI'),
      (this.#On.uniforms.splatData.value.unpackAlignment = 4));
    const r = new Int32Array(t.x * t.y);
    ((this.#On.uniforms.splatIndexesHost.value = new this.#ln.DataTexture(
      r,
      t.x,
      t.y,
      this.#ln.RedIntegerFormat,
      this.#ln.IntType,
    )),
      (this.#On.uniforms.splatIndexesHost.value.needsUpdate = !0),
      (this.#On.uniforms.splatIndexesHost.value.internalFormat = 'R32I'),
      (this.#On.uniforms.splatIndexesHost.value.unpackAlignment = 4),
      (this.#On.uniforms.shRawTexture.value = this.#or ? this.#Pn.tempTexIntRed : this.#Pn.tempTexFloatRGBA),
      (this.#On.uniformsNeedUpdate = !0),
      (this.#cr = r.byteLength),
      (this.#ur = n.byteLength),
      this.#xr());
  }
  #xr() {
    this.#hr = this.#lr + this.#cr + this.#ur + this.#dr + this.#fr;
  }
  updateSplatDataTexture(t) {
    if (this.#f) return;
    const e = this.#On.uniforms.splatData.value,
      i = e.image.data,
      s = new Uint32Array(i.buffer);
    for (let e = 0; e < t.length; ++e) s[e] = t[e];
    for (let e = t.length; e < t.length + 6 && e < s.length; ++e) s[e] = t[t.length - 1];
    e.needsUpdate = !0;
  }
  updateIndexTexture(t) {
    if (this.#f) return;
    const e = this.#On.uniforms.splatIndexesHost.value,
      i = e.image.data;
    t.length !== this.#Jn && console.error('udpate error ....................fd');
    const s = new Int32Array(i.buffer),
      n = Math.min(t.length, this.#Jn);
    for (let e = 0; e < n; ++e) s[e] = t[e];
    ((e.needsUpdate = !0), (this.#In += 1));
  }
  updateIndexTextureWithInit() {
    if (this.#f) return;
    const t = this.#On.uniforms.splatIndexesHost.value,
      e = t.image.data,
      i = new Int32Array(e.buffer);
    for (let t = 0; t < this.#Jn; ++t) i[t] = t;
    for (let t = this.#Jn; t < i.length; ++t) i[t] = 0;
    ((t.needsUpdate = !0), (this.#er = !0), (this.#sr = !0));
    const s = this.#Pt.dynamicState.cmrPosLocal.clone(),
      n = this.#Pt.dynamicState.cmrForward.clone();
    (this.#Gn.copy(s), this.#Wn.copy(n), (this.#Qn = this.#Pt.dynamicState.tick));
  }
  updateSHTexture(t) {
    if (this.#f || this.#$n) return;
    this.#$n = !0;
    let e = 0;
    if (this.#or) {
      const i = new Int32Array(this.shDimensions.x * this.shDimensions.y * 4);
      ((e = i.byteLength),
        (this.#On.uniforms.shRawTexture.value = new this.#ln.DataTexture(
          i,
          this.shDimensions.x,
          this.shDimensions.y,
          this.#ln.RedIntegerFormat,
          this.#ln.IntType,
        )),
        (this.#On.uniforms.shRawTexture.value.needsUpdate = !0),
        (this.#On.uniforms.shRawTexture.value.internalFormat = 'R32I'),
        (this.#On.uniforms.shRawTexture.value.unpackAlignment = 4));
      const s = this.#On.uniforms.shRawTexture.value,
        n = s.image.data,
        r = new Uint16Array(t),
        a = new Uint32Array(n.buffer);
      for (let t = 0; t < r.length; ++t) a[t] = r[t];
      s.needsUpdate = !0;
    } else {
      const i = new Float32Array(this.shDimensions.x * this.shDimensions.y * 4);
      ((e = i.byteLength),
        (this.#On.uniforms.shRawTexture.value = new this.#ln.DataTexture(
          i,
          this.shDimensions.x,
          this.shDimensions.y,
          this.#ln.RGBAFormat,
          this.#ln.FloatType,
        )),
        (this.#On.uniforms.shRawTexture.value.needsUpdate = !0),
        (this.#On.uniforms.shRawTexture.value.unpackAlignment = 4));
      const s = this.#On.uniforms.shRawTexture.value,
        n = s.image.data,
        r = new Uint32Array(t),
        a = new Uint32Array(n.buffer);
      for (let t = 0; t < r.length; ++t) a[t] = r[t];
      s.needsUpdate = !0;
    }
    ((this.#dr = e), this.#xr(), (this.#In += 1));
  }
  updateSemanticTexture(t) {
    if (this.#f || !this.#or || this.#tr) return;
    this.#tr = !0;
    let e = 0;
    const i = new Int32Array(this.semDimensions.x * this.semDimensions.y * 4);
    ((e = i.byteLength),
      (this.#On.uniforms.semanticTexture.value = new this.#ln.DataTexture(
        i,
        this.semDimensions.x,
        this.semDimensions.y,
        this.#ln.RedIntegerFormat,
        this.#ln.IntType,
      )),
      (this.#On.uniforms.semanticTexture.value.needsUpdate = !0),
      (this.#On.uniforms.semanticTexture.value.internalFormat = 'R32I'),
      (this.#On.uniforms.semanticTexture.value.unpackAlignment = 4));
    const s = this.#On.uniforms.semanticTexture.value,
      n = s.image.data,
      r = 2 == this.#Xe.semanticDataSize ? new Uint16Array(t) : new Uint32Array(t),
      a = new Uint32Array(n.buffer);
    for (let t = 0; t < r.length; ++t) a[t] = r[t];
    ((s.needsUpdate = !0), (this.#fr = e), this.#xr(), (this.#In += 1));
  }
  updateUniformsDynamic() {
    if (this.#f) return;
    const t = this.#Pt.dynamicState;
    let e = et;
    if (!this.isEnvMesh) {
      if (this.#nr) {
        ((this.#nr = !1), (this.#rr = t.tick));
        const e = this.#qn.parent,
          i = e.getNodeByLevel(e.initAroundLevel),
          s = this.#qn.points,
          n = i ? i.points : 0;
        if (0 != s && this.#P != e.totalLevel - 1) {
          const t = Math.ceil(ut.lerp(0, et, n / s));
          this.#ar = ut.clamp(t, 1, et);
        } else this.#ar = et;
      }
      if (1 == t.loadingSwitch && this.#qn.points > 10) {
        const i = (t.tick - this.#rr) / 1e3,
          s = ut.smoothstep(i, 0, 5),
          n = Math.ceil((et - this.#ar) * s);
        e = ut.clamp(this.#ar + n, 1, et);
      }
    }
    ((this.#On.uniforms.viewport.value = new this.#ln.Vector2(t.viewport.x, t.viewport.y)),
      (this.#On.uniforms.cmrPos.value = t.cmrPosLocal.clone()),
      this.#On.uniforms.clipPlane.value.copy(t.clipPlane),
      this.#On.uniforms.clipBoxMatrixInv.value.copy(t.clipBoxMatrixInv),
      this.#On.uniforms.ndc2local.value.copy(t.ndc2local),
      (this.#On.uniforms.scPos.value = t.scenePositionLocal.clone()));
    let i = !0;
    this.#or &&
      (this.#Tn.lutShTex &&
        this.#On.uniforms.lutShTexture.value != this.#Tn.lutShTex &&
        (this.#On.uniforms.lutShTexture.value = this.#Tn.lutShTex),
      (i = this.#On.uniforms.lutShTexture.value === this.#Tn.lutShTex));
    let s = !0;
    (this.#or && (s = this.#tr),
      this.#On.uniforms.use0.value.set(t.pointsOnly, !!(t.useSH && this.#$n && i), t.useCustomColor, 0),
      this.#On.uniforms.use1.value.set(t.useClipBox, t.clipBoxSide, 0, 0),
      this.#On.uniforms.use2.value.set(
        t.alpha,
        !(!t.useEdgeCrop || t.pointsOnly || this.isEnvMesh || !(this.#Jn > 5e3)),
        t.useClipPlane,
        !!(t.useSemantic && t.loadingReady && s),
      ));
    const n = (t.loadingSplatDistance * t.loadingSplatDistance) / 100,
      r = (t.loadingPointDistance * t.loadingPointDistance) / 100,
      a = this.isEnvMesh ? 0 : t.loadingSwitch;
    (this.#On.uniforms.use3.value.set(a, n, r, e),
      this.#On.uniforms.semanticColors.value != this.#Tn.semanticColorsTex &&
        (this.#On.uniforms.semanticColors.value = this.#Tn.semanticColorsTex));
  }
  getBBox() {
    return this.#zt;
  }
  intersectWithRay(t, e, i) {
    if (this.#Hn.buffer.byteLength < 1) return null;
    const s = new pt(),
      n = new pt(),
      r = new pt(),
      a = e * e;
    let o = -1;
    const h = this.#Xe.useLccCompress ? 6 : 8,
      l = new Float32Array(this.#Hn.buffer);
    for (let e = 0; e < this.#Jn; ++e) {
      const c = l[e * h + 0],
        u = l[e * h + 1],
        d = l[e * h + 2],
        f = s.set(c, u, d),
        p = n.copy(f).sub(t.origin);
      if (i && !i(f)) continue;
      const m = p.dot(t.direction);
      if (m < 0 || m > t.length) continue;
      const g = r.copy(t.origin).addScaledVector(t.direction, m).sub(t.origin).sub(p);
      g.dot(g) > a || ((t.length = m), (o = m));
    }
    if (o < 0) return null;
    return { point: t.origin.clone().addScaledVector(t.direction, o), distance: o };
  }
  #pr(t) {
    const e = t / 1e4;
    return e < 1
      ? 100
      : e < 10
        ? 90
        : e < 20
          ? 70
          : e < 30
            ? 50
            : e < 40
              ? 40
              : e < 50
                ? 30
                : e < 60
                  ? 20
                  : e < 70
                    ? 10
                    : e < 80 || e < 90 || e < 100 || e < 110 || e < 120 || e < 130 || e < 140 || e < 150 || e < 160
                      ? 5
                      : e < 180
                        ? 3
                        : 1;
  }
  isCanShow() {
    if (!this.#er) return !1;
    if (this.isEnvMesh) return !0;
    const t = this.#Pt.config.MeshCanShowThreshold;
    return this.#Pt.dynamicState.cmrPosLocal.distanceToSquared(this.#Gn) < t * t;
  }
  checkNeedSort() {
    if (this.#ir) return !1;
    if (!this.#er) return !0;
    if (this.isEnvMesh && this.#er) return !1;
    const t = this.#Pt.config.CameraPosChangedSortThreshold,
      e = this.#Pt.config.CameraAngleChangedSortThreshold,
      i = this.#Pt.dynamicState.cmrPosLocal.distanceToSquared(this.#Gn),
      s = this.#Pt.dynamicState.cmrForward.dot(this.#Wn);
    if (this.#Xe.enableDepthSorting) {
      if (i < t * t && s > e) return !1;
    } else if (i < t * t) return !1;
    const n = [0, 160, 320, 480, 640, 800, 960];
    return !(this.#Pt.dynamicState.tick - this.#Qn < n[Math.min(n.length - 1, this.#qn.level)]);
  }
  startSorting() {
    const t = this.#Pt.dynamicState.cmrPosLocal.clone(),
      e = this.#Pt.dynamicState.cmrForwardLocal.clone();
    (this.#Xn.copy(t), this.#Yn.copy(e), (this.#Zn = this.#Pt.dynamicState.tick), (this.isSorting = !0));
  }
  endSorting(t = !1) {
    ((this.#sr = t),
      (this.#er = !0),
      (this.#ir = !1),
      (this.sortInfos.lastDrawCount = 0),
      t ? this.updateIndexTexture(this.indexes) : console.error('index-rt has been removed !!!!'),
      this.#Gn.copy(this.#Xn),
      this.#Wn.copy(this.#Yn),
      (this.#Qn = this.#Zn));
  }
}
class vi {
  count = 0;
  size = 0;
  #vr = 0;
  #br = 0;
  limitCount = 0;
  limitSize = 0;
  constructor(t, e) {
    ((this.#vr = t), (this.#br = e), this.reset());
  }
  isAvailable() {
    return this.#vr > this.count && this.#br > this.size;
  }
  reset() {
    ((this.limitCount = Math.max(this.limitCount, this.count)),
      (this.limitSize = Math.max(this.limitSize, this.size)),
      (this.count = 0),
      (this.size = 0));
  }
  isChanged() {
    return 0 != this.count;
  }
}
class bi {
  constructor(t) {
    ((this.prev = null), (this.next = null), (this.obj = t));
  }
  dispose() {
    ((this.prev = null), (this.next = null), (this.obj = null));
  }
}
class wi {
  #wr = 0;
  #r = null;
  constructor() {
    ((this.#r = new bi(null)), (this.#r.prev = this.#r), (this.#r.next = this.#r));
  }
  dispose() {
    for (; !this.isEmpty(); ) this.dequeue();
    ((this.#r.prev = null), (this.#r.next = null), (this.#r = null));
  }
  traverse(t) {
    let e = this.#r.next;
    for (; e !== this.#r; ) (t(e.obj), (e = e.next));
  }
  get isEmpty() {
    return 0 === this.#wr;
  }
  get length() {
    return this.#wr;
  }
  enqueue(t) {
    let e = new bi(t);
    (this.#wr++, (e.next = this.#r), (e.prev = this.#r.prev), (this.#r.prev.next = e), (this.#r.prev = e));
  }
  dequeue() {
    if (this.isEmpty) return null;
    const t = this.#r.next;
    ((t.prev.next = t.next), (t.next.prev = t.prev), this.#wr--);
    const e = t.obj;
    return (t.dispose(), e);
  }
  peek() {
    if (this.isEmpty) return null;
    return this.#r.next.obj;
  }
}
function Si(t) {
  const e = new Int32Array(1e5);
  self.onmessage = (t) => {
    const i = t.data.workerIndex,
      s = t.data.enableDepthSorting,
      n = t.data.splatCount,
      r = t.data.camPos,
      a = t.data.camForward,
      o = new Int32Array(t.data.indexesBuffer),
      h = new Int32Array(t.data.distancesBuffer),
      l = new Float32Array(t.data.transformsBuffer);
    (s
      ? (function (t, i, s, n, r, a) {
          let o = Number.MAX_SAFE_INTEGER,
            h = -Number.MAX_SAFE_INTEGER,
            l = i.x - a[0],
            c = i.y - a[1],
            u = i.z - a[2],
            d = -1e3 * Math.sqrt(l * l + c * c + u * u);
          for (let e = 0; e < t; e++) {
            let t = i.x - a[3 * e],
              n = i.y - a[3 * e + 1],
              l = i.z - a[3 * e + 2],
              c = -1e3 * Math.abs(t * s.x + n * s.y + l * s.z),
              u = Math.round(c - d);
            (u > h && (h = u), u < o && (o = u), (r[e] = u));
          }
          const f = h - o + 1;
          let p;
          if (f < e.length) {
            p = e;
            for (let t = 0; t < f; ++t) e[t] = 0;
          } else p = new Int32Array(f);
          for (let e = 0; e < t; e++) p[r[e] - o]++;
          for (let t = 1; t < p.length; ++t) p[t] += p[t - 1];
          for (let t = r.length - 1; t >= 0; --t) {
            const e = r[t] - o;
            (p[e]--, (n[p[e]] = t));
          }
        })(n, r, a, o, h, l)
      : (function (t, i, s, n, r) {
          let a = Number.MAX_SAFE_INTEGER,
            o = -Number.MAX_SAFE_INTEGER,
            h = i.x - r[0],
            l = i.y - r[1],
            c = i.z - r[2],
            u = -1e3 * Math.sqrt(h * h + l * l + c * c);
          for (let e = 0; e < t; e++) {
            let t = i.x - r[3 * e],
              s = i.y - r[3 * e + 1],
              h = i.z - r[3 * e + 2],
              l = -1e3 * Math.sqrt(t * t + s * s + h * h),
              c = Math.round(l - u);
            (c > o && (o = c), c < a && (a = c), (n[e] = c));
          }
          const d = o - a + 1;
          let f;
          if (d < e.length) {
            f = e;
            for (let t = 0; t < d; ++t) e[t] = 0;
          } else f = new Int32Array(d);
          for (let e = 0; e < t; e++) f[n[e] - a]++;
          for (let t = 1; t < f.length; ++t) f[t] += f[t - 1];
          for (let t = n.length - 1; t >= 0; --t) {
            const e = n[t] - a;
            (f[e]--, (s[f[e]] = t));
          }
        })(n, r, o, h, l),
      postMessage({ workerIndex: i, indexesBuffer: o.buffer, distancesBuffer: h.buffer, transformsBuffer: l.buffer }, [
        o.buffer,
        h.buffer,
        l.buffer,
      ]));
  };
}
class Mi {
  enableDepthSorting = !1;
  splatCount;
  camPos;
  camForward;
  indexes;
  distances;
  transforms;
  mesh;
  beginCallback;
  endCalllback;
}
class Ci {
  #f = !1;
  #lt = [];
  #Sr = [];
  #Mr = [];
  #wr = 0;
  #Cr = 0;
  #Er = !0;
  #Dr = new wi();
  constructor(t) {
    for (let e = 0; e < t; ++e) {
      const t = Se(Si);
      t ? (this.#wr++, this.#lt.push(t)) : console.error('create worker failed !!!');
    }
    this.#lt.forEach((t) => {
      t.onmessage = (t) => {
        if (this.#f) return;
        const e = t.data.workerIndex,
          i = this.#Mr[e];
        ((i.indexes = new Int32Array(t.data.indexesBuffer)),
          (i.distances = new Int32Array(t.data.distancesBuffer)),
          (i.transforms = new Float32Array(t.data.transformsBuffer)),
          this.#Dr.enqueue(i),
          this.#Cr--,
          (this.#Sr[e] = !1));
      };
    });
  }
  setEnable(t) {
    this.#Er = t;
  }
  isReady() {
    return this.#Er && this.#Cr < this.#wr;
  }
  dispose() {
    ((this.#f = !0),
      this.#lt.forEach((t) => {
        t.terminate();
      }),
      (this.#lt = []),
      (this.#wr = 0));
  }
  triggerSorting(t) {
    if (!this.isReady()) return void console.error('CPUSorter is not ready !!!');
    let e,
      i = -1;
    for (let t = 0; t < this.#lt.length; ++t)
      if (!this.#Sr[t]) {
        ((i = t), (e = this.#lt[t]));
        break;
      }
    i < 0
      ? console.error('not find ready worker!!!')
      : ((this.#Mr[i] = t),
        (this.#Sr[i] = !0),
        (this.#Cr += 1),
        t.beginCallback?.(t),
        e.postMessage(
          {
            workerIndex: i,
            enableDepthSorting: t.enableDepthSorting,
            splatCount: t.splatCount,
            camPos: { x: t.camPos.x, y: t.camPos.y, z: t.camPos.z },
            camForward: { x: t.camForward?.x, y: t.camForward?.y, z: t.camForward?.z },
            indexesBuffer: t.indexes.buffer,
            distancesBuffer: t.distances.buffer,
            transformsBuffer: t.transforms.buffer,
          },
          [t.indexes.buffer, t.distances.buffer, t.transforms.buffer],
        ));
  }
  update(t) {
    for (;;) {
      const e = this.#Dr.peek();
      if (!e) break;
      const i = e.indexes.byteLength;
      if (!t.isAvailable()) break;
      ((t.size += i), (t.count += 1), e.endCalllback?.(e), this.#Dr.dequeue());
    }
  }
}
const Ei = '\nprecision highp float;\nin vec3 position;\nvoid main() {\n     gl_Position = vec4( position, 1.0 );\n}\n';
class Di {
  #Pt;
  #Xe;
  #ln;
  #ke;
  #Ar;
  #Fr;
  #Pr;
  #Tr;
  #Ir;
  #_r;
  #Rr = { x: 512, y: 512 };
  #Nr = null;
  #Er = !0;
  constructor(t) {
    ((this.#Pt = t),
      (this.#ln = this.#Pt.lccParam.renderLib),
      (this.#ke = this.#Pt.lccParam.renderer),
      (this.#Xe = this.#Pt.config),
      (this.#Fr = new this.#ln.BufferGeometry()),
      this.#Fr.setAttribute('position', new this.#ln.Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)),
      (this.#Ar = new this.#ln.OrthographicCamera(-1, 1, 1, -1, 0, 1)),
      this.#Br(this.#Rr),
      this.#kr());
  }
  #Br(t) {
    const e = this.#ln.RGBAIntegerFormat,
      i = this.#ln.IntType,
      s = 'RGBA32I';
    ((this.#Ir = new this.#ln.WebGLRenderTarget(t.x, t.y, {
      count: 1,
      minFilter: this.#ln.NearestFilter,
      magFilter: this.#ln.NearestFilter,
      format: e,
      type: i,
      internalFormat: s,
      depthBuffer: !1,
      stencilBuffer: !1,
    })),
      (this.#Ir.texture.name = 'sortRT1'),
      (this.#_r = new this.#ln.WebGLRenderTarget(t.x, t.y, {
        count: 1,
        minFilter: this.#ln.NearestFilter,
        magFilter: this.#ln.NearestFilter,
        format: e,
        type: i,
        internalFormat: s,
        depthBuffer: !1,
        stencilBuffer: !1,
      })),
      (this.#_r.texture.name = 'sortRT2'));
  }
  #kr() {
    let t = new this.#ln.RawShaderMaterial({
        name: 'Bitonic Sort ',
        uniforms: {
          u_data: { value: null },
          dimension: { value: { x: 2, y: 2 } },
          stage: { value: 0 },
          pass: { value: 0 },
        },
        vertexShader: Ei,
        fragmentShader:
          '\nprecision highp float;\nprecision highp int;\nlayout(location = 0) out ivec4 pc_FragColor;\n\nuniform highp isampler2D u_data;\n\nuniform int stage;\nuniform int pass;\nuniform ivec2 dimension;\n\nivec4 fetch(int x, int y) {\n    return texelFetch(u_data, ivec2(x, y), 0);\n}\n\nbool minOrmax(int d1_high, int d1_low, int d2_high, int d2_low) {\n    if(d1_high > d2_high) {\n     return true;\n    }\n    if(d1_high < d2_high) {\n     return false;\n    }\n\n    if(d1_low > d2_low) {\n        return true;\n    }\n\n    if(d1_low < d2_low) {\n        return false;\n    }\n\n    return false;\n}\nvoid main() {\n\n    int fx = int(gl_FragCoord.x);\n    int fy = int(gl_FragCoord.y);\n    int index = fx + fy * dimension.x;\n\n    int pairIndex = index ^ pass;\n\n    int dFx = pairIndex % dimension.x;\n    int dFy = pairIndex / dimension.x;\n\n    bool mask = index > pairIndex;\n\n    ivec4 indexValue = fetch(fx, fy);\n    ivec4 pairValue = fetch(dFx, dFy);\n\n    bool up = ((index & stage) == 0);\n\n    // int b1 = (index - pairIndex) / abs(index - pairIndex);\n\n    // int vv = indexValue.x - pairValue.x;\n\n    // int b2 = (vv) / abs(vv);\n\n    // int b3 = min(index & stage, 2) - 1;\n    \n    // int rs1 = b1 * b2 * b3;\n\n    // pc_FragColor = max(rs1 * indexValue, -rs1 * pairValue);\n\n\n    if(!up) {\n        // if(indexValue.x > pairValue.x){\n\n        if(minOrmax(indexValue.x, indexValue.z, pairValue.x, pairValue.z)){\n            if(mask) {\n                pc_FragColor = indexValue;\n            } else {\n                pc_FragColor = pairValue;\n            }\n        } else {\n            if(mask) {\n                pc_FragColor = pairValue;\n            } else {\n                pc_FragColor = indexValue;\n            }\n        }\n    } else {\n        // if(indexValue.x < pairValue.x){\n\n        if(!minOrmax(indexValue.x, indexValue.z, pairValue.x, pairValue.z)){\n            if(mask) {\n                pc_FragColor = indexValue;\n            } else {\n                pc_FragColor = pairValue;\n            }\n        } else {\n            if(mask) {\n                pc_FragColor = pairValue;\n            } else {\n                pc_FragColor = indexValue;\n            }\n        }\n    }\n    \n}\n\n\n',
        glslVersion: this.#ln.GLSL3,
        depthTest: !1,
        depthWrite: !1,
        side: this.#ln.DoubleSide,
      }),
      e = new this.#ln.RawShaderMaterial({
        name: 'Bitonic Sort Distance',
        uniforms: {
          transforms: { value: null },
          dimension: { value: { x: 2, y: 2 } },
          dataDimensions: { value: { x: 2, y: 2 } },
          splatCount: { value: 0 },
          cmrPos: { value: { x: 0, y: 0, z: 0 } },
        },
        vertexShader: Ei,
        fragmentShader:
          '\nprecision highp float;\nprecision highp int;\nlayout(location = 0) out ivec4 pc_FragColor;\n\nuniform sampler2D transforms;\n\nuniform int splatCount;\nuniform ivec2 dimension;\nuniform ivec2 dataDimensions;\nuniform vec3 cmrPos;\n\nvoid main() {\n\n\n    int fx = int(gl_FragCoord.x);\n    int fy = int(gl_FragCoord.y);\n\n    int index = fx + fy * dimension.x;\n\n    int id1 = int(index * 2);\n    int x1 = id1 % int(dataDimensions.x);\n    int y1 = id1 / int(dataDimensions.x);\n\n    if(index >= splatCount) {\n      pc_FragColor = ivec4(10, index, 0, 0);\n    } else {\n      vec4 sampledTransform = texelFetch(transforms, ivec2(x1, y1), 0);\n      float distance = length(vec3(sampledTransform.xyz) - cmrPos) + 1000.0;\n      float dm = fract(distance) * 1000000000.;\n      pc_FragColor = ivec4(int(distance), index, int(dm), 0);\n    }\n}\n\n',
        glslVersion: this.#ln.GLSL3,
        depthTest: !1,
        depthWrite: !1,
        side: this.#ln.DoubleSide,
      });
    ((this.#Tr = new this.#ln.Mesh(this.#Fr, t)), (this.#Pr = new this.#ln.Mesh(this.#Fr, e)));
  }
  #zr(t, e) {
    const i = e.sortCmrPosPending,
      s = e.splatCount,
      n = e.dimensions,
      r = e.transformsTexture;
    ((this.#Pr.material.uniforms.splatCount.value = s),
      (this.#Pr.material.uniforms.dimension.value = n),
      (this.#Pr.material.uniforms.dataDimensions.value = e.dataDimensions),
      (this.#Pr.material.uniforms.transforms.value = r),
      (this.#Pr.material.uniforms.cmrPos.value = i),
      this.#Rr.x * this.#Rr.y < n.x * n.y &&
        ((this.#Rr.x = n.x),
        (this.#Rr.y = n.y),
        this.#Ir.setSize(this.#Rr.x, this.#Rr.y),
        this.#_r.setSize(this.#Rr.x, this.#Rr.y)),
      t.setViewport(0, 0, n.x, n.y),
      t.setRenderTarget(this.#Ir),
      t.render(this.#Pr, this.#Ar));
  }
  #Lr(t, e) {
    const i = e.sortInfos,
      s = e.dimensions,
      n = i.maxCountOneTime,
      r = s.x * s.y;
    let a = 0;
    const o = Math.min(i.lastDrawCount + n, i.totalDrawCount);
    this.#Tr.material.uniforms.dimension.value = s;
    for (let n = 2; n <= r; n <<= 1)
      for (let r = n >> 1; r > 0; r >>= 1) {
        if (a < i.lastDrawCount) {
          a++;
          continue;
        }
        if (a === o) return void (i.lastDrawCount = o);
        (a++,
          (this.#Tr.material.uniforms.stage.value = n),
          (this.#Tr.material.uniforms.pass.value = r),
          (this.#Tr.material.uniforms.u_data.value = this.#Ir.texture),
          t.setViewport(0, 0, s.x, s.y),
          a === i.totalDrawCount ? t.setRenderTarget(e.indexRT) : t.setRenderTarget(this.#_r),
          t.render(this.#Tr, this.#Ar));
        let h = this.#Ir;
        ((this.#Ir = this.#_r), (this.#_r = h));
      }
    o === i.totalDrawCount && (e.endSorting(), (this.#Nr = null));
  }
  update() {
    if (this.#Nr) {
      if (this.#Nr.isDispose) return (console.log('sorting mesh had been disposed !!!'), void (this.#Nr = null));
      (this.#Nr.sortInfos.lastDrawCount < 1 && this.#zr(this.#ke, this.#Nr),
        this.#Lr(this.#ke, this.#Nr),
        this.#ke.setRenderTarget(null));
    }
  }
  setEnable(t) {
    this.#Er = t;
  }
  isReady() {
    return this.#Er && !this.#Nr;
  }
  triggerSorting(t) {
    this.#Nr || ((this.#Nr = t), t.startSorting());
  }
  dispose() {
    ((this.#Nr = null),
      (this.#Ar = null),
      this.#Pr &&
        ((this.#Pr.geometry = null),
        this.#Pr.material &&
          ((this.#Pr.material.uniforms.transforms.value = null),
          this.#Pr.material.dispose(),
          (this.#Pr.material = null)),
        (this.#Pr = null)),
      this.#Tr &&
        ((this.#Tr.geometry = null),
        this.#Tr.material &&
          ((this.#Tr.material.uniforms.u_data.value = null), this.#Tr.material.dispose(), (this.#Tr.material = null)),
        (this.#Tr = null)),
      this.#Fr && (this.#Fr.dispose(), (this.#Fr = null)),
      this.#Ir && (this.#Ir.texture.dispose(), this.#Ir.dispose(), (this.#Ir = null)),
      this.#_r && (this.#_r.texture.dispose(), this.#_r.dispose(), (this.#_r = null)));
  }
}
class Ai {
  #f = !1;
  #G;
  #K;
  #Pt;
  #Or;
  #Hr;
  #jr;
  #qr = [];
  #Vr = [];
  #Ur = [];
  #Kr = [];
  #Gr = [];
  #Wr = [];
  #Qr = [];
  #Xr;
  #Yr = 0;
  constructor(t, e) {
    ((this.#Xr = e),
      (this.#Pt = t),
      (this.#G = this.#Pt.gpuCache),
      (this.#K = this.#Pt.cpuCache),
      (this.#Or = new Ci(this.#Pt.config.CpuSortThreadNum)),
      this.#Pt.config.WebglSortingEnable && (this.#Hr = new Di(this.#Pt)));
  }
  dispose() {
    ((this.#f = !0), this.#Or.dispose(), this.#Hr?.dispose(), this.#jr?.dispose());
  }
  #Zr(t, e) {
    const i = this.#Pt.lccParam.renderLib,
      s = new i.BufferGeometry();
    (s.setAttribute('position', new i.BufferAttribute(t, 3)), s.setIndex(new i.BufferAttribute(e, 1)));
    const n = new i.MeshBasicMaterial({ color: 8421504, side: i.DoubleSide });
    return new i.Mesh(s, n);
  }
  #Jr() {
    if (this.#jr) return this.#jr;
    const t = this.#Pt.meta,
      e = this.#Pt.renderID,
      i = this.#K.queryEnv(e);
    if (!i || !t) return null;
    const { splatCounts: s, data: n, sh: r, pos: a } = i;
    return (
      (this.#jr = new xi(this.#Pt, null, s, n, a, yt(r))),
      (this.#jr.object.renderOrder = 0),
      this.#G.pushEnv(e, this.#jr),
      this.#jr
    );
  }
  getEnvmesh(t = !0) {
    return (this.#jr || this.#Jr(), this.#jr ? (t && !this.#jr.isFirstSorted ? null : this.#jr) : null);
  }
  getMesh(t, e = !0) {
    let i = this.#G.queryMesh(t.renderID, t.id);
    return i ? (e && !i.isFirstSorted ? null : i) : null;
  }
  clearCacheCollQueue() {
    this.#Vr = [];
  }
  pushCacheCollQueue(t) {
    this.#Vr.push(t);
  }
  clearCacheQueue() {
    this.#qr = [];
  }
  pushCacheQueue(t) {
    this.#qr.push(t);
  }
  clearCacheSHQueue() {
    this.#Ur = [];
  }
  pushCacheSHQueue(t) {
    this.#Ur.push(t);
  }
  clearCacheSemQueue() {
    this.#Kr = [];
  }
  pushCacheSemQueue(t) {
    this.#Kr.push(t);
  }
  clearSortQueue() {
    ((this.#Gr = []), (this.#Wr = []));
  }
  pushSortQueue(t) {
    t.isSorting || (t.isFirstSorted, this.#Wr.push(t));
  }
  update(t) {
    if (!this.#f) {
      this.#Or.update(this.#Xr);
      for (let t = 0; t < this.#Vr.length; ++t) {
        const e = this.#Vr[t],
          i = e.queryCacheData();
        if (!i) continue;
        const s = this.#Zr(i.vertexes, i.faces);
        e.pushCacheMesh(s) || (console.error('push coll mesh fail.'), s.dispose());
      }
      for (let t = 0; t < this.#qr.length && this.#Xr.isAvailable(); ++t) {
        const i = this.#qr[t];
        if (!i || !i.isCache(e) || this.#G.queryMesh(i.renderID, i.id)) continue;
        const { data: s, sh: n, pos: r } = i.queryCache(),
          a = (s?.byteLength || 0) + (n?.byteLength || 0);
        ((this.#Xr.size += a), (this.#Xr.count += 1));
        const o = new xi(this.#Pt, i, i.points, s, r, n);
        this.#G.pushMesh(i.renderID, i.id, o, o.size) || (console.log('push mesh failed...'), o.dispose());
      }
      for (let t = 0; t < this.#Ur.length && this.#Xr.isAvailable(); ++t) {
        const e = this.#Ur[t],
          s = e.node;
        if (e.hasUploadSH || !s || !s.isCache(i)) continue;
        const { data: n, sh: r, pos: a } = s.queryCache();
        ((this.#Xr.size += r.byteLength),
          (this.#Xr.count += 1),
          e.updateSHTexture(r),
          this.#G.flushMesh(s.renderID, s.id, e, e.size));
      }
      for (let t = 0; t < this.#Kr.length && this.#Xr.isAvailable(); ++t) {
        const e = this.#Kr[t],
          i = e.node;
        if (e.hasUploadSem || !i || !i.isCache(l)) continue;
        const { sem: s } = i.queryCache();
        ((this.#Xr.size += s.byteLength),
          (this.#Xr.count += 1),
          e.updateSemanticTexture(s),
          this.#G.flushMesh(i.renderID, i.id, e, e.size));
      }
      for (
        0 == this.#Qr.length && (this.#Qr = [...this.#Gr, ...this.#Wr]);
        this.#Qr.length > 0 && this.#Or.isReady();

      ) {
        let t = this.#Qr.shift();
        if (!t || t.isDispose || !t.checkNeedSort()) continue;
        const e = this.#Pt.dynamicState.cmrPosLocal,
          i = this.#Pt.dynamicState.cmrForwardLocal,
          s = new Mi();
        ((s.enableDepthSorting = this.#Pt.config.enableDepthSorting),
          (s.splatCount = t.splatCount),
          (s.camPos = { x: e.x, y: e.y, z: e.z }),
          (s.camForward = { x: i.x, y: i.y, z: i.z }),
          (s.distances = t.distances),
          (s.indexes = t.indexes),
          (s.transforms = t.pos),
          (s.mesh = t),
          (s.beginCallback = (t) => {
            t.mesh && !t.mesh.isDispose && t.mesh.startSorting();
          }),
          (s.endCalllback = (t) => {
            t.mesh &&
              !t.mesh.isDispose &&
              ((t.mesh.pos = t.transforms),
              (t.mesh.indexes = t.indexes),
              (t.mesh.distances = t.distances),
              t.mesh.endSorting(!0));
          }),
          this.#Or.triggerSorting(s));
      }
    }
  }
}
class Fi {
  #$r = new Ot();
  #ta = new Ot();
  #ea = 1;
  #ia = new pt();
  #sa = new pt();
  #na = new pt();
  #ra = new ie(new pt(-0.5, -0.5, -0.5), new pt(0.5, 0.5, 0.5));
  #aa = new pt();
  constructor() {
    this.update();
  }
  get matrix() {
    return this.#$r;
  }
  get matrixInverse() {
    return this.#ta;
  }
  get clipSide() {
    return this.#ea;
  }
  get position() {
    return this.#ia;
  }
  get rotation() {
    return this.#na;
  }
  get scale() {
    return this.#sa;
  }
  setSize(t, e, i) {
    this.#sa(t, e, i);
  }
  reset() {
    ((this.#ia = new pt()), (this.#na = new pt()), (this.#sa = new pt()), (this.#ea = 1), this.update());
  }
  copy(t) {
    (this.#ia.copy(t.position),
      this.#sa.copy(t.scale),
      this.#na.copy(t.rotation),
      (this.#ea = t.clipSide),
      this.#$r.copy(t.matrix),
      this.#ta.copy(t.matrixInverse));
  }
  update(t, e, i, s = 1) {
    (t?.isVector3 && this.#ia.copy(t), e?.isVector3 && this.#na.copy(e), i?.isVector3 && this.#sa.copy(i));
    const n = new Ot()
        .makeRotationX(this.#na.x)
        .multiply(new Ot().makeRotationY(this.#na.y))
        .multiply(new Ot().makeRotationZ(this.#na.z)),
      r = new dt().setFromRotationMatrix(n),
      a = new Ot().compose(this.#ia, r, this.#sa);
    ((this.#$r = a), (this.#ta = a.clone().invert()), (this.#ea = s));
  }
  testPoint(t) {
    const e = 1 == this.#ea,
      i = this.#aa.copy(t).applyMatrix4(this.#ta),
      s = this.#ra.containsPoint(i);
    return (e && s) || (!e && !s);
  }
}
class Pi {
  constructor(t = new pt(0, 0, 0), e = new pt(0, 1, 0), i = 1) {
    ((this.start = t), (this.end = e), (this.radius = i));
  }
  clone() {
    return new Pi(this.start.clone(), this.end.clone(), this.radius);
  }
  set(t, e, i) {
    (this.start.copy(t), this.end.copy(e), (this.radius = i));
  }
  copy(t) {
    (this.start.copy(t.start), this.end.copy(t.end), (this.radius = t.radius));
  }
  getCenter(t) {
    return t.copy(this.end).add(this.start).multiplyScalar(0.5);
  }
  translate(t) {
    (this.start.add(t), this.end.add(t));
  }
  applyMatrix4(t) {
    return (this.start.applyMatrix4(t), this.end.applyMatrix4(t), this);
  }
  calAABB(t) {
    let e = t;
    return (
      e || (e = new ie()),
      e.makeEmpty(),
      e.expandByPoint(this.start),
      e.expandByPoint(this.end),
      e.min.addScalar(-this.radius),
      e.max.addScalar(this.radius),
      e
    );
  }
  checkAABBAxis(t, e, i, s, n, r, a, o, h) {
    return (n - t < h || n - i < h) && (t - r < h || i - r < h) && (a - e < h || a - s < h) && (e - o < h || s - o < h);
  }
  intersectsBox(t) {
    return (
      this.checkAABBAxis(
        this.start.x,
        this.start.y,
        this.end.x,
        this.end.y,
        t.min.x,
        t.max.x,
        t.min.y,
        t.max.y,
        this.radius,
      ) &&
      this.checkAABBAxis(
        this.start.x,
        this.start.z,
        this.end.x,
        this.end.z,
        t.min.x,
        t.max.x,
        t.min.z,
        t.max.z,
        this.radius,
      ) &&
      this.checkAABBAxis(
        this.start.y,
        this.start.z,
        this.end.y,
        this.end.z,
        t.min.y,
        t.max.y,
        t.min.z,
        t.max.z,
        this.radius,
      )
    );
  }
}
const Ti = new pt(),
  Ii = new pt(),
  _i = new pt(),
  Ri = new pt(),
  Ni = new pt(),
  Bi = new pt(),
  ki = new pt(),
  zi = new pt(),
  Li = new pt(),
  Oi = new pt(),
  Hi = new st(),
  ji = new st(),
  qi = new st();
class Vi {
  constructor(t = new pt(), e = new pt(), i = new pt()) {
    ((this.a = t), (this.b = e), (this.c = i));
  }
  static getNormal(t, e, i, s) {
    (s.subVectors(i, e), Ti.subVectors(t, e), s.cross(Ti));
    const n = s.lengthSq();
    return n > 0 ? s.multiplyScalar(1 / Math.sqrt(n)) : s.set(0, 0, 0);
  }
  static getBarycoord(t, e, i, s, n) {
    (Ti.subVectors(s, e), Ii.subVectors(i, e), _i.subVectors(t, e));
    const r = Ti.dot(Ti),
      a = Ti.dot(Ii),
      o = Ti.dot(_i),
      h = Ii.dot(Ii),
      l = Ii.dot(_i),
      c = r * h - a * a;
    if (0 === c) return (n.set(0, 0, 0), null);
    const u = 1 / c,
      d = (h * o - a * l) * u,
      f = (r * l - a * o) * u;
    return n.set(1 - d - f, f, d);
  }
  static containsPoint(t, e, i, s) {
    return null !== this.getBarycoord(t, e, i, s, Ri) && Ri.x >= 0 && Ri.y >= 0 && Ri.x + Ri.y <= 1;
  }
  static getInterpolation(t, e, i, s, n, r, a, o) {
    return null === this.getBarycoord(t, e, i, s, Ri)
      ? ((o.x = 0), (o.y = 0), 'z' in o && (o.z = 0), 'w' in o && (o.w = 0), null)
      : (o.setScalar(0), o.addScaledVector(n, Ri.x), o.addScaledVector(r, Ri.y), o.addScaledVector(a, Ri.z), o);
  }
  static getInterpolatedAttribute(t, e, i, s, n, r) {
    return (
      Hi.setScalar(0),
      ji.setScalar(0),
      qi.setScalar(0),
      Hi.fromBufferAttribute(t, e),
      ji.fromBufferAttribute(t, i),
      qi.fromBufferAttribute(t, s),
      r.setScalar(0),
      r.addScaledVector(Hi, n.x),
      r.addScaledVector(ji, n.y),
      r.addScaledVector(qi, n.z),
      r
    );
  }
  static isFrontFacing(t, e, i, s) {
    return (Ti.subVectors(i, e), Ii.subVectors(t, e), Ti.cross(Ii).dot(s) < 0);
  }
  set(t, e, i) {
    return (this.a.copy(t), this.b.copy(e), this.c.copy(i), this);
  }
  setFromPointsAndIndices(t, e, i, s) {
    return (this.a.copy(t[e]), this.b.copy(t[i]), this.c.copy(t[s]), this);
  }
  setFromAttributeAndIndices(t, e, i, s) {
    return (this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, i), this.c.fromBufferAttribute(t, s), this);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return (this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this);
  }
  getArea() {
    return (Ti.subVectors(this.c, this.b), Ii.subVectors(this.a, this.b), 0.5 * Ti.cross(Ii).length());
  }
  getMidpoint(t) {
    return t
      .addVectors(this.a, this.b)
      .add(this.c)
      .multiplyScalar(1 / 3);
  }
  getNormal(t) {
    return Vi.getNormal(this.a, this.b, this.c, t);
  }
  getPlane(t) {
    return t.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(t, e) {
    return Vi.getBarycoord(t, this.a, this.b, this.c, e);
  }
  getInterpolation(t, e, i, s, n) {
    return Vi.getInterpolation(t, this.a, this.b, this.c, e, i, s, n);
  }
  containsPoint(t) {
    return Vi.containsPoint(t, this.a, this.b, this.c);
  }
  isFrontFacing(t) {
    return Vi.isFrontFacing(this.a, this.b, this.c, t);
  }
  intersectsBox(t) {
    return t.intersectsTriangle(this);
  }
  closestPointToPoint(t, e) {
    const i = this.a,
      s = this.b,
      n = this.c;
    let r, a;
    (Ni.subVectors(s, i), Bi.subVectors(n, i), zi.subVectors(t, i));
    const o = Ni.dot(zi),
      h = Bi.dot(zi);
    if (o <= 0 && h <= 0) return e.copy(i);
    Li.subVectors(t, s);
    const l = Ni.dot(Li),
      c = Bi.dot(Li);
    if (l >= 0 && c <= l) return e.copy(s);
    const u = o * c - l * h;
    if (u <= 0 && o >= 0 && l <= 0) return ((r = o / (o - l)), e.copy(i).addScaledVector(Ni, r));
    Oi.subVectors(t, n);
    const d = Ni.dot(Oi),
      f = Bi.dot(Oi);
    if (f >= 0 && d <= f) return e.copy(n);
    const p = d * h - o * f;
    if (p <= 0 && h >= 0 && f <= 0) return ((a = h / (h - f)), e.copy(i).addScaledVector(Bi, a));
    const m = l * f - d * c;
    if (m <= 0 && c - l >= 0 && d - f >= 0)
      return (ki.subVectors(n, s), (a = (c - l) / (c - l + (d - f))), e.copy(s).addScaledVector(ki, a));
    const g = 1 / (m + p + u);
    return ((r = p * g), (a = u * g), e.copy(i).addScaledVector(Ni, r).addScaledVector(Bi, a));
  }
  equals(t) {
    return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
  }
}
const Ui = new pt(),
  Ki = new pt();
class Gi {
  constructor(t = new pt(), e = new pt()) {
    ((this.start = t), (this.end = e));
  }
  set(t, e) {
    return (this.start.copy(t), this.end.copy(e), this);
  }
  copy(t) {
    return (this.start.copy(t.start), this.end.copy(t.end), this);
  }
  getCenter(t) {
    return t.addVectors(this.start, this.end).multiplyScalar(0.5);
  }
  delta(t) {
    return t.subVectors(this.end, this.start);
  }
  distanceSq() {
    return this.start.distanceToSquared(this.end);
  }
  distance() {
    return this.start.distanceTo(this.end);
  }
  at(t, e) {
    return this.delta(e).multiplyScalar(t).add(this.start);
  }
  closestPointToPointParameter(t, e) {
    (Ui.subVectors(t, this.start), Ki.subVectors(this.end, this.start));
    const i = Ki.dot(Ki);
    let s = Ki.dot(Ui) / i;
    return (e && (s = ht(s, 0, 1)), s);
  }
  closestPointToPoint(t, e, i) {
    const s = this.closestPointToPointParameter(t, e);
    return this.delta(i).multiplyScalar(s).add(this.start);
  }
  applyMatrix4(t) {
    return (this.start.applyMatrix4(t), this.end.applyMatrix4(t), this);
  }
  equals(t) {
    return t.start.equals(this.start) && t.end.equals(this.end);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Wi {
  constructor() {
    ((this.min = 1 / 0), (this.max = -1 / 0));
  }
  setFromPointsField(t, e) {
    let i = 1 / 0,
      s = -1 / 0;
    for (let n = 0, r = t.length; n < r; n++) {
      const r = t[n][e];
      ((i = r < i ? r : i), (s = r > s ? r : s));
    }
    ((this.min = i), (this.max = s));
  }
  setFromPoints(t, e) {
    let i = 1 / 0,
      s = -1 / 0;
    for (let n = 0, r = e.length; n < r; n++) {
      const r = e[n],
        a = t.dot(r);
      ((i = a < i ? a : i), (s = a > s ? a : s));
    }
    ((this.min = i), (this.max = s));
  }
  isSeparated(t) {
    return this.min > t.max || t.min > this.max;
  }
}
Wi.prototype.setFromBox = (function () {
  const t = new pt();
  return function (e, i) {
    const s = i.min,
      n = i.max;
    let r = 1 / 0,
      a = -1 / 0;
    for (let i = 0; i <= 1; i++)
      for (let o = 0; o <= 1; o++)
        for (let h = 0; h <= 1; h++) {
          ((t.x = s.x * i + n.x * (1 - i)), (t.y = s.y * o + n.y * (1 - o)), (t.z = s.z * h + n.z * (1 - h)));
          const l = e.dot(t);
          ((r = Math.min(l, r)), (a = Math.max(l, a)));
        }
    ((this.min = r), (this.max = a));
  };
})();
const Qi = (function () {
    const t = new pt(),
      e = new pt(),
      i = new pt();
    return function (s, n, r) {
      const a = s.start,
        o = t,
        h = n.start,
        l = e;
      (i.subVectors(a, h), t.subVectors(s.end, s.start), e.subVectors(n.end, n.start));
      const c = i.dot(l),
        u = l.dot(o),
        d = l.dot(l),
        f = i.dot(o),
        p = o.dot(o) * d - u * u;
      let m, g;
      ((m = 0 !== p ? (c * u - f * d) / p : 0), (g = (c + m * u) / d), (r.x = m), (r.y = g));
    };
  })(),
  Xi = (function () {
    const t = new ee(),
      e = new pt(),
      i = new pt();
    return function (s, n, r, a) {
      Qi(s, n, t);
      let o = t.x,
        h = t.y;
      if (o >= 0 && o <= 1 && h >= 0 && h <= 1) return (s.at(o, r), void n.at(h, a));
      if (o >= 0 && o <= 1) return (h < 0 ? n.at(0, a) : n.at(1, a), void s.closestPointToPoint(a, !0, r));
      if (h >= 0 && h <= 1) return (o < 0 ? s.at(0, r) : s.at(1, r), void n.closestPointToPoint(r, !0, a));
      {
        let t, l;
        ((t = o < 0 ? s.start : s.end), (l = h < 0 ? n.start : n.end));
        const c = e,
          u = i;
        return (
          s.closestPointToPoint(l, !0, e),
          n.closestPointToPoint(t, !0, i),
          c.distanceToSquared(l) <= u.distanceToSquared(t) ? (r.copy(c), void a.copy(l)) : (r.copy(t), void a.copy(u))
        );
      }
    };
  })(),
  Yi = (function () {
    const t = new pt(),
      e = new pt(),
      i = new ti(),
      s = new Gi();
    return function (n, r) {
      const { radius: a, center: o } = n,
        { a: h, b: l, c: c } = r;
      ((s.start = h), (s.end = l));
      if (s.closestPointToPoint(o, !0, t).distanceTo(o) <= a) return !0;
      ((s.start = h), (s.end = c));
      if (s.closestPointToPoint(o, !0, t).distanceTo(o) <= a) return !0;
      ((s.start = l), (s.end = c));
      if (s.closestPointToPoint(o, !0, t).distanceTo(o) <= a) return !0;
      const u = r.getPlane(i);
      if (Math.abs(u.distanceToPoint(o)) <= a) {
        const t = u.projectPoint(o, e);
        if (r.containsPoint(t)) return !0;
      }
      return !1;
    };
  })();
function Zi(t) {
  return Math.abs(t) < 1e-15;
}
class Ji extends Vi {
  constructor(...t) {
    (super(...t),
      (this.isExtendedTriangle = !0),
      (this.satAxes = new Array(4).fill().map(() => new pt())),
      (this.satBounds = new Array(4).fill().map(() => new Wi())),
      (this.points = [this.a, this.b, this.c]),
      (this.sphere = new Qe()),
      (this.plane = new ti()),
      (this.needsUpdate = !0));
  }
  intersectsSphere(t) {
    return Yi(t, this);
  }
  update() {
    const t = this.a,
      e = this.b,
      i = this.c,
      s = this.points,
      n = this.satAxes,
      r = this.satBounds,
      a = n[0],
      o = r[0];
    (this.getNormal(a), o.setFromPoints(a, s));
    const h = n[1],
      l = r[1];
    (h.subVectors(t, e), l.setFromPoints(h, s));
    const c = n[2],
      u = r[2];
    (c.subVectors(e, i), u.setFromPoints(c, s));
    const d = n[3],
      f = r[3];
    (d.subVectors(i, t),
      f.setFromPoints(d, s),
      this.sphere.setFromPoints(this.points),
      this.plane.setFromNormalAndCoplanarPoint(a, t),
      (this.needsUpdate = !1));
  }
}
((Ji.prototype.closestPointToSegment = (function () {
  const t = new pt(),
    e = new pt(),
    i = new Gi();
  return function (s, n = null, r = null) {
    const { start: a, end: o } = s,
      h = this.points;
    let l,
      c = 1 / 0;
    for (let a = 0; a < 3; a++) {
      const o = (a + 1) % 3;
      (i.start.copy(h[a]),
        i.end.copy(h[o]),
        Xi(i, s, t, e),
        (l = t.distanceToSquared(e)),
        l < c && ((c = l), n && n.copy(t), r && r.copy(e)));
    }
    return (
      this.closestPointToPoint(a, t),
      (l = a.distanceToSquared(t)),
      l < c && ((c = l), n && n.copy(t), r && r.copy(a)),
      this.closestPointToPoint(o, t),
      (l = o.distanceToSquared(t)),
      l < c && ((c = l), n && n.copy(t), r && r.copy(o)),
      Math.sqrt(c)
    );
  };
})()),
  (Ji.prototype.intersectsTriangle = (function () {
    const t = new Ji(),
      e = new Array(3),
      i = new Array(3),
      s = new Wi(),
      n = new Wi(),
      r = new pt(),
      a = new pt(),
      o = new pt(),
      h = new pt(),
      l = new pt(),
      c = new Gi(),
      u = new Gi(),
      d = new Gi(),
      f = new pt();
    function p(t, e, i) {
      const s = t.points;
      let n = 0,
        r = -1;
      for (let t = 0; t < 3; t++) {
        const { start: o, end: h } = c;
        (o.copy(s[t]), h.copy(s[(t + 1) % 3]), c.delta(a));
        const l = Zi(e.distanceToPoint(o));
        if (Zi(e.normal.dot(a)) && l) {
          (i.copy(c), (n = 2));
          break;
        }
        const u = e.intersectLine(c, f);
        if ((!u && l && f.copy(o), (u || l) && !Zi(f.distanceTo(h)))) {
          if (n <= 1) {
            ((1 === n ? i.start : i.end).copy(f), l && (r = n));
          } else if (n >= 2) {
            ((1 === r ? i.start : i.end).copy(f), (n = 2));
            break;
          }
          if ((n++, 2 === n && -1 === r)) break;
        }
      }
      return n;
    }
    return function (a, c = null, f = !1) {
      (this.needsUpdate && this.update(),
        a.isExtendedTriangle ? a.needsUpdate && a.update() : (t.copy(a), t.update(), (a = t)));
      const m = this.plane,
        g = a.plane;
      if (Math.abs(m.normal.dot(g.normal)) > 1 - 1e-10) {
        const t = this.satBounds,
          o = this.satAxes;
        ((i[0] = a.a), (i[1] = a.b), (i[2] = a.c));
        for (let e = 0; e < 4; e++) {
          const n = t[e],
            r = o[e];
          if ((s.setFromPoints(r, i), n.isSeparated(s))) return !1;
        }
        const h = a.satBounds,
          l = a.satAxes;
        ((e[0] = this.a), (e[1] = this.b), (e[2] = this.c));
        for (let t = 0; t < 4; t++) {
          const i = h[t],
            n = l[t];
          if ((s.setFromPoints(n, e), i.isSeparated(s))) return !1;
        }
        for (let t = 0; t < 4; t++) {
          const a = o[t];
          for (let t = 0; t < 4; t++) {
            const o = l[t];
            if ((r.crossVectors(a, o), s.setFromPoints(r, e), n.setFromPoints(r, i), s.isSeparated(n))) return !1;
          }
        }
        return (
          c &&
            (f ||
              console.warn(
                'ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.',
              ),
            c.start.set(0, 0, 0),
            c.end.set(0, 0, 0)),
          !0
        );
      }
      {
        const t = p(this, g, u);
        if (1 === t && a.containsPoint(u.end)) return (c && (c.start.copy(u.end), c.end.copy(u.end)), !0);
        if (2 !== t) return !1;
        const e = p(a, m, d);
        if (1 === e && this.containsPoint(d.end)) return (c && (c.start.copy(d.end), c.end.copy(d.end)), !0);
        if (2 !== e) return !1;
        if ((u.delta(o), d.delta(h), o.dot(h) < 0)) {
          let t = d.start;
          ((d.start = d.end), (d.end = t));
        }
        const i = u.start.dot(o),
          s = u.end.dot(o),
          n = d.start.dot(o),
          r = d.end.dot(o);
        return (
          (i === r || n === s || s < n !== i < r) &&
          (c &&
            (l.subVectors(u.start, d.start),
            l.dot(o) > 0 ? c.start.copy(u.start) : c.start.copy(d.start),
            l.subVectors(u.end, d.end),
            l.dot(o) < 0 ? c.end.copy(u.end) : c.end.copy(d.end)),
          !0)
        );
      }
    };
  })()),
  (Ji.prototype.distanceToPoint = (function () {
    const t = new pt();
    return function (e) {
      return (this.closestPointToPoint(e, t), e.distanceTo(t));
    };
  })()),
  (Ji.prototype.distanceToTriangle = (function () {
    const t = new pt(),
      e = new pt(),
      i = ['a', 'b', 'c'],
      s = new Gi(),
      n = new Gi();
    return function (r, a = null, o = null) {
      const h = a || o ? s : null;
      if (this.intersectsTriangle(r, h)) return ((a || o) && (a && h.getCenter(a), o && h.getCenter(o)), 0);
      let l = 1 / 0;
      for (let e = 0; e < 3; e++) {
        let s;
        const n = i[e],
          h = r[n];
        (this.closestPointToPoint(h, t),
          (s = h.distanceToSquared(t)),
          s < l && ((l = s), a && a.copy(t), o && o.copy(h)));
        const c = this[n];
        (r.closestPointToPoint(c, t), (s = c.distanceToSquared(t)), s < l && ((l = s), a && a.copy(c), o && o.copy(t)));
      }
      for (let h = 0; h < 3; h++) {
        const c = i[h],
          u = i[(h + 1) % 3];
        s.set(this[c], this[u]);
        for (let h = 0; h < 3; h++) {
          const c = i[h],
            u = i[(h + 1) % 3];
          (n.set(r[c], r[u]), Xi(s, n, t, e));
          const d = t.distanceToSquared(e);
          d < l && ((l = d), a && a.copy(t), o && o.copy(e));
        }
      }
      return Math.sqrt(l);
    };
  })()));
const $i = new pt(),
  ts = new pt(),
  es = new pt();
(new pt(), new ie());
const is = new ie(),
  ss = new ie(),
  ns = new Ji(),
  rs = 2;
function as(t, e) {
  return e[t + 6];
}
function os(t, e) {
  return e[t + 14];
}
function hs(t, e) {
  return 65535 === e[t + 15];
}
function ls(t) {
  return t + 8;
}
function cs(t, e) {
  return e[t + 6];
}
function us(t, e, i) {
  let s = 2 * t;
  for (; !hs(s, e); ) s = 2 * (t = ls(t));
  return as(t, i);
}
function ds(t, e, i) {
  let s = 2 * t;
  for (; !hs(s, e); ) s = 2 * (t = cs(t, i));
  return as(t, i) + os(s, e);
}
function fs(t, e, i) {
  return (
    (i.min.x = e[t]),
    (i.min.y = e[t + 1]),
    (i.min.z = e[t + 2]),
    (i.max.x = e[t + 3]),
    (i.max.y = e[t + 4]),
    (i.max.z = e[t + 5]),
    i
  );
}
function ps(t, e, i, s, n) {
  let r, a, o, h, l, c;
  const u = 1 / i.direction.x,
    d = 1 / i.direction.y,
    f = 1 / i.direction.z,
    p = i.origin.x,
    m = i.origin.y,
    g = i.origin.z;
  let y = e[t],
    x = e[t + 3],
    v = e[t + 1],
    b = e[t + 3 + 1],
    w = e[t + 2],
    S = e[t + 3 + 2];
  return (
    u >= 0 ? ((r = (y - p) * u), (a = (x - p) * u)) : ((r = (x - p) * u), (a = (y - p) * u)),
    d >= 0 ? ((o = (v - m) * d), (h = (b - m) * d)) : ((o = (b - m) * d), (h = (v - m) * d)),
    !(r > h || o > a) &&
      ((o > r || isNaN(r)) && (r = o),
      (h < a || isNaN(a)) && (a = h),
      f >= 0 ? ((l = (w - g) * f), (c = (S - g) * f)) : ((l = (S - g) * f), (c = (w - g) * f)),
      !(r > c || l > a) && ((l > r || r != r) && (r = l), (c < a || a != a) && (a = c), r <= n && a >= s))
  );
}
function ms(t, e, i, s) {
  const n = t.vertexes,
    r = t.faces;
  for (let t = e, a = e + i; t < a; ++t) {
    let e = r[3 * t + 0],
      i = r[3 * t + 1],
      a = r[3 * t + 2],
      o = n[3 * e + 0],
      h = n[3 * e + 1],
      l = n[3 * e + 2],
      c = n[3 * i + 0],
      u = n[3 * i + 1],
      d = n[3 * i + 2],
      f = n[3 * a + 0],
      p = n[3 * a + 1],
      m = n[3 * a + 2];
    if ((ns.a.set(o, h, l), ns.b.set(c, u, d), ns.c.set(f, p, m), (ns.needsUpdate = !0), s(ns))) return !0;
  }
  return !1;
}
function gs(t, e) {
  const i = [];
  return (
    (function t(e, i, s, n) {
      const r = i.bvh_f32,
        a = i.bvh_u16,
        o = i.bvh_u32,
        h = 2 * e;
      if (hs(h, a)) {
        !(function (t, e, i, s, n, r = !0) {
          const a = t.vertexes,
            o = t.faces;
          for (let t = i, h = i + s; t < h; ++t) {
            let i = o[3 * t + 0],
              s = o[3 * t + 1],
              h = o[3 * t + 2],
              l = a[3 * i + 0],
              c = a[3 * i + 1],
              u = a[3 * i + 2],
              d = a[3 * s + 0],
              f = a[3 * s + 1],
              p = a[3 * s + 2],
              m = a[3 * h + 0],
              g = a[3 * h + 1],
              y = a[3 * h + 2];
            ($i.set(l, c, u), ts.set(d, f, p), es.set(m, g, y));
            const x = e.intersectTriangle($i, ts, es, !1);
            x && (r && (e.length = x.distance), n.push(x));
          }
        })(i, s, as(e, o), os(h, a), n);
      } else {
        const a = ls(e);
        ps(a, r, s, 0, s.length) && t(a, i, s, n);
        const h = cs(e, o);
        ps(h, r, s, 0, s.length) && t(h, i, s, n);
      }
    })(0, t, e, i),
    0 == i.length ? null : i[i.length - 1]
  );
}
function ys(t, e, i) {
  return (function t(e, i, s, n) {
    const r = i.bvh_f32,
      a = i.bvh_u16,
      o = i.bvh_u32;
    let h = 2 * e;
    if (hs(h, a)) {
      return ms(i, as(e, o), os(h, a), n);
    }
    {
      let h,
        l = ls(e),
        c = cs(e, o),
        u = is;
      fs(l, r, u);
      const d = s(u);
      if (d === rs) {
        const t = us(l, a, o);
        h = ms(i, t, ds(l, a, o) - t, n);
      } else h = d && t(l, i, s, n);
      if (h) return !0;
      let f,
        p = ss;
      fs(c, r, p);
      const m = s(p);
      if (m === rs) {
        const t = us(c, a, o);
        f = ms(i, t, ds(c, a, o) - t, n);
      } else f = m && t(c, i, s, n);
      return !!f;
    }
  })(0, t, e, i);
}
function xs(t, e) {
  return ys(
    t,
    (t) => e.intersectsBox(t),
    (t) => t.intersectsSphere(e),
  );
}
function vs(t, e) {
  let i = !1,
    s = new pt(0, 0, 0);
  const n = e.radius,
    r = new pt(),
    a = e.center.clone();
  return (
    ys(
      t,
      (t) => e.intersectsBox(t),
      (t) => {
        t.closestPointToPoint(a, r);
        const e = r.distanceTo(a);
        if (e < n) {
          const t = n - e;
          let s = a.clone().sub(r).normalize();
          (a.addScaledVector(s, t), (i = !0));
        }
        return !1;
      },
    ),
    i && s.copy(a).sub(e.center),
    { hit: i, delta: s }
  );
}
function bs(t, e) {
  const i = new ie();
  e.calAABB(i);
  const s = e.radius,
    n = new Gi(e.start.clone(), e.end.clone()),
    r = new pt(),
    a = new pt();
  return ys(
    t,
    (t) => t.intersectsBox(i),
    (t) => t.closestPointToSegment(n, r, a) < s,
  );
}
function ws(t, e) {
  const i = new ie();
  e.calAABB(i);
  const s = e.radius,
    n = new Gi(e.start.clone(), e.end.clone());
  let r = !1,
    a = new pt(0, 0, 0);
  const o = new pt(),
    h = new pt();
  return (
    ys(
      t,
      (t) => t.intersectsBox(i),
      (t) => {
        const e = t.closestPointToSegment(n, o, h);
        if (e < s) {
          const t = s - e;
          let i = h.sub(o).normalize();
          (n.start.addScaledVector(i, t), n.end.addScaledVector(i, t), (r = !0));
        }
        return !1;
      },
    ),
    r && a.copy(n.start).sub(e.start),
    { hit: r, delta: a }
  );
}
class Ss {
  #oa;
  #ha;
  #la;
  #ca;
  #ua = 0;
  #da = 0;
  constructor(t = 2e3) {
    ((this.#oa = new Uint32Array(t)),
      (this.#ha = new Uint32Array(t)),
      (this.#la = new Uint32Array(t)),
      (this.#ca = new Uint32Array(t)));
  }
  resize(t) {
    if (t > this.#la.length) {
      const e = t + 500;
      ((this.#oa = this.#fa(this.#oa, e)),
        (this.#ha = this.#fa(this.#ha, e)),
        (this.#la = new Uint32Array(e)),
        (this.#ca = new Uint32Array(e)));
    }
    this.#da = t;
  }
  setValue(t, e, i) {
    ((this.#la[t] = e), (this.#ca[t] = i));
  }
  isChanged() {
    if (this.#ua != this.#da) return !0;
    for (let t = this.#da - 1; t >= 0; --t) if (this.#oa[t] != this.#la[t] || this.#ha[t] != this.#ca[t]) return !0;
    return !1;
  }
  backup() {
    (([this.#oa, this.#la] = [this.#la, this.#oa]),
      ([this.#ha, this.#ca] = [this.#ca, this.#ha]),
      (this.#ua = this.#da));
  }
  #fa(t, e) {
    const i = new Uint32Array(e);
    return (i.set(t, 0), i);
  }
}
let Ms = class t extends Wt {
  static GlobalID = 0;
  #f = !1;
  #S;
  #ln;
  #Ye;
  #pa;
  #Re;
  #K;
  #G;
  #vt;
  #Ze;
  #ma;
  #Xe;
  #Pt;
  #ga;
  #ya = [];
  #xa = [];
  #va = new Fi();
  #di = !1;
  #ba = !1;
  #wa = !0;
  #Xr;
  #Sa = !0;
  #Ma;
  #Ca = 0;
  #Ea = new Ss();
  #Da = 0;
  constructor(e) {
    (super(),
      (this.#S = t.GlobalID++),
      (this.#Pt = e),
      (this.#Pt.renderID = this.#S),
      (this.#Re = this.#Pt.lccParam),
      (this.#Ye = this.#Pt.cameraMgr),
      (this.#K = this.#Pt.cpuCache),
      (this.#G = this.#Pt.gpuCache),
      (this.#vt = this.#Pt.collCache),
      (this.#Ze = this.#Pt.dataLoader),
      (this.#Xe = this.#Pt.config),
      (this.#ln = this.#Pt.lccParam.renderLib),
      (this.#Xr = new vi(this.#Pt.config.GpuMaxUploadCount, this.#Pt.config.GpuMaxUploadBytes)),
      (this.#pa = new ai(this.#Pt, this.#Ye, this.#Ze)),
      (this.#ma = new Ai(this.#Pt, this.#Xr)),
      (this.#ga = new this.#ln.Group()),
      (this.#Pt.resourcesScene = new yi(this.#Re)));
  }
  get id() {
    return this.#S;
  }
  get distanceToCam() {
    if (!this.#di) return 1e6;
    return this.#pa.center.distanceToSquared(this.#Pt.dynamicState.cmrPosLocal);
  }
  get root() {
    return this.#ga;
  }
  get maxLoadSplatCount() {
    return this.#Xe.maxLoadSplatCount;
  }
  set maxLoadSplatCount(t) {
    (console.log('set max splats: ' + t), (this.#Xe.maxLoadSplatCount = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  dispose() {
    ((this.#f = !0), this.#ga.clear(), this.#ma.dispose());
    const t = [],
      e = [];
    (this.#pa.getAllNodeID(t),
      this.#pa.getAllCollID(e),
      this.#pa.dispose(),
      this.#K.clear(this.id, t),
      this.#G.clear(this.id, t),
      this.#vt?.clear(this.id, e),
      this.#Pt.resourcesScene.dispose(),
      (this.#Pt.resourcesScene = null));
  }
  #Aa() {
    this.#Sa = !0;
  }
  checkFirstDataReady() {
    return this.#pa.isFirstDataReady;
  }
  clearRenderNextFrame() {
    this.#Sa = !1;
  }
  checkRenderNextFrame() {
    return this.#Sa;
  }
  getInstancedMesh() {
    return this.#ga;
  }
  getEnvInstancedMesh() {
    return this.#ga;
  }
  getMeta() {
    if (this.#di) return this.#pa.metaJson;
    console.error('meta is not ready');
  }
  togglePointsDisplayMode() {
    ((this.#Xe.pointsOnly = !this.#Xe.pointsOnly), this.#Aa());
  }
  useEnvironment(t) {
    ((this.#Xe.useEnv = !!t), this.#pa.setConfigDirty(), this.#Aa());
  }
  useShcoef(t, e) {
    (console.log('sdk useShcoef: ' + t),
      (this.#Xe.useSH = !!t),
      this.#pa.setConfigDirty(),
      this.#Aa(),
      this.#di
        ? t && this.#wa
          ? ((this.#wa = !1),
            this.#pa.loadSH(
              () => {},
              (t) => {
                e && e(t);
              },
              () => {
                console.error('load sh failed...');
              },
            ))
          : e && e(1)
        : console.error('meta is not ready'));
  }
  hasShcoef() {
    return !!this.#di && this.#pa.hasSH;
  }
  hasEnvironment() {
    return !!this.#di && this.#pa.hasEnvironment;
  }
  hasCollision() {
    return !!this.#di && this.#pa.hasColl;
  }
  getBounds() {
    if (!this.#di) return null;
    let t = this.#pa.bbox;
    if (!t) return null;
    let e = t.min,
      i = t.max;
    return { min: { x: e.x, y: e.y, z: e.z }, max: { x: i.x, y: i.y, z: i.z } };
  }
  setSemantic(t) {
    ((this.#Xe.useSemantic = !!t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setSenmanticColor(t) {
    if (!Array.isArray(t) || 0 == t.length) return void console.error('set sem colors failed: error data structure');
    let e = !1;
    for (let i = 0; i < t.length; ++i) {
      const s = t[i];
      if (!Array.isArray(s) || 3 != s.length) {
        e = !0;
        break;
      }
    }
    e
      ? console.error('set sem colors failed: error data structure')
      : (this.#Pt.resourcesScene.updateSemanticColor(t), this.#Aa());
  }
  resetSemanticColor() {
    (this.#Pt.resourcesScene.resetSemanticColor(), this.#Aa());
  }
  setDepthSorting(t) {
    ((this.#Xe.enableDepthSorting = !!t), this.#Aa());
  }
  setVisible(t) {
    ((this.#Xe.visible = !!t), this.#Aa());
  }
  setPointsColor(t) {
    'default' === t || 'rainbow' === t
      ? ((this.#Xe.pointsColor = 'default' === t ? S : M), this.#Aa())
      : console.error('The input style is not supported.');
  }
  setAlpha(t) {
    Ct(t) ? console.error('set failed !!!') : ((t = ut.clamp(t, 0, 1)), (this.#Xe.alpha = t), this.#Aa());
  }
  setClipBox(t) {
    if (wt(t)) return (this.#va.reset(), (this.#Xe.useClipBox = !1), void this.#Aa());
    if (!(t && t.scale && t.rotation && t.position)) return void console.error('set failed !!!');
    const e = t.clipSide || 1,
      i = Ft('scale', t),
      s = Ft('rotation', t),
      n = Ft('position', t);
    i && s && n
      ? (this.#va.update(n, s, i, e), (this.#Xe.useClipBox = !0), this.#Aa())
      : console.error('set failed !!!');
  }
  setClipPlane(t, e) {
    if (wt(t)) return ((this.#Xe.useClipPlane = !1), void this.#Aa());
    Array.isArray(t) && 'number' == typeof e
      ? (this.#Pt.dynamicState.clipPlane.set(t[0], t[1], t[2], e), (this.#Xe.useClipPlane = !0), this.#Aa())
      : console.error('setClipPlane failed: param error');
  }
  setStartLod(t) {
    Ct(t) || t < 0
      ? console.error('set failed !!!')
      : ((this.#Xe.MinLodUsed = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  getLodInfos() {
    return this.#pa.meta?.splats;
  }
  setEndLod(t) {
    isNaN(t) || t < 0
      ? console.error('set failed !!!')
      : ((this.#Xe.MaxLodUsed = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setMaxDistance(t) {
    Ct(t) || t < 0
      ? console.error('set failed !!!')
      : ((this.#Xe.MaxDistaneLimit = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setMaxSplats(t) {
    Ct(t) || t < 0
      ? console.error('set failed !!!')
      : (console.log('set max splats: ' + t), (this.#Xe.maxLoadSplatCount = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setMaxNodeSplats(t) {
    Ct(t) || t < 0
      ? console.error('set failed !!!')
      : (console.log('set max node splats: ' + t),
        (this.#Xe.LodLevelUpSpatsInNode = t),
        this.#pa.setConfigDirty(),
        this.#Aa());
  }
  getCurrentConfig() {
    return this.#Xe.getUserConfig();
  }
  updateCurrentConfig(t) {
    (this.#Xe.setUserConfig(t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setLodAutoLevelUp(t) {
    ((this.#Xe.useLodAutoOptimization = !!t), this.#pa.setConfigDirty(), this.#Aa());
  }
  _paramToRay(t) {
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return new gi(s, n, t.maxDistance);
  }
  _paramToRayFromOrigin(t) {
    const e = new pt(t.origin.x, t.origin.y, t.origin.z),
      i = new pt(t.direction.x, t.direction.y, t.direction.z).normalize();
    return new gi(e, i, t.maxDistance);
  }
  #Fa(t) {
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return new gi(s, n, t.maxDistance)
      .applyMatrix4(new Ot().copy(this.#ga.matrixWorld).invert())
      .intersectBox(this.#pa.bbox);
  }
  #Pa(t) {
    const e = new pt(t.origin.x, t.origin.y, t.origin.z),
      i = new pt(t.direction.x, t.direction.y, t.direction.z).normalize();
    return new gi(e, i, t.maxDistance)
      .applyMatrix4(new Ot().copy(this.#ga.matrixWorld).invert())
      .intersectBox(this.#pa.bbox);
  }
  raycast(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.evt || Ct(t.evt.x) || Ct(t.evt.y) || Ct(t.maxDistance) || Ct(t.radius)) return null;
    if (t.maxDistance < 0 || t.radius < 0) return null;
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return this.raycastFromOrigin({
      origin: { x: s.x, y: s.y, z: s.z },
      direction: { x: n.x, y: n.y, z: n.z },
      maxDistance: t.maxDistance,
      radius: t.radius,
    });
  }
  raycastFromOrigin(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.origin || !t.direction || Ct(t.maxDistance) || Ct(t.radius)) return null;
    if (Ct(t.origin.x) || Ct(t.origin.y) || Ct(t.origin.z)) return null;
    if (Ct(t.direction.x) || Ct(t.direction.y) || Ct(t.direction.z)) return null;
    if (t.maxDistance < 0 || t.radius < 0) return null;
    const e = new pt(t.origin.x, t.origin.y, t.origin.z),
      i = new pt(t.direction.x, t.direction.y, t.direction.z).normalize(),
      s = new gi(e, i, t.maxDistance).applyMatrix4(new Ot().copy(this.#ga.matrixWorld).invert()),
      n = t.radius;
    let r = [];
    if (
      (this.#ya.forEach((t) => {
        if (t.isEnvMesh) return;
        const e = t.getBBox(),
          i = s.intersectBox(e);
        if (!i) return;
        const n = this.#Ta(t.node.parent);
        r.push({ mesh: n || t, distance: i.distance });
      }),
      0 == r.length)
    )
      return null;
    r.sort((t, e) => t.distance - e.distance);
    let a = this.#Xe.useClipBox ? (t) => this.#va.testPoint(t) : null;
    for (let t = 0; t < r.length; ++t) {
      let e = r[t].mesh.intersectWithRay(s, n, a);
      if (e) {
        const t = e.point;
        return (t.applyMatrix4(this.#ga.matrixWorld), { x: t.x, y: t.y, z: t.z });
      }
    }
    return null;
  }
  #Ta(t) {
    if (!t) return null;
    const e = t.nodes.length;
    for (let i = 0; i < e; i++) {
      const e = t.nodes[i];
      if (e) {
        const i = this.#G.queryMesh(t.renderID, e?.id, !1);
        if (i) return i;
      }
    }
    return null;
  }
  intersectsRay(t) {
    let e = this.intersectsRayExt(t);
    return e ? e.point : null;
  }
  intersectsRayFromOrigin(t) {
    let e = this.intersectsRayFromOriginExt(t);
    return e ? e.point : null;
  }
  intersectsRayExt(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.evt || Ct(t.evt.x) || Ct(t.evt.y) || Ct(t.maxDistance)) return null;
    if (t.maxDistance < 0) return null;
    if (!this.hasCollision()) return null;
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return this.intersectsRayFromOriginExt({
      origin: { x: s.x, y: s.y, z: s.z },
      direction: { x: n.x, y: n.y, z: n.z },
      maxDistance: t.maxDistance,
    });
  }
  intersectsRayFromOriginExt(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.origin || !t.direction || Ct(t.maxDistance)) return null;
    if (Ct(t.origin.x) || Ct(t.origin.y) || Ct(t.origin.z)) return null;
    if (Ct(t.direction.x) || Ct(t.direction.y) || Ct(t.direction.z)) return null;
    if (t.maxDistance < 0) return null;
    if (!this.hasCollision()) return null;
    const e = new pt(t.origin.x, t.origin.y, t.origin.z),
      i = new pt(t.direction.x, t.direction.y, t.direction.z).normalize(),
      s = new gi(e, i, t.maxDistance).applyMatrix4(new Ot().copy(this.#ga.matrixWorld).invert());
    let n,
      r = s.origin;
    n =
      s.length === 1 / 0
        ? s.origin.clone().addScaledVector(s.direction, 1e5)
        : s.origin.clone().addScaledVector(s.direction, s.length);
    const a = new ie().setFromPoints([r, n]),
      o = this.#pa.getUnitsFromBBox(a.min, a.max);
    let h = [];
    for (let t = 0; t < o.length; ++t) {
      const e = o[t];
      if (!e || !e.coll) continue;
      const i = e.coll.queryCacheData();
      if (!i) continue;
      const n = s.intersectBox(e.getBBox());
      n && h.push({ ccd: i, distance: n.distance });
    }
    h.sort((t, e) => t.distance - e.distance);
    for (let t = 0; t < h.length; ++t) {
      const e = gs(h[t].ccd, s);
      if (!e) continue;
      const i = e.point;
      i.applyMatrix4(this.#ga.matrixWorld);
      const n = e.normal;
      return (
        n.transformDirection(this.#ga.matrixWorld),
        { point: { x: i.x, y: i.y, z: i.z }, normal: { x: n.x, y: n.y, z: n.z } }
      );
    }
    return null;
  }
  intersectsSphere(t) {
    let e = { hit: !1, delta: { x: 0, y: 0, z: 0 } };
    if (this.#f) return (console.error('The renderer had been dispose !!!'), e);
    if (!t || !t.center || Ct(t.radius)) return e;
    if (Ct(t.center.x) || Ct(t.center.y) || Ct(t.center.z)) return e;
    if (!this.hasCollision()) return e;
    const i = new pt(t.center.x, t.center.y, t.center.z).applyMatrix4(new Ot().copy(this.#ga.matrixWorld).invert()),
      s = new Qe(i, t.radius),
      n = new ie();
    s.getBoundingBox(n);
    const r = this.#pa.getUnitsFromBBox(n.min, n.max);
    let a = [];
    for (let t = 0; t < r.length; ++t) {
      const e = r[t];
      if (!e || !e.coll) continue;
      const i = e.coll.queryCacheData();
      i && a.push(i);
    }
    if (t.noDelta)
      for (let t = 0; t < a.length; ++t) {
        if (xs(a[t], s)) {
          e.hit = !0;
          break;
        }
      }
    else {
      let t = !1,
        i = new pt(0, 0, 0);
      for (let e = 0; e < a.length; ++e) {
        const n = a[e],
          { hit: r, delta: o } = vs(n, s);
        r && ((t = !0), i.add(o), s.translate(o));
      }
      (t && i.transformDirectionWithoutNormlize(this.#ga.matrixWorld),
        (e.hit = t),
        (e.delta = { x: i.x, y: i.y, z: i.z }));
    }
    return e;
  }
  intersectsCapsule(t) {
    let e = { hit: !1, delta: { x: 0, y: 0, z: 0 } };
    if (this.#f) return (console.error('The renderer had been dispose !!!'), e);
    if (!t || !t.start || !t.end || Ct(t.radius)) return e;
    if (Ct(t.start.x) || Ct(t.start.y) || Ct(t.start.z)) return e;
    if (Ct(t.end.x) || Ct(t.end.y) || Ct(t.end.z)) return e;
    if (!this.hasCollision()) return e;
    const i = new Ot().copy(this.#ga.matrixWorld).invert(),
      s = new pt(t.start.x, t.start.y, t.start.z).applyMatrix4(i),
      n = new pt(t.end.x, t.end.y, t.end.z).applyMatrix4(i),
      r = new Pi(s, n, t.radius),
      a = new ie();
    r.calAABB(a);
    const o = this.#pa.getUnitsFromBBox(a.min, a.max);
    let h = [];
    for (let t = 0; t < o.length; ++t) {
      const e = o[t];
      if (!e || !e.coll) continue;
      const i = e.coll.queryCacheData();
      i && h.push(i);
    }
    if (t.noDelta)
      for (let t = 0; t < h.length; ++t) {
        if (bs(h[t], r)) {
          e.hit = !0;
          break;
        }
      }
    else {
      let t = !1,
        i = new pt(0, 0, 0);
      for (let e = 0; e < h.length; ++e) {
        const s = h[e],
          { hit: n, delta: a } = ws(s, r);
        n && ((t = !0), i.add(a), r.translate(a));
      }
      (t && i.transformDirectionWithoutNormlize(this.#ga.matrixWorld),
        (e.hit = t),
        (e.delta = { x: i.x, y: i.y, z: i.z }));
    }
    return e;
  }
  #Ia(t) {
    const e = this.#Pt.dynamicState,
      i = this.#Ye.viewWidth,
      s = this.#Ye.viewHeight,
      n = this.#Ye.fov,
      r = this.#Ye.projectionMatrix,
      a = this.#Ye.cam2WorldMatrix,
      o = new Ot().copy(this.#ga.matrixWorld).invert(),
      h = new Ot().multiplyMatrices(o, a),
      l = this.#Ye.position,
      c = this.#Ye.position.clone().applyMatrix4(o),
      u = new pt(0, 0, -1).transformDirection(a),
      d = u.clone().transformDirection(o),
      f = this.#Ye.projectionMatrix.clone().invert(),
      p = new Ot().multiplyMatrices(h, f);
    let m = new si();
    (m.setFromProjectionMatrix(r),
      m.planes.forEach((t) => {
        t.applyMatrix4(h);
      }),
      (e.frustum = m),
      (e.focal = s / 2 / Math.tan((n / 2 / 180) * Math.PI)),
      (e.viewport.x = i),
      (e.viewport.y = s),
      e.cmrPos.copy(l),
      e.cmrForward.copy(u),
      e.cmrForwardLocal.copy(d),
      e.cmrPosLocal.copy(c),
      e.cmrProjMatrix.copy(r),
      e.cmr2LocalMatrix.copy(h),
      e.cmrPosModelLocal.copy(c),
      e.cmr2ModelLocalMatrix.copy(h),
      e.ndc2local.copy(p),
      (e.alpha = this.#Xe.alpha),
      (e.visible = this.#Xe.visible),
      (e.useEnv = this.#Xe.useEnv),
      (e.useSH = this.#Xe.useSH),
      (e.pointsOnly = this.#Xe.pointsOnly),
      (e.useCustomColor = !(this.#Xe.pointsColor !== M)),
      (e.useEdgeCrop = this.#Xe.useEdgeCrop),
      (e.clipBoxSide = this.#va.clipSide),
      e.clipBoxMatrixInv.copy(this.#va.matrixInverse),
      (e.useClipPlane = this.#Xe.useClipPlane),
      (e.useClipBox = this.#Xe.useClipBox),
      (e.useSemantic = this.#Xe.useSemantic),
      (e.tick = t));
  }
  #_a(t) {
    this.#Pt.dynamicState.loadingReady = this.#ba;
  }
  load(t, e, i, s, n) {
    const r = { dataPath: t };
    ((r.metaSuccessFunc = (t) => {
      this.#di = !0;
    }),
      (r.successFunc = () => {
        (console.log('loading ready ...'), (this.#ba = !0));
        const t = this.getInstancedMesh();
        e && e(t);
      }),
      (r.progressFunc = (t) => {
        i && i(t);
      }),
      (r.failureFunc = () => {
        s && s();
      }),
      (r.checkFuncSplats = (t) => {
        if (!t) return !0;
        if (t.isColl) return !!t.isCacheData();
        if (t.isNode) {
          let e = this.#G.queryMesh(t.renderID, t.id);
          return !(!e || !e.isFirstSorted);
        }
        return (console.error('unknow chunk...(render)'), !0);
      }),
      'function' == typeof n && (r.preProcessFunc = n),
      this.#pa.load(r));
  }
  update(t) {
    if (
      ((this.#ya = []),
      (this.#xa = []),
      this.#ga.clear(),
      this.#ga.updateMatrixWorld(!0),
      this.#Ia(t),
      this.#Xr.reset(),
      this.#ma.clearCacheQueue(),
      this.#ma.clearCacheSHQueue(),
      this.#ma.clearSortQueue(),
      this.#ma.clearCacheCollQueue(),
      this.#ma.clearCacheSemQueue(),
      this.#pa.update(t),
      !this.#di)
    )
      return;
    if ((this.#Ra(), this.#Xe.useLccCompress && !this.#Pt.resourcesScene.lutScaleTex)) return;
    this.#_a(t);
    const e = this.#pa.getRenderNodes();
    (this.#Na(e),
      this.#Ba(),
      this.#ka(),
      this.#za(),
      this.#Ea.resize(this.#ya.length),
      this.#ya.forEach((t, e, i) => {
        (t.updateUniformsDynamic(),
          this.#Xe.useSH && !t.hasUploadSH && this.#ma.pushCacheSHQueue(t),
          this.#Xe.useSemantic && this.#Xe.useLccCompress && !t.hasUploadSem && this.#ma.pushCacheSemQueue(t),
          (t.object.renderOrder = -e - 1),
          this.#ga.add(t.object),
          this.#Ea.setValue(e, t.id, t.flushID));
      }),
      this.#xa.forEach((t, e, i) => {
        this.#ga.add(t);
      }),
      (this.#ga.visible = this.#Pt.dynamicState.visible));
    for (let t = this.#ya.length - 1; t >= 0; --t) {
      const e = this.#ya[t];
      if (!e.isEnvMesh) {
        const t = e.node;
        this.#G.touchMesh(t.renderID, t.id);
      }
    }
    (this.#ma.update(t),
      this.#Ye.isCameraChanged && (this.#Da = 10),
      this.#Sa ||
        ((this.#Da > 0 ||
          this.#pa.isLoadingDirty ||
          this.#Xr.isChanged() ||
          this.#Ye.isCameraChanged ||
          this.#Ea.isChanged()) &&
          this.#Aa()),
      this.#Ea.backup(),
      (this.#Da = Math.max(0, this.#Da - 1)),
      this.#La());
  }
  #Ra() {
    if (!this.#Xe.useLccCompress) return;
    const t = this.#Pt.resourcesScene,
      e = this.#K.queryLut(this.#S, o),
      i = this.#K.queryLut(this.#S, h);
    (!t.lutScaleTex && e && t.setLutScale(e.data), !t.lutShTex && i && t.setLutSH(i.data));
  }
  #Na(t) {
    if (0 == t.length) return;
    const i = this.#pa.minLimitLod,
      s = this.#Xe.maxLoadSplatCount >= this.#Xe.TemporaryUnlimitReqiredSplatCount;
    for (let n = 0; n < t.length; ++n) {
      const r = t[n];
      if (!r || r.points < this.#Xe.MinValidSplatsInNode) continue;
      const a = r.parent,
        o = s ? 0 : this.#Xe.useLodAutoOptimization ? Math.min(r.level, i) : r.level,
        h = a.nodes.length;
      let l,
        c = this.#G.queryMesh(r.renderID, r.id);
      if (c) {
        if ((c.checkNeedSort() && this.#ma.pushSortQueue(c), c.isCanShow())) {
          this.#ya.push(c);
          continue;
        }
      } else r.isCache(e) && this.#ma.pushCacheQueue(r);
      let u,
        d,
        f = 0;
      for (let t = o; t < h; ++t) {
        const e = a.nodes[t];
        if (!e || e.points < this.#Xe.MinValidSplatsInNode) continue;
        let i = this.#G.queryMesh(e.renderID, e.id);
        if (!i || !i.isFirstSorted) continue;
        const s = i.sortTickLast;
        s > f && ((f = s), (l = i));
      }
      if (l)
        (this.#ya.push(l),
          l != c && l.checkNeedSort() && !this.#Xe.useLodAutoOptimization && this.#ma.pushSortQueue(l));
      else {
        for (let t = o; t < h; ++t) {
          const e = a.nodes[t];
          if (!e || e.points < this.#Xe.MinValidSplatsInNode) continue;
          let i = this.#G.queryMesh(e.renderID, e.id);
          if (i) {
            u = i;
            break;
          }
        }
        if (u && u !== c) this.#ma.pushSortQueue(u);
        else {
          for (let t = o; t < h; ++t) {
            const i = a.nodes[t];
            if (i && !(i.points < this.#Xe.MinValidSplatsInNode) && i.isCache(e)) {
              d = i;
              break;
            }
          }
          d && d !== r && this.#ma.pushCacheQueue(d);
        }
      }
    }
  }
  #Ba() {
    const t = this.#ma.getEnvmesh();
    if (this.#Pt.dynamicState.useEnv)
      if (t)
        (this.#ba && 1 != this.#Pt.dynamicState.loadingSwitch && this.#ya.push(t),
          t.checkNeedSort() && this.#ma.pushSortQueue(t));
      else {
        const t = this.#ma.getEnvmesh(!1);
        t && this.#ma.pushSortQueue(t);
      }
  }
  #ka() {
    if (this.#ba) return;
    const t = this.#pa.getLoadingNodes();
    for (let i = 0; i < t.length; ++i) {
      const s = t[i];
      if (!s) continue;
      let n = this.#G.queryMesh(s.renderID, s.id);
      !n && s.isCache(e) ? this.#ma.pushCacheQueue(s) : n && !n.isFirstSorted && this.#ma.pushSortQueue(n);
    }
  }
  #za() {
    const t = this.#pa.getRenderColls();
    for (let e = 0; e < t.length; ++e) {
      const i = t[e],
        s = i.queryCacheMesh();
      s ? this.#xa.push(s) : i.isCacheData() && this.#ma.pushCacheCollQueue(i);
    }
  }
  #La() {
    let t = 0,
      e = 0,
      i = 1e9;
    this.#ya.forEach((s) => {
      ((t += s.splatCount), (e = Math.max(e, s.splatCount)), (i = Math.min(i, s.splatCount)));
    });
    const s = this.#Pt.performance;
    ((s.totalPoints = t),
      (s.maxPoints = e),
      (s.minPoints = i),
      (s.meshNum = this.#ya.length),
      (s.bwLimitCount = this.#Xr.limitCount),
      (s.bwLimitSize = this.#Xr.limitSize));
    const n = this.#Pt.dynamicState.tick;
    if ((void 0 === this.#Ma && (this.#Ma = n), n - this.#Ma > 2e3 && 325879 === this.#Ca)) {
      this.#Ma = n;
      let t = {};
      (console.log('perf: ', s),
        console.log(
          '  ',
          this.#ya.map((t) => t?.node?.level),
        ),
        console.log(
          '  ',
          this.#ya.map((t) => t?.node?.points),
        ),
        this.#ya.forEach((e, i) => {
          t[e?.node?.level] = (t[e?.node?.level] || 0) + e.splatCount;
        }),
        console.log('  ', t),
        325879 === this.#Ca && console.log('conf: ', this.#Pt.config),
        (this.#Ca = 0));
    }
  }
  _tD3qmTg9vF2jLmA9(t) {
    Ct(t) || (this.#Ca = t);
  }
};
function Cs(t) {
  const e = 0,
    i = 2,
    s = (t) => {
      const e = t.byteLength / 32,
        i = new Uint32Array(t),
        s = new Uint32Array(3 * e);
      for (let t = 0; t < e; ++t)
        ((s[3 * t + 0] = i[8 * t + 0]), (s[3 * t + 1] = i[8 * t + 1]), (s[3 * t + 2] = i[8 * t + 2]));
      return { pos: s };
    },
    n = t.data.index,
    r = t.data.type,
    a = t.data.buffer;
  if (r == e) {
    const e = t.data.useLccCompress,
      i = t.data.quanBBox;
    if (e) {
      const { data: t, pos: e } = ((t, e) => {
        const { min: i, max: s } = e,
          n = t.byteLength / 16,
          r = new Uint32Array(t),
          a = new Uint32Array(6 * n),
          o = new Float32Array(a.buffer),
          h = new Float32Array(3 * n);
        let l, c, u, d, f, p, m, g, y, x;
        for (let t = 0; t < n; ++t)
          ((l = r[4 * t + 0]),
            (c = r[4 * t + 1]),
            (u = r[4 * t + 2]),
            (d = r[4 * t + 3]),
            (f = (32767 & l) / 32767),
            (p = ((l >> 15) & 32767) / 32767),
            (m = (((l >> 30) & 3) + ((16383 & c) << 2)) / 65535),
            (f = f <= 1 ? f : 1),
            (p = p <= 1 ? p : 1),
            (m = m <= 1 ? m : 1),
            (g = i.x * (1 - f) + s.x * f),
            (y = i.y * (1 - p) + s.y * p),
            (x = i.z * (1 - m) + s.z * m),
            (h[3 * t + 0] = g),
            (h[3 * t + 1] = y),
            (h[3 * t + 2] = x),
            (o[6 * t + 0] = g),
            (o[6 * t + 1] = y),
            (o[6 * t + 2] = x),
            (a[6 * t + 3] = c),
            (a[6 * t + 4] = u),
            (a[6 * t + 5] = d));
        return { data: a, pos: h };
      })(a, i);
      postMessage({ index: n, dataBuffer: t.buffer, posBuffer: e.buffer }, [t.buffer, e.buffer]);
    } else {
      const { pos: t } = s(a);
      postMessage({ index: n, dataBuffer: a, posBuffer: t.buffer }, [a, t.buffer]);
    }
  } else if (r == i) {
    if (t.data.hasSH) {
      const {
        pos: t,
        sh: e,
        data: i,
      } = ((t) => {
        const e = 24,
          i = t.byteLength / 96,
          s = new Uint32Array(t),
          n = new Uint32Array(3 * i),
          r = new Uint32Array(8 * i),
          a = new Uint32Array(16 * i);
        for (let t = 0; t < i; ++t) {
          ((n[3 * t + 0] = s[t * e + 0]), (n[3 * t + 1] = s[t * e + 1]), (n[3 * t + 2] = s[t * e + 2]));
          for (let i = 0; i < 8; ++i) r[8 * t + i] = s[t * e + i];
          for (let i = 0; i < 16; ++i) a[16 * t + i] = s[t * e + 8 + i];
        }
        return { pos: n, sh: a, data: r };
      })(a);
      postMessage({ index: n, dataBuffer: i.buffer, posBuffer: t.buffer, shBuffer: e.buffer }, [
        i.buffer,
        t.buffer,
        e.buffer,
      ]);
    } else {
      const { pos: t } = s(a);
      postMessage({ index: n, dataBuffer: a, posBuffer: t.buffer }, [a, t.buffer]);
    }
  } else console.error('unkonw type......');
}
let Es = class {
    type;
    buffer;
    size;
    meta;
    renderID;
    quanBBox;
    callback;
    isDeprecated = !1;
  },
  Ds = class extends Ne {
    #f = !1;
    #ht = 0;
    #lt = [];
    #ct = [];
    #ut = [];
    #te = 0;
    #ft = !0;
    constructor(t = 4) {
      super();
      for (let e = 0; e < t; ++e) {
        const t = we(Cs);
        t ? (this.#lt.push(t), this.#ht++) : console.error('create worker failed !!!');
      }
      this.#lt.forEach((t) => {
        t.onmessage = (t) => {
          if (this.#f) return;
          const i = t.data.index,
            n = this.#ut[i];
          if (!n.isDeprecated)
            if (n.type === e) {
              const e = new Uint32Array(t.data.dataBuffer),
                i = new Float32Array(t.data.posBuffer);
              n.callback(e, i, void 0);
            } else if (n.type === s) {
              const e = new Uint32Array(t.data.dataBuffer),
                i = new Float32Array(t.data.posBuffer),
                s = n.meta.hasSH ? new Uint32Array(t.data.shBuffer) : void 0;
              n.callback(e, i, s);
            }
          ((this.#ut[i] = void 0), this.#te--, this.#te < this.#ht && (this.#ft = !0));
        };
      });
    }
    dispose() {
      ((this.#f = !0),
        this.#lt.forEach((t) => {
          t.terminate();
        }),
        (this.#ct = []),
        (this.#ut = []),
        (this.#lt = []),
        (this.#ht = 0),
        (this.#ft = !1));
    }
    #Ct() {
      if (this.#ft && 0 != this.#ct.length && 0 != this.#ht) {
        for (let t = 0; t < this.#ht && 0 !== this.#ct.length; ++t) {
          const e = t;
          if (this.#ut[e]) continue;
          const i = (this.#ut[e] = this.#ct.shift()),
            n = this.#lt[e];
          (i.type == s
            ? n.postMessage({ index: e, type: i.type, buffer: i.buffer, hasSH: i.meta.hasSH }, [
                i.buffer?.buffer || i.buffer,
              ])
            : n.postMessage(
                {
                  index: e,
                  type: i.type,
                  buffer: i.buffer,
                  quanBBox: i.quanBBox,
                  useLccCompress: i.meta.useLccCompress,
                },
                [i.buffer?.buffer || i.buffer],
              ),
            this.#te++);
        }
        this.#ft = this.#te < this.#ht;
      }
    }
    update(t) {
      this.#f || this.#Ct();
    }
    decompress(t, i, n, r, a, o, h) {
      if (this.#f) return !1;
      if (t !== e && t !== s) return (console.error('unkonw type: ' + t), !1);
      let l = new Es();
      return (
        (l.renderID = a),
        (l.type = t),
        (l.buffer = i),
        (l.size = n),
        (l.meta = r),
        (l.quanBBox = o),
        (l.callback = h),
        this.#ct.push(l),
        this.#Ct(),
        !0
      );
    }
    unload(t) {
      ((this.#ct = this.#ct.filter((e) => e.renderID !== t)),
        this.#ut.forEach((e) => {
          e?.renderID === t && (e.isDeprecated = !0);
        }));
    }
  };
var As,
  Fs,
  Ps = Object.getOwnPropertyNames,
  Ts = ((As = {
    'node_modules/jsrsasign/lib/jsrsasign.js'(t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h,
        l,
        c = { userAgent: !1 },
        u = {},
        d =
          d ||
          (function (t, e) {
            var i = {},
              s = (i.lib = {}),
              n = (s.Base = (function () {
                function t() {}
                return {
                  extend: function (e) {
                    t.prototype = this;
                    var i = new t();
                    return (
                      e && i.mixIn(e),
                      i.hasOwnProperty('init') ||
                        (i.init = function () {
                          i.$super.init.apply(this, arguments);
                        }),
                      (i.init.prototype = i),
                      (i.$super = this),
                      i
                    );
                  },
                  create: function () {
                    var t = this.extend();
                    return (t.init.apply(t, arguments), t);
                  },
                  init: function () {},
                  mixIn: function (t) {
                    for (var e in t) t.hasOwnProperty(e) && (this[e] = t[e]);
                    t.hasOwnProperty('toString') && (this.toString = t.toString);
                  },
                  clone: function () {
                    return this.init.prototype.extend(this);
                  },
                };
              })()),
              r = (s.WordArray = n.extend({
                init: function (t, e) {
                  ((t = this.words = t || []), (this.sigBytes = null != e ? e : 4 * t.length));
                },
                toString: function (t) {
                  return (t || o).stringify(this);
                },
                concat: function (t) {
                  var e = this.words,
                    i = t.words,
                    s = this.sigBytes,
                    n = t.sigBytes;
                  if ((this.clamp(), s % 4))
                    for (var r = 0; r < n; r++) {
                      var a = (i[r >>> 2] >>> (24 - (r % 4) * 8)) & 255;
                      e[(s + r) >>> 2] |= a << (24 - ((s + r) % 4) * 8);
                    }
                  else for (r = 0; r < n; r += 4) e[(s + r) >>> 2] = i[r >>> 2];
                  return ((this.sigBytes += n), this);
                },
                clamp: function () {
                  var e = this.words,
                    i = this.sigBytes;
                  ((e[i >>> 2] &= 4294967295 << (32 - (i % 4) * 8)), (e.length = t.ceil(i / 4)));
                },
                clone: function () {
                  var t = n.clone.call(this);
                  return ((t.words = this.words.slice(0)), t);
                },
                random: function (e) {
                  for (var i = [], s = 0; s < e; s += 4) i.push((4294967296 * t.random()) | 0);
                  return new r.init(i, e);
                },
              })),
              a = (i.enc = {}),
              o = (a.Hex = {
                stringify: function (t) {
                  for (var e = t.words, i = t.sigBytes, s = [], n = 0; n < i; n++) {
                    var r = (e[n >>> 2] >>> (24 - (n % 4) * 8)) & 255;
                    (s.push((r >>> 4).toString(16)), s.push((15 & r).toString(16)));
                  }
                  return s.join('');
                },
                parse: function (t) {
                  for (var e = t.length, i = [], s = 0; s < e; s += 2)
                    i[s >>> 3] |= parseInt(t.substr(s, 2), 16) << (24 - (s % 8) * 4);
                  return new r.init(i, e / 2);
                },
              }),
              h = (a.Latin1 = {
                stringify: function (t) {
                  for (var e = t.words, i = t.sigBytes, s = [], n = 0; n < i; n++) {
                    var r = (e[n >>> 2] >>> (24 - (n % 4) * 8)) & 255;
                    s.push(String.fromCharCode(r));
                  }
                  return s.join('');
                },
                parse: function (t) {
                  for (var e = t.length, i = [], s = 0; s < e; s++)
                    i[s >>> 2] |= (255 & t.charCodeAt(s)) << (24 - (s % 4) * 8);
                  return new r.init(i, e);
                },
              }),
              l = (a.Utf8 = {
                stringify: function (t) {
                  try {
                    return decodeURIComponent(escape(h.stringify(t)));
                  } catch (t) {
                    throw new Error('Malformed UTF-8 data');
                  }
                },
                parse: function (t) {
                  return h.parse(unescape(encodeURIComponent(t)));
                },
              }),
              c = (s.BufferedBlockAlgorithm = n.extend({
                reset: function () {
                  ((this._data = new r.init()), (this._nDataBytes = 0));
                },
                _append: function (t) {
                  ('string' == typeof t && (t = l.parse(t)), this._data.concat(t), (this._nDataBytes += t.sigBytes));
                },
                _process: function (e) {
                  var i = this._data,
                    s = i.words,
                    n = i.sigBytes,
                    a = this.blockSize,
                    o = n / (4 * a),
                    h = (o = e ? t.ceil(o) : t.max((0 | o) - this._minBufferSize, 0)) * a,
                    l = t.min(4 * h, n);
                  if (h) {
                    for (var c = 0; c < h; c += a) this._doProcessBlock(s, c);
                    var u = s.splice(0, h);
                    i.sigBytes -= l;
                  }
                  return new r.init(u, l);
                },
                clone: function () {
                  var t = n.clone.call(this);
                  return ((t._data = this._data.clone()), t);
                },
                _minBufferSize: 0,
              }));
            s.Hasher = c.extend({
              cfg: n.extend(),
              init: function (t) {
                ((this.cfg = this.cfg.extend(t)), this.reset());
              },
              reset: function () {
                (c.reset.call(this), this._doReset());
              },
              update: function (t) {
                return (this._append(t), this._process(), this);
              },
              finalize: function (t) {
                return (t && this._append(t), this._doFinalize());
              },
              blockSize: 16,
              _createHelper: function (t) {
                return function (e, i) {
                  return new t.init(i).finalize(e);
                };
              },
              _createHmacHelper: function (t) {
                return function (e, i) {
                  return new u.HMAC.init(t, i).finalize(e);
                };
              },
            });
            var u = (i.algo = {});
            return i;
          })(Math);
      ((i = (e = d).lib),
        (s = i.Base),
        (n = i.WordArray),
        ((e = e.x64 = {}).Word = s.extend({
          init: function (t, e) {
            ((this.high = t), (this.low = e));
          },
        })),
        (e.WordArray = s.extend({
          init: function (t, e) {
            ((t = this.words = t || []), (this.sigBytes = null != e ? e : 8 * t.length));
          },
          toX32: function () {
            for (var t = this.words, e = t.length, i = [], s = 0; s < e; s++) {
              var r = t[s];
              (i.push(r.high), i.push(r.low));
            }
            return n.create(i, this.sigBytes);
          },
          clone: function () {
            for (var t = s.clone.call(this), e = (t.words = this.words.slice(0)), i = e.length, n = 0; n < i; n++)
              e[n] = e[n].clone();
            return t;
          },
        })),
        d.lib.Cipher ||
          (function (t) {
            var e = (p = d).lib,
              i = e.Base,
              s = e.WordArray,
              n = e.BufferedBlockAlgorithm,
              r = p.enc.Base64,
              a = p.algo.EvpKDF,
              o = (e.Cipher = n.extend({
                cfg: i.extend(),
                createEncryptor: function (t, e) {
                  return this.create(this._ENC_XFORM_MODE, t, e);
                },
                createDecryptor: function (t, e) {
                  return this.create(this._DEC_XFORM_MODE, t, e);
                },
                init: function (t, e, i) {
                  ((this.cfg = this.cfg.extend(i)), (this._xformMode = t), (this._key = e), this.reset());
                },
                reset: function () {
                  (n.reset.call(this), this._doReset());
                },
                process: function (t) {
                  return (this._append(t), this._process());
                },
                finalize: function (t) {
                  return (t && this._append(t), this._doFinalize());
                },
                keySize: 4,
                ivSize: 4,
                _ENC_XFORM_MODE: 1,
                _DEC_XFORM_MODE: 2,
                _createHelper: function (t) {
                  return {
                    encrypt: function (e, i, s) {
                      return ('string' == typeof i ? m : f).encrypt(t, e, i, s);
                    },
                    decrypt: function (e, i, s) {
                      return ('string' == typeof i ? m : f).decrypt(t, e, i, s);
                    },
                  };
                },
              }));
            e.StreamCipher = o.extend({
              _doFinalize: function () {
                return this._process(!0);
              },
              blockSize: 1,
            });
            var h = (p.mode = {}),
              l = function (t, e, i) {
                var s = this._iv;
                s ? (this._iv = void 0) : (s = this._prevBlock);
                for (var n = 0; n < i; n++) t[e + n] ^= s[n];
              },
              c = (e.BlockCipherMode = i.extend({
                createEncryptor: function (t, e) {
                  return this.Encryptor.create(t, e);
                },
                createDecryptor: function (t, e) {
                  return this.Decryptor.create(t, e);
                },
                init: function (t, e) {
                  ((this._cipher = t), (this._iv = e));
                },
              })).extend();
            ((c.Encryptor = c.extend({
              processBlock: function (t, e) {
                var i = this._cipher,
                  s = i.blockSize;
                (l.call(this, t, e, s), i.encryptBlock(t, e), (this._prevBlock = t.slice(e, e + s)));
              },
            })),
              (c.Decryptor = c.extend({
                processBlock: function (t, e) {
                  var i = this._cipher,
                    s = i.blockSize,
                    n = t.slice(e, e + s);
                  (i.decryptBlock(t, e), l.call(this, t, e, s), (this._prevBlock = n));
                },
              })),
              (h = h.CBC = c),
              (c = (p.pad = {}).Pkcs7 =
                {
                  pad: function (t, e) {
                    for (
                      var i, n = ((i = (i = 4 * e) - (t.sigBytes % i)) << 24) | (i << 16) | (i << 8) | i, r = [], a = 0;
                      a < i;
                      a += 4
                    )
                      r.push(n);
                    ((i = s.create(r, i)), t.concat(i));
                  },
                  unpad: function (t) {
                    t.sigBytes -= 255 & t.words[(t.sigBytes - 1) >>> 2];
                  },
                }),
              (e.BlockCipher = o.extend({
                cfg: o.cfg.extend({ mode: h, padding: c }),
                reset: function () {
                  o.reset.call(this);
                  var t = (e = this.cfg).iv,
                    e = e.mode;
                  if (this._xformMode == this._ENC_XFORM_MODE) var i = e.createEncryptor;
                  else ((i = e.createDecryptor), (this._minBufferSize = 1));
                  this._mode = i.call(e, this, t && t.words);
                },
                _doProcessBlock: function (t, e) {
                  this._mode.processBlock(t, e);
                },
                _doFinalize: function () {
                  var t = this.cfg.padding;
                  if (this._xformMode == this._ENC_XFORM_MODE) {
                    t.pad(this._data, this.blockSize);
                    var e = this._process(!0);
                  } else ((e = this._process(!0)), t.unpad(e));
                  return e;
                },
                blockSize: 4,
              })));
            var u = (e.CipherParams = i.extend({
                init: function (t) {
                  this.mixIn(t);
                },
                toString: function (t) {
                  return (t || this.formatter).stringify(this);
                },
              })),
              f =
                ((h = (p.format = {}).OpenSSL =
                  {
                    stringify: function (t) {
                      var e = t.ciphertext;
                      return ((t = t.salt) ? s.create([1398893684, 1701076831]).concat(t).concat(e) : e).toString(r);
                    },
                    parse: function (t) {
                      var e = (t = r.parse(t)).words;
                      if (1398893684 == e[0] && 1701076831 == e[1]) {
                        var i = s.create(e.slice(2, 4));
                        (e.splice(0, 4), (t.sigBytes -= 16));
                      }
                      return u.create({ ciphertext: t, salt: i });
                    },
                  }),
                (e.SerializableCipher = i.extend({
                  cfg: i.extend({ format: h }),
                  encrypt: function (t, e, i, s) {
                    s = this.cfg.extend(s);
                    var n = t.createEncryptor(i, s);
                    return (
                      (e = n.finalize(e)),
                      (n = n.cfg),
                      u.create({
                        ciphertext: e,
                        key: i,
                        iv: n.iv,
                        algorithm: t,
                        mode: n.mode,
                        padding: n.padding,
                        blockSize: t.blockSize,
                        formatter: s.format,
                      })
                    );
                  },
                  decrypt: function (t, e, i, s) {
                    return (
                      (s = this.cfg.extend(s)),
                      (e = this._parse(e, s.format)),
                      t.createDecryptor(i, s).finalize(e.ciphertext)
                    );
                  },
                  _parse: function (t, e) {
                    return 'string' == typeof t ? e.parse(t, this) : t;
                  },
                }))),
              p = ((p.kdf = {}).OpenSSL = {
                execute: function (t, e, i, n) {
                  return (
                    n || (n = s.random(8)),
                    (t = a.create({ keySize: e + i }).compute(t, n)),
                    (i = s.create(t.words.slice(e), 4 * i)),
                    (t.sigBytes = 4 * e),
                    u.create({ key: t, iv: i, salt: n })
                  );
                },
              }),
              m = (e.PasswordBasedCipher = f.extend({
                cfg: f.cfg.extend({ kdf: p }),
                encrypt: function (t, e, i, s) {
                  return (
                    (i = (s = this.cfg.extend(s)).kdf.execute(i, t.keySize, t.ivSize)),
                    (s.iv = i.iv),
                    (t = f.encrypt.call(this, t, e, i.key, s)).mixIn(i),
                    t
                  );
                },
                decrypt: function (t, e, i, s) {
                  return (
                    (s = this.cfg.extend(s)),
                    (e = this._parse(e, s.format)),
                    (i = s.kdf.execute(i, t.keySize, t.ivSize, e.salt)),
                    (s.iv = i.iv),
                    f.decrypt.call(this, t, e, i.key, s)
                  );
                },
              }));
          })(),
        (function () {
          for (
            var t = d,
              e = t.lib.BlockCipher,
              i = t.algo,
              s = [],
              n = [],
              r = [],
              a = [],
              o = [],
              h = [],
              l = [],
              c = [],
              u = [],
              f = [],
              p = [],
              m = 0;
            256 > m;
            m++
          )
            p[m] = 128 > m ? m << 1 : (m << 1) ^ 283;
          var g = 0,
            y = 0;
          for (m = 0; 256 > m; m++) {
            var x = ((x = y ^ (y << 1) ^ (y << 2) ^ (y << 3) ^ (y << 4)) >>> 8) ^ (255 & x) ^ 99;
            ((s[g] = x), (n[x] = g));
            var v = p[g],
              b = p[v],
              w = p[b],
              S = (257 * p[x]) ^ (16843008 * x);
            ((r[g] = (S << 24) | (S >>> 8)),
              (a[g] = (S << 16) | (S >>> 16)),
              (o[g] = (S << 8) | (S >>> 24)),
              (h[g] = S),
              (S = (16843009 * w) ^ (65537 * b) ^ (257 * v) ^ (16843008 * g)),
              (l[x] = (S << 24) | (S >>> 8)),
              (c[x] = (S << 16) | (S >>> 16)),
              (u[x] = (S << 8) | (S >>> 24)),
              (f[x] = S),
              g ? ((g = v ^ p[p[p[w ^ v]]]), (y ^= p[p[y]])) : (g = y = 1));
          }
          var M = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
          ((i = i.AES =
            e.extend({
              _doReset: function () {
                for (
                  var t = (i = this._key).words,
                    e = i.sigBytes / 4,
                    i = 4 * ((this._nRounds = e + 6) + 1),
                    n = (this._keySchedule = []),
                    r = 0;
                  r < i;
                  r++
                )
                  if (r < e) n[r] = t[r];
                  else {
                    var a = n[r - 1];
                    (r % e
                      ? 6 < e &&
                        4 == r % e &&
                        (a = (s[a >>> 24] << 24) | (s[(a >>> 16) & 255] << 16) | (s[(a >>> 8) & 255] << 8) | s[255 & a])
                      : ((a =
                          (s[(a = (a << 8) | (a >>> 24)) >>> 24] << 24) |
                          (s[(a >>> 16) & 255] << 16) |
                          (s[(a >>> 8) & 255] << 8) |
                          s[255 & a]),
                        (a ^= M[(r / e) | 0] << 24)),
                      (n[r] = n[r - e] ^ a));
                  }
                for (t = this._invKeySchedule = [], e = 0; e < i; e++)
                  ((r = i - e),
                    (a = e % 4 ? n[r] : n[r - 4]),
                    (t[e] =
                      4 > e || 4 >= r
                        ? a
                        : l[s[a >>> 24]] ^ c[s[(a >>> 16) & 255]] ^ u[s[(a >>> 8) & 255]] ^ f[s[255 & a]]));
              },
              encryptBlock: function (t, e) {
                this._doCryptBlock(t, e, this._keySchedule, r, a, o, h, s);
              },
              decryptBlock: function (t, e) {
                var i = t[e + 1];
                ((t[e + 1] = t[e + 3]),
                  (t[e + 3] = i),
                  this._doCryptBlock(t, e, this._invKeySchedule, l, c, u, f, n),
                  (i = t[e + 1]),
                  (t[e + 1] = t[e + 3]),
                  (t[e + 3] = i));
              },
              _doCryptBlock: function (t, e, i, s, n, r, a, o) {
                for (
                  var h = this._nRounds,
                    l = t[e] ^ i[0],
                    c = t[e + 1] ^ i[1],
                    u = t[e + 2] ^ i[2],
                    d = t[e + 3] ^ i[3],
                    f = 4,
                    p = 1;
                  p < h;
                  p++
                ) {
                  var m = s[l >>> 24] ^ n[(c >>> 16) & 255] ^ r[(u >>> 8) & 255] ^ a[255 & d] ^ i[f++],
                    g = s[c >>> 24] ^ n[(u >>> 16) & 255] ^ r[(d >>> 8) & 255] ^ a[255 & l] ^ i[f++],
                    y = s[u >>> 24] ^ n[(d >>> 16) & 255] ^ r[(l >>> 8) & 255] ^ a[255 & c] ^ i[f++];
                  ((d = s[d >>> 24] ^ n[(l >>> 16) & 255] ^ r[(c >>> 8) & 255] ^ a[255 & u] ^ i[f++]),
                    (l = m),
                    (c = g),
                    (u = y));
                }
                ((m =
                  ((o[l >>> 24] << 24) | (o[(c >>> 16) & 255] << 16) | (o[(u >>> 8) & 255] << 8) | o[255 & d]) ^
                  i[f++]),
                  (g =
                    ((o[c >>> 24] << 24) | (o[(u >>> 16) & 255] << 16) | (o[(d >>> 8) & 255] << 8) | o[255 & l]) ^
                    i[f++]),
                  (y =
                    ((o[u >>> 24] << 24) | (o[(d >>> 16) & 255] << 16) | (o[(l >>> 8) & 255] << 8) | o[255 & c]) ^
                    i[f++]),
                  (d =
                    ((o[d >>> 24] << 24) | (o[(l >>> 16) & 255] << 16) | (o[(c >>> 8) & 255] << 8) | o[255 & u]) ^
                    i[f++]),
                  (t[e] = m),
                  (t[e + 1] = g),
                  (t[e + 2] = y),
                  (t[e + 3] = d));
              },
              keySize: 8,
            })),
            (t.AES = e._createHelper(i)));
        })(),
        (function () {
          function t(t, e) {
            var i = ((this._lBlock >>> t) ^ this._rBlock) & e;
            ((this._rBlock ^= i), (this._lBlock ^= i << t));
          }
          function e(t, e) {
            var i = ((this._rBlock >>> t) ^ this._lBlock) & e;
            ((this._lBlock ^= i), (this._rBlock ^= i << t));
          }
          var i = d,
            s = (n = i.lib).WordArray,
            n = n.BlockCipher,
            r = i.algo,
            a = [
              57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44,
              36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20,
              12, 4,
            ],
            o = [
              14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37,
              47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32,
            ],
            h = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28],
            l = [
              {
                0: 8421888,
                268435456: 32768,
                536870912: 8421378,
                805306368: 2,
                1073741824: 512,
                1342177280: 8421890,
                1610612736: 8389122,
                1879048192: 8388608,
                2147483648: 514,
                2415919104: 8389120,
                2684354560: 33280,
                2952790016: 8421376,
                3221225472: 32770,
                3489660928: 8388610,
                3758096384: 0,
                4026531840: 33282,
                134217728: 0,
                402653184: 8421890,
                671088640: 33282,
                939524096: 32768,
                1207959552: 8421888,
                1476395008: 512,
                1744830464: 8421378,
                2013265920: 2,
                2281701376: 8389120,
                2550136832: 33280,
                2818572288: 8421376,
                3087007744: 8389122,
                3355443200: 8388610,
                3623878656: 32770,
                3892314112: 514,
                4160749568: 8388608,
                1: 32768,
                268435457: 2,
                536870913: 8421888,
                805306369: 8388608,
                1073741825: 8421378,
                1342177281: 33280,
                1610612737: 512,
                1879048193: 8389122,
                2147483649: 8421890,
                2415919105: 8421376,
                2684354561: 8388610,
                2952790017: 33282,
                3221225473: 514,
                3489660929: 8389120,
                3758096385: 32770,
                4026531841: 0,
                134217729: 8421890,
                402653185: 8421376,
                671088641: 8388608,
                939524097: 512,
                1207959553: 32768,
                1476395009: 8388610,
                1744830465: 2,
                2013265921: 33282,
                2281701377: 32770,
                2550136833: 8389122,
                2818572289: 514,
                3087007745: 8421888,
                3355443201: 8389120,
                3623878657: 0,
                3892314113: 33280,
                4160749569: 8421378,
              },
              {
                0: 1074282512,
                16777216: 16384,
                33554432: 524288,
                50331648: 1074266128,
                67108864: 1073741840,
                83886080: 1074282496,
                100663296: 1073758208,
                117440512: 16,
                134217728: 540672,
                150994944: 1073758224,
                167772160: 1073741824,
                184549376: 540688,
                201326592: 524304,
                218103808: 0,
                234881024: 16400,
                251658240: 1074266112,
                8388608: 1073758208,
                25165824: 540688,
                41943040: 16,
                58720256: 1073758224,
                75497472: 1074282512,
                92274688: 1073741824,
                109051904: 524288,
                125829120: 1074266128,
                142606336: 524304,
                159383552: 0,
                176160768: 16384,
                192937984: 1074266112,
                209715200: 1073741840,
                226492416: 540672,
                243269632: 1074282496,
                260046848: 16400,
                268435456: 0,
                285212672: 1074266128,
                301989888: 1073758224,
                318767104: 1074282496,
                335544320: 1074266112,
                352321536: 16,
                369098752: 540688,
                385875968: 16384,
                402653184: 16400,
                419430400: 524288,
                436207616: 524304,
                452984832: 1073741840,
                469762048: 540672,
                486539264: 1073758208,
                503316480: 1073741824,
                520093696: 1074282512,
                276824064: 540688,
                293601280: 524288,
                310378496: 1074266112,
                327155712: 16384,
                343932928: 1073758208,
                360710144: 1074282512,
                377487360: 16,
                394264576: 1073741824,
                411041792: 1074282496,
                427819008: 1073741840,
                444596224: 1073758224,
                461373440: 524304,
                478150656: 0,
                494927872: 16400,
                511705088: 1074266128,
                528482304: 540672,
              },
              {
                0: 260,
                1048576: 0,
                2097152: 67109120,
                3145728: 65796,
                4194304: 65540,
                5242880: 67108868,
                6291456: 67174660,
                7340032: 67174400,
                8388608: 67108864,
                9437184: 67174656,
                10485760: 65792,
                11534336: 67174404,
                12582912: 67109124,
                13631488: 65536,
                14680064: 4,
                15728640: 256,
                524288: 67174656,
                1572864: 67174404,
                2621440: 0,
                3670016: 67109120,
                4718592: 67108868,
                5767168: 65536,
                6815744: 65540,
                7864320: 260,
                8912896: 4,
                9961472: 256,
                11010048: 67174400,
                12058624: 65796,
                13107200: 65792,
                14155776: 67109124,
                15204352: 67174660,
                16252928: 67108864,
                16777216: 67174656,
                17825792: 65540,
                18874368: 65536,
                19922944: 67109120,
                20971520: 256,
                22020096: 67174660,
                23068672: 67108868,
                24117248: 0,
                25165824: 67109124,
                26214400: 67108864,
                27262976: 4,
                28311552: 65792,
                29360128: 67174400,
                30408704: 260,
                31457280: 65796,
                32505856: 67174404,
                17301504: 67108864,
                18350080: 260,
                19398656: 67174656,
                20447232: 0,
                21495808: 65540,
                22544384: 67109120,
                23592960: 256,
                24641536: 67174404,
                25690112: 65536,
                26738688: 67174660,
                27787264: 65796,
                28835840: 67108868,
                29884416: 67109124,
                30932992: 67174400,
                31981568: 4,
                33030144: 65792,
              },
              {
                0: 2151682048,
                65536: 2147487808,
                131072: 4198464,
                196608: 2151677952,
                262144: 0,
                327680: 4198400,
                393216: 2147483712,
                458752: 4194368,
                524288: 2147483648,
                589824: 4194304,
                655360: 64,
                720896: 2147487744,
                786432: 2151678016,
                851968: 4160,
                917504: 4096,
                983040: 2151682112,
                32768: 2147487808,
                98304: 64,
                163840: 2151678016,
                229376: 2147487744,
                294912: 4198400,
                360448: 2151682112,
                425984: 0,
                491520: 2151677952,
                557056: 4096,
                622592: 2151682048,
                688128: 4194304,
                753664: 4160,
                819200: 2147483648,
                884736: 4194368,
                950272: 4198464,
                1015808: 2147483712,
                1048576: 4194368,
                1114112: 4198400,
                1179648: 2147483712,
                1245184: 0,
                1310720: 4160,
                1376256: 2151678016,
                1441792: 2151682048,
                1507328: 2147487808,
                1572864: 2151682112,
                1638400: 2147483648,
                1703936: 2151677952,
                1769472: 4198464,
                1835008: 2147487744,
                1900544: 4194304,
                1966080: 64,
                2031616: 4096,
                1081344: 2151677952,
                1146880: 2151682112,
                1212416: 0,
                1277952: 4198400,
                1343488: 4194368,
                1409024: 2147483648,
                1474560: 2147487808,
                1540096: 64,
                1605632: 2147483712,
                1671168: 4096,
                1736704: 2147487744,
                1802240: 2151678016,
                1867776: 4160,
                1933312: 2151682048,
                1998848: 4194304,
                2064384: 4198464,
              },
              {
                0: 128,
                4096: 17039360,
                8192: 262144,
                12288: 536870912,
                16384: 537133184,
                20480: 16777344,
                24576: 553648256,
                28672: 262272,
                32768: 16777216,
                36864: 537133056,
                40960: 536871040,
                45056: 553910400,
                49152: 553910272,
                53248: 0,
                57344: 17039488,
                61440: 553648128,
                2048: 17039488,
                6144: 553648256,
                10240: 128,
                14336: 17039360,
                18432: 262144,
                22528: 537133184,
                26624: 553910272,
                30720: 536870912,
                34816: 537133056,
                38912: 0,
                43008: 553910400,
                47104: 16777344,
                51200: 536871040,
                55296: 553648128,
                59392: 16777216,
                63488: 262272,
                65536: 262144,
                69632: 128,
                73728: 536870912,
                77824: 553648256,
                81920: 16777344,
                86016: 553910272,
                90112: 537133184,
                94208: 16777216,
                98304: 553910400,
                102400: 553648128,
                106496: 17039360,
                110592: 537133056,
                114688: 262272,
                118784: 536871040,
                122880: 0,
                126976: 17039488,
                67584: 553648256,
                71680: 16777216,
                75776: 17039360,
                79872: 537133184,
                83968: 536870912,
                88064: 17039488,
                92160: 128,
                96256: 553910272,
                100352: 262272,
                104448: 553910400,
                108544: 0,
                112640: 553648128,
                116736: 16777344,
                120832: 262144,
                124928: 537133056,
                129024: 536871040,
              },
              {
                0: 268435464,
                256: 8192,
                512: 270532608,
                768: 270540808,
                1024: 268443648,
                1280: 2097152,
                1536: 2097160,
                1792: 268435456,
                2048: 0,
                2304: 268443656,
                2560: 2105344,
                2816: 8,
                3072: 270532616,
                3328: 2105352,
                3584: 8200,
                3840: 270540800,
                128: 270532608,
                384: 270540808,
                640: 8,
                896: 2097152,
                1152: 2105352,
                1408: 268435464,
                1664: 268443648,
                1920: 8200,
                2176: 2097160,
                2432: 8192,
                2688: 268443656,
                2944: 270532616,
                3200: 0,
                3456: 270540800,
                3712: 2105344,
                3968: 268435456,
                4096: 268443648,
                4352: 270532616,
                4608: 270540808,
                4864: 8200,
                5120: 2097152,
                5376: 268435456,
                5632: 268435464,
                5888: 2105344,
                6144: 2105352,
                6400: 0,
                6656: 8,
                6912: 270532608,
                7168: 8192,
                7424: 268443656,
                7680: 270540800,
                7936: 2097160,
                4224: 8,
                4480: 2105344,
                4736: 2097152,
                4992: 268435464,
                5248: 268443648,
                5504: 8200,
                5760: 270540808,
                6016: 270532608,
                6272: 270540800,
                6528: 270532616,
                6784: 8192,
                7040: 2105352,
                7296: 2097160,
                7552: 0,
                7808: 268435456,
                8064: 268443656,
              },
              {
                0: 1048576,
                16: 33555457,
                32: 1024,
                48: 1049601,
                64: 34604033,
                80: 0,
                96: 1,
                112: 34603009,
                128: 33555456,
                144: 1048577,
                160: 33554433,
                176: 34604032,
                192: 34603008,
                208: 1025,
                224: 1049600,
                240: 33554432,
                8: 34603009,
                24: 0,
                40: 33555457,
                56: 34604032,
                72: 1048576,
                88: 33554433,
                104: 33554432,
                120: 1025,
                136: 1049601,
                152: 33555456,
                168: 34603008,
                184: 1048577,
                200: 1024,
                216: 34604033,
                232: 1,
                248: 1049600,
                256: 33554432,
                272: 1048576,
                288: 33555457,
                304: 34603009,
                320: 1048577,
                336: 33555456,
                352: 34604032,
                368: 1049601,
                384: 1025,
                400: 34604033,
                416: 1049600,
                432: 1,
                448: 0,
                464: 34603008,
                480: 33554433,
                496: 1024,
                264: 1049600,
                280: 33555457,
                296: 34603009,
                312: 1,
                328: 33554432,
                344: 1048576,
                360: 1025,
                376: 34604032,
                392: 33554433,
                408: 34603008,
                424: 0,
                440: 34604033,
                456: 1049601,
                472: 1024,
                488: 33555456,
                504: 1048577,
              },
              {
                0: 134219808,
                1: 131072,
                2: 134217728,
                3: 32,
                4: 131104,
                5: 134350880,
                6: 134350848,
                7: 2048,
                8: 134348800,
                9: 134219776,
                10: 133120,
                11: 134348832,
                12: 2080,
                13: 0,
                14: 134217760,
                15: 133152,
                2147483648: 2048,
                2147483649: 134350880,
                2147483650: 134219808,
                2147483651: 134217728,
                2147483652: 134348800,
                2147483653: 133120,
                2147483654: 133152,
                2147483655: 32,
                2147483656: 134217760,
                2147483657: 2080,
                2147483658: 131104,
                2147483659: 134350848,
                2147483660: 0,
                2147483661: 134348832,
                2147483662: 134219776,
                2147483663: 131072,
                16: 133152,
                17: 134350848,
                18: 32,
                19: 2048,
                20: 134219776,
                21: 134217760,
                22: 134348832,
                23: 131072,
                24: 0,
                25: 131104,
                26: 134348800,
                27: 134219808,
                28: 134350880,
                29: 133120,
                30: 2080,
                31: 134217728,
                2147483664: 131072,
                2147483665: 2048,
                2147483666: 134348832,
                2147483667: 133152,
                2147483668: 32,
                2147483669: 134348800,
                2147483670: 134217728,
                2147483671: 134219808,
                2147483672: 134350880,
                2147483673: 134217760,
                2147483674: 134219776,
                2147483675: 0,
                2147483676: 133120,
                2147483677: 2080,
                2147483678: 131104,
                2147483679: 134350848,
              },
            ],
            c = [4160749569, 528482304, 33030144, 2064384, 129024, 8064, 504, 2147483679],
            u = (r.DES = n.extend({
              _doReset: function () {
                for (var t = this._key.words, e = [], i = 0; 56 > i; i++) {
                  var s = a[i] - 1;
                  e[i] = (t[s >>> 5] >>> (31 - (s % 32))) & 1;
                }
                for (t = this._subKeys = [], s = 0; 16 > s; s++) {
                  var n = (t[s] = []),
                    r = h[s];
                  for (i = 0; 24 > i; i++)
                    ((n[(i / 6) | 0] |= e[(o[i] - 1 + r) % 28] << (31 - (i % 6))),
                      (n[4 + ((i / 6) | 0)] |= e[28 + ((o[i + 24] - 1 + r) % 28)] << (31 - (i % 6))));
                  for (n[0] = (n[0] << 1) | (n[0] >>> 31), i = 1; 7 > i; i++) n[i] >>>= 4 * (i - 1) + 3;
                  n[7] = (n[7] << 5) | (n[7] >>> 27);
                }
                for (e = this._invSubKeys = [], i = 0; 16 > i; i++) e[i] = t[15 - i];
              },
              encryptBlock: function (t, e) {
                this._doCryptBlock(t, e, this._subKeys);
              },
              decryptBlock: function (t, e) {
                this._doCryptBlock(t, e, this._invSubKeys);
              },
              _doCryptBlock: function (i, s, n) {
                ((this._lBlock = i[s]),
                  (this._rBlock = i[s + 1]),
                  t.call(this, 4, 252645135),
                  t.call(this, 16, 65535),
                  e.call(this, 2, 858993459),
                  e.call(this, 8, 16711935),
                  t.call(this, 1, 1431655765));
                for (var r = 0; 16 > r; r++) {
                  for (var a = n[r], o = this._lBlock, h = this._rBlock, u = 0, d = 0; 8 > d; d++)
                    u |= l[d][((h ^ a[d]) & c[d]) >>> 0];
                  ((this._lBlock = h), (this._rBlock = o ^ u));
                }
                ((n = this._lBlock),
                  (this._lBlock = this._rBlock),
                  (this._rBlock = n),
                  t.call(this, 1, 1431655765),
                  e.call(this, 8, 16711935),
                  e.call(this, 2, 858993459),
                  t.call(this, 16, 65535),
                  t.call(this, 4, 252645135),
                  (i[s] = this._lBlock),
                  (i[s + 1] = this._rBlock));
              },
              keySize: 2,
              ivSize: 2,
              blockSize: 2,
            }));
          ((i.DES = n._createHelper(u)),
            (r = r.TripleDES =
              n.extend({
                _doReset: function () {
                  var t = this._key.words;
                  ((this._des1 = u.createEncryptor(s.create(t.slice(0, 2)))),
                    (this._des2 = u.createEncryptor(s.create(t.slice(2, 4)))),
                    (this._des3 = u.createEncryptor(s.create(t.slice(4, 6)))));
                },
                encryptBlock: function (t, e) {
                  (this._des1.encryptBlock(t, e), this._des2.decryptBlock(t, e), this._des3.encryptBlock(t, e));
                },
                decryptBlock: function (t, e) {
                  (this._des3.decryptBlock(t, e), this._des2.encryptBlock(t, e), this._des1.decryptBlock(t, e));
                },
                keySize: 6,
                ivSize: 2,
                blockSize: 2,
              })),
            (i.TripleDES = n._createHelper(r)));
        })(),
        (function () {
          var t = d,
            e = t.lib.WordArray;
          t.enc.Base64 = {
            stringify: function (t) {
              var e = t.words,
                i = t.sigBytes,
                s = this._map;
              (t.clamp(), (t = []));
              for (var n = 0; n < i; n += 3)
                for (
                  var r =
                      (((e[n >>> 2] >>> (24 - (n % 4) * 8)) & 255) << 16) |
                      (((e[(n + 1) >>> 2] >>> (24 - ((n + 1) % 4) * 8)) & 255) << 8) |
                      ((e[(n + 2) >>> 2] >>> (24 - ((n + 2) % 4) * 8)) & 255),
                    a = 0;
                  4 > a && n + 0.75 * a < i;
                  a++
                )
                  t.push(s.charAt((r >>> (6 * (3 - a))) & 63));
              if ((e = s.charAt(64))) for (; t.length % 4; ) t.push(e);
              return t.join('');
            },
            parse: function (t) {
              var i = t.length,
                s = this._map;
              (n = s.charAt(64)) && -1 != (n = t.indexOf(n)) && (i = n);
              for (var n = [], r = 0, a = 0; a < i; a++)
                if (a % 4) {
                  var o = s.indexOf(t.charAt(a - 1)) << ((a % 4) * 2),
                    h = s.indexOf(t.charAt(a)) >>> (6 - (a % 4) * 2);
                  ((n[r >>> 2] |= (o | h) << (24 - (r % 4) * 8)), r++);
                }
              return e.create(n, r);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
          };
        })(),
        (function (t) {
          function e(t, e, i, s, n, r, a) {
            return (((t = t + ((e & i) | (~e & s)) + n + a) << r) | (t >>> (32 - r))) + e;
          }
          function i(t, e, i, s, n, r, a) {
            return (((t = t + ((e & s) | (i & ~s)) + n + a) << r) | (t >>> (32 - r))) + e;
          }
          function s(t, e, i, s, n, r, a) {
            return (((t = t + (e ^ i ^ s) + n + a) << r) | (t >>> (32 - r))) + e;
          }
          function n(t, e, i, s, n, r, a) {
            return (((t = t + (i ^ (e | ~s)) + n + a) << r) | (t >>> (32 - r))) + e;
          }
          for (var r = d, a = (h = r.lib).WordArray, o = h.Hasher, h = r.algo, l = [], c = 0; 64 > c; c++)
            l[c] = (4294967296 * t.abs(t.sin(c + 1))) | 0;
          ((h = h.MD5 =
            o.extend({
              _doReset: function () {
                this._hash = new a.init([1732584193, 4023233417, 2562383102, 271733878]);
              },
              _doProcessBlock: function (t, r) {
                for (var a = 0; 16 > a; a++) {
                  var o = t[(h = r + a)];
                  t[h] = (16711935 & ((o << 8) | (o >>> 24))) | (4278255360 & ((o << 24) | (o >>> 8)));
                }
                a = this._hash.words;
                var h = t[r + 0],
                  c = ((o = t[r + 1]), t[r + 2]),
                  u = t[r + 3],
                  d = t[r + 4],
                  f = t[r + 5],
                  p = t[r + 6],
                  m = t[r + 7],
                  g = t[r + 8],
                  y = t[r + 9],
                  x = t[r + 10],
                  v = t[r + 11],
                  b = t[r + 12],
                  w = t[r + 13],
                  S = t[r + 14],
                  M = t[r + 15],
                  C = e((C = a[0]), (A = a[1]), (D = a[2]), (E = a[3]), h, 7, l[0]),
                  E = e(E, C, A, D, o, 12, l[1]),
                  D = e(D, E, C, A, c, 17, l[2]),
                  A = e(A, D, E, C, u, 22, l[3]);
                ((C = e(C, A, D, E, d, 7, l[4])),
                  (E = e(E, C, A, D, f, 12, l[5])),
                  (D = e(D, E, C, A, p, 17, l[6])),
                  (A = e(A, D, E, C, m, 22, l[7])),
                  (C = e(C, A, D, E, g, 7, l[8])),
                  (E = e(E, C, A, D, y, 12, l[9])),
                  (D = e(D, E, C, A, x, 17, l[10])),
                  (A = e(A, D, E, C, v, 22, l[11])),
                  (C = e(C, A, D, E, b, 7, l[12])),
                  (E = e(E, C, A, D, w, 12, l[13])),
                  (D = e(D, E, C, A, S, 17, l[14])),
                  (C = i(C, (A = e(A, D, E, C, M, 22, l[15])), D, E, o, 5, l[16])),
                  (E = i(E, C, A, D, p, 9, l[17])),
                  (D = i(D, E, C, A, v, 14, l[18])),
                  (A = i(A, D, E, C, h, 20, l[19])),
                  (C = i(C, A, D, E, f, 5, l[20])),
                  (E = i(E, C, A, D, x, 9, l[21])),
                  (D = i(D, E, C, A, M, 14, l[22])),
                  (A = i(A, D, E, C, d, 20, l[23])),
                  (C = i(C, A, D, E, y, 5, l[24])),
                  (E = i(E, C, A, D, S, 9, l[25])),
                  (D = i(D, E, C, A, u, 14, l[26])),
                  (A = i(A, D, E, C, g, 20, l[27])),
                  (C = i(C, A, D, E, w, 5, l[28])),
                  (E = i(E, C, A, D, c, 9, l[29])),
                  (D = i(D, E, C, A, m, 14, l[30])),
                  (C = s(C, (A = i(A, D, E, C, b, 20, l[31])), D, E, f, 4, l[32])),
                  (E = s(E, C, A, D, g, 11, l[33])),
                  (D = s(D, E, C, A, v, 16, l[34])),
                  (A = s(A, D, E, C, S, 23, l[35])),
                  (C = s(C, A, D, E, o, 4, l[36])),
                  (E = s(E, C, A, D, d, 11, l[37])),
                  (D = s(D, E, C, A, m, 16, l[38])),
                  (A = s(A, D, E, C, x, 23, l[39])),
                  (C = s(C, A, D, E, w, 4, l[40])),
                  (E = s(E, C, A, D, h, 11, l[41])),
                  (D = s(D, E, C, A, u, 16, l[42])),
                  (A = s(A, D, E, C, p, 23, l[43])),
                  (C = s(C, A, D, E, y, 4, l[44])),
                  (E = s(E, C, A, D, b, 11, l[45])),
                  (D = s(D, E, C, A, M, 16, l[46])),
                  (C = n(C, (A = s(A, D, E, C, c, 23, l[47])), D, E, h, 6, l[48])),
                  (E = n(E, C, A, D, m, 10, l[49])),
                  (D = n(D, E, C, A, S, 15, l[50])),
                  (A = n(A, D, E, C, f, 21, l[51])),
                  (C = n(C, A, D, E, b, 6, l[52])),
                  (E = n(E, C, A, D, u, 10, l[53])),
                  (D = n(D, E, C, A, x, 15, l[54])),
                  (A = n(A, D, E, C, o, 21, l[55])),
                  (C = n(C, A, D, E, g, 6, l[56])),
                  (E = n(E, C, A, D, M, 10, l[57])),
                  (D = n(D, E, C, A, p, 15, l[58])),
                  (A = n(A, D, E, C, w, 21, l[59])),
                  (C = n(C, A, D, E, d, 6, l[60])),
                  (E = n(E, C, A, D, v, 10, l[61])),
                  (D = n(D, E, C, A, c, 15, l[62])),
                  (A = n(A, D, E, C, y, 21, l[63])),
                  (a[0] = (a[0] + C) | 0),
                  (a[1] = (a[1] + A) | 0),
                  (a[2] = (a[2] + D) | 0),
                  (a[3] = (a[3] + E) | 0));
              },
              _doFinalize: function () {
                var e = this._data,
                  i = e.words,
                  s = 8 * this._nDataBytes,
                  n = 8 * e.sigBytes;
                i[n >>> 5] |= 128 << (24 - (n % 32));
                var r = t.floor(s / 4294967296);
                for (
                  i[15 + (((n + 64) >>> 9) << 4)] =
                    (16711935 & ((r << 8) | (r >>> 24))) | (4278255360 & ((r << 24) | (r >>> 8))),
                    i[14 + (((n + 64) >>> 9) << 4)] =
                      (16711935 & ((s << 8) | (s >>> 24))) | (4278255360 & ((s << 24) | (s >>> 8))),
                    e.sigBytes = 4 * (i.length + 1),
                    this._process(),
                    i = (e = this._hash).words,
                    s = 0;
                  4 > s;
                  s++
                )
                  ((n = i[s]), (i[s] = (16711935 & ((n << 8) | (n >>> 24))) | (4278255360 & ((n << 24) | (n >>> 8)))));
                return e;
              },
              clone: function () {
                var t = o.clone.call(this);
                return ((t._hash = this._hash.clone()), t);
              },
            })),
            (r.MD5 = o._createHelper(h)),
            (r.HmacMD5 = o._createHmacHelper(h)));
        })(Math),
        (a = (l = (r = d).lib).WordArray),
        (o = l.Hasher),
        (h = []),
        (l = r.algo.SHA1 =
          o.extend({
            _doReset: function () {
              this._hash = new a.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
            },
            _doProcessBlock: function (t, e) {
              for (var i = this._hash.words, s = i[0], n = i[1], r = i[2], a = i[3], o = i[4], l = 0; 80 > l; l++) {
                if (16 > l) h[l] = 0 | t[e + l];
                else {
                  var c = h[l - 3] ^ h[l - 8] ^ h[l - 14] ^ h[l - 16];
                  h[l] = (c << 1) | (c >>> 31);
                }
                ((c = ((s << 5) | (s >>> 27)) + o + h[l]),
                  (c =
                    20 > l
                      ? c + (1518500249 + ((n & r) | (~n & a)))
                      : 40 > l
                        ? c + (1859775393 + (n ^ r ^ a))
                        : 60 > l
                          ? c + (((n & r) | (n & a) | (r & a)) - 1894007588)
                          : c + ((n ^ r ^ a) - 899497514)),
                  (o = a),
                  (a = r),
                  (r = (n << 30) | (n >>> 2)),
                  (n = s),
                  (s = c));
              }
              ((i[0] = (i[0] + s) | 0),
                (i[1] = (i[1] + n) | 0),
                (i[2] = (i[2] + r) | 0),
                (i[3] = (i[3] + a) | 0),
                (i[4] = (i[4] + o) | 0));
            },
            _doFinalize: function () {
              var t = this._data,
                e = t.words,
                i = 8 * this._nDataBytes,
                s = 8 * t.sigBytes;
              return (
                (e[s >>> 5] |= 128 << (24 - (s % 32))),
                (e[14 + (((s + 64) >>> 9) << 4)] = Math.floor(i / 4294967296)),
                (e[15 + (((s + 64) >>> 9) << 4)] = i),
                (t.sigBytes = 4 * e.length),
                this._process(),
                this._hash
              );
            },
            clone: function () {
              var t = o.clone.call(this);
              return ((t._hash = this._hash.clone()), t);
            },
          })),
        (r.SHA1 = o._createHelper(l)),
        (r.HmacSHA1 = o._createHmacHelper(l)),
        (function (t) {
          for (
            var e = d,
              i = (n = e.lib).WordArray,
              s = n.Hasher,
              n = e.algo,
              r = [],
              a = [],
              o = function (t) {
                return (4294967296 * (t - (0 | t))) | 0;
              },
              h = 2,
              l = 0;
            64 > l;

          ) {
            var c;
            t: {
              c = h;
              for (var u = t.sqrt(c), f = 2; f <= u; f++)
                if (!(c % f)) {
                  c = !1;
                  break t;
                }
              c = !0;
            }
            (c && (8 > l && (r[l] = o(t.pow(h, 0.5))), (a[l] = o(t.pow(h, 1 / 3))), l++), h++);
          }
          var p = [];
          ((n = n.SHA256 =
            s.extend({
              _doReset: function () {
                this._hash = new i.init(r.slice(0));
              },
              _doProcessBlock: function (t, e) {
                for (
                  var i = this._hash.words,
                    s = i[0],
                    n = i[1],
                    r = i[2],
                    o = i[3],
                    h = i[4],
                    l = i[5],
                    c = i[6],
                    u = i[7],
                    d = 0;
                  64 > d;
                  d++
                ) {
                  if (16 > d) p[d] = 0 | t[e + d];
                  else {
                    var f = p[d - 15],
                      m = p[d - 2];
                    p[d] =
                      (((f << 25) | (f >>> 7)) ^ ((f << 14) | (f >>> 18)) ^ (f >>> 3)) +
                      p[d - 7] +
                      (((m << 15) | (m >>> 17)) ^ ((m << 13) | (m >>> 19)) ^ (m >>> 10)) +
                      p[d - 16];
                  }
                  ((f =
                    u +
                    (((h << 26) | (h >>> 6)) ^ ((h << 21) | (h >>> 11)) ^ ((h << 7) | (h >>> 25))) +
                    ((h & l) ^ (~h & c)) +
                    a[d] +
                    p[d]),
                    (m =
                      (((s << 30) | (s >>> 2)) ^ ((s << 19) | (s >>> 13)) ^ ((s << 10) | (s >>> 22))) +
                      ((s & n) ^ (s & r) ^ (n & r))),
                    (u = c),
                    (c = l),
                    (l = h),
                    (h = (o + f) | 0),
                    (o = r),
                    (r = n),
                    (n = s),
                    (s = (f + m) | 0));
                }
                ((i[0] = (i[0] + s) | 0),
                  (i[1] = (i[1] + n) | 0),
                  (i[2] = (i[2] + r) | 0),
                  (i[3] = (i[3] + o) | 0),
                  (i[4] = (i[4] + h) | 0),
                  (i[5] = (i[5] + l) | 0),
                  (i[6] = (i[6] + c) | 0),
                  (i[7] = (i[7] + u) | 0));
              },
              _doFinalize: function () {
                var e = this._data,
                  i = e.words,
                  s = 8 * this._nDataBytes,
                  n = 8 * e.sigBytes;
                return (
                  (i[n >>> 5] |= 128 << (24 - (n % 32))),
                  (i[14 + (((n + 64) >>> 9) << 4)] = t.floor(s / 4294967296)),
                  (i[15 + (((n + 64) >>> 9) << 4)] = s),
                  (e.sigBytes = 4 * i.length),
                  this._process(),
                  this._hash
                );
              },
              clone: function () {
                var t = s.clone.call(this);
                return ((t._hash = this._hash.clone()), t);
              },
            })),
            (e.SHA256 = s._createHelper(n)),
            (e.HmacSHA256 = s._createHmacHelper(n)));
        })(Math),
        (function () {
          var t = d,
            e = t.lib.WordArray,
            i = (s = t.algo).SHA256,
            s = (s.SHA224 = i.extend({
              _doReset: function () {
                this._hash = new e.init([
                  3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428,
                ]);
              },
              _doFinalize: function () {
                var t = i._doFinalize.call(this);
                return ((t.sigBytes -= 4), t);
              },
            }));
          ((t.SHA224 = i._createHelper(s)), (t.HmacSHA224 = i._createHmacHelper(s)));
        })(),
        (function () {
          function t() {
            return s.create.apply(s, arguments);
          }
          for (
            var e = d,
              i = e.lib.Hasher,
              s = (r = e.x64).Word,
              n = r.WordArray,
              r = e.algo,
              a = [
                t(1116352408, 3609767458),
                t(1899447441, 602891725),
                t(3049323471, 3964484399),
                t(3921009573, 2173295548),
                t(961987163, 4081628472),
                t(1508970993, 3053834265),
                t(2453635748, 2937671579),
                t(2870763221, 3664609560),
                t(3624381080, 2734883394),
                t(310598401, 1164996542),
                t(607225278, 1323610764),
                t(1426881987, 3590304994),
                t(1925078388, 4068182383),
                t(2162078206, 991336113),
                t(2614888103, 633803317),
                t(3248222580, 3479774868),
                t(3835390401, 2666613458),
                t(4022224774, 944711139),
                t(264347078, 2341262773),
                t(604807628, 2007800933),
                t(770255983, 1495990901),
                t(1249150122, 1856431235),
                t(1555081692, 3175218132),
                t(1996064986, 2198950837),
                t(2554220882, 3999719339),
                t(2821834349, 766784016),
                t(2952996808, 2566594879),
                t(3210313671, 3203337956),
                t(3336571891, 1034457026),
                t(3584528711, 2466948901),
                t(113926993, 3758326383),
                t(338241895, 168717936),
                t(666307205, 1188179964),
                t(773529912, 1546045734),
                t(1294757372, 1522805485),
                t(1396182291, 2643833823),
                t(1695183700, 2343527390),
                t(1986661051, 1014477480),
                t(2177026350, 1206759142),
                t(2456956037, 344077627),
                t(2730485921, 1290863460),
                t(2820302411, 3158454273),
                t(3259730800, 3505952657),
                t(3345764771, 106217008),
                t(3516065817, 3606008344),
                t(3600352804, 1432725776),
                t(4094571909, 1467031594),
                t(275423344, 851169720),
                t(430227734, 3100823752),
                t(506948616, 1363258195),
                t(659060556, 3750685593),
                t(883997877, 3785050280),
                t(958139571, 3318307427),
                t(1322822218, 3812723403),
                t(1537002063, 2003034995),
                t(1747873779, 3602036899),
                t(1955562222, 1575990012),
                t(2024104815, 1125592928),
                t(2227730452, 2716904306),
                t(2361852424, 442776044),
                t(2428436474, 593698344),
                t(2756734187, 3733110249),
                t(3204031479, 2999351573),
                t(3329325298, 3815920427),
                t(3391569614, 3928383900),
                t(3515267271, 566280711),
                t(3940187606, 3454069534),
                t(4118630271, 4000239992),
                t(116418474, 1914138554),
                t(174292421, 2731055270),
                t(289380356, 3203993006),
                t(460393269, 320620315),
                t(685471733, 587496836),
                t(852142971, 1086792851),
                t(1017036298, 365543100),
                t(1126000580, 2618297676),
                t(1288033470, 3409855158),
                t(1501505948, 4234509866),
                t(1607167915, 987167468),
                t(1816402316, 1246189591),
              ],
              o = [],
              h = 0;
            80 > h;
            h++
          )
            o[h] = t();
          ((r = r.SHA512 =
            i.extend({
              _doReset: function () {
                this._hash = new n.init([
                  new s.init(1779033703, 4089235720),
                  new s.init(3144134277, 2227873595),
                  new s.init(1013904242, 4271175723),
                  new s.init(2773480762, 1595750129),
                  new s.init(1359893119, 2917565137),
                  new s.init(2600822924, 725511199),
                  new s.init(528734635, 4215389547),
                  new s.init(1541459225, 327033209),
                ]);
              },
              _doProcessBlock: function (t, e) {
                for (
                  var i = (u = this._hash.words)[0],
                    s = u[1],
                    n = u[2],
                    r = u[3],
                    h = u[4],
                    l = u[5],
                    c = u[6],
                    u = u[7],
                    d = i.high,
                    f = i.low,
                    p = s.high,
                    m = s.low,
                    g = n.high,
                    y = n.low,
                    x = r.high,
                    v = r.low,
                    b = h.high,
                    w = h.low,
                    S = l.high,
                    M = l.low,
                    C = c.high,
                    E = c.low,
                    D = u.high,
                    A = u.low,
                    F = d,
                    P = f,
                    T = p,
                    I = m,
                    _ = g,
                    R = y,
                    N = x,
                    B = v,
                    k = b,
                    z = w,
                    L = S,
                    O = M,
                    H = C,
                    j = E,
                    q = D,
                    V = A,
                    U = 0;
                  80 > U;
                  U++
                ) {
                  var K = o[U];
                  if (16 > U)
                    var G = (K.high = 0 | t[e + 2 * U]),
                      W = (K.low = 0 | t[e + 2 * U + 1]);
                  else {
                    G =
                      (((W = (G = o[U - 15]).high) >>> 1) | ((Q = G.low) << 31)) ^ ((W >>> 8) | (Q << 24)) ^ (W >>> 7);
                    var Q = ((Q >>> 1) | (W << 31)) ^ ((Q >>> 8) | (W << 24)) ^ ((Q >>> 7) | (W << 25)),
                      X =
                        (((W = (X = o[U - 2]).high) >>> 19) | ((Y = X.low) << 13)) ^
                        ((W << 3) | (Y >>> 29)) ^
                        (W >>> 6),
                      Y = ((Y >>> 19) | (W << 13)) ^ ((Y << 3) | (W >>> 29)) ^ ((Y >>> 6) | (W << 26)),
                      Z = (W = o[U - 7]).high,
                      J = ($ = o[U - 16]).high,
                      $ = $.low;
                    ((G =
                      (G =
                        (G = G + Z + ((W = Q + W.low) >>> 0 < Q >>> 0 ? 1 : 0)) +
                        X +
                        ((W += Y) >>> 0 < Y >>> 0 ? 1 : 0)) +
                      J +
                      ((W += $) >>> 0 < $ >>> 0 ? 1 : 0)),
                      (K.high = G),
                      (K.low = W));
                  }
                  ((Z = (k & L) ^ (~k & H)), ($ = (z & O) ^ (~z & j)), (K = (F & T) ^ (F & _) ^ (T & _)));
                  var tt = (P & I) ^ (P & R) ^ (I & R),
                    et =
                      ((Q = ((F >>> 28) | (P << 4)) ^ ((F << 30) | (P >>> 2)) ^ ((F << 25) | (P >>> 7))),
                      (X = ((P >>> 28) | (F << 4)) ^ ((P << 30) | (F >>> 2)) ^ ((P << 25) | (F >>> 7))),
                      (Y = a[U]).high),
                    it = Y.low;
                  ((J =
                    q +
                    (((k >>> 14) | (z << 18)) ^ ((k >>> 18) | (z << 14)) ^ ((k << 23) | (z >>> 9))) +
                    ((Y = V + (((z >>> 14) | (k << 18)) ^ ((z >>> 18) | (k << 14)) ^ ((z << 23) | (k >>> 9)))) >>> 0 <
                    V >>> 0
                      ? 1
                      : 0)),
                    (q = H),
                    (V = j),
                    (H = L),
                    (j = O),
                    (L = k),
                    (O = z),
                    (k =
                      (N +
                        (J =
                          (J =
                            (J = J + Z + ((Y += $) >>> 0 < $ >>> 0 ? 1 : 0)) +
                            et +
                            ((Y += it) >>> 0 < it >>> 0 ? 1 : 0)) +
                          G +
                          ((Y += W) >>> 0 < W >>> 0 ? 1 : 0)) +
                        ((z = (B + Y) | 0) >>> 0 < B >>> 0 ? 1 : 0)) |
                      0),
                    (N = _),
                    (B = R),
                    (_ = T),
                    (R = I),
                    (T = F),
                    (I = P),
                    (F =
                      (J +
                        (K = Q + K + ((W = X + tt) >>> 0 < X >>> 0 ? 1 : 0)) +
                        ((P = (Y + W) | 0) >>> 0 < Y >>> 0 ? 1 : 0)) |
                      0));
                }
                ((f = i.low = f + P),
                  (i.high = d + F + (f >>> 0 < P >>> 0 ? 1 : 0)),
                  (m = s.low = m + I),
                  (s.high = p + T + (m >>> 0 < I >>> 0 ? 1 : 0)),
                  (y = n.low = y + R),
                  (n.high = g + _ + (y >>> 0 < R >>> 0 ? 1 : 0)),
                  (v = r.low = v + B),
                  (r.high = x + N + (v >>> 0 < B >>> 0 ? 1 : 0)),
                  (w = h.low = w + z),
                  (h.high = b + k + (w >>> 0 < z >>> 0 ? 1 : 0)),
                  (M = l.low = M + O),
                  (l.high = S + L + (M >>> 0 < O >>> 0 ? 1 : 0)),
                  (E = c.low = E + j),
                  (c.high = C + H + (E >>> 0 < j >>> 0 ? 1 : 0)),
                  (A = u.low = A + V),
                  (u.high = D + q + (A >>> 0 < V >>> 0 ? 1 : 0)));
              },
              _doFinalize: function () {
                var t = this._data,
                  e = t.words,
                  i = 8 * this._nDataBytes,
                  s = 8 * t.sigBytes;
                return (
                  (e[s >>> 5] |= 128 << (24 - (s % 32))),
                  (e[30 + (((s + 128) >>> 10) << 5)] = Math.floor(i / 4294967296)),
                  (e[31 + (((s + 128) >>> 10) << 5)] = i),
                  (t.sigBytes = 4 * e.length),
                  this._process(),
                  this._hash.toX32()
                );
              },
              clone: function () {
                var t = i.clone.call(this);
                return ((t._hash = this._hash.clone()), t);
              },
              blockSize: 32,
            })),
            (e.SHA512 = i._createHelper(r)),
            (e.HmacSHA512 = i._createHmacHelper(r)));
        })(),
        (function () {
          var t = d,
            e = (n = t.x64).Word,
            i = n.WordArray,
            s = (n = t.algo).SHA512,
            n = (n.SHA384 = s.extend({
              _doReset: function () {
                this._hash = new i.init([
                  new e.init(3418070365, 3238371032),
                  new e.init(1654270250, 914150663),
                  new e.init(2438529370, 812702999),
                  new e.init(355462360, 4144912697),
                  new e.init(1731405415, 4290775857),
                  new e.init(2394180231, 1750603025),
                  new e.init(3675008525, 1694076839),
                  new e.init(1203062813, 3204075428),
                ]);
              },
              _doFinalize: function () {
                var t = s._doFinalize.call(this);
                return ((t.sigBytes -= 16), t);
              },
            }));
          ((t.SHA384 = s._createHelper(n)), (t.HmacSHA384 = s._createHmacHelper(n)));
        })(),
        (function () {
          var t = d,
            e = (s = t.lib).WordArray,
            i = s.Hasher,
            s = t.algo,
            n = e.create([
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11,
              8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5,
              6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13,
            ]),
            r = e.create([
              5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1,
              2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10,
              14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11,
            ]),
            a = e.create([
              11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7,
              13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6,
              8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6,
            ]),
            o = e.create([
              8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15,
              13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9,
              12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11,
            ]),
            h = e.create([0, 1518500249, 1859775393, 2400959708, 2840853838]),
            l = e.create([1352829926, 1548603684, 1836072691, 2053994217, 0]);
          ((s = s.RIPEMD160 =
            i.extend({
              _doReset: function () {
                this._hash = e.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
              },
              _doProcessBlock: function (t, e) {
                for (var i = 0; 16 > i; i++) {
                  var s = t[(w = e + i)];
                  t[w] = (16711935 & ((s << 8) | (s >>> 24))) | (4278255360 & ((s << 24) | (s >>> 8)));
                }
                var c,
                  u,
                  d,
                  f,
                  p,
                  m,
                  g,
                  y,
                  x,
                  v,
                  b,
                  w = this._hash.words,
                  S = ((s = h.words), l.words),
                  M = n.words,
                  C = r.words,
                  E = a.words,
                  D = o.words;
                for (m = c = w[0], g = u = w[1], y = d = w[2], x = f = w[3], v = p = w[4], i = 0; 80 > i; i += 1)
                  ((b = (c + t[e + M[i]]) | 0),
                    (b =
                      16 > i
                        ? b + ((u ^ d ^ f) + s[0])
                        : 32 > i
                          ? b + (((u & d) | (~u & f)) + s[1])
                          : 48 > i
                            ? b + (((u | ~d) ^ f) + s[2])
                            : 64 > i
                              ? b + (((u & f) | (d & ~f)) + s[3])
                              : b + ((u ^ (d | ~f)) + s[4])),
                    (b = ((b = ((b |= 0) << E[i]) | (b >>> (32 - E[i]))) + p) | 0),
                    (c = p),
                    (p = f),
                    (f = (d << 10) | (d >>> 22)),
                    (d = u),
                    (u = b),
                    (b = (m + t[e + C[i]]) | 0),
                    (b =
                      16 > i
                        ? b + ((g ^ (y | ~x)) + S[0])
                        : 32 > i
                          ? b + (((g & x) | (y & ~x)) + S[1])
                          : 48 > i
                            ? b + (((g | ~y) ^ x) + S[2])
                            : 64 > i
                              ? b + (((g & y) | (~g & x)) + S[3])
                              : b + ((g ^ y ^ x) + S[4])),
                    (b = ((b = ((b |= 0) << D[i]) | (b >>> (32 - D[i]))) + v) | 0),
                    (m = v),
                    (v = x),
                    (x = (y << 10) | (y >>> 22)),
                    (y = g),
                    (g = b));
                ((b = (w[1] + d + x) | 0),
                  (w[1] = (w[2] + f + v) | 0),
                  (w[2] = (w[3] + p + m) | 0),
                  (w[3] = (w[4] + c + g) | 0),
                  (w[4] = (w[0] + u + y) | 0),
                  (w[0] = b));
              },
              _doFinalize: function () {
                var t = this._data,
                  e = t.words,
                  i = 8 * this._nDataBytes,
                  s = 8 * t.sigBytes;
                for (
                  e[s >>> 5] |= 128 << (24 - (s % 32)),
                    e[14 + (((s + 64) >>> 9) << 4)] =
                      (16711935 & ((i << 8) | (i >>> 24))) | (4278255360 & ((i << 24) | (i >>> 8))),
                    t.sigBytes = 4 * (e.length + 1),
                    this._process(),
                    e = (t = this._hash).words,
                    i = 0;
                  5 > i;
                  i++
                )
                  ((s = e[i]), (e[i] = (16711935 & ((s << 8) | (s >>> 24))) | (4278255360 & ((s << 24) | (s >>> 8)))));
                return t;
              },
              clone: function () {
                var t = i.clone.call(this);
                return ((t._hash = this._hash.clone()), t);
              },
            })),
            (t.RIPEMD160 = i._createHelper(s)),
            (t.HmacRIPEMD160 = i._createHmacHelper(s)));
        })(),
        (function () {
          var t = d,
            e = t.enc.Utf8;
          t.algo.HMAC = t.lib.Base.extend({
            init: function (t, i) {
              ((t = this._hasher = new t.init()), 'string' == typeof i && (i = e.parse(i)));
              var s = t.blockSize,
                n = 4 * s;
              (i.sigBytes > n && (i = t.finalize(i)), i.clamp());
              for (
                var r = (this._oKey = i.clone()), a = (this._iKey = i.clone()), o = r.words, h = a.words, l = 0;
                l < s;
                l++
              )
                ((o[l] ^= 1549556828), (h[l] ^= 909522486));
              ((r.sigBytes = a.sigBytes = n), this.reset());
            },
            reset: function () {
              var t = this._hasher;
              (t.reset(), t.update(this._iKey));
            },
            update: function (t) {
              return (this._hasher.update(t), this);
            },
            finalize: function (t) {
              var e = this._hasher;
              return ((t = e.finalize(t)), e.reset(), e.finalize(this._oKey.clone().concat(t)));
            },
          });
        })(),
        (function () {
          var t,
            e = d,
            i = (t = e.lib).Base,
            s = t.WordArray,
            n = (t = e.algo).HMAC,
            r = (t.PBKDF2 = i.extend({
              cfg: i.extend({ keySize: 4, hasher: t.SHA1, iterations: 1 }),
              init: function (t) {
                this.cfg = this.cfg.extend(t);
              },
              compute: function (t, e) {
                var i = this.cfg,
                  r = n.create(i.hasher, t),
                  a = s.create(),
                  o = s.create([1]),
                  h = a.words,
                  l = o.words,
                  c = i.keySize;
                for (i = i.iterations; h.length < c; ) {
                  var u = r.update(e).finalize(o);
                  r.reset();
                  for (var d = u.words, f = d.length, p = u, m = 1; m < i; m++) {
                    ((p = r.finalize(p)), r.reset());
                    for (var g = p.words, y = 0; y < f; y++) d[y] ^= g[y];
                  }
                  (a.concat(u), l[0]++);
                }
                return ((a.sigBytes = 4 * c), a);
              },
            }));
          e.PBKDF2 = function (t, e, i) {
            return r.create(i).compute(t, e);
          };
        })());
      var f,
        p = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      function m(t) {
        var e,
          i,
          s = '';
        for (e = 0; e + 3 <= t.length; e += 3)
          ((i = parseInt(t.substring(e, e + 3), 16)), (s += p.charAt(i >> 6) + p.charAt(63 & i)));
        for (
          e + 1 == t.length
            ? ((i = parseInt(t.substring(e, e + 1), 16)), (s += p.charAt(i << 2)))
            : e + 2 == t.length &&
              ((i = parseInt(t.substring(e, e + 2), 16)), (s += p.charAt(i >> 2) + p.charAt((3 & i) << 4)));
          (3 & s.length) > 0;

        )
          s += '=';
        return s;
      }
      function g(t) {
        var e,
          i,
          s,
          n = '',
          r = 0;
        for (e = 0; e < t.length && '=' != t.charAt(e); ++e)
          (s = p.indexOf(t.charAt(e))) < 0 ||
            (0 == r
              ? ((n += M(s >> 2)), (i = 3 & s), (r = 1))
              : 1 == r
                ? ((n += M((i << 2) | (s >> 4))), (i = 15 & s), (r = 2))
                : 2 == r
                  ? ((n += M(i)), (n += M(s >> 2)), (i = 3 & s), (r = 3))
                  : ((n += M((i << 2) | (s >> 4))), (n += M(15 & s)), (r = 0)));
        return (1 == r && (n += M(i << 2)), n);
      }
      function y(t) {
        var e,
          i = g(t),
          s = new Array();
        for (e = 0; 2 * e < i.length; ++e) s[e] = parseInt(i.substring(2 * e, 2 * e + 2), 16);
        return s;
      }
      function x(t, e, i) {
        null != t &&
          ('number' == typeof t
            ? this.fromNumber(t, e, i)
            : null == e && 'string' != typeof t
              ? this.fromString(t, 256)
              : this.fromString(t, e));
      }
      function v() {
        return new x(null);
      }
      ('Microsoft Internet Explorer' == c.appName
        ? ((x.prototype.am = function (t, e, i, s, n, r) {
            for (var a = 32767 & e, o = e >> 15; --r >= 0; ) {
              var h = 32767 & this[t],
                l = this[t++] >> 15,
                c = o * h + l * a;
              ((n =
                ((h = a * h + ((32767 & c) << 15) + i[s] + (1073741823 & n)) >>> 30) + (c >>> 15) + o * l + (n >>> 30)),
                (i[s++] = 1073741823 & h));
            }
            return n;
          }),
          (f = 30))
        : 'Netscape' != c.appName
          ? ((x.prototype.am = function (t, e, i, s, n, r) {
              for (; --r >= 0; ) {
                var a = e * this[t++] + i[s] + n;
                ((n = Math.floor(a / 67108864)), (i[s++] = 67108863 & a));
              }
              return n;
            }),
            (f = 26))
          : ((x.prototype.am = function (t, e, i, s, n, r) {
              for (var a = 16383 & e, o = e >> 14; --r >= 0; ) {
                var h = 16383 & this[t],
                  l = this[t++] >> 14,
                  c = o * h + l * a;
                ((n = ((h = a * h + ((16383 & c) << 14) + i[s] + n) >> 28) + (c >> 14) + o * l),
                  (i[s++] = 268435455 & h));
              }
              return n;
            }),
            (f = 28)),
        (x.prototype.DB = f),
        (x.prototype.DM = (1 << f) - 1),
        (x.prototype.DV = 1 << f),
        (x.prototype.FV = Math.pow(2, 52)),
        (x.prototype.F1 = 52 - f),
        (x.prototype.F2 = 2 * f - 52));
      var b,
        w,
        S = new Array();
      for (b = '0'.charCodeAt(0), w = 0; w <= 9; ++w) S[b++] = w;
      for (b = 'a'.charCodeAt(0), w = 10; w < 36; ++w) S[b++] = w;
      for (b = 'A'.charCodeAt(0), w = 10; w < 36; ++w) S[b++] = w;
      function M(t) {
        return '0123456789abcdefghijklmnopqrstuvwxyz'.charAt(t);
      }
      function C(t, e) {
        var i = S[t.charCodeAt(e)];
        return null == i ? -1 : i;
      }
      function E(t) {
        var e = v();
        return (e.fromInt(t), e);
      }
      function D(t) {
        var e,
          i = 1;
        return (
          0 != (e = t >>> 16) && ((t = e), (i += 16)),
          0 != (e = t >> 8) && ((t = e), (i += 8)),
          0 != (e = t >> 4) && ((t = e), (i += 4)),
          0 != (e = t >> 2) && ((t = e), (i += 2)),
          0 != (e = t >> 1) && ((t = e), (i += 1)),
          i
        );
      }
      function A(t) {
        this.m = t;
      }
      function F(t) {
        ((this.m = t),
          (this.mp = t.invDigit()),
          (this.mpl = 32767 & this.mp),
          (this.mph = this.mp >> 15),
          (this.um = (1 << (t.DB - 15)) - 1),
          (this.mt2 = 2 * t.t));
      }
      function P(t, e) {
        return t & e;
      }
      function T(t, e) {
        return t | e;
      }
      function I(t, e) {
        return t ^ e;
      }
      function _(t, e) {
        return t & ~e;
      }
      function R(t) {
        if (0 == t) return -1;
        var e = 0;
        return (
          65535 & t || ((t >>= 16), (e += 16)),
          255 & t || ((t >>= 8), (e += 8)),
          15 & t || ((t >>= 4), (e += 4)),
          3 & t || ((t >>= 2), (e += 2)),
          1 & t || ++e,
          e
        );
      }
      function N(t) {
        for (var e = 0; 0 != t; ) ((t &= t - 1), ++e);
        return e;
      }
      function B() {}
      function k(t) {
        return t;
      }
      function z(t) {
        ((this.r2 = v()),
          (this.q3 = v()),
          x.ONE.dlShiftTo(2 * t.t, this.r2),
          (this.mu = this.r2.divide(t)),
          (this.m = t));
      }
      ((A.prototype.convert = function (t) {
        return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
      }),
        (A.prototype.revert = function (t) {
          return t;
        }),
        (A.prototype.reduce = function (t) {
          t.divRemTo(this.m, null, t);
        }),
        (A.prototype.mulTo = function (t, e, i) {
          (t.multiplyTo(e, i), this.reduce(i));
        }),
        (A.prototype.sqrTo = function (t, e) {
          (t.squareTo(e), this.reduce(e));
        }),
        (F.prototype.convert = function (t) {
          var e = v();
          return (
            t.abs().dlShiftTo(this.m.t, e),
            e.divRemTo(this.m, null, e),
            t.s < 0 && e.compareTo(x.ZERO) > 0 && this.m.subTo(e, e),
            e
          );
        }),
        (F.prototype.revert = function (t) {
          var e = v();
          return (t.copyTo(e), this.reduce(e), e);
        }),
        (F.prototype.reduce = function (t) {
          for (; t.t <= this.mt2; ) t[t.t++] = 0;
          for (var e = 0; e < this.m.t; ++e) {
            var i = 32767 & t[e],
              s = (i * this.mpl + (((i * this.mph + (t[e] >> 15) * this.mpl) & this.um) << 15)) & t.DM;
            for (t[(i = e + this.m.t)] += this.m.am(0, s, t, e, 0, this.m.t); t[i] >= t.DV; )
              ((t[i] -= t.DV), t[++i]++);
          }
          (t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t));
        }),
        (F.prototype.mulTo = function (t, e, i) {
          (t.multiplyTo(e, i), this.reduce(i));
        }),
        (F.prototype.sqrTo = function (t, e) {
          (t.squareTo(e), this.reduce(e));
        }),
        (x.prototype.copyTo = function (t) {
          for (var e = this.t - 1; e >= 0; --e) t[e] = this[e];
          ((t.t = this.t), (t.s = this.s));
        }),
        (x.prototype.fromInt = function (t) {
          ((this.t = 1),
            (this.s = t < 0 ? -1 : 0),
            t > 0 ? (this[0] = t) : t < -1 ? (this[0] = t + this.DV) : (this.t = 0));
        }),
        (x.prototype.fromString = function (t, e) {
          var i;
          if (16 == e) i = 4;
          else if (8 == e) i = 3;
          else if (256 == e) i = 8;
          else if (2 == e) i = 1;
          else if (32 == e) i = 5;
          else {
            if (4 != e) return void this.fromRadix(t, e);
            i = 2;
          }
          ((this.t = 0), (this.s = 0));
          for (var s = t.length, n = !1, r = 0; --s >= 0; ) {
            var a = 8 == i ? 255 & t[s] : C(t, s);
            a < 0
              ? '-' == t.charAt(s) && (n = !0)
              : ((n = !1),
                0 == r
                  ? (this[this.t++] = a)
                  : r + i > this.DB
                    ? ((this[this.t - 1] |= (a & ((1 << (this.DB - r)) - 1)) << r),
                      (this[this.t++] = a >> (this.DB - r)))
                    : (this[this.t - 1] |= a << r),
                (r += i) >= this.DB && (r -= this.DB));
          }
          (8 == i && 128 & t[0] && ((this.s = -1), r > 0 && (this[this.t - 1] |= ((1 << (this.DB - r)) - 1) << r)),
            this.clamp(),
            n && x.ZERO.subTo(this, this));
        }),
        (x.prototype.clamp = function () {
          for (var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t; ) --this.t;
        }),
        (x.prototype.dlShiftTo = function (t, e) {
          var i;
          for (i = this.t - 1; i >= 0; --i) e[i + t] = this[i];
          for (i = t - 1; i >= 0; --i) e[i] = 0;
          ((e.t = this.t + t), (e.s = this.s));
        }),
        (x.prototype.drShiftTo = function (t, e) {
          for (var i = t; i < this.t; ++i) e[i - t] = this[i];
          ((e.t = Math.max(this.t - t, 0)), (e.s = this.s));
        }),
        (x.prototype.lShiftTo = function (t, e) {
          var i,
            s = t % this.DB,
            n = this.DB - s,
            r = (1 << n) - 1,
            a = Math.floor(t / this.DB),
            o = (this.s << s) & this.DM;
          for (i = this.t - 1; i >= 0; --i) ((e[i + a + 1] = (this[i] >> n) | o), (o = (this[i] & r) << s));
          for (i = a - 1; i >= 0; --i) e[i] = 0;
          ((e[a] = o), (e.t = this.t + a + 1), (e.s = this.s), e.clamp());
        }),
        (x.prototype.rShiftTo = function (t, e) {
          e.s = this.s;
          var i = Math.floor(t / this.DB);
          if (i >= this.t) e.t = 0;
          else {
            var s = t % this.DB,
              n = this.DB - s,
              r = (1 << s) - 1;
            e[0] = this[i] >> s;
            for (var a = i + 1; a < this.t; ++a) ((e[a - i - 1] |= (this[a] & r) << n), (e[a - i] = this[a] >> s));
            (s > 0 && (e[this.t - i - 1] |= (this.s & r) << n), (e.t = this.t - i), e.clamp());
          }
        }),
        (x.prototype.subTo = function (t, e) {
          for (var i = 0, s = 0, n = Math.min(t.t, this.t); i < n; )
            ((s += this[i] - t[i]), (e[i++] = s & this.DM), (s >>= this.DB));
          if (t.t < this.t) {
            for (s -= t.s; i < this.t; ) ((s += this[i]), (e[i++] = s & this.DM), (s >>= this.DB));
            s += this.s;
          } else {
            for (s += this.s; i < t.t; ) ((s -= t[i]), (e[i++] = s & this.DM), (s >>= this.DB));
            s -= t.s;
          }
          ((e.s = s < 0 ? -1 : 0), s < -1 ? (e[i++] = this.DV + s) : s > 0 && (e[i++] = s), (e.t = i), e.clamp());
        }),
        (x.prototype.multiplyTo = function (t, e) {
          var i = this.abs(),
            s = t.abs(),
            n = i.t;
          for (e.t = n + s.t; --n >= 0; ) e[n] = 0;
          for (n = 0; n < s.t; ++n) e[n + i.t] = i.am(0, s[n], e, n, 0, i.t);
          ((e.s = 0), e.clamp(), this.s != t.s && x.ZERO.subTo(e, e));
        }),
        (x.prototype.squareTo = function (t) {
          for (var e = this.abs(), i = (t.t = 2 * e.t); --i >= 0; ) t[i] = 0;
          for (i = 0; i < e.t - 1; ++i) {
            var s = e.am(i, e[i], t, 2 * i, 0, 1);
            (t[i + e.t] += e.am(i + 1, 2 * e[i], t, 2 * i + 1, s, e.t - i - 1)) >= e.DV &&
              ((t[i + e.t] -= e.DV), (t[i + e.t + 1] = 1));
          }
          (t.t > 0 && (t[t.t - 1] += e.am(i, e[i], t, 2 * i, 0, 1)), (t.s = 0), t.clamp());
        }),
        (x.prototype.divRemTo = function (t, e, i) {
          var s = t.abs();
          if (!(s.t <= 0)) {
            var n = this.abs();
            if (n.t < s.t) return (null != e && e.fromInt(0), void (null != i && this.copyTo(i)));
            null == i && (i = v());
            var r = v(),
              a = this.s,
              o = t.s,
              h = this.DB - D(s[s.t - 1]);
            h > 0 ? (s.lShiftTo(h, r), n.lShiftTo(h, i)) : (s.copyTo(r), n.copyTo(i));
            var l = r.t,
              c = r[l - 1];
            if (0 != c) {
              var u = c * (1 << this.F1) + (l > 1 ? r[l - 2] >> this.F2 : 0),
                d = this.FV / u,
                f = (1 << this.F1) / u,
                p = 1 << this.F2,
                m = i.t,
                g = m - l,
                y = null == e ? v() : e;
              for (
                r.dlShiftTo(g, y),
                  i.compareTo(y) >= 0 && ((i[i.t++] = 1), i.subTo(y, i)),
                  x.ONE.dlShiftTo(l, y),
                  y.subTo(r, r);
                r.t < l;

              )
                r[r.t++] = 0;
              for (; --g >= 0; ) {
                var b = i[--m] == c ? this.DM : Math.floor(i[m] * d + (i[m - 1] + p) * f);
                if ((i[m] += r.am(0, b, i, g, 0, l)) < b)
                  for (r.dlShiftTo(g, y), i.subTo(y, i); i[m] < --b; ) i.subTo(y, i);
              }
              (null != e && (i.drShiftTo(l, e), a != o && x.ZERO.subTo(e, e)),
                (i.t = l),
                i.clamp(),
                h > 0 && i.rShiftTo(h, i),
                a < 0 && x.ZERO.subTo(i, i));
            }
          }
        }),
        (x.prototype.invDigit = function () {
          if (this.t < 1) return 0;
          var t = this[0];
          if (!(1 & t)) return 0;
          var e = 3 & t;
          return (e =
            ((e =
              ((e = ((e = (e * (2 - (15 & t) * e)) & 15) * (2 - (255 & t) * e)) & 255) *
                (2 - (((65535 & t) * e) & 65535))) &
              65535) *
              (2 - ((t * e) % this.DV))) %
            this.DV) > 0
            ? this.DV - e
            : -e;
        }),
        (x.prototype.isEven = function () {
          return 0 == (this.t > 0 ? 1 & this[0] : this.s);
        }),
        (x.prototype.exp = function (t, e) {
          if (t > 4294967295 || t < 1) return x.ONE;
          var i = v(),
            s = v(),
            n = e.convert(this),
            r = D(t) - 1;
          for (n.copyTo(i); --r >= 0; )
            if ((e.sqrTo(i, s), (t & (1 << r)) > 0)) e.mulTo(s, n, i);
            else {
              var a = i;
              ((i = s), (s = a));
            }
          return e.revert(i);
        }),
        (x.prototype.toString = function (t) {
          if (this.s < 0) return '-' + this.negate().toString(t);
          var e;
          if (16 == t) e = 4;
          else if (8 == t) e = 3;
          else if (2 == t) e = 1;
          else if (32 == t) e = 5;
          else {
            if (4 != t) return this.toRadix(t);
            e = 2;
          }
          var i,
            s = (1 << e) - 1,
            n = !1,
            r = '',
            a = this.t,
            o = this.DB - ((a * this.DB) % e);
          if (a-- > 0)
            for (o < this.DB && (i = this[a] >> o) > 0 && ((n = !0), (r = M(i))); a >= 0; )
              (o < e
                ? ((i = (this[a] & ((1 << o) - 1)) << (e - o)), (i |= this[--a] >> (o += this.DB - e)))
                : ((i = (this[a] >> (o -= e)) & s), o <= 0 && ((o += this.DB), --a)),
                i > 0 && (n = !0),
                n && (r += M(i)));
          return n ? r : '0';
        }),
        (x.prototype.negate = function () {
          var t = v();
          return (x.ZERO.subTo(this, t), t);
        }),
        (x.prototype.abs = function () {
          return this.s < 0 ? this.negate() : this;
        }),
        (x.prototype.compareTo = function (t) {
          var e = this.s - t.s;
          if (0 != e) return e;
          var i = this.t;
          if (0 != (e = i - t.t)) return this.s < 0 ? -e : e;
          for (; --i >= 0; ) if (0 != (e = this[i] - t[i])) return e;
          return 0;
        }),
        (x.prototype.bitLength = function () {
          return this.t <= 0 ? 0 : this.DB * (this.t - 1) + D(this[this.t - 1] ^ (this.s & this.DM));
        }),
        (x.prototype.mod = function (t) {
          var e = v();
          return (this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(x.ZERO) > 0 && t.subTo(e, e), e);
        }),
        (x.prototype.modPowInt = function (t, e) {
          var i;
          return ((i = t < 256 || e.isEven() ? new A(e) : new F(e)), this.exp(t, i));
        }),
        (x.ZERO = E(0)),
        (x.ONE = E(1)),
        (B.prototype.convert = k),
        (B.prototype.revert = k),
        (B.prototype.mulTo = function (t, e, i) {
          t.multiplyTo(e, i);
        }),
        (B.prototype.sqrTo = function (t, e) {
          t.squareTo(e);
        }),
        (z.prototype.convert = function (t) {
          if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
          if (t.compareTo(this.m) < 0) return t;
          var e = v();
          return (t.copyTo(e), this.reduce(e), e);
        }),
        (z.prototype.revert = function (t) {
          return t;
        }),
        (z.prototype.reduce = function (t) {
          for (
            t.drShiftTo(this.m.t - 1, this.r2),
              t.t > this.m.t + 1 && ((t.t = this.m.t + 1), t.clamp()),
              this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3),
              this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
            t.compareTo(this.r2) < 0;

          )
            t.dAddOffset(1, this.m.t + 1);
          for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0; ) t.subTo(this.m, t);
        }),
        (z.prototype.mulTo = function (t, e, i) {
          (t.multiplyTo(e, i), this.reduce(i));
        }),
        (z.prototype.sqrTo = function (t, e) {
          (t.squareTo(e), this.reduce(e));
        }));
      var L,
        O,
        H,
        j,
        q,
        V,
        U,
        K = [
          2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107,
          109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229,
          233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359,
          367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491,
          499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641,
          643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787,
          797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941,
          947, 953, 967, 971, 977, 983, 991, 997,
        ],
        G = (1 << 26) / K[K.length - 1];
      function W() {
        ((this.i = 0), (this.j = 0), (this.S = new Array()));
      }
      function Q() {
        !(function (t) {
          ((O[H++] ^= 255 & t),
            (O[H++] ^= (t >> 8) & 255),
            (O[H++] ^= (t >> 16) & 255),
            (O[H++] ^= (t >> 24) & 255),
            H >= 256 && (H -= 256));
        })(new Date().getTime());
      }
      if (
        ((x.prototype.chunkSize = function (t) {
          return Math.floor((Math.LN2 * this.DB) / Math.log(t));
        }),
        (x.prototype.toRadix = function (t) {
          if ((null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36)) return '0';
          var e = this.chunkSize(t),
            i = Math.pow(t, e),
            s = E(i),
            n = v(),
            r = v(),
            a = '';
          for (this.divRemTo(s, n, r); n.signum() > 0; )
            ((a = (i + r.intValue()).toString(t).substr(1) + a), n.divRemTo(s, n, r));
          return r.intValue().toString(t) + a;
        }),
        (x.prototype.fromRadix = function (t, e) {
          (this.fromInt(0), null == e && (e = 10));
          for (var i = this.chunkSize(e), s = Math.pow(e, i), n = !1, r = 0, a = 0, o = 0; o < t.length; ++o) {
            var h = C(t, o);
            h < 0
              ? '-' == t.charAt(o) && 0 == this.signum() && (n = !0)
              : ((a = e * a + h), ++r >= i && (this.dMultiply(s), this.dAddOffset(a, 0), (r = 0), (a = 0)));
          }
          (r > 0 && (this.dMultiply(Math.pow(e, r)), this.dAddOffset(a, 0)), n && x.ZERO.subTo(this, this));
        }),
        (x.prototype.fromNumber = function (t, e, i) {
          if ('number' == typeof e)
            if (t < 2) this.fromInt(1);
            else
              for (
                this.fromNumber(t, i),
                  this.testBit(t - 1) || this.bitwiseTo(x.ONE.shiftLeft(t - 1), T, this),
                  this.isEven() && this.dAddOffset(1, 0);
                !this.isProbablePrime(e);

              )
                (this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(x.ONE.shiftLeft(t - 1), this));
          else {
            var s = new Array(),
              n = 7 & t;
            ((s.length = 1 + (t >> 3)),
              e.nextBytes(s),
              n > 0 ? (s[0] &= (1 << n) - 1) : (s[0] = 0),
              this.fromString(s, 256));
          }
        }),
        (x.prototype.bitwiseTo = function (t, e, i) {
          var s,
            n,
            r = Math.min(t.t, this.t);
          for (s = 0; s < r; ++s) i[s] = e(this[s], t[s]);
          if (t.t < this.t) {
            for (n = t.s & this.DM, s = r; s < this.t; ++s) i[s] = e(this[s], n);
            i.t = this.t;
          } else {
            for (n = this.s & this.DM, s = r; s < t.t; ++s) i[s] = e(n, t[s]);
            i.t = t.t;
          }
          ((i.s = e(this.s, t.s)), i.clamp());
        }),
        (x.prototype.changeBit = function (t, e) {
          var i = x.ONE.shiftLeft(t);
          return (this.bitwiseTo(i, e, i), i);
        }),
        (x.prototype.addTo = function (t, e) {
          for (var i = 0, s = 0, n = Math.min(t.t, this.t); i < n; )
            ((s += this[i] + t[i]), (e[i++] = s & this.DM), (s >>= this.DB));
          if (t.t < this.t) {
            for (s += t.s; i < this.t; ) ((s += this[i]), (e[i++] = s & this.DM), (s >>= this.DB));
            s += this.s;
          } else {
            for (s += this.s; i < t.t; ) ((s += t[i]), (e[i++] = s & this.DM), (s >>= this.DB));
            s += t.s;
          }
          ((e.s = s < 0 ? -1 : 0), s > 0 ? (e[i++] = s) : s < -1 && (e[i++] = this.DV + s), (e.t = i), e.clamp());
        }),
        (x.prototype.dMultiply = function (t) {
          ((this[this.t] = this.am(0, t - 1, this, 0, 0, this.t)), ++this.t, this.clamp());
        }),
        (x.prototype.dAddOffset = function (t, e) {
          if (0 != t) {
            for (; this.t <= e; ) this[this.t++] = 0;
            for (this[e] += t; this[e] >= this.DV; )
              ((this[e] -= this.DV), ++e >= this.t && (this[this.t++] = 0), ++this[e]);
          }
        }),
        (x.prototype.multiplyLowerTo = function (t, e, i) {
          var s,
            n = Math.min(this.t + t.t, e);
          for (i.s = 0, i.t = n; n > 0; ) i[--n] = 0;
          for (s = i.t - this.t; n < s; ++n) i[n + this.t] = this.am(0, t[n], i, n, 0, this.t);
          for (s = Math.min(t.t, e); n < s; ++n) this.am(0, t[n], i, n, 0, e - n);
          i.clamp();
        }),
        (x.prototype.multiplyUpperTo = function (t, e, i) {
          --e;
          var s = (i.t = this.t + t.t - e);
          for (i.s = 0; --s >= 0; ) i[s] = 0;
          for (s = Math.max(e - this.t, 0); s < t.t; ++s)
            i[this.t + s - e] = this.am(e - s, t[s], i, 0, 0, this.t + s - e);
          (i.clamp(), i.drShiftTo(1, i));
        }),
        (x.prototype.modInt = function (t) {
          if (t <= 0) return 0;
          var e = this.DV % t,
            i = this.s < 0 ? t - 1 : 0;
          if (this.t > 0)
            if (0 == e) i = this[0] % t;
            else for (var s = this.t - 1; s >= 0; --s) i = (e * i + this[s]) % t;
          return i;
        }),
        (x.prototype.millerRabin = function (t) {
          var e = this.subtract(x.ONE),
            i = e.getLowestSetBit();
          if (i <= 0) return !1;
          var s = e.shiftRight(i);
          (t = (t + 1) >> 1) > K.length && (t = K.length);
          for (var n = v(), r = 0; r < t; ++r) {
            n.fromInt(K[Math.floor(Math.random() * K.length)]);
            var a = n.modPow(s, this);
            if (0 != a.compareTo(x.ONE) && 0 != a.compareTo(e)) {
              for (var o = 1; o++ < i && 0 != a.compareTo(e); )
                if (0 == (a = a.modPowInt(2, this)).compareTo(x.ONE)) return !1;
              if (0 != a.compareTo(e)) return !1;
            }
          }
          return !0;
        }),
        (x.prototype.clone = function () {
          var t = v();
          return (this.copyTo(t), t);
        }),
        (x.prototype.intValue = function () {
          if (this.s < 0) {
            if (1 == this.t) return this[0] - this.DV;
            if (0 == this.t) return -1;
          } else {
            if (1 == this.t) return this[0];
            if (0 == this.t) return 0;
          }
          return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
        }),
        (x.prototype.byteValue = function () {
          return 0 == this.t ? this.s : (this[0] << 24) >> 24;
        }),
        (x.prototype.shortValue = function () {
          return 0 == this.t ? this.s : (this[0] << 16) >> 16;
        }),
        (x.prototype.signum = function () {
          return this.s < 0 ? -1 : this.t <= 0 || (1 == this.t && this[0] <= 0) ? 0 : 1;
        }),
        (x.prototype.toByteArray = function () {
          var t = this.t,
            e = new Array();
          e[0] = this.s;
          var i,
            s = this.DB - ((t * this.DB) % 8),
            n = 0;
          if (t-- > 0)
            for (
              s < this.DB && (i = this[t] >> s) != (this.s & this.DM) >> s && (e[n++] = i | (this.s << (this.DB - s)));
              t >= 0;

            )
              (s < 8
                ? ((i = (this[t] & ((1 << s) - 1)) << (8 - s)), (i |= this[--t] >> (s += this.DB - 8)))
                : ((i = (this[t] >> (s -= 8)) & 255), s <= 0 && ((s += this.DB), --t)),
                128 & i && (i |= -256),
                0 == n && (128 & this.s) != (128 & i) && ++n,
                (n > 0 || i != this.s) && (e[n++] = i));
          return e;
        }),
        (x.prototype.equals = function (t) {
          return 0 == this.compareTo(t);
        }),
        (x.prototype.min = function (t) {
          return this.compareTo(t) < 0 ? this : t;
        }),
        (x.prototype.max = function (t) {
          return this.compareTo(t) > 0 ? this : t;
        }),
        (x.prototype.and = function (t) {
          var e = v();
          return (this.bitwiseTo(t, P, e), e);
        }),
        (x.prototype.or = function (t) {
          var e = v();
          return (this.bitwiseTo(t, T, e), e);
        }),
        (x.prototype.xor = function (t) {
          var e = v();
          return (this.bitwiseTo(t, I, e), e);
        }),
        (x.prototype.andNot = function (t) {
          var e = v();
          return (this.bitwiseTo(t, _, e), e);
        }),
        (x.prototype.not = function () {
          for (var t = v(), e = 0; e < this.t; ++e) t[e] = this.DM & ~this[e];
          return ((t.t = this.t), (t.s = ~this.s), t);
        }),
        (x.prototype.shiftLeft = function (t) {
          var e = v();
          return (t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e);
        }),
        (x.prototype.shiftRight = function (t) {
          var e = v();
          return (t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e);
        }),
        (x.prototype.getLowestSetBit = function () {
          for (var t = 0; t < this.t; ++t) if (0 != this[t]) return t * this.DB + R(this[t]);
          return this.s < 0 ? this.t * this.DB : -1;
        }),
        (x.prototype.bitCount = function () {
          for (var t = 0, e = this.s & this.DM, i = 0; i < this.t; ++i) t += N(this[i] ^ e);
          return t;
        }),
        (x.prototype.testBit = function (t) {
          var e = Math.floor(t / this.DB);
          return e >= this.t ? 0 != this.s : !!(this[e] & (1 << t % this.DB));
        }),
        (x.prototype.setBit = function (t) {
          return this.changeBit(t, T);
        }),
        (x.prototype.clearBit = function (t) {
          return this.changeBit(t, _);
        }),
        (x.prototype.flipBit = function (t) {
          return this.changeBit(t, I);
        }),
        (x.prototype.add = function (t) {
          var e = v();
          return (this.addTo(t, e), e);
        }),
        (x.prototype.subtract = function (t) {
          var e = v();
          return (this.subTo(t, e), e);
        }),
        (x.prototype.multiply = function (t) {
          var e = v();
          return (this.multiplyTo(t, e), e);
        }),
        (x.prototype.divide = function (t) {
          var e = v();
          return (this.divRemTo(t, e, null), e);
        }),
        (x.prototype.remainder = function (t) {
          var e = v();
          return (this.divRemTo(t, null, e), e);
        }),
        (x.prototype.divideAndRemainder = function (t) {
          var e = v(),
            i = v();
          return (this.divRemTo(t, e, i), new Array(e, i));
        }),
        (x.prototype.modPow = function (t, e) {
          var i,
            s,
            n = t.bitLength(),
            r = E(1);
          if (n <= 0) return r;
          ((i = n < 18 ? 1 : n < 48 ? 3 : n < 144 ? 4 : n < 768 ? 5 : 6),
            (s = n < 8 ? new A(e) : e.isEven() ? new z(e) : new F(e)));
          var a = new Array(),
            o = 3,
            h = i - 1,
            l = (1 << i) - 1;
          if (((a[1] = s.convert(this)), i > 1)) {
            var c = v();
            for (s.sqrTo(a[1], c); o <= l; ) ((a[o] = v()), s.mulTo(c, a[o - 2], a[o]), (o += 2));
          }
          var u,
            d,
            f = t.t - 1,
            p = !0,
            m = v();
          for (n = D(t[f]) - 1; f >= 0; ) {
            for (
              n >= h
                ? (u = (t[f] >> (n - h)) & l)
                : ((u = (t[f] & ((1 << (n + 1)) - 1)) << (h - n)), f > 0 && (u |= t[f - 1] >> (this.DB + n - h))),
                o = i;
              !(1 & u);

            )
              ((u >>= 1), --o);
            if (((n -= o) < 0 && ((n += this.DB), --f), p)) (a[u].copyTo(r), (p = !1));
            else {
              for (; o > 1; ) (s.sqrTo(r, m), s.sqrTo(m, r), (o -= 2));
              (o > 0 ? s.sqrTo(r, m) : ((d = r), (r = m), (m = d)), s.mulTo(m, a[u], r));
            }
            for (; f >= 0 && !(t[f] & (1 << n)); )
              (s.sqrTo(r, m), (d = r), (r = m), (m = d), --n < 0 && ((n = this.DB - 1), --f));
          }
          return s.revert(r);
        }),
        (x.prototype.modInverse = function (t) {
          var e = t.isEven();
          if ((this.isEven() && e) || 0 == t.signum()) return x.ZERO;
          for (var i = t.clone(), s = this.clone(), n = E(1), r = E(0), a = E(0), o = E(1); 0 != i.signum(); ) {
            for (; i.isEven(); )
              (i.rShiftTo(1, i),
                e
                  ? ((n.isEven() && r.isEven()) || (n.addTo(this, n), r.subTo(t, r)), n.rShiftTo(1, n))
                  : r.isEven() || r.subTo(t, r),
                r.rShiftTo(1, r));
            for (; s.isEven(); )
              (s.rShiftTo(1, s),
                e
                  ? ((a.isEven() && o.isEven()) || (a.addTo(this, a), o.subTo(t, o)), a.rShiftTo(1, a))
                  : o.isEven() || o.subTo(t, o),
                o.rShiftTo(1, o));
            i.compareTo(s) >= 0
              ? (i.subTo(s, i), e && n.subTo(a, n), r.subTo(o, r))
              : (s.subTo(i, s), e && a.subTo(n, a), o.subTo(r, o));
          }
          return 0 != s.compareTo(x.ONE)
            ? x.ZERO
            : o.compareTo(t) >= 0
              ? o.subtract(t)
              : o.signum() < 0
                ? (o.addTo(t, o), o.signum() < 0 ? o.add(t) : o)
                : o;
        }),
        (x.prototype.pow = function (t) {
          return this.exp(t, new B());
        }),
        (x.prototype.gcd = function (t) {
          var e = this.s < 0 ? this.negate() : this.clone(),
            i = t.s < 0 ? t.negate() : t.clone();
          if (e.compareTo(i) < 0) {
            var s = e;
            ((e = i), (i = s));
          }
          var n = e.getLowestSetBit(),
            r = i.getLowestSetBit();
          if (r < 0) return e;
          for (n < r && (r = n), r > 0 && (e.rShiftTo(r, e), i.rShiftTo(r, i)); e.signum() > 0; )
            ((n = e.getLowestSetBit()) > 0 && e.rShiftTo(n, e),
              (n = i.getLowestSetBit()) > 0 && i.rShiftTo(n, i),
              e.compareTo(i) >= 0 ? (e.subTo(i, e), e.rShiftTo(1, e)) : (i.subTo(e, i), i.rShiftTo(1, i)));
          return (r > 0 && i.lShiftTo(r, i), i);
        }),
        (x.prototype.isProbablePrime = function (t) {
          var e,
            i = this.abs();
          if (1 == i.t && i[0] <= K[K.length - 1]) {
            for (e = 0; e < K.length; ++e) if (i[0] == K[e]) return !0;
            return !1;
          }
          if (i.isEven()) return !1;
          for (e = 1; e < K.length; ) {
            for (var s = K[e], n = e + 1; n < K.length && s < G; ) s *= K[n++];
            for (s = i.modInt(s); e < n; ) if (s % K[e++] == 0) return !1;
          }
          return i.millerRabin(t);
        }),
        (x.prototype.square = function () {
          var t = v();
          return (this.squareTo(t), t);
        }),
        (W.prototype.init = function (t) {
          var e, i, s;
          for (e = 0; e < 256; ++e) this.S[e] = e;
          for (i = 0, e = 0; e < 256; ++e)
            ((i = (i + this.S[e] + t[e % t.length]) & 255), (s = this.S[e]), (this.S[e] = this.S[i]), (this.S[i] = s));
          ((this.i = 0), (this.j = 0));
        }),
        (W.prototype.next = function () {
          var t;
          return (
            (this.i = (this.i + 1) & 255),
            (this.j = (this.j + this.S[this.i]) & 255),
            (t = this.S[this.i]),
            (this.S[this.i] = this.S[this.j]),
            (this.S[this.j] = t),
            this.S[(t + this.S[this.i]) & 255]
          );
        }),
        null == O)
      ) {
        if (((O = new Array()), (H = 0), void 0 !== u && (void 0 !== u.crypto || void 0 !== u.msCrypto)))
          if ((q = u.crypto || u.msCrypto).getRandomValues)
            for (V = new Uint8Array(32), q.getRandomValues(V), j = 0; j < 32; ++j) O[H++] = V[j];
          else if ('Netscape' == c.appName && c.appVersion < '5')
            for (U = u.crypto.random(32), j = 0; j < U.length; ++j) O[H++] = 255 & U.charCodeAt(j);
        for (; H < 256; ) ((j = Math.floor(65536 * Math.random())), (O[H++] = j >>> 8), (O[H++] = 255 & j));
        ((H = 0), Q());
      }
      function X() {
        if (null == L) {
          for (Q(), (L = new W()).init(O), H = 0; H < O.length; ++H) O[H] = 0;
          H = 0;
        }
        return L.next();
      }
      function Y() {}
      function Z(t, e) {
        return new x(t, e);
      }
      function J() {
        ((this.n = null),
          (this.e = 0),
          (this.d = null),
          (this.p = null),
          (this.q = null),
          (this.dmp1 = null),
          (this.dmq1 = null),
          (this.coeff = null));
      }
      function $(t, e) {
        ((this.x = e), (this.q = t));
      }
      function tt(t, e, i, s) {
        ((this.curve = t), (this.x = e), (this.y = i), (this.z = null == s ? x.ONE : s), (this.zinv = null));
      }
      function et(t, e, i) {
        ((this.q = t),
          (this.a = this.fromBigInteger(e)),
          (this.b = this.fromBigInteger(i)),
          (this.infinity = new tt(this, null, null)));
      }
      ((Y.prototype.nextBytes = function (t) {
        var e;
        for (e = 0; e < t.length; ++e) t[e] = X();
      }),
        (J.prototype.doPublic = function (t) {
          return t.modPowInt(this.e, this.n);
        }),
        (J.prototype.setPublic = function (t, e) {
          if (((this.isPublic = !0), (this.isPrivate = !1), 'string' != typeof t)) ((this.n = t), (this.e = e));
          else {
            if (!(null != t && null != e && t.length > 0 && e.length > 0)) throw 'Invalid RSA public key';
            ((this.n = Z(t, 16)), (this.e = parseInt(e, 16)));
          }
        }),
        (J.prototype.type = 'RSA'),
        (J.prototype.doPrivate = function (t) {
          if (null == this.p || null == this.q) return t.modPow(this.d, this.n);
          for (
            var e = t.mod(this.p).modPow(this.dmp1, this.p), i = t.mod(this.q).modPow(this.dmq1, this.q);
            e.compareTo(i) < 0;

          )
            e = e.add(this.p);
          return e.subtract(i).multiply(this.coeff).mod(this.p).multiply(this.q).add(i);
        }),
        (J.prototype.setPrivate = function (t, e, i) {
          if (((this.isPrivate = !0), 'string' != typeof t)) ((this.n = t), (this.e = e), (this.d = i));
          else {
            if (!(null != t && null != e && t.length > 0 && e.length > 0)) throw 'Invalid RSA private key';
            ((this.n = Z(t, 16)), (this.e = parseInt(e, 16)), (this.d = Z(i, 16)));
          }
        }),
        (J.prototype.setPrivateEx = function (t, e, i, s, n, r, a, o) {
          if (((this.isPrivate = !0), (this.isPublic = !1), null == t)) throw 'RSASetPrivateEx N == null';
          if (null == e) throw 'RSASetPrivateEx E == null';
          if (0 == t.length) throw 'RSASetPrivateEx N.length == 0';
          if (0 == e.length) throw 'RSASetPrivateEx E.length == 0';
          if (!(null != t && null != e && t.length > 0 && e.length > 0))
            throw 'Invalid RSA private key in RSASetPrivateEx';
          ((this.n = Z(t, 16)),
            (this.e = parseInt(e, 16)),
            (this.d = Z(i, 16)),
            (this.p = Z(s, 16)),
            (this.q = Z(n, 16)),
            (this.dmp1 = Z(r, 16)),
            (this.dmq1 = Z(a, 16)),
            (this.coeff = Z(o, 16)));
        }),
        (J.prototype.generate = function (t, e) {
          var i = new Y(),
            s = t >> 1;
          this.e = parseInt(e, 16);
          for (var n = new x(e, 16), r = t / 2 - 100, a = x.ONE.shiftLeft(r); ; ) {
            for (
              ;
              (this.p = new x(t - s, 1, i)),
                0 != this.p.subtract(x.ONE).gcd(n).compareTo(x.ONE) || !this.p.isProbablePrime(10);

            );
            for (
              ;
              (this.q = new x(s, 1, i)),
                0 != this.q.subtract(x.ONE).gcd(n).compareTo(x.ONE) || !this.q.isProbablePrime(10);

            );
            if (this.p.compareTo(this.q) <= 0) {
              var o = this.p;
              ((this.p = this.q), (this.q = o));
            }
            var h = this.q.subtract(this.p).abs();
            if (!(h.bitLength() < r || h.compareTo(a) <= 0)) {
              var l = this.p.subtract(x.ONE),
                c = this.q.subtract(x.ONE),
                u = l.multiply(c);
              if (0 == u.gcd(n).compareTo(x.ONE) && ((this.n = this.p.multiply(this.q)), this.n.bitLength() == t)) {
                ((this.d = n.modInverse(u)),
                  (this.dmp1 = this.d.mod(l)),
                  (this.dmq1 = this.d.mod(c)),
                  (this.coeff = this.q.modInverse(this.p)));
                break;
              }
            }
          }
          this.isPrivate = !0;
        }),
        ($.prototype.equals = function (t) {
          return t == this || (this.q.equals(t.q) && this.x.equals(t.x));
        }),
        ($.prototype.toBigInteger = function () {
          return this.x;
        }),
        ($.prototype.negate = function () {
          return new $(this.q, this.x.negate().mod(this.q));
        }),
        ($.prototype.add = function (t) {
          return new $(this.q, this.x.add(t.toBigInteger()).mod(this.q));
        }),
        ($.prototype.subtract = function (t) {
          return new $(this.q, this.x.subtract(t.toBigInteger()).mod(this.q));
        }),
        ($.prototype.multiply = function (t) {
          return new $(this.q, this.x.multiply(t.toBigInteger()).mod(this.q));
        }),
        ($.prototype.square = function () {
          return new $(this.q, this.x.square().mod(this.q));
        }),
        ($.prototype.divide = function (t) {
          return new $(this.q, this.x.multiply(t.toBigInteger().modInverse(this.q)).mod(this.q));
        }),
        ($.prototype.sqrt = function () {
          return new $(this.q, this.x.sqrt().mod(this.q));
        }),
        (tt.prototype.getX = function () {
          return (
            null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)),
            this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q))
          );
        }),
        (tt.prototype.getY = function () {
          return (
            null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)),
            this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q))
          );
        }),
        (tt.prototype.equals = function (t) {
          return (
            t == this ||
            (this.isInfinity()
              ? t.isInfinity()
              : t.isInfinity()
                ? this.isInfinity()
                : !!t.y
                    .toBigInteger()
                    .multiply(this.z)
                    .subtract(this.y.toBigInteger().multiply(t.z))
                    .mod(this.curve.q)
                    .equals(x.ZERO) &&
                  t.x
                    .toBigInteger()
                    .multiply(this.z)
                    .subtract(this.x.toBigInteger().multiply(t.z))
                    .mod(this.curve.q)
                    .equals(x.ZERO))
          );
        }),
        (tt.prototype.isInfinity = function () {
          return (null == this.x && null == this.y) || (this.z.equals(x.ZERO) && !this.y.toBigInteger().equals(x.ZERO));
        }),
        (tt.prototype.negate = function () {
          return new tt(this.curve, this.x, this.y.negate(), this.z);
        }),
        (tt.prototype.add = function (t) {
          if (this.isInfinity()) return t;
          if (t.isInfinity()) return this;
          var e = t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q),
            i = t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q);
          if (x.ZERO.equals(i)) return x.ZERO.equals(e) ? this.twice() : this.curve.getInfinity();
          var s = new x('3'),
            n = this.x.toBigInteger(),
            r = this.y.toBigInteger();
          (t.x.toBigInteger(), t.y.toBigInteger());
          var a = i.square(),
            o = a.multiply(i),
            h = n.multiply(a),
            l = e.square().multiply(this.z),
            c = l.subtract(h.shiftLeft(1)).multiply(t.z).subtract(o).multiply(i).mod(this.curve.q),
            u = h
              .multiply(s)
              .multiply(e)
              .subtract(r.multiply(o))
              .subtract(l.multiply(e))
              .multiply(t.z)
              .add(e.multiply(o))
              .mod(this.curve.q),
            d = o.multiply(this.z).multiply(t.z).mod(this.curve.q);
          return new tt(this.curve, this.curve.fromBigInteger(c), this.curve.fromBigInteger(u), d);
        }),
        (tt.prototype.twice = function () {
          if (this.isInfinity()) return this;
          if (0 == this.y.toBigInteger().signum()) return this.curve.getInfinity();
          var t = new x('3'),
            e = this.x.toBigInteger(),
            i = this.y.toBigInteger(),
            s = i.multiply(this.z),
            n = s.multiply(i).mod(this.curve.q),
            r = this.curve.a.toBigInteger(),
            a = e.square().multiply(t);
          x.ZERO.equals(r) || (a = a.add(this.z.square().multiply(r)));
          var o = (a = a.mod(this.curve.q))
              .square()
              .subtract(e.shiftLeft(3).multiply(n))
              .shiftLeft(1)
              .multiply(s)
              .mod(this.curve.q),
            h = a
              .multiply(t)
              .multiply(e)
              .subtract(n.shiftLeft(1))
              .shiftLeft(2)
              .multiply(n)
              .subtract(a.square().multiply(a))
              .mod(this.curve.q),
            l = s.square().multiply(s).shiftLeft(3).mod(this.curve.q);
          return new tt(this.curve, this.curve.fromBigInteger(o), this.curve.fromBigInteger(h), l);
        }),
        (tt.prototype.multiply = function (t) {
          if (this.isInfinity()) return this;
          if (0 == t.signum()) return this.curve.getInfinity();
          var e,
            i = t,
            s = i.multiply(new x('3')),
            n = this.negate(),
            r = this,
            a = this.curve.q.subtract(t),
            o = a.multiply(new x('3')),
            h = new tt(this.curve, this.x, this.y),
            l = h.negate();
          for (e = s.bitLength() - 2; e > 0; --e) {
            r = r.twice();
            var c = s.testBit(e);
            c != i.testBit(e) && (r = r.add(c ? this : n));
          }
          for (e = o.bitLength() - 2; e > 0; --e) {
            h = h.twice();
            var u = o.testBit(e);
            u != a.testBit(e) && (h = h.add(u ? h : l));
          }
          return r;
        }),
        (tt.prototype.multiplyTwo = function (t, e, i) {
          var s;
          s = t.bitLength() > i.bitLength() ? t.bitLength() - 1 : i.bitLength() - 1;
          for (var n = this.curve.getInfinity(), r = this.add(e); s >= 0; )
            ((n = n.twice()),
              t.testBit(s) ? (n = i.testBit(s) ? n.add(r) : n.add(this)) : i.testBit(s) && (n = n.add(e)),
              --s);
          return n;
        }),
        (et.prototype.getQ = function () {
          return this.q;
        }),
        (et.prototype.getA = function () {
          return this.a;
        }),
        (et.prototype.getB = function () {
          return this.b;
        }),
        (et.prototype.equals = function (t) {
          return t == this || (this.q.equals(t.q) && this.a.equals(t.a) && this.b.equals(t.b));
        }),
        (et.prototype.getInfinity = function () {
          return this.infinity;
        }),
        (et.prototype.fromBigInteger = function (t) {
          return new $(this.q, t);
        }),
        (et.prototype.decodePointHex = function (t) {
          switch (parseInt(t.substr(0, 2), 16)) {
            case 0:
              return this.infinity;
            case 2:
            case 3:
              var e = t.substr(0, 2);
              t.substr(2);
              var i = this.fromBigInteger(new x(o, 16)),
                s = this.getA(),
                n = this.getB(),
                r = i.square().add(s).multiply(i).add(n).sqrt();
              return ('03' == e && (r = r.negate()), new tt(this, i, r));
            case 4:
            case 6:
            case 7:
              var a = (t.length - 2) / 2,
                o = t.substr(2, a),
                h = t.substr(a + 2, a);
              return new tt(this, this.fromBigInteger(new x(o, 16)), this.fromBigInteger(new x(h, 16)));
            default:
              return null;
          }
        }),
        ($.prototype.getByteLength = function () {
          return Math.floor((this.toBigInteger().bitLength() + 7) / 8);
        }),
        (tt.prototype.getEncoded = function (t) {
          var e = function (t, e) {
              var i = t.toByteArrayUnsigned();
              if (e < i.length) i = i.slice(i.length - e);
              else for (; e > i.length; ) i.unshift(0);
              return i;
            },
            i = this.getX().toBigInteger(),
            s = this.getY().toBigInteger(),
            n = e(i, 32);
          return (t ? (s.isEven() ? n.unshift(2) : n.unshift(3)) : (n.unshift(4), (n = n.concat(e(s, 32)))), n);
        }),
        (tt.decodeFrom = function (t, e) {
          e[0];
          var i = e.length - 1,
            s = e.slice(1, 1 + i / 2),
            n = e.slice(1 + i / 2, 1 + i);
          (s.unshift(0), n.unshift(0));
          var r = new x(s),
            a = new x(n);
          return new tt(t, t.fromBigInteger(r), t.fromBigInteger(a));
        }),
        (tt.decodeFromHex = function (t, e) {
          e.substr(0, 2);
          var i = e.length - 2,
            s = e.substr(2, i / 2),
            n = e.substr(2 + i / 2, i / 2),
            r = new x(s, 16),
            a = new x(n, 16);
          return new tt(t, t.fromBigInteger(r), t.fromBigInteger(a));
        }),
        (tt.prototype.add2D = function (t) {
          if (this.isInfinity()) return t;
          if (t.isInfinity()) return this;
          if (this.x.equals(t.x)) return this.y.equals(t.y) ? this.twice() : this.curve.getInfinity();
          var e = t.x.subtract(this.x),
            i = t.y.subtract(this.y).divide(e),
            s = i.square().subtract(this.x).subtract(t.x),
            n = i.multiply(this.x.subtract(s)).subtract(this.y);
          return new tt(this.curve, s, n);
        }),
        (tt.prototype.twice2D = function () {
          if (this.isInfinity()) return this;
          if (0 == this.y.toBigInteger().signum()) return this.curve.getInfinity();
          var t = this.curve.fromBigInteger(x.valueOf(2)),
            e = this.curve.fromBigInteger(x.valueOf(3)),
            i = this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(t)),
            s = i.square().subtract(this.x.multiply(t)),
            n = i.multiply(this.x.subtract(s)).subtract(this.y);
          return new tt(this.curve, s, n);
        }),
        (tt.prototype.multiply2D = function (t) {
          if (this.isInfinity()) return this;
          if (0 == t.signum()) return this.curve.getInfinity();
          var e,
            i = t,
            s = i.multiply(new x('3')),
            n = this.negate(),
            r = this;
          for (e = s.bitLength() - 2; e > 0; --e) {
            r = r.twice();
            var a = s.testBit(e);
            a != i.testBit(e) && (r = r.add2D(a ? this : n));
          }
          return r;
        }),
        (tt.prototype.isOnCurve = function () {
          var t = this.getX().toBigInteger(),
            e = this.getY().toBigInteger(),
            i = this.curve.getA().toBigInteger(),
            s = this.curve.getB().toBigInteger(),
            n = this.curve.getQ(),
            r = e.multiply(e).mod(n),
            a = t.multiply(t).multiply(t).add(i.multiply(t)).add(s).mod(n);
          return r.equals(a);
        }),
        (tt.prototype.toString = function () {
          return '(' + this.getX().toBigInteger().toString() + ',' + this.getY().toBigInteger().toString() + ')';
        }),
        (tt.prototype.validate = function () {
          var t = this.curve.getQ();
          if (this.isInfinity()) throw new Error('Point is at infinity.');
          var e = this.getX().toBigInteger(),
            i = this.getY().toBigInteger();
          if (e.compareTo(x.ONE) < 0 || e.compareTo(t.subtract(x.ONE)) > 0)
            throw new Error('x coordinate out of bounds');
          if (i.compareTo(x.ONE) < 0 || i.compareTo(t.subtract(x.ONE)) > 0)
            throw new Error('y coordinate out of bounds');
          if (!this.isOnCurve()) throw new Error('Point is not on the curve.');
          if (this.multiply(t).isInfinity()) throw new Error('Point is not a scalar multiple of G.');
          return !0;
        }));
      var it = (function () {
        var t = new RegExp(
            '(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))',
            'g',
          ),
          e = new RegExp('\\\\(?:([^u])|u(.{4}))', 'g'),
          i = { '"': '"', '/': '/', '\\': '\\', b: '\b', f: '\f', n: '\n', r: '\r', t: '\t' };
        function s(t, e, s) {
          return e ? i[e] : String.fromCharCode(parseInt(s, 16));
        }
        var n = new String(''),
          r = Object.hasOwnProperty;
        return function (i, a) {
          var o,
            h,
            l = i.match(t),
            c = l[0],
            u = !1;
          '{' === c ? (o = {}) : '[' === c ? (o = []) : ((o = []), (u = !0));
          for (var d = [o], f = 1 - u, p = l.length; f < p; ++f) {
            var m;
            switch ((c = l[f]).charCodeAt(0)) {
              default:
                (((m = d[0])[h || m.length] = +c), (h = void 0));
                break;
              case 34:
                if (
                  (-1 !== (c = c.substring(1, c.length - 1)).indexOf('\\') && (c = c.replace(e, s)), (m = d[0]), !h)
                ) {
                  if (!(m instanceof Array)) {
                    h = c || n;
                    break;
                  }
                  h = m.length;
                }
                ((m[h] = c), (h = void 0));
                break;
              case 91:
                ((m = d[0]), d.unshift((m[h || m.length] = [])), (h = void 0));
                break;
              case 93:
              case 125:
                d.shift();
                break;
              case 102:
                (((m = d[0])[h || m.length] = !1), (h = void 0));
                break;
              case 110:
                (((m = d[0])[h || m.length] = null), (h = void 0));
                break;
              case 116:
                (((m = d[0])[h || m.length] = !0), (h = void 0));
                break;
              case 123:
                ((m = d[0]), d.unshift((m[h || m.length] = {})), (h = void 0));
            }
          }
          if (u) {
            if (1 !== d.length) throw new Error();
            o = o[0];
          } else if (d.length) throw new Error();
          if (a) {
            var g = function (t, e) {
              var i = t[e];
              if (i && 'object' == typeof i) {
                var s = null;
                for (var n in i)
                  if (r.call(i, n) && i !== t) {
                    var o = g(i, n);
                    void 0 !== o ? (i[n] = o) : (s || (s = []), s.push(n));
                  }
                if (s) for (var h = s.length; --h >= 0; ) delete i[s[h]];
              }
              return a.call(t, e, i);
            };
            o = g({ '': o }, '');
          }
          return o;
        };
      })();
      ((void 0 !== st && st) || (st = {}),
        (void 0 !== st.asn1 && st.asn1) || (st.asn1 = {}),
        (st.asn1.ASN1Util = new (function () {
          ((this.integerToByteHex = function (t) {
            var e = t.toString(16);
            return (e.length % 2 == 1 && (e = '0' + e), e);
          }),
            (this.bigIntToMinTwosComplementsHex = function (t) {
              return Ut(t);
            }),
            (this.getPEMStringFromHex = function (t, e) {
              return Mt(t, e);
            }),
            (this.newObject = function (t) {
              var e = st.asn1,
                i = e.ASN1Object,
                s = e.DERBoolean,
                n = e.DERInteger,
                r = e.DERBitString,
                a = e.DEROctetString,
                o = e.DERNull,
                h = e.DERObjectIdentifier,
                l = e.DEREnumerated,
                c = e.DERUTF8String,
                u = e.DERNumericString,
                d = e.DERPrintableString,
                f = e.DERTeletexString,
                p = e.DERIA5String,
                m = e.DERUTCTime,
                g = e.DERGeneralizedTime,
                y = e.DERVisibleString,
                x = e.DERBMPString,
                v = e.DERSequence,
                b = e.DERSet,
                w = e.DERTaggedObject,
                S = e.ASN1Util.newObject;
              if (t instanceof e.ASN1Object) return t;
              var M = Object.keys(t);
              if (1 != M.length) throw new Error('key of param shall be only one.');
              var C = M[0];
              if (
                -1 ==
                ':asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:'.indexOf(
                  ':' + C + ':',
                )
              )
                throw new Error('undefined key: ' + C);
              if ('bool' == C) return new s(t[C]);
              if ('int' == C) return new n(t[C]);
              if ('bitstr' == C) return new r(t[C]);
              if ('octstr' == C) return new a(t[C]);
              if ('null' == C) return new o(t[C]);
              if ('oid' == C) return new h(t[C]);
              if ('enum' == C) return new l(t[C]);
              if ('utf8str' == C) return new c(t[C]);
              if ('numstr' == C) return new u(t[C]);
              if ('prnstr' == C) return new d(t[C]);
              if ('telstr' == C) return new f(t[C]);
              if ('ia5str' == C) return new p(t[C]);
              if ('utctime' == C) return new m(t[C]);
              if ('gentime' == C) return new g(t[C]);
              if ('visstr' == C) return new y(t[C]);
              if ('bmpstr' == C) return new x(t[C]);
              if ('asn1' == C) return new i(t[C]);
              if ('seq' == C) {
                for (var E = t[C], D = [], A = 0; A < E.length; A++) {
                  var F = S(E[A]);
                  D.push(F);
                }
                return new v({ array: D });
              }
              if ('set' == C) {
                for (E = t[C], D = [], A = 0; A < E.length; A++) ((F = S(E[A])), D.push(F));
                return new b({ array: D });
              }
              if ('tag' == C) {
                var P = t[C];
                if ('[object Array]' === Object.prototype.toString.call(P) && 3 == P.length) {
                  var T = S(P[2]);
                  return new w({ tag: P[0], explicit: P[1], obj: T });
                }
                return new w(P);
              }
            }),
            (this.jsonToASN1HEX = function (t) {
              return this.newObject(t).tohex();
            }));
        })()),
        (st.asn1.ASN1Util.oidHexToInt = function (t) {
          for (
            var e = '', i = parseInt(t.substr(0, 2), 16), s = ((e = Math.floor(i / 40) + '.' + (i % 40)), ''), n = 2;
            n < t.length;
            n += 2
          ) {
            var r = ('00000000' + parseInt(t.substr(n, 2), 16).toString(2)).slice(-8);
            ((s += r.substr(1, 7)), '0' == r.substr(0, 1) && ((e = e + '.' + new x(s, 2).toString(10)), (s = '')));
          }
          return e;
        }),
        (st.asn1.ASN1Util.oidIntToHex = function (t) {
          var e = function (t) {
              var e = t.toString(16);
              return (1 == e.length && (e = '0' + e), e);
            },
            i = function (t) {
              var i = '',
                s = new x(t, 10).toString(2),
                n = 7 - (s.length % 7);
              7 == n && (n = 0);
              for (var r = '', a = 0; a < n; a++) r += '0';
              for (s = r + s, a = 0; a < s.length - 1; a += 7) {
                var o = s.substr(a, 7);
                (a != s.length - 7 && (o = '1' + o), (i += e(parseInt(o, 2))));
              }
              return i;
            };
          if (!t.match(/^[0-9.]+$/)) throw 'malformed oid string: ' + t;
          var s = '',
            n = t.split('.'),
            r = 40 * parseInt(n[0]) + parseInt(n[1]);
          ((s += e(r)), n.splice(0, 2));
          for (var a = 0; a < n.length; a++) s += i(n[a]);
          return s;
        }),
        (st.asn1.ASN1Object = function (t) {
          ((this.params = null),
            (this.getLengthHexFromValue = function () {
              if (void 0 === this.hV || null == this.hV) throw new Error('this.hV is null or undefined');
              if (this.hV.length % 2 == 1) throw new Error('value hex must be even length: n=0,v=' + this.hV);
              var t = this.hV.length / 2,
                e = t.toString(16);
              if ((e.length % 2 == 1 && (e = '0' + e), t < 128)) return e;
              var i = e.length / 2;
              if (i > 15) throw new Error('ASN.1 length too long to represent by 8x: n = ' + t.toString(16));
              return (128 + i).toString(16) + e;
            }),
            (this.tohex = function () {
              return (
                (null == this.hTLV || this.isModified) &&
                  ((this.hV = this.getFreshValueHex()),
                  (this.hL = this.getLengthHexFromValue()),
                  (this.hTLV = this.hT + this.hL + this.hV),
                  (this.isModified = !1)),
                this.hTLV
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.getValueHex = function () {
              return (this.tohex(), this.hV);
            }),
            (this.getFreshValueHex = function () {
              return '';
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            null != t && null != t.tlv && ((this.hTLV = t.tlv), (this.isModified = !1)));
        }),
        (st.asn1.DERAbstractString = function (t) {
          (st.asn1.DERAbstractString.superclass.constructor.call(this),
            (this.getString = function () {
              return this.s;
            }),
            (this.setString = function (t) {
              ((this.hTLV = null), (this.isModified = !0), (this.s = t), (this.hV = mt(this.s).toLowerCase()));
            }),
            (this.setStringHex = function (t) {
              ((this.hTLV = null), (this.isModified = !0), (this.s = null), (this.hV = t));
            }),
            (this.getFreshValueHex = function () {
              return this.hV;
            }),
            void 0 !== t &&
              ('string' == typeof t
                ? this.setString(t)
                : void 0 !== t.str
                  ? this.setString(t.str)
                  : void 0 !== t.hex && this.setStringHex(t.hex)));
        }),
        Zt(st.asn1.DERAbstractString, st.asn1.ASN1Object),
        (st.asn1.DERAbstractTime = function (t) {
          (st.asn1.DERAbstractTime.superclass.constructor.call(this),
            (this.localDateToUTC = function (t) {
              var e = t.getTime() + 6e4 * t.getTimezoneOffset();
              return new Date(e);
            }),
            (this.formatDate = function (t, e, i) {
              var s = this.zeroPadding,
                n = this.localDateToUTC(t),
                r = String(n.getFullYear());
              'utc' == e && (r = r.substr(2, 2));
              var a =
                r +
                s(String(n.getMonth() + 1), 2) +
                s(String(n.getDate()), 2) +
                s(String(n.getHours()), 2) +
                s(String(n.getMinutes()), 2) +
                s(String(n.getSeconds()), 2);
              if (!0 === i) {
                var o = n.getMilliseconds();
                if (0 != o) {
                  var h = s(String(o), 3);
                  a = a + '.' + (h = h.replace(/[0]+$/, ''));
                }
              }
              return a + 'Z';
            }),
            (this.zeroPadding = function (t, e) {
              return t.length >= e ? t : new Array(e - t.length + 1).join('0') + t;
            }),
            (this.setByParam = function (t) {
              ((this.hV = null), (this.hTLV = null), (this.params = t));
            }),
            (this.getString = function () {}),
            (this.setString = function (t) {
              ((this.hTLV = null),
                (this.isModified = !0),
                null == this.params && (this.params = {}),
                (this.params.str = t));
            }),
            (this.setByDate = function (t) {
              ((this.hTLV = null),
                (this.isModified = !0),
                null == this.params && (this.params = {}),
                (this.params.date = t));
            }),
            (this.setByDateValue = function (t, e, i, s, n, r) {
              var a = new Date(Date.UTC(t, e - 1, i, s, n, r, 0));
              this.setByDate(a);
            }),
            (this.getFreshValueHex = function () {
              return this.hV;
            }));
        }),
        Zt(st.asn1.DERAbstractTime, st.asn1.ASN1Object),
        (st.asn1.DERAbstractStructured = function (t) {
          (st.asn1.DERAbstractString.superclass.constructor.call(this),
            (this.setByASN1ObjectArray = function (t) {
              ((this.hTLV = null), (this.isModified = !0), (this.asn1Array = t));
            }),
            (this.appendASN1Object = function (t) {
              ((this.hTLV = null), (this.isModified = !0), this.asn1Array.push(t));
            }),
            (this.asn1Array = new Array()),
            void 0 !== t && void 0 !== t.array && (this.asn1Array = t.array));
        }),
        Zt(st.asn1.DERAbstractStructured, st.asn1.ASN1Object),
        (st.asn1.DERBoolean = function (t) {
          (st.asn1.DERBoolean.superclass.constructor.call(this),
            (this.hT = '01'),
            (this.hTLV = 0 == t ? '010100' : '0101ff'));
        }),
        Zt(st.asn1.DERBoolean, st.asn1.ASN1Object),
        (st.asn1.DERInteger = function (t) {
          (st.asn1.DERInteger.superclass.constructor.call(this), (this.hT = '02'), (this.params = null));
          var e = Ut;
          ((this.setByBigInteger = function (t) {
            ((this.isModified = !0), (this.params = { bigint: t }));
          }),
            (this.setByInteger = function (t) {
              ((this.isModified = !0), (this.params = t));
            }),
            (this.setValueHex = function (t) {
              ((this.isModified = !0), (this.params = { hex: t }));
            }),
            (this.getFreshValueHex = function () {
              var t = this.params,
                i = null;
              if (null == t) throw new Error('value not set');
              if ('object' == typeof t && null != t.hex) return ((this.hV = t.hex), this.hV);
              if ('number' == typeof t) i = new x(String(t), 10);
              else if (null != t.int) i = new x(String(t.int), 10);
              else {
                if (null == t.bigint) throw new Error('wrong parameter');
                i = t.bigint;
              }
              return ((this.hV = e(i)), this.hV);
            }),
            null != t && (this.params = t));
        }),
        Zt(st.asn1.DERInteger, st.asn1.ASN1Object),
        (st.asn1.DERBitString = function (t) {
          if (void 0 !== t && void 0 !== t.obj) {
            var e = st.asn1.ASN1Util.newObject(t.obj);
            t.hex = '00' + e.tohex();
          }
          (st.asn1.DERBitString.superclass.constructor.call(this),
            (this.hT = '03'),
            (this.setHexValueIncludingUnusedBits = function (t) {
              ((this.hTLV = null), (this.isModified = !0), (this.hV = t));
            }),
            (this.setUnusedBitsAndHexValue = function (t, e) {
              if (t < 0 || 7 < t) throw 'unused bits shall be from 0 to 7: u = ' + t;
              var i = '0' + t;
              ((this.hTLV = null), (this.isModified = !0), (this.hV = i + e));
            }),
            (this.setByBinaryString = function (t) {
              var e = 8 - ((t = t.replace(/0+$/, '')).length % 8);
              (8 == e && (e = 0), (t += '0000000'.substr(0, e)));
              for (var i = '', s = 0; s < t.length - 1; s += 8) {
                var n = t.substr(s, 8),
                  r = parseInt(n, 2).toString(16);
                (1 == r.length && (r = '0' + r), (i += r));
              }
              ((this.hTLV = null), (this.isModified = !0), (this.hV = '0' + e + i));
            }),
            (this.setByBooleanArray = function (t) {
              for (var e = '', i = 0; i < t.length; i++) 1 == t[i] ? (e += '1') : (e += '0');
              this.setByBinaryString(e);
            }),
            (this.newFalseArray = function (t) {
              for (var e = new Array(t), i = 0; i < t; i++) e[i] = !1;
              return e;
            }),
            (this.getFreshValueHex = function () {
              return this.hV;
            }),
            void 0 !== t &&
              ('string' == typeof t && t.toLowerCase().match(/^[0-9a-f]+$/)
                ? this.setHexValueIncludingUnusedBits(t)
                : void 0 !== t.hex
                  ? this.setHexValueIncludingUnusedBits(t.hex)
                  : void 0 !== t.bin
                    ? this.setByBinaryString(t.bin)
                    : void 0 !== t.array && this.setByBooleanArray(t.array)));
        }),
        Zt(st.asn1.DERBitString, st.asn1.ASN1Object),
        (st.asn1.DEROctetString = function (t) {
          if (void 0 !== t && void 0 !== t.obj) {
            var e = st.asn1.ASN1Util.newObject(t.obj);
            t.hex = e.tohex();
          }
          (st.asn1.DEROctetString.superclass.constructor.call(this, t), (this.hT = '04'));
        }),
        Zt(st.asn1.DEROctetString, st.asn1.DERAbstractString),
        (st.asn1.DERNull = function () {
          (st.asn1.DERNull.superclass.constructor.call(this), (this.hT = '05'), (this.hTLV = '0500'));
        }),
        Zt(st.asn1.DERNull, st.asn1.ASN1Object),
        (st.asn1.DERObjectIdentifier = function (t) {
          (st.asn1.DERObjectIdentifier.superclass.constructor.call(this),
            (this.hT = '06'),
            (this.setValueHex = function (t) {
              ((this.hTLV = null), (this.isModified = !0), (this.s = null), (this.hV = t));
            }),
            (this.setValueOidString = function (t) {
              var e = jt(t);
              if (null == e) throw new Error('malformed oid string: ' + t);
              ((this.hTLV = null), (this.isModified = !0), (this.s = null), (this.hV = e));
            }),
            (this.setValueName = function (t) {
              var e = st.asn1.x509.OID.name2oid(t);
              if ('' === e) throw new Error('DERObjectIdentifier oidName undefined: ' + t);
              this.setValueOidString(e);
            }),
            (this.setValueNameOrOid = function (t) {
              t.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(t) : this.setValueName(t);
            }),
            (this.getFreshValueHex = function () {
              return this.hV;
            }),
            (this.setByParam = function (t) {
              'string' == typeof t
                ? this.setValueNameOrOid(t)
                : void 0 !== t.oid
                  ? this.setValueNameOrOid(t.oid)
                  : void 0 !== t.name
                    ? this.setValueNameOrOid(t.name)
                    : void 0 !== t.hex && this.setValueHex(t.hex);
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.DERObjectIdentifier, st.asn1.ASN1Object),
        (st.asn1.DEREnumerated = function (t) {
          (st.asn1.DEREnumerated.superclass.constructor.call(this),
            (this.hT = '0a'),
            (this.setByBigInteger = function (t) {
              ((this.hTLV = null), (this.isModified = !0), (this.hV = Ut(t)));
            }),
            (this.setByInteger = function (t) {
              var e = new x(String(t), 10);
              this.setByBigInteger(e);
            }),
            (this.setValueHex = function (t) {
              this.hV = t;
            }),
            (this.getFreshValueHex = function () {
              return this.hV;
            }),
            void 0 !== t &&
              (void 0 !== t.int
                ? this.setByInteger(t.int)
                : 'number' == typeof t
                  ? this.setByInteger(t)
                  : void 0 !== t.hex && this.setValueHex(t.hex)));
        }),
        Zt(st.asn1.DEREnumerated, st.asn1.ASN1Object),
        (st.asn1.DERUTF8String = function (t) {
          (st.asn1.DERUTF8String.superclass.constructor.call(this, t), (this.hT = '0c'));
        }),
        Zt(st.asn1.DERUTF8String, st.asn1.DERAbstractString),
        (st.asn1.DERNumericString = function (t) {
          (st.asn1.DERNumericString.superclass.constructor.call(this, t), (this.hT = '12'));
        }),
        Zt(st.asn1.DERNumericString, st.asn1.DERAbstractString),
        (st.asn1.DERPrintableString = function (t) {
          (st.asn1.DERPrintableString.superclass.constructor.call(this, t), (this.hT = '13'));
        }),
        Zt(st.asn1.DERPrintableString, st.asn1.DERAbstractString),
        (st.asn1.DERTeletexString = function (t) {
          (st.asn1.DERTeletexString.superclass.constructor.call(this, t), (this.hT = '14'));
        }),
        Zt(st.asn1.DERTeletexString, st.asn1.DERAbstractString),
        (st.asn1.DERIA5String = function (t) {
          (st.asn1.DERIA5String.superclass.constructor.call(this, t), (this.hT = '16'));
        }),
        Zt(st.asn1.DERIA5String, st.asn1.DERAbstractString),
        (st.asn1.DERVisibleString = function (t) {
          (st.asn1.DERIA5String.superclass.constructor.call(this, t), (this.hT = '1a'));
        }),
        Zt(st.asn1.DERVisibleString, st.asn1.DERAbstractString),
        (st.asn1.DERBMPString = function (t) {
          (st.asn1.DERBMPString.superclass.constructor.call(this, t), (this.hT = '1e'));
        }),
        Zt(st.asn1.DERBMPString, st.asn1.DERAbstractString),
        (st.asn1.DERUTCTime = function (t) {
          (st.asn1.DERUTCTime.superclass.constructor.call(this, t),
            (this.hT = '17'),
            (this.params = void 0),
            (this.getFreshValueHex = function () {
              var t = this.params;
              if ((null == this.params && (t = { date: new Date() }), 'string' == typeof t)) {
                if (!t.match(/^[0-9]{12}Z$/) && !t.match(/^[0-9]{12}\.[0-9]+Z$/))
                  throw new Error('malformed string for UTCTime: ' + t);
                this.hV = ct(t);
              } else if (null != t.str) this.hV = ct(t.str);
              else if (null == t.date && 1 == t.millis) {
                var e = new Date();
                this.hV = ct(this.formatDate(e, 'utc', !0));
              } else if (null != t.date && t.date instanceof Date) {
                var i = !0 === t.millis;
                this.hV = ct(this.formatDate(t.date, 'utc', i));
              } else t instanceof Date && (this.hV = ct(this.formatDate(t, 'utc')));
              if (null == this.hV) throw new Error('parameter not specified properly for UTCTime');
              return this.hV;
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.DERUTCTime, st.asn1.DERAbstractTime),
        (st.asn1.DERGeneralizedTime = function (t) {
          (st.asn1.DERGeneralizedTime.superclass.constructor.call(this, t),
            (this.hT = '18'),
            (this.params = t),
            (this.getFreshValueHex = function () {
              var t = this.params;
              if ((null == this.params && (t = { date: new Date() }), 'string' == typeof t)) {
                if (!t.match(/^[0-9]{14}Z$/) && !t.match(/^[0-9]{14}\.[0-9]+Z$/))
                  throw new Error('malformed string for GeneralizedTime: ' + t);
                this.hV = ct(t);
              } else if (null != t.str) this.hV = ct(t.str);
              else if (null == t.date && 1 == t.millis) {
                var e = new Date();
                this.hV = ct(this.formatDate(e, 'gen', !0));
              } else if (null != t.date && t.date instanceof Date) {
                var i = !0 === t.millis;
                this.hV = ct(this.formatDate(t.date, 'gen', i));
              } else t instanceof Date && (this.hV = ct(this.formatDate(t, 'gen')));
              if (null == this.hV) throw new Error('parameter not specified properly for GeneralizedTime');
              return this.hV;
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.DERGeneralizedTime, st.asn1.DERAbstractTime),
        (st.asn1.DERSequence = function (t) {
          (st.asn1.DERSequence.superclass.constructor.call(this, t),
            (this.hT = '30'),
            (this.getFreshValueHex = function () {
              for (var t = '', e = 0; e < this.asn1Array.length; e++) t += this.asn1Array[e].tohex();
              return ((this.hV = t), this.hV);
            }));
        }),
        Zt(st.asn1.DERSequence, st.asn1.DERAbstractStructured),
        (st.asn1.DERSet = function (t) {
          (st.asn1.DERSet.superclass.constructor.call(this, t),
            (this.hT = '31'),
            (this.sortFlag = !0),
            (this.getFreshValueHex = function () {
              for (var t = new Array(), e = 0; e < this.asn1Array.length; e++) {
                var i = this.asn1Array[e];
                t.push(i.tohex());
              }
              return (1 == this.sortFlag && t.sort(), (this.hV = t.join('')), this.hV);
            }),
            void 0 !== t && void 0 !== t.sortflag && 0 == t.sortflag && (this.sortFlag = !1));
        }),
        Zt(st.asn1.DERSet, st.asn1.DERAbstractStructured),
        (st.asn1.DERTaggedObject = function (t) {
          st.asn1.DERTaggedObject.superclass.constructor.call(this);
          var e = st.asn1,
            i = at,
            s = i.getV;
          i.isASN1HEX;
          var n = e.ASN1Util.newObject;
          ((this.hT = 'a0'),
            (this.hV = ''),
            (this.isExplicit = !0),
            (this.asn1Object = null),
            (this.params = { tag: 'a0', explicit: !0 }),
            (this.setASN1Object = function (t, e, i) {
              this.params = { tag: e, explicit: t, obj: i };
            }),
            (this.getFreshValueHex = function () {
              var t = this.params;
              if (
                (null == t.explicit && (t.explicit = !0),
                null != t.tage && ((t.tag = t.tage), (t.explicit = !0)),
                null != t.tagi && ((t.tag = t.tagi), (t.explicit = !1)),
                null != t.str)
              )
                this.hV = mt(t.str);
              else if (null != t.hex) this.hV = t.hex;
              else {
                if (null == t.obj) throw new Error('str, hex nor obj not specified');
                var i;
                (t.obj instanceof e.ASN1Object
                  ? (i = t.obj.tohex())
                  : 'object' == typeof t.obj && (i = n(t.obj).tohex()),
                  t.explicit ? (this.hV = i) : (this.hV = s(i, 0)));
              }
              return (
                null == t.tag && (t.tag = 'a0'),
                (this.hT = t.tag),
                (this.hTLV = null),
                (this.isModified = !0),
                this.hV
              );
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.DERTaggedObject, st.asn1.ASN1Object));
      var st,
        nt,
        rt,
        at = new (function () {})();
      function ot(t) {
        for (var e = new Array(), i = 0; i < t.length; i++) e[i] = t.charCodeAt(i);
        return e;
      }
      function ht(t) {
        for (var e = '', i = 0; i < t.length; i++) e += String.fromCharCode(t[i]);
        return e;
      }
      function lt(t) {
        for (var e = '', i = 0; i < t.length; i++) {
          var s = t[i].toString(16);
          (1 == s.length && (s = '0' + s), (e += s));
        }
        return e;
      }
      function ct(t) {
        return lt(ot(t));
      }
      function ut(t) {
        return (t = (t = (t = t.replace(/\=/g, '')).replace(/\+/g, '-')).replace(/\//g, '_'));
      }
      function dt(t) {
        return (
          t.length % 4 == 2 ? (t += '==') : t.length % 4 == 3 && (t += '='),
          (t = (t = t.replace(/-/g, '+')).replace(/_/g, '/'))
        );
      }
      function ft(t) {
        return (t.length % 2 == 1 && (t = '0' + t), ut(m(t)));
      }
      function pt(t) {
        return g(dt(t));
      }
      function mt(t) {
        return Ft(zt(t)).toLowerCase();
      }
      function gt(t) {
        try {
          return decodeURIComponent(Pt(t));
        } catch (t) {
          return null;
        }
      }
      function yt(t) {
        return gt(
          (function (t) {
            for (var e = t.match(/.{1,2}/g), i = [], s = 0; s < e.length; s++) {
              var n = parseInt(e[s], 16);
              161 <= n && n <= 191
                ? (i.push('c2'), i.push(e[s]))
                : 192 <= n && n <= 255
                  ? (i.push('c3'), i.push((n - 64).toString(16)))
                  : i.push(e[s]);
            }
            return i.join('');
          })(t),
        );
      }
      function xt(t) {
        for (var e = '', i = 0; i < t.length - 1; i += 2) e += String.fromCharCode(parseInt(t.substr(i, 2), 16));
        return e;
      }
      function vt(t) {
        for (var e = '', i = 0; i < t.length; i++) e += ('0' + t.charCodeAt(i).toString(16)).slice(-2);
        return e;
      }
      function bt(t) {
        return m(t);
      }
      function wt(t, e) {
        return (t = (t = t.replace(new RegExp('(.{' + e + '})', 'g'), '$1\r\n')).replace(/\s+$/, ''));
      }
      function St(t) {
        return g(t.replace(/[^0-9A-Za-z\/+=]*/g, ''));
      }
      function Mt(t, e) {
        return '-----BEGIN ' + e + '-----\r\n' + wt(bt(t), 64) + '\r\n-----END ' + e + '-----\r\n';
      }
      function Ct(t, e) {
        if (-1 == t.indexOf('-----BEGIN ')) throw new Error("can't find PEM header");
        return St(
          (t =
            void 0 !== e
              ? (t = t.replace(new RegExp('^[^]*-----BEGIN ' + e + '-----'), '')).replace(
                  new RegExp('-----END ' + e + '-----[^]*$'),
                  '',
                )
              : (t = t.replace(/^[^]*-----BEGIN [^-]+-----/, '')).replace(/-----END [^-]+-----[^]*$/, '')),
        );
      }
      function Et(t) {
        var e, i, s, n, r, a, o, h, l, c;
        if ((c = (t = At(t)).match(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/)))
          return (
            (e = parseInt(c[1])),
            (i = parseInt(c[2]) - 1),
            (s = parseInt(c[3])),
            (n = parseInt(c[4])),
            (r = parseInt(c[5])),
            (a = parseInt(c[6])),
            (o = 0),
            '' !== (h = c[7]) && ((l = (h.substr(1) + '00').substr(0, 3)), (o = parseInt(l))),
            Date.UTC(e, i, s, n, r, a, o)
          );
        throw new Error('unsupported zulu format: ' + t);
      }
      function Dt(t) {
        return Math.round(Et(t) / 1e3);
      }
      function At(t) {
        return t.match(/^[0-9]{12}Z$/) || t.match(/^[0-9]{12}[.][0-9]*Z$/)
          ? t.match(/^[0-4]/)
            ? '20' + t
            : '19' + t
          : t;
      }
      function Ft(t) {
        return t.replace(/%/g, '');
      }
      function Pt(t) {
        return t.replace(/(..)/g, '%$1');
      }
      function Tt(t) {
        var e = 'malformed IPv6 address';
        if (!t.match(/^[0-9A-Fa-f:]+$/)) throw e;
        var i = (t = t.toLowerCase()).split(':').length - 1;
        if (i < 2) throw e;
        var s = ':'.repeat(7 - i + 2),
          n = (t = t.replace('::', s)).split(':');
        if (8 != n.length) throw e;
        for (var r = 0; r < 8; r++) n[r] = ('0000' + n[r]).slice(-4);
        return n.join('');
      }
      function It(t) {
        if (!t.match(/^[0-9A-Fa-f]{32}$/)) throw new Error('malformed IPv6 address: ' + t);
        var e = (t = t.toLowerCase()).match(/.{1,4}/g);
        ((e = e.map(function (t) {
          return t.replace(/^0+/, '');
        })),
          (e = e.map(function (t) {
            return '' == t ? '0' : t;
          })));
        var i = (t = ':' + e.join(':') + ':').match(/:(0:){2,}/g);
        if (null == i) return t.slice(1, -1);
        var s = i.sort().slice(-1)[0];
        return (
          '::' != (t = t.replace(s.substr(0, s.length - 1), ':')).substr(0, 2) && (t = t.substr(1)),
          '::' != t.substr(-2, 2) && (t = t.substr(0, t.length - 1)),
          t
        );
      }
      function _t(t) {
        var e = new Error('malformed hex value');
        if (!t.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/)) throw e;
        if (8 == t.length)
          try {
            return (
              parseInt(t.substr(0, 2), 16) +
              '.' +
              parseInt(t.substr(2, 2), 16) +
              '.' +
              parseInt(t.substr(4, 2), 16) +
              '.' +
              parseInt(t.substr(6, 2), 16)
            );
          } catch (t) {
            throw e;
          }
        else {
          if (16 != t.length) {
            if (32 == t.length) return It(t);
            if (64 == t.length) {
              try {
                return It(t.substr(0, 32)) + '/' + Rt(t.substr(32));
              } catch (t) {
                throw e;
              }
              return;
            }
            return t;
          }
          try {
            return _t(t.substr(0, 8)) + '/' + Rt(t.substr(8));
          } catch (t) {
            throw e;
          }
        }
      }
      function Rt(t) {
        var e,
          i = new Error('malformed mask');
        try {
          e = new x(t, 16).toString(2);
        } catch (t) {
          throw i;
        }
        if (!e.match(/^1*0*$/)) throw i;
        return e.replace(/0+$/, '').length;
      }
      function Nt(t) {
        var e = new Error('malformed IP address');
        if (!(t = t.toLowerCase(t)).match(/^[0-9a-f.:/]+$/)) throw e;
        if (!t.match(/^[0-9.]+$/)) {
          var i;
          if (t.match(/^[0-9.]+\/[0-9]+$/)) return Nt((i = t.split('/'))[0]) + Bt(parseInt(i[1]), 32);
          if (t.match(/^[0-9a-f:]+$/) && -1 !== t.indexOf(':')) return Tt(t);
          if (t.match(/^[0-9a-f:]+\/[0-9]+$/) && -1 !== t.indexOf(':'))
            return Tt((i = t.split('/'))[0]) + Bt(parseInt(i[1]), 128);
          throw e;
        }
        var s = t.split('.');
        if (4 !== s.length) throw e;
        var n = '';
        try {
          for (var r = 0; r < 4; r++) n += ('0' + parseInt(s[r]).toString(16)).slice(-2);
          return n;
        } catch (t) {
          throw e;
        }
      }
      function Bt(t, e) {
        return 32 == e && 0 == t
          ? '00000000'
          : 128 == e && 0 == t
            ? '00000000000000000000000000000000'
            : new x(Array(t + 1).join('1') + Array(e - t + 1).join('0'), 2).toString(16);
      }
      function kt(t) {
        var e = t.match(/.{4}/g).map(function (t) {
          var e = parseInt(t.substr(0, 2), 16),
            i = parseInt(t.substr(2), 16);
          if ((0 == e) & (i < 128)) return String.fromCharCode(i);
          if (e < 8) {
            var s = 128 | (63 & i);
            return gt((192 | ((7 & e) << 3) | ((192 & i) >> 6)).toString(16) + s.toString(16));
          }
          s = 128 | ((15 & e) << 2) | ((192 & i) >> 6);
          var n = 128 | (63 & i);
          return gt((224 | ((240 & e) >> 4)).toString(16) + s.toString(16) + n.toString(16));
        });
        return e.join('');
      }
      function zt(t) {
        for (var e = encodeURIComponent(t), i = '', s = 0; s < e.length; s++)
          '%' == e[s] ? ((i += e.substr(s, 3)), (s += 2)) : (i = i + '%' + ct(e[s]));
        return i;
      }
      function Lt(t) {
        return !(t.length % 2 != 0 || (!t.match(/^[0-9a-f]+$/) && !t.match(/^[0-9A-F]+$/)));
      }
      function Ot(t) {
        return !!t.match(/^[0-9A-Za-z-_.]+$/);
      }
      function Ht(t) {
        return t.length % 2 == 1 ? '0' + t : t.substr(0, 1) > '7' ? '00' + t : t;
      }
      function jt(t) {
        var e = function (t) {
            var e = t.toString(16);
            return (1 == e.length && (e = '0' + e), e);
          },
          i = function (t) {
            var i = '',
              s = parseInt(t, 10).toString(2),
              n = 7 - (s.length % 7);
            7 == n && (n = 0);
            for (var r = '', a = 0; a < n; a++) r += '0';
            for (s = r + s, a = 0; a < s.length - 1; a += 7) {
              var o = s.substr(a, 7);
              (a != s.length - 7 && (o = '1' + o), (i += e(parseInt(o, 2))));
            }
            return i;
          };
        try {
          if (!t.match(/^[0-9.]+$/)) return null;
          var s = '',
            n = t.split('.'),
            r = 40 * parseInt(n[0], 10) + parseInt(n[1], 10);
          ((s += e(r)), n.splice(0, 2));
          for (var a = 0; a < n.length; a++) s += i(n[a]);
          return s;
        } catch (t) {
          return null;
        }
      }
      function qt(t) {
        if (!Lt(t)) return null;
        try {
          var e = [],
            i = t.substr(0, 2),
            s = parseInt(i, 16);
          ((e[0] = new String(Math.floor(s / 40))), (e[1] = new String(s % 40)));
          for (var n = t.substr(2), r = [], a = 0; a < n.length / 2; a++) r.push(parseInt(n.substr(2 * a, 2), 16));
          var o = [],
            h = '';
          for (a = 0; a < r.length; a++)
            128 & r[a]
              ? (h += Kt((127 & r[a]).toString(2), 7))
              : ((h += Kt((127 & r[a]).toString(2), 7)), o.push(new String(parseInt(h, 2))), (h = ''));
          var l = e.join('.');
          return (o.length > 0 && (l = l + '.' + o.join('.')), l);
        } catch (t) {
          return null;
        }
      }
      function Vt(t) {
        return Ut(new x(String(t), 10));
      }
      function Ut(t) {
        var e = t.toString(16);
        if ('-' != e.substr(0, 1)) return (e.length % 2 == 1 ? (e = '0' + e) : e.match(/^[0-7]/) || (e = '00' + e), e);
        var i = e.substr(1).length;
        i % 2 == 1 ? (i += 1) : e.match(/^[0-7]/) || (i += 2);
        for (var s = '', n = 0; n < i; n++) s += 'f';
        return (e = new x(s, 16).xor(t).add(x.ONE).toString(16).replace(/^-/, ''));
      }
      ((at.getLblen = function (t, e) {
        if ('8' != t.substr(e + 2, 1)) return 1;
        var i = parseInt(t.substr(e + 3, 1));
        return 0 == i ? -1 : 0 < i && i < 10 ? i + 1 : -2;
      }),
        (at.getL = function (t, e) {
          var i = at.getLblen(t, e);
          return i < 1 ? '' : t.substr(e + 2, 2 * i);
        }),
        (at.getVblen = function (t, e) {
          var i;
          return '' == (i = at.getL(t, e))
            ? -1
            : ('8' === i.substr(0, 1) ? new x(i.substr(2), 16) : new x(i, 16)).intValue();
        }),
        (at.getVidx = function (t, e) {
          var i = at.getLblen(t, e);
          return i < 0 ? i : e + 2 * (i + 1);
        }),
        (at.getV = function (t, e) {
          var i = at.getVidx(t, e),
            s = at.getVblen(t, e);
          return t.substr(i, 2 * s);
        }),
        (at.getTLV = function (t, e) {
          return t.substr(e, 2) + at.getL(t, e) + at.getV(t, e);
        }),
        (at.getTLVblen = function (t, e) {
          return 2 + 2 * at.getLblen(t, e) + 2 * at.getVblen(t, e);
        }),
        (at.getNextSiblingIdx = function (t, e) {
          return at.getVidx(t, e) + 2 * at.getVblen(t, e);
        }),
        (at.getChildIdx = function (t, e) {
          var i,
            s,
            n,
            r = at,
            a = [];
          ((i = r.getVidx(t, e)), (s = 2 * r.getVblen(t, e)), '03' == t.substr(e, 2) && ((i += 2), (s -= 2)), (n = 0));
          for (var o = i; n <= s; ) {
            var h = r.getTLVblen(t, o);
            if (((n += h) <= s && a.push(o), (o += h), n >= s)) break;
          }
          return a;
        }),
        (at.getNthChildIdx = function (t, e, i) {
          return at.getChildIdx(t, e)[i];
        }),
        (at.getIdxbyList = function (t, e, i, s) {
          var n,
            r,
            a = at;
          return 0 == i.length
            ? void 0 !== s && t.substr(e, 2) !== s
              ? -1
              : e
            : (n = i.shift()) >= (r = a.getChildIdx(t, e)).length
              ? -1
              : a.getIdxbyList(t, r[n], i, s);
        }),
        (at.getIdxbyListEx = function (t, e, i, s) {
          var n,
            r,
            a = at;
          if (0 == i.length) return void 0 !== s && t.substr(e, 2) !== s ? -1 : e;
          ((n = i.shift()), (r = a.getChildIdx(t, e)));
          for (var o = 0, h = 0; h < r.length; h++) {
            var l = t.substr(r[h], 2);
            if (
              ('number' == typeof n && !a.isContextTag(l) && o == n) ||
              ('string' == typeof n && a.isContextTag(l, n))
            )
              return a.getIdxbyListEx(t, r[h], i, s);
            a.isContextTag(l) || o++;
          }
          return -1;
        }),
        (at.getTLVbyList = function (t, e, i, s) {
          var n = at,
            r = n.getIdxbyList(t, e, i, s);
          return -1 == r || r >= t.length ? null : n.getTLV(t, r);
        }),
        (at.getTLVbyListEx = function (t, e, i, s) {
          var n = at,
            r = n.getIdxbyListEx(t, e, i, s);
          return -1 == r ? null : n.getTLV(t, r);
        }),
        (at.getVbyList = function (t, e, i, s, n) {
          var r,
            a,
            o = at;
          return -1 == (r = o.getIdxbyList(t, e, i, s)) || r >= t.length
            ? null
            : ((a = o.getV(t, r)), !0 === n && (a = a.substr(2)), a);
        }),
        (at.getVbyListEx = function (t, e, i, s, n) {
          var r,
            a,
            o = at;
          return -1 == (r = o.getIdxbyListEx(t, e, i, s))
            ? null
            : ((a = o.getV(t, r)), '03' == t.substr(r, 2) && !1 !== n && (a = a.substr(2)), a);
        }),
        (at.getInt = function (t, e, i) {
          null == i && (i = -1);
          try {
            var s = t.substr(e, 2);
            if ('02' != s && '03' != s) return i;
            var n = at.getV(t, e);
            return '02' == s ? parseInt(n, 16) : Gt(n);
          } catch (t) {
            return i;
          }
        }),
        (at.getOID = function (t, e, i) {
          null == i && (i = null);
          try {
            return '06' != t.substr(e, 2) ? i : qt(at.getV(t, e));
          } catch (t) {
            return i;
          }
        }),
        (at.getOIDName = function (t, e, i) {
          null == i && (i = null);
          try {
            var s = at.getOID(t, e, i);
            if (s == i) return i;
            var n = st.asn1.x509.OID.oid2name(s);
            return '' == n ? s : n;
          } catch (t) {
            return i;
          }
        }),
        (at.getString = function (t, e, i) {
          null == i && (i = null);
          try {
            return xt(at.getV(t, e));
          } catch (t) {
            return i;
          }
        }),
        (at.hextooidstr = function (t) {
          var e = function (t, e) {
              return t.length >= e ? t : new Array(e - t.length + 1).join('0') + t;
            },
            i = [],
            s = t.substr(0, 2),
            n = parseInt(s, 16);
          ((i[0] = new String(Math.floor(n / 40))), (i[1] = new String(n % 40)));
          for (var r = t.substr(2), a = [], o = 0; o < r.length / 2; o++) a.push(parseInt(r.substr(2 * o, 2), 16));
          var h = [],
            l = '';
          for (o = 0; o < a.length; o++)
            128 & a[o]
              ? (l += e((127 & a[o]).toString(2), 7))
              : ((l += e((127 & a[o]).toString(2), 7)), h.push(new String(parseInt(l, 2))), (l = ''));
          var c = i.join('.');
          return (h.length > 0 && (c = c + '.' + h.join('.')), c);
        }),
        (at.dump = function (t, e, i, s) {
          var n = at,
            r = n.getV,
            a = n.dump,
            o = n.getChildIdx,
            h = t;
          t instanceof st.asn1.ASN1Object && (h = t.tohex());
          var l = function (t, e) {
            return t.length <= 2 * e
              ? t
              : t.substr(0, e) + '..(total ' + t.length / 2 + 'bytes)..' + t.substr(t.length - e, e);
          };
          (void 0 === e && (e = { ommit_long_octet: 32 }), void 0 === i && (i = 0), void 0 === s && (s = ''));
          var c,
            u = e.ommit_long_octet;
          if ('01' == (c = h.substr(i, 2))) return '00' == (d = r(h, i)) ? s + 'BOOLEAN FALSE\n' : s + 'BOOLEAN TRUE\n';
          if ('02' == c) return s + 'INTEGER ' + l((d = r(h, i)), u) + '\n';
          if ('03' == c) {
            var d = r(h, i);
            if (n.isASN1HEX(d.substr(2))) {
              var f = s + 'BITSTRING, encapsulates\n';
              return (f += a(d.substr(2), e, 0, s + '  '));
            }
            return s + 'BITSTRING ' + l(d, u) + '\n';
          }
          if ('04' == c)
            return (
              (d = r(h, i)),
              n.isASN1HEX(d)
                ? ((f = s + 'OCTETSTRING, encapsulates\n'), (f += a(d, e, 0, s + '  ')))
                : s + 'OCTETSTRING ' + l(d, u) + '\n'
            );
          if ('05' == c) return s + 'NULL\n';
          if ('06' == c) {
            var p = r(h, i),
              m = st.asn1.ASN1Util.oidHexToInt(p),
              g = st.asn1.x509.OID.oid2name(m),
              y = m.replace(/\./g, ' ');
            return '' != g ? s + 'ObjectIdentifier ' + g + ' (' + y + ')\n' : s + 'ObjectIdentifier (' + y + ')\n';
          }
          if ('0a' == c) return s + 'ENUMERATED ' + parseInt(r(h, i)) + '\n';
          if ('0c' == c) return s + "UTF8String '" + gt(r(h, i)) + "'\n";
          if ('13' == c) return s + "PrintableString '" + gt(r(h, i)) + "'\n";
          if ('14' == c) return s + "TeletexString '" + gt(r(h, i)) + "'\n";
          if ('16' == c) return s + "IA5String '" + gt(r(h, i)) + "'\n";
          if ('17' == c) return s + 'UTCTime ' + gt(r(h, i)) + '\n';
          if ('18' == c) return s + 'GeneralizedTime ' + gt(r(h, i)) + '\n';
          if ('1a' == c) return s + "VisualString '" + gt(r(h, i)) + "'\n";
          if ('1e' == c) return s + "BMPString '" + kt(r(h, i)) + "'\n";
          if ('30' == c) {
            if ('3000' == h.substr(i, 4)) return s + 'SEQUENCE {}\n';
            f = s + 'SEQUENCE\n';
            var x = e;
            if (
              (2 == (w = o(h, i)).length || 3 == w.length) &&
              '06' == h.substr(w[0], 2) &&
              '04' == h.substr(w[w.length - 1], 2)
            ) {
              g = n.oidname(r(h, w[0]));
              var v = JSON.parse(JSON.stringify(e));
              ((v.x509ExtName = g), (x = v));
            }
            for (var b = 0; b < w.length; b++) f += a(h, x, w[b], s + '  ');
            return f;
          }
          if ('31' == c) {
            f = s + 'SET\n';
            var w = o(h, i);
            for (b = 0; b < w.length; b++) f += a(h, e, w[b], s + '  ');
            return f;
          }
          if (128 & (c = parseInt(c, 16))) {
            var S = 31 & c;
            if (32 & c) {
              for (f = s + '[' + S + ']\n', w = o(h, i), b = 0; b < w.length; b++) f += a(h, e, w[b], s + '  ');
              return f;
            }
            if (((d = r(h, i)), at.isASN1HEX(d))) {
              var f = s + '[' + S + ']\n';
              return (f += a(d, e, 0, s + '  '));
            }
            return (
              ('68747470' == d.substr(0, 8) || ('subjectAltName' === e.x509ExtName && 2 == S)) && (d = gt(d)),
              (f = s + '[' + S + '] ' + d + '\n')
            );
          }
          return s + 'UNKNOWN(' + c + ') ' + r(h, i) + '\n';
        }),
        (at.parse = function (t) {
          var e = at,
            i = e.parse,
            s = e.isASN1HEX,
            n = e.getV,
            r = e.getTLV,
            a = e.getChildIdx,
            o = st.asn1,
            h = o.ASN1Util.oidHexToInt,
            l = o.x509.OID.oid2name,
            c = gt,
            u = kt,
            d = yt,
            f = {
              '0c': 'utf8str',
              12: 'numstr',
              13: 'prnstr',
              14: 'telstr',
              16: 'ia5str',
              17: 'utctime',
              18: 'gentime',
              '1a': 'visstr',
              '1e': 'bmpstr',
              30: 'seq',
              31: 'set',
            },
            p = t.substr(0, 2),
            m = {},
            g = n(t, 0);
          if ('01' == p) return '0101ff' == t ? { bool: !0 } : { bool: !1 };
          if ('02' == p) return { int: { hex: g } };
          if ('03' == p)
            try {
              if ('00' != g.substr(0, 2)) throw 'not encap';
              var y = g.substr(2);
              if (!s(y)) throw 'not encap';
              return { bitstr: { obj: i(y) } };
            } catch (t) {
              var x = null;
              return (g.length <= 10 && (x = Qt(g)), null == x ? { bitstr: { hex: g } } : { bitstr: { bin: x } });
            }
          else if ('04' == p)
            try {
              if (!s(g)) throw 'not encap';
              return { octstr: { obj: i(g) } };
            } catch (t) {
              return { octstr: { hex: g } };
            }
          else {
            if ('05' == p) return { null: '' };
            if ('06' == p) {
              var v = h(g),
                b = l(v);
              return '' == b ? { oid: v } : { oid: b };
            }
            if ('0a' == p) return g.length > 4 ? { enum: { hex: g } } : { enum: parseInt(g, 16) };
            if ('30' == p || '31' == p)
              return (
                (m[f[p]] = (function (t) {
                  for (var e = [], s = a(t, 0), n = 0; n < s.length; n++) {
                    var o = s[n],
                      h = r(t, o),
                      l = i(h);
                    e.push(l);
                  }
                  return e;
                })(t)),
                m
              );
            if ('14' == p) {
              var w = d(g);
              return ((m[f[p]] = { str: w }), m);
            }
            if ('1e' == p) return ((w = u(g)), (m[f[p]] = { str: w }), m);
            if (-1 != ':0c:12:13:16:17:18:1a:'.indexOf(p)) return ((w = c(g)), (m[f[p]] = { str: w }), m);
            if (p.match(/^8[0-9]$/))
              return (null == (w = c(g))) | ('' == w) ||
                null != w.match(/[\x00-\x1F\x7F-\x9F]/) ||
                null != w.match(/[\u0000-\u001F\u0080–\u009F]/)
                ? { tag: { tag: p, explicit: !1, hex: g } }
                : { tag: { tag: p, explicit: !1, str: w } };
            if (!p.match(/^a[0-9]$/)) {
              var S = new st.asn1.ASN1Object();
              return ((S.hV = g), { asn1: { tlv: p + S.getLengthHexFromValue() + g } });
            }
            try {
              if (!s(g)) throw new Error('not encap');
              return { tag: { tag: p, explicit: !0, obj: i(g) } };
            } catch (t) {
              return { tag: { tag: p, explicit: !0, hex: g } };
            }
          }
        }),
        (at.isContextTag = function (t, e) {
          var i, s;
          t = t.toLowerCase();
          try {
            i = parseInt(t, 16);
          } catch (t) {
            return -1;
          }
          if (void 0 === e) return 128 == (192 & i);
          try {
            return (
              null != e.match(/^\[[0-9]+\]$/) &&
              !((s = parseInt(e.substr(1, e.length - 1), 10)) > 31) &&
              128 == (192 & i) &&
              (31 & i) == s
            );
          } catch (t) {
            return !1;
          }
        }),
        (at.isASN1HEX = function (t) {
          var e = at;
          if (t.length % 2 == 1) return !1;
          var i = e.getVblen(t, 0),
            s = t.substr(0, 2),
            n = e.getL(t, 0);
          return t.length - s.length - n.length == 2 * i;
        }),
        (at.checkStrictDER = function (t, e, i, s, n) {
          var r = at;
          if (void 0 === i) {
            if ('string' != typeof t) throw new Error('not hex string');
            if (((t = t.toLowerCase()), !st.lang.String.isHex(t))) throw new Error('not hex string');
            ((i = t.length), (n = (s = t.length / 2) < 128 ? 1 : Math.ceil(s.toString(16)) + 1));
          }
          if (r.getL(t, e).length > 2 * n) throw new Error('L of TLV too long: idx=' + e);
          var a = r.getVblen(t, e);
          if (a > s) throw new Error('value of L too long than hex: idx=' + e);
          var o = r.getTLV(t, e),
            h = o.length - 2 - r.getL(t, e).length;
          if (h !== 2 * a) throw new Error("V string length and L's value not the same:" + h + '/' + 2 * a);
          if (0 === e && t.length != o.length)
            throw new Error('total length and TLV length unmatch:' + t.length + '!=' + o.length);
          var l = t.substr(e, 2);
          if ('02' === l) {
            var c = r.getVidx(t, e);
            if ('00' == t.substr(c, 2) && t.charCodeAt(c + 2) < 56) throw new Error('not least zeros for DER INTEGER');
          }
          if (32 & parseInt(l, 16)) {
            for (var u = r.getVblen(t, e), d = 0, f = r.getChildIdx(t, e), p = 0; p < f.length; p++)
              ((d += r.getTLV(t, f[p]).length), r.checkStrictDER(t, f[p], i, s, n));
            if (2 * u != d) throw new Error("sum of children's TLV length and L unmatch: " + 2 * u + '!=' + d);
          }
        }),
        (at.oidname = function (t) {
          var e = st.asn1;
          st.lang.String.isHex(t) && (t = e.ASN1Util.oidHexToInt(t));
          var i = e.x509.OID.oid2name(t);
          return ('' === i && (i = t), i);
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.asn1 && st.asn1) || (st.asn1 = {}),
        (void 0 !== st.asn1.x509 && st.asn1.x509) || (st.asn1.x509 = {}),
        (st.asn1.x509.Certificate = function (t) {
          st.asn1.x509.Certificate.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERBitString,
            s = e.DERSequence,
            n = e.x509,
            r = n.TBSCertificate,
            a = n.AlgorithmIdentifier;
          ((this.params = void 0),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.sign = function () {
              var t = this.params,
                e = t.sigalg;
              null != t.sigalg.name && (e = t.sigalg.name);
              var i = t.tbsobj.tohex(),
                s = new st.crypto.Signature({ alg: e });
              (s.init(t.cakey), s.updateHex(i), (t.sighex = s.sign()));
            }),
            (this.getPEM = function () {
              return Mt(this.tohex(), 'CERTIFICATE');
            }),
            (this.tohex = function () {
              var t = this.params;
              if (
                ((null != t.tbsobj && null != t.tbsobj) || (t.tbsobj = new r(t)),
                null == t.sighex && null != t.cakey && this.sign(),
                null == t.sighex)
              )
                throw new Error('sighex or cakey parameter not defined');
              var e = [];
              return (
                e.push(t.tbsobj),
                e.push(new a({ name: t.sigalg })),
                e.push(new i({ hex: '00' + t.sighex })),
                new s({ array: e }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && (this.params = t));
        }),
        Zt(st.asn1.x509.Certificate, st.asn1.ASN1Object),
        (st.asn1.x509.TBSCertificate = function (t) {
          st.asn1.x509.TBSCertificate.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.x509,
            s = e.DERTaggedObject,
            n = e.DERInteger,
            r = e.DERSequence,
            a = i.AlgorithmIdentifier,
            o = i.Time,
            h = i.X500Name,
            l = i.Extensions,
            c = i.SubjectPublicKeyInfo;
          ((this.params = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t = [],
                e = this.params;
              if (null != e.version || 1 != e.version) {
                var i = 2;
                null != e.version && (i = e.version - 1);
                var u = new s({ obj: new n({ int: i }) });
                t.push(u);
              }
              return (
                t.push(new n(e.serial)),
                t.push(new a({ name: e.sigalg })),
                t.push(new h(e.issuer)),
                t.push(new r({ array: [new o(e.notbefore), new o(e.notafter)] })),
                t.push(new h(e.subject)),
                t.push(new c(Jt.getKey(e.sbjpubkey))),
                void 0 !== e.ext && e.ext.length > 0 && t.push(new s({ tag: 'a3', obj: new l(e.ext) })),
                new st.asn1.DERSequence({ array: t }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.TBSCertificate, st.asn1.ASN1Object),
        (st.asn1.x509.Extensions = function (t) {
          st.asn1.x509.Extensions.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.x509;
          ((this.aParam = []),
            (this.setByParam = function (t) {
              this.aParam = t;
            }),
            (this.tohex = function () {
              for (var t = [], e = 0; e < this.aParam.length; e++) {
                var n = this.aParam[e],
                  r = n.extname,
                  a = null;
                if (null != n.extn) a = new s.PrivateExtension(n);
                else if ('subjectKeyIdentifier' == r) a = new s.SubjectKeyIdentifier(n);
                else if ('keyUsage' == r) a = new s.KeyUsage(n);
                else if ('subjectAltName' == r) a = new s.SubjectAltName(n);
                else if ('issuerAltName' == r) a = new s.IssuerAltName(n);
                else if ('basicConstraints' == r) a = new s.BasicConstraints(n);
                else if ('nameConstraints' == r) a = new s.NameConstraints(n);
                else if ('cRLDistributionPoints' == r) a = new s.CRLDistributionPoints(n);
                else if ('certificatePolicies' == r) a = new s.CertificatePolicies(n);
                else if ('policyMappings' == r) a = new s.PolicyMappings(n);
                else if ('policyConstraints' == r) a = new s.PolicyConstraints(n);
                else if ('inhibitAnyPolicy' == r) a = new s.InhibitAnyPolicy(n);
                else if ('authorityKeyIdentifier' == r) a = new s.AuthorityKeyIdentifier(n);
                else if ('extKeyUsage' == r) a = new s.ExtKeyUsage(n);
                else if ('authorityInfoAccess' == r) a = new s.AuthorityInfoAccess(n);
                else if ('cRLNumber' == r) a = new s.CRLNumber(n);
                else if ('cRLReason' == r) a = new s.CRLReason(n);
                else if ('ocspNonce' == r) a = new s.OCSPNonce(n);
                else if ('ocspNoCheck' == r) a = new s.OCSPNoCheck(n);
                else if ('adobeTimeStamp' == r) a = new s.AdobeTimeStamp(n);
                else {
                  if ('subjectDirectoryAttributes' != r)
                    throw new Error('extension not supported:' + JSON.stringify(n));
                  a = new s.SubjectDirectoryAttributes(n);
                }
                null != a && t.push(a);
              }
              return new i({ array: t }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.Extensions, st.asn1.ASN1Object),
        (st.asn1.x509.Extension = function (t) {
          st.asn1.x509.Extension.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERObjectIdentifier,
            s = e.DEROctetString;
          e.DERBitString;
          var n = e.DERBoolean,
            r = e.DERSequence;
          ((this.tohex = function () {
            var t = new i({ oid: this.oid }),
              e = new s({ hex: this.getExtnValueHex() }),
              a = new Array();
            return (a.push(t), this.critical && a.push(new n()), a.push(e), new r({ array: a }).tohex());
          }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.critical = !1),
            void 0 !== t && void 0 !== t.critical && (this.critical = t.critical));
        }),
        Zt(st.asn1.x509.Extension, st.asn1.ASN1Object),
        (st.asn1.x509.KeyUsage = function (t) {
          st.asn1.x509.KeyUsage.superclass.constructor.call(this, t);
          var e = Error,
            i = {
              digitalSignature: 0,
              nonRepudiation: 1,
              keyEncipherment: 2,
              dataEncipherment: 3,
              keyAgreement: 4,
              keyCertSign: 5,
              cRLSign: 6,
              encipherOnly: 7,
              decipherOnly: 8,
            };
          ((this.getExtnValueHex = function () {
            var t = this.getBinValue();
            return ((this.asn1ExtnValue = new st.asn1.DERBitString({ bin: t })), this.asn1ExtnValue.tohex());
          }),
            (this.getBinValue = function () {
              var t = this.params;
              if ('object' != typeof t || ('object' != typeof t.names && 'string' != typeof t.bin))
                throw new e('parameter not yet set');
              if (null != t.names) return Xt(t.names, i);
              if (null != t.bin) return t.bin;
              throw new e('parameter not set properly');
            }),
            (this.oid = '2.5.29.15'),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.KeyUsage, st.asn1.x509.Extension),
        (st.asn1.x509.BasicConstraints = function (t) {
          st.asn1.x509.BasicConstraints.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.DERBoolean,
            s = e.DERInteger,
            n = e.DERSequence;
          ((this.getExtnValueHex = function () {
            var t = new Array();
            (this.cA && t.push(new i()), this.pathLen > -1 && t.push(new s({ int: this.pathLen })));
            var e = new n({ array: t });
            return ((this.asn1ExtnValue = e), this.asn1ExtnValue.tohex());
          }),
            (this.oid = '2.5.29.19'),
            (this.cA = !1),
            (this.pathLen = -1),
            void 0 !== t && (void 0 !== t.cA && (this.cA = t.cA), void 0 !== t.pathLen && (this.pathLen = t.pathLen)));
        }),
        Zt(st.asn1.x509.BasicConstraints, st.asn1.x509.Extension),
        (st.asn1.x509.CRLDistributionPoints = function (t) {
          st.asn1.x509.CRLDistributionPoints.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.x509;
          ((this.getExtnValueHex = function () {
            return this.asn1ExtnValue.tohex();
          }),
            (this.setByDPArray = function (t) {
              for (var s = [], n = 0; n < t.length; n++)
                if (t[n] instanceof st.asn1.ASN1Object) s.push(t[n]);
                else {
                  var r = new i.DistributionPoint(t[n]);
                  s.push(r);
                }
              this.asn1ExtnValue = new e.DERSequence({ array: s });
            }),
            (this.setByOneURI = function (t) {
              var e = new i.DistributionPoint({ fulluri: t });
              this.setByDPArray([e]);
            }),
            (this.oid = '2.5.29.31'),
            void 0 !== t &&
              (void 0 !== t.array ? this.setByDPArray(t.array) : void 0 !== t.uri && this.setByOneURI(t.uri)));
        }),
        Zt(st.asn1.x509.CRLDistributionPoints, st.asn1.x509.Extension),
        (st.asn1.x509.DistributionPoint = function (t) {
          st.asn1.x509.DistributionPoint.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.x509.DistributionPointName;
          ((this.tohex = function () {
            var t = new e.DERSequence();
            if (null != this.asn1DP) {
              var i = new e.DERTaggedObject({ explicit: !0, tag: 'a0', obj: this.asn1DP });
              t.appendASN1Object(i);
            }
            return ((this.hTLV = t.tohex()), this.hTLV);
          }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t &&
              (void 0 !== t.dpobj
                ? (this.asn1DP = t.dpobj)
                : void 0 !== t.dpname
                  ? (this.asn1DP = new i(t.dpname))
                  : void 0 !== t.fulluri && (this.asn1DP = new i({ full: [{ uri: t.fulluri }] }))));
        }),
        Zt(st.asn1.x509.DistributionPoint, st.asn1.ASN1Object),
        (st.asn1.x509.DistributionPointName = function (t) {
          st.asn1.x509.DistributionPointName.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERTaggedObject;
          if (
            ((this.tohex = function () {
              if ('full' != this.type) throw new Error("currently type shall be 'full': " + this.type);
              return (
                (this.asn1Obj = new i({ explicit: !1, tag: this.tag, obj: this.asn1V })),
                (this.hTLV = this.asn1Obj.tohex()),
                this.hTLV
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t)
          )
            if (e.x509.GeneralNames.prototype.isPrototypeOf(t))
              ((this.type = 'full'), (this.tag = 'a0'), (this.asn1V = t));
            else {
              if (void 0 === t.full) throw new Error('This class supports GeneralNames only as argument');
              ((this.type = 'full'), (this.tag = 'a0'), (this.asn1V = new e.x509.GeneralNames(t.full)));
            }
        }),
        Zt(st.asn1.x509.DistributionPointName, st.asn1.ASN1Object),
        (st.asn1.x509.CertificatePolicies = function (t) {
          st.asn1.x509.CertificatePolicies.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.x509,
            s = e.DERSequence,
            n = i.PolicyInformation;
          ((this.params = null),
            (this.getExtnValueHex = function () {
              for (var t = [], e = 0; e < this.params.array.length; e++) t.push(new n(this.params.array[e]));
              var i = new s({ array: t });
              return ((this.asn1ExtnValue = i), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '2.5.29.32'),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.CertificatePolicies, st.asn1.x509.Extension),
        (st.asn1.x509.PolicyInformation = function (t) {
          st.asn1.x509.PolicyInformation.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERObjectIdentifier,
            n = e.x509.PolicyQualifierInfo;
          ((this.params = null),
            (this.tohex = function () {
              if (void 0 === this.params.policyoid && void 0 === this.params.array)
                throw new Error('parameter oid and array missing');
              var t = [new s(this.params.policyoid)];
              if (void 0 !== this.params.array) {
                for (var e = [], r = 0; r < this.params.array.length; r++) e.push(new n(this.params.array[r]));
                e.length > 0 && t.push(new i({ array: e }));
              }
              return new i({ array: t }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.PolicyInformation, st.asn1.ASN1Object),
        (st.asn1.x509.PolicyQualifierInfo = function (t) {
          st.asn1.x509.PolicyQualifierInfo.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERIA5String,
            n = e.DERObjectIdentifier,
            r = e.x509.UserNotice;
          ((this.params = null),
            (this.tohex = function () {
              return void 0 !== this.params.cps
                ? new i({ array: [new n({ oid: '1.3.6.1.5.5.7.2.1' }), new s({ str: this.params.cps })] }).tohex()
                : null != this.params.unotice
                  ? new i({ array: [new n({ oid: '1.3.6.1.5.5.7.2.2' }), new r(this.params.unotice)] }).tohex()
                  : void 0;
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.PolicyQualifierInfo, st.asn1.ASN1Object),
        (st.asn1.x509.UserNotice = function (t) {
          st.asn1.x509.UserNotice.superclass.constructor.call(this, t);
          var e = st.asn1.DERSequence;
          st.asn1.DERInteger;
          var i = st.asn1.x509.DisplayText,
            s = st.asn1.x509.NoticeReference;
          ((this.params = null),
            (this.tohex = function () {
              var t = [];
              return (
                void 0 !== this.params.noticeref && t.push(new s(this.params.noticeref)),
                void 0 !== this.params.exptext && t.push(new i(this.params.exptext)),
                new e({ array: t }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.UserNotice, st.asn1.ASN1Object),
        (st.asn1.x509.NoticeReference = function (t) {
          st.asn1.x509.NoticeReference.superclass.constructor.call(this, t);
          var e = st.asn1.DERSequence,
            i = st.asn1.DERInteger,
            s = st.asn1.x509.DisplayText;
          ((this.params = null),
            (this.tohex = function () {
              var t = [];
              if ((void 0 !== this.params.org && t.push(new s(this.params.org)), void 0 !== this.params.noticenum)) {
                for (var n = [], r = this.params.noticenum, a = 0; a < r.length; a++) n.push(new i(r[a]));
                t.push(new e({ array: n }));
              }
              if (0 == t.length) throw new Error('parameter is empty');
              return new e({ array: t }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.NoticeReference, st.asn1.ASN1Object),
        (st.asn1.x509.DisplayText = function (t) {
          (st.asn1.x509.DisplayText.superclass.constructor.call(this, t),
            (this.hT = '0c'),
            void 0 !== t &&
              ('ia5' === t.type
                ? (this.hT = '16')
                : 'vis' === t.type
                  ? (this.hT = '1a')
                  : 'bmp' === t.type && (this.hT = '1e')));
        }),
        Zt(st.asn1.x509.DisplayText, st.asn1.DERAbstractString),
        (st.asn1.x509.PolicyMappings = function (t) {
          st.asn1.x509.PolicyMappings.superclass.constructor.call(this, t);
          var e = st.asn1;
          e.x509;
          var i = e.ASN1Util.newObject;
          ((this.params = null),
            (this.getExtnValueHex = function () {
              for (var t = this.params, e = [], s = 0; s < t.array.length; s++) {
                var n = t.array[s];
                e.push({ seq: [{ oid: n[0] }, { oid: n[1] }] });
              }
              return ((this.asn1ExtnValue = i({ seq: e })), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '2.5.29.33'),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.PolicyMappings, st.asn1.x509.Extension),
        (st.asn1.x509.PolicyConstraints = function (t) {
          st.asn1.x509.PolicyConstraints.superclass.constructor.call(this, t);
          var e = st.asn1;
          e.x509;
          var i = e.ASN1Util.newObject;
          ((this.params = null),
            (this.getExtnValueHex = function () {
              var t = this.params,
                e = [];
              return (
                null != t.reqexp && e.push({ tag: { tagi: '80', obj: { int: t.reqexp } } }),
                null != t.inhibit && e.push({ tag: { tagi: '81', obj: { int: t.inhibit } } }),
                (this.asn1ExtnValue = i({ seq: e })),
                this.asn1ExtnValue.tohex()
              );
            }),
            (this.oid = '2.5.29.36'),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.PolicyConstraints, st.asn1.x509.Extension),
        (st.asn1.x509.InhibitAnyPolicy = function (t) {
          st.asn1.x509.InhibitAnyPolicy.superclass.constructor.call(this, t);
          var e = st.asn1;
          e.x509;
          var i = e.ASN1Util.newObject;
          ((this.params = null),
            (this.getExtnValueHex = function () {
              return ((this.asn1ExtnValue = i({ int: this.params.skip })), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '2.5.29.54'),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.InhibitAnyPolicy, st.asn1.x509.Extension),
        (st.asn1.x509.NameConstraints = function (t) {
          st.asn1.x509.NameConstraints.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.x509,
            s = e.ASN1Util.newObject,
            n = i.GeneralSubtree;
          ((this.params = null),
            (this.getExtnValueHex = function () {
              var t = this.params,
                e = [];
              if (null != t.permit && null != t.permit.length) {
                for (var i = [], r = 0; r < t.permit.length; r++) i.push(new n(t.permit[r]));
                e.push({ tag: { tagi: 'a0', obj: { seq: i } } });
              }
              if (null != t.exclude && null != t.exclude.length) {
                var a = [];
                for (r = 0; r < t.exclude.length; r++) a.push(new n(t.exclude[r]));
                e.push({ tag: { tagi: 'a1', obj: { seq: a } } });
              }
              return ((this.asn1ExtnValue = s({ seq: e })), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '2.5.29.30'),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.NameConstraints, st.asn1.x509.Extension),
        (st.asn1.x509.GeneralSubtree = function (t) {
          st.asn1.x509.GeneralSubtree.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.x509.GeneralName,
            s = e.ASN1Util.newObject;
          ((this.params = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t = this.params,
                e = [new i(t)];
              return (
                null != t.min && e.push({ tag: { tagi: '80', obj: { int: t.min } } }),
                null != t.max && e.push({ tag: { tagi: '81', obj: { int: t.max } } }),
                s({ seq: e }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.GeneralSubtree, st.asn1.ASN1Object),
        (st.asn1.x509.ExtKeyUsage = function (t) {
          st.asn1.x509.ExtKeyUsage.superclass.constructor.call(this, t);
          var e = st.asn1;
          ((this.setPurposeArray = function (t) {
            this.asn1ExtnValue = new e.DERSequence();
            for (var i = 0; i < t.length; i++) {
              var s = new e.DERObjectIdentifier(t[i]);
              this.asn1ExtnValue.appendASN1Object(s);
            }
          }),
            (this.getExtnValueHex = function () {
              return this.asn1ExtnValue.tohex();
            }),
            (this.oid = '2.5.29.37'),
            void 0 !== t && void 0 !== t.array && this.setPurposeArray(t.array));
        }),
        Zt(st.asn1.x509.ExtKeyUsage, st.asn1.x509.Extension),
        (st.asn1.x509.AuthorityKeyIdentifier = function (t) {
          st.asn1.x509.AuthorityKeyIdentifier.superclass.constructor.call(this, t);
          var e = st,
            i = e.asn1,
            s = i.DERTaggedObject,
            n = i.x509.GeneralNames;
          (e.crypto.Util.isKey,
            (this.asn1KID = null),
            (this.asn1CertIssuer = null),
            (this.asn1CertSN = null),
            (this.getExtnValueHex = function () {
              var t = new Array();
              (this.asn1KID && t.push(new s({ explicit: !1, tag: '80', obj: this.asn1KID })),
                this.asn1CertIssuer &&
                  t.push(new s({ explicit: !1, tag: 'a1', obj: new n([{ dn: this.asn1CertIssuer }]) })),
                this.asn1CertSN && t.push(new s({ explicit: !1, tag: '82', obj: this.asn1CertSN })));
              var e = new i.DERSequence({ array: t });
              return ((this.asn1ExtnValue = e), this.asn1ExtnValue.tohex());
            }),
            (this.setKIDByParam = function (t) {
              if (void 0 !== t.str || void 0 !== t.hex) this.asn1KID = new st.asn1.DEROctetString(t);
              else if (
                ('object' == typeof t && st.crypto.Util.isKey(t)) ||
                ('string' == typeof t && -1 != t.indexOf('BEGIN '))
              ) {
                var e = t;
                'string' == typeof t && (e = Jt.getKey(t));
                var i = Jt.getKeyID(e);
                this.asn1KID = new st.asn1.DEROctetString({ hex: i });
              }
            }),
            (this.setCertIssuerByParam = function (t) {
              void 0 !== t.str ||
              void 0 !== t.ldapstr ||
              void 0 !== t.hex ||
              void 0 !== t.certsubject ||
              void 0 !== t.certissuer
                ? (this.asn1CertIssuer = new st.asn1.x509.X500Name(t))
                : 'string' == typeof t &&
                  -1 != t.indexOf('BEGIN ') &&
                  -1 != t.indexOf('CERTIFICATE') &&
                  (this.asn1CertIssuer = new st.asn1.x509.X500Name({ certissuer: t }));
            }),
            (this.setCertSNByParam = function (t) {
              if (void 0 !== t.str || void 0 !== t.bigint || void 0 !== t.hex)
                this.asn1CertSN = new st.asn1.DERInteger(t);
              else if ('string' == typeof t && -1 != t.indexOf('BEGIN ') && t.indexOf('CERTIFICATE')) {
                var e = new ie();
                e.readCertPEM(t);
                var i = e.getSerialNumberHex();
                this.asn1CertSN = new st.asn1.DERInteger({ hex: i });
              }
            }),
            (this.oid = '2.5.29.35'),
            void 0 !== t &&
              (void 0 !== t.kid && this.setKIDByParam(t.kid),
              void 0 !== t.issuer && this.setCertIssuerByParam(t.issuer),
              void 0 !== t.sn && this.setCertSNByParam(t.sn),
              void 0 !== t.issuersn &&
                'string' == typeof t.issuersn &&
                -1 != t.issuersn.indexOf('BEGIN ') &&
                t.issuersn.indexOf('CERTIFICATE') &&
                (this.setCertSNByParam(t.issuersn), this.setCertIssuerByParam(t.issuersn))));
        }),
        Zt(st.asn1.x509.AuthorityKeyIdentifier, st.asn1.x509.Extension),
        (st.asn1.x509.SubjectKeyIdentifier = function (t) {
          st.asn1.x509.SubjectKeyIdentifier.superclass.constructor.call(this, t);
          var e = st.asn1.DEROctetString;
          ((this.asn1KID = null),
            (this.getExtnValueHex = function () {
              return ((this.asn1ExtnValue = this.asn1KID), this.asn1ExtnValue.tohex());
            }),
            (this.setKIDByParam = function (t) {
              if (void 0 !== t.str || void 0 !== t.hex) this.asn1KID = new e(t);
              else if (
                ('object' == typeof t && st.crypto.Util.isKey(t)) ||
                ('string' == typeof t && -1 != t.indexOf('BEGIN'))
              ) {
                var i = t;
                'string' == typeof t && (i = Jt.getKey(t));
                var s = Jt.getKeyID(i);
                this.asn1KID = new st.asn1.DEROctetString({ hex: s });
              }
            }),
            (this.oid = '2.5.29.14'),
            void 0 !== t && void 0 !== t.kid && this.setKIDByParam(t.kid));
        }),
        Zt(st.asn1.x509.SubjectKeyIdentifier, st.asn1.x509.Extension),
        (st.asn1.x509.AuthorityInfoAccess = function (t) {
          (st.asn1.x509.AuthorityInfoAccess.superclass.constructor.call(this, t),
            (this.setAccessDescriptionArray = function (t) {
              for (
                var e = new Array(),
                  i = st.asn1,
                  s = i.DERSequence,
                  n = i.DERObjectIdentifier,
                  r = i.x509.GeneralName,
                  a = 0;
                a < t.length;
                a++
              ) {
                var o,
                  h = t[a];
                if (void 0 !== h.ocsp)
                  o = new s({ array: [new n({ oid: '1.3.6.1.5.5.7.48.1' }), new r({ uri: h.ocsp })] });
                else {
                  if (void 0 === h.caissuer) throw new Error('unknown AccessMethod parameter: ' + JSON.stringify(h));
                  o = new s({ array: [new n({ oid: '1.3.6.1.5.5.7.48.2' }), new r({ uri: h.caissuer })] });
                }
                e.push(o);
              }
              this.asn1ExtnValue = new s({ array: e });
            }),
            (this.getExtnValueHex = function () {
              return this.asn1ExtnValue.tohex();
            }),
            (this.oid = '1.3.6.1.5.5.7.1.1'),
            void 0 !== t && void 0 !== t.array && this.setAccessDescriptionArray(t.array));
        }),
        Zt(st.asn1.x509.AuthorityInfoAccess, st.asn1.x509.Extension),
        (st.asn1.x509.SubjectAltName = function (t) {
          (st.asn1.x509.SubjectAltName.superclass.constructor.call(this, t),
            (this.setNameArray = function (t) {
              this.asn1ExtnValue = new st.asn1.x509.GeneralNames(t);
            }),
            (this.getExtnValueHex = function () {
              return this.asn1ExtnValue.tohex();
            }),
            (this.oid = '2.5.29.17'),
            void 0 !== t && void 0 !== t.array && this.setNameArray(t.array));
        }),
        Zt(st.asn1.x509.SubjectAltName, st.asn1.x509.Extension),
        (st.asn1.x509.IssuerAltName = function (t) {
          (st.asn1.x509.IssuerAltName.superclass.constructor.call(this, t),
            (this.setNameArray = function (t) {
              this.asn1ExtnValue = new st.asn1.x509.GeneralNames(t);
            }),
            (this.getExtnValueHex = function () {
              return this.asn1ExtnValue.tohex();
            }),
            (this.oid = '2.5.29.18'),
            void 0 !== t && void 0 !== t.array && this.setNameArray(t.array));
        }),
        Zt(st.asn1.x509.IssuerAltName, st.asn1.x509.Extension),
        (st.asn1.x509.SubjectDirectoryAttributes = function (t) {
          st.asn1.x509.SubjectDirectoryAttributes.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.ASN1Util.newObject,
            n = e.x509.OID.name2oid;
          ((this.params = null),
            (this.getExtnValueHex = function () {
              for (var t = [], e = 0; e < this.params.array.length; e++) {
                var r = this.params.array[e];
                if (null == r.attr || null == r.array) {
                  var a = { seq: [{ oid: '1.2.3.4' }, { set: [{ utf8str: 'DE' }] }] };
                  if ('dateOfBirth' == r.attr) ((a.seq[0].oid = n(r.attr)), (a.seq[1].set[0] = { gentime: r.str }));
                  else if ('placeOfBirth' == r.attr)
                    ((a.seq[0].oid = n(r.attr)), (a.seq[1].set[0] = { utf8str: r.str }));
                  else if ('gender' == r.attr) ((a.seq[0].oid = n(r.attr)), (a.seq[1].set[0] = { prnstr: r.str }));
                  else if ('countryOfCitizenship' == r.attr)
                    ((a.seq[0].oid = n(r.attr)), (a.seq[1].set[0] = { prnstr: r.str }));
                  else {
                    if ('countryOfResidence' != r.attr) throw new Error('unsupported attribute: ' + r.attr);
                    ((a.seq[0].oid = n(r.attr)), (a.seq[1].set[0] = { prnstr: r.str }));
                  }
                  t.push(new s(a));
                } else {
                  var o = { seq: [{ oid: r.attr }, { set: r.array }] };
                  t.push(s(o));
                }
              }
              var h = new i({ array: t });
              return ((this.asn1ExtnValue = h), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '2.5.29.9'),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.x509.SubjectDirectoryAttributes, st.asn1.x509.Extension),
        (st.asn1.x509.PrivateExtension = function (t) {
          st.asn1.x509.PrivateExtension.superclass.constructor.call(this, t);
          var e = st,
            i = e.lang.String.isHex,
            s = e.asn1,
            n = s.x509.OID.name2oid,
            r = s.ASN1Util.newObject;
          ((this.params = null),
            (this.setByParam = function (t) {
              ((this.oid = n(t.extname)), (this.params = t));
            }),
            (this.getExtnValueHex = function () {
              if (null == this.params.extname || null == this.params.extn)
                throw new Error('extname or extnhex not specified');
              var t = this.params.extn;
              if ('string' == typeof t && i(t)) return t;
              if ('object' == typeof t)
                try {
                  return r(t).tohex();
                } catch (t) {}
              throw new Error('unsupported extn value');
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.PrivateExtension, st.asn1.x509.Extension),
        (st.asn1.x509.CRL = function (t) {
          st.asn1.x509.CRL.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERBitString,
            n = e.x509,
            r = n.AlgorithmIdentifier,
            a = n.TBSCertList;
          ((this.params = void 0),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.sign = function () {
              var t = new a(this.params).tohex(),
                e = new st.crypto.Signature({ alg: this.params.sigalg });
              (e.init(this.params.cakey), e.updateHex(t));
              var i = e.sign();
              this.params.sighex = i;
            }),
            (this.getPEM = function () {
              return Mt(this.tohex(), 'X509 CRL');
            }),
            (this.tohex = function () {
              var t = this.params;
              if (
                (null == t.tbsobj && (t.tbsobj = new a(t)),
                null == t.sighex && null != t.cakey && this.sign(),
                null == t.sighex)
              )
                throw new Error('sighex or cakey parameter not defined');
              var e = [];
              return (
                e.push(t.tbsobj),
                e.push(new r({ name: t.sigalg })),
                e.push(new s({ hex: '00' + t.sighex })),
                new i({ array: e }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && (this.params = t));
        }),
        Zt(st.asn1.x509.CRL, st.asn1.ASN1Object),
        (st.asn1.x509.TBSCertList = function (t) {
          st.asn1.x509.TBSCertList.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERInteger,
            s = e.DERSequence,
            n = e.DERTaggedObject;
          e.DERObjectIdentifier;
          var r = e.x509,
            a = r.AlgorithmIdentifier,
            o = r.Time,
            h = r.Extensions,
            l = r.X500Name;
          ((this.params = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.getRevCertSequence = function () {
              for (var t = [], e = this.params.revcert, n = 0; n < e.length; n++) {
                var r = [new i(e[n].sn), new o(e[n].date)];
                (null != e[n].ext && r.push(new h(e[n].ext)), t.push(new s({ array: r })));
              }
              return new s({ array: t });
            }),
            (this.tohex = function () {
              var t = [],
                e = this.params;
              if (null != e.version) {
                var r = e.version - 1,
                  c = new i({ int: r });
                t.push(c);
              }
              if (
                (t.push(new a({ name: e.sigalg })),
                t.push(new l(e.issuer)),
                t.push(new o(e.thisupdate)),
                null != e.nextupdate && t.push(new o(e.nextupdate)),
                null != e.revcert && t.push(this.getRevCertSequence()),
                null != e.ext)
              ) {
                var u = new h(e.ext);
                t.push(new n({ tag: 'a0', explicit: !0, obj: u }));
              }
              return new s({ array: t }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.TBSCertList, st.asn1.ASN1Object),
        (st.asn1.x509.CRLEntry = function (t) {
          st.asn1.x509.CRLEntry.superclass.constructor.call(this);
          var e = st.asn1;
          ((this.setCertSerial = function (t) {
            this.sn = new e.DERInteger(t);
          }),
            (this.setRevocationDate = function (t) {
              this.time = new e.x509.Time(t);
            }),
            (this.tohex = function () {
              var t = new e.DERSequence({ array: [this.sn, this.time] });
              return ((this.TLV = t.tohex()), this.TLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t &&
              (void 0 !== t.time && this.setRevocationDate(t.time), void 0 !== t.sn && this.setCertSerial(t.sn)));
        }),
        Zt(st.asn1.x509.CRLEntry, st.asn1.ASN1Object),
        (st.asn1.x509.CRLNumber = function (t) {
          (st.asn1.x509.CRLNumber.superclass.constructor.call(this, t),
            (this.params = void 0),
            (this.getExtnValueHex = function () {
              return ((this.asn1ExtnValue = new st.asn1.DERInteger(this.params.num)), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '2.5.29.20'),
            null != t && (this.params = t));
        }),
        Zt(st.asn1.x509.CRLNumber, st.asn1.x509.Extension),
        (st.asn1.x509.CRLReason = function (t) {
          (st.asn1.x509.CRLReason.superclass.constructor.call(this, t),
            (this.params = void 0),
            (this.getExtnValueHex = function () {
              return ((this.asn1ExtnValue = new st.asn1.DEREnumerated(this.params.code)), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '2.5.29.21'),
            null != t && (this.params = t));
        }),
        Zt(st.asn1.x509.CRLReason, st.asn1.x509.Extension),
        (st.asn1.x509.OCSPNonce = function (t) {
          (st.asn1.x509.OCSPNonce.superclass.constructor.call(this, t),
            (this.params = void 0),
            (this.getExtnValueHex = function () {
              return ((this.asn1ExtnValue = new st.asn1.DEROctetString(this.params)), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '1.3.6.1.5.5.7.48.1.2'),
            null != t && (this.params = t));
        }),
        Zt(st.asn1.x509.OCSPNonce, st.asn1.x509.Extension),
        (st.asn1.x509.OCSPNoCheck = function (t) {
          (st.asn1.x509.OCSPNoCheck.superclass.constructor.call(this, t),
            (this.params = void 0),
            (this.getExtnValueHex = function () {
              return ((this.asn1ExtnValue = new st.asn1.DERNull()), this.asn1ExtnValue.tohex());
            }),
            (this.oid = '1.3.6.1.5.5.7.48.1.5'),
            null != t && (this.params = t));
        }),
        Zt(st.asn1.x509.OCSPNoCheck, st.asn1.x509.Extension),
        (st.asn1.x509.AdobeTimeStamp = function (t) {
          st.asn1.x509.AdobeTimeStamp.superclass.constructor.call(this, t);
          var e = st.asn1,
            i = e.DERInteger,
            s = e.DERBoolean,
            n = e.DERSequence,
            r = e.x509.GeneralName;
          ((this.params = null),
            (this.getExtnValueHex = function () {
              var t = this.params,
                e = [new i(1)];
              return (
                e.push(new r({ uri: t.uri })),
                null != t.reqauth && e.push(new s(t.reqauth)),
                (this.asn1ExtnValue = new n({ array: e })),
                this.asn1ExtnValue.tohex()
              );
            }),
            (this.oid = '1.2.840.113583.1.1.9.1'),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.AdobeTimeStamp, st.asn1.x509.Extension),
        (st.asn1.x509.X500Name = function (t) {
          (st.asn1.x509.X500Name.superclass.constructor.call(this),
            (this.asn1Array = []),
            (this.paramArray = []),
            (this.sRule = 'utf8'));
          var e = st.asn1,
            i = e.x509,
            s = i.RDN;
          ((this.setByString = function (t, e) {
            void 0 !== e && (this.sRule = e);
            var i = t.split('/');
            i.shift();
            for (var n = [], r = 0; r < i.length; r++)
              if (i[r].match(/^[^=]+=.+$/)) n.push(i[r]);
              else {
                var a = n.length - 1;
                n[a] = n[a] + '/' + i[r];
              }
            for (r = 0; r < n.length; r++) this.asn1Array.push(new s({ str: n[r], rule: this.sRule }));
          }),
            (this.setByLdapString = function (t, e) {
              void 0 !== e && (this.sRule = e);
              var s = i.X500Name.ldapToCompat(t);
              this.setByString(s, e);
            }),
            (this.setByObject = function (t, e) {
              for (var i in (void 0 !== e && (this.sRule = e), t))
                if (t.hasOwnProperty(i)) {
                  var n = new s({ str: i + '=' + t[i], rule: this.sRule });
                  this.asn1Array ? this.asn1Array.push(n) : (this.asn1Array = [n]);
                }
            }),
            (this.setByParam = function (t) {
              var e;
              (void 0 !== t.rule && (this.sRule = t.rule),
                void 0 !== t.array
                  ? (this.paramArray = t.array)
                  : void 0 !== t.str
                    ? this.setByString(t.str)
                    : void 0 !== t.ldapstr
                      ? this.setByLdapString(t.ldapstr)
                      : void 0 !== t.hex
                        ? (this.hTLV = t.hex)
                        : void 0 !== t.certissuer
                          ? ((e = new ie()).readCertPEM(t.certissuer), (this.hTLV = e.getIssuerHex()))
                          : void 0 !== t.certsubject
                            ? ((e = new ie()).readCertPEM(t.certsubject), (this.hTLV = e.getSubjectHex()))
                            : 'object' == typeof t &&
                              void 0 === t.certsubject &&
                              void 0 === t.certissuer &&
                              this.setByObject(t));
            }),
            (this.tohex = function () {
              if ('string' == typeof this.hTLV) return this.hTLV;
              if (0 == this.asn1Array.length && this.paramArray.length > 0)
                for (var t = 0; t < this.paramArray.length; t++) {
                  var i = { array: this.paramArray[t] };
                  'utf8' != this.sRule && (i.rule = this.sRule);
                  var n = new s(i);
                  this.asn1Array.push(n);
                }
              var r = new e.DERSequence({ array: this.asn1Array });
              return ((this.hTLV = r.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.X500Name, st.asn1.ASN1Object),
        (st.asn1.x509.X500Name.compatToLDAP = function (t) {
          if ('/' !== t.substr(0, 1)) throw 'malformed input';
          var e = (t = t.substr(1)).split('/');
          return (
            e.reverse(),
            (e = e.map(function (t) {
              return t.replace(/,/, '\\,');
            })),
            e.join(',')
          );
        }),
        (st.asn1.x509.X500Name.onelineToLDAP = function (t) {
          return st.asn1.x509.X500Name.compatToLDAP(t);
        }),
        (st.asn1.x509.X500Name.ldapToCompat = function (t) {
          for (var e = t.split(','), i = !1, s = [], n = 0; e.length > 0; n++) {
            var r = e.shift();
            if (!0 === i) {
              var a = (s.pop() + ',' + r).replace(/\\,/g, ',');
              (s.push(a), (i = !1));
            } else s.push(r);
            '\\' === r.substr(-1, 1) && (i = !0);
          }
          return (
            (s = s.map(function (t) {
              return t.replace('/', '\\/');
            })),
            s.reverse(),
            '/' + s.join('/')
          );
        }),
        (st.asn1.x509.X500Name.ldapToOneline = function (t) {
          return st.asn1.x509.X500Name.ldapToCompat(t);
        }),
        (st.asn1.x509.RDN = function (t) {
          (st.asn1.x509.RDN.superclass.constructor.call(this),
            (this.asn1Array = []),
            (this.paramArray = []),
            (this.sRule = 'utf8'));
          var e = st.asn1.x509.AttributeTypeAndValue;
          ((this.setByParam = function (t) {
            (void 0 !== t.rule && (this.sRule = t.rule),
              void 0 !== t.str && this.addByMultiValuedString(t.str),
              void 0 !== t.array && (this.paramArray = t.array));
          }),
            (this.addByString = function (t) {
              this.asn1Array.push(new st.asn1.x509.AttributeTypeAndValue({ str: t, rule: this.sRule }));
            }),
            (this.addByMultiValuedString = function (t) {
              for (var e = st.asn1.x509.RDN.parseString(t), i = 0; i < e.length; i++) this.addByString(e[i]);
            }),
            (this.tohex = function () {
              if (0 == this.asn1Array.length && this.paramArray.length > 0)
                for (var t = 0; t < this.paramArray.length; t++) {
                  var i = this.paramArray[t];
                  void 0 !== i.rule && 'utf8' != this.sRule && (i.rule = this.sRule);
                  var s = new e(i);
                  this.asn1Array.push(s);
                }
              var n = new st.asn1.DERSet({ array: this.asn1Array });
              return ((this.TLV = n.tohex()), this.TLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.RDN, st.asn1.ASN1Object),
        (st.asn1.x509.RDN.parseString = function (t) {
          for (var e = t.split(/\+/), i = !1, s = [], n = 0; e.length > 0; n++) {
            var r = e.shift();
            if (!0 === i) {
              var a = (s.pop() + '+' + r).replace(/\\\+/g, '+');
              (s.push(a), (i = !1));
            } else s.push(r);
            '\\' === r.substr(-1, 1) && (i = !0);
          }
          var o = !1,
            h = [];
          for (n = 0; s.length > 0; n++) {
            if (((r = s.shift()), !0 === o)) {
              var l = h.pop();
              r.match(/"$/)
                ? ((a = (l + '+' + r).replace(/^([^=]+)="(.*)"$/, '$1=$2')), h.push(a), (o = !1))
                : h.push(l + '+' + r);
            } else h.push(r);
            r.match(/^[^=]+="/) && (o = !0);
          }
          return h;
        }),
        (st.asn1.x509.AttributeTypeAndValue = function (t) {
          (st.asn1.x509.AttributeTypeAndValue.superclass.constructor.call(this),
            (this.sRule = 'utf8'),
            (this.sType = null),
            (this.sValue = null),
            (this.dsType = null));
          var e = st,
            i = e.asn1,
            s = i.DERSequence,
            n = i.DERUTF8String,
            r = i.DERPrintableString,
            a = i.DERTeletexString,
            o = i.DERIA5String,
            h = i.DERVisibleString,
            l = i.DERBMPString,
            c = e.lang.String.isMail,
            u = e.lang.String.isPrintable;
          ((this.setByParam = function (t) {
            if (
              (void 0 !== t.rule && (this.sRule = t.rule),
              void 0 !== t.ds && (this.dsType = t.ds),
              void 0 === t.value && void 0 !== t.str)
            ) {
              var e = t.str.match(/^([^=]+)=(.+)$/);
              if (!e) throw new Error('malformed attrTypeAndValueStr: ' + attrTypeAndValueStr);
              ((this.sType = e[1]), (this.sValue = e[2]));
            } else ((this.sType = t.type), (this.sValue = t.value));
          }),
            (this.setByString = function (t, e) {
              void 0 !== e && (this.sRule = e);
              var i = t.match(/^([^=]+)=(.+)$/);
              if (!i) throw new Error('malformed attrTypeAndValueStr: ' + attrTypeAndValueStr);
              this.setByAttrTypeAndValueStr(i[1], i[2]);
            }),
            (this._getDsType = function () {
              var t = this.sType,
                e = this.sValue,
                i = this.sRule;
              return 'prn' === i
                ? 'CN' == t && c(e)
                  ? 'ia5'
                  : u(e)
                    ? 'prn'
                    : 'utf8'
                : 'utf8' === i
                  ? 'CN' == t && c(e)
                    ? 'ia5'
                    : 'C' == t
                      ? 'prn'
                      : 'utf8'
                  : 'utf8';
            }),
            (this.setByAttrTypeAndValueStr = function (t, e, i) {
              (void 0 !== i && (this.sRule = i), (this.sType = t), (this.sValue = e));
            }),
            (this.getValueObj = function (t, e) {
              if ('utf8' == t) return new n({ str: e });
              if ('prn' == t) return new r({ str: e });
              if ('tel' == t) return new a({ str: e });
              if ('ia5' == t) return new o({ str: e });
              if ('vis' == t) return new h({ str: e });
              if ('bmp' == t) return new l({ str: e });
              throw new Error('unsupported directory string type: type=' + t + ' value=' + e);
            }),
            (this.tohex = function () {
              null == this.dsType && (this.dsType = this._getDsType());
              var t = st.asn1.x509.OID.atype2obj(this.sType),
                e = this.getValueObj(this.dsType, this.sValue),
                i = new s({ array: [t, e] });
              return ((this.TLV = i.tohex()), this.TLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.AttributeTypeAndValue, st.asn1.ASN1Object),
        (st.asn1.x509.SubjectPublicKeyInfo = function (t) {
          st.asn1.x509.SubjectPublicKeyInfo.superclass.constructor.call(this);
          var e = st,
            i = e.asn1,
            s = i.DERInteger,
            n = i.DERBitString,
            r = i.DERObjectIdentifier,
            a = i.DERSequence,
            o = i.ASN1Util.newObject,
            h = i.x509.AlgorithmIdentifier,
            l = e.crypto;
          (l.ECDSA,
            l.DSA,
            (this.getASN1Object = function () {
              if (null == this.asn1AlgId || null == this.asn1SubjPKey) throw 'algId and/or subjPubKey not set';
              return new a({ array: [this.asn1AlgId, this.asn1SubjPKey] });
            }),
            (this.tohex = function () {
              var t = this.getASN1Object();
              return ((this.hTLV = t.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setPubKey = function (t) {
              try {
                if (t instanceof J) {
                  var e = o({ seq: [{ int: { bigint: t.n } }, { int: { int: t.e } }] }).tohex();
                  ((this.asn1AlgId = new h({ name: 'rsaEncryption' })), (this.asn1SubjPKey = new n({ hex: '00' + e })));
                }
              } catch (t) {}
              try {
                if (t instanceof st.crypto.ECDSA) {
                  var i = new r({ name: t.curveName });
                  ((this.asn1AlgId = new h({ name: 'ecPublicKey', asn1params: i })),
                    (this.asn1SubjPKey = new n({ hex: '00' + t.pubKeyHex })));
                }
              } catch (t) {}
              try {
                if (t instanceof st.crypto.DSA) {
                  ((i = new o({ seq: [{ int: { bigint: t.p } }, { int: { bigint: t.q } }, { int: { bigint: t.g } }] })),
                    (this.asn1AlgId = new h({ name: 'dsa', asn1params: i })));
                  var a = new s({ bigint: t.y });
                  this.asn1SubjPKey = new n({ hex: '00' + a.tohex() });
                }
              } catch (t) {}
            }),
            void 0 !== t && this.setPubKey(t));
        }),
        Zt(st.asn1.x509.SubjectPublicKeyInfo, st.asn1.ASN1Object),
        (st.asn1.x509.Time = function (t) {
          st.asn1.x509.Time.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERUTCTime,
            s = e.DERGeneralizedTime;
          ((this.params = null),
            (this.type = null),
            (this.setTimeParams = function (t) {
              this.timeParams = t;
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.getType = function (t) {
              return t.match(/^[0-9]{12}Z$/)
                ? 'utc'
                : t.match(/^[0-9]{14}Z$/)
                  ? 'gen'
                  : t.match(/^[0-9]{12}\.[0-9]+Z$/)
                    ? 'utc'
                    : t.match(/^[0-9]{14}\.[0-9]+Z$/)
                      ? 'gen'
                      : null;
            }),
            (this.tohex = function () {
              var t = this.params,
                e = null;
              if (
                ('string' == typeof t && (t = { str: t }),
                null == t || !t.str || (null != t.type && null != t.type) || (t.type = this.getType(t.str)),
                null != t && t.str
                  ? ('utc' == t.type && (e = new i(t.str)), 'gen' == t.type && (e = new s(t.str)))
                  : (e = 'gen' == this.type ? new s() : new i()),
                null == e)
              )
                throw new Error('wrong setting for Time');
              return ((this.TLV = e.tohex()), this.TLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        (st.asn1.x509.Time_bak = function (t) {
          st.asn1.x509.Time_bak.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERUTCTime,
            s = e.DERGeneralizedTime;
          ((this.setTimeParams = function (t) {
            this.timeParams = t;
          }),
            (this.tohex = function () {
              var t = null;
              return (
                (t =
                  null != this.timeParams
                    ? 'utc' == this.type
                      ? new i(this.timeParams)
                      : new s(this.timeParams)
                    : 'utc' == this.type
                      ? new i()
                      : new s()),
                (this.TLV = t.tohex()),
                this.TLV
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.type = 'utc'),
            void 0 !== t &&
              (void 0 !== t.type
                ? (this.type = t.type)
                : void 0 !== t.str &&
                  (t.str.match(/^[0-9]{12}Z$/) && (this.type = 'utc'),
                  t.str.match(/^[0-9]{14}Z$/) && (this.type = 'gen')),
              (this.timeParams = t)));
        }),
        Zt(st.asn1.x509.Time, st.asn1.ASN1Object),
        (st.asn1.x509.AlgorithmIdentifier = function (t) {
          (st.asn1.x509.AlgorithmIdentifier.superclass.constructor.call(this),
            (this.nameAlg = null),
            (this.asn1Alg = null),
            (this.asn1Params = null),
            (this.paramEmpty = !1));
          var e = st.asn1,
            i = e.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
          if (
            ((this.tohex = function () {
              if (null === this.nameAlg && null === this.asn1Alg) throw new Error('algorithm not specified');
              if (null !== this.nameAlg) {
                var t = null;
                for (var s in i) s === this.nameAlg && (t = i[s]);
                if (null !== t) return ((this.hTLV = t), this.hTLV);
              }
              null !== this.nameAlg && null === this.asn1Alg && (this.asn1Alg = e.x509.OID.name2obj(this.nameAlg));
              var n = [this.asn1Alg];
              null !== this.asn1Params && n.push(this.asn1Params);
              var r = new e.DERSequence({ array: n });
              return ((this.hTLV = r.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t &&
              (void 0 !== t.name && (this.nameAlg = t.name),
              void 0 !== t.asn1params && (this.asn1Params = t.asn1params),
              void 0 !== t.paramempty && (this.paramEmpty = t.paramempty)),
            null === this.asn1Params && !1 === this.paramEmpty && null !== this.nameAlg)
          ) {
            void 0 !== this.nameAlg.name && (this.nameAlg = this.nameAlg.name);
            var s = this.nameAlg.toLowerCase();
            'withdsa' !== s.substr(-7, 7) && 'withecdsa' !== s.substr(-9, 9) && (this.asn1Params = new e.DERNull());
          }
        }),
        Zt(st.asn1.x509.AlgorithmIdentifier, st.asn1.ASN1Object),
        (st.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV = {
          SHAwithRSAandMGF1: '300d06092a864886f70d01010a3000',
          SHA256withRSAandMGF1:
            '303d06092a864886f70d01010a3030a00d300b0609608648016503040201a11a301806092a864886f70d010108300b0609608648016503040201a203020120',
          SHA384withRSAandMGF1:
            '303d06092a864886f70d01010a3030a00d300b0609608648016503040202a11a301806092a864886f70d010108300b0609608648016503040202a203020130',
          SHA512withRSAandMGF1:
            '303d06092a864886f70d01010a3030a00d300b0609608648016503040203a11a301806092a864886f70d010108300b0609608648016503040203a203020140',
        }),
        (st.asn1.x509.GeneralName = function (t) {
          st.asn1.x509.GeneralName.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.x509,
            s = i.X500Name,
            n = i.OtherName,
            r = e.DERIA5String;
          e.DERPrintableString;
          var a = e.DEROctetString,
            o = e.DERTaggedObject,
            h = e.ASN1Object,
            l = Error;
          ((this.params = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t,
                e,
                i = this.params,
                c = !1;
              if (void 0 !== i.other) ((t = 'a0'), (e = new n(i.other)));
              else if (void 0 !== i.rfc822) ((t = '81'), (e = new r({ str: i.rfc822 })));
              else if (void 0 !== i.dns) ((t = '82'), (e = new r({ str: i.dns })));
              else if (void 0 !== i.dn)
                ((t = 'a4'),
                  (c = !0),
                  (e =
                    'string' == typeof i.dn
                      ? new s({ str: i.dn })
                      : i.dn instanceof st.asn1.x509.X500Name
                        ? i.dn
                        : new s(i.dn)));
              else if (void 0 !== i.ldapdn) ((t = 'a4'), (c = !0), (e = new s({ ldapstr: i.ldapdn })));
              else if (void 0 !== i.certissuer || void 0 !== i.certsubj) {
                var u, d;
                ((t = 'a4'), (c = !0));
                var f = null;
                if (
                  (void 0 !== i.certsubj ? ((u = !1), (d = i.certsubj)) : ((u = !0), (d = i.certissuer)),
                  d.match(/^[0-9A-Fa-f]+$/),
                  -1 != d.indexOf('-----BEGIN ') && (f = Ct(d)),
                  null == f)
                )
                  throw new Error('certsubj/certissuer not cert');
                var p,
                  m = new ie();
                ((m.hex = f), (p = u ? m.getIssuerHex() : m.getSubjectHex()), ((e = new h()).hTLV = p));
              } else if (void 0 !== i.uri) ((t = '86'), (e = new r({ str: i.uri })));
              else {
                if (void 0 === i.ip) throw new l('improper params');
                var g;
                t = '87';
                var y = i.ip;
                try {
                  if (y.match(/^[0-9a-f]+$/)) {
                    var x = y.length;
                    if (8 != x && 16 != x && 32 != x && 64 != x) throw 'err';
                    g = y;
                  } else g = Nt(y);
                } catch (t) {
                  throw new l('malformed IP address: ' + i.ip + ':' + t.message);
                }
                e = new a({ hex: g });
              }
              return new o({ tag: t, explicit: c, obj: e }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.GeneralName, st.asn1.ASN1Object),
        (st.asn1.x509.GeneralNames = function (t) {
          st.asn1.x509.GeneralNames.superclass.constructor.call(this);
          var e = st.asn1;
          ((this.setByParamArray = function (t) {
            for (var i = 0; i < t.length; i++) {
              var s = new e.x509.GeneralName(t[i]);
              this.asn1Array.push(s);
            }
          }),
            (this.tohex = function () {
              return new e.DERSequence({ array: this.asn1Array }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.asn1Array = new Array()),
            void 0 !== t && this.setByParamArray(t));
        }),
        Zt(st.asn1.x509.GeneralNames, st.asn1.ASN1Object),
        (st.asn1.x509.OtherName = function (t) {
          st.asn1.x509.OtherName.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERObjectIdentifier,
            s = e.DERSequence,
            n = e.ASN1Util.newObject;
          ((this.params = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t = this.params;
              if (null == t.oid || null == t.value) throw new Error('oid or value not specified');
              var e = new i({ oid: t.oid }),
                r = n({ tag: { tag: 'a0', explicit: !0, obj: t.value } });
              return new s({ array: [e, r] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.x509.OtherName, st.asn1.ASN1Object),
        (st.asn1.x509.OID = new (function () {
          var t = st.asn1.DERObjectIdentifier;
          ((this.name2oidList = {
            'aes128-CBC': '2.16.840.1.101.3.4.1.2',
            'aes256-CBC': '2.16.840.1.101.3.4.1.42',
            sha1: '1.3.14.3.2.26',
            sha256: '2.16.840.1.101.3.4.2.1',
            sha384: '2.16.840.1.101.3.4.2.2',
            sha512: '2.16.840.1.101.3.4.2.3',
            sha224: '2.16.840.1.101.3.4.2.4',
            md5: '1.2.840.113549.2.5',
            md2: '1.3.14.7.2.2.1',
            ripemd160: '1.3.36.3.2.1',
            hmacWithSHA1: '1.2.840.113549.2.7',
            hmacWithSHA224: '1.2.840.113549.2.8',
            hmacWithSHA256: '1.2.840.113549.2.9',
            hmacWithSHA384: '1.2.840.113549.2.10',
            hmacWithSHA512: '1.2.840.113549.2.11',
            MD2withRSA: '1.2.840.113549.1.1.2',
            MD4withRSA: '1.2.840.113549.1.1.3',
            MD5withRSA: '1.2.840.113549.1.1.4',
            SHA1withRSA: '1.2.840.113549.1.1.5',
            'pkcs1-MGF': '1.2.840.113549.1.1.8',
            rsaPSS: '1.2.840.113549.1.1.10',
            SHA224withRSA: '1.2.840.113549.1.1.14',
            SHA256withRSA: '1.2.840.113549.1.1.11',
            SHA384withRSA: '1.2.840.113549.1.1.12',
            SHA512withRSA: '1.2.840.113549.1.1.13',
            SHA1withECDSA: '1.2.840.10045.4.1',
            SHA224withECDSA: '1.2.840.10045.4.3.1',
            SHA256withECDSA: '1.2.840.10045.4.3.2',
            SHA384withECDSA: '1.2.840.10045.4.3.3',
            SHA512withECDSA: '1.2.840.10045.4.3.4',
            dsa: '1.2.840.10040.4.1',
            SHA1withDSA: '1.2.840.10040.4.3',
            SHA224withDSA: '2.16.840.1.101.3.4.3.1',
            SHA256withDSA: '2.16.840.1.101.3.4.3.2',
            rsaEncryption: '1.2.840.113549.1.1.1',
            commonName: '2.5.4.3',
            countryName: '2.5.4.6',
            localityName: '2.5.4.7',
            stateOrProvinceName: '2.5.4.8',
            streetAddress: '2.5.4.9',
            organizationName: '2.5.4.10',
            organizationalUnitName: '2.5.4.11',
            domainComponent: '0.9.2342.19200300.100.1.25',
            userId: '0.9.2342.19200300.100.1.1',
            surname: '2.5.4.4',
            givenName: '2.5.4.42',
            title: '2.5.4.12',
            distinguishedName: '2.5.4.49',
            emailAddress: '1.2.840.113549.1.9.1',
            description: '2.5.4.13',
            businessCategory: '2.5.4.15',
            postalCode: '2.5.4.17',
            uniqueIdentifier: '2.5.4.45',
            organizationIdentifier: '2.5.4.97',
            jurisdictionOfIncorporationL: '1.3.6.1.4.1.311.60.2.1.1',
            jurisdictionOfIncorporationSP: '1.3.6.1.4.1.311.60.2.1.2',
            jurisdictionOfIncorporationC: '1.3.6.1.4.1.311.60.2.1.3',
            subjectDirectoryAttributes: '2.5.29.9',
            subjectKeyIdentifier: '2.5.29.14',
            keyUsage: '2.5.29.15',
            subjectAltName: '2.5.29.17',
            issuerAltName: '2.5.29.18',
            basicConstraints: '2.5.29.19',
            cRLNumber: '2.5.29.20',
            cRLReason: '2.5.29.21',
            nameConstraints: '2.5.29.30',
            cRLDistributionPoints: '2.5.29.31',
            certificatePolicies: '2.5.29.32',
            anyPolicy: '2.5.29.32.0',
            policyMappings: '2.5.29.33',
            authorityKeyIdentifier: '2.5.29.35',
            policyConstraints: '2.5.29.36',
            extKeyUsage: '2.5.29.37',
            inhibitAnyPolicy: '2.5.29.54',
            authorityInfoAccess: '1.3.6.1.5.5.7.1.1',
            ocsp: '1.3.6.1.5.5.7.48.1',
            ocspBasic: '1.3.6.1.5.5.7.48.1.1',
            ocspNonce: '1.3.6.1.5.5.7.48.1.2',
            ocspNoCheck: '1.3.6.1.5.5.7.48.1.5',
            caIssuers: '1.3.6.1.5.5.7.48.2',
            anyExtendedKeyUsage: '2.5.29.37.0',
            serverAuth: '1.3.6.1.5.5.7.3.1',
            clientAuth: '1.3.6.1.5.5.7.3.2',
            codeSigning: '1.3.6.1.5.5.7.3.3',
            emailProtection: '1.3.6.1.5.5.7.3.4',
            timeStamping: '1.3.6.1.5.5.7.3.8',
            ocspSigning: '1.3.6.1.5.5.7.3.9',
            smtpUTF8Mailbox: '1.3.6.1.5.5.7.8.9',
            dateOfBirth: '1.3.6.1.5.5.7.9.1',
            placeOfBirth: '1.3.6.1.5.5.7.9.2',
            gender: '1.3.6.1.5.5.7.9.3',
            countryOfCitizenship: '1.3.6.1.5.5.7.9.4',
            countryOfResidence: '1.3.6.1.5.5.7.9.5',
            ecPublicKey: '1.2.840.10045.2.1',
            'P-256': '1.2.840.10045.3.1.7',
            secp256r1: '1.2.840.10045.3.1.7',
            secp256k1: '1.3.132.0.10',
            secp384r1: '1.3.132.0.34',
            secp521r1: '1.3.132.0.35',
            pkcs5PBES2: '1.2.840.113549.1.5.13',
            pkcs5PBKDF2: '1.2.840.113549.1.5.12',
            'des-EDE3-CBC': '1.2.840.113549.3.7',
            data: '1.2.840.113549.1.7.1',
            'signed-data': '1.2.840.113549.1.7.2',
            'enveloped-data': '1.2.840.113549.1.7.3',
            'digested-data': '1.2.840.113549.1.7.5',
            'encrypted-data': '1.2.840.113549.1.7.6',
            'authenticated-data': '1.2.840.113549.1.9.16.1.2',
            tstinfo: '1.2.840.113549.1.9.16.1.4',
            signingCertificate: '1.2.840.113549.1.9.16.2.12',
            timeStampToken: '1.2.840.113549.1.9.16.2.14',
            signaturePolicyIdentifier: '1.2.840.113549.1.9.16.2.15',
            etsArchiveTimeStamp: '1.2.840.113549.1.9.16.2.27',
            signingCertificateV2: '1.2.840.113549.1.9.16.2.47',
            etsArchiveTimeStampV2: '1.2.840.113549.1.9.16.2.48',
            extensionRequest: '1.2.840.113549.1.9.14',
            contentType: '1.2.840.113549.1.9.3',
            messageDigest: '1.2.840.113549.1.9.4',
            signingTime: '1.2.840.113549.1.9.5',
            counterSignature: '1.2.840.113549.1.9.6',
            archiveTimeStampV3: '0.4.0.1733.2.4',
            pdfRevocationInfoArchival: '1.2.840.113583.1.1.8',
            adobeTimeStamp: '1.2.840.113583.1.1.9.1',
            smimeMailboxLegacy: '2.23.140.1.5.1.1',
            smimeMailboxMulti: '2.23.140.1.5.1.2',
            smimeMailboxStrict: '2.23.140.1.5.1.3',
            smimeOrganizationLegacy: '2.23.140.1.5.2.1',
            smimeOrganizationMulti: '2.23.140.1.5.2.2',
            smimeOrganizationStrict: '2.23.140.1.5.2.3',
            smimeSponsorLegacy: '2.23.140.1.5.3.1',
            smimeSponsorMulti: '2.23.140.1.5.3.2',
            smimeSponsorStrict: '2.23.140.1.5.3.3',
            smimeIndividualLegacy: '2.23.140.1.5.4.1',
            smimeIndividualMulti: '2.23.140.1.5.4.2',
            smimeIndividualStrict: '2.23.140.1.5.4.3',
          }),
            (this.atype2oidList = {
              CN: '2.5.4.3',
              L: '2.5.4.7',
              ST: '2.5.4.8',
              O: '2.5.4.10',
              OU: '2.5.4.11',
              C: '2.5.4.6',
              STREET: '2.5.4.9',
              DC: '0.9.2342.19200300.100.1.25',
              UID: '0.9.2342.19200300.100.1.1',
              SN: '2.5.4.4',
              T: '2.5.4.12',
              GN: '2.5.4.42',
              DN: '2.5.4.49',
              E: '1.2.840.113549.1.9.1',
              description: '2.5.4.13',
              businessCategory: '2.5.4.15',
              postalCode: '2.5.4.17',
              serialNumber: '2.5.4.5',
              uniqueIdentifier: '2.5.4.45',
              organizationIdentifier: '2.5.4.97',
              jurisdictionOfIncorporationL: '1.3.6.1.4.1.311.60.2.1.1',
              jurisdictionOfIncorporationSP: '1.3.6.1.4.1.311.60.2.1.2',
              jurisdictionOfIncorporationC: '1.3.6.1.4.1.311.60.2.1.3',
            }),
            (this.objCache = {}),
            (this.name2obj = function (e) {
              if (void 0 !== this.objCache[e]) return this.objCache[e];
              if (void 0 === this.name2oidList[e]) throw 'Name of ObjectIdentifier not defined: ' + e;
              var i = this.name2oidList[e],
                s = new t({ oid: i });
              return ((this.objCache[e] = s), s);
            }),
            (this.atype2obj = function (e) {
              if (void 0 !== this.objCache[e]) return this.objCache[e];
              var i;
              if (e.match(/^\d+\.\d+\.[0-9.]+$/)) i = e;
              else if (void 0 !== this.atype2oidList[e]) i = this.atype2oidList[e];
              else {
                if (void 0 === this.name2oidList[e]) throw new Error('AttributeType name undefined: ' + e);
                i = this.name2oidList[e];
              }
              var s = new t({ oid: i });
              return ((this.objCache[e] = s), s);
            }),
            (this.registerOIDs = function (t) {
              if (this.checkOIDs(t)) for (var e in t) this.name2oidList[e] = t[e];
            }),
            (this.checkOIDs = function (t) {
              try {
                var e = Object.keys(t);
                return (
                  0 != e.length &&
                  (e.map(function (t, e, i) {
                    if (!this[t].match(/^[0-2]\.[0-9.]+$/)) throw new Error('value is not OID');
                  }, t),
                  !0)
                );
              } catch (t) {
                return !1;
              }
            }));
        })()),
        (st.asn1.x509.OID.oid2name = function (t) {
          var e = st.asn1.x509.OID.name2oidList;
          for (var i in e) if (e[i] == t) return i;
          return '';
        }),
        (st.asn1.x509.OID.oid2atype = function (t) {
          var e = st.asn1.x509.OID.atype2oidList;
          for (var i in e) if (e[i] == t) return i;
          return t;
        }),
        (st.asn1.x509.OID.name2oid = function (t) {
          if (t.match(/^[0-9.]+$/)) return t;
          var e = st.asn1.x509.OID.name2oidList;
          return void 0 === e[t] ? '' : e[t];
        }),
        (st.asn1.x509.X509Util = {}),
        (st.asn1.x509.X509Util.newCertPEM = function (t) {
          var e = st.asn1.x509;
          return (e.TBSCertificate, new (0, e.Certificate)(t).getPEM());
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.asn1 && st.asn1) || (st.asn1 = {}),
        (void 0 !== st.asn1.cms && st.asn1.cms) || (st.asn1.cms = {}),
        (st.asn1.cms.Attribute = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERSequence,
            n = i.DERSet,
            r = i.DERObjectIdentifier;
          ((this.params = null),
            (this.typeOid = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.getValueArray = function () {
              throw new e('not yet implemented abstract');
            }),
            (this.tohex = function () {
              var t = new r({ oid: this.typeOid }),
                e = new n({ array: this.getValueArray() });
              return new s({ array: [t, e] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }));
        }),
        Zt(st.asn1.cms.Attribute, st.asn1.ASN1Object),
        (st.asn1.cms.ContentType = function (t) {
          var e = st.asn1;
          (e.cms.ContentType.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.3'),
            (this.getValueArray = function () {
              return [new e.DERObjectIdentifier(this.params.type)];
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.ContentType, st.asn1.cms.Attribute),
        (st.asn1.cms.MessageDigest = function (t) {
          var e = st.asn1,
            i = e.DEROctetString;
          (e.cms.MessageDigest.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.4'),
            (this.getValueArray = function () {
              return [new i(this.params)];
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.MessageDigest, st.asn1.cms.Attribute),
        (st.asn1.cms.SigningTime = function (t) {
          var e = st.asn1;
          (e.cms.SigningTime.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.5'),
            (this.getValueArray = function () {
              return [new e.x509.Time(this.params)];
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.SigningTime, st.asn1.cms.Attribute),
        (st.asn1.cms.SigningCertificate = function (t) {
          var e = Error,
            i = st,
            s = i.asn1,
            n = s.DERSequence,
            r = s.cms,
            a = r.ESSCertID;
          (i.crypto,
            r.SigningCertificate.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.16.2.12'),
            (this.getValueArray = function () {
              if (null == this.params || null == this.params || null == this.params.array)
                throw new e("parameter 'array' not specified");
              for (var i = this.params.array, s = [], r = 0; r < i.length; r++) {
                var o = i[r];
                (0 != t.hasis ||
                  'string' != typeof o ||
                  (-1 == o.indexOf('-----BEGIN') && !at.isASN1HEX(o)) ||
                  (o = { cert: o }),
                  0 != o.hasis && 0 == t.hasis && (o.hasis = !1),
                  s.push(new a(o)));
              }
              var h = new n({ array: s });
              return [new n({ array: [h] })];
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.SigningCertificate, st.asn1.cms.Attribute),
        (st.asn1.cms.ESSCertID = function (t) {
          st.asn1.cms.ESSCertID.superclass.constructor.call(this);
          var e = Error,
            i = st,
            s = i.asn1,
            n = s.DEROctetString,
            r = s.DERSequence,
            a = s.cms.IssuerSerial;
          ((this.params = null),
            (this.getCertHash = function (t, s) {
              if (null != t.hash) return t.hash;
              if ('string' == typeof t && -1 == t.indexOf('-----BEGIN') && !at.isASN1HEX(t)) return t;
              var n, r, a;
              if ('string' == typeof t) n = t;
              else {
                if (null == t.cert) throw new e('hash nor cert unspecified');
                n = t.cert;
              }
              if (
                ((r = -1 != n.indexOf('-----BEGIN') ? Ct(n) : n),
                'string' == typeof t && (-1 != t.indexOf('-----BEGIN') ? (r = Ct(t)) : at.isASN1HEX(t) && (r = t)),
                null != t.alg)
              )
                a = t.alg;
              else {
                if (null == s) throw new e('hash alg unspecified');
                a = s;
              }
              return i.crypto.Util.hashHex(r, a);
            }),
            (this.tohex = function () {
              var t = this.params,
                e = this.getCertHash(t, 'sha1'),
                i = [];
              return (
                i.push(new n({ hex: e })),
                (('string' == typeof t && -1 != t.indexOf('-----BEGIN')) ||
                  (null != t.cert && 0 != t.hasis) ||
                  (null != t.issuer && null != t.serial)) &&
                  i.push(new a(t)),
                new r({ array: i }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.ESSCertID, st.asn1.ASN1Object),
        (st.asn1.cms.SigningCertificateV2 = function (t) {
          var e = Error,
            i = st,
            s = i.asn1,
            n = s.DERSequence;
          s.x509;
          var r = s.cms,
            a = r.ESSCertIDv2;
          (i.crypto,
            r.SigningCertificateV2.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.16.2.47'),
            (this.getValueArray = function () {
              if (null == this.params || null == this.params || null == this.params.array)
                throw new e("parameter 'array' not specified");
              for (var i = this.params.array, s = [], r = 0; r < i.length; r++) {
                var o = i[r];
                ((null == t.alg && 0 != t.hasis) ||
                  'string' != typeof o ||
                  (-1 == o.indexOf('-----BEGIN') && !at.isASN1HEX(o)) ||
                  (o = { cert: o }),
                  null == o.alg && null != t.alg && (o.alg = t.alg),
                  0 != o.hasis && 0 == t.hasis && (o.hasis = !1),
                  s.push(new a(o)));
              }
              var h = new n({ array: s });
              return [new n({ array: [h] })];
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.SigningCertificateV2, st.asn1.cms.Attribute),
        (st.asn1.cms.ESSCertIDv2 = function (t) {
          st.asn1.cms.ESSCertIDv2.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DEROctetString,
            s = e.DERSequence,
            n = e.cms.IssuerSerial,
            r = e.x509.AlgorithmIdentifier;
          ((this.params = null),
            (this.tohex = function () {
              var t = this.params,
                e = this.getCertHash(t, 'sha256'),
                a = [];
              return (
                null != t.alg && 'sha256' != t.alg && a.push(new r({ name: t.alg })),
                a.push(new i({ hex: e })),
                (('string' == typeof t && -1 != t.indexOf('-----BEGIN')) ||
                  (null != t.cert && 0 != t.hasis) ||
                  (null != t.issuer && null != t.serial)) &&
                  a.push(new n(t)),
                new s({ array: a }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.ESSCertIDv2, st.asn1.cms.ESSCertID),
        (st.asn1.cms.IssuerSerial = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERInteger,
            n = i.DERSequence,
            r = i.cms,
            a = i.x509.GeneralNames,
            o = ie;
          (r.IssuerSerial.superclass.constructor.call(this),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t,
                i,
                r = this.params;
              if (('string' == typeof r && -1 != r.indexOf('-----BEGIN')) || null != r.cert) {
                var h;
                h = null != r.cert ? r.cert : r;
                var l = new o();
                (l.readCertPEM(h), (t = l.getIssuer()), (i = { hex: l.getSerialNumberHex() }));
              } else {
                if (null == r.issuer || !r.serial) throw new e('cert or issuer and serial parameter not specified');
                ((t = r.issuer), (i = r.serial));
              }
              var c = new a([{ dn: t }]),
                u = new s(i);
              return new n({ array: [c, u] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.IssuerSerial, st.asn1.ASN1Object),
        (st.asn1.cms.SignerIdentifier = function (t) {
          var e = st.asn1;
          (e.DERInteger, e.DERSequence);
          var i = e.cms,
            s = i.IssuerAndSerialNumber,
            n = i.SubjectKeyIdentifier;
          (e.x509.X500Name,
            i.SignerIdentifier.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if ('isssn' == t.type) return new s(t).tohex();
              if ('skid' == t.type) return new n(t).tohex();
              throw new Error('wrong property for isssn or skid');
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.SignerIdentifier, st.asn1.ASN1Object),
        (st.asn1.cms.IssuerAndSerialNumber = function (t) {
          var e = st.asn1,
            i = e.DERInteger,
            s = e.DERSequence,
            n = e.cms,
            r = e.x509.X500Name,
            a = ie,
            o = Error;
          (n.IssuerAndSerialNumber.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t,
                e,
                n = this.params;
              if (('string' == typeof n && -1 != n.indexOf('-----BEGIN')) || null != n.cert) {
                var h;
                h = null != n.cert ? n.cert : n;
                var l = new a();
                (l.readCertPEM(h), (t = l.getIssuer()), (e = { hex: l.getSerialNumberHex() }));
              } else {
                if (null == n.issuer || !n.serial) throw new o('cert or issuer and serial parameter not specified');
                ((t = n.issuer), (e = n.serial));
              }
              var c = new r(t),
                u = new i(e);
              return new s({ array: [c, u] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.IssuerAndSerialNumber, st.asn1.ASN1Object),
        (st.asn1.cms.SubjectKeyIdentifier = function (t) {
          var e = st.asn1;
          (e.DERInteger, e.DERSequence);
          var i = e.ASN1Util.newObject,
            s = e.cms;
          (s.IssuerAndSerialName, s.SubjectKeyIdentifier, e.x509.X500Name);
          var n = ie,
            r = Error;
          (s.SubjectKeyIdentifier.superclass.constructor.call(this),
            (this.tohex = function () {
              var t,
                e = this.params;
              if (null == e.cert && null == e.skid) throw new r('property cert nor skid undefined');
              return (
                null != e.cert
                  ? (t = new n(e.cert).getExtSubjectKeyIdentifier().kid.hex)
                  : null != e.skid && (t = e.skid),
                i({ tag: { tage: 'a0', obj: { octstr: { hex: t } } } }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.SubjectKeyIdentifier, st.asn1.ASN1Object),
        (st.asn1.cms.AttributeList = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERSet,
            n = i.cms;
          (n.AttributeList.superclass.constructor.call(this),
            (this.params = null),
            (this.hTLV = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t = this.params;
              if (null != this.hTLV) return this.hTLV;
              var i = !0;
              null != t.sortflag && (i = t.sortflag);
              for (var r = t.array, a = [], o = 0; o < r.length; o++) {
                var h = r[o],
                  l = h.attr;
                if ('contentType' == l) a.push(new n.ContentType(h));
                else if ('messageDigest' == l) a.push(new n.MessageDigest(h));
                else if ('signingTime' == l) a.push(new n.SigningTime(h));
                else if ('signingCertificate' == l) a.push(new n.SigningCertificate(h));
                else if ('signingCertificateV2' == l) a.push(new n.SigningCertificateV2(h));
                else if ('signaturePolicyIdentifier' == l) a.push(new st.asn1.cades.SignaturePolicyIdentifier(h));
                else {
                  if ('signatureTimeStamp' != l && 'timeStampToken' != l) throw new e('unknown attr: ' + l);
                  a.push(new st.asn1.cades.SignatureTimeStamp(h));
                }
              }
              var c = new s({ array: a, sortflag: i });
              return ((this.hTLV = c.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.AttributeList, st.asn1.ASN1Object),
        (st.asn1.cms.SignerInfo = function (t) {
          var e = Error,
            i = st,
            s = i.asn1,
            n = s.DERInteger,
            r = s.DEROctetString,
            a = s.DERSequence,
            o = s.DERTaggedObject,
            h = s.cms,
            l = h.SignerIdentifier,
            c = h.AttributeList;
          (h.ContentType, h.EncapsulatedContentInfo, h.MessageDigest, h.SignedData);
          var u = s.x509.AlgorithmIdentifier,
            d = i.crypto,
            f = Jt;
          (h.SignerInfo.superclass.constructor.call(this),
            (this.params = null),
            (this.sign = function () {
              var t = this.params,
                e = t.sigalg,
                i = new c(t.sattrs).tohex(),
                s = f.getKey(t.signkey),
                n = new d.Signature({ alg: e });
              (n.init(s), n.updateHex(i));
              var r = n.sign();
              t.sighex = r;
            }),
            (this.tohex = function () {
              var t = this.params,
                i = [];
              if (
                (i.push(new n({ int: t.version })),
                i.push(new l(t.id)),
                i.push(new u({ name: t.hashalg })),
                null != t.sattrs)
              ) {
                var s = new c(t.sattrs);
                try {
                  i.push(new o({ tag: 'a0', explicit: !1, obj: s }));
                } catch (t) {
                  throw new e('si sattr error: ' + t);
                }
              }
              if (
                (null != t.sigalgfield ? i.push(new u({ name: t.sigalgfield })) : i.push(new u({ name: t.sigalg })),
                null == t.sighex && null != t.signkey && this.sign(),
                i.push(new r({ hex: t.sighex })),
                null != t.uattrs)
              ) {
                s = new c(t.uattrs);
                try {
                  i.push(new o({ tag: 'a1', explicit: !1, obj: s }));
                } catch (t) {
                  throw new e('si uattr error: ' + t);
                }
              }
              return new a({ array: i }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.SignerInfo, st.asn1.ASN1Object),
        (st.asn1.cms.EncapsulatedContentInfo = function (t) {
          var e = st.asn1,
            i = e.DERTaggedObject,
            s = e.DERSequence,
            n = e.DERObjectIdentifier,
            r = e.DEROctetString;
          (e.cms.EncapsulatedContentInfo.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                e = [];
              if (
                (e.push(new n(t.type)),
                null != t.content && (null != t.content.hex || null != t.content.str) && 1 != t.isDetached)
              ) {
                var a = new r(t.content),
                  o = new i({ tag: 'a0', explicit: !0, obj: a });
                e.push(o);
              }
              return new s({ array: e }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.EncapsulatedContentInfo, st.asn1.ASN1Object),
        (st.asn1.cms.ContentInfo = function (t) {
          var e = st.asn1,
            i = e.DERTaggedObject,
            s = e.DERSequence,
            n = e.DERObjectIdentifier;
          (e.x509.OID.name2obj,
            st.asn1.cms.ContentInfo.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                e = [];
              e.push(new n(t.type));
              var r = new i({ tag: 'a0', explicit: !0, obj: t.obj });
              return (e.push(r), new s({ array: e }).tohex());
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.ContentInfo, st.asn1.ASN1Object),
        (st.asn1.cms.SignedData = function (t) {
          var e = st.asn1;
          e.ASN1Object;
          var i = e.DERInteger,
            s = e.DERSet,
            n = e.DERSequence;
          e.DERTaggedObject;
          var r = e.cms,
            a = r.EncapsulatedContentInfo,
            o = r.SignerInfo,
            h = r.ContentInfo,
            l = r.CertificateSet,
            c = r.RevocationInfoChoices,
            u = e.x509.AlgorithmIdentifier;
          (st.asn1.cms.SignedData.superclass.constructor.call(this),
            (this.params = null),
            (this.checkAndFixParam = function () {
              var t = this.params;
              (this._setDigestAlgs(t),
                this._setContentTypeByEContent(t),
                this._setMessageDigestByEContent(t),
                this._setSignerInfoVersion(t),
                this._setSignedDataVersion(t));
            }),
            (this._setDigestAlgs = function (t) {
              for (var e = {}, i = t.sinfos, s = 0; s < i.length; s++) e[i[s].hashalg] = 1;
              t.hashalgs = Object.keys(e).sort();
            }),
            (this._setContentTypeByEContent = function (t) {
              for (var e = t.econtent.type, i = t.sinfos, s = 0; s < i.length; s++) {
                var n = i[s];
                this._getAttrParamByName(n, 'contentType').type = e;
              }
            }),
            (this._setMessageDigestByEContent = function (t) {
              var e = t.econtent;
              t.econtent.type;
              var i = e.content.hex;
              null == i && 'data' == e.type && null != e.content.str && (i = vt(e.content.str));
              for (var s = t.sinfos, n = 0; n < s.length; n++) {
                var r = s[n],
                  a = r.hashalg,
                  o = this._getAttrParamByName(r, 'messageDigest'),
                  h = st.crypto.Util.hashHex(i, a);
                o.hex = h;
              }
            }),
            (this._getAttrParamByName = function (t, e) {
              for (var i = t.sattrs.array, s = 0; s < i.length; s++) if (i[s].attr == e) return i[s];
            }),
            (this._setSignerInfoVersion = function (t) {
              for (var e = t.sinfos, i = 0; i < e.length; i++) {
                var s = e[i],
                  n = 1;
                ('skid' == s.id.type && (n = 3), (s.version = n));
              }
            }),
            (this._setSignedDataVersion = function (t) {
              var e = this._getSignedDataVersion(t);
              t.version = e;
            }),
            (this._getSignedDataVersion = function (t) {
              if (null != t.revinfos)
                for (var e = t.revinfos, i = 0; i < e.length; i++) if (null != e[i].ocsp) return 5;
              var s = t.sinfos;
              for (i = 0; i < s.length; i++) if (3 == t.sinfos[i].version) return 3;
              return 'data' != t.econtent.type ? 3 : 1;
            }),
            (this.tohex = function () {
              var t = this.params;
              (null != this.getEncodedHexPrepare && this.getEncodedHexPrepare(),
                1 != t.fixed && this.checkAndFixParam());
              var e = [];
              e.push(new i({ int: t.version }));
              for (var r = [], h = 0; h < t.hashalgs.length; h++) {
                var d = t.hashalgs[h];
                r.push(new u({ name: d }));
              }
              (e.push(new s({ array: r })),
                e.push(new a(t.econtent)),
                null != t.certs && e.push(new l(t.certs)),
                null != t.revinfos && e.push(new c(t.revinfos)));
              var f = [];
              for (h = 0; h < t.sinfos.length; h++) {
                var p = t.sinfos[h];
                f.push(new o(p));
              }
              return (e.push(new s({ array: f })), new n({ array: e }).tohex());
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.getContentInfo = function () {
              return new h({ type: 'signed-data', obj: this });
            }),
            (this.getContentInfoEncodedHex = function () {
              return this.getContentInfo().tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.SignedData, st.asn1.ASN1Object),
        (st.asn1.cms.CertificateSet = function (t) {
          st.asn1.cms.CertificateSet.superclass.constructor.call(this);
          var e = Error,
            i = st.asn1,
            s = i.DERTaggedObject,
            n = i.DERSet,
            r = i.ASN1Object;
          ((this.params = null),
            (this.tohex = function () {
              var t,
                i = this.params,
                a = [];
              if (i instanceof Array) t = i;
              else {
                if (null == i.array) throw new e('cert array not specified');
                t = i.array;
              }
              for (var o = 0; o < t.length; o++) {
                var h = Ct(t[o]),
                  l = new r();
                ((l.hTLV = h), a.push(l));
              }
              var c = { array: a };
              0 == i.sortflag && (c.sortflag = !1);
              var u = new n(c);
              return new s({ tag: 'a0', explicit: !1, obj: u }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.CertificateSet, st.asn1.ASN1Object),
        (st.asn1.cms.RevocationInfoChoices = function (t) {
          (st.asn1.cms.RevocationInfoChoices.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if ((!t) instanceof Array) throw new Error('params is not array');
              for (var e = [], i = 0; i < t.length; i++) e.push(new st.asn1.cms.RevocationInfoChoice(t[i]));
              return st.asn1.ASN1Util.newObject({ tag: { tagi: 'a1', obj: { set: e } } }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.RevocationInfoChoices, st.asn1.ASN1Object),
        (st.asn1.cms.RevocationInfoChoice = function (t) {
          (st.asn1.cms.RevocationInfoChoice.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if (null != t.crl && 'string' == typeof t.crl) {
                var e = t.crl;
                return (-1 != t.crl.indexOf('-----BEGIN') && (e = Ct(t.crl)), e);
              }
              if (null != t.ocsp)
                return st.asn1.ASN1Util.newObject({
                  tag: { tagi: 'a1', obj: new st.asn1.cms.OtherRevocationFormat(t) },
                }).tohex();
              throw new Error('property crl or ocsp undefined');
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.RevocationInfoChoice, st.asn1.ASN1Object),
        (st.asn1.cms.OtherRevocationFormat = function (t) {
          st.asn1.cms.OtherRevocationFormat.superclass.constructor.call(this);
          var e = Error,
            i = st,
            s = i.asn1.ASN1Util.newObject,
            n = i.lang.String.isHex;
          ((this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if (null == t.ocsp) throw new e('property ocsp not specified');
              if (!n(t.ocsp) || !at.isASN1HEX(t.ocsp)) throw new e('ocsp value not ASN.1 hex string');
              return s({ seq: [{ oid: '1.3.6.1.5.5.7.16.2' }, { asn1: { tlv: t.ocsp } }] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cms.OtherRevocationFormat, st.asn1.ASN1Object),
        (st.asn1.cms.CMSUtil = new (function () {})()),
        (st.asn1.cms.CMSUtil.newSignedData = function (t) {
          return new st.asn1.cms.SignedData(t);
        }),
        (st.asn1.cms.CMSUtil.verifySignedData = function (t) {
          var e = st,
            i = e.asn1,
            s = i.cms;
          (s.SignerInfo,
            s.SignedData,
            s.SigningTime,
            s.SigningCertificate,
            s.SigningCertificateV2,
            i.cades.SignaturePolicyIdentifier);
          var n = e.lang.String.isHex,
            r = at,
            a = r.getVbyList,
            o = r.getTLVbyList,
            h = r.getIdxbyList,
            l = r.getChildIdx,
            c = r.getTLV,
            u = r.oidname,
            d = e.crypto.Util.hashHex;
          void 0 === t.cms && n(t.cms);
          var f = t.cms,
            p = function (t, e) {
              var i = e.idx;
              ((e.signerid_issuer1 = o(t, i, [1, 0], '30')),
                (e.signerid_serial1 = a(t, i, [1, 1], '02')),
                (e.hashalg = u(a(t, i, [2, 0], '06'))));
              var s = h(t, i, [3], 'a0');
              ((e.idxSignedAttrs = s), m(t, e, s));
              var n = l(t, i).length;
              if (n < 6) throw 'malformed SignerInfo';
              ((e.sigalg = u(a(t, i, [n - 2, 0], '06'))), (e.sigval = a(t, i, [n - 1], '04')));
            },
            m = function (t, e, i) {
              var s = l(t, i);
              e.signedAttrIdxList = s;
              for (var n = 0; n < s.length; n++) {
                var r,
                  o = s[n],
                  h = a(t, o, [0], '06');
                '2a864886f70d010905' === h
                  ? ((r = gt(a(t, o, [1, 0]))), (e.saSigningTime = r))
                  : '2a864886f70d010904' === h && ((r = a(t, o, [1, 0], '04')), (e.saMessageDigest = r));
              }
            },
            g = function (t, e, i, s) {
              i.verifyDetail = {};
              var n = i.verifyDetail,
                r = e.parse.econtent,
                a = i.hashalg,
                o = i.saMessageDigest;
              ((n.validMessageDigest = !1),
                d(r, a) === o && (n.validMessageDigest = !0),
                (function (t, e, i, s) {
                  var n,
                    r = e.parse.certsIdx;
                  if (void 0 === e.certs) {
                    ((n = []), (e.certkeys = []));
                    for (var a = l(t, r), o = 0; o < a.length; o++) {
                      var h = c(t, a[o]),
                        u = new ie();
                      (u.readCertHex(h), (n[o] = u), (e.certkeys[o] = u.getPublicKey()));
                    }
                    e.certs = n;
                  } else n = e.certs;
                  for (e.cccc = n.length, e.cccci = a.length, o = 0; o < n.length; o++) {
                    var d = u.getIssuerHex(),
                      f = u.getSerialNumberHex();
                    i.signerid_issuer1 === d && i.signerid_serial1 === f && (i.certkey_idx = o);
                  }
                })(t, e, i),
                (n.validSignatureValue = !1));
              var h = i.sigalg,
                u = '31' + c(t, i.idxSignedAttrs).substr(2);
              i.signedattrshex = u;
              var f = e.certs[i.certkey_idx].getPublicKey(),
                p = new st.crypto.Signature({ alg: h });
              (p.init(f), p.updateHex(u));
              var m = p.verify(i.sigval);
              ((n.validSignatureValue_isValid = m),
                !0 === m && (n.validSignatureValue = !0),
                (i.isValid = !1),
                n.validMessageDigest && n.validSignatureValue && (i.isValid = !0));
            },
            y = { isValid: !1, parse: {} };
          return (
            (function (t, e) {
              if ('2a864886f70d010702' !== a(t, 0, [0], '06')) return e;
              ((e.cmsType = 'signedData'),
                (e.econtent = a(t, 0, [1, 0, 2, 1, 0])),
                (function (t, e) {
                  for (var i, s = 3; s < 6; s++)
                    if (void 0 !== (i = h(t, 0, [1, 0, s]))) {
                      var n = t.substr(i, 2);
                      ('a0' === n && (e.certsIdx = i),
                        'a1' === n && (e.revinfosIdx = i),
                        '31' === n && (e.signerinfosIdx = i));
                    }
                })(t, e),
                (e.signerInfos = []),
                (function (t, e) {
                  var i = e.signerinfosIdx;
                  if (void 0 !== i) {
                    var s = l(t, i);
                    e.signerInfoIdxList = s;
                    for (var n = 0; n < s.length; n++) {
                      var r = { idx: s[n] };
                      (p(t, r), e.signerInfos.push(r));
                    }
                  }
                })(t, e));
            })(f, y.parse),
            (function (t, e) {
              for (var i = e.parse.signerInfos, s = i.length, n = !0, r = 0; r < s; r++) {
                var a = i[r];
                (g(t, e, a), a.isValid || (n = !1));
              }
              e.isValid = n;
            })(f, y),
            y
          );
        }),
        (st.asn1.cms.CMSParser = function () {
          var t = Error,
            e = ie,
            i = new e(),
            s = at,
            n = s.getV,
            r = s.getTLV;
          s.getIdxbyList;
          var a = s.getTLVbyList,
            o = s.getTLVbyListEx,
            h = s.getVbyList,
            l = s.getVbyListEx,
            c = s.getChildIdx;
          ((this.getCMSSignedData = function (t) {
            var e = a(t, 0, [1, 0]);
            return this.getSignedData(e);
          }),
            (this.getSignedData = function (t) {
              var e = c(t, 0),
                i = {},
                s = n(t, e[0]),
                a = parseInt(s, 16);
              i.version = a;
              var h = r(t, e[1]);
              i.hashalgs = this.getHashAlgArray(h);
              var l = r(t, e[2]);
              i.econtent = this.getEContent(l);
              var u = o(t, 0, ['[0]']);
              (null != u && (i.certs = this.getCertificateSet(u)), o(t, 0, ['[1]']));
              var d = o(t, 0, [3]);
              return ((i.sinfos = this.getSignerInfos(d)), i);
            }),
            (this.getHashAlgArray = function (t) {
              for (var i = c(t, 0), s = new e(), n = [], a = 0; a < i.length; a++) {
                var o = r(t, i[a]),
                  h = s.getAlgorithmIdentifierName(o);
                n.push(h);
              }
              return n;
            }),
            (this.getEContent = function (t) {
              var e = {},
                i = h(t, 0, [0]),
                s = h(t, 0, [1, 0]);
              return ((e.type = st.asn1.x509.OID.oid2name(at.hextooidstr(i))), (e.content = { hex: s }), e);
            }),
            (this.getSignerInfos = function (t) {
              for (var e = [], i = c(t, 0), s = 0; s < i.length; s++) {
                var n = r(t, i[s]),
                  a = this.getSignerInfo(n);
                e.push(a);
              }
              return e;
            }),
            (this.getSignerInfo = function (t) {
              var e = {},
                n = c(t, 0),
                a = s.getInt(t, n[0], -1);
              -1 != a && (e.version = a);
              var h = r(t, n[1]),
                u = this.getIssuerAndSerialNumber(h);
              e.id = u;
              var d = r(t, n[2]),
                f = i.getAlgorithmIdentifierName(d);
              e.hashalg = f;
              var p = o(t, 0, ['[0]']);
              if (null != p) {
                var m = this.getAttributeList(p);
                e.sattrs = m;
              }
              var g = o(t, 0, [3]),
                y = i.getAlgorithmIdentifierName(g);
              e.sigalg = y;
              var x = l(t, 0, [4]);
              e.sighex = x;
              var v = o(t, 0, ['[1]']);
              if (null != v) {
                var b = this.getAttributeList(v);
                e.uattrs = b;
              }
              return e;
            }),
            (this.getSignerIdentifier = function (t) {
              if ('30' == t.substr(0, 2)) return this.getIssuerAndSerialNumber(t);
              throw new Error('SKID of signerIdentifier not supported');
            }),
            (this.getIssuerAndSerialNumber = function (t) {
              var e = { type: 'isssn' },
                s = c(t, 0),
                a = r(t, s[0]);
              e.issuer = i.getX500Name(a);
              var o = n(t, s[1]);
              return ((e.serial = { hex: o }), e);
            }),
            (this.getAttributeList = function (t) {
              for (var e = [], i = c(t, 0), s = 0; s < i.length; s++) {
                var n = r(t, i[s]),
                  a = this.getAttribute(n);
                e.push(a);
              }
              return { array: e };
            }),
            (this.getAttribute = function (t) {
              var e = {},
                i = c(t, 0),
                n = s.getOID(t, i[0]),
                a = st.asn1.x509.OID.oid2name(n);
              e.attr = a;
              var o = r(t, i[1]),
                h = c(o, 0);
              if (1 == h.length) e.valhex = r(o, h[0]);
              else {
                for (var l = [], u = 0; u < h.length; u++) l.push(r(o, h[u]));
                e.valhex = l;
              }
              return (
                'contentType' == a
                  ? this.setContentType(e)
                  : 'messageDigest' == a
                    ? this.setMessageDigest(e)
                    : 'signingTime' == a
                      ? this.setSigningTime(e)
                      : 'signingCertificate' == a
                        ? this.setSigningCertificate(e)
                        : 'signingCertificateV2' == a
                          ? this.setSigningCertificateV2(e)
                          : 'signaturePolicyIdentifier' == a && this.setSignaturePolicyIdentifier(e),
                e
              );
            }),
            (this.setContentType = function (t) {
              var e = s.getOIDName(t.valhex, 0, null);
              null != e && ((t.type = e), delete t.valhex);
            }),
            (this.setSigningTime = function (t) {
              var e = gt(n(t.valhex, 0));
              ((t.str = e), delete t.valhex);
            }),
            (this.setMessageDigest = function (t) {
              var e = n(t.valhex, 0);
              ((t.hex = e), delete t.valhex);
            }),
            (this.setSigningCertificate = function (t) {
              var e = c(t.valhex, 0);
              if (e.length > 0) {
                for (var i = r(t.valhex, e[0]), s = c(i, 0), n = [], a = 0; a < s.length; a++) {
                  var o = r(i, s[a]),
                    h = this.getESSCertID(o);
                  n.push(h);
                }
                t.array = n;
              }
              if (e.length > 1) {
                var l = r(t.valhex, e[1]);
                t.polhex = l;
              }
              delete t.valhex;
            }),
            (this.setSignaturePolicyIdentifier = function (t) {
              var i = c(t.valhex, 0);
              if (i.length > 0) {
                var a = s.getOID(t.valhex, i[0]);
                t.oid = a;
              }
              if (i.length > 1) {
                var o = new e(),
                  h = c(t.valhex, i[1]),
                  l = r(t.valhex, h[0]),
                  u = o.getAlgorithmIdentifierName(l);
                t.alg = u;
                var d = n(t.valhex, h[1]);
                t.hash = d;
              }
              delete t.valhex;
            }),
            (this.setSigningCertificateV2 = function (t) {
              var e = c(t.valhex, 0);
              if (e.length > 0) {
                for (var i = r(t.valhex, e[0]), s = c(i, 0), n = [], a = 0; a < s.length; a++) {
                  var o = r(i, s[a]),
                    h = this.getESSCertIDv2(o);
                  n.push(h);
                }
                t.array = n;
              }
              if (e.length > 1) {
                var l = r(t.valhex, e[1]);
                t.polhex = l;
              }
              delete t.valhex;
            }),
            (this.getESSCertID = function (t) {
              var e = {},
                i = c(t, 0);
              if (i.length > 0) {
                var s = n(t, i[0]);
                e.hash = s;
              }
              if (i.length > 1) {
                var a = r(t, i[1]),
                  o = this.getIssuerSerial(a);
                (null != o.serial && (e.serial = o.serial), null != o.issuer && (e.issuer = o.issuer));
              }
              return e;
            }),
            (this.getESSCertIDv2 = function (e) {
              var s = {},
                a = c(e, 0);
              if (a.length < 1 || 3 < a.length) throw new t('wrong number of elements');
              var o = 0;
              if ('30' == e.substr(a[0], 2)) {
                var h = r(e, a[0]);
                ((s.alg = i.getAlgorithmIdentifierName(h)), o++);
              } else s.alg = 'sha256';
              var l = n(e, a[o]);
              if (((s.hash = l), a.length > o + 1)) {
                var u = r(e, a[o + 1]),
                  d = this.getIssuerSerial(u);
                ((s.issuer = d.issuer), (s.serial = d.serial));
              }
              return s;
            }),
            (this.getIssuerSerial = function (t) {
              var e = {},
                s = c(t, 0),
                a = r(t, s[0]),
                o = i.getGeneralNames(a)[0].dn;
              e.issuer = o;
              var h = n(t, s[1]);
              return ((e.serial = { hex: h }), e);
            }),
            (this.getCertificateSet = function (t) {
              for (var e = c(t, 0), i = [], s = 0; s < e.length; s++) {
                var n = r(t, e[s]);
                if ('30' == n.substr(0, 2)) {
                  var a = Mt(n, 'CERTIFICATE');
                  i.push(a);
                }
              }
              return { array: i, sortflag: !1 };
            }));
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.asn1 && st.asn1) || (st.asn1 = {}),
        (void 0 !== st.asn1.tsp && st.asn1.tsp) || (st.asn1.tsp = {}),
        (st.asn1.tsp.TimeStampToken = function (t) {
          var e = st.asn1.tsp;
          (e.TimeStampToken.superclass.constructor.call(this),
            (this.params = null),
            (this.getEncodedHexPrepare = function () {
              var t = new e.TSTInfo(this.params.econtent.content);
              this.params.econtent.content.hex = t.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.TimeStampToken, st.asn1.cms.SignedData),
        (st.asn1.tsp.TSTInfo = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERInteger,
            n = e.DERBoolean,
            r = e.DERGeneralizedTime,
            a = e.DERObjectIdentifier,
            o = e.DERTaggedObject,
            h = e.tsp,
            l = h.MessageImprint,
            c = h.Accuracy;
          e.x509.X500Name;
          var u = e.x509.GeneralName;
          if (
            (h.TSTInfo.superclass.constructor.call(this),
            (this.dVersion = new s({ int: 1 })),
            (this.dPolicy = null),
            (this.dMessageImprint = null),
            (this.dSerial = null),
            (this.dGenTime = null),
            (this.dAccuracy = null),
            (this.dOrdering = null),
            (this.dNonce = null),
            (this.dTsa = null),
            (this.tohex = function () {
              var t = [this.dVersion];
              if (null == this.dPolicy) throw new Error('policy shall be specified.');
              if ((t.push(this.dPolicy), null == this.dMessageImprint))
                throw new Error('messageImprint shall be specified.');
              if ((t.push(this.dMessageImprint), null == this.dSerial))
                throw new Error('serialNumber shall be specified.');
              if ((t.push(this.dSerial), null == this.dGenTime)) throw new Error('genTime shall be specified.');
              (t.push(this.dGenTime),
                null != this.dAccuracy && t.push(this.dAccuracy),
                null != this.dOrdering && t.push(this.dOrdering),
                null != this.dNonce && t.push(this.dNonce),
                null != this.dTsa && t.push(this.dTsa));
              var e = new i({ array: t });
              return ((this.hTLV = e.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t)
          ) {
            if ('string' == typeof t.policy) {
              if (!t.policy.match(/^[0-9.]+$/)) throw 'policy shall be oid like 0.1.4.134';
              this.dPolicy = new a({ oid: t.policy });
            }
            (void 0 !== t.messageImprint && (this.dMessageImprint = new l(t.messageImprint)),
              void 0 !== t.serial && (this.dSerial = new s(t.serial)),
              void 0 !== t.genTime && (this.dGenTime = new r(t.genTime)),
              void 0 !== t.accuracy && (this.dAccuracy = new c(t.accuracy)),
              void 0 !== t.ordering && 1 == t.ordering && (this.dOrdering = new n()),
              void 0 !== t.nonce && (this.dNonce = new s(t.nonce)),
              void 0 !== t.tsa && (this.dTsa = new o({ tag: 'a0', explicit: !0, obj: new u({ dn: t.tsa }) })));
          }
        }),
        Zt(st.asn1.tsp.TSTInfo, st.asn1.ASN1Object),
        (st.asn1.tsp.Accuracy = function (t) {
          var e = st.asn1,
            i = e.ASN1Util.newObject;
          (e.tsp.Accuracy.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                e = [];
              return (
                null != t.seconds && 'number' == typeof t.seconds && e.push({ int: t.seconds }),
                null != t.millis &&
                  'number' == typeof t.millis &&
                  e.push({ tag: { tagi: '80', obj: { int: t.millis } } }),
                null != t.micros &&
                  'number' == typeof t.micros &&
                  e.push({ tag: { tagi: '81', obj: { int: t.micros } } }),
                i({ seq: e }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.Accuracy, st.asn1.ASN1Object),
        (st.asn1.tsp.MessageImprint = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DEROctetString,
            n = e.x509.AlgorithmIdentifier;
          (e.tsp.MessageImprint.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                e = new n({ name: t.alg }),
                r = new s({ hex: t.hash });
              return new i({ array: [e, r] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.MessageImprint, st.asn1.ASN1Object),
        (st.asn1.tsp.TimeStampReq = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERInteger,
            n = e.DERBoolean;
          e.ASN1Object;
          var r = e.DERObjectIdentifier,
            a = e.tsp,
            o = a.MessageImprint;
          (a.TimeStampReq.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                e = [];
              return (
                e.push(new s({ int: 1 })),
                t.messageImprint instanceof st.asn1.ASN1Object
                  ? e.push(t.messageImprint)
                  : e.push(new o(t.messageImprint)),
                null != t.policy && e.push(new r(t.policy)),
                null != t.nonce && e.push(new s(t.nonce)),
                1 == t.certreq && e.push(new n()),
                new i({ array: e }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.TimeStampReq, st.asn1.ASN1Object),
        (st.asn1.tsp.TimeStampResp = function (t) {
          var e = st.asn1,
            i = e.DERSequence;
          e.ASN1Object;
          var s = e.tsp,
            n = s.PKIStatusInfo;
          (s.TimeStampResp.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                r = [];
              if (null != t.econtent || null != t.tst)
                if ((null != t.statusinfo ? r.push(new n(t.statusinfo)) : r.push(new n('granted')), null != t.econtent))
                  r.push(new s.TimeStampToken(t).getContentInfo());
                else {
                  if (!(t.tst instanceof e.ASN1Object)) throw new Error('improper member tst value');
                  r.push(t.tst);
                }
              else {
                if (null == t.statusinfo) throw new Error('parameter for token nor statusinfo not specified');
                r.push(new n(t.statusinfo));
              }
              return new i({ array: r }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.TimeStampResp, st.asn1.ASN1Object),
        (st.asn1.tsp.PKIStatusInfo = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERSequence,
            n = i.tsp,
            r = n.PKIStatus,
            a = n.PKIFreeText,
            o = n.PKIFailureInfo;
          (n.PKIStatusInfo.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                i = [];
              if ('string' == typeof t) i.push(new r(t));
              else {
                if (null == t.status) throw new e("property 'status' unspecified");
                (i.push(new r(t.status)),
                  null != t.statusstr && i.push(new a(t.statusstr)),
                  null != t.failinfo && i.push(new o(t.failinfo)));
              }
              return new s({ array: i }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.PKIStatusInfo, st.asn1.ASN1Object),
        (st.asn1.tsp.PKIStatus = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERInteger;
          i.tsp.PKIStatus.superclass.constructor.call(this);
          var n = {
            granted: 0,
            grantedWithMods: 1,
            rejection: 2,
            waiting: 3,
            revocationWarning: 4,
            revocationNotification: 5,
          };
          ((this.params = null),
            (this.tohex = function () {
              var t,
                i = this.params;
              if ('string' == typeof i)
                try {
                  t = n[i];
                } catch (t) {
                  throw new e('undefined name: ' + i);
                }
              else {
                if ('number' != typeof i) throw new e('unsupported params');
                t = i;
              }
              return new s({ int: t }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.PKIStatus, st.asn1.ASN1Object),
        (st.asn1.tsp.PKIFreeText = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERSequence,
            n = i.DERUTF8String;
          (i.tsp.PKIFreeText.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if ((!t) instanceof Array) throw new e('wrong params: not array');
              for (var i = [], r = 0; r < t.length; r++) i.push(new n({ str: t[r] }));
              return new s({ array: i }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.PKIFreeText, st.asn1.ASN1Object),
        (st.asn1.tsp.PKIFailureInfo = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERBitString,
            n = i.tsp.PKIFailureInfo,
            r = {
              badAlg: 0,
              badRequest: 2,
              badDataFormat: 5,
              timeNotAvailable: 14,
              unacceptedPolicy: 15,
              unacceptedExtension: 16,
              addInfoNotAvailable: 17,
              systemFailure: 25,
            };
          (n.superclass.constructor.call(this),
            (this.params = null),
            (this.getBinValue = function () {
              var t = this.params,
                i = 0;
              if ('number' == typeof t && 0 <= t && t <= 25) {
                for (var s = (i |= 1 << t).toString(2), n = '', a = s.length - 1; a >= 0; a--) n += s[a];
                return n;
              }
              if ('string' == typeof t && null != r[t]) return Xt([t], r);
              if ('object' == typeof t && null != t.length) return Xt(t, r);
              throw new e('wrong params');
            }),
            (this.tohex = function () {
              this.params;
              var t = this.getBinValue();
              return new s({ bin: t }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.tsp.PKIFailureInfo, st.asn1.ASN1Object),
        (st.asn1.tsp.AbstractTSAAdapter = function (t) {
          this.getTSTHex = function (t, e) {
            throw 'not implemented yet';
          };
        }),
        (st.asn1.tsp.SimpleTSAAdapter = function (t) {
          var e = st,
            i = e.asn1.tsp,
            s = e.crypto.Util.hashHex;
          (i.SimpleTSAAdapter.superclass.constructor.call(this),
            (this.params = null),
            (this.serial = 0),
            (this.getTSTHex = function (t, e) {
              var n = s(t, e);
              ((this.params.econtent.content.messageImprint = { alg: e, hash: n }),
                (this.params.econtent.content.serial = { int: this.serial++ }));
              var r = Math.floor(1e9 * Math.random());
              return (
                (this.params.econtent.content.nonce = { int: r }),
                new i.TimeStampToken(this.params).getContentInfoEncodedHex()
              );
            }),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.tsp.SimpleTSAAdapter, st.asn1.tsp.AbstractTSAAdapter),
        (st.asn1.tsp.FixedTSAAdapter = function (t) {
          var e = st,
            i = e.asn1.tsp,
            s = e.crypto.Util.hashHex;
          (i.FixedTSAAdapter.superclass.constructor.call(this),
            (this.params = null),
            (this.getTSTHex = function (t, e) {
              var n = s(t, e);
              return (
                (this.params.econtent.content.messageImprint = { alg: e, hash: n }),
                new i.TimeStampToken(this.params).getContentInfoEncodedHex()
              );
            }),
            void 0 !== t && (this.params = t));
        }),
        Zt(st.asn1.tsp.FixedTSAAdapter, st.asn1.tsp.AbstractTSAAdapter),
        (st.asn1.tsp.TSPUtil = new (function () {})()),
        (st.asn1.tsp.TSPUtil.newTimeStampToken = function (t) {
          return new st.asn1.tsp.TimeStampToken(t);
        }),
        (st.asn1.tsp.TSPUtil.parseTimeStampReq = function (t) {
          return new st.asn1.tsp.TSPParser().getTimeStampReq(t);
        }),
        (st.asn1.tsp.TSPUtil.parseMessageImprint = function (t) {
          return new st.asn1.tsp.TSPParser().getMessageImprint(t);
        }),
        (st.asn1.tsp.TSPParser = function () {
          var t = new ie(),
            e = at,
            i = e.getV,
            s = e.getTLV,
            n = e.getIdxbyList;
          e.getTLVbyListEx;
          var r = e.getChildIdx,
            a = ['granted', 'grantedWithMods', 'rejection', 'waiting', 'revocationWarning', 'revocationNotification'],
            o = {
              0: 'badAlg',
              2: 'badRequest',
              5: 'badDataFormat',
              14: 'timeNotAvailable',
              15: 'unacceptedPolicy',
              16: 'unacceptedExtension',
              17: 'addInfoNotAvailable',
              25: 'systemFailure',
            };
          ((this.getResponse = function (t) {
            var e = r(t, 0);
            if (1 == e.length) return this.getPKIStatusInfo(s(t, e[0]));
            if (e.length > 1) {
              var i = this.getPKIStatusInfo(s(t, e[0])),
                n = s(t, e[1]),
                a = this.getToken(n);
              return ((a.statusinfo = i), a);
            }
          }),
            (this.getToken = function (t) {
              var e = new st.asn1.cms.CMSParser().getCMSSignedData(t);
              return (this.setTSTInfo(e), e);
            }),
            (this.setTSTInfo = function (t) {
              var e = t.econtent;
              if ('tstinfo' == e.type) {
                var i = e.content.hex,
                  s = this.getTSTInfo(i);
                e.content = s;
              }
            }),
            (this.getTSTInfo = function (e) {
              var n = {},
                a = r(e, 0),
                o = i(e, a[1]);
              n.policy = qt(o);
              var h = s(e, a[2]);
              n.messageImprint = this.getMessageImprint(h);
              var l = i(e, a[3]);
              n.serial = { hex: l };
              var c = i(e, a[4]);
              n.genTime = { str: gt(c) };
              var u = 0;
              if (a.length > 5 && '30' == e.substr(a[5], 2)) {
                var d = s(e, a[5]);
                ((n.accuracy = this.getAccuracy(d)), u++);
              }
              if (
                (a.length > 5 + u &&
                  '01' == e.substr(a[5 + u], 2) &&
                  ('ff' == i(e, a[5 + u]) && (n.ordering = !0), u++),
                a.length > 5 + u && '02' == e.substr(a[5 + u], 2))
              ) {
                var f = i(e, a[5 + u]);
                ((n.nonce = { hex: f }), u++);
              }
              if (a.length > 5 + u && 'a0' == e.substr(a[5 + u], 2)) {
                var p = s(e, a[5 + u]);
                ((p = '30' + p.substr(2)), (pGeneralNames = t.getGeneralNames(p)));
                var m = pGeneralNames[0].dn;
                ((n.tsa = m), u++);
              }
              if (a.length > 5 + u && 'a1' == e.substr(a[5 + u], 2)) {
                var g = s(e, a[5 + u]);
                g = '30' + g.substr(2);
                var y = t.getExtParamArray(g);
                ((n.ext = y), u++);
              }
              return n;
            }),
            (this.getAccuracy = function (t) {
              for (var e = {}, s = r(t, 0), n = 0; n < s.length; n++) {
                var a = t.substr(s[n], 2),
                  o = i(t, s[n]),
                  h = parseInt(o, 16);
                '02' == a ? (e.seconds = h) : '80' == a ? (e.millis = h) : '81' == a && (e.micros = h);
              }
              return e;
            }),
            (this.getMessageImprint = function (t) {
              if ('30' != t.substr(0, 2)) throw new Error('head of messageImprint hex shall be x30');
              var s = {};
              r(t, 0);
              var a = n(t, 0, [0, 0]),
                o = i(t, a),
                h = e.hextooidstr(o),
                l = st.asn1.x509.OID.oid2name(h);
              if ('' == l) throw new Error('hashAlg name undefined: ' + h);
              var c = l,
                u = n(t, 0, [1]);
              return ((s.alg = c), (s.hash = i(t, u)), s);
            }),
            (this.getPKIStatusInfo = function (t) {
              var e = {},
                n = r(t, 0),
                o = 0;
              try {
                var h = i(t, n[0]),
                  l = parseInt(h, 16);
                e.status = a[l];
              } catch (t) {}
              if (n.length > 1 && '30' == t.substr(n[1], 2)) {
                var c = s(t, n[1]);
                ((e.statusstr = this.getPKIFreeText(c)), o++);
              }
              if (n.length > o && '03' == t.substr(n[1 + o], 2)) {
                var u = s(t, n[1 + o]);
                e.failinfo = this.getPKIFailureInfo(u);
              }
              return e;
            }),
            (this.getPKIFreeText = function (t) {
              for (var i = [], s = r(t, 0), n = 0; n < s.length; n++) i.push(e.getString(t, s[n]));
              return i;
            }),
            (this.getPKIFailureInfo = function (t) {
              var i = e.getInt(t, 0);
              return null != o[i] ? o[i] : i;
            }),
            (this.getTimeStampReq = function (t) {
              var n = { certreq: !1 },
                a = r(t, 0);
              if (a.length < 2) throw new Error('TimeStampReq must have at least 2 items');
              var o = s(t, a[1]);
              n.messageImprint = st.asn1.tsp.TSPUtil.parseMessageImprint(o);
              for (var h = 2; h < a.length; h++) {
                var l = a[h],
                  c = t.substr(l, 2);
                if ('06' == c) {
                  var u = i(t, l);
                  n.policy = e.hextooidstr(u);
                }
                ('02' == c && (n.nonce = i(t, l)), '01' == c && (n.certreq = !0));
              }
              return n;
            }));
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.asn1 && st.asn1) || (st.asn1 = {}),
        (void 0 !== st.asn1.cades && st.asn1.cades) || (st.asn1.cades = {}),
        (st.asn1.cades.SignaturePolicyIdentifier = function (t) {
          var e = st.asn1.cades,
            i = e.SignaturePolicyId;
          (e.SignaturePolicyIdentifier.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.16.2.15'),
            (this.params = null),
            (this.getValueArray = function () {
              return [new i(this.params)];
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.SignaturePolicyIdentifier, st.asn1.cms.Attribute),
        (st.asn1.cades.SignaturePolicyId = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERObjectIdentifier;
          e.x509.AlgorithmIdentifier;
          var n = e.cades,
            r = n.SignaturePolicyId,
            a = n.OtherHashAlgAndValue;
          (r.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                e = [];
              return (e.push(new s(t.oid)), e.push(new a(t)), new i({ array: e }).tohex());
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.SignaturePolicyId, st.asn1.ASN1Object),
        (st.asn1.cades.OtherHashAlgAndValue = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERSequence,
            n = i.DEROctetString,
            r = i.x509.AlgorithmIdentifier;
          (i.cades.OtherHashAlgAndValue.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if (null == t.alg) throw new e("property 'alg' not specified");
              if (null == t.hash && null == t.cert) throw new e("property 'hash' nor 'cert' not specified");
              var i = null;
              if (null != t.hash) i = t.hash;
              else if (null != t.cert) {
                if ('string' != typeof t.cert) throw new e('cert not string');
                var a = t.cert;
                (-1 != t.cert.indexOf('-----BEGIN') && (a = Ct(t.cert)), (i = st.crypto.Util.hashHex(a, t.alg)));
              }
              var o = [];
              return (o.push(new r({ name: t.alg })), o.push(new n({ hex: i })), new s({ array: o }).tohex());
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.OtherHashAlgAndValue, st.asn1.ASN1Object),
        (st.asn1.cades.OtherHashValue = function (t) {
          st.asn1.cades.OtherHashValue.superclass.constructor.call(this);
          var e = Error,
            i = st;
          i.lang.String.isHex;
          var s = i.asn1.DEROctetString;
          (i.crypto.Util.hashHex,
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if (null == t.hash && null == t.cert) throw new e('hash or cert not specified');
              var i = null;
              if (null != t.hash) i = t.hash;
              else if (null != t.cert) {
                if ('string' != typeof t.cert) throw new e('cert not string');
                var n = t.cert;
                (-1 != t.cert.indexOf('-----BEGIN') && (n = Ct(t.cert)), (i = st.crypto.Util.hashHex(n, 'sha1')));
              }
              return new s({ hex: i }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.OtherHashValue, st.asn1.ASN1Object),
        (st.asn1.cades.SignatureTimeStamp = function (t) {
          var e = Error,
            i = st,
            s = i.lang.String.isHex,
            n = i.asn1,
            r = n.ASN1Object;
          (n.x509,
            n.cades.SignatureTimeStamp.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.16.2.14'),
            (this.params = null),
            (this.getValueArray = function () {
              var t = this.params;
              if (null != t.tst) {
                if (s(t.tst)) return (((i = new r()).hTLV = t.tst), [i]);
                if (t.tst instanceof r) return [t.tst];
                throw new e('params.tst has wrong value');
              }
              if (null != t.res) {
                var i,
                  n = t.res;
                if ((n instanceof r && (n = n.tohex()), 'string' != typeof n || !s(n)))
                  throw new e('params.res has wrong value');
                return (at.getTLVbyList(n, 0, [1]), ((i = new r()).hTLV = t.tst), [i]);
              }
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.SignatureTimeStamp, st.asn1.cms.Attribute),
        (st.asn1.cades.CompleteCertificateRefs = function (t) {
          var e = Error,
            i = st,
            s = i.asn1,
            n = s.DERSequence,
            r = s.cades,
            a = r.OtherCertID,
            o = i.lang.String.isHex;
          (r.CompleteCertificateRefs.superclass.constructor.call(this),
            (this.typeOid = '1.2.840.113549.1.9.16.2.21'),
            (this.params = null),
            (this.getValueArray = function () {
              for (var t = this.params, i = [], s = 0; s < t.array.length; s++) {
                var r = t.array[s];
                if ('string' == typeof r)
                  if (-1 != r.indexOf('-----BEGIN')) r = { cert: r };
                  else {
                    if (!o(r)) throw new e('unsupported value: ' + r);
                    r = { hash: r };
                  }
                (null != t.alg && null == r.alg && (r.alg = t.alg),
                  null != t.hasis && null == r.hasis && (r.hasis = t.hasis));
                var h = new a(r);
                i.push(h);
              }
              return [new n({ array: i })];
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.CompleteCertificateRefs, st.asn1.cms.Attribute),
        (st.asn1.cades.OtherCertID = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.cms.IssuerSerial,
            n = e.cades,
            r = n.OtherHashValue,
            a = n.OtherHashAlgAndValue;
          (n.OtherCertID.superclass.constructor.call(this),
            (this.params = t),
            (this.tohex = function () {
              var t = this.params;
              'string' == typeof t &&
                (-1 != t.indexOf('-----BEGIN') ? (t = { cert: t }) : _isHex(t) && (t = { hash: t }));
              var e = [],
                n = null;
              if (
                ((n = null != t.alg ? new a(t) : new r(t)),
                e.push(n),
                (null != t.cert && 1 == t.hasis) || (null != t.issuer && null != t.serial))
              ) {
                var o = new s(t);
                e.push(o);
              }
              return new i({ array: e }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.OtherCertID, st.asn1.ASN1Object),
        (st.asn1.cades.OtherHash = function (t) {
          var e = st,
            i = e.asn1;
          i.cms;
          var s = i.cades,
            n = s.OtherHashAlgAndValue,
            r = s.OtherHashValue;
          e.crypto.Util.hashHex;
          var a = e.lang.String.isHex;
          (s.OtherHash.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              return (
                'string' == typeof t && (-1 != t.indexOf('-----BEGIN') ? (t = { cert: t }) : a(t) && (t = { hash: t })),
                (null != t.alg ? new n(t) : new r(t)).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.cades.OtherHash, st.asn1.ASN1Object),
        (st.asn1.cades.CAdESUtil = new (function () {})()),
        (st.asn1.cades.CAdESUtil.parseSignedDataForAddingUnsigned = function (t) {
          return new st.asn1.cms.CMSParser().getCMSSignedData(t);
        }),
        (st.asn1.cades.CAdESUtil.parseSignerInfoForAddingUnsigned = function (t, e, i) {
          var s = at,
            n = s.getChildIdx,
            r = s.getTLV,
            a = s.getV,
            o = st.asn1,
            h = o.ASN1Object,
            l = o.cms,
            c = l.AttributeList,
            u = l.SignerInfo,
            d = {},
            f = n(t, e);
          if (6 != f.length) throw 'not supported items for SignerInfo (!=6)';
          var p = f.shift();
          d.version = r(t, p);
          var m = f.shift();
          d.si = r(t, m);
          var g = f.shift();
          d.digalg = r(t, g);
          var y = f.shift();
          d.sattrs = r(t, y);
          var x = f.shift();
          d.sigalg = r(t, x);
          var v = f.shift();
          ((d.sig = r(t, v)), (d.sigval = a(t, v)));
          var b = null;
          return (
            (d.obj = new u()),
            ((b = new h()).hTLV = d.version),
            (d.obj.dCMSVersion = b),
            ((b = new h()).hTLV = d.si),
            (d.obj.dSignerIdentifier = b),
            ((b = new h()).hTLV = d.digalg),
            (d.obj.dDigestAlgorithm = b),
            ((b = new h()).hTLV = d.sattrs),
            (d.obj.dSignedAttrs = b),
            ((b = new h()).hTLV = d.sigalg),
            (d.obj.dSigAlg = b),
            ((b = new h()).hTLV = d.sig),
            (d.obj.dSig = b),
            (d.obj.dUnsignedAttrs = new c()),
            d
          );
        }),
        (void 0 !== st.asn1.csr && st.asn1.csr) || (st.asn1.csr = {}),
        (st.asn1.csr.CertificationRequest = function (t) {
          var e = st.asn1,
            i = e.DERBitString,
            s = e.DERSequence,
            n = e.csr;
          e.x509;
          var r = n.CertificationRequestInfo;
          (n.CertificationRequest.superclass.constructor.call(this),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.sign = function () {
              var t = new r(this.params).tohex(),
                e = new st.crypto.Signature({ alg: this.params.sigalg });
              (e.init(this.params.sbjprvkey), e.updateHex(t));
              var i = e.sign();
              this.params.sighex = i;
            }),
            (this.getPEM = function () {
              return Mt(this.tohex(), 'CERTIFICATE REQUEST');
            }),
            (this.tohex = function () {
              var t = this.params,
                e = new st.asn1.csr.CertificationRequestInfo(this.params),
                n = new st.asn1.x509.AlgorithmIdentifier({ name: t.sigalg });
              if ((null == t.sighex && null != t.sbjprvkey && this.sign(), null == t.sighex))
                throw new Error('sighex or sbjprvkey parameter not defined');
              var r = new i({ hex: '00' + t.sighex });
              return new s({ array: [e, n, r] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.csr.CertificationRequest, st.asn1.ASN1Object),
        (st.asn1.csr.CertificationRequestInfo = function (t) {
          var e = st.asn1;
          e.DERBitString;
          var i = e.DERSequence,
            s = e.DERInteger,
            n = e.DERUTF8String,
            r = e.DERTaggedObject,
            a = e.ASN1Util.newObject,
            o = e.csr,
            h = e.x509,
            l = h.X500Name,
            c = h.Extensions,
            u = h.SubjectPublicKeyInfo;
          (o.AttributeList,
            o.CertificationRequestInfo.superclass.constructor.call(this),
            (this.params = null),
            (this.setByParam = function (t) {
              null != t && (this.params = t);
            }),
            (this.tohex = function () {
              var t = this.params,
                e = [];
              if (
                (e.push(new s({ int: 0 })),
                e.push(new l(t.subject)),
                e.push(new u(Jt.getKey(t.sbjpubkey))),
                null != t.attrs)
              ) {
                var o = (function (t) {
                    for (var e = Error, i = st.asn1.x509.Extensions, s = [], n = 0; n < t.length; n++) {
                      var r = t[n],
                        a = r.attr;
                      if ('extensionRequest' == a) {
                        var o = { seq: [{ oid: '1.2.840.113549.1.9.14' }, { set: [new i(r.ext)] }] };
                        s.push(o);
                      } else if ('unstructuredName' == a)
                        ((o = { seq: [{ oid: '1.2.840.113549.1.9.2' }, { set: r.names }] }), s.push(o));
                      else {
                        if ('challengePassword' != a) throw new e('unknown CSR attribute');
                        ((o = { seq: [{ oid: '1.2.840.113549.1.9.7' }, { set: [{ utf8str: r.password }] }] }),
                          s.push(o));
                      }
                    }
                    return { set: s };
                  })(t.attrs),
                  h = a({ tag: { tage: 'a0', obj: o } });
                e.push(h);
              } else if (null != t.extreq) {
                var d = new c(t.extreq);
                ((h = a({ tag: { tage: 'a0', obj: { seq: [{ oid: '1.2.840.113549.1.9.14' }, { set: [d] }] } } })),
                  e.push(h));
              } else e.push(new r({ tag: 'a0', explicit: !1, obj: new n({ str: '' }) }));
              return new i({ array: e }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            null != t && this.setByParam(t));
        }),
        Zt(st.asn1.csr.CertificationRequestInfo, st.asn1.ASN1Object),
        (st.asn1.csr.AttributeList = function (t) {}),
        Zt(st.asn1.csr.AttributeList, st.asn1.ASN1Object),
        (st.asn1.csr.CSRUtil = new (function () {})()),
        (st.asn1.csr.CSRUtil.newCSRPEM = function (t) {
          return new st.asn1.csr.CertificationRequest(t).getPEM();
        }),
        (st.asn1.csr.CSRUtil.getParam = function (t, e) {
          var i = at,
            s = i.getV,
            n = i.getIdxbyList,
            r = i.getTLVbyList,
            a = i.getTLVbyListEx,
            o = i.getVbyListEx,
            h = {};
          if (-1 == t.indexOf('-----BEGIN CERTIFICATE REQUEST')) throw new Error('argument is not PEM file');
          var l = Ct(t, 'CERTIFICATE REQUEST');
          e && (h.tbs = r(l, 0, [0]));
          try {
            var c = a(l, 0, [0, 1]);
            if ('3000' == c) h.subject = {};
            else {
              var u = new ie();
              h.subject = u.getX500Name(c);
            }
          } catch (t) {}
          var d = a(l, 0, [0, 2]),
            f = Jt.getKey(d, null, 'pkcs8pub');
          h.sbjpubkey = Jt.getPEM(f, 'PKCS8PUB');
          var p,
            m,
            g =
              ((m = n((p = l), 0, [0, 3, 0, 0], '06')),
              '2a864886f70d01090e' != s(p, m) ? null : r(p, 0, [0, 3, 0, 1, 0], '30'));
          ((u = new ie()), null != g && (h.extreq = u.getExtParamArray(g)));
          try {
            var y = a(l, 0, [1], '30');
            ((u = new ie()), (h.sigalg = u.getAlgorithmIdentifierName(y)));
          } catch (t) {}
          try {
            var x = o(l, 0, [2]);
            h.sighex = x;
          } catch (t) {}
          return h;
        }),
        (st.asn1.csr.CSRUtil.verifySignature = function (t) {
          try {
            var e = null;
            if (
              ('string' == typeof t && -1 != t.indexOf('-----BEGIN CERTIFICATE REQUEST')
                ? (e = st.asn1.csr.CSRUtil.getParam(t, !0))
                : 'object' == typeof t &&
                  null != t.sbjpubkey &&
                  null != t.sigalg &&
                  null != t.sighex &&
                  null != t.tbs &&
                  (e = t),
              null == e)
            )
              return !1;
            var i = new st.crypto.Signature({ alg: e.sigalg });
            return (i.init(e.sbjpubkey), i.updateHex(e.tbs), i.verify(e.sighex));
          } catch (t) {
            return (alert(t), !1);
          }
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.asn1 && st.asn1) || (st.asn1 = {}),
        (void 0 !== st.asn1.ocsp && st.asn1.ocsp) || (st.asn1.ocsp = {}),
        (st.asn1.ocsp.DEFAULT_HASH = 'sha1'),
        (st.asn1.ocsp.OCSPResponse = function (t) {
          (st.asn1.ocsp.OCSPResponse.superclass.constructor.call(this), st.asn1.DEREnumerated);
          var e = st.asn1.ASN1Util.newObject,
            i = st.asn1.ocsp.ResponseBytes,
            s = [
              'successful',
              'malformedRequest',
              'internalError',
              'tryLater',
              '_not_used_',
              'sigRequired',
              'unauthorized',
            ];
          ((this.params = null),
            (this._getStatusCode = function () {
              var t = this.params.resstatus;
              return 'number' == typeof t ? t : 'string' != typeof t ? -1 : s.indexOf(t);
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t = this.params,
                s = this._getStatusCode();
              if (-1 == s) throw new Error('responseStatus not supported: ' + t.resstatus);
              if (0 != s) return e({ seq: [{ enum: { int: s } }] }).tohex();
              var n = new i(t);
              return e({ seq: [{ enum: { int: 0 } }, { tag: { tag: 'a0', explicit: !0, obj: n } }] }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.OCSPResponse, st.asn1.ASN1Object),
        (st.asn1.ocsp.ResponseBytes = function (t) {
          st.asn1.ocsp.ResponseBytes.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERObjectIdentifier,
            n = e.DEROctetString,
            r = e.ocsp.BasicOCSPResponse;
          ((this.params = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.tohex = function () {
              var t = this.params;
              if ('ocspBasic' != t.restype) throw new Error('not supported responseType: ' + t.restype);
              var e = new r(t),
                a = [];
              return (
                a.push(new s({ name: 'ocspBasic' })),
                a.push(new n({ hex: e.tohex() })),
                new i({ array: a }).tohex()
              );
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.ResponseBytes, st.asn1.ASN1Object),
        (st.asn1.ocsp.BasicOCSPResponse = function (t) {
          st.asn1.ocsp.BasicOCSPResponse.superclass.constructor.call(this);
          var e = Error,
            i = st.asn1,
            s = i.ASN1Object,
            n = i.DERSequence;
          i.DERGeneralizedTime;
          var r = i.DERTaggedObject,
            a = i.DERBitString;
          i.x509.Extensions;
          var o = i.x509.AlgorithmIdentifier,
            h = i.ocsp;
          (h.ResponderID,
            (_SingleResponseList = h.SingleResponseList),
            (_ResponseData = h.ResponseData),
            (this.params = null),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            (this.sign = function () {
              var t = this.params,
                e = t.tbsresp.tohex(),
                i = new st.crypto.Signature({ alg: t.sigalg });
              (i.init(t.reskey), i.updateHex(e), (t.sighex = i.sign()));
            }),
            (this.tohex = function () {
              var t = this.params;
              (null == t.tbsresp && (t.tbsresp = new _ResponseData(t)),
                null == t.sighex && null != t.reskey && this.sign());
              var i = [];
              if (
                (i.push(t.tbsresp),
                i.push(new o({ name: t.sigalg })),
                i.push(new a({ hex: '00' + t.sighex })),
                null != t.certs && null != t.certs.length)
              ) {
                for (var h = [], l = 0; l < t.certs.length; l++) {
                  var c = t.certs[l],
                    u = null;
                  if (at.isASN1HEX(c)) u = c;
                  else {
                    if (!c.match(/-----BEGIN/)) throw new e('certs[' + l + '] not hex or PEM');
                    u = Ct(c);
                  }
                  h.push(new s({ tlv: u }));
                }
                var d = new n({ array: h });
                i.push(new r({ tag: 'a0', explicit: !0, obj: d }));
              }
              return new n({ array: i }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.BasicOCSPResponse, st.asn1.ASN1Object),
        (st.asn1.ocsp.ResponseData = function (t) {
          st.asn1.ocsp.ResponseData.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.DERGeneralizedTime,
            n = e.DERTaggedObject,
            r = e.x509.Extensions,
            a = e.ocsp,
            o = a.ResponderID;
          ((_SingleResponseList = a.SingleResponseList),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              (t.respid, t.prodat, t.array);
              var e = [];
              if (
                (e.push(new o(t.respid)),
                e.push(new s(t.prodat)),
                e.push(new _SingleResponseList(t.array)),
                null != t.ext)
              ) {
                var a = new r(t.ext);
                e.push(new n({ tag: 'a1', explicit: !0, obj: a }));
              }
              return new i({ array: e }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.ResponseData, st.asn1.ASN1Object),
        (st.asn1.ocsp.ResponderID = function (t) {
          st.asn1.ocsp.ResponderID.superclass.constructor.call(this);
          var e = st,
            i = e.asn1,
            s = i.ASN1Util.newObject,
            n = i.x509.X500Name,
            r = e.lang.String.isHex,
            a = Error;
          ((this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if (null != t.key) {
                var e,
                  i = null;
                if (
                  ('string' == typeof t.key
                    ? (r(t.key) && (i = t.key),
                      t.key.match(/-----BEGIN CERTIFICATE/) &&
                        null != (e = new ie(t.key).getExtSubjectKeyIdentifier()) &&
                        (i = e.kid.hex))
                    : t.key instanceof ie && null != (e = t.key.getExtSubjectKeyIdentifier()) && (i = e.kid.hex),
                  null == i)
                )
                  throw new a('wrong key member value');
                return s({ tag: { tag: 'a2', explicit: !0, obj: { octstr: { hex: i } } } }).tohex();
              }
              if (null != t.name) {
                var o = null;
                if (
                  ('string' == typeof t.name && t.name.match(/-----BEGIN CERTIFICATE/)
                    ? (o = new ie(t.name).getSubject())
                    : t.name instanceof ie
                      ? (o = t.name.getSubject())
                      : 'object' != typeof t.name || (null == t.name.array && null == t.name.str) || (o = t.name),
                  null == o)
                )
                  throw new a('wrong name member value');
                return s({ tag: { tag: 'a1', explicit: !0, obj: new n(o) } }).tohex();
              }
              throw new a('key or name not specified');
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.ResponderID, st.asn1.ASN1Object),
        (st.asn1.ocsp.SingleResponseList = function (t) {
          st.asn1.ocsp.SingleResponseList.superclass.constructor.call(this);
          var e = st.asn1,
            i = e.DERSequence,
            s = e.ocsp.SingleResponse;
          ((this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if ('object' != typeof t || null == t.length) throw new Error('params not specified properly');
              for (var e = [], n = 0; n < t.length; n++) e.push(new s(t[n]));
              return new i({ array: e }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.SingleResponseList, st.asn1.ASN1Object),
        (st.asn1.ocsp.SingleResponse = function (t) {
          var e = Error,
            i = st.asn1,
            s = i.DERSequence,
            n = i.DERGeneralizedTime,
            r = i.DERTaggedObject,
            a = i.ocsp,
            o = a.CertID,
            h = a.CertStatus,
            l = i.x509.Extensions;
          (a.SingleResponse.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params,
                i = [];
              if (null == t.certid) throw new e('certid unspecified');
              if (null == t.status) throw new e('status unspecified');
              if (null == t.thisupdate) throw new e('thisupdate unspecified');
              if (
                (i.push(new o(t.certid)), i.push(new h(t.status)), i.push(new n(t.thisupdate)), null != t.nextupdate)
              ) {
                var a = new n(t.nextupdate);
                i.push(new r({ tag: 'a0', explicit: !0, obj: a }));
              }
              if (null != t.ext) {
                var c = new l(t.ext);
                i.push(new r({ tag: 'a1', explicit: !0, obj: c }));
              }
              return new s({ array: i }).tohex();
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.SingleResponse, st.asn1.ASN1Object),
        (st.asn1.ocsp.CertID = function (t) {
          var e = st,
            i = e.asn1,
            s = i.DEROctetString,
            n = i.DERInteger,
            r = i.DERSequence,
            a = i.x509.AlgorithmIdentifier,
            o = i.ocsp;
          o.DEFAULT_HASH;
          var h = e.crypto.Util.hashHex,
            l = ie,
            c = at.getVbyList;
          (o.CertID.superclass.constructor.call(this),
            (this.DEFAULT_HASH = 'sha1'),
            (this.params = null),
            (this.setByValue = function (t, e, i, s) {
              (null == s && (s = this.DEFAULT_HASH), (this.params = { alg: s, issname: t, isskey: e, sbjsn: i }));
            }),
            (this.setByCert = function (t, e, i) {
              (null == i && (i = this.DEFAULT_HASH), (this.params = { alg: i, issuerCert: t, subjectCert: e }));
            }),
            (this.getParamByCerts = function (t, e, i) {
              null == i && (i = this.DEFAULT_HASH);
              var s = new l(t),
                n = new l(e),
                r = h(s.getSubjectHex(), i),
                a = s.getPublicKeyHex();
              return { alg: i, issname: r, isskey: h(c(a, 0, [1], '03', !0), i), sbjsn: n.getSerialNumberHex() };
            }),
            (this.tohex = function () {
              if ('object' != typeof this.params) throw new Error('params not set');
              var t,
                e,
                i,
                o,
                h = this.params;
              if (((o = null == h.alg ? this.DEFAULT_HASH : h.alg), null != h.issuerCert && null != h.subjectCert)) {
                var l = this.getParamByCerts(h.issuerCert, h.subjectCert, o);
                ((t = l.issname), (e = l.isskey), (i = l.sbjsn));
              } else {
                if (null == h.issname || null == h.isskey || null == h.sbjsn)
                  throw new Error('required param members not defined');
                ((t = h.issname), (e = h.isskey), (i = h.sbjsn));
              }
              var c = new a({ name: o }),
                u = new s({ hex: t }),
                d = new s({ hex: e }),
                f = new n({ hex: i }),
                p = new r({ array: [c, u, d, f] });
              return ((this.hTLV = p.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.CertID, st.asn1.ASN1Object),
        (st.asn1.ocsp.CertStatus = function (t) {
          (st.asn1.ocsp.CertStatus.superclass.constructor.call(this),
            (this.params = null),
            (this.tohex = function () {
              var t = this.params;
              if ('good' == t.status) return '8000';
              if ('unknown' == t.status) return '8200';
              if ('revoked' == t.status) {
                var e = [{ gentime: { str: t.time } }];
                null != t.reason && e.push({ tag: { tag: 'a0', explicit: !0, obj: { enum: { int: t.reason } } } });
                var i = { tag: 'a1', explicit: !1, obj: { seq: e } };
                return st.asn1.ASN1Util.newObject({ tag: i }).tohex();
              }
              throw new Error('bad status');
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            (this.setByParam = function (t) {
              this.params = t;
            }),
            void 0 !== t && this.setByParam(t));
        }),
        Zt(st.asn1.ocsp.CertStatus, st.asn1.ASN1Object),
        (st.asn1.ocsp.Request = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.ocsp;
          if (
            (s.Request.superclass.constructor.call(this),
            (this.dReqCert = null),
            (this.dExt = null),
            (this.tohex = function () {
              var t = [];
              if (null === this.dReqCert) throw 'reqCert not set';
              t.push(this.dReqCert);
              var e = new i({ array: t });
              return ((this.hTLV = e.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t)
          ) {
            var n = new s.CertID(t);
            this.dReqCert = n;
          }
        }),
        Zt(st.asn1.ocsp.Request, st.asn1.ASN1Object),
        (st.asn1.ocsp.TBSRequest = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.ocsp;
          (s.TBSRequest.superclass.constructor.call(this),
            (this.version = 0),
            (this.dRequestorName = null),
            (this.dRequestList = []),
            (this.dRequestExt = null),
            (this.setRequestListByParam = function (t) {
              for (var e = [], i = 0; i < t.length; i++) {
                var n = new s.Request(t[0]);
                e.push(n);
              }
              this.dRequestList = e;
            }),
            (this.tohex = function () {
              var t = [];
              if (0 !== this.version) throw 'not supported version: ' + this.version;
              if (null !== this.dRequestorName) throw 'requestorName not supported';
              var e = new i({ array: this.dRequestList });
              if ((t.push(e), null !== this.dRequestExt)) throw 'requestExtensions not supported';
              var s = new i({ array: t });
              return ((this.hTLV = s.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && void 0 !== t.reqList && this.setRequestListByParam(t.reqList));
        }),
        Zt(st.asn1.ocsp.TBSRequest, st.asn1.ASN1Object),
        (st.asn1.ocsp.OCSPRequest = function (t) {
          var e = st.asn1,
            i = e.DERSequence,
            s = e.ocsp;
          if (
            (s.OCSPRequest.superclass.constructor.call(this),
            (this.dTbsRequest = null),
            (this.dOptionalSignature = null),
            (this.tohex = function () {
              var t = [];
              if (null === this.dTbsRequest) throw 'tbsRequest not set';
              if ((t.push(this.dTbsRequest), null !== this.dOptionalSignature)) throw 'optionalSignature not supported';
              var e = new i({ array: t });
              return ((this.hTLV = e.tohex()), this.hTLV);
            }),
            (this.getEncodedHex = function () {
              return this.tohex();
            }),
            void 0 !== t && void 0 !== t.reqList)
          ) {
            var n = new s.TBSRequest(t);
            this.dTbsRequest = n;
          }
        }),
        Zt(st.asn1.ocsp.OCSPRequest, st.asn1.ASN1Object),
        (st.asn1.ocsp.OCSPUtil = {}),
        (st.asn1.ocsp.OCSPUtil.getRequestHex = function (t, e, i) {
          var s = st.asn1.ocsp;
          void 0 === i && (i = s.DEFAULT_HASH);
          var n = { alg: i, issuerCert: t, subjectCert: e };
          return new s.OCSPRequest({ reqList: [n] }).tohex();
        }),
        (st.asn1.ocsp.OCSPUtil.getOCSPResponseInfo = function (t) {
          var e = at,
            i = e.getVbyList,
            s = e.getVbyListEx,
            n = e.getIdxbyList;
          e.getIdxbyListEx;
          var r = e.getV,
            a = {};
          try {
            var o = s(t, 0, [0], '0a');
            a.responseStatus = parseInt(o, 16);
          } catch (t) {}
          if (0 !== a.responseStatus) return a;
          try {
            var h = n(t, 0, [1, 0, 1, 0, 0, 2, 0, 1]);
            '80' === t.substr(h, 2)
              ? (a.certStatus = 'good')
              : 'a1' === t.substr(h, 2)
                ? ((a.certStatus = 'revoked'), (a.revocationTime = gt(i(t, h, [0]))))
                : '82' === t.substr(h, 2) && (a.certStatus = 'unknown');
          } catch (t) {}
          try {
            var l = n(t, 0, [1, 0, 1, 0, 0, 2, 0, 2]);
            a.thisUpdate = gt(r(t, l));
          } catch (t) {}
          try {
            var c = n(t, 0, [1, 0, 1, 0, 0, 2, 0, 3]);
            'a0' === t.substr(c, 2) && (a.nextUpdate = gt(i(t, c, [0])));
          } catch (t) {}
          return a;
        }),
        (st.asn1.ocsp.OCSPParser = function () {
          var t = Error,
            e = ie,
            i = new e(),
            s = at,
            n = s.getV,
            r = s.getTLV,
            a = s.getIdxbyList,
            o = s.getVbyList,
            h = s.getTLVbyList,
            l = s.getVbyListEx,
            c = s.getTLVbyListEx,
            u = s.getChildIdx;
          ((this.getOCSPRequest = function (e) {
            var i = u(e, 0);
            if (1 != i.length && 2 != i.length) throw new t('wrong number elements: ' + i.length);
            return this.getTBSRequest(r(e, i[0]));
          }),
            (this.getTBSRequest = function (t) {
              var e = {},
                s = c(t, 0, [0], '30');
              e.array = this.getRequestList(s);
              var n = c(t, 0, ['[2]', 0], '30');
              return (null != n && (e.ext = i.getExtParamArray(n)), e);
            }),
            (this.getRequestList = function (t) {
              for (var e = [], i = u(t, 0), s = 0; s < i.length; s++) ((t = r(t, i[s])), e.push(this.getRequest(t)));
              return e;
            }),
            (this.getRequest = function (e) {
              var s = u(e, 0);
              if (1 != s.length && 2 != s.length) throw new t('wrong number elements: ' + s.length);
              var n = this.getCertID(r(e, s[0]));
              if (2 == s.length) {
                var o = a(e, 0, [1, 0]);
                n.ext = i.getExtParamArray(r(e, o));
              }
              return n;
            }),
            (this.getCertID = function (i) {
              var s = u(i, 0);
              if (4 != s.length) throw new t('wrong number elements: ' + s.length);
              var a = new e(),
                o = {};
              return (
                (o.alg = a.getAlgorithmIdentifierName(r(i, s[0]))),
                (o.issname = n(i, s[1])),
                (o.isskey = n(i, s[2])),
                (o.sbjsn = n(i, s[3])),
                o
              );
            }),
            (this.getOCSPResponse = function (t) {
              var e,
                i = u(t, 0),
                s = n(t, i[0]),
                r = parseInt(s);
              if (1 == i.length) return { resstatus: r };
              var a = h(t, 0, [1, 0]);
              return (((e = this.getResponseBytes(a)).resstatus = r), e);
            }),
            (this.getResponseBytes = function (t) {
              var e,
                i = u(t, 0),
                s = h(t, 0, [1, 0]);
              e = this.getBasicOCSPResponse(s);
              var r = n(t, i[0]);
              return ((e.restype = st.asn1.x509.OID.oid2name(qt(r))), e);
            }),
            (this.getBasicOCSPResponse = function (t) {
              var e,
                i = u(t, 0);
              e = this.getResponseData(r(t, i[0]));
              var s = new ie();
              e.alg = s.getAlgorithmIdentifierName(r(t, i[1]));
              var a = n(t, i[2]);
              e.sighex = a.substr(2);
              var o = l(t, 0, ['[0]']);
              if (null != o) {
                for (var h = u(o, 0), c = [], d = 0; d < h.length; d++) {
                  var f = r(o, h[d]);
                  c.push(f);
                }
                e.certs = c;
              }
              return e;
            }),
            (this.getResponseData = function (t) {
              var e = u(t, 0),
                i = e.length,
                s = {},
                a = 0;
              ('a0' == t.substr(e[0], 2) && a++, (s.respid = this.getResponderID(r(t, e[a++]))));
              var o = n(t, e[a++]);
              if (
                ((s.prodat = gt(o)),
                (s.array = this.getSingleResponseList(r(t, e[a++]))),
                'a1' == t.substr(e[i - 1], 2))
              ) {
                var l = h(t, e[i - 1], [0]),
                  c = new ie();
                s.ext = c.getExtParamArray(l);
              }
              return s;
            }),
            (this.getResponderID = function (t) {
              var e = {};
              if ('a2' == t.substr(0, 2)) {
                var i = o(t, 0, [0]);
                e.key = i;
              }
              if ('a1' == t.substr(0, 2)) {
                var s = h(t, 0, [0]),
                  n = new ie();
                e.name = n.getX500Name(s);
              }
              return e;
            }),
            (this.getSingleResponseList = function (t) {
              for (var e = u(t, 0), i = [], s = 0; s < e.length; s++) {
                var n = this.getSingleResponse(r(t, e[s]));
                i.push(n);
              }
              return i;
            }),
            (this.getSingleResponse = function (t) {
              var e = u(t, 0),
                i = {},
                s = this.getCertID(r(t, e[0]));
              i.certid = s;
              var a = this.getCertStatus(r(t, e[1]));
              if (((i.status = a), '18' == t.substr(e[2], 2))) {
                var l = n(t, e[2]);
                i.thisupdate = gt(l);
              }
              for (var c = 3; c < e.length; c++) {
                if ('a0' == t.substr(e[c], 2)) {
                  var d = o(t, e[c], [0], '18');
                  i.nextupdate = gt(d);
                }
                if ('a1' == t.substr(e[c], 2)) {
                  var f = new ie(),
                    p = h(t, 0, [c, 0]);
                  i.ext = f.getExtParamArray(p);
                }
              }
              return i;
            }),
            (this.getCertStatus = function (t) {
              var e = {};
              if ('8000' == t) return { status: 'good' };
              if ('8200' == t) return { status: 'unknown' };
              if ('a1' == t.substr(0, 2)) {
                e.status = 'revoked';
                var i = gt(o(t, 0, [0]));
                e.time = i;
              }
              return e;
            }));
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.lang && st.lang) || (st.lang = {}),
        (st.lang.String = function () {}),
        'function' == typeof Buffer
          ? ((nt = function (t) {
              return ut(Buffer.from(t, 'utf8').toString('base64'));
            }),
            (rt = function (t) {
              return Buffer.from(dt(t), 'base64').toString('utf8');
            }))
          : ((nt = function (t) {
              return ft(Ft(zt(t)));
            }),
            (rt = function (t) {
              return decodeURIComponent(Pt(pt(t)));
            })),
        (st.lang.String.isInteger = function (t) {
          return !!t.match(/^[0-9]+$/) || !!t.match(/^-[0-9]+$/);
        }),
        (st.lang.String.isHex = function (t) {
          return Lt(t);
        }),
        (st.lang.String.isBase64 = function (t) {
          return !(!(t = t.replace(/\s+/g, '')).match(/^[0-9A-Za-z+\/]+={0,3}$/) || t.length % 4 != 0);
        }),
        (st.lang.String.isBase64URL = function (t) {
          return !t.match(/[+/=]/) && ((t = dt(t)), st.lang.String.isBase64(t));
        }),
        (st.lang.String.isIntegerArray = function (t) {
          return !!(t = t.replace(/\s+/g, '')).match(/^\[[0-9,]+\]$/);
        }),
        (st.lang.String.isPrintable = function (t) {
          return null !== t.match(/^[0-9A-Za-z '()+,-./:=?]*$/);
        }),
        (st.lang.String.isIA5 = function (t) {
          return null !== t.match(/^[\x20-\x21\x23-\x7f]*$/);
        }),
        (st.lang.String.isMail = function (t) {
          return null !== t.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
        }));
      var Kt = function (t, e, i) {
        return (null == i && (i = '0'), t.length >= e ? t : new Array(e - t.length + 1).join(i) + t);
      };
      function Gt(t) {
        if (t.length % 2 != 0) return -1;
        if (null == (t = t.toLowerCase()).match(/^[0-9a-f]+$/)) return -1;
        try {
          var e = t.substr(0, 2);
          if ('00' == e) return parseInt(t.substr(2), 16);
          var i = parseInt(e, 16);
          if (i > 7) return -1;
          var s = t.substr(2),
            n = parseInt(s, 16).toString(2);
          ('0' == n && (n = '00000000'), (n = n.slice(0, 0 - i)));
          var r = parseInt(n, 2);
          return NaN == r ? -1 : r;
        } catch (t) {
          return -1;
        }
      }
      function Wt(t) {
        if ('number' != typeof t) return null;
        if (t < 0) return null;
        var e = Number(t).toString(2),
          i = 8 - (e.length % 8);
        (8 == i && (i = 0), (e += Kt('', i, '0')));
        var s = parseInt(e, 2).toString(16);
        return (s.length % 2 == 1 && (s = '0' + s), '0' + i + s);
      }
      function Qt(t) {
        if ('string' != typeof t) return null;
        if (t.length % 2 != 0) return null;
        if (!t.match(/^[0-9a-f]+$/)) return null;
        try {
          var e = parseInt(t.substr(0, 2), 16);
          if (e < 0 || 7 < e) return null;
          for (var i = t.substr(2), s = '', n = 0; n < i.length; n += 2) {
            var r = i.substr(n, 2),
              a = parseInt(r, 16).toString(2);
            s += a = ('0000000' + a).slice(-8);
          }
          return s.substr(0, s.length - e);
        } catch (t) {
          return null;
        }
      }
      function Xt(t, e) {
        for (var i = 0, s = 0; s < t.length; s++) i |= 1 << e[t[s]];
        var n = i.toString(2),
          r = '';
        for (s = n.length - 1; s >= 0; s--) r += n[s];
        return r;
      }
      function Yt(t, e, i) {
        if ('object' == typeof t) {
          e = String(e).split('.');
          for (var s = 0; s < e.length && t; s++) {
            var n = e[s];
            (n.match(/^[0-9]+$/) && (n = parseInt(n)), (t = t[n]));
          }
          return t || !1 === t ? t : i;
        }
      }
      function Zt(t, e) {
        var i = function () {};
        ((i.prototype = e.prototype),
          (t.prototype = new i()),
          (t.prototype.constructor = t),
          (t.superclass = e.prototype),
          e.prototype.constructor == Object.prototype.constructor && (e.prototype.constructor = e));
      }
      ((void 0 !== st && st) || (st = {}),
        (void 0 !== st.crypto && st.crypto) || (st.crypto = {}),
        (st.crypto.Util = new (function () {
          ((this.DIGESTINFOHEAD = {
            sha1: '3021300906052b0e03021a05000414',
            sha224: '302d300d06096086480165030402040500041c',
            sha256: '3031300d060960864801650304020105000420',
            sha384: '3041300d060960864801650304020205000430',
            sha512: '3051300d060960864801650304020305000440',
            md2: '3020300c06082a864886f70d020205000410',
            md5: '3020300c06082a864886f70d020505000410',
            ripemd160: '3021300906052b2403020105000414',
          }),
            (this.DEFAULTPROVIDER = {
              md5: 'cryptojs',
              sha1: 'cryptojs',
              sha224: 'cryptojs',
              sha256: 'cryptojs',
              sha384: 'cryptojs',
              sha512: 'cryptojs',
              ripemd160: 'cryptojs',
              hmacmd5: 'cryptojs',
              hmacsha1: 'cryptojs',
              hmacsha224: 'cryptojs',
              hmacsha256: 'cryptojs',
              hmacsha384: 'cryptojs',
              hmacsha512: 'cryptojs',
              hmacripemd160: 'cryptojs',
              MD5withRSA: 'cryptojs/jsrsa',
              SHA1withRSA: 'cryptojs/jsrsa',
              SHA224withRSA: 'cryptojs/jsrsa',
              SHA256withRSA: 'cryptojs/jsrsa',
              SHA384withRSA: 'cryptojs/jsrsa',
              SHA512withRSA: 'cryptojs/jsrsa',
              RIPEMD160withRSA: 'cryptojs/jsrsa',
              MD5withECDSA: 'cryptojs/jsrsa',
              SHA1withECDSA: 'cryptojs/jsrsa',
              SHA224withECDSA: 'cryptojs/jsrsa',
              SHA256withECDSA: 'cryptojs/jsrsa',
              SHA384withECDSA: 'cryptojs/jsrsa',
              SHA512withECDSA: 'cryptojs/jsrsa',
              RIPEMD160withECDSA: 'cryptojs/jsrsa',
              SHA1withDSA: 'cryptojs/jsrsa',
              SHA224withDSA: 'cryptojs/jsrsa',
              SHA256withDSA: 'cryptojs/jsrsa',
              MD5withRSAandMGF1: 'cryptojs/jsrsa',
              SHAwithRSAandMGF1: 'cryptojs/jsrsa',
              SHA1withRSAandMGF1: 'cryptojs/jsrsa',
              SHA224withRSAandMGF1: 'cryptojs/jsrsa',
              SHA256withRSAandMGF1: 'cryptojs/jsrsa',
              SHA384withRSAandMGF1: 'cryptojs/jsrsa',
              SHA512withRSAandMGF1: 'cryptojs/jsrsa',
              RIPEMD160withRSAandMGF1: 'cryptojs/jsrsa',
            }),
            (this.CRYPTOJSMESSAGEDIGESTNAME = {
              md5: d.algo.MD5,
              sha1: d.algo.SHA1,
              sha224: d.algo.SHA224,
              sha256: d.algo.SHA256,
              sha384: d.algo.SHA384,
              sha512: d.algo.SHA512,
              ripemd160: d.algo.RIPEMD160,
            }),
            (this.getDigestInfoHex = function (t, e) {
              if (void 0 === this.DIGESTINFOHEAD[e]) throw 'alg not supported in Util.DIGESTINFOHEAD: ' + e;
              return this.DIGESTINFOHEAD[e] + t;
            }),
            (this.getPaddedDigestInfoHex = function (t, e, i) {
              var s = this.getDigestInfoHex(t, e),
                n = i / 4;
              if (s.length + 22 > n) throw 'key is too short for SigAlg: keylen=' + i + ',' + e;
              for (var r = '0001', a = '00' + s, o = '', h = n - 4 - a.length, l = 0; l < h; l += 2) o += 'ff';
              return r + o + a;
            }),
            (this.hashString = function (t, e) {
              return new st.crypto.MessageDigest({ alg: e }).digestString(t);
            }),
            (this.hashHex = function (t, e) {
              return new st.crypto.MessageDigest({ alg: e }).digestHex(t);
            }),
            (this.sha1 = function (t) {
              return this.hashString(t, 'sha1');
            }),
            (this.sha256 = function (t) {
              return this.hashString(t, 'sha256');
            }),
            (this.sha256Hex = function (t) {
              return this.hashHex(t, 'sha256');
            }),
            (this.sha512 = function (t) {
              return this.hashString(t, 'sha512');
            }),
            (this.sha512Hex = function (t) {
              return this.hashHex(t, 'sha512');
            }),
            (this.isKey = function (t) {
              return t instanceof J || t instanceof st.crypto.DSA || t instanceof st.crypto.ECDSA;
            }));
        })()),
        (st.crypto.Util.md5 = function (t) {
          return new st.crypto.MessageDigest({ alg: 'md5', prov: 'cryptojs' }).digestString(t);
        }),
        (st.crypto.Util.ripemd160 = function (t) {
          return new st.crypto.MessageDigest({ alg: 'ripemd160', prov: 'cryptojs' }).digestString(t);
        }),
        (st.crypto.Util.SECURERANDOMGEN = new Y()),
        (st.crypto.Util.getRandomHexOfNbytes = function (t) {
          var e = new Array(t);
          return (st.crypto.Util.SECURERANDOMGEN.nextBytes(e), lt(e));
        }),
        (st.crypto.Util.getRandomBigIntegerOfNbytes = function (t) {
          return new x(st.crypto.Util.getRandomHexOfNbytes(t), 16);
        }),
        (st.crypto.Util.getRandomHexOfNbits = function (t) {
          var e = t % 8,
            i = new Array((t - e) / 8 + 1);
          return (st.crypto.Util.SECURERANDOMGEN.nextBytes(i), (i[0] = (((255 << e) & 255) ^ 255) & i[0]), lt(i));
        }),
        (st.crypto.Util.getRandomBigIntegerOfNbits = function (t) {
          return new x(st.crypto.Util.getRandomHexOfNbits(t), 16);
        }),
        (st.crypto.Util.getRandomBigIntegerZeroToMax = function (t) {
          for (var e = t.bitLength(); ; ) {
            var i = st.crypto.Util.getRandomBigIntegerOfNbits(e);
            if (-1 != t.compareTo(i)) return i;
          }
        }),
        (st.crypto.Util.getRandomBigIntegerMinToMax = function (t, e) {
          var i = t.compareTo(e);
          if (1 == i) throw 'biMin is greater than biMax';
          if (0 == i) return t;
          var s = e.subtract(t);
          return st.crypto.Util.getRandomBigIntegerZeroToMax(s).add(t);
        }),
        (st.crypto.MessageDigest = function (t) {
          ((this.setAlgAndProvider = function (t, e) {
            if (
              (null !== (t = st.crypto.MessageDigest.getCanonicalAlgName(t)) &&
                void 0 === e &&
                (e = st.crypto.Util.DEFAULTPROVIDER[t]),
              -1 != ':md5:sha1:sha224:sha256:sha384:sha512:ripemd160:'.indexOf(t) && 'cryptojs' == e)
            ) {
              try {
                this.md = st.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t].create();
              } catch (e) {
                throw 'setAlgAndProvider hash alg set fail alg=' + t + '/' + e;
              }
              ((this.updateString = function (t) {
                this.md.update(t);
              }),
                (this.updateHex = function (t) {
                  var e = d.enc.Hex.parse(t);
                  this.md.update(e);
                }),
                (this.digest = function () {
                  return this.md.finalize().toString(d.enc.Hex);
                }),
                (this.digestString = function (t) {
                  return (this.updateString(t), this.digest());
                }),
                (this.digestHex = function (t) {
                  return (this.updateHex(t), this.digest());
                }));
            }
            if (-1 != ':sha256:'.indexOf(t) && 'sjcl' == e) {
              try {
                this.md = new sjcl.hash.sha256();
              } catch (e) {
                throw 'setAlgAndProvider hash alg set fail alg=' + t + '/' + e;
              }
              ((this.updateString = function (t) {
                this.md.update(t);
              }),
                (this.updateHex = function (t) {
                  var e = sjcl.codec.hex.toBits(t);
                  this.md.update(e);
                }),
                (this.digest = function () {
                  var t = this.md.finalize();
                  return sjcl.codec.hex.fromBits(t);
                }),
                (this.digestString = function (t) {
                  return (this.updateString(t), this.digest());
                }),
                (this.digestHex = function (t) {
                  return (this.updateHex(t), this.digest());
                }));
            }
          }),
            (this.updateString = function (t) {
              throw 'updateString(str) not supported for this alg/prov: ' + this.algName + '/' + this.provName;
            }),
            (this.updateHex = function (t) {
              throw 'updateHex(hex) not supported for this alg/prov: ' + this.algName + '/' + this.provName;
            }),
            (this.digest = function () {
              throw 'digest() not supported for this alg/prov: ' + this.algName + '/' + this.provName;
            }),
            (this.digestString = function (t) {
              throw 'digestString(str) not supported for this alg/prov: ' + this.algName + '/' + this.provName;
            }),
            (this.digestHex = function (t) {
              throw 'digestHex(hex) not supported for this alg/prov: ' + this.algName + '/' + this.provName;
            }),
            void 0 !== t &&
              void 0 !== t.alg &&
              ((this.algName = t.alg),
              void 0 === t.prov && (this.provName = st.crypto.Util.DEFAULTPROVIDER[this.algName]),
              this.setAlgAndProvider(this.algName, this.provName)));
        }),
        (st.crypto.MessageDigest.getCanonicalAlgName = function (t) {
          return ('string' == typeof t && (t = (t = t.toLowerCase()).replace(/-/, '')), t);
        }),
        (st.crypto.MessageDigest.getHashLength = function (t) {
          var e = st.crypto.MessageDigest,
            i = e.getCanonicalAlgName(t);
          if (void 0 === e.HASHLENGTH[i]) throw 'not supported algorithm: ' + t;
          return e.HASHLENGTH[i];
        }),
        (st.crypto.MessageDigest.HASHLENGTH = {
          md5: 16,
          sha1: 20,
          sha224: 28,
          sha256: 32,
          sha384: 48,
          sha512: 64,
          ripemd160: 20,
        }),
        (st.crypto.Mac = function (t) {
          ((this.setAlgAndProvider = function (t, e) {
            if ((null == (t = t.toLowerCase()) && (t = 'hmacsha1'), 'hmac' != (t = t.toLowerCase()).substr(0, 4)))
              throw 'setAlgAndProvider unsupported HMAC alg: ' + t;
            (void 0 === e && (e = st.crypto.Util.DEFAULTPROVIDER[t]), (this.algProv = t + '/' + e));
            var i = t.substr(4);
            if (-1 != ':md5:sha1:sha224:sha256:sha384:sha512:ripemd160:'.indexOf(i) && 'cryptojs' == e) {
              try {
                var s = st.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[i];
                this.mac = d.algo.HMAC.create(s, this.pass);
              } catch (t) {
                throw 'setAlgAndProvider hash alg set fail hashAlg=' + i + '/' + t;
              }
              ((this.updateString = function (t) {
                this.mac.update(t);
              }),
                (this.updateHex = function (t) {
                  var e = d.enc.Hex.parse(t);
                  this.mac.update(e);
                }),
                (this.doFinal = function () {
                  return this.mac.finalize().toString(d.enc.Hex);
                }),
                (this.doFinalString = function (t) {
                  return (this.updateString(t), this.doFinal());
                }),
                (this.doFinalHex = function (t) {
                  return (this.updateHex(t), this.doFinal());
                }));
            }
          }),
            (this.updateString = function (t) {
              throw 'updateString(str) not supported for this alg/prov: ' + this.algProv;
            }),
            (this.updateHex = function (t) {
              throw 'updateHex(hex) not supported for this alg/prov: ' + this.algProv;
            }),
            (this.doFinal = function () {
              throw 'digest() not supported for this alg/prov: ' + this.algProv;
            }),
            (this.doFinalString = function (t) {
              throw 'digestString(str) not supported for this alg/prov: ' + this.algProv;
            }),
            (this.doFinalHex = function (t) {
              throw 'digestHex(hex) not supported for this alg/prov: ' + this.algProv;
            }),
            (this.setPassword = function (t) {
              if ('string' == typeof t) {
                var e = t;
                return (
                  (t.length % 2 != 1 && t.match(/^[0-9A-Fa-f]+$/)) || (e = vt(t)),
                  void (this.pass = d.enc.Hex.parse(e))
                );
              }
              if ('object' != typeof t) throw 'KJUR.crypto.Mac unsupported password type: ' + t;
              if (((e = null), void 0 !== t.hex)) {
                if (t.hex.length % 2 != 0 || !t.hex.match(/^[0-9A-Fa-f]+$/)) throw 'Mac: wrong hex password: ' + t.hex;
                e = t.hex;
              }
              if (
                (void 0 !== t.utf8 && (e = mt(t.utf8)),
                void 0 !== t.rstr && (e = vt(t.rstr)),
                void 0 !== t.b64 && (e = g(t.b64)),
                void 0 !== t.b64u && (e = pt(t.b64u)),
                null == e)
              )
                throw 'KJUR.crypto.Mac unsupported password type: ' + t;
              this.pass = d.enc.Hex.parse(e);
            }),
            void 0 !== t &&
              (void 0 !== t.pass && this.setPassword(t.pass),
              void 0 !== t.alg &&
                ((this.algName = t.alg),
                void 0 === t.prov && (this.provName = st.crypto.Util.DEFAULTPROVIDER[this.algName]),
                this.setAlgAndProvider(this.algName, this.provName))));
        }),
        (st.crypto.Signature = function (t) {
          var e = null;
          if (
            ((this._setAlgNames = function () {
              var t = this.algName.match(/^(.+)with(.+)$/);
              t &&
                ((this.mdAlgName = t[1].toLowerCase()),
                (this.pubkeyAlgName = t[2].toLowerCase()),
                'rsaandmgf1' == this.pubkeyAlgName && 'sha' == this.mdAlgName && (this.mdAlgName = 'sha1'));
            }),
            (this._zeroPaddingOfSignature = function (t, e) {
              for (var i = '', s = e / 4 - t.length, n = 0; n < s; n++) i += '0';
              return i + t;
            }),
            (this.setAlgAndProvider = function (t, e) {
              if ((this._setAlgNames(), 'cryptojs/jsrsa' != e)) throw new Error('provider not supported: ' + e);
              if (-1 != ':md5:sha1:sha224:sha256:sha384:sha512:ripemd160:'.indexOf(this.mdAlgName)) {
                try {
                  this.md = new st.crypto.MessageDigest({ alg: this.mdAlgName });
                } catch (t) {
                  throw new Error('setAlgAndProvider hash alg set fail alg=' + this.mdAlgName + '/' + t);
                }
                ((this.init = function (t, e) {
                  var i = null;
                  try {
                    i = void 0 === e ? Jt.getKey(t) : Jt.getKey(t, e);
                  } catch (t) {
                    throw 'init failed:' + t;
                  }
                  if (!0 === i.isPrivate) ((this.prvKey = i), (this.state = 'SIGN'));
                  else {
                    if (!0 !== i.isPublic) throw 'init failed.:' + i;
                    ((this.pubKey = i), (this.state = 'VERIFY'));
                  }
                }),
                  (this.updateString = function (t) {
                    this.md.updateString(t);
                  }),
                  (this.updateHex = function (t) {
                    this.md.updateHex(t);
                  }),
                  (this.sign = function () {
                    if (
                      ((this.sHashHex = this.md.digest()),
                      void 0 === this.prvKey &&
                        void 0 !== this.ecprvhex &&
                        void 0 !== this.eccurvename &&
                        void 0 !== st.crypto.ECDSA &&
                        (this.prvKey = new st.crypto.ECDSA({ curve: this.eccurvename, prv: this.ecprvhex })),
                      this.prvKey instanceof J && 'rsaandmgf1' === this.pubkeyAlgName)
                    )
                      this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
                    else if (this.prvKey instanceof J && 'rsa' === this.pubkeyAlgName)
                      this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
                    else if (this.prvKey instanceof st.crypto.ECDSA)
                      this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                    else {
                      if (!(this.prvKey instanceof st.crypto.DSA))
                        throw 'Signature: unsupported private key alg: ' + this.pubkeyAlgName;
                      this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                    }
                    return this.hSign;
                  }),
                  (this.signString = function (t) {
                    return (this.updateString(t), this.sign());
                  }),
                  (this.signHex = function (t) {
                    return (this.updateHex(t), this.sign());
                  }),
                  (this.verify = function (t) {
                    if (
                      ((this.sHashHex = this.md.digest()),
                      void 0 === this.pubKey &&
                        void 0 !== this.ecpubhex &&
                        void 0 !== this.eccurvename &&
                        void 0 !== st.crypto.ECDSA &&
                        (this.pubKey = new st.crypto.ECDSA({ curve: this.eccurvename, pub: this.ecpubhex })),
                      this.pubKey instanceof J && 'rsaandmgf1' === this.pubkeyAlgName)
                    )
                      return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, t, this.mdAlgName, this.pssSaltLen);
                    if (this.pubKey instanceof J && 'rsa' === this.pubkeyAlgName)
                      return this.pubKey.verifyWithMessageHash(this.sHashHex, t);
                    if (void 0 !== st.crypto.ECDSA && this.pubKey instanceof st.crypto.ECDSA)
                      return this.pubKey.verifyWithMessageHash(this.sHashHex, t);
                    if (void 0 !== st.crypto.DSA && this.pubKey instanceof st.crypto.DSA)
                      return this.pubKey.verifyWithMessageHash(this.sHashHex, t);
                    throw 'Signature: unsupported public key alg: ' + this.pubkeyAlgName;
                  }));
              }
            }),
            (this.init = function (t, e) {
              throw 'init(key, pass) not supported for this alg:prov=' + this.algProvName;
            }),
            (this.updateString = function (t) {
              throw 'updateString(str) not supported for this alg:prov=' + this.algProvName;
            }),
            (this.updateHex = function (t) {
              throw 'updateHex(hex) not supported for this alg:prov=' + this.algProvName;
            }),
            (this.sign = function () {
              throw 'sign() not supported for this alg:prov=' + this.algProvName;
            }),
            (this.signString = function (t) {
              throw 'digestString(str) not supported for this alg:prov=' + this.algProvName;
            }),
            (this.signHex = function (t) {
              throw 'digestHex(hex) not supported for this alg:prov=' + this.algProvName;
            }),
            (this.verify = function (t) {
              throw 'verify(hSigVal) not supported for this alg:prov=' + this.algProvName;
            }),
            (this.initParams = t),
            void 0 !== t &&
              (void 0 !== t.alg &&
                ((this.algName = t.alg),
                void 0 === t.prov
                  ? (this.provName = st.crypto.Util.DEFAULTPROVIDER[this.algName])
                  : (this.provName = t.prov),
                (this.algProvName = this.algName + ':' + this.provName),
                this.setAlgAndProvider(this.algName, this.provName),
                this._setAlgNames()),
              void 0 !== t.psssaltlen && (this.pssSaltLen = t.psssaltlen),
              void 0 !== t.prvkeypem))
          ) {
            if (void 0 !== t.prvkeypas) throw 'both prvkeypem and prvkeypas parameters not supported';
            try {
              ((e = Jt.getKey(t.prvkeypem)), this.init(e));
            } catch (t) {
              throw 'fatal error to load pem private key: ' + t;
            }
          }
        }),
        (st.crypto.Cipher = function (t) {}),
        (st.crypto.Cipher.encrypt = function (t, e, i, s) {
          if ((null != Yt(s, 'enclag') && (i = s.encalg), 'string' == typeof i && '-CBC' == i.substr(-4))) {
            var n = e,
              r = t;
            (null != Yt(s, 'key') && (n = s.key), null != Yt(s, 'enc') && (hEnc = s.enc));
            var a,
              o = d.enc.Hex.parse(n),
              h = d.enc.Hex.parse(r),
              l = d.enc.Hex.parse(s.iv);
            if ('des-EDE3-CBC' == i) a = d.TripleDES.encrypt(h, o, { iv: l });
            else {
              if ('aes128-CBC' != i && 'aes256-CBC' != i) throw new Error('unsupported algorithm: ' + i);
              a = d.AES.encrypt(h, o, { iv: l });
            }
            return a + '';
          }
          throw new Error('Cipher.encrypt: unsupported key or algorithm');
        }),
        (st.crypto.Cipher.decrypt = function (t, e, i, s) {
          if ((null != Yt(s, 'enclag') && (i = s.encalg), 'string' == typeof i && '-CBC' == i.substr(-4))) {
            var n = e,
              r = t;
            (null != Yt(s, 'key') && (n = s.key), null != Yt(s, 'enc') && (r = s.enc));
            var a,
              o = d.enc.Hex.parse(n),
              h = d.enc.Hex.parse(r),
              l = d.enc.Hex.parse(s.iv);
            if ('des-EDE3-CBC' == i) a = d.TripleDES.decrypt({ ciphertext: h }, o, { iv: l });
            else {
              if ('aes128-CBC' != i && 'aes256-CBC' != i) throw new Error('unsupported algorithm: ' + i);
              a = d.AES.decrypt({ ciphertext: h }, o, { iv: l });
            }
            return d.enc.Hex.stringify(a);
          }
          throw new Error('Cipher.decrypt: unsupported key or algorithm');
        }),
        (st.crypto.OID = new (function () {
          this.oidhex2name = {
            '2a864886f70d010101': 'rsaEncryption',
            '2a8648ce3d0201': 'ecPublicKey',
            '2a8648ce380401': 'dsa',
            '2a8648ce3d030107': 'secp256r1',
            '2b8104001f': 'secp192k1',
            '2b81040021': 'secp224r1',
            '2b8104000a': 'secp256k1',
            '2b81040022': 'secp384r1',
            '2b81040023': 'secp521r1',
            '2a8648ce380403': 'SHA1withDSA',
            '608648016503040301': 'SHA224withDSA',
            '608648016503040302': 'SHA256withDSA',
          };
        })()),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.crypto && st.crypto) || (st.crypto = {}),
        (st.crypto.ECDSA = function (t) {
          var e = Error,
            i = x,
            s = tt,
            n = st.crypto.ECDSA,
            r = st.crypto.ECParameterDB,
            a = n.getName,
            o = at,
            h = o.getVbyListEx,
            l = o.isASN1HEX,
            c = new Y();
          ((this.type = 'EC'),
            (this.isPrivate = !1),
            (this.isPublic = !1),
            (this.getBigRandom = function (t) {
              return new i(t.bitLength(), c).mod(t.subtract(i.ONE)).add(i.ONE);
            }),
            (this.setNamedCurve = function (t) {
              ((this.ecparams = r.getByName(t)),
                (this.prvKeyHex = null),
                (this.pubKeyHex = null),
                (this.curveName = t));
            }),
            (this.setPrivateKeyHex = function (t) {
              ((this.isPrivate = !0), (this.prvKeyHex = t));
            }),
            (this.setPublicKeyHex = function (t) {
              ((this.isPublic = !0), (this.pubKeyHex = t));
            }),
            (this.getPublicKeyXYHex = function () {
              var t = this.pubKeyHex;
              if ('04' !== t.substr(0, 2)) throw 'this method supports uncompressed format(04) only';
              var e = this.ecparams.keycharlen;
              if (t.length !== 2 + 2 * e) throw 'malformed public key hex length';
              var i = {};
              return ((i.x = t.substr(2, e)), (i.y = t.substr(2 + e)), i);
            }),
            (this.getShortNISTPCurveName = function () {
              var t = this.curveName;
              return 'secp256r1' === t || 'NIST P-256' === t || 'P-256' === t || 'prime256v1' === t
                ? 'P-256'
                : 'secp384r1' === t || 'NIST P-384' === t || 'P-384' === t
                  ? 'P-384'
                  : 'secp521r1' === t || 'NIST P-521' === t || 'P-521' === t
                    ? 'P-521'
                    : null;
            }),
            (this.generateKeyPairHex = function () {
              var t = this.ecparams.n,
                e = this.getBigRandom(t),
                i = this.ecparams.keycharlen,
                s = ('0000000000' + e.toString(16)).slice(-i);
              return (this.setPrivateKeyHex(s), { ecprvhex: s, ecpubhex: this.generatePublicKeyHex() });
            }),
            (this.generatePublicKeyHex = function () {
              var t = new i(this.prvKeyHex, 16),
                e = this.ecparams.G.multiply(t),
                s = e.getX().toBigInteger(),
                n = e.getY().toBigInteger(),
                r = this.ecparams.keycharlen,
                a = '04' + ('0000000000' + s.toString(16)).slice(-r) + ('0000000000' + n.toString(16)).slice(-r);
              return (this.setPublicKeyHex(a), a);
            }),
            (this.signWithMessageHash = function (t) {
              return this.signHex(t, this.prvKeyHex);
            }),
            (this.signHex = function (t, e) {
              var s = new i(e, 16),
                r = this.ecparams.n,
                a = new i(t.substring(0, this.ecparams.keycharlen), 16);
              do {
                var o = this.getBigRandom(r),
                  h = this.ecparams.G.multiply(o).getX().toBigInteger().mod(r);
              } while (h.compareTo(i.ZERO) <= 0);
              var l = o
                .modInverse(r)
                .multiply(a.add(s.multiply(h)))
                .mod(r);
              return n.biRSSigToASN1Sig(h, l);
            }),
            (this.sign = function (t, e) {
              var s = e,
                n = this.ecparams.n,
                r = i.fromByteArrayUnsigned(t);
              do {
                var a = this.getBigRandom(n),
                  o = this.ecparams.G.multiply(a).getX().toBigInteger().mod(n);
              } while (o.compareTo(x.ZERO) <= 0);
              var h = a
                .modInverse(n)
                .multiply(r.add(s.multiply(o)))
                .mod(n);
              return this.serializeSig(o, h);
            }),
            (this.verifyWithMessageHash = function (t, e) {
              return this.verifyHex(t, e, this.pubKeyHex);
            }),
            (this.verifyHex = function (t, e, r) {
              try {
                var a,
                  o,
                  h = n.parseSigHex(e);
                ((a = h.r), (o = h.s));
                var l = s.decodeFromHex(this.ecparams.curve, r),
                  c = new i(t.substring(0, this.ecparams.keycharlen), 16);
                return this.verifyRaw(c, a, o, l);
              } catch (t) {
                return !1;
              }
            }),
            (this.verify = function (t, e, n) {
              var r, a, o;
              if (Bitcoin.Util.isArray(e)) {
                var h = this.parseSig(e);
                ((r = h.r), (a = h.s));
              } else {
                if ('object' != typeof e || !e.r || !e.s) throw 'Invalid value for signature';
                ((r = e.r), (a = e.s));
              }
              if (n instanceof tt) o = n;
              else {
                if (!Bitcoin.Util.isArray(n)) throw 'Invalid format for pubkey value, must be byte array or ECPointFp';
                o = s.decodeFrom(this.ecparams.curve, n);
              }
              var l = i.fromByteArrayUnsigned(t);
              return this.verifyRaw(l, r, a, o);
            }),
            (this.verifyRaw = function (t, e, s, n) {
              var r = this.ecparams.n,
                a = this.ecparams.G;
              if (e.compareTo(i.ONE) < 0 || e.compareTo(r) >= 0) return !1;
              if (s.compareTo(i.ONE) < 0 || s.compareTo(r) >= 0) return !1;
              var o = s.modInverse(r),
                h = t.multiply(o).mod(r),
                l = e.multiply(o).mod(r);
              return a.multiply(h).add(n.multiply(l)).getX().toBigInteger().mod(r).equals(e);
            }),
            (this.serializeSig = function (t, e) {
              var i = t.toByteArraySigned(),
                s = e.toByteArraySigned(),
                n = [];
              return (
                n.push(2),
                n.push(i.length),
                (n = n.concat(i)).push(2),
                n.push(s.length),
                (n = n.concat(s)).unshift(n.length),
                n.unshift(48),
                n
              );
            }),
            (this.parseSig = function (t) {
              var e;
              if (48 != t[0]) throw new Error('Signature not a valid DERSequence');
              if (2 != t[(e = 2)]) throw new Error('First element in signature must be a DERInteger');
              var s = t.slice(e + 2, e + 2 + t[e + 1]);
              if (2 != t[(e += 2 + t[e + 1])]) throw new Error('Second element in signature must be a DERInteger');
              var n = t.slice(e + 2, e + 2 + t[e + 1]);
              return ((e += 2 + t[e + 1]), { r: i.fromByteArrayUnsigned(s), s: i.fromByteArrayUnsigned(n) });
            }),
            (this.parseSigCompact = function (t) {
              if (65 !== t.length) throw 'Signature has the wrong length';
              var e = t[0] - 27;
              if (e < 0 || e > 7) throw 'Invalid signature type';
              var s = this.ecparams.n;
              return {
                r: i.fromByteArrayUnsigned(t.slice(1, 33)).mod(s),
                s: i.fromByteArrayUnsigned(t.slice(33, 65)).mod(s),
                i: e,
              };
            }),
            (this.readPKCS5PrvKeyHex = function (t) {
              if (!1 === l(t)) throw new Error('not ASN.1 hex string');
              var e, i, s;
              try {
                ((e = h(t, 0, ['[0]', 0], '06')), (i = h(t, 0, [1], '04')));
                try {
                  s = h(t, 0, ['[1]', 0], '03');
                } catch (t) {}
              } catch (t) {
                throw new Error('malformed PKCS#1/5 plain ECC private key');
              }
              if (((this.curveName = a(e)), void 0 === this.curveName)) throw 'unsupported curve name';
              (this.setNamedCurve(this.curveName),
                this.setPublicKeyHex(s),
                this.setPrivateKeyHex(i),
                (this.isPublic = !1));
            }),
            (this.readPKCS8PrvKeyHex = function (t) {
              if (!1 === l(t)) throw new e('not ASN.1 hex string');
              var i, s, n;
              try {
                (h(t, 0, [1, 0], '06'), (i = h(t, 0, [1, 1], '06')), (s = h(t, 0, [2, 0, 1], '04')));
                try {
                  n = h(t, 0, [2, 0, '[1]', 0], '03');
                } catch (t) {}
              } catch (t) {
                throw new e('malformed PKCS#8 plain ECC private key');
              }
              if (((this.curveName = a(i)), void 0 === this.curveName)) throw new e('unsupported curve name');
              (this.setNamedCurve(this.curveName),
                this.setPublicKeyHex(n),
                this.setPrivateKeyHex(s),
                (this.isPublic = !1));
            }),
            (this.readPKCS8PubKeyHex = function (t) {
              if (!1 === l(t)) throw new e('not ASN.1 hex string');
              var i, s;
              try {
                (h(t, 0, [0, 0], '06'), (i = h(t, 0, [0, 1], '06')), (s = h(t, 0, [1], '03')));
              } catch (t) {
                throw new e('malformed PKCS#8 ECC public key');
              }
              if (((this.curveName = a(i)), null === this.curveName)) throw new e('unsupported curve name');
              (this.setNamedCurve(this.curveName), this.setPublicKeyHex(s));
            }),
            (this.readCertPubKeyHex = function (t, i) {
              if (!1 === l(t)) throw new e('not ASN.1 hex string');
              var s, n;
              try {
                ((s = h(t, 0, [0, 5, 0, 1], '06')), (n = h(t, 0, [0, 5, 1], '03')));
              } catch (t) {
                throw new e('malformed X.509 certificate ECC public key');
              }
              if (((this.curveName = a(s)), null === this.curveName)) throw new e('unsupported curve name');
              (this.setNamedCurve(this.curveName), this.setPublicKeyHex(n));
            }),
            void 0 !== t && void 0 !== t.curve && (this.curveName = t.curve),
            void 0 === this.curveName && (this.curveName = 'secp256r1'),
            this.setNamedCurve(this.curveName),
            void 0 !== t &&
              (void 0 !== t.prv && this.setPrivateKeyHex(t.prv), void 0 !== t.pub && this.setPublicKeyHex(t.pub)));
        }),
        (st.crypto.ECDSA.parseSigHex = function (t) {
          var e = st.crypto.ECDSA.parseSigHexInHexRS(t);
          return { r: new x(e.r, 16), s: new x(e.s, 16) };
        }),
        (st.crypto.ECDSA.parseSigHexInHexRS = function (t) {
          var e = at,
            i = e.getChildIdx,
            s = e.getV;
          if ((e.checkStrictDER(t, 0), '30' != t.substr(0, 2))) throw new Error('signature is not a ASN.1 sequence');
          var n = i(t, 0);
          if (2 != n.length) throw new Error('signature shall have two elements');
          var r = n[0],
            a = n[1];
          if ('02' != t.substr(r, 2)) throw new Error('1st item not ASN.1 integer');
          if ('02' != t.substr(a, 2)) throw new Error('2nd item not ASN.1 integer');
          return { r: s(t, r), s: s(t, a) };
        }),
        (st.crypto.ECDSA.asn1SigToConcatSig = function (t) {
          var e = st.crypto.ECDSA.parseSigHexInHexRS(t),
            i = e.r,
            s = e.s;
          if (i.length >= 130 && i.length <= 134) {
            if (i.length % 2 != 0) throw Error('unknown ECDSA sig r length error');
            if (s.length % 2 != 0) throw Error('unknown ECDSA sig s length error');
            ('00' == i.substr(0, 2) && (i = i.substr(2)), '00' == s.substr(0, 2) && (s = s.substr(2)));
            var n = Math.max(i.length, s.length);
            return (i = ('000000' + i).slice(-n)) + (s = ('000000' + s).slice(-n));
          }
          if (
            ('00' == i.substr(0, 2) && i.length % 32 == 2 && (i = i.substr(2)),
            '00' == s.substr(0, 2) && s.length % 32 == 2 && (s = s.substr(2)),
            i.length % 32 == 30 && (i = '00' + i),
            s.length % 32 == 30 && (s = '00' + s),
            i.length % 32 != 0)
          )
            throw Error('unknown ECDSA sig r length error');
          if (s.length % 32 != 0) throw Error('unknown ECDSA sig s length error');
          return i + s;
        }),
        (st.crypto.ECDSA.concatSigToASN1Sig = function (t) {
          if (t.length % 4 != 0) throw Error('unknown ECDSA concatinated r-s sig length error');
          var e = t.substr(0, t.length / 2),
            i = t.substr(t.length / 2);
          return st.crypto.ECDSA.hexRSSigToASN1Sig(e, i);
        }),
        (st.crypto.ECDSA.hexRSSigToASN1Sig = function (t, e) {
          var i = new x(t, 16),
            s = new x(e, 16);
          return st.crypto.ECDSA.biRSSigToASN1Sig(i, s);
        }),
        (st.crypto.ECDSA.biRSSigToASN1Sig = function (t, e) {
          var i = st.asn1,
            s = new i.DERInteger({ bigint: t }),
            n = new i.DERInteger({ bigint: e });
          return new i.DERSequence({ array: [s, n] }).tohex();
        }),
        (st.crypto.ECDSA.getName = function (t) {
          return '2b8104001f' === t
            ? 'secp192k1'
            : '2a8648ce3d030107' === t
              ? 'secp256r1'
              : '2b8104000a' === t
                ? 'secp256k1'
                : '2b81040021' === t
                  ? 'secp224r1'
                  : '2b81040022' === t
                    ? 'secp384r1'
                    : '2b81040023' === t
                      ? 'secp521r1'
                      : -1 !== '|secp256r1|NIST P-256|P-256|prime256v1|'.indexOf(t)
                        ? 'secp256r1'
                        : -1 !== '|secp256k1|'.indexOf(t)
                          ? 'secp256k1'
                          : -1 !== '|secp224r1|NIST P-224|P-224|'.indexOf(t)
                            ? 'secp224r1'
                            : -1 !== '|secp384r1|NIST P-384|P-384|'.indexOf(t)
                              ? 'secp384r1'
                              : -1 !== '|secp521r1|NIST P-521|P-521|'.indexOf(t)
                                ? 'secp521r1'
                                : null;
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.crypto && st.crypto) || (st.crypto = {}),
        (st.crypto.ECParameterDB = new (function () {
          var t = {},
            e = {};
          function i(t) {
            return new x(t, 16);
          }
          ((this.getByName = function (i) {
            var s = i;
            if ((void 0 !== e[s] && (s = e[i]), void 0 !== t[s])) return t[s];
            throw 'unregistered EC curve name: ' + s;
          }),
            (this.regist = function (s, n, r, a, o, h, l, c, u, d, f, p) {
              t[s] = {};
              var m = i(r),
                g = i(a),
                y = i(o),
                x = i(h),
                v = i(l),
                b = new et(m, g, y),
                w = b.decodePointHex('04' + c + u);
              ((t[s].name = s),
                (t[s].keylen = n),
                (t[s].keycharlen = 2 * Math.ceil(n / 8)),
                (t[s].curve = b),
                (t[s].G = w),
                (t[s].n = x),
                (t[s].h = v),
                (t[s].oid = f),
                (t[s].info = p));
              for (var S = 0; S < d.length; S++) e[d[S]] = s;
            }));
        })()),
        st.crypto.ECParameterDB.regist(
          'secp128r1',
          128,
          'FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF',
          'FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC',
          'E87579C11079F43DD824993C2CEE5ED3',
          'FFFFFFFE0000000075A30D1B9038A115',
          '1',
          '161FF7528B899B2D0C28607CA52C5B86',
          'CF5AC8395BAFEB13C02DA292DDED7A83',
          [],
          '',
          'secp128r1 : SECG curve over a 128 bit prime field',
        ),
        st.crypto.ECParameterDB.regist(
          'secp160k1',
          160,
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73',
          '0',
          '7',
          '0100000000000000000001B8FA16DFAB9ACA16B6B3',
          '1',
          '3B4C382CE37AA192A4019E763036F4F5DD4D7EBB',
          '938CF935318FDCED6BC28286531733C3F03C4FEE',
          [],
          '',
          'secp160k1 : SECG curve over a 160 bit prime field',
        ),
        st.crypto.ECParameterDB.regist(
          'secp160r1',
          160,
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF',
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC',
          '1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45',
          '0100000000000000000001F4C8F927AED3CA752257',
          '1',
          '4A96B5688EF573284664698968C38BB913CBFC82',
          '23A628553168947D59DCC912042351377AC5FB32',
          [],
          '',
          'secp160r1 : SECG curve over a 160 bit prime field',
        ),
        st.crypto.ECParameterDB.regist(
          'secp192k1',
          192,
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37',
          '0',
          '3',
          'FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D',
          '1',
          'DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D',
          '9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D',
          [],
        ),
        st.crypto.ECParameterDB.regist(
          'secp192r1',
          192,
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF',
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC',
          '64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1',
          'FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831',
          '1',
          '188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012',
          '07192B95FFC8DA78631011ED6B24CDD573F977A11E794811',
          [],
        ),
        st.crypto.ECParameterDB.regist(
          'secp224r1',
          224,
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001',
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE',
          'B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4',
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D',
          '1',
          'B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21',
          'BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34',
          [],
        ),
        st.crypto.ECParameterDB.regist(
          'secp256k1',
          256,
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F',
          '0',
          '7',
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141',
          '1',
          '79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798',
          '483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8',
          [],
        ),
        st.crypto.ECParameterDB.regist(
          'secp256r1',
          256,
          'FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF',
          'FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC',
          '5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B',
          'FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551',
          '1',
          '6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296',
          '4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5',
          ['NIST P-256', 'P-256', 'prime256v1'],
        ),
        st.crypto.ECParameterDB.regist(
          'secp384r1',
          384,
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF',
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC',
          'B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF',
          'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973',
          '1',
          'AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7',
          '3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f',
          ['NIST P-384', 'P-384'],
        ),
        st.crypto.ECParameterDB.regist(
          'secp521r1',
          521,
          '1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF',
          '1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC',
          '051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00',
          '1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409',
          '1',
          '00C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66',
          '011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650',
          ['NIST P-521', 'P-521'],
        ),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.crypto && st.crypto) || (st.crypto = {}),
        (st.crypto.DSA = function () {
          var t = at;
          t.getVbyList;
          var e = t.getVbyListEx,
            i = t.isASN1HEX,
            s = x;
          ((this.p = null),
            (this.q = null),
            (this.g = null),
            (this.y = null),
            (this.x = null),
            (this.type = 'DSA'),
            (this.isPrivate = !1),
            (this.isPublic = !1),
            (this.setPrivate = function (t, e, i, s, n) {
              ((this.isPrivate = !0), (this.p = t), (this.q = e), (this.g = i), (this.y = s), (this.x = n));
            }),
            (this.setPrivateHex = function (t, e, i, s, n) {
              var r, a, o, h, l;
              ((r = new x(t, 16)),
                (a = new x(e, 16)),
                (o = new x(i, 16)),
                (h = 'string' == typeof s && s.length > 1 ? new x(s, 16) : null),
                (l = new x(n, 16)),
                this.setPrivate(r, a, o, h, l));
            }),
            (this.setPublic = function (t, e, i, s) {
              ((this.isPublic = !0), (this.p = t), (this.q = e), (this.g = i), (this.y = s), (this.x = null));
            }),
            (this.setPublicHex = function (t, e, i, s) {
              var n, r, a, o;
              ((n = new x(t, 16)),
                (r = new x(e, 16)),
                (a = new x(i, 16)),
                (o = new x(s, 16)),
                this.setPublic(n, r, a, o));
            }),
            (this.signWithMessageHash = function (t) {
              var e = this.p,
                i = this.q,
                s = this.g;
              this.y;
              var n = this.x,
                r = st.crypto.Util.getRandomBigIntegerMinToMax(x.ONE.add(x.ONE), i.subtract(x.ONE)),
                a = new x(t.substr(0, i.bitLength() / 4), 16),
                o = s.modPow(r, e).mod(i),
                h = r
                  .modInverse(i)
                  .multiply(a.add(n.multiply(o)))
                  .mod(i);
              return st.asn1.ASN1Util.jsonToASN1HEX({ seq: [{ int: { bigint: o } }, { int: { bigint: h } }] });
            }),
            (this.verifyWithMessageHash = function (t, e) {
              var i = this.p,
                s = this.q,
                n = this.g,
                r = this.y,
                a = this.parseASN1Signature(e),
                o = a[0],
                h = a[1],
                l = new x(t.substr(0, s.bitLength() / 4), 16);
              if (x.ZERO.compareTo(o) > 0 || o.compareTo(s) > 0) throw 'invalid DSA signature';
              if (x.ZERO.compareTo(h) >= 0 || h.compareTo(s) > 0) throw 'invalid DSA signature';
              var c = h.modInverse(s),
                u = l.multiply(c).mod(s),
                d = o.multiply(c).mod(s);
              return 0 == n.modPow(u, i).multiply(r.modPow(d, i)).mod(i).mod(s).compareTo(o);
            }),
            (this.parseASN1Signature = function (t) {
              try {
                return [new s(e(t, 0, [0], '02'), 16), new s(e(t, 0, [1], '02'), 16)];
              } catch (t) {
                throw new Error('malformed ASN.1 DSA signature');
              }
            }),
            (this.readPKCS5PrvKeyHex = function (t) {
              var s, n, r, a, o;
              if (!1 === i(t)) throw new Error('not ASN.1 hex string');
              try {
                ((s = e(t, 0, [1], '02')),
                  (n = e(t, 0, [2], '02')),
                  (r = e(t, 0, [3], '02')),
                  (a = e(t, 0, [4], '02')),
                  (o = e(t, 0, [5], '02')));
              } catch (t) {
                throw new Error('malformed PKCS#1/5 plain DSA private key');
              }
              this.setPrivateHex(s, n, r, a, o);
            }),
            (this.readPKCS8PrvKeyHex = function (t) {
              var s, n, r, a;
              if (!1 === i(t)) throw new Error('not ASN.1 hex string');
              try {
                ((s = e(t, 0, [1, 1, 0], '02')),
                  (n = e(t, 0, [1, 1, 1], '02')),
                  (r = e(t, 0, [1, 1, 2], '02')),
                  (a = e(t, 0, [2, 0], '02')));
              } catch (t) {
                throw new Error('malformed PKCS#8 plain DSA private key');
              }
              this.setPrivateHex(s, n, r, null, a);
            }),
            (this.readPKCS8PubKeyHex = function (t) {
              var s, n, r, a;
              if (!1 === i(t)) throw new Error('not ASN.1 hex string');
              try {
                ((s = e(t, 0, [0, 1, 0], '02')),
                  (n = e(t, 0, [0, 1, 1], '02')),
                  (r = e(t, 0, [0, 1, 2], '02')),
                  (a = e(t, 0, [1, 0], '02')));
              } catch (t) {
                throw new Error('malformed PKCS#8 DSA public key');
              }
              this.setPublicHex(s, n, r, a);
            }),
            (this.readCertPubKeyHex = function (t, s) {
              var n, r, a, o;
              if (!1 === i(t)) throw new Error('not ASN.1 hex string');
              try {
                ((n = e(t, 0, [0, 5, 0, 1, 0], '02')),
                  (r = e(t, 0, [0, 5, 0, 1, 1], '02')),
                  (a = e(t, 0, [0, 5, 0, 1, 2], '02')),
                  (o = e(t, 0, [0, 5, 1, 0], '02')));
              } catch (t) {
                throw new Error('malformed X.509 certificate DSA public key');
              }
              this.setPublicHex(n, r, a, o);
            }));
        }));
      var Jt = (function () {
        var t = function (t, i, s) {
            return e(d.AES, t, i, s);
          },
          e = function (t, e, i, s) {
            var n = d.enc.Hex.parse(e),
              r = d.enc.Hex.parse(i),
              a = d.enc.Hex.parse(s),
              o = {};
            ((o.key = r), (o.iv = a), (o.ciphertext = n));
            var h = t.decrypt(o, r, { iv: a });
            return d.enc.Hex.stringify(h);
          },
          i = function (t, e, i) {
            return s(d.AES, t, e, i);
          },
          s = function (t, e, i, s) {
            var n = d.enc.Hex.parse(e),
              r = d.enc.Hex.parse(i),
              a = d.enc.Hex.parse(s),
              o = t.encrypt(n, r, { iv: a }),
              h = d.enc.Hex.parse(o.toString());
            return d.enc.Base64.stringify(h);
          },
          n = {
            'AES-256-CBC': { proc: t, eproc: i, keylen: 32, ivlen: 16 },
            'AES-192-CBC': { proc: t, eproc: i, keylen: 24, ivlen: 16 },
            'AES-128-CBC': { proc: t, eproc: i, keylen: 16, ivlen: 16 },
            'DES-EDE3-CBC': {
              proc: function (t, i, s) {
                return e(d.TripleDES, t, i, s);
              },
              eproc: function (t, e, i) {
                return s(d.TripleDES, t, e, i);
              },
              keylen: 24,
              ivlen: 8,
            },
            'DES-CBC': {
              proc: function (t, i, s) {
                return e(d.DES, t, i, s);
              },
              eproc: function (t, e, i) {
                return s(d.DES, t, e, i);
              },
              keylen: 8,
              ivlen: 8,
            },
          },
          r = function (t) {
            var e = {},
              i = t.match(new RegExp('DEK-Info: ([^,]+),([0-9A-Fa-f]+)', 'm'));
            i && ((e.cipher = i[1]), (e.ivsalt = i[2]));
            var s = t.match(new RegExp('-----BEGIN ([A-Z]+) PRIVATE KEY-----'));
            s && (e.type = s[1]);
            var n = -1,
              r = 0;
            (-1 != t.indexOf('\r\n\r\n') && ((n = t.indexOf('\r\n\r\n')), (r = 2)),
              -1 != t.indexOf('\n\n') && ((n = t.indexOf('\n\n')), (r = 1)));
            var a = t.indexOf('-----END');
            if (-1 != n && -1 != a) {
              var o = t.substring(n + 2 * r, a - r);
              ((o = o.replace(/\s+/g, '')), (e.data = o));
            }
            return e;
          },
          a = function (t, e, i) {
            for (
              var s = i.substring(0, 16),
                r = d.enc.Hex.parse(s),
                a = d.enc.Utf8.parse(e),
                o = n[t].keylen + n[t].ivlen,
                h = '',
                l = null;
              ;

            ) {
              var c = d.algo.MD5.create();
              if (
                (null != l && c.update(l),
                c.update(a),
                c.update(r),
                (l = c.finalize()),
                (h += d.enc.Hex.stringify(l)).length >= 2 * o)
              )
                break;
            }
            var u = {};
            return (
              (u.keyhex = h.substr(0, 2 * n[t].keylen)),
              (u.ivhex = h.substr(2 * n[t].keylen, 2 * n[t].ivlen)),
              u
            );
          },
          o = function (t, e, i, s) {
            var r = d.enc.Base64.parse(t),
              a = d.enc.Hex.stringify(r);
            return (0, n[e].proc)(a, i, s);
          };
        return {
          version: '1.0.0',
          parsePKCS5PEM: function (t) {
            return r(t);
          },
          getKeyAndUnusedIvByPasscodeAndIvsalt: function (t, e, i) {
            return a(t, e, i);
          },
          decryptKeyB64: function (t, e, i, s) {
            return o(t, e, i, s);
          },
          getDecryptedKeyHex: function (t, e) {
            var i = r(t),
              s = i.cipher,
              n = i.ivsalt,
              h = i.data,
              l = a(s, e, n).keyhex;
            return o(h, s, l, n);
          },
          getEncryptedPKCS5PEMFromPrvKeyHex: function (t, e, i, s, r) {
            var o = '';
            if (((void 0 !== s && null != s) || (s = 'AES-256-CBC'), void 0 === n[s]))
              throw new Error('KEYUTIL unsupported algorithm: ' + s);
            if (void 0 === r || null == r) {
              var h = (function (t) {
                var e = d.lib.WordArray.random(t);
                return d.enc.Hex.stringify(e);
              })(n[s].ivlen);
              r = h.toUpperCase();
            }
            var l = (function (t, e, i, s) {
              return (0, n[e].eproc)(t, i, s);
            })(e, s, a(s, i, r).keyhex, r);
            return (
              (o = '-----BEGIN ' + t + ' PRIVATE KEY-----\r\n'),
              (o += 'Proc-Type: 4,ENCRYPTED\r\n'),
              (o += 'DEK-Info: ' + s + ',' + r + '\r\n'),
              (o += '\r\n'),
              (o += l.replace(/(.{64})/g, '$1\r\n')),
              (o += '\r\n-----END ' + t + ' PRIVATE KEY-----\r\n')
            );
          },
          getEncryptedPKCS8PEM: function (t, e, i) {
            return Mt(this.getEncryptedPKCS8Hex(t, e, i), 'ENCRYPTED PRIVATE KEY');
          },
          getEncryptedPKCS8Hex: function (t, e, i) {
            var s;
            (((s = null == i || null == i ? {} : JSON.parse(JSON.stringify(i))).plain = t),
              this.initPBES2Param(s),
              this.encryptPBES2Param(s, e));
            var n = this.generatePBES2ASN1Param(s);
            return st.asn1.ASN1Util.newObject(n).tohex();
          },
          initPBES2Param: function (t) {
            var e;
            (null == Yt(t, 'encalg') && (t.encalg = 'aes256-CBC'),
              null == Yt(t, 'iter') && (t.iter = 2048),
              null == Yt(t, 'prf') && (t.prf = 'hmacWithSHA256'),
              null == Yt(t, 'salt') && (t.salt = d.enc.Hex.stringify(d.lib.WordArray.random(8))),
              null == Yt(t, 'enciv') &&
                ('des-EDE3-CBC' == t.encalg && (e = 8),
                'aes128-CBC' == t.encalg && (e = 16),
                'aes256-CBC' == t.encalg && (e = 16),
                (t.enciv = d.enc.Hex.stringify(d.lib.WordArray.random(e)))));
          },
          encryptPBES2Param: function (t, e) {
            var i = Jt.getDKFromPBES2Param(t, e);
            try {
              var s = st.crypto.Cipher.encrypt(t.plain, i, t.encalg, { iv: t.enciv });
            } catch (e) {
              throw new Error('encrypt error: ' + t.plain + ' ' + i + ' ' + t.encalg + ' ' + t.enciv);
            }
            t.enc = s;
          },
          generatePBES2ASN1Param: function (t) {
            var e = {
              seq: [
                {
                  seq: [
                    { oid: 'pkcs5PBES2' },
                    {
                      seq: [
                        {
                          seq: [
                            { oid: 'pkcs5PBKDF2' },
                            { seq: [{ octstr: { hex: t.salt } }, { int: { hex: Vt(t.iter) } }] },
                          ],
                        },
                        { seq: [{ oid: t.encalg }, { octstr: { hex: t.enciv } }] },
                      ],
                    },
                  ],
                },
                { octstr: { hex: t.enc } },
              ],
            };
            return (
              'hmacWithSHA1' != t.prf &&
                e.seq[0].seq[1].seq[0].seq[1].seq.push({ seq: [{ oid: t.prf }, { null: '' }] }),
              e
            );
          },
          parseHexOfEncryptedPKCS8: function (t) {
            var e = at,
              i = e.getChildIdx,
              s = e.getV,
              n = {},
              r = i(t, 0);
            if (2 != r.length) throw new Error('malformed format: SEQUENCE(0).items != 2: ' + r.length);
            n.ciphertext = s(t, r[1]);
            var a = i(t, r[0]);
            if (2 != a.length) throw new Error('malformed format: SEQUENCE(0.0).items != 2: ' + a.length);
            if ('2a864886f70d01050d' != s(t, a[0])) throw new Error('this only supports pkcs5PBES2');
            var o = i(t, a[1]);
            if (2 != a.length) throw new Error('malformed format: SEQUENCE(0.0.1).items != 2: ' + o.length);
            var h = i(t, o[1]);
            if (2 != h.length) throw new Error('malformed format: SEQUENCE(0.0.1.1).items != 2: ' + h.length);
            if ('2a864886f70d0307' != s(t, h[0])) throw 'this only supports TripleDES';
            ((n.encryptionSchemeAlg = 'TripleDES'), (n.encryptionSchemeIV = s(t, h[1])));
            var l = i(t, o[0]);
            if (2 != l.length) throw new Error('malformed format: SEQUENCE(0.0.1.0).items != 2: ' + l.length);
            if ('2a864886f70d01050c' != s(t, l[0])) throw new Error('this only supports pkcs5PBKDF2');
            var c = i(t, l[1]);
            if (c.length < 2) throw new Error('malformed format: SEQUENCE(0.0.1.0.1).items < 2: ' + c.length);
            n.pbkdf2Salt = s(t, c[0]);
            var u = s(t, c[1]);
            try {
              n.pbkdf2Iter = parseInt(u, 16);
            } catch (t) {
              throw new Error('malformed format pbkdf2Iter: ' + u);
            }
            return n;
          },
          getPBKDF2KeyHexFromParam: function (t, e) {
            var i = d.enc.Hex.parse(t.pbkdf2Salt),
              s = t.pbkdf2Iter,
              n = d.PBKDF2(e, i, { keySize: 6, iterations: s });
            return d.enc.Hex.stringify(n);
          },
          _getPlainPKCS8HexFromEncryptedPKCS8PEM: function (t, e) {
            var i = Ct(t, 'ENCRYPTED PRIVATE KEY'),
              s = this.parseHexOfEncryptedPKCS8(i),
              n = Jt.getPBKDF2KeyHexFromParam(s, e),
              r = {};
            r.ciphertext = d.enc.Hex.parse(s.ciphertext);
            var a = d.enc.Hex.parse(n),
              o = d.enc.Hex.parse(s.encryptionSchemeIV),
              h = d.TripleDES.decrypt(r, a, { iv: o });
            return d.enc.Hex.stringify(h);
          },
          parsePBES2: function (t) {
            var e = at.parse(t);
            if ('pkcs5PBES2' != Yt(e, 'seq.0.seq.0.oid') || 'pkcs5PBKDF2' != Yt(e, 'seq.0.seq.1.seq.0.seq.0.oid'))
              throw new Error('not pkcs5PBES2 and pkcs5PBKDF2 used');
            var i = Yt(e, 'seq.0.seq.1.seq.0.seq.1.seq');
            if (null == i) throw new Error('PBKDF2 parameter not found');
            var s = Yt(i, '0.octstr.hex'),
              n = Yt(i, '1.int.hex'),
              r = Yt(i, '2.seq.0.oid', 'hmacWithSHA1'),
              a = -1;
            try {
              a = parseInt(n, 16);
            } catch (t) {
              throw new Error('iter not proper value');
            }
            var o = Yt(e, 'seq.0.seq.1.seq.1.seq.0.oid'),
              h = Yt(e, 'seq.0.seq.1.seq.1.seq.1.octstr.hex'),
              l = Yt(e, 'seq.1.octstr.hex');
            if (null == o || null == h || null == l) throw new Error('encalg, enciv or enc is undefined');
            return { salt: s, iter: a, prf: r, encalg: o, enciv: h, enc: l };
          },
          getDKFromPBES2Param: function (t, e) {
            var i = {
              hmacWithSHA1: d.algo.SHA1,
              hmacWithSHA224: d.algo.SHA224,
              hmacWithSHA256: d.algo.SHA256,
              hmacWithSHA384: d.algo.SHA384,
              hmacWithSHA512: d.algo.SHA512,
            }[t.prf];
            if (null == i) throw new Error('unsupported prf');
            var s = { 'des-EDE3-CBC': 6, 'aes128-CBC': 4, 'aes256-CBC': 8 }[t.encalg];
            if (null == s) throw new Error('unsupported encalg');
            var n = d.enc.Hex.parse(t.salt),
              r = t.iter;
            try {
              var a = d.PBKDF2(e, n, { keySize: s, iterations: r, hasher: i });
              return d.enc.Hex.stringify(a);
            } catch (i) {
              throw new Error('PBKDF2 error: ' + i + ' ' + JSON.stringify(t) + ' ' + e);
            }
          },
          getPlainHexFromEncryptedPKCS8PEM: function (t, e) {
            if (-1 == t.indexOf('BEGIN ENCRYPTED PRIVATE KEY')) throw new Error('not Encrypted PKCS#8 PEM string');
            var i,
              s = Ct(t);
            try {
              i = Jt.parsePBES2(s);
            } catch (t) {
              throw new Error('malformed PBES2 format: ' + t.message);
            }
            var n = Jt.getDKFromPBES2Param(i, e);
            return st.crypto.Cipher.decrypt(i.enc, n, i.encalg, { iv: i.enciv });
          },
          getKeyFromEncryptedPKCS8PEM: function (t, e) {
            var i = this.getPlainHexFromEncryptedPKCS8PEM(t, e);
            return this.getKeyFromPlainPrivatePKCS8Hex(i);
          },
          parsePlainPrivatePKCS8Hex: function (t) {
            var e = at,
              i = e.getChildIdx,
              s = e.getV,
              n = { algparam: null };
            if ('30' != t.substr(0, 2)) throw new Error('malformed plain PKCS8 private key(code:001)');
            var r = i(t, 0);
            if (r.length < 3) throw new Error('malformed plain PKCS8 private key(code:002)');
            if ('30' != t.substr(r[1], 2)) throw new Error('malformed PKCS8 private key(code:003)');
            var a = i(t, r[1]);
            if (2 != a.length) throw new Error('malformed PKCS8 private key(code:004)');
            if ('06' != t.substr(a[0], 2)) throw new Error('malformed PKCS8 private key(code:005)');
            if (
              ((n.algoid = s(t, a[0])),
              '06' == t.substr(a[1], 2) && (n.algparam = s(t, a[1])),
              '04' != t.substr(r[2], 2))
            )
              throw new Error('malformed PKCS8 private key(code:006)');
            return ((n.keyidx = e.getVidx(t, r[2])), n);
          },
          getKeyFromPlainPrivatePKCS8PEM: function (t) {
            var e = Ct(t, 'PRIVATE KEY');
            return this.getKeyFromPlainPrivatePKCS8Hex(e);
          },
          getKeyFromPlainPrivatePKCS8Hex: function (t) {
            var e,
              i = this.parsePlainPrivatePKCS8Hex(t);
            if ('2a864886f70d010101' == i.algoid) e = new J();
            else if ('2a8648ce380401' == i.algoid) e = new st.crypto.DSA();
            else {
              if ('2a8648ce3d0201' != i.algoid) throw new Error('unsupported private key algorithm');
              e = new st.crypto.ECDSA();
            }
            return (e.readPKCS8PrvKeyHex(t), e);
          },
          _getKeyFromPublicPKCS8Hex: function (t) {
            var e,
              i = at.getVbyList(t, 0, [0, 0], '06');
            if ('2a864886f70d010101' === i) e = new J();
            else if ('2a8648ce380401' === i) e = new st.crypto.DSA();
            else {
              if ('2a8648ce3d0201' !== i) throw new Error('unsupported PKCS#8 public key hex');
              e = new st.crypto.ECDSA();
            }
            return (e.readPKCS8PubKeyHex(t), e);
          },
          parsePublicRawRSAKeyHex: function (t) {
            var e = at,
              i = e.getChildIdx,
              s = e.getV,
              n = {};
            if ('30' != t.substr(0, 2)) throw new Error('malformed RSA key(code:001)');
            var r = i(t, 0);
            if (2 != r.length) throw new Error('malformed RSA key(code:002)');
            if ('02' != t.substr(r[0], 2)) throw new Error('malformed RSA key(code:003)');
            if (((n.n = s(t, r[0])), '02' != t.substr(r[1], 2))) throw new Error('malformed RSA key(code:004)');
            return ((n.e = s(t, r[1])), n);
          },
          parsePublicPKCS8Hex: function (t) {
            var e = at,
              i = e.getChildIdx,
              s = e.getV,
              n = { algparam: null },
              r = i(t, 0);
            if (2 != r.length) throw new Error('outer DERSequence shall have 2 elements: ' + r.length);
            var a = r[0];
            if ('30' != t.substr(a, 2)) throw new Error('malformed PKCS8 public key(code:001)');
            var o = i(t, a);
            if (2 != o.length) throw new Error('malformed PKCS8 public key(code:002)');
            if ('06' != t.substr(o[0], 2)) throw new Error('malformed PKCS8 public key(code:003)');
            if (
              ((n.algoid = s(t, o[0])),
              '06' == t.substr(o[1], 2)
                ? (n.algparam = s(t, o[1]))
                : '30' == t.substr(o[1], 2) &&
                  ((n.algparam = {}),
                  (n.algparam.p = e.getVbyList(t, o[1], [0], '02')),
                  (n.algparam.q = e.getVbyList(t, o[1], [1], '02')),
                  (n.algparam.g = e.getVbyList(t, o[1], [2], '02'))),
              '03' != t.substr(r[1], 2))
            )
              throw new Error('malformed PKCS8 public key(code:004)');
            return ((n.key = s(t, r[1]).substr(2)), n);
          },
        };
      })();
      function $t(t, e) {
        for (var i = '', s = e / 4 - t.length, n = 0; n < s; n++) i += '0';
        return i + t;
      }
      function te(t, e, i) {
        for (var s = '', n = 0; s.length < e; )
          ((s += xt(
            i(
              vt(
                t +
                  String.fromCharCode.apply(String, [
                    (4278190080 & n) >> 24,
                    (16711680 & n) >> 16,
                    (65280 & n) >> 8,
                    255 & n,
                  ]),
              ),
            ),
          )),
            (n += 1));
        return s;
      }
      function ee(t) {
        for (var e in st.crypto.Util.DIGESTINFOHEAD) {
          var i = st.crypto.Util.DIGESTINFOHEAD[e],
            s = i.length;
          if (t.substring(0, s) == i) return [e, t.substring(s)];
        }
        return [];
      }
      function ie(t) {
        var e = at,
          i = e.getChildIdx,
          s = e.getV;
        e.dump;
        var n,
          r = e.parse,
          a = e.getTLV,
          o = e.getVbyList,
          h = e.getVbyListEx,
          l = e.getTLVbyList,
          c = e.getTLVbyListEx,
          u = e.getIdxbyList,
          d = e.getIdxbyListEx,
          f = e.getVidx,
          p = e.getInt,
          m = e.oidname,
          g = e.hextooidstr,
          y = Ct,
          x = Error;
        try {
          n = st.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
        } catch (t) {}
        ((this.HEX2STAG = { '0c': 'utf8', 13: 'prn', 16: 'ia5', '1a': 'vis', '1e': 'bmp' }),
          (this.hex = null),
          (this.version = 0),
          (this.foffset = 0),
          (this.aExtInfo = null),
          (this.getVersion = function () {
            if (null === this.hex || 0 !== this.version) return this.version;
            var t = l(this.hex, 0, [0, 0]);
            if ('a0' == t.substr(0, 2)) {
              var e = l(t, 0, [0]),
                i = p(e, 0);
              if (i < 0 || 2 < i) throw new Error('malformed version field');
              return ((this.version = i + 1), this.version);
            }
            return ((this.version = 1), (this.foffset = -1), 1);
          }),
          (this.getSerialNumberHex = function () {
            return h(this.hex, 0, [0, 0], '02');
          }),
          (this.getSignatureAlgorithmField = function () {
            var t = c(this.hex, 0, [0, 1]);
            return this.getAlgorithmIdentifierName(t);
          }),
          (this.getAlgorithmIdentifierName = function (t) {
            for (var e in n) if (t === n[e]) return e;
            return m(h(t, 0, [0], '06'));
          }),
          (this.getIssuer = function (t, e) {
            return this.getX500Name(this.getIssuerHex(), t, e);
          }),
          (this.getIssuerHex = function () {
            return l(this.hex, 0, [0, 3 + this.foffset], '30');
          }),
          (this.getIssuerString = function () {
            return this.getIssuer().str;
          }),
          (this.getSubject = function (t, e) {
            return this.getX500Name(this.getSubjectHex(), t, e);
          }),
          (this.getSubjectHex = function () {
            return l(this.hex, 0, [0, 5 + this.foffset], '30');
          }),
          (this.getSubjectString = function () {
            return this.getSubject().str;
          }),
          (this.getNotBefore = function () {
            var t = o(this.hex, 0, [0, 4 + this.foffset, 0]);
            return ((t = t.replace(/(..)/g, '%$1')), (t = decodeURIComponent(t)));
          }),
          (this.getNotAfter = function () {
            var t = o(this.hex, 0, [0, 4 + this.foffset, 1]);
            return ((t = t.replace(/(..)/g, '%$1')), (t = decodeURIComponent(t)));
          }),
          (this.getPublicKeyHex = function () {
            return this.getSPKI();
          }),
          (this.getSPKI = function () {
            return l(this.hex, 0, [0, 6 + this.foffset], '30');
          }),
          (this.getSPKIValue = function () {
            var t = this.getSPKI();
            return null == t ? null : o(t, 0, [1], '03', !0);
          }),
          (this.getPublicKeyIdx = function () {
            return u(this.hex, 0, [0, 6 + this.foffset], '30');
          }),
          (this.getPublicKeyContentIdx = function () {
            var t = this.getPublicKeyIdx();
            return u(this.hex, t, [1, 0], '30');
          }),
          (this.getPublicKey = function () {
            return Jt.getKey(this.getPublicKeyHex(), null, 'pkcs8pub');
          }),
          (this.getSignatureAlgorithmName = function () {
            var t = l(this.hex, 0, [1], '30');
            return this.getAlgorithmIdentifierName(t);
          }),
          (this.getSignatureValueHex = function () {
            return o(this.hex, 0, [2], '03', !0);
          }),
          (this.verifySignature = function (t) {
            var e = this.getSignatureAlgorithmField(),
              i = this.getSignatureValueHex(),
              s = l(this.hex, 0, [0], '30'),
              n = new st.crypto.Signature({ alg: e });
            return (n.init(t), n.updateHex(s), n.verify(i));
          }),
          (this.parseExt = function (t) {
            var n, r, a;
            if (void 0 === t) {
              if (((a = this.hex), 3 !== this.version)) return -1;
              ((n = u(a, 0, [0, 7, 0], '30')), (r = i(a, n)));
            } else {
              a = Ct(t);
              var h = u(a, 0, [0, 3, 0, 0], '06');
              if ('2a864886f70d01090e' != s(a, h)) return void (this.aExtInfo = new Array());
              ((n = u(a, 0, [0, 3, 0, 1, 0], '30')), (r = i(a, n)), (this.hex = a));
            }
            this.aExtInfo = new Array();
            for (var l = 0; l < r.length; l++) {
              var c = { critical: !1 },
                d = 0;
              (3 === i(a, r[l]).length && ((c.critical = !0), (d = 1)), (c.oid = e.hextooidstr(o(a, r[l], [0], '06'))));
              var p = u(a, r[l], [1 + d]);
              ((c.vidx = f(a, p)), this.aExtInfo.push(c));
            }
          }),
          (this.getExtInfo = function (t) {
            var e = this.aExtInfo,
              i = t;
            if ((t.match(/^[0-9.]+$/) || (i = st.asn1.x509.OID.name2oid(t)), '' !== i))
              for (var s = 0; s < e.length; s++) if (e[s].oid === i) return e[s];
          }),
          (this.getCriticalExtV = function (t, e, i) {
            if (null != e) return [e, i];
            var s = this.getExtInfo(t);
            return null == s ? [null, null] : [a(this.hex, s.vidx), s.critical];
          }),
          (this.getExtBasicConstraints = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var i = this.getExtInfo('basicConstraints');
              if (void 0 === i) return;
              ((t = a(this.hex, i.vidx)), (e = i.critical));
            }
            var n = { extname: 'basicConstraints' };
            if ((e && (n.critical = !0), '3000' === t)) return n;
            if ('30030101ff' === t) return ((n.cA = !0), n);
            if ('30060101ff02' === t.substr(0, 12)) {
              var r = s(t, 10),
                o = parseInt(r, 16);
              return ((n.cA = !0), (n.pathLen = o), n);
            }
            throw new Error('hExtV parse error: ' + t);
          }),
          (this.getExtNameConstraints = function (t, e) {
            var s = this.getCriticalExtV('nameConstraints', t, e);
            if (((t = s[0]), (e = s[1]), null != t)) {
              var n = { extname: 'nameConstraints' };
              e && (n.critical = !0);
              for (var r = i(t, 0), o = 0; o < r.length; o++) {
                for (var h = [], l = i(t, r[o]), c = 0; c < l.length; c++) {
                  var u = a(t, l[c]),
                    d = this.getGeneralSubtree(u);
                  h.push(d);
                }
                var f = t.substr(r[o], 2);
                'a0' == f ? (n.permit = h) : 'a1' == f && (n.exclude = h);
              }
              return n;
            }
          }),
          (this.getGeneralSubtree = function (t) {
            var e = i(t, 0),
              n = e.length;
            if (n < 1 || 2 < n) throw new Error('wrong num elements');
            for (var r = this.getGeneralName(a(t, e[0])), o = 1; o < n; o++) {
              var h = t.substr(e[o], 2),
                l = s(t, e[o]),
                c = parseInt(l, 16);
              ('80' == h && (r.min = c), '81' == h && (r.max = c));
            }
            return r;
          }),
          (this.getExtKeyUsage = function (t, e) {
            var i = this.getCriticalExtV('keyUsage', t, e);
            if (((t = i[0]), (e = i[1]), null != t)) {
              var s = { extname: 'keyUsage' };
              return (e && (s.critical = !0), (s.names = this.getExtKeyUsageString(t).split(',')), s);
            }
          }),
          (this.getExtKeyUsageBin = function (t) {
            if (void 0 === t) {
              var e = this.getExtInfo('keyUsage');
              if (void 0 === e) return '';
              t = a(this.hex, e.vidx);
            }
            if (8 != t.length && 10 != t.length) throw new Error('malformed key usage value: ' + t);
            var i = '000000000000000' + parseInt(t.substr(6), 16).toString(2);
            return (
              8 == t.length && (i = i.slice(-8)),
              10 == t.length && (i = i.slice(-16)),
              '' == (i = i.replace(/0+$/, '')) && (i = '0'),
              i
            );
          }),
          (this.getExtKeyUsageString = function (t) {
            for (var e = this.getExtKeyUsageBin(t), i = new Array(), s = 0; s < e.length; s++)
              '1' == e.substr(s, 1) && i.push(ie.KEYUSAGE_NAME[s]);
            return i.join(',');
          }),
          (this.getExtSubjectKeyIdentifier = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var i = this.getExtInfo('subjectKeyIdentifier');
              if (void 0 === i) return;
              ((t = a(this.hex, i.vidx)), (e = i.critical));
            }
            var n = { extname: 'subjectKeyIdentifier' };
            e && (n.critical = !0);
            var r = s(t, 0);
            return ((n.kid = { hex: r }), n);
          }),
          (this.getExtAuthorityKeyIdentifier = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var n = this.getExtInfo('authorityKeyIdentifier');
              if (void 0 === n) return;
              ((t = a(this.hex, n.vidx)), (e = n.critical));
            }
            var r = { extname: 'authorityKeyIdentifier' };
            e && (r.critical = !0);
            for (var o = i(t, 0), h = 0; h < o.length; h++) {
              var l = t.substr(o[h], 2);
              if (('80' === l && (r.kid = { hex: s(t, o[h]) }), 'a1' === l)) {
                var c = a(t, o[h]),
                  u = this.getGeneralNames(c);
                r.issuer = u[0].dn;
              }
              '82' === l && (r.sn = { hex: s(t, o[h]) });
            }
            return r;
          }),
          (this.getExtExtKeyUsage = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var n = this.getExtInfo('extKeyUsage');
              if (void 0 === n) return;
              ((t = a(this.hex, n.vidx)), (e = n.critical));
            }
            var r = { extname: 'extKeyUsage', array: [] };
            e && (r.critical = !0);
            for (var o = i(t, 0), h = 0; h < o.length; h++) r.array.push(m(s(t, o[h])));
            return r;
          }),
          (this.getExtExtKeyUsageName = function () {
            var t = this.getExtInfo('extKeyUsage');
            if (void 0 === t) return t;
            var e = new Array(),
              n = a(this.hex, t.vidx);
            if ('' === n) return e;
            for (var r = i(n, 0), o = 0; o < r.length; o++) e.push(m(s(n, r[o])));
            return e;
          }),
          (this.getExtSubjectAltName = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var i = this.getExtInfo('subjectAltName');
              if (void 0 === i) return;
              ((t = a(this.hex, i.vidx)), (e = i.critical));
            }
            var s = { extname: 'subjectAltName', array: [] };
            return (e && (s.critical = !0), (s.array = this.getGeneralNames(t)), s);
          }),
          (this.getExtIssuerAltName = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var i = this.getExtInfo('issuerAltName');
              if (void 0 === i) return;
              ((t = a(this.hex, i.vidx)), (e = i.critical));
            }
            var s = { extname: 'issuerAltName', array: [] };
            return (e && (s.critical = !0), (s.array = this.getGeneralNames(t)), s);
          }),
          (this.getGeneralNames = function (t) {
            for (var e = i(t, 0), s = [], n = 0; n < e.length; n++) {
              var r = this.getGeneralName(a(t, e[n]));
              void 0 !== r && s.push(r);
            }
            return s;
          }),
          (this.getGeneralName = function (t) {
            var e = t.substr(0, 2),
              i = s(t, 0),
              n = xt(i);
            return '81' == e
              ? { rfc822: n }
              : '82' == e
                ? { dns: n }
                : '86' == e
                  ? { uri: n }
                  : '87' == e
                    ? { ip: _t(i) }
                    : 'a4' == e
                      ? { dn: this.getX500Name(i) }
                      : 'a0' == e
                        ? { other: this.getOtherName(t) }
                        : void 0;
          }),
          (this.getExtSubjectAltName2 = function () {
            var t,
              e,
              n,
              r = this.getExtInfo('subjectAltName');
            if (void 0 === r) return r;
            for (var o = new Array(), h = a(this.hex, r.vidx), l = i(h, 0), c = 0; c < l.length; c++)
              ((n = h.substr(l[c], 2)),
                (t = s(h, l[c])),
                '81' === n && ((e = gt(t)), o.push(['MAIL', e])),
                '82' === n && ((e = gt(t)), o.push(['DNS', e])),
                '84' === n && ((e = ie.hex2dn(t, 0)), o.push(['DN', e])),
                '86' === n && ((e = gt(t)), o.push(['URI', e])),
                '87' === n && ((e = _t(t)), o.push(['IP', e])));
            return o;
          }),
          (this.getExtCRLDistributionPoints = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var s = this.getExtInfo('cRLDistributionPoints');
              if (void 0 === s) return;
              ((t = a(this.hex, s.vidx)), (e = s.critical));
            }
            var n = { extname: 'cRLDistributionPoints', array: [] };
            e && (n.critical = !0);
            for (var r = i(t, 0), o = 0; o < r.length; o++) {
              var h = a(t, r[o]);
              n.array.push(this.getDistributionPoint(h));
            }
            return n;
          }),
          (this.getDistributionPoint = function (t) {
            for (var e = {}, s = i(t, 0), n = 0; n < s.length; n++) {
              var r = t.substr(s[n], 2),
                o = a(t, s[n]);
              'a0' == r && (e.dpname = this.getDistributionPointName(o));
            }
            return e;
          }),
          (this.getDistributionPointName = function (t) {
            for (var e = {}, s = i(t, 0), n = 0; n < s.length; n++) {
              var r = t.substr(s[n], 2),
                o = a(t, s[n]);
              'a0' == r && (e.full = this.getGeneralNames(o));
            }
            return e;
          }),
          (this.getExtCRLDistributionPointsURI = function () {
            var t = this.getExtCRLDistributionPoints();
            if (null == t) return t;
            for (var e = t.array, i = [], s = 0; s < e.length; s++)
              try {
                null != e[s].dpname.full[0].uri && i.push(e[s].dpname.full[0].uri);
              } catch (t) {}
            return i;
          }),
          (this.getExtAIAInfo = function () {
            var t = this.getExtInfo('authorityInfoAccess');
            if (void 0 === t) return t;
            for (var e = { ocsp: [], caissuer: [] }, s = i(this.hex, t.vidx), n = 0; n < s.length; n++) {
              var r = o(this.hex, s[n], [0], '06'),
                a = o(this.hex, s[n], [1], '86');
              ('2b06010505073001' === r && e.ocsp.push(gt(a)), '2b06010505073002' === r && e.caissuer.push(gt(a)));
            }
            return e;
          }),
          (this.getExtAuthorityInfoAccess = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var s = this.getExtInfo('authorityInfoAccess');
              if (void 0 === s) return;
              ((t = a(this.hex, s.vidx)), (e = s.critical));
            }
            var n = { extname: 'authorityInfoAccess', array: [] };
            e && (n.critical = !0);
            for (var r = i(t, 0), l = 0; l < r.length; l++) {
              var c = h(t, r[l], [0], '06'),
                u = gt(o(t, r[l], [1], '86'));
              if ('2b06010505073001' == c) n.array.push({ ocsp: u });
              else {
                if ('2b06010505073002' != c) throw new Error('unknown method: ' + c);
                n.array.push({ caissuer: u });
              }
            }
            return n;
          }),
          (this.getExtCertificatePolicies = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var s = this.getExtInfo('certificatePolicies');
              if (void 0 === s) return;
              ((t = a(this.hex, s.vidx)), (e = s.critical));
            }
            var n = { extname: 'certificatePolicies', array: [] };
            e && (n.critical = !0);
            for (var r = i(t, 0), o = 0; o < r.length; o++) {
              var h = a(t, r[o]),
                l = this.getPolicyInformation(h);
              n.array.push(l);
            }
            return n;
          }),
          (this.getPolicyInformation = function (t) {
            var e = {},
              s = o(t, 0, [0], '06');
            e.policyoid = m(s);
            var n = d(t, 0, [1], '30');
            if (-1 != n) {
              e.array = [];
              for (var r = i(t, n), h = 0; h < r.length; h++) {
                var l = a(t, r[h]),
                  c = this.getPolicyQualifierInfo(l);
                e.array.push(c);
              }
            }
            return e;
          }),
          (this.getOtherName = function (t) {
            var e = {},
              s = i(t, 0),
              n = o(t, s[0], [], '06'),
              a = o(t, s[1], []);
            return ((e.oid = m(n)), (e.value = r(a)), e);
          }),
          (this.getPolicyQualifierInfo = function (t) {
            var e = {},
              i = o(t, 0, [0], '06');
            if ('2b06010505070201' === i) {
              var s = h(t, 0, [1], '16');
              e.cps = xt(s);
            } else if ('2b06010505070202' === i) {
              var n = l(t, 0, [1], '30');
              e.unotice = this.getUserNotice(n);
            }
            return e;
          }),
          (this.getUserNotice = function (t) {
            var i = null;
            try {
              return ((i = e.parse(t)), this._asn1ToUnotice(i));
            } catch (t) {
              return;
            }
          }),
          (this._asn1ToUnotice = function (t) {
            try {
              for (var e = {}, i = Yt(t, 'seq'), s = 0; s < i.length; s++) {
                var n = this._asn1ToNoticeRef(i[s]);
                null != n && (e.noticeref = n);
                var r = this.asn1ToDisplayText(i[s]);
                null != r && (e.exptext = r);
              }
              return Object.keys(e).length > 0 ? e : void 0;
            } catch (t) {
              return;
            }
          }),
          (this._asn1ToNoticeRef = function (t) {
            try {
              for (var e = {}, i = Yt(t, 'seq'), s = 0; s < i.length; s++) {
                var n = this._asn1ToNoticeNum(i[s]);
                null != n && (e.noticenum = n);
                var r = this.asn1ToDisplayText(i[s]);
                null != r && (e.org = r);
              }
              return Object.keys(e).length > 0 ? e : void 0;
            } catch (t) {
              return;
            }
          }),
          (this._asn1ToNoticeNum = function (t) {
            try {
              for (var e = Yt(t, 'seq'), i = [], s = 0; s < e.length; s++) {
                var n = e[s];
                i.push(parseInt(Yt(n, 'int.hex'), 16));
              }
              return i;
            } catch (t) {
              return;
            }
          }),
          (this.getDisplayText = function (t) {
            var e = {};
            return (
              (e.type = { '0c': 'utf8', 16: 'ia5', '1a': 'vis', '1e': 'bmp' }[t.substr(0, 2)]),
              (e.str = xt(s(t, 0))),
              e
            );
          }),
          (this.asn1ToDisplayText = function (t) {
            return null != t.utf8str
              ? { type: 'utf8', str: t.utf8str.str }
              : null != t.ia5str
                ? { type: 'ia5', str: t.ia5str.str }
                : null != t.visstr
                  ? { type: 'vis', str: t.visstr.str }
                  : null != t.bmpstr
                    ? { type: 'bmp', str: t.bmpstr.str }
                    : null != t.prnstr
                      ? { type: 'prn', str: t.prnstr.str }
                      : void 0;
          }),
          (this.getExtPolicyMappings = function (t, e) {
            var i = this.getCriticalExtV('policyMappings', t, e);
            if (((t = i[0]), (e = i[1]), null != t)) {
              var s = { extname: 'policyMappings' };
              e && (s.critical = !0);
              try {
                for (var n = r(t).seq, a = [], o = 0; o < n.length; o++) {
                  var h = n[o].seq;
                  a.push([h[0].oid, h[1].oid]);
                }
                s.array = a;
              } catch (t) {
                throw new x('malformed policyMappings');
              }
              return s;
            }
          }),
          (this.getExtPolicyConstraints = function (t, e) {
            var i = this.getCriticalExtV('policyConstraints', t, e);
            if (((t = i[0]), (e = i[1]), null != t)) {
              var s = { extname: 'policyConstraints' };
              e && (s.critical = !0);
              var n = r(t);
              try {
                for (var a = n.seq, o = 0; o < a.length; o++) {
                  var h = a[o].tag;
                  0 == h.explicit &&
                    ('80' == h.tag && (s.reqexp = parseInt(h.hex, 16)),
                    '81' == h.tag && (s.inhibit = parseInt(h.hex, 16)));
                }
              } catch (t) {
                return new x('malformed policyConstraints value');
              }
              return s;
            }
          }),
          (this.getExtInhibitAnyPolicy = function (t, e) {
            var i = this.getCriticalExtV('inhibitAnyPolicy', t, e);
            if (((t = i[0]), (e = i[1]), null != t)) {
              var s = { extname: 'inhibitAnyPolicy' };
              e && (s.critical = !0);
              var n = p(t, 0);
              return -1 == n ? new x('wrong value') : ((s.skip = n), s);
            }
          }),
          (this.getExtCRLNumber = function (t, e) {
            var i = { extname: 'cRLNumber' };
            if ((e && (i.critical = !0), '02' == t.substr(0, 2))) return ((i.num = { hex: s(t, 0) }), i);
            throw new x('hExtV parse error: ' + t);
          }),
          (this.getExtCRLReason = function (t, e) {
            var i = { extname: 'cRLReason' };
            if ((e && (i.critical = !0), '0a' == t.substr(0, 2))) return ((i.code = parseInt(s(t, 0), 16)), i);
            throw new Error('hExtV parse error: ' + t);
          }),
          (this.getExtOcspNonce = function (t, e) {
            var i = { extname: 'ocspNonce' };
            e && (i.critical = !0);
            var n = s(t, 0);
            return ((i.hex = n), i);
          }),
          (this.getExtOcspNoCheck = function (t, e) {
            var i = { extname: 'ocspNoCheck' };
            return (e && (i.critical = !0), i);
          }),
          (this.getExtAdobeTimeStamp = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var s = this.getExtInfo('adobeTimeStamp');
              if (void 0 === s) return;
              ((t = a(this.hex, s.vidx)), (e = s.critical));
            }
            var n = { extname: 'adobeTimeStamp' };
            e && (n.critical = !0);
            var r = i(t, 0);
            if (r.length > 1) {
              var o = a(t, r[1]),
                h = this.getGeneralName(o);
              null != h.uri && (n.uri = h.uri);
            }
            if (r.length > 2) {
              var l = a(t, r[2]);
              ('0101ff' == l && (n.reqauth = !0), '010100' == l && (n.reqauth = !1));
            }
            return n;
          }),
          (this.getExtSubjectDirectoryAttributes = function (t, e) {
            if (void 0 === t && void 0 === e) {
              var i = this.getExtInfo('subjectDirectoryAttributes');
              if (void 0 === i) return;
              ((t = a(this.hex, i.vidx)), (e = i.critical));
            }
            var s = { extname: 'subjectDirectoryAttributes' };
            e && (s.critical = !0);
            try {
              for (var n = r(t), o = [], h = 0; h < n.seq.length; h++) {
                var l = n.seq[h],
                  c = Yt(l, 'seq.0.oid'),
                  u = Yt(l, 'seq.1.set');
                if (null == c || null == u) throw 'error';
                o.push({ attr: c, array: u });
              }
              return ((s.array = o), s);
            } catch (t) {
              throw new Error('malformed subjectDirectoryAttributes extension value');
            }
          }));
        var v = function (t) {
            var e = {};
            try {
              var i = t.seq[0].oid,
                s = st.asn1.x509.OID.name2oid(i);
              e.type = st.asn1.x509.OID.oid2atype(s);
              var n = t.seq[1];
              if (null != n.utf8str) ((e.ds = 'utf8'), (e.value = n.utf8str.str));
              else if (null != n.numstr) ((e.ds = 'num'), (e.value = n.numstr.str));
              else if (null != n.telstr) ((e.ds = 'tel'), (e.value = n.telstr.str));
              else if (null != n.prnstr) ((e.ds = 'prn'), (e.value = n.prnstr.str));
              else if (null != n.ia5str) ((e.ds = 'ia5'), (e.value = n.ia5str.str));
              else if (null != n.visstr) ((e.ds = 'vis'), (e.value = n.visstr.str));
              else {
                if (null == n.bmpstr) throw 'error';
                ((e.ds = 'bmp'), (e.value = n.bmpstr.str));
              }
              return e;
            } catch (t) {
              throw new Erorr('improper ASN.1 parsed AttrTypeAndValue');
            }
          },
          b = function (t) {
            try {
              return t.set.map(function (t) {
                return v(t);
              });
            } catch (t) {
              throw new Error('improper ASN.1 parsed RDN: ' + t);
            }
          };
        ((this.getX500NameRule = function (t) {
          for (var e = null, i = [], s = 0; s < t.length; s++)
            for (var n = t[s], r = 0; r < n.length; r++) i.push(n[r]);
          for (s = 0; s < i.length; s++) {
            var a = i[s],
              o = a.ds,
              h = a.value,
              l = a.type;
            if ('prn' != o && 'utf8' != o && 'ia5' != o) return 'mixed';
            if ('ia5' == o) {
              if ('CN' != l) return 'mixed';
              if (st.lang.String.isMail(h)) continue;
              return 'mixed';
            }
            if ('C' == l) {
              if ('prn' == o) continue;
              return 'mixed';
            }
            if (null == e) e = o;
            else if (e !== o) return 'mixed';
          }
          return null == e ? 'prn' : e;
        }),
          (this.getAttrTypeAndValue = function (t) {
            var e = r(t);
            return v(e);
          }),
          (this.getRDN = function (t) {
            var e = r(t);
            return b(e);
          }),
          (this.getX500NameArray = function (t) {
            return (function (t) {
              try {
                return t.seq.map(function (t) {
                  return b(t);
                });
              } catch (t) {
                throw new Error('improper ASN.1 parsed X500Name: ' + t);
              }
            })(r(t));
          }),
          (this.getX500Name = function (t, e, i) {
            var s = this.getX500NameArray(t),
              n = { str: this.dnarraytostr(s) };
            return ((n.array = s), 1 == i && (n.hex = t), 1 == e && (n.canon = this.c14nRDNArray(s)), n);
          }),
          (this.readCertPEM = function (t) {
            this.readCertHex(y(t));
          }),
          (this.readCertHex = function (t) {
            ((this.hex = t), this.getVersion());
            try {
              (u(this.hex, 0, [0, 7], 'a3'), this.parseExt());
            } catch (t) {}
          }),
          (this.getParam = function (t) {
            var e = {};
            return (
              null == t && (t = {}),
              (e.version = this.getVersion()),
              (e.serial = { hex: this.getSerialNumberHex() }),
              (e.sigalg = this.getSignatureAlgorithmField()),
              (e.issuer = this.getIssuer(t.dncanon, t.dnhex)),
              (e.notbefore = this.getNotBefore()),
              (e.notafter = this.getNotAfter()),
              (e.subject = this.getSubject(t.dncanon, t.dnhex)),
              (e.sbjpubkey = Mt(this.getPublicKeyHex(), 'PUBLIC KEY')),
              null != this.aExtInfo && this.aExtInfo.length > 0 && (e.ext = this.getExtParamArray()),
              (e.sighex = this.getSignatureValueHex()),
              1 == t.tbshex && (e.tbshex = l(this.hex, 0, [0])),
              1 == t.nodnarray && (delete e.issuer.array, delete e.subject.array),
              e
            );
          }),
          (this.getExtParamArray = function (t) {
            null == t && -1 != d(this.hex, 0, [0, '[3]']) && (t = c(this.hex, 0, [0, '[3]', 0], '30'));
            for (var e = [], s = i(t, 0), n = 0; n < s.length; n++) {
              var r = a(t, s[n]),
                o = this.getExtParam(r);
              null != o && e.push(o);
            }
            return e;
          }),
          (this.getExtParam = function (t) {
            var e = i(t, 0).length;
            if (2 != e && 3 != e) throw new Error('wrong number elements in Extension: ' + e + ' ' + t);
            var s = g(o(t, 0, [0], '06')),
              n = !1;
            3 == e && '0101ff' == l(t, 0, [1]) && (n = !0);
            var a = l(t, 0, [e - 1, 0]),
              h = void 0;
            if (
              ('2.5.29.14' == s
                ? (h = this.getExtSubjectKeyIdentifier(a, n))
                : '2.5.29.15' == s
                  ? (h = this.getExtKeyUsage(a, n))
                  : '2.5.29.17' == s
                    ? (h = this.getExtSubjectAltName(a, n))
                    : '2.5.29.18' == s
                      ? (h = this.getExtIssuerAltName(a, n))
                      : '2.5.29.19' == s
                        ? (h = this.getExtBasicConstraints(a, n))
                        : '2.5.29.30' == s
                          ? (h = this.getExtNameConstraints(a, n))
                          : '2.5.29.31' == s
                            ? (h = this.getExtCRLDistributionPoints(a, n))
                            : '2.5.29.32' == s
                              ? (h = this.getExtCertificatePolicies(a, n))
                              : '2.5.29.33' == s
                                ? (h = this.getExtPolicyMappings(a, n))
                                : '2.5.29.35' == s
                                  ? (h = this.getExtAuthorityKeyIdentifier(a, n))
                                  : '2.5.29.36' == s
                                    ? (h = this.getExtPolicyConstraints(a, n))
                                    : '2.5.29.37' == s
                                      ? (h = this.getExtExtKeyUsage(a, n))
                                      : '2.5.29.54' == s
                                        ? (h = this.getExtInhibitAnyPolicy(a, n))
                                        : '1.3.6.1.5.5.7.1.1' == s
                                          ? (h = this.getExtAuthorityInfoAccess(a, n))
                                          : '2.5.29.20' == s
                                            ? (h = this.getExtCRLNumber(a, n))
                                            : '2.5.29.21' == s
                                              ? (h = this.getExtCRLReason(a, n))
                                              : '2.5.29.9' == s
                                                ? (h = this.getExtSubjectDirectoryAttributes(a, n))
                                                : '1.3.6.1.5.5.7.48.1.2' == s
                                                  ? (h = this.getExtOcspNonce(a, n))
                                                  : '1.3.6.1.5.5.7.48.1.5' == s
                                                    ? (h = this.getExtOcspNoCheck(a, n))
                                                    : '1.2.840.113583.1.1.9.1' == s
                                                      ? (h = this.getExtAdobeTimeStamp(a, n))
                                                      : null != ie.EXT_PARSER[s] && (h = ie.EXT_PARSER[s](s, n, a)),
              null != h)
            )
              return h;
            var c = { extname: s, extn: a };
            try {
              c.extn = r(a);
            } catch (t) {}
            return (n && (c.critical = !0), c);
          }),
          (this.findExt = function (t, e) {
            for (var i = 0; i < t.length; i++) if (t[i].extname == e) return t[i];
            return null;
          }),
          (this.updateExtCDPFullURI = function (t, e) {
            var i = this.findExt(t, 'cRLDistributionPoints');
            if (null != i && null != i.array)
              for (var s = i.array, n = 0; n < s.length; n++)
                if (null != s[n].dpname && null != s[n].dpname.full)
                  for (var r = s[n].dpname.full, a = 0; a < r.length; a++) {
                    var o = r[n];
                    null != o.uri && (o.uri = e);
                  }
          }),
          (this.updateExtAIAOCSP = function (t, e) {
            var i = this.findExt(t, 'authorityInfoAccess');
            if (null != i && null != i.array)
              for (var s = i.array, n = 0; n < s.length; n++) null != s[n].ocsp && (s[n].ocsp = e);
          }),
          (this.updateExtAIACAIssuer = function (t, e) {
            var i = this.findExt(t, 'authorityInfoAccess');
            if (null != i && null != i.array)
              for (var s = i.array, n = 0; n < s.length; n++) null != s[n].caissuer && (s[n].caissuer = e);
          }),
          (this.dnarraytostr = function (t) {
            return (
              '/' +
              t
                .map(function (t) {
                  return (function (t) {
                    return t
                      .map(function (t) {
                        return (function (t) {
                          return t.type + '=' + t.value;
                        })(t).replace(/\+/, '\\+');
                      })
                      .join('+');
                  })(t).replace(/\//, '\\/');
                })
                .join('/')
            );
          }),
          (this.setCanonicalizedDN = function (t) {
            var e;
            if (null != t.str && null == t.array) {
              var i = new st.asn1.x509.X500Name({ str: t.str }).tohex();
              e = this.getX500NameArray(i);
            } else e = t.array;
            null == t.canon && (t.canon = this.c14nRDNArray(e));
          }),
          (this.c14nRDNArray = function (t) {
            for (var e = [], i = 0; i < t.length; i++) {
              for (var s = t[i], n = [], r = 0; r < s.length; r++) {
                var a = s[r],
                  o = a.value;
                ((o = (o = (o = (o = o.replace(/^\s*/, '')).replace(/\s*$/, '')).replace(/\s+/g, ' ')).toLowerCase()),
                  n.push(a.type.toLowerCase() + '=' + o));
              }
              e.push(n.join('+'));
            }
            return '/' + e.join('/');
          }),
          (this.getInfo = function () {
            var t,
              e,
              i,
              s = function (t) {
                for (var e = '', i = '    ', s = '\n', n = t.array, r = 0; r < n.length; r++) {
                  var a = n[r];
                  (null != a.dn && (e += i + 'dn: ' + a.dn.str + s),
                    null != a.ip && (e += i + 'ip: ' + a.ip + s),
                    null != a.rfc822 && (e += i + 'rfc822: ' + a.rfc822 + s),
                    null != a.dns && (e += i + 'dns: ' + a.dns + s),
                    null != a.uri && (e += i + 'uri: ' + a.uri + s),
                    null != a.other &&
                      (e += i + 'other: ' + a.other.oid + '=' + JSON.stringify(a.other.value).replace(/\"/g, '') + s));
                }
                return (e = e.replace(/\n$/, ''));
              },
              n = function (t) {
                for (var e = '', i = t.array, s = 0; s < i.length; s++) {
                  var n = i[s];
                  if (((e += '    policy oid: ' + n.policyoid + '\n'), void 0 !== n.array))
                    for (var r = 0; r < n.array.length; r++) {
                      var a = n.array[r];
                      void 0 !== a.cps && (e += '    cps: ' + a.cps + '\n');
                    }
                }
                return e;
              },
              r = function (t) {
                for (var e = '', i = t.array, s = 0; s < i.length; s++) {
                  var n = i[s];
                  try {
                    void 0 !== n.dpname.full[0].uri && (e += '    ' + n.dpname.full[0].uri + '\n');
                  } catch (t) {}
                  try {
                    void 0 !== n.dname.full[0].dn.hex && (e += '    ' + ie.hex2dn(n.dpname.full[0].dn.hex) + '\n');
                  } catch (t) {}
                }
                return e;
              },
              a = function (t) {
                for (var e = '', i = t.array, s = 0; s < i.length; s++) {
                  var n = i[s];
                  (void 0 !== n.caissuer && (e += '    caissuer: ' + n.caissuer + '\n'),
                    void 0 !== n.ocsp && (e += '    ocsp: ' + n.ocsp + '\n'));
                }
                return e;
              };
            if (
              ((t = 'Basic Fields\n'),
              (t += '  serial number: ' + this.getSerialNumberHex() + '\n'),
              (t += '  signature algorithm: ' + this.getSignatureAlgorithmField() + '\n'),
              (t += '  issuer: ' + this.getIssuerString() + '\n'),
              (t += '  notBefore: ' + this.getNotBefore() + '\n'),
              (t += '  notAfter: ' + this.getNotAfter() + '\n'),
              (t += '  subject: ' + this.getSubjectString() + '\n'),
              (t += '  subject public key info: \n'),
              (t += '    key algorithm: ' + (e = this.getPublicKey()).type + '\n'),
              'RSA' === e.type &&
                ((t += '    n=' + Ht(e.n.toString(16)).substr(0, 16) + '...\n'),
                (t += '    e=' + Ht(e.e.toString(16)) + '\n')),
              null != (i = this.aExtInfo))
            ) {
              t += 'X509v3 Extensions:\n';
              for (var o = 0; o < i.length; o++) {
                var h = i[o],
                  l = st.asn1.x509.OID.oid2name(h.oid);
                '' === l && (l = h.oid);
                var c = '';
                if (
                  (!0 === h.critical && (c = 'CRITICAL'), (t += '  ' + l + ' ' + c + ':\n'), 'basicConstraints' === l)
                ) {
                  var u = this.getExtBasicConstraints();
                  void 0 === u.cA
                    ? (t += '    {}\n')
                    : ((t += '    cA=true'), void 0 !== u.pathLen && (t += ', pathLen=' + u.pathLen), (t += '\n'));
                } else {
                  var d;
                  if ('policyMappings' == l)
                    t +=
                      '    ' +
                      this.getExtPolicyMappings()
                        .array.map(function (t) {
                          var e = t;
                          return e[0] + ':' + e[1];
                        })
                        .join(', ') +
                      '\n';
                  else if ('policyConstraints' == l)
                    ((t += '    '),
                      null != (d = this.getExtPolicyConstraints()).reqexp && (t += ' reqexp=' + d.reqexp),
                      null != d.inhibit && (t += ' inhibit=' + d.inhibit),
                      (t += '\n'));
                  else if ('inhibitAnyPolicy' == l) t += '    skip=' + (d = this.getExtInhibitAnyPolicy()).skip + '\n';
                  else if ('keyUsage' == l) t += '    ' + this.getExtKeyUsageString() + '\n';
                  else if ('subjectKeyIdentifier' == l) t += '    ' + this.getExtSubjectKeyIdentifier().kid.hex + '\n';
                  else if ('authorityKeyIdentifier' == l) {
                    var f = this.getExtAuthorityKeyIdentifier();
                    void 0 !== f.kid && (t += '    kid=' + f.kid.hex + '\n');
                  } else
                    'extKeyUsage' == l
                      ? (t += '    ' + this.getExtExtKeyUsage().array.join(', ') + '\n')
                      : 'subjectAltName' == l
                        ? (t += s(this.getExtSubjectAltName()) + '\n')
                        : 'cRLDistributionPoints' == l
                          ? (t += r(this.getExtCRLDistributionPoints()))
                          : 'authorityInfoAccess' == l
                            ? (t += a(this.getExtAuthorityInfoAccess()))
                            : 'certificatePolicies' == l && (t += n(this.getExtCertificatePolicies()));
                }
              }
            }
            return (
              (t += 'signature algorithm: ' + this.getSignatureAlgorithmName() + '\n'),
              (t += 'signature: ' + this.getSignatureValueHex().substr(0, 16) + '...\n')
            );
          }),
          'string' == typeof t &&
            (-1 != t.indexOf('-----BEGIN') ? this.readCertPEM(t) : st.lang.String.isHex(t) && this.readCertHex(t)));
      }
      ((Jt.getKey = function (t, e, i) {
        var s = (y = at).getChildIdx;
        y.getV;
        var n,
          r = y.getVbyList,
          a = st.crypto,
          o = a.ECDSA,
          h = a.DSA,
          l = J,
          c = Ct,
          u = Jt;
        if (void 0 !== l && t instanceof l) return t;
        if (void 0 !== o && t instanceof o) return t;
        if (void 0 !== h && t instanceof h) return t;
        if (void 0 !== t.curve && void 0 !== t.xy && void 0 === t.d) return new o({ pub: t.xy, curve: t.curve });
        if (void 0 !== t.curve && void 0 !== t.d) return new o({ prv: t.d, curve: t.curve });
        if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 === t.d)
          return ((P = new l()).setPublic(t.n, t.e), P);
        if (
          void 0 === t.kty &&
          void 0 !== t.n &&
          void 0 !== t.e &&
          void 0 !== t.d &&
          void 0 !== t.p &&
          void 0 !== t.q &&
          void 0 !== t.dp &&
          void 0 !== t.dq &&
          void 0 !== t.co &&
          void 0 === t.qi
        )
          return ((P = new l()).setPrivateEx(t.n, t.e, t.d, t.p, t.q, t.dp, t.dq, t.co), P);
        if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d && void 0 === t.p)
          return ((P = new l()).setPrivate(t.n, t.e, t.d), P);
        if (void 0 !== t.p && void 0 !== t.q && void 0 !== t.g && void 0 !== t.y && void 0 === t.x)
          return ((P = new h()).setPublic(t.p, t.q, t.g, t.y), P);
        if (void 0 !== t.p && void 0 !== t.q && void 0 !== t.g && void 0 !== t.y && void 0 !== t.x)
          return ((P = new h()).setPrivate(t.p, t.q, t.g, t.y, t.x), P);
        if ('RSA' === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 === t.d)
          return ((P = new l()).setPublic(pt(t.n), pt(t.e)), P);
        if (
          'RSA' === t.kty &&
          void 0 !== t.n &&
          void 0 !== t.e &&
          void 0 !== t.d &&
          void 0 !== t.p &&
          void 0 !== t.q &&
          void 0 !== t.dp &&
          void 0 !== t.dq &&
          void 0 !== t.qi
        )
          return (
            (P = new l()).setPrivateEx(pt(t.n), pt(t.e), pt(t.d), pt(t.p), pt(t.q), pt(t.dp), pt(t.dq), pt(t.qi)),
            P
          );
        if ('RSA' === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d)
          return ((P = new l()).setPrivate(pt(t.n), pt(t.e), pt(t.d)), P);
        if ('EC' === t.kty && void 0 !== t.crv && void 0 !== t.x && void 0 !== t.y && void 0 === t.d) {
          var d = (F = new o({ curve: t.crv })).ecparams.keycharlen,
            f = '04' + ('0000000000' + pt(t.x)).slice(-d) + ('0000000000' + pt(t.y)).slice(-d);
          return (F.setPublicKeyHex(f), F);
        }
        if ('EC' === t.kty && void 0 !== t.crv && void 0 !== t.x && void 0 !== t.y && void 0 !== t.d) {
          ((d = (F = new o({ curve: t.crv })).ecparams.keycharlen),
            (f = '04' + ('0000000000' + pt(t.x)).slice(-d) + ('0000000000' + pt(t.y)).slice(-d)));
          var p = ('0000000000' + pt(t.d)).slice(-d);
          return (F.setPublicKeyHex(f), F.setPrivateKeyHex(p), F);
        }
        if ('pkcs5prv' === i) {
          var m,
            g = t,
            y = at;
          if (9 === (m = s(g, 0)).length) (P = new l()).readPKCS5PrvKeyHex(g);
          else if (6 === m.length) (P = new h()).readPKCS5PrvKeyHex(g);
          else {
            if (!(m.length > 2 && '04' === g.substr(m[1], 2))) throw new Error('unsupported PKCS#1/5 hexadecimal key');
            (P = new o()).readPKCS5PrvKeyHex(g);
          }
          return P;
        }
        if ('pkcs8prv' === i) return (P = u.getKeyFromPlainPrivatePKCS8Hex(t));
        if ('pkcs8pub' === i) return u._getKeyFromPublicPKCS8Hex(t);
        if ('x509pub' === i) return ie.getPublicKeyFromCertHex(t);
        if (
          -1 != t.indexOf('-END CERTIFICATE-', 0) ||
          -1 != t.indexOf('-END X509 CERTIFICATE-', 0) ||
          -1 != t.indexOf('-END TRUSTED CERTIFICATE-', 0)
        )
          return ie.getPublicKeyFromCertPEM(t);
        if (-1 != t.indexOf('-END PUBLIC KEY-')) {
          var v = Ct(t, 'PUBLIC KEY');
          return u._getKeyFromPublicPKCS8Hex(v);
        }
        if (-1 != t.indexOf('-END RSA PRIVATE KEY-') && -1 == t.indexOf('4,ENCRYPTED')) {
          var b = c(t, 'RSA PRIVATE KEY');
          return u.getKey(b, null, 'pkcs5prv');
        }
        if (-1 != t.indexOf('-END DSA PRIVATE KEY-') && -1 == t.indexOf('4,ENCRYPTED')) {
          var w = r((n = c(t, 'DSA PRIVATE KEY')), 0, [1], '02'),
            S = r(n, 0, [2], '02'),
            M = r(n, 0, [3], '02'),
            C = r(n, 0, [4], '02'),
            E = r(n, 0, [5], '02');
          return ((P = new h()).setPrivate(new x(w, 16), new x(S, 16), new x(M, 16), new x(C, 16), new x(E, 16)), P);
        }
        if (-1 != t.indexOf('-END EC PRIVATE KEY-') && -1 == t.indexOf('4,ENCRYPTED'))
          return ((b = c(t, 'EC PRIVATE KEY')), u.getKey(b, null, 'pkcs5prv'));
        if (-1 != t.indexOf('-END PRIVATE KEY-')) return u.getKeyFromPlainPrivatePKCS8PEM(t);
        if (-1 != t.indexOf('-END RSA PRIVATE KEY-') && -1 != t.indexOf('4,ENCRYPTED')) {
          var D = u.getDecryptedKeyHex(t, e),
            A = new J();
          return (A.readPKCS5PrvKeyHex(D), A);
        }
        if (-1 != t.indexOf('-END EC PRIVATE KEY-') && -1 != t.indexOf('4,ENCRYPTED')) {
          var F,
            P = r((n = u.getDecryptedKeyHex(t, e)), 0, [1], '04'),
            T = r(n, 0, [2, 0], '06'),
            I = r(n, 0, [3, 0], '03').substr(2);
          if (void 0 === st.crypto.OID.oidhex2name[T]) throw new Error('undefined OID(hex) in KJUR.crypto.OID: ' + T);
          return (
            (F = new o({ curve: st.crypto.OID.oidhex2name[T] })).setPublicKeyHex(I),
            F.setPrivateKeyHex(P),
            (F.isPublic = !1),
            F
          );
        }
        if (-1 != t.indexOf('-END DSA PRIVATE KEY-') && -1 != t.indexOf('4,ENCRYPTED'))
          return (
            (w = r((n = u.getDecryptedKeyHex(t, e)), 0, [1], '02')),
            (S = r(n, 0, [2], '02')),
            (M = r(n, 0, [3], '02')),
            (C = r(n, 0, [4], '02')),
            (E = r(n, 0, [5], '02')),
            (P = new h()).setPrivate(new x(w, 16), new x(S, 16), new x(M, 16), new x(C, 16), new x(E, 16)),
            P
          );
        if (-1 != t.indexOf('-END ENCRYPTED PRIVATE KEY-')) return u.getKeyFromEncryptedPKCS8PEM(t, e);
        throw new Error('not supported argument');
      }),
        (Jt.generateKeypair = function (t, e) {
          if ('RSA' == t) {
            var i = e;
            ((a = new J()).generate(i, '10001'), (a.isPrivate = !0), (a.isPublic = !0));
            var s = new J(),
              n = a.n.toString(16),
              r = a.e.toString(16);
            return (
              s.setPublic(n, r),
              (s.isPrivate = !1),
              (s.isPublic = !0),
              ((o = {}).prvKeyObj = a),
              (o.pubKeyObj = s),
              o
            );
          }
          if ('EC' == t) {
            var a,
              o,
              h = e,
              l = new st.crypto.ECDSA({ curve: h }).generateKeyPairHex();
            return (
              (a = new st.crypto.ECDSA({ curve: h })).setPublicKeyHex(l.ecpubhex),
              a.setPrivateKeyHex(l.ecprvhex),
              (a.isPrivate = !0),
              (a.isPublic = !1),
              (s = new st.crypto.ECDSA({ curve: h })).setPublicKeyHex(l.ecpubhex),
              (s.isPrivate = !1),
              (s.isPublic = !0),
              ((o = {}).prvKeyObj = a),
              (o.pubKeyObj = s),
              o
            );
          }
          throw new Error('unknown algorithm: ' + t);
        }),
        (Jt.getPEM = function (t, e, i, s, n, r) {
          var a = st,
            o = a.asn1,
            h = o.DERObjectIdentifier,
            l = o.DERInteger,
            c = o.ASN1Util.newObject,
            u = o.x509.SubjectPublicKeyInfo,
            d = a.crypto,
            f = d.DSA,
            p = d.ECDSA,
            m = J;
          function g(t) {
            return c({
              seq: [
                { int: 0 },
                { int: { bigint: t.n } },
                { int: t.e },
                { int: { bigint: t.d } },
                { int: { bigint: t.p } },
                { int: { bigint: t.q } },
                { int: { bigint: t.dmp1 } },
                { int: { bigint: t.dmq1 } },
                { int: { bigint: t.coeff } },
              ],
            });
          }
          function y(t) {
            return c({
              seq: [
                { int: 1 },
                { octstr: { hex: t.prvKeyHex } },
                { tag: ['a0', !0, { oid: { name: t.curveName } }] },
                { tag: ['a1', !0, { bitstr: { hex: '00' + t.pubKeyHex } }] },
              ],
            });
          }
          function x(t) {
            return c({
              seq: [
                { int: 0 },
                { int: { bigint: t.p } },
                { int: { bigint: t.q } },
                { int: { bigint: t.g } },
                { int: { bigint: t.y } },
                { int: { bigint: t.x } },
              ],
            });
          }
          if (
            ((void 0 !== m && t instanceof m) ||
              (void 0 !== f && t instanceof f) ||
              (void 0 !== p && t instanceof p)) &&
            1 == t.isPublic &&
            (void 0 === e || 'PKCS8PUB' == e)
          )
            return Mt((S = new u(t).tohex()), 'PUBLIC KEY');
          if ('PKCS1PRV' == e && void 0 !== m && t instanceof m && (void 0 === i || null == i) && 1 == t.isPrivate)
            return Mt((S = g(t).tohex()), 'RSA PRIVATE KEY');
          if ('PKCS1PRV' == e && void 0 !== p && t instanceof p && (void 0 === i || null == i) && 1 == t.isPrivate) {
            var v = new h({ name: t.curveName }).tohex(),
              b = y(t).tohex(),
              w = '';
            return ((w += Mt(v, 'EC PARAMETERS')), (w += Mt(b, 'EC PRIVATE KEY')));
          }
          if ('PKCS1PRV' == e && void 0 !== f && t instanceof f && (void 0 === i || null == i) && 1 == t.isPrivate)
            return Mt((S = x(t).tohex()), 'DSA PRIVATE KEY');
          if ('PKCS5PRV' == e && void 0 !== m && t instanceof m && void 0 !== i && null != i && 1 == t.isPrivate) {
            var S = g(t).tohex();
            return (void 0 === s && (s = 'DES-EDE3-CBC'), this.getEncryptedPKCS5PEMFromPrvKeyHex('RSA', S, i, s, r));
          }
          if ('PKCS5PRV' == e && void 0 !== p && t instanceof p && void 0 !== i && null != i && 1 == t.isPrivate)
            return (
              (S = y(t).tohex()),
              void 0 === s && (s = 'DES-EDE3-CBC'),
              this.getEncryptedPKCS5PEMFromPrvKeyHex('EC', S, i, s, r)
            );
          if ('PKCS5PRV' == e && void 0 !== f && t instanceof f && void 0 !== i && null != i && 1 == t.isPrivate)
            return (
              (S = x(t).tohex()),
              void 0 === s && (s = 'DES-EDE3-CBC'),
              this.getEncryptedPKCS5PEMFromPrvKeyHex('DSA', S, i, s, r)
            );
          var M = function (t, e) {
            if ('string' == typeof e) return Jt.getEncryptedPKCS8PEM(t, e);
            if ('object' == typeof e && null != Yt(e, 'passcode')) {
              var i = JSON.parse(JSON.stringify(e)),
                s = i.passcode;
              return (delete i.passcode, Jt.getEncryptedPKCS8PEM(t, s, i));
            }
          };
          if ('PKCS8PRV' == e && null != m && t instanceof m && 1 == t.isPrivate) {
            var C = g(t).tohex();
            return (
              (S = c({
                seq: [{ int: 0 }, { seq: [{ oid: { name: 'rsaEncryption' } }, { null: !0 }] }, { octstr: { hex: C } }],
              }).tohex()),
              void 0 === i || null == i ? Mt(S, 'PRIVATE KEY') : M(S, i)
            );
          }
          if ('PKCS8PRV' == e && void 0 !== p && t instanceof p && 1 == t.isPrivate) {
            var E = { seq: [{ int: 1 }, { octstr: { hex: t.prvKeyHex } }] };
            return (
              'string' == typeof t.pubKeyHex &&
                E.seq.push({ tag: ['a1', !0, { bitstr: { hex: '00' + t.pubKeyHex } }] }),
              (C = new c(E).tohex()),
              (S = c({
                seq: [
                  { int: 0 },
                  { seq: [{ oid: { name: 'ecPublicKey' } }, { oid: { name: t.curveName } }] },
                  { octstr: { hex: C } },
                ],
              }).tohex()),
              void 0 === i || null == i ? Mt(S, 'PRIVATE KEY') : M(S, i)
            );
          }
          if ('PKCS8PRV' == e && void 0 !== f && t instanceof f && 1 == t.isPrivate)
            return (
              (C = new l({ bigint: t.x }).tohex()),
              (S = c({
                seq: [
                  { int: 0 },
                  {
                    seq: [
                      { oid: { name: 'dsa' } },
                      { seq: [{ int: { bigint: t.p } }, { int: { bigint: t.q } }, { int: { bigint: t.g } }] },
                    ],
                  },
                  { octstr: { hex: C } },
                ],
              }).tohex()),
              void 0 === i || null == i ? Mt(S, 'PRIVATE KEY') : M(S, i)
            );
          throw new Error('unsupported object nor format');
        }),
        (Jt.getKeyFromCSRPEM = function (t) {
          var e = Ct(t, 'CERTIFICATE REQUEST');
          return Jt.getKeyFromCSRHex(e);
        }),
        (Jt.getKeyFromCSRHex = function (t) {
          var e = Jt.parseCSRHex(t);
          return Jt.getKey(e.p8pubkeyhex, null, 'pkcs8pub');
        }),
        (Jt.parseCSRHex = function (t) {
          var e = at,
            i = e.getChildIdx,
            s = e.getTLV,
            n = {},
            r = t;
          if ('30' != r.substr(0, 2)) throw new Error('malformed CSR(code:001)');
          var a = i(r, 0);
          if (a.length < 1) throw new Error('malformed CSR(code:002)');
          if ('30' != r.substr(a[0], 2)) throw new Error('malformed CSR(code:003)');
          var o = i(r, a[0]);
          if (o.length < 3) throw new Error('malformed CSR(code:004)');
          return ((n.p8pubkeyhex = s(r, o[2])), n);
        }),
        (Jt.getKeyID = function (t) {
          var e = Jt,
            i = at;
          'string' == typeof t && -1 != t.indexOf('BEGIN ') && (t = e.getKey(t));
          var s = Ct(e.getPEM(t)),
            n = i.getIdxbyList(s, 0, [1]),
            r = i.getV(s, n).substring(2);
          return st.crypto.Util.hashHex(r, 'sha1');
        }),
        (Jt.getJWK = function (t, e, i, s, n) {
          var r,
            a,
            o = {},
            h = st.crypto.Util.hashHex;
          if ('string' == typeof t) ((r = Jt.getKey(t)), -1 != t.indexOf('CERTIFICATE') && (a = Ct(t)));
          else {
            if ('object' != typeof t) throw new Error('unsupported keyinfo type');
            t instanceof ie ? ((r = t.getPublicKey()), (a = t.hex)) : (r = t);
          }
          if (r instanceof J && r.isPrivate)
            ((o.kty = 'RSA'),
              (o.n = ft(r.n.toString(16))),
              (o.e = ft(r.e.toString(16))),
              (o.d = ft(r.d.toString(16))),
              (o.p = ft(r.p.toString(16))),
              (o.q = ft(r.q.toString(16))),
              (o.dp = ft(r.dmp1.toString(16))),
              (o.dq = ft(r.dmq1.toString(16))),
              (o.qi = ft(r.coeff.toString(16))));
          else if (r instanceof J && r.isPublic)
            ((o.kty = 'RSA'), (o.n = ft(r.n.toString(16))), (o.e = ft(r.e.toString(16))));
          else if (r instanceof st.crypto.ECDSA && r.isPrivate) {
            if ('P-256' !== (c = r.getShortNISTPCurveName()) && 'P-384' !== c && 'P-521' !== c)
              throw new Error('unsupported curve name for JWT: ' + c);
            var l = r.getPublicKeyXYHex();
            ((o.kty = 'EC'), (o.crv = c), (o.x = ft(l.x)), (o.y = ft(l.y)), (o.d = ft(r.prvKeyHex)));
          } else if (r instanceof st.crypto.ECDSA && r.isPublic) {
            var c;
            if ('P-256' !== (c = r.getShortNISTPCurveName()) && 'P-384' !== c && 'P-521' !== c)
              throw new Error('unsupported curve name for JWT: ' + c);
            ((l = r.getPublicKeyXYHex()), (o.kty = 'EC'), (o.crv = c), (o.x = ft(l.x)), (o.y = ft(l.y)));
          }
          if (null == o.kty) throw new Error('unsupported keyinfo');
          return (
            r.isPrivate || 1 == e || (o.kid = st.jws.JWS.getJWKthumbprint(o)),
            null != a && 1 != i && (o.x5c = [m(a)]),
            null != a && 1 != s && (o.x5t = ut(m(h(a, 'sha1')))),
            null != a && 1 != n && (o['x5t#S256'] = ut(m(h(a, 'sha256')))),
            o
          );
        }),
        (Jt.getJWKFromKey = function (t) {
          return Jt.getJWK(t, !0, !0, !0, !0);
        }),
        (J.getPosArrayOfChildrenFromHex = function (t) {
          return at.getChildIdx(t, 0);
        }),
        (J.getHexValueArrayOfChildrenFromHex = function (t) {
          var e,
            i = at.getV,
            s = i(t, (e = J.getPosArrayOfChildrenFromHex(t))[0]),
            n = i(t, e[1]),
            r = i(t, e[2]),
            a = i(t, e[3]),
            o = i(t, e[4]),
            h = i(t, e[5]),
            l = i(t, e[6]),
            c = i(t, e[7]),
            u = i(t, e[8]);
          return ((e = new Array()).push(s, n, r, a, o, h, l, c, u), e);
        }),
        (J.prototype.readPrivateKeyFromPEMString = function (t) {
          var e = Ct(t),
            i = J.getHexValueArrayOfChildrenFromHex(e);
          this.setPrivateEx(i[1], i[2], i[3], i[4], i[5], i[6], i[7], i[8]);
        }),
        (J.prototype.readPKCS5PrvKeyHex = function (t) {
          var e = J.getHexValueArrayOfChildrenFromHex(t);
          this.setPrivateEx(e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]);
        }),
        (J.prototype.readPKCS8PrvKeyHex = function (t) {
          var e,
            i,
            s,
            n,
            r,
            a,
            o,
            h,
            l = at,
            c = l.getVbyListEx;
          if (!1 === l.isASN1HEX(t)) throw new Error('not ASN.1 hex string');
          try {
            ((e = c(t, 0, [2, 0, 1], '02')),
              (i = c(t, 0, [2, 0, 2], '02')),
              (s = c(t, 0, [2, 0, 3], '02')),
              (n = c(t, 0, [2, 0, 4], '02')),
              (r = c(t, 0, [2, 0, 5], '02')),
              (a = c(t, 0, [2, 0, 6], '02')),
              (o = c(t, 0, [2, 0, 7], '02')),
              (h = c(t, 0, [2, 0, 8], '02')));
          } catch (t) {
            throw new Error('malformed PKCS#8 plain RSA private key');
          }
          this.setPrivateEx(e, i, s, n, r, a, o, h);
        }),
        (J.prototype.readPKCS5PubKeyHex = function (t) {
          var e = at,
            i = e.getV;
          if (!1 === e.isASN1HEX(t)) throw new Error('keyHex is not ASN.1 hex string');
          var s = e.getChildIdx(t, 0);
          if (2 !== s.length || '02' !== t.substr(s[0], 2) || '02' !== t.substr(s[1], 2))
            throw new Error('wrong hex for PKCS#5 public key');
          var n = i(t, s[0]),
            r = i(t, s[1]);
          this.setPublic(n, r);
        }),
        (J.prototype.readPKCS8PubKeyHex = function (t) {
          var e = at;
          if (!1 === e.isASN1HEX(t)) throw new Error('not ASN.1 hex string');
          if ('06092a864886f70d010101' !== e.getTLVbyListEx(t, 0, [0, 0])) throw new Error('not PKCS8 RSA public key');
          var i = e.getTLVbyListEx(t, 0, [1, 0]);
          this.readPKCS5PubKeyHex(i);
        }),
        (J.prototype.readCertPubKeyHex = function (t, e) {
          var i, s;
          ((i = new ie()).readCertHex(t), (s = i.getPublicKeyHex()), this.readPKCS8PubKeyHex(s));
        }),
        (J.prototype.sign = function (t, e) {
          var i = (function (t) {
            return st.crypto.Util.hashString(t, e);
          })(t);
          return this.signWithMessageHash(i, e);
        }),
        (J.prototype.signWithMessageHash = function (t, e) {
          var i = Z(st.crypto.Util.getPaddedDigestInfoHex(t, e, this.n.bitLength()), 16);
          return $t(this.doPrivate(i).toString(16), this.n.bitLength());
        }),
        (J.prototype.signPSS = function (t, e, i) {
          var s = (function (t) {
            return st.crypto.Util.hashHex(t, e);
          })(vt(t));
          return (void 0 === i && (i = -1), this.signWithMessageHashPSS(s, e, i));
        }),
        (J.prototype.signWithMessageHashPSS = function (t, e, i) {
          var s,
            n = xt(t),
            r = n.length,
            a = this.n.bitLength() - 1,
            o = Math.ceil(a / 8),
            h = function (t) {
              return st.crypto.Util.hashHex(t, e);
            };
          if (-1 === i || void 0 === i) i = r;
          else if (-2 === i) i = o - r - 2;
          else if (i < -2) throw new Error('invalid salt length');
          if (o < r + i + 2) throw new Error('data too long');
          var l = '';
          i > 0 && ((l = new Array(i)), new Y().nextBytes(l), (l = String.fromCharCode.apply(String, l)));
          var c = xt(h(vt('\0\0\0\0\0\0\0\0' + n + l))),
            u = [];
          for (s = 0; s < o - i - r - 2; s += 1) u[s] = 0;
          var d = String.fromCharCode.apply(String, u) + '' + l,
            f = te(c, d.length, h),
            p = [];
          for (s = 0; s < d.length; s += 1) p[s] = d.charCodeAt(s) ^ f.charCodeAt(s);
          var m = (65280 >> (8 * o - a)) & 255;
          for (p[0] &= ~m, s = 0; s < r; s++) p.push(c.charCodeAt(s));
          return (p.push(188), $t(this.doPrivate(new x(p)).toString(16), this.n.bitLength()));
        }),
        (J.prototype.verify = function (t, e) {
          if (null == (e = e.toLowerCase()).match(/^[0-9a-f]+$/)) return !1;
          var i = Z(e, 16),
            s = this.n.bitLength();
          if (i.bitLength() > s) return !1;
          var n = this.doPublic(i).toString(16);
          if (n.length + 3 != s / 4) return !1;
          var r = ee(n.replace(/^1f+00/, ''));
          if (0 == r.length) return !1;
          var a = r[0],
            o = r[1],
            h = (function (t) {
              return st.crypto.Util.hashString(t, a);
            })(t);
          return o == h;
        }),
        (J.prototype.verifyWithMessageHash = function (t, e) {
          if (e.length != Math.ceil(this.n.bitLength() / 4)) return !1;
          var i = Z(e, 16);
          if (i.bitLength() > this.n.bitLength()) return 0;
          var s = ee(
            this.doPublic(i)
              .toString(16)
              .replace(/^1f+00/, ''),
          );
          return 0 != s.length && (s[0], s[1] == t);
        }),
        (J.prototype.verifyPSS = function (t, e, i, s) {
          var n,
            r = ((n = vt(t)), st.crypto.Util.hashHex(n, i));
          return (void 0 === s && (s = -1), this.verifyWithMessageHashPSS(r, e, i, s));
        }),
        (J.prototype.verifyWithMessageHashPSS = function (t, e, i, s) {
          if (e.length != Math.ceil(this.n.bitLength() / 4)) return !1;
          var n,
            r = new x(e, 16),
            a = function (t) {
              return st.crypto.Util.hashHex(t, i);
            },
            o = xt(t),
            h = o.length,
            l = this.n.bitLength() - 1,
            c = Math.ceil(l / 8);
          if (-1 === s || void 0 === s) s = h;
          else if (-2 === s) s = c - h - 2;
          else if (s < -2) throw new Error('invalid salt length');
          if (c < h + s + 2) throw new Error('data too long');
          var u = this.doPublic(r).toByteArray();
          for (n = 0; n < u.length; n += 1) u[n] &= 255;
          for (; u.length < c; ) u.unshift(0);
          if (188 !== u[c - 1]) throw new Error('encoded message does not end in 0xbc');
          var d = (u = String.fromCharCode.apply(String, u)).substr(0, c - h - 1),
            f = u.substr(d.length, h),
            p = (65280 >> (8 * c - l)) & 255;
          if (d.charCodeAt(0) & p) throw new Error('bits beyond keysize not zero');
          var m = te(f, d.length, a),
            g = [];
          for (n = 0; n < d.length; n += 1) g[n] = d.charCodeAt(n) ^ m.charCodeAt(n);
          g[0] &= ~p;
          var y = c - h - s - 2;
          for (n = 0; n < y; n += 1) if (0 !== g[n]) throw new Error('leftmost octets not zero');
          if (1 !== g[y]) throw new Error('0x01 marker not found');
          return f === xt(a(vt('\0\0\0\0\0\0\0\0' + o + String.fromCharCode.apply(String, g.slice(-s)))));
        }),
        (J.SALT_LEN_HLEN = -1),
        (J.SALT_LEN_MAX = -2),
        (J.SALT_LEN_RECOVER = -2),
        (ie.EXT_PARSER = {}),
        (ie.registExtParser = function (t, e) {
          ie.EXT_PARSER[t] = e;
        }),
        (ie.hex2dn = function (t, e) {
          void 0 === e && (e = 0);
          var i = new ie();
          return (at.getTLV(t, e), i.getX500Name(t).str);
        }),
        (ie.hex2rdn = function (t, e) {
          if ((void 0 === e && (e = 0), '31' !== t.substr(e, 2))) throw new Error('malformed RDN');
          for (var i = new Array(), s = at.getChildIdx(t, e), n = 0; n < s.length; n++)
            i.push(ie.hex2attrTypeValue(t, s[n]));
          return (
            (i = i.map(function (t) {
              return t.replace('+', '\\+');
            })),
            i.join('+')
          );
        }),
        (ie.hex2attrTypeValue = function (t, e) {
          var i = at,
            s = i.getV;
          if ((void 0 === e && (e = 0), '30' !== t.substr(e, 2))) throw new Error('malformed attribute type and value');
          var n = i.getChildIdx(t, e);
          2 !== n.length || t.substr(n[0], 2);
          var r = s(t, n[0]),
            a = st.asn1.ASN1Util.oidHexToInt(r);
          return st.asn1.x509.OID.oid2atype(a) + '=' + xt(s(t, n[1]));
        }),
        (ie.getPublicKeyFromCertHex = function (t) {
          var e = new ie();
          return (e.readCertHex(t), e.getPublicKey());
        }),
        (ie.getPublicKeyFromCertPEM = function (t) {
          var e = new ie();
          return (e.readCertPEM(t), e.getPublicKey());
        }),
        (ie.getPublicKeyInfoPropOfCertPEM = function (t) {
          var e,
            i,
            s = at.getVbyList,
            n = { algparam: null };
          return (
            (e = new ie()).readCertPEM(t),
            (i = e.getPublicKeyHex()),
            (n.keyhex = s(i, 0, [1], '03').substr(2)),
            (n.algoid = s(i, 0, [0, 0], '06')),
            '2a8648ce3d0201' === n.algoid && (n.algparam = s(i, 0, [0, 1], '06')),
            n
          );
        }),
        (ie.KEYUSAGE_NAME = [
          'digitalSignature',
          'nonRepudiation',
          'keyEncipherment',
          'dataEncipherment',
          'keyAgreement',
          'keyCertSign',
          'cRLSign',
          'encipherOnly',
          'decipherOnly',
        ]),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.jws && st.jws) || (st.jws = {}),
        (st.jws.JWS = function () {
          var t = st.jws.JWS.isSafeJSONString;
          this.parseJWS = function (e, i) {
            if (void 0 === this.parsedJWS || (!i && void 0 === this.parsedJWS.sigvalH)) {
              var s = e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
              if (null == s) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
              var n = s[1],
                r = s[2],
                a = s[3],
                o = n + '.' + r;
              if (
                ((this.parsedJWS = {}),
                (this.parsedJWS.headB64U = n),
                (this.parsedJWS.payloadB64U = r),
                (this.parsedJWS.sigvalB64U = a),
                (this.parsedJWS.si = o),
                !i)
              ) {
                var h = pt(a),
                  l = Z(h, 16);
                ((this.parsedJWS.sigvalH = h), (this.parsedJWS.sigvalBI = l));
              }
              var c = rt(n),
                u = rt(r);
              if (((this.parsedJWS.headS = c), (this.parsedJWS.payloadS = u), !t(c, this.parsedJWS, 'headP')))
                throw 'malformed JSON string for JWS Head: ' + c;
            }
          };
        }),
        (st.jws.JWS.sign = function (t, e, i, s, n) {
          var r = st,
            a = r.jws.JWS,
            o = a.readSafeJSONString,
            h = a.isSafeJSONString,
            l = r.crypto;
          l.ECDSA;
          var c,
            u,
            d,
            f = l.Mac,
            p = l.Signature,
            m = JSON;
          if ('string' != typeof e && 'object' != typeof e) throw 'spHeader must be JSON string or object: ' + e;
          if (('object' == typeof e && ((u = e), (c = m.stringify(u))), 'string' == typeof e)) {
            if (!h((c = e))) throw 'JWS Head is not safe JSON string: ' + c;
            u = o(c);
          }
          if (
            ((d = i),
            'object' == typeof i && (d = m.stringify(i)),
            ('' != t && null != t) || void 0 === u.alg || (t = u.alg),
            '' != t && null != t && void 0 === u.alg && ((u.alg = t), (c = m.stringify(u))),
            t !== u.alg)
          )
            throw "alg and sHeader.alg doesn't match: " + t + '!=' + u.alg;
          var g = null;
          if (void 0 === a.jwsalg2sigalg[t]) throw 'unsupported alg name: ' + t;
          g = a.jwsalg2sigalg[t];
          var y = nt(c) + '.' + nt(d),
            x = '';
          if ('Hmac' == g.substr(0, 4)) {
            if (void 0 === s) throw 'mac key shall be specified for HS* alg';
            var v = new f({ alg: g, prov: 'cryptojs', pass: s });
            (v.updateString(y), (x = v.doFinal()));
          } else if (-1 != g.indexOf('withECDSA')) {
            ((w = new p({ alg: g })).init(s, n), w.updateString(y));
            var b = w.sign();
            x = st.crypto.ECDSA.asn1SigToConcatSig(b);
          } else {
            var w;
            'none' != g && ((w = new p({ alg: g })).init(s, n), w.updateString(y), (x = w.sign()));
          }
          return y + '.' + ft(x);
        }),
        (st.jws.JWS.verify = function (t, e, i) {
          var s,
            n = st,
            r = n.jws.JWS,
            a = r.readSafeJSONString,
            o = n.crypto,
            h = o.ECDSA,
            l = o.Mac,
            c = o.Signature;
          if (((s = J), !Ot(t))) return !1;
          var u = t.split('.');
          if (3 !== u.length) return !1;
          var d = u[0] + '.' + u[1],
            f = pt(u[2]),
            p = a(rt(u[0])),
            m = null,
            g = null;
          if (void 0 === p.alg) throw 'algorithm not specified in header';
          if (
            ((g = (m = p.alg).substr(0, 2)),
            null != i &&
              '[object Array]' === Object.prototype.toString.call(i) &&
              i.length > 0 &&
              -1 == (':' + i.join(':') + ':').indexOf(':' + m + ':'))
          )
            throw "algorithm '" + m + "' not accepted in the list";
          if ('none' != m && null === e) throw 'key shall be specified to verify.';
          if (
            ('string' == typeof e && -1 != e.indexOf('-----BEGIN ') && (e = Jt.getKey(e)),
            !(('RS' != g && 'PS' != g) || e instanceof s))
          )
            throw 'key shall be a RSAKey obj for RS* and PS* algs';
          if ('ES' == g && !(e instanceof h)) throw 'key shall be a ECDSA obj for ES* algs';
          var y = null;
          if (void 0 === r.jwsalg2sigalg[p.alg]) throw 'unsupported alg name: ' + m;
          if ('none' == (y = r.jwsalg2sigalg[m])) throw 'not supported';
          if ('Hmac' == y.substr(0, 4)) {
            if (void 0 === e) throw 'hexadecimal key shall be specified for HMAC';
            var x = new l({ alg: y, pass: e });
            return (x.updateString(d), f == x.doFinal());
          }
          if (-1 != y.indexOf('withECDSA')) {
            var v,
              b = null;
            try {
              b = h.concatSigToASN1Sig(f);
            } catch (t) {
              return !1;
            }
            return ((v = new c({ alg: y })).init(e), v.updateString(d), v.verify(b));
          }
          return ((v = new c({ alg: y })).init(e), v.updateString(d), v.verify(f));
        }),
        (st.jws.JWS.parse = function (t) {
          var e,
            i,
            s,
            n = t.split('.'),
            r = {};
          if (2 != n.length && 3 != n.length) throw "malformed sJWS: wrong number of '.' splitted elements";
          return (
            (e = n[0]),
            (i = n[1]),
            3 == n.length && (s = n[2]),
            (r.headerObj = st.jws.JWS.readSafeJSONString(rt(e))),
            (r.payloadObj = st.jws.JWS.readSafeJSONString(rt(i))),
            (r.headerPP = JSON.stringify(r.headerObj, null, '  ')),
            null == r.payloadObj ? (r.payloadPP = rt(i)) : (r.payloadPP = JSON.stringify(r.payloadObj, null, '  ')),
            void 0 !== s && (r.sigHex = pt(s)),
            r
          );
        }),
        (st.jws.JWS.verifyJWT = function (t, e, i) {
          var s = st.jws,
            n = s.JWS,
            r = n.readSafeJSONString,
            a = n.inArray,
            o = n.includedArray;
          if (!Ot(t)) return !1;
          var h = t.split('.');
          if (3 != h.length) return !1;
          var l = h[0],
            c = h[1];
          pt(h[2]);
          var u = r(rt(l)),
            d = r(rt(c));
          if (void 0 === u.alg) return !1;
          if (void 0 === i.alg) throw 'acceptField.alg shall be specified';
          if (!a(u.alg, i.alg)) return !1;
          if (void 0 !== d.iss && 'object' == typeof i.iss && !a(d.iss, i.iss)) return !1;
          if (void 0 !== d.sub && 'object' == typeof i.sub && !a(d.sub, i.sub)) return !1;
          if (void 0 !== d.aud && 'object' == typeof i.aud)
            if ('string' == typeof d.aud) {
              if (!a(d.aud, i.aud)) return !1;
            } else if ('object' == typeof d.aud && !o(d.aud, i.aud)) return !1;
          var f = s.IntDate.getNow();
          return (
            void 0 !== i.verifyAt && 'number' == typeof i.verifyAt && (f = i.verifyAt),
            (void 0 !== i.gracePeriod && 'number' == typeof i.gracePeriod) || (i.gracePeriod = 0),
            !(
              (void 0 !== d.exp && 'number' == typeof d.exp && d.exp + i.gracePeriod < f) ||
              (void 0 !== d.nbf && 'number' == typeof d.nbf && f < d.nbf - i.gracePeriod) ||
              (void 0 !== d.iat && 'number' == typeof d.iat && f < d.iat - i.gracePeriod) ||
              (void 0 !== d.jti && void 0 !== i.jti && d.jti !== i.jti) ||
              !n.verify(t, e, i.alg)
            )
          );
        }),
        (st.jws.JWS.includedArray = function (t, e) {
          var i = st.jws.JWS.inArray;
          if (null === t) return !1;
          if ('object' != typeof t) return !1;
          if ('number' != typeof t.length) return !1;
          for (var s = 0; s < t.length; s++) if (!i(t[s], e)) return !1;
          return !0;
        }),
        (st.jws.JWS.inArray = function (t, e) {
          if (null === e) return !1;
          if ('object' != typeof e) return !1;
          if ('number' != typeof e.length) return !1;
          for (var i = 0; i < e.length; i++) if (e[i] == t) return !0;
          return !1;
        }),
        (st.jws.JWS.jwsalg2sigalg = {
          HS256: 'HmacSHA256',
          HS384: 'HmacSHA384',
          HS512: 'HmacSHA512',
          RS256: 'SHA256withRSA',
          RS384: 'SHA384withRSA',
          RS512: 'SHA512withRSA',
          ES256: 'SHA256withECDSA',
          ES384: 'SHA384withECDSA',
          ES512: 'SHA512withECDSA',
          PS256: 'SHA256withRSAandMGF1',
          PS384: 'SHA384withRSAandMGF1',
          PS512: 'SHA512withRSAandMGF1',
          none: 'none',
        }),
        (st.jws.JWS.isSafeJSONString = function (t, e, i) {
          var s = null;
          try {
            return 'object' != typeof (s = it(t)) || s.constructor === Array ? 0 : (e && (e[i] = s), 1);
          } catch (t) {
            return 0;
          }
        }),
        (st.jws.JWS.readSafeJSONString = function (t) {
          var e = null;
          try {
            return 'object' != typeof (e = it(t)) || e.constructor === Array ? null : e;
          } catch (t) {
            return null;
          }
        }),
        (st.jws.JWS.getEncodedSignatureValueFromJWS = function (t) {
          var e = t.match(/^[^.]+\.[^.]+\.([^.]+)$/);
          if (null == e) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
          return e[1];
        }),
        (st.jws.JWS.getJWKthumbprint = function (t) {
          if ('RSA' !== t.kty && 'EC' !== t.kty && 'oct' !== t.kty) throw 'unsupported algorithm for JWK Thumprint';
          var e = '{';
          if ('RSA' === t.kty) {
            if ('string' != typeof t.n || 'string' != typeof t.e) throw 'wrong n and e value for RSA key';
            ((e += '"e":"' + t.e + '",'), (e += '"kty":"' + t.kty + '",'), (e += '"n":"' + t.n + '"}'));
          } else if ('EC' === t.kty) {
            if ('string' != typeof t.crv || 'string' != typeof t.x || 'string' != typeof t.y)
              throw 'wrong crv, x and y value for EC key';
            ((e += '"crv":"' + t.crv + '",'),
              (e += '"kty":"' + t.kty + '",'),
              (e += '"x":"' + t.x + '",'),
              (e += '"y":"' + t.y + '"}'));
          } else if ('oct' === t.kty) {
            if ('string' != typeof t.k) throw 'wrong k value for oct(symmetric) key';
            ((e += '"kty":"' + t.kty + '",'), (e += '"k":"' + t.k + '"}'));
          }
          var i = vt(e);
          return ft(st.crypto.Util.hashHex(i, 'sha256'));
        }),
        (st.jws.IntDate = {}),
        (st.jws.IntDate.get = function (t) {
          var e = st.jws.IntDate,
            i = e.getNow,
            s = e.getZulu;
          if ('now' == t) return i();
          if ('now + 1hour' == t) return i() + 3600;
          if ('now + 1day' == t) return i() + 86400;
          if ('now + 1month' == t) return i() + 2592e3;
          if ('now + 1year' == t) return i() + 31536e3;
          if (t.match(/Z$/)) return s(t);
          if (t.match(/^[0-9]+$/)) return parseInt(t);
          throw 'unsupported format: ' + t;
        }),
        (st.jws.IntDate.getZulu = function (t) {
          return Dt(t);
        }),
        (st.jws.IntDate.getNow = function () {
          return ~~(new Date() / 1e3);
        }),
        (st.jws.IntDate.intDate2UTCString = function (t) {
          return new Date(1e3 * t).toUTCString();
        }),
        (st.jws.IntDate.intDate2Zulu = function (t) {
          var e = new Date(1e3 * t);
          return (
            ('0000' + e.getUTCFullYear()).slice(-4) +
            ('00' + (e.getUTCMonth() + 1)).slice(-2) +
            ('00' + e.getUTCDate()).slice(-2) +
            ('00' + e.getUTCHours()).slice(-2) +
            ('00' + e.getUTCMinutes()).slice(-2) +
            ('00' + e.getUTCSeconds()).slice(-2) +
            'Z'
          );
        }),
        (void 0 !== st && st) || (st = {}),
        (void 0 !== st.jws && st.jws) || (st.jws = {}),
        (st.jws.JWSJS = function () {
          var t = st.jws.JWS,
            e = t.readSafeJSONString;
          ((this.aHeader = []),
            (this.sPayload = ''),
            (this.aSignature = []),
            (this.init = function () {
              ((this.aHeader = []), (this.sPayload = void 0), (this.aSignature = []));
            }),
            (this.initWithJWS = function (t) {
              this.init();
              var e = t.split('.');
              if (3 != e.length) throw 'malformed input JWS';
              (this.aHeader.push(e[0]), (this.sPayload = e[1]), this.aSignature.push(e[2]));
            }),
            (this.addSignature = function (t, e, i, s) {
              if (void 0 === this.sPayload || null === this.sPayload) throw "there's no JSON-JS signature to add.";
              var n = this.aHeader.length;
              if (this.aHeader.length != this.aSignature.length) throw 'aHeader.length != aSignature.length';
              try {
                var r = st.jws.JWS.sign(t, e, this.sPayload, i, s).split('.');
                (r[0], r[2], this.aHeader.push(r[0]), this.aSignature.push(r[2]));
              } catch (t) {
                throw (
                  this.aHeader.length > n && this.aHeader.pop(),
                  this.aSignature.length > n && this.aSignature.pop(),
                  'addSignature failed: ' + t
                );
              }
            }),
            (this.verifyAll = function (t) {
              if (this.aHeader.length !== t.length || this.aSignature.length !== t.length) return !1;
              for (var e = 0; e < t.length; e++) {
                var i = t[e];
                if (2 !== i.length) return !1;
                if (!1 === this.verifyNth(e, i[0], i[1])) return !1;
              }
              return !0;
            }),
            (this.verifyNth = function (e, i, s) {
              if (this.aHeader.length <= e || this.aSignature.length <= e) return !1;
              var n = this.aHeader[e],
                r = this.aSignature[e],
                a = n + '.' + this.sPayload + '.' + r,
                o = !1;
              try {
                o = t.verify(a, i, s);
              } catch (t) {
                return !1;
              }
              return o;
            }),
            (this.readJWSJS = function (t) {
              if ('string' == typeof t) {
                var i = e(t);
                if (null == i) throw 'argument is not safe JSON object string';
                ((this.aHeader = i.headers), (this.sPayload = i.payload), (this.aSignature = i.signatures));
              } else
                try {
                  if (!(t.headers.length > 0)) throw 'malformed header';
                  if (((this.aHeader = t.headers), 'string' != typeof t.payload)) throw 'malformed signatures';
                  if (((this.sPayload = t.payload), !(t.signatures.length > 0))) throw 'malformed signatures';
                  this.aSignature = t.signatures;
                } catch (t) {
                  throw 'malformed JWS-JS JSON object: ' + t;
                }
            }),
            (this.getJSON = function () {
              return { headers: this.aHeader, payload: this.sPayload, signatures: this.aSignature };
            }),
            (this.isEmpty = function () {
              return 0 == this.aHeader.length ? 1 : 0;
            }));
        }),
        (t.SecureRandom = Y),
        (t.rng_seed_time = Q),
        (t.BigInteger = x),
        (t.RSAKey = J),
        (t.ECDSA = st.crypto.ECDSA),
        (t.DSA = st.crypto.DSA),
        (t.Signature = st.crypto.Signature),
        (t.MessageDigest = st.crypto.MessageDigest),
        (t.Mac = st.crypto.Mac),
        (t.KEYUTIL = Jt),
        (t.ASN1HEX = at),
        (t.X509 = ie),
        (t.X509CRL = function (t) {
          var e = st.lang.String.isHex,
            i = at,
            s = i.getV,
            n = i.getTLV,
            r = i.getVbyList,
            a = i.getTLVbyList,
            o = i.getTLVbyListEx,
            h = i.getIdxbyList,
            l = i.getIdxbyListEx,
            c = i.getChildIdx,
            u = new ie();
          ((this.hex = null),
            (this.posSigAlg = null),
            (this.posRevCert = null),
            (this.parsed = null),
            (this._setPos = function () {
              var t = h(this.hex, 0, [0, 0]),
                e = this.hex.substr(t, 2);
              if ('02' == e) this.posSigAlg = 1;
              else {
                if ('30' != e) throw new Error('malformed 1st item of TBSCertList: ' + e);
                this.posSigAlg = 0;
              }
              var i,
                s = h(this.hex, 0, [0, this.posSigAlg + 3]),
                n = this.hex.substr(s, 2);
              if ('17' == n || '18' == n)
                ((i = h(this.hex, 0, [0, this.posSigAlg + 4])),
                  (this.posRevCert = null),
                  -1 != i && '30' == this.hex.substr(i, 2) && (this.posRevCert = this.posSigAlg + 4));
              else if ('30' == n) this.posRevCert = this.posSigAlg + 3;
              else {
                if ('a0' != n) throw new Error('malformed nextUpdate or revCert tag: ' + n);
                this.posRevCert = null;
              }
            }),
            (this.getVersion = function () {
              return 0 == this.posSigAlg ? null : parseInt(r(this.hex, 0, [0, 0], '02'), 16) + 1;
            }),
            (this.getSignatureAlgorithmField = function () {
              var t = a(this.hex, 0, [0, this.posSigAlg], '30');
              return u.getAlgorithmIdentifierName(t);
            }),
            (this.getIssuer = function () {
              return u.getX500Name(this.getIssuerHex());
            }),
            (this.getIssuerHex = function () {
              return a(this.hex, 0, [0, this.posSigAlg + 1], '30');
            }),
            (this.getThisUpdate = function () {
              var t = r(this.hex, 0, [0, this.posSigAlg + 2]);
              return (result = xt(t));
            }),
            (this.getNextUpdate = function () {
              var t = h(this.hex, 0, [0, this.posSigAlg + 3]),
                e = this.hex.substr(t, 2);
              return '17' != e && '18' != e ? null : xt(s(this.hex, t));
            }),
            (this.getRevCertArray = function () {
              if (null == this.posRevCert) return null;
              for (var t = [], e = h(this.hex, 0, [0, this.posRevCert]), i = c(this.hex, e), s = 0; s < i.length; s++) {
                var r = n(this.hex, i[s]);
                t.push(this.getRevCert(r));
              }
              return t;
            }),
            (this.getRevCert = function (t) {
              var e = {},
                i = c(t, 0);
              return (
                (e.sn = { hex: r(t, 0, [0], '02') }),
                (e.date = xt(r(t, 0, [1]))),
                3 == i.length && (e.ext = u.getExtParamArray(a(t, 0, [2]))),
                e
              );
            }),
            (this.findRevCert = function (t) {
              var e = new ie(t).getSerialNumberHex();
              return this.findRevCertBySN(e);
            }),
            (this.findRevCertBySN = function (t) {
              if ((null == this.parsed && this.getParam(), null == this.parsed.revcert)) return null;
              for (var e = this.parsed.revcert, i = 0; i < e.length; i++) if (t == e[i].sn.hex) return e[i];
              return null;
            }),
            (this.getSignatureValueHex = function () {
              return r(this.hex, 0, [2], '03', !0);
            }),
            (this.verifySignature = function (t) {
              var e = this.getSignatureAlgorithmField(),
                i = this.getSignatureValueHex(),
                s = a(this.hex, 0, [0], '30'),
                n = new st.crypto.Signature({ alg: e });
              return (n.init(t), n.updateHex(s), n.verify(i));
            }),
            (this.getParam = function (t) {
              var e = {},
                i = this.getVersion();
              (null != i && (e.version = i),
                (e.sigalg = this.getSignatureAlgorithmField()),
                (e.issuer = this.getIssuer()),
                (e.thisupdate = this.getThisUpdate()));
              var s = this.getNextUpdate();
              null != s && (e.nextupdate = s);
              var n = this.getRevCertArray();
              if ((null != n && (e.revcert = n), -1 != l(this.hex, 0, [0, '[0]']))) {
                var r = o(this.hex, 0, [0, '[0]', 0]);
                e.ext = u.getExtParamArray(r);
              }
              return (
                (e.sighex = this.getSignatureValueHex()),
                (this.parsed = e),
                'object' == typeof t &&
                  (1 == t.tbshex && (e.tbshex = a(this.hex, 0, [0])), 1 == t.nodnarray && delete e.issuer.array),
                e
              );
            }),
            'string' == typeof t &&
              (e(t) ? (this.hex = t) : t.match(/-----BEGIN X509 CRL/) && (this.hex = Ct(t)), this._setPos()));
        }),
        (t.CryptoJS = d),
        (t.b64tohex = g),
        (t.b64toBA = y),
        (t.ECFieldElementFp = $),
        (t.ECPointFp = tt),
        (t.ECCurveFp = et),
        (t.stoBA = ot),
        (t.BAtos = ht),
        (t.BAtohex = lt),
        (t.stohex = ct),
        (t.stob64 = function (t) {
          return m(ct(t));
        }),
        (t.stob64u = function (t) {
          return ut(m(ct(t)));
        }),
        (t.b64utos = function (t) {
          return ht(y(dt(t)));
        }),
        (t.b64tob64u = ut),
        (t.b64utob64 = dt),
        (t.hex2b64 = m),
        (t.hextob64u = ft),
        (t.b64utohex = pt),
        (t.utf8tob64u = nt),
        (t.b64utoutf8 = rt),
        (t.utf8tob64 = function (t) {
          return m(Ft(zt(t)));
        }),
        (t.b64toutf8 = function (t) {
          return decodeURIComponent(Pt(g(t)));
        }),
        (t.utf8tohex = mt),
        (t.hextoutf8 = gt),
        (t.hextorstr = xt),
        (t.rstrtohex = vt),
        (t.hextob64 = bt),
        (t.hextob64nl = function (t) {
          return wt(bt(t), 64);
        }),
        (t.b64nltohex = St),
        (t.hextopem = Mt),
        (t.pemtohex = Ct),
        (t.hextoArrayBuffer = function (t) {
          if (t.length % 2 != 0) throw 'input is not even length';
          if (null == t.match(/^[0-9A-Fa-f]+$/)) throw 'input is not hexadecimal';
          for (var e = new ArrayBuffer(t.length / 2), i = new DataView(e), s = 0; s < t.length / 2; s++)
            i.setUint8(s, parseInt(t.substr(2 * s, 2), 16));
          return e;
        }),
        (t.ArrayBuffertohex = function (t) {
          for (var e = '', i = new DataView(t), s = 0; s < t.byteLength; s++)
            e += ('00' + i.getUint8(s).toString(16)).slice(-2);
          return e;
        }),
        (t.zulutomsec = Et),
        (t.msectozulu = function (t) {
          var e = new Date(t),
            i = ('0000' + e.getUTCFullYear()).slice(-4),
            s = ('00' + (e.getUTCMonth() + 1)).slice(-2),
            n = ('00' + e.getUTCDate()).slice(-2),
            r = ('00' + e.getUTCHours()).slice(-2),
            a = ('00' + e.getUTCMinutes()).slice(-2),
            o = ('00' + e.getUTCSeconds()).slice(-2),
            h = ('000' + e.getUTCMilliseconds()).slice(-3);
          return i + s + n + r + a + o + (h = '' != (h = h.replace(/0+$/, '')) ? '.' + h : h) + 'Z';
        }),
        (t.zulutosec = Dt),
        (t.zulutodate = function (t) {
          return new Date(Et(t));
        }),
        (t.datetozulu = function (t, e, i) {
          var s,
            n = t.getUTCFullYear();
          if (e) {
            if (n < 1950 || 2049 < n) throw 'not proper year for UTCTime: ' + n;
            s = ('' + n).slice(-2);
          } else s = ('000' + n).slice(-4);
          if (
            ((s += ('0' + (t.getUTCMonth() + 1)).slice(-2)),
            (s += ('0' + t.getUTCDate()).slice(-2)),
            (s += ('0' + t.getUTCHours()).slice(-2)),
            (s += ('0' + t.getUTCMinutes()).slice(-2)),
            (s += ('0' + t.getUTCSeconds()).slice(-2)),
            i)
          ) {
            var r = t.getUTCMilliseconds();
            0 !== r && (s += '.' + (r = (r = ('00' + r).slice(-3)).replace(/0+$/g, '')));
          }
          return (s += 'Z');
        }),
        (t.uricmptohex = Ft),
        (t.hextouricmp = Pt),
        (t.ipv6tohex = Tt),
        (t.hextoipv6 = It),
        (t.hextoip = _t),
        (t.iptohex = Nt),
        (t.ucs2hextoutf8 = kt),
        (t.encodeURIComponentAll = zt),
        (t.newline_toUnix = function (t) {
          return (t = t.replace(/\r\n/gm, '\n'));
        }),
        (t.newline_toDos = function (t) {
          return (t = (t = t.replace(/\r\n/gm, '\n')).replace(/\n/gm, '\r\n'));
        }),
        (t.hextoposhex = Ht),
        (t.intarystrtohex = function (t) {
          t = (t = (t = t.replace(/^\s*\[\s*/, '')).replace(/\s*\]\s*$/, '')).replace(/\s*/g, '');
          try {
            var e = t
              .split(/,/)
              .map(function (t, e, i) {
                var s = parseInt(t);
                if (s < 0 || 255 < s) throw 'integer not in range 0-255';
                return ('00' + s.toString(16)).slice(-2);
              })
              .join('');
            return e;
          } catch (t) {
            throw 'malformed integer array string: ' + t;
          }
        }),
        (t.strdiffidx = function (t, e) {
          var i = t.length;
          t.length > e.length && (i = e.length);
          for (var s = 0; s < i; s++) if (t.charCodeAt(s) != e.charCodeAt(s)) return s;
          return t.length != e.length ? i : -1;
        }),
        (t.oidtohex = jt),
        (t.hextooid = qt),
        (t.strpad = Kt),
        (t.bitstrtoint = Gt),
        (t.inttobitstr = Wt),
        (t.bitstrtobinstr = Qt),
        (t.binstrtobitstr = function (t) {
          if ('string' != typeof t) return null;
          if (null == t.match(/^[01]+$/)) return null;
          try {
            return Wt(parseInt(t, 2));
          } catch (t) {
            return null;
          }
        }),
        (t.isBase64URLDot = Ot),
        (t.namearraytobinstr = Xt),
        (t.extendClass = Zt),
        (t.foldnl = wt),
        (t.b64topem = function (t, e) {
          return '-----BEGIN ' + e + '-----\r\n' + wt(t, 64) + '\r\n-----END ' + e + '-----\r\n';
        }),
        (t.pemtob64 = function (t) {
          return -1 == t.indexOf('-----BEGIN ') || -1 == t.indexOf('-----END ')
            ? null
            : (t = (t = (t = t.replace(/^[\s\S]*?-----BEGIN [^-]+-----/m, '')).replace(
                  /-----END [\s\S]+$/m,
                  '',
                )).replace(/\s+/g, '')).match(/^[0-9a-zA-Z+/=]+$/)
              ? t
              : null;
        }),
        (t.timeogen = At),
        (t.aryval = Yt),
        (t.inttohex = Vt),
        (t.twoscompl = Ut),
        (t.KJUR = st),
        (t.crypto = st.crypto),
        (t.asn1 = st.asn1),
        (t.jws = st.jws),
        (t.lang = st.lang),
        (t.VERSION = '11.1.0'),
        (t.VERSION_FULL =
          'jsrsasign(all) 11.1.0 (2024-02-01) (c) 2010-2023 Kenji Urushima | kjur.github.io/jsrsasign/license'));
    },
  }),
  function () {
    return (Fs || (0, As[Ps(As)[0]])((Fs = { exports: {} }).exports, Fs), Fs.exports);
  })();
const Is = 1,
  _s = '1',
  Rs = '0';
class Ns {
  #Oa = !1;
  #Ha;
  #ja;
  #qa;
  #Va;
  #Ua;
  #Ka;
  #Ga = { w: 78, h: 13 };
  #Wa = { position: 0, uImage: 0, uv: 0 };
  #Be;
  #Qa;
  #Xa = 1;
  #Ya;
  #Za = !1;
  #Ja = void 0;
  #$a;
  #to = !1;
  #eo = !1;
  #io = atob('aHR0cHM6Ly9hcGktZ3cueGdyaWRzLmNsb3VkL2xpeGVsLWZyb250LWFwaS9kZXYvc2RrL2F1dGhlbnRpY2F0aW9u');
  #so = atob('aHR0cHM6Ly9hcGktZ3cueGdyaWRzLmNvbS9saXhlbC1mcm9udC1hcGkvZGV2L3Nkay9hdXRoZW50aWNhdGlvbg==');
  #no = atob('aHR0cHM6Ly9zdGctYXBpLWd3Lnhncmlkcy5jbG91ZC9saXhlbC1mcm9udC1hcGkvZGV2L3Nkay9hdXRoZW50aWNhdGlvbg==');
  #ro = [];
  constructor(t, e, i) {
    var s;
    t &&
      ((this.#Be = t),
      (this.#Qa = i),
      (this.#Ya = this.#ao()),
      (this.#Za = '127.0.0.1' === (s = this.#Ya) || 'localhost' === s),
      this.#oo(),
      (this.#Ha =
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAANCAYAAAAHZljfAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAL6SURBVEiJ3Zetk+JAEMV/vbUCGRmJjFyJjEQikciVJ+/PWLkyEolEIpFI5MrIyLh3YnqWYUhCrm7VvaqpgqR7uvtNf0yQVEsqmAFJW0lvc2T/d5iTtgX2ZtYBSKqALzPr/fcSOAEF0Ee5n8DIofVm1s+Q+0buk6RFuoekBbCYsjHgW65z03WBFVADjZm1kmqgAvYuuHNDnxNGVsAK+BwIuvQ9GjNr/VkFrAmHkePLzJpEvyIc7hT2ZnZ1+Tdglfor6TePJPTA2cxOmb8LYEPgYAj9K4CZnV14J6kxs5OkZQzW105SFZ0bwJVAXNyjdyciadeEtOjYxfVy5Bm98GeHEdtb7kkpeCRpARyBNvlfAivPzmMiW/u7ZsReIA7AyQIPnJBt79wy5WNkk6jfud4u2aPgRloadOU6R/4CZvY19FzSZMklaLM9rpKuwLuk1swu/nwJXMbsAby44UpS6Sl7IQRbcGN851kyCe8zDeE0dwyTFvHQw9I1ZUfSwuVKbysFw5n7FF4FV+7LsgXeJC3H/HpNBN8lHc3sGMuWQMInoRTWjJdK6kgn6eD63Qhpd/Dg6+zZIcmAHGsgne7HZ43+CVpClkWcuB38HSR1QBN7XCfpBGwkFWZ2kLRxxU8za7z5P4WfysadKSRtZpB3JmR6xI7hoRFx4hZo8wNTfknSV32/j5HMXwPbl0T47A7VklYe7JVQpoW/n4Qb2hHKsPFV+SGk6Emat5n1ZtbFlcgMImkJANs5bWTC5xLvaUN28uVy5asrvxN6URwQa2+W35nnk3L0ZHPSvHTaODAk1cnYb4GFpDWPvWlJyLaWCQwNoxnlWnp8ERWh5O8GgccylvE18BV73IlwcnG69oSybTLyHu5oCWIp71MZvxc2rn81szbpg+tEL6IDDtlE6xnIwIy8Eog6HY9Xmt7t5bYe7nGEnl4ORhl09hbvZn5vq+PF0/9/l4438Py+88/I+8hYVudfAnPfpTLM/HKY/GKIOpJ+eZ0/haTVXNn/HX8AWSQLzxm37JIAAAAASUVORK5CYII='),
      (this.#ja = e || t.getContext('webgl2')),
      console.log('watemark info===> ', this.#Ya, this.#Qa));
  }
  get isVerifySig() {
    return void 0 !== this.#Ja && null !== this.#Ja;
  }
  #oo() {
    if (this.#Za) this.#Ja = !0;
    else
      try {
        const t = this.#Qa;
        if (t) {
          const e = bt(t);
          if (e) {
            const t = JSON.parse(e),
              i = `${t.A}${t.B}${t.C}${t.D}${this.#Xa}${this.#Ya}`;
            if (!this.#ho(i, t.Sig)) return void (this.#Ja = !1);
            Rs === t.A
              ? ((this.#to = !0), (this.#$a = Number(t.B)), this.#lo())
              : _s === t.A && ((this.#Ja = this.#co(t)), console.log('offline authorize success !', this.#Ja));
          }
        } else this.#Ja = !1;
      } catch (t) {
        (console.warn(t), (this.#Ja = !1));
      }
  }
  #ao() {
    return window.location.hostname.replace('www.', '');
  }
  #uo() {
    const { auth: t } = this.#ro[0];
    if (!t) return !1;
    try {
      const e = bt(t),
        i = JSON.parse(e),
        s = `${i.bizCode}${i.timestamp}${this.#Xa}${this.#Ya}`;
      return (
        !!this.#ho(s, i.signature) &&
        !(Math.abs(Date.now() - 1e3 * Number(i.timestamp)) > 864e5) &&
        ('0' !== i.bizCode ? ((this.#Ja = !1), !1) : (console.log('online authorize success !'), !0))
      );
    } catch (t) {
      return (console.warn(t), !1);
    }
  }
  #lo() {
    if (this.#eo) return;
    const t = Is === this.#$a ? this.#io : this.#so,
      e = { appKey: this.#Qa },
      i = new Request(t, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(e) });
    (fetch(i)
      .then((t) => (t.ok ? t.json() : null))
      .then((t) => {
        (t && t?.data && this.#ro.push(t.data), (this.#eo = !1));
      })
      .catch((t) => {
        ((this.#eo = !1), console.error(t));
      }),
      (this.#eo = !0));
  }
  #co(t) {
    return Date.now() < 1e3 * Number(t.C);
  }
  #ho(t, e) {
    const i = new Ts.crypto.Signature({ alg: 'SHA256withRSA' });
    (i.init(
      atob(
        'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0NCk1Gd3dEUVlKS29aSWh2Y05BUUVCQlFBRFN3QXdTQUpCQUxPa3dkNmU3eFUrUlptMHhWMy8wUVEvWXN3WHo2VjgNCkRza1ZLekVOV1YzT1FMQ05HcTVlSHM1RnQrbnRqeWRQMGFtbEZvYjQ5cG92YnpDcFV1aHVPNWtDQXdFQUFRPT0NCi0tLS0tRU5EIFBVQkxJQyBLRVktLS0tLQ==',
      ),
    ),
      i.updateString(t));
    const s = i.verify(
      (function (t) {
        const e = atob(t);
        let i = '';
        for (let t = 0; t < e.length; t++) i += e.charCodeAt(t).toString(16).padStart(2, '0');
        return i;
      })(e),
    );
    return (console.log(`=====verify Signature ${s} !`), s);
  }
  update() {
    void 0 === this.#Ja || null === this.#Ja
      ? this.#to && (0 === this.#ro.length ? this.#lo() : (this.#Ja = this.#uo()))
      : this.#Ja || this.draw();
  }
  #Zr() {
    const t = this.#ja,
      { vs: e, fs: i } = this.#do(),
      s = this.#fo(e, t.VERTEX_SHADER),
      n = this.#fo(i, t.FRAGMENT_SHADER);
    this.#qa = this.#po(s, n);
    const r = this.#mo();
    ((this.#Va = r.vertexBuffer), (this.#Ua = r.uvBuffer), (this.#Ka = this.#go()));
  }
  #do() {
    return {
      vs: atob(
        'I3ZlcnNpb24gMzAwIGVzDQogICAgICAgIHByZWNpc2lvbiBoaWdocCBmbG9hdDsNCiAgICAgICAgaW4gdmVjMiBwb3NpdGlvbjsNCiAgICAgICAgaW4gdmVjMiB1djsNCiAgICAgICAgb3V0IHZlYzIgdlV2Ow0KICAgICAgICB2b2lkIG1haW4oKSB7DQogICAgICAgICAgICAgZ2xfUG9zaXRpb24gPSB2ZWM0KCBwb3NpdGlvbiAsIDEuMCwgIDEuMCApOw0KICAgICAgICAgICAgIHZVdiA9IHV2Ow0KICAgICAgICB9',
      ),
      fs: atob(
        'I3ZlcnNpb24gMzAwIGVzDQogICAgICAgIHByZWNpc2lvbiBtZWRpdW1wIGZsb2F0Ow0KICAgICAgICB1bmlmb3JtIHNhbXBsZXIyRCB1X2ltYWdlOw0KDQogICAgICAgIG91dCB2ZWM0IG91dENvbG9yOw0KICAgICAgICBpbiB2ZWMyIHZVdjsNCg0KICAgICAgICB2b2lkIG1haW4gKCkgew0KICAgICAgICAgICAgICAgIHZlYzQgY29sb3IgPSB0ZXh0dXJlKHVfaW1hZ2UsIHZVdik7DQogICAgICAgICAgICAgICAgb3V0Q29sb3IgPSB2ZWM0KGNvbG9yLnJnYiwgY29sb3IuYSAqIDAuNSk7DQogICAgICAgIH0=',
      ),
    };
  }
  #fo(t, e) {
    const i = this.#ja,
      s = i.createShader(e);
    return (
      i.shaderSource(s, t),
      i.compileShader(s),
      i.getShaderParameter(s, i.COMPILE_STATUS)
        ? s
        : (console.error('An error occurred compiling the shader: ' + i.getShaderInfoLog(s)), i.deleteShader(s), null)
    );
  }
  #mo() {
    const t = this.#ja,
      e = new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]),
      i = new Float32Array([0, 1, 1, 1, 0, 0, 1, 0]),
      s = t.createBuffer();
    (t.bindBuffer(t.ARRAY_BUFFER, s), t.bufferData(t.ARRAY_BUFFER, e, t.STATIC_DRAW));
    const n = t.createBuffer();
    return (
      t.bindBuffer(t.ARRAY_BUFFER, n),
      t.bufferData(t.ARRAY_BUFFER, i, t.STATIC_DRAW),
      { vertexBuffer: s, uvBuffer: n }
    );
  }
  #po(t, e) {
    const i = this.#ja,
      s = i.createProgram();
    return (
      i.attachShader(s, t),
      i.attachShader(s, e),
      i.linkProgram(s),
      i.getProgramParameter(s, i.LINK_STATUS)
        ? s
        : (console.error('Unable to initialize the shader program: ' + i.getProgramInfoLog(s)), null)
    );
  }
  #go() {
    const t = this.#ja,
      e = t.createTexture();
    (t.bindTexture(t.TEXTURE_2D, e),
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE),
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE),
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR),
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR));
    var i = new Ts.crypto.MessageDigest({ alg: 'sha256' });
    if ((i.updateString(this.#Ha), 'd433ed9ddb8d5e8aa3e8492f965b338b143420fc10d8cc899bdf258455d81aa2' === i.digest())) {
      const i = new Image();
      ((i.src = this.#Ha),
        (i.onload = () => {
          (t.bindTexture(t.TEXTURE_2D, e), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, i));
        }));
    }
    return e;
  }
  draw() {
    const t = this.#ja;
    if (!this.#Oa)
      return (
        this.#Zr(),
        (this.#Oa = !0),
        (this.#Wa.position = t.getAttribLocation(this.#qa, 'position')),
        (this.#Wa.uv = t.getAttribLocation(this.#qa, 'uv')),
        void (this.#Wa.uImage = t.getUniformLocation(this.#qa, 'u_image'))
      );
    const e = this.#Be.offsetWidth,
      i = this.#Ga.w / this.#Ga.h,
      s = this.#qa,
      n = this.#Va,
      r = this.#Ua,
      a = this.#Ka;
    t.useProgram(s);
    const o = this.#Wa.position;
    (t.bindBuffer(t.ARRAY_BUFFER, n), t.vertexAttribPointer(o, 2, t.FLOAT, !1, 0, 0), t.enableVertexAttribArray(o));
    const h = this.#Wa.uv;
    (t.bindBuffer(t.ARRAY_BUFFER, r), t.vertexAttribPointer(h, 2, t.FLOAT, !1, 0, 0), t.enableVertexAttribArray(h));
    const l = this.#Wa.uImage;
    (t.uniform1i(l, 0),
      t.activeTexture(t.TEXTURE0),
      t.bindTexture(t.TEXTURE_2D, a),
      t.enable(t.BLEND),
      t.blendFunc(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA));
    const c = Math.min(this.#Ga.w, 0.1 * e),
      u = c / i,
      d = Math.max(0, e - 8 - c);
    (t.viewport(d, 6, c, u),
      t.drawArrays(t.TRIANGLE_STRIP, 0, 4),
      t.disable(t.BLEND),
      t.bindTexture(t.TEXTURE_2D, null),
      t.useProgram(null));
  }
  dispose() {
    const t = this.#ja;
    (this.#Ka && (t.deleteTexture(this.#Ka), (this.#Ka = void 0)),
      this.#Va && (t.deleteBuffer(this.#Va), (this.#Va = void 0)),
      this.#Ua && (t.deleteBuffer(this.#Ua), (this.#Ua = void 0)),
      this.#qa && (t.deleteProgram(this.#qa), (this.#qa = void 0)));
  }
}
let Bs = class extends qe {
  #f = !1;
  #yo;
  #Re;
  #Ye;
  #K;
  #G;
  #vt;
  #Ze;
  #ae;
  #oe;
  #xo = [];
  #Pn;
  #ga;
  #vo;
  #bo;
  #ee;
  constructor(t, e, i) {
    (super(),
      (this.#yo = t),
      (this.#Re = e),
      (this.#bo = new Ns(e.canvas, null, e.appKey)),
      (e.waterMark = this.#bo),
      (this.#vo = new Bt(t, e.configExternal)),
      (this.#Pn = new ui(e)),
      (this.#Ye = new Ue(e)),
      (this.#K = new Yt(this.#vo.MaxCPUCacheSize, void 0)),
      (this.#G = new ye(this.#vo.MaxGPUCacheSize, (t, e, i) => {
        e?.dispose();
      })),
      (this.#vt = new xe(this.#vo.MaxCPUCollCacheSize, void 0, this.#vo.MaxGPUCollCacheSize, (t, e, i) => {
        e?.dispose();
      })),
      (this.#ee = new Ie(x, this.#vo.LocalCacheNum, this.#K, this.#G, this.#vt, 'function' == typeof i)),
      (this.#ee.enabled = this.#Re.useIndexDB),
      this.#ee.setMaxIndexDBCacheSize(this.#vo.MaxIndexDBCacheSize),
      (this.#ae = new Ds(this.#vo.DecompressThreadNum)),
      (this.#oe = new ze(this.#vo.CollBuildThreadNum)),
      (this.#Ze = new je(this.#K, this.#oe, this.#ae, this.#ee, i, !0, !0)),
      (this.#ga = new this.#Re.renderLib.Group()),
      (this.#ga.renderOrder = 0),
      this.#Re.scene.add(this.#ga));
  }
  get wm() {
    return this.#bo;
  }
  get isDispose() {
    return this.#f;
  }
  dispose() {
    this.#f ||
      ((this.#f = !0),
      this.#Re.scene.remove(this.#ga),
      this.#xo.forEach((t) => {
        t.dispose();
      }),
      (this.#xo = []),
      this.#Ze.dispose(),
      this.#ae.dispose(),
      this.#oe.dispose(),
      this.#G.dispose(),
      this.#K.dispose(),
      this.#vt.dispose(),
      this.#Ye.dispose(),
      this.#Pn.dispose(),
      this.#ee.dispose());
  }
  update(t) {
    if (
      (this.#Ye.update(t),
      this.#K.update(t),
      this.#G.update(t),
      this.#vt.update(t),
      this.#Ze.update(t),
      this.#ae.update?.(t),
      this.#oe.update(t),
      this.#ee.update(t),
      this.#xo.forEach((e) => {
        e.update(t);
      }),
      this.#xo.length > 1)
    ) {
      const t = this.#xo.map((t, e) => e);
      t.sort((t, e) => this.#xo[t].distanceToCam - this.#xo[e].distanceToCam);
      let e = this.#xo[t[0]].root.children.length;
      for (let i = 1; i < t.length; ++i) {
        const s = t[i];
        (this.#xo[s].root.children.forEach((t, i, s) => {
          t.renderOrder -= e;
        }),
          (e += this.#xo[s].root.children.length));
      }
    }
  }
  createRenderer(t) {
    let e = new kt(this.#yo);
    ((e.useEnv = this.#Re.useEnv),
      (e.gpuAcceleration = this.#Re.gpuAcceleration),
      (e.pointsColor = this.#Re.pointsColor),
      (e.useLoadingEffect = this.#Re.useLoadingEffect),
      (e.loadingEffectCenter = this.#Re.loadingEffectCenter),
      this.#Re.useLccPerf && (e.enableDepthSorting = !0));
    let i = new ni();
    ((i.config = e),
      (i.configCommon = this.#vo),
      (i.lccParam = this.#Re),
      (i.cpuCache = this.#K),
      (i.gpuCache = this.#G),
      (i.collCache = this.#vt),
      (i.dataLoader = this.#Ze),
      (i.resources = this.#Pn),
      (i.cameraMgr = this.#Ye),
      (i.platform = this.#yo),
      (i.localCacheMgr = this.#ee));
    let s = new Ms(i);
    if (t.modelMatrix) {
      const e = new this.#Re.renderLib.Vector3(),
        i = new this.#Re.renderLib.Quaternion(),
        n = new this.#Re.renderLib.Vector3();
      (t.modelMatrix.decompose(e, i, n),
        s.root.position.copy(e),
        s.root.quaternion.copy(i),
        s.root.scale.copy(n),
        s.root.updateMatrix());
    }
    return (this.#xo.push(s), this.#ga.add(s.root), s);
  }
  destroyRenderer(t) {
    this.#xo.indexOf(t) < 0 ||
      (this.#Ze.unload(t.id),
      this.#ae.unload(t.id),
      this.#oe.unload(t.id),
      this.#ee.unload(t.id),
      this.#ga.remove(t?.root),
      (this.#xo = this.#xo.filter((e) => e !== t)),
      t?.dispose());
  }
  getAllRenderers() {
    return this.#xo;
  }
  raycast(t) {
    if (0 == this.#xo.length) return null;
    if (1 == this.#xo.length) return this.#xo[0].raycast(t);
    const e = [];
    return (
      this.#xo.forEach((i, s, n) => {
        let r = i._paramToRay(t),
          a = i.raycast(t);
        if (a) {
          let t = r.origin.distanceToSquared(new pt(a.x, a.y, a.z));
          e.push({ intersect: a, distance: t, renderIndex: s });
        }
      }),
      e.sort((t, e) => t.distance - e.distance),
      e.length > 0 ? e[0].intersect : null
    );
  }
  raycastFromOrigin(t) {
    if (0 == this.#xo.length) return null;
    if (1 == this.#xo.length) return this.#xo[0].raycastFromOrigin(t);
    const e = [];
    return (
      this.#xo.forEach((i, s, n) => {
        let r = i._paramToRayFromOrigin(t),
          a = i.raycastFromOrigin(t);
        if (a) {
          let t = r.origin.distanceToSquared(new pt(a.x, a.y, a.z));
          e.push({ intersect: a, distance: t, renderIndex: s });
        }
      }),
      e.sort((t, e) => t.distance - e.distance),
      e.length > 0 ? e[0].intersect : null
    );
  }
  clearIndexDB() {
    this.#ee.enabled && this.#ee.clearLCCIndexDB();
  }
};
class ks extends Ve {
  #Ne;
  #Be;
  #ze;
  #Le;
  #Oe;
  #He;
  #je;
  #qe = !1;
  #ia = new pt();
  #na = new dt();
  #wo = new Ot();
  #So = new Ot();
  constructor(t) {
    (super(),
      (this.#Ne = t.camera),
      (this.#Be = t.canvas),
      (this.#ze = this.fov),
      (this.#Le = this.#Be.width),
      (this.#Oe = this.#Be.height),
      (this.#He = this.position.clone()),
      (this.#je = this.rotation.clone()));
  }
  get isCameraChanged() {
    return this.#qe;
  }
  get fov() {
    return (180 * this.#Ne.frustum.fov) / Math.PI;
  }
  get fovy() {
    return (180 * this.#Ne.frustum.fovy) / Math.PI;
  }
  get viewWidth() {
    return this.#Le;
  }
  get viewHeight() {
    return this.#Oe;
  }
  get position() {
    return this.#ia.copy(this.#Ne.positionWC);
  }
  get projectionMatrix() {
    return this.#wo.fromCesiumMatrix4(this.#Ne.frustum.projectionMatrix);
  }
  get rotation() {
    return this.#na.fromCesiumMatrix4(this.#Ne.inverseViewMatrix);
  }
  get cam2WorldMatrix() {
    return this.#So.fromCesiumMatrix4(this.#Ne.inverseViewMatrix);
  }
  get viewMatrix() {
    return new Ot().fromCesiumMatrix4(this.#Ne.viewMatrix);
  }
  _update(t) {
    let e = this.position,
      i = this.rotation,
      s = this.fov,
      n = this.#Be.width,
      r = this.#Be.height;
    ((this.#qe = !1),
      s != this.#ze && ((this.#ze = s), (this.#qe = !0)),
      (n == this.#Le && r == this.#Oe) || ((this.#Le = n), (this.#Oe = r), (this.#qe = !0)),
      e.equalsApproximately(this.#He) || (this.#He.copy(e), (this.#qe = !0)),
      i.equalsApproximately(this.#je) || (this.#je.copy(i), (this.#qe = !0)));
  }
  _dispose() {}
}
function zs(t) {
  const e = 0,
    i = 2,
    s = 3;
  var n = 1,
    r = 2,
    a = 3,
    o = 5,
    h = 6378137,
    l = 6356752.314,
    c = 0.0066943799901413165,
    u = 484813681109536e-20,
    d = Math.PI / 2,
    f = 0.16666666666666666,
    p = 0.04722222222222222,
    m = 0.022156084656084655,
    g = 1e-10,
    y = 0.017453292519943295,
    x = 57.29577951308232,
    v = Math.PI / 4,
    b = 2 * Math.PI,
    w = 3.14159265359,
    S = {
      greenwich: 0,
      lisbon: -9.131906111111,
      paris: 2.337229166667,
      bogota: -74.080916666667,
      madrid: -3.687938888889,
      rome: 12.452333333333,
      bern: 7.439583333333,
      jakarta: 106.807719444444,
      ferro: -17.666666666667,
      brussels: 4.367975,
      stockholm: 18.058277777778,
      athens: 23.7163375,
      oslo: 10.722916666667,
    },
    M = { ft: { to_meter: 0.3048 }, 'us-ft': { to_meter: 1200 / 3937 } },
    C = /[\s_\-\/\(\)]/g;
  function E(t, e) {
    if (t[e]) return t[e];
    for (var i, s = Object.keys(t), n = e.toLowerCase().replace(C, ''), r = -1; ++r < s.length; )
      if ((i = s[r]).toLowerCase().replace(C, '') === n) return t[i];
  }
  function D(t) {
    var e,
      i,
      s,
      n = {},
      r = t
        .split('+')
        .map(function (t) {
          return t.trim();
        })
        .filter(function (t) {
          return t;
        })
        .reduce(function (t, e) {
          var i = e.split('=');
          return (i.push(!0), (t[i[0].toLowerCase()] = i[1]), t);
        }, {}),
      a = {
        proj: 'projName',
        datum: 'datumCode',
        rf: function (t) {
          n.rf = parseFloat(t);
        },
        lat_0: function (t) {
          n.lat0 = t * y;
        },
        lat_1: function (t) {
          n.lat1 = t * y;
        },
        lat_2: function (t) {
          n.lat2 = t * y;
        },
        lat_ts: function (t) {
          n.lat_ts = t * y;
        },
        lon_0: function (t) {
          n.long0 = t * y;
        },
        lon_1: function (t) {
          n.long1 = t * y;
        },
        lon_2: function (t) {
          n.long2 = t * y;
        },
        alpha: function (t) {
          n.alpha = parseFloat(t) * y;
        },
        gamma: function (t) {
          n.rectified_grid_angle = parseFloat(t);
        },
        lonc: function (t) {
          n.longc = t * y;
        },
        x_0: function (t) {
          n.x0 = parseFloat(t);
        },
        y_0: function (t) {
          n.y0 = parseFloat(t);
        },
        k_0: function (t) {
          n.k0 = parseFloat(t);
        },
        k: function (t) {
          n.k0 = parseFloat(t);
        },
        a: function (t) {
          n.a = parseFloat(t);
        },
        b: function (t) {
          n.b = parseFloat(t);
        },
        r: function (t) {
          n.a = n.b = parseFloat(t);
        },
        r_a: function () {
          n.R_A = !0;
        },
        zone: function (t) {
          n.zone = parseInt(t, 10);
        },
        south: function () {
          n.utmSouth = !0;
        },
        towgs84: function (t) {
          n.datum_params = t.split(',').map(function (t) {
            return parseFloat(t);
          });
        },
        to_meter: function (t) {
          n.to_meter = parseFloat(t);
        },
        units: function (t) {
          n.units = t;
          var e = E(M, t);
          e && (n.to_meter = e.to_meter);
        },
        from_greenwich: function (t) {
          n.from_greenwich = t * y;
        },
        pm: function (t) {
          var e = E(S, t);
          n.from_greenwich = (e || parseFloat(t)) * y;
        },
        nadgrids: function (t) {
          '@null' === t ? (n.datumCode = 'none') : (n.nadgrids = t);
        },
        axis: function (t) {
          var e = 'ewnsud';
          3 === t.length &&
            -1 !== e.indexOf(t.substr(0, 1)) &&
            -1 !== e.indexOf(t.substr(1, 1)) &&
            -1 !== e.indexOf(t.substr(2, 1)) &&
            (n.axis = t);
        },
        approx: function () {
          n.approx = !0;
        },
      };
    for (e in r) ((i = r[e]), e in a ? ('function' == typeof (s = a[e]) ? s(i) : (n[s] = i)) : (n[e] = i));
    return ('string' == typeof n.datumCode && 'WGS84' !== n.datumCode && (n.datumCode = n.datumCode.toLowerCase()), n);
  }
  var A = function (t) {
      return new N(t).output();
    },
    F = 1,
    P = /\s/,
    T = /[A-Za-z]/,
    I = /[A-Za-z84_]/,
    _ = /[,\]]/,
    R = /[\d\.E\-\+]/;
  function N(t) {
    if ('string' != typeof t) throw new Error('not a string');
    ((this.text = t.trim()),
      (this.level = 0),
      (this.place = 0),
      (this.root = null),
      (this.stack = []),
      (this.currentObject = null),
      (this.state = F));
  }
  function B(t, e, i) {
    Array.isArray(e) && (i.unshift(e), (e = null));
    var s = e ? {} : t,
      n = i.reduce(function (t, e) {
        return (k(e, t), t);
      }, s);
    e && (t[e] = n);
  }
  function k(t, e) {
    if (Array.isArray(t)) {
      var i = t.shift();
      if (('PARAMETER' === i && (i = t.shift()), 1 === t.length))
        return Array.isArray(t[0]) ? ((e[i] = {}), void k(t[0], e[i])) : void (e[i] = t[0]);
      if (t.length)
        if ('TOWGS84' !== i) {
          if ('AXIS' === i) return (i in e || (e[i] = []), void e[i].push(t));
          var s;
          switch ((Array.isArray(i) || (e[i] = {}), i)) {
            case 'UNIT':
            case 'PRIMEM':
            case 'VERT_DATUM':
              return ((e[i] = { name: t[0].toLowerCase(), convert: t[1] }), void (3 === t.length && k(t[2], e[i])));
            case 'SPHEROID':
            case 'ELLIPSOID':
              return ((e[i] = { name: t[0], a: t[1], rf: t[2] }), void (4 === t.length && k(t[3], e[i])));
            case 'PROJECTEDCRS':
            case 'PROJCRS':
            case 'GEOGCS':
            case 'GEOCCS':
            case 'PROJCS':
            case 'LOCAL_CS':
            case 'GEODCRS':
            case 'GEODETICCRS':
            case 'GEODETICDATUM':
            case 'EDATUM':
            case 'ENGINEERINGDATUM':
            case 'VERT_CS':
            case 'VERTCRS':
            case 'VERTICALCRS':
            case 'COMPD_CS':
            case 'COMPOUNDCRS':
            case 'ENGINEERINGCRS':
            case 'ENGCRS':
            case 'FITTED_CS':
            case 'LOCAL_DATUM':
            case 'DATUM':
              return ((t[0] = ['name', t[0]]), void B(e, i, t));
            default:
              for (s = -1; ++s < t.length; ) if (!Array.isArray(t[s])) return k(t, e[i]);
              return B(e, i, t);
          }
        } else e[i] = t;
      else e[i] = !0;
    } else e[t] = !0;
  }
  ((N.prototype.readCharicter = function () {
    var t = this.text[this.place++];
    if (4 !== this.state)
      for (; P.test(t); ) {
        if (this.place >= this.text.length) return;
        t = this.text[this.place++];
      }
    switch (this.state) {
      case F:
        return this.neutral(t);
      case 2:
        return this.keyword(t);
      case 4:
        return this.quoted(t);
      case 5:
        return this.afterquote(t);
      case 3:
        return this.number(t);
      case -1:
        return;
    }
  }),
    (N.prototype.afterquote = function (t) {
      if ('"' === t) return ((this.word += '"'), void (this.state = 4));
      if (_.test(t)) return ((this.word = this.word.trim()), void this.afterItem(t));
      throw new Error('havn\'t handled "' + t + '" in afterquote yet, index ' + this.place);
    }),
    (N.prototype.afterItem = function (t) {
      return ',' === t
        ? (null !== this.word && this.currentObject.push(this.word), (this.word = null), void (this.state = F))
        : ']' === t
          ? (this.level--,
            null !== this.word && (this.currentObject.push(this.word), (this.word = null)),
            (this.state = F),
            (this.currentObject = this.stack.pop()),
            void (this.currentObject || (this.state = -1)))
          : void 0;
    }),
    (N.prototype.number = function (t) {
      if (!R.test(t)) {
        if (_.test(t)) return ((this.word = parseFloat(this.word)), void this.afterItem(t));
        throw new Error('havn\'t handled "' + t + '" in number yet, index ' + this.place);
      }
      this.word += t;
    }),
    (N.prototype.quoted = function (t) {
      '"' !== t ? (this.word += t) : (this.state = 5);
    }),
    (N.prototype.keyword = function (t) {
      if (I.test(t)) this.word += t;
      else {
        if ('[' === t) {
          var e = [];
          return (
            e.push(this.word),
            this.level++,
            null === this.root ? (this.root = e) : this.currentObject.push(e),
            this.stack.push(this.currentObject),
            (this.currentObject = e),
            void (this.state = F)
          );
        }
        if (!_.test(t)) throw new Error('havn\'t handled "' + t + '" in keyword yet, index ' + this.place);
        this.afterItem(t);
      }
    }),
    (N.prototype.neutral = function (t) {
      if (T.test(t)) return ((this.word = t), void (this.state = 2));
      if ('"' === t) return ((this.word = ''), void (this.state = 4));
      if (R.test(t)) return ((this.word = t), void (this.state = 3));
      if (!_.test(t)) throw new Error('havn\'t handled "' + t + '" in neutral yet, index ' + this.place);
      this.afterItem(t);
    }),
    (N.prototype.output = function () {
      for (; this.place < this.text.length; ) this.readCharicter();
      if (-1 === this.state) return this.root;
      throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
    }));
  var z,
    L = 0.017453292519943295;
  function O(t) {
    return t * L;
  }
  function H(t) {
    var e = A(t),
      i = e.shift(),
      s = e.shift();
    (e.unshift(['name', s]), e.unshift(['type', i]));
    var n = {};
    return (
      k(e, n),
      (function (t) {
        if (
          ('GEOGCS' === t.type
            ? (t.projName = 'longlat')
            : 'LOCAL_CS' === t.type
              ? ((t.projName = 'identity'), (t.local = !0))
              : 'object' == typeof t.PROJECTION
                ? (t.projName = Object.keys(t.PROJECTION)[0])
                : (t.projName = t.PROJECTION),
          t.AXIS)
        ) {
          for (var e = '', i = 0, s = t.AXIS.length; i < s; ++i) {
            var n = [t.AXIS[i][0].toLowerCase(), t.AXIS[i][1].toLowerCase()];
            -1 !== n[0].indexOf('north') || (('y' === n[0] || 'lat' === n[0]) && 'north' === n[1])
              ? (e += 'n')
              : -1 !== n[0].indexOf('south') || (('y' === n[0] || 'lat' === n[0]) && 'south' === n[1])
                ? (e += 's')
                : -1 !== n[0].indexOf('east') || (('x' === n[0] || 'lon' === n[0]) && 'east' === n[1])
                  ? (e += 'e')
                  : (-1 === n[0].indexOf('west') && (('x' !== n[0] && 'lon' !== n[0]) || 'west' !== n[1])) ||
                    (e += 'w');
          }
          (2 === e.length && (e += 'u'), 3 === e.length && (t.axis = e));
        }
        t.UNIT &&
          ((t.units = t.UNIT.name.toLowerCase()),
          'metre' === t.units && (t.units = 'meter'),
          t.UNIT.convert &&
            ('GEOGCS' === t.type
              ? t.DATUM && t.DATUM.SPHEROID && (t.to_meter = t.UNIT.convert * t.DATUM.SPHEROID.a)
              : (t.to_meter = t.UNIT.convert)));
        var r = t.GEOGCS;
        function a(e) {
          return e * (t.to_meter || 1);
        }
        ('GEOGCS' === t.type && (r = t),
          r &&
            (r.DATUM ? (t.datumCode = r.DATUM.name.toLowerCase()) : (t.datumCode = r.name.toLowerCase()),
            'd_' === t.datumCode.slice(0, 2) && (t.datumCode = t.datumCode.slice(2)),
            ('new_zealand_geodetic_datum_1949' !== t.datumCode && 'new_zealand_1949' !== t.datumCode) ||
              (t.datumCode = 'nzgd49'),
            ('wgs_1984' !== t.datumCode && 'world_geodetic_system_1984' !== t.datumCode) ||
              ('Mercator_Auxiliary_Sphere' === t.PROJECTION && (t.sphere = !0), (t.datumCode = 'wgs84')),
            '_ferro' === t.datumCode.slice(-6) && (t.datumCode = t.datumCode.slice(0, -6)),
            '_jakarta' === t.datumCode.slice(-8) && (t.datumCode = t.datumCode.slice(0, -8)),
            ~t.datumCode.indexOf('belge') && (t.datumCode = 'rnb72'),
            r.DATUM &&
              r.DATUM.SPHEROID &&
              ((t.ellps = r.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk')),
              'international' === t.ellps.toLowerCase().slice(0, 13) && (t.ellps = 'intl'),
              (t.a = r.DATUM.SPHEROID.a),
              (t.rf = parseFloat(r.DATUM.SPHEROID.rf, 10))),
            r.DATUM && r.DATUM.TOWGS84 && (t.datum_params = r.DATUM.TOWGS84),
            ~t.datumCode.indexOf('osgb_1936') && (t.datumCode = 'osgb36'),
            ~t.datumCode.indexOf('osni_1952') && (t.datumCode = 'osni52'),
            (~t.datumCode.indexOf('tm65') || ~t.datumCode.indexOf('geodetic_datum_of_1965')) && (t.datumCode = 'ire65'),
            'ch1903+' === t.datumCode && (t.datumCode = 'ch1903'),
            ~t.datumCode.indexOf('israel') && (t.datumCode = 'isr93')),
          t.b && !isFinite(t.b) && (t.b = t.a),
          [
            ['standard_parallel_1', 'Standard_Parallel_1'],
            ['standard_parallel_1', 'Latitude of 1st standard parallel'],
            ['standard_parallel_2', 'Standard_Parallel_2'],
            ['standard_parallel_2', 'Latitude of 2nd standard parallel'],
            ['false_easting', 'False_Easting'],
            ['false_easting', 'False easting'],
            ['false-easting', 'Easting at false origin'],
            ['false_northing', 'False_Northing'],
            ['false_northing', 'False northing'],
            ['false_northing', 'Northing at false origin'],
            ['central_meridian', 'Central_Meridian'],
            ['central_meridian', 'Longitude of natural origin'],
            ['central_meridian', 'Longitude of false origin'],
            ['latitude_of_origin', 'Latitude_Of_Origin'],
            ['latitude_of_origin', 'Central_Parallel'],
            ['latitude_of_origin', 'Latitude of natural origin'],
            ['latitude_of_origin', 'Latitude of false origin'],
            ['scale_factor', 'Scale_Factor'],
            ['k0', 'scale_factor'],
            ['latitude_of_center', 'Latitude_Of_Center'],
            ['latitude_of_center', 'Latitude_of_center'],
            ['lat0', 'latitude_of_center', O],
            ['longitude_of_center', 'Longitude_Of_Center'],
            ['longitude_of_center', 'Longitude_of_center'],
            ['longc', 'longitude_of_center', O],
            ['x0', 'false_easting', a],
            ['y0', 'false_northing', a],
            ['long0', 'central_meridian', O],
            ['lat0', 'latitude_of_origin', O],
            ['lat0', 'standard_parallel_1', O],
            ['lat1', 'standard_parallel_1', O],
            ['lat2', 'standard_parallel_2', O],
            ['azimuth', 'Azimuth'],
            ['alpha', 'azimuth', O],
            ['srsCode', 'name'],
          ].forEach(function (e) {
            return (
              (i = t),
              (n = (s = e)[0]),
              (r = s[1]),
              void (!(n in i) && r in i && ((i[n] = i[r]), 3 === s.length && (i[n] = s[2](i[n]))))
            );
            var i, s, n, r;
          }),
          t.long0 ||
            !t.longc ||
            ('Albers_Conic_Equal_Area' !== t.projName && 'Lambert_Azimuthal_Equal_Area' !== t.projName) ||
            (t.long0 = t.longc),
          t.lat_ts ||
          !t.lat1 ||
          ('Stereographic_South_Pole' !== t.projName && 'Polar Stereographic (variant B)' !== t.projName)
            ? !t.lat_ts &&
              t.lat0 &&
              'Polar_Stereographic' === t.projName &&
              ((t.lat_ts = t.lat0), (t.lat0 = O(t.lat0 > 0 ? 90 : -90)))
            : ((t.lat0 = O(t.lat1 > 0 ? 90 : -90)), (t.lat_ts = t.lat1)));
      })(n),
      n
    );
  }
  function j(t) {
    var e = this;
    if (2 === arguments.length) {
      var i = arguments[1];
      'string' == typeof i ? ('+' === i.charAt(0) ? (j[t] = D(arguments[1])) : (j[t] = H(arguments[1]))) : (j[t] = i);
    } else if (1 === arguments.length) {
      if (Array.isArray(t))
        return t.map(function (t) {
          Array.isArray(t) ? j.apply(e, t) : j(t);
        });
      if ('string' == typeof t) {
        if (t in j) return j[t];
      } else
        'EPSG' in t
          ? (j['EPSG:' + t.EPSG] = t)
          : 'ESRI' in t
            ? (j['ESRI:' + t.ESRI] = t)
            : 'IAU2000' in t
              ? (j['IAU2000:' + t.IAU2000] = t)
              : console.log(t);
      return;
    }
  }
  ((z = j)('EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'),
    z(
      'EPSG:4269',
      '+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees',
    ),
    z(
      'EPSG:3857',
      '+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs',
    ),
    (z.WGS84 = z['EPSG:4326']),
    (z['EPSG:3785'] = z['EPSG:3857']),
    (z.GOOGLE = z['EPSG:3857']),
    (z['EPSG:900913'] = z['EPSG:3857']),
    (z['EPSG:102113'] = z['EPSG:3857']));
  var q = j;
  var V = [
    'PROJECTEDCRS',
    'PROJCRS',
    'GEOGCS',
    'GEOCCS',
    'PROJCS',
    'LOCAL_CS',
    'GEODCRS',
    'GEODETICCRS',
    'GEODETICDATUM',
    'ENGCRS',
    'ENGINEERINGCRS',
  ];
  var U = ['3857', '900913', '3785', '102113'];
  var K = function (t) {
    if (
      !(function (t) {
        return 'string' == typeof t;
      })(t)
    )
      return t;
    if (
      (function (t) {
        return t in q;
      })(t)
    )
      return q[t];
    if (
      (function (t) {
        return V.some(function (e) {
          return t.indexOf(e) > -1;
        });
      })(t)
    ) {
      var e = H(t);
      if (
        (function (t) {
          var e = E(t, 'authority');
          if (e) {
            var i = E(e, 'epsg');
            return i && U.indexOf(i) > -1;
          }
        })(e)
      )
        return q['EPSG:3857'];
      var i = (function (t) {
        var e = E(t, 'extension');
        if (e) return E(e, 'proj4');
      })(e);
      return i ? D(i) : e;
    }
    return (function (t) {
      return '+' === t[0];
    })(t)
      ? D(t)
      : void 0;
  };
  function G(t, e) {
    var i, s;
    if (((t = t || {}), !e)) return t;
    for (s in e) void 0 !== (i = e[s]) && (t[s] = i);
    return t;
  }
  function W(t, e, i) {
    var s = t * e;
    return i / Math.sqrt(1 - s * s);
  }
  function Q(t) {
    return t < 0 ? -1 : 1;
  }
  function X(t) {
    return Math.abs(t) <= w ? t : t - Q(t) * b;
  }
  function Y(t, e, i) {
    var s = t * i,
      n = 0.5 * t;
    return ((s = Math.pow((1 - s) / (1 + s), n)), Math.tan(0.5 * (d - e)) / s);
  }
  function Z(t, e) {
    for (var i, s, n = 0.5 * t, r = d - 2 * Math.atan(e), a = 0; a <= 15; a++)
      if (
        ((i = t * Math.sin(r)),
        (r += s = d - 2 * Math.atan(e * Math.pow((1 - i) / (1 + i), n)) - r),
        Math.abs(s) <= 1e-10)
      )
        return r;
    return -9999;
  }
  function J(t) {
    return t;
  }
  var $ = [
      {
        init: function () {
          var t = this.b / this.a;
          ((this.es = 1 - t * t),
            'x0' in this || (this.x0 = 0),
            'y0' in this || (this.y0 = 0),
            (this.e = Math.sqrt(this.es)),
            this.lat_ts
              ? this.sphere
                ? (this.k0 = Math.cos(this.lat_ts))
                : (this.k0 = W(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)))
              : this.k0 || (this.k ? (this.k0 = this.k) : (this.k0 = 1)));
        },
        forward: function (t) {
          var e,
            i,
            s = t.x,
            n = t.y;
          if (n * x > 90 && n * x < -90 && s * x > 180 && s * x < -180) return null;
          if (Math.abs(Math.abs(n) - d) <= g) return null;
          if (this.sphere)
            ((e = this.x0 + this.a * this.k0 * X(s - this.long0)),
              (i = this.y0 + this.a * this.k0 * Math.log(Math.tan(v + 0.5 * n))));
          else {
            var r = Math.sin(n),
              a = Y(this.e, n, r);
            ((e = this.x0 + this.a * this.k0 * X(s - this.long0)), (i = this.y0 - this.a * this.k0 * Math.log(a)));
          }
          return ((t.x = e), (t.y = i), t);
        },
        inverse: function (t) {
          var e,
            i,
            s = t.x - this.x0,
            n = t.y - this.y0;
          if (this.sphere) i = d - 2 * Math.atan(Math.exp(-n / (this.a * this.k0)));
          else {
            var r = Math.exp(-n / (this.a * this.k0));
            if (-9999 === (i = Z(this.e, r))) return null;
          }
          return ((e = X(this.long0 + s / (this.a * this.k0))), (t.x = e), (t.y = i), t);
        },
        names: [
          'Mercator',
          'Popular Visualisation Pseudo Mercator',
          'Mercator_1SP',
          'Mercator_Auxiliary_Sphere',
          'merc',
        ],
      },
      { init: function () {}, forward: J, inverse: J, names: ['longlat', 'identity'] },
    ],
    tt = {},
    et = [];
  function it(t, e) {
    var i = et.length;
    return t.names
      ? ((et[i] = t),
        t.names.forEach(function (t) {
          tt[t.toLowerCase()] = i;
        }),
        this)
      : (console.log(e), !0);
  }
  var st = {
      start: function () {
        $.forEach(it);
      },
      add: it,
      get: function (t) {
        if (!t) return !1;
        var e = t.toLowerCase();
        return void 0 !== tt[e] && et[tt[e]] ? et[tt[e]] : void 0;
      },
    },
    nt = {
      MERIT: { a: 6378137, rf: 298.257, ellipseName: 'MERIT 1983' },
      SGS85: { a: 6378136, rf: 298.257, ellipseName: 'Soviet Geodetic System 85' },
      GRS80: { a: 6378137, rf: 298.257222101, ellipseName: 'GRS 1980(IUGG, 1980)' },
      IAU76: { a: 6378140, rf: 298.257, ellipseName: 'IAU 1976' },
      airy: { a: 6377563.396, b: 6356256.91, ellipseName: 'Airy 1830' },
      APL4: { a: 6378137, rf: 298.25, ellipseName: 'Appl. Physics. 1965' },
      NWL9D: { a: 6378145, rf: 298.25, ellipseName: 'Naval Weapons Lab., 1965' },
      mod_airy: { a: 6377340.189, b: 6356034.446, ellipseName: 'Modified Airy' },
      andrae: { a: 6377104.43, rf: 300, ellipseName: 'Andrae 1876 (Den., Iclnd.)' },
      aust_SA: { a: 6378160, rf: 298.25, ellipseName: 'Australian Natl & S. Amer. 1969' },
      GRS67: { a: 6378160, rf: 298.247167427, ellipseName: 'GRS 67(IUGG 1967)' },
      bessel: { a: 6377397.155, rf: 299.1528128, ellipseName: 'Bessel 1841' },
      bess_nam: { a: 6377483.865, rf: 299.1528128, ellipseName: 'Bessel 1841 (Namibia)' },
      clrk66: { a: 6378206.4, b: 6356583.8, ellipseName: 'Clarke 1866' },
      clrk80: { a: 6378249.145, rf: 293.4663, ellipseName: 'Clarke 1880 mod.' },
      clrk80ign: { a: 6378249.2, b: 6356515, rf: 293.4660213, ellipseName: 'Clarke 1880 (IGN)' },
      clrk58: { a: 6378293.645208759, rf: 294.2606763692654, ellipseName: 'Clarke 1858' },
      CPM: { a: 6375738.7, rf: 334.29, ellipseName: 'Comm. des Poids et Mesures 1799' },
      delmbr: { a: 6376428, rf: 311.5, ellipseName: 'Delambre 1810 (Belgium)' },
      engelis: { a: 6378136.05, rf: 298.2566, ellipseName: 'Engelis 1985' },
      evrst30: { a: 6377276.345, rf: 300.8017, ellipseName: 'Everest 1830' },
      evrst48: { a: 6377304.063, rf: 300.8017, ellipseName: 'Everest 1948' },
      evrst56: { a: 6377301.243, rf: 300.8017, ellipseName: 'Everest 1956' },
      evrst69: { a: 6377295.664, rf: 300.8017, ellipseName: 'Everest 1969' },
      evrstSS: { a: 6377298.556, rf: 300.8017, ellipseName: 'Everest (Sabah & Sarawak)' },
      fschr60: { a: 6378166, rf: 298.3, ellipseName: 'Fischer (Mercury Datum) 1960' },
      fschr60m: { a: 6378155, rf: 298.3, ellipseName: 'Fischer 1960' },
      fschr68: { a: 6378150, rf: 298.3, ellipseName: 'Fischer 1968' },
      helmert: { a: 6378200, rf: 298.3, ellipseName: 'Helmert 1906' },
      hough: { a: 6378270, rf: 297, ellipseName: 'Hough' },
      intl: { a: 6378388, rf: 297, ellipseName: 'International 1909 (Hayford)' },
      kaula: { a: 6378163, rf: 298.24, ellipseName: 'Kaula 1961' },
      lerch: { a: 6378139, rf: 298.257, ellipseName: 'Lerch 1979' },
      mprts: { a: 6397300, rf: 191, ellipseName: 'Maupertius 1738' },
      new_intl: { a: 6378157.5, b: 6356772.2, ellipseName: 'New International 1967' },
      plessis: { a: 6376523, rf: 6355863, ellipseName: 'Plessis 1817 (France)' },
      krass: { a: 6378245, rf: 298.3, ellipseName: 'Krassovsky, 1942' },
      SEasia: { a: 6378155, b: 6356773.3205, ellipseName: 'Southeast Asia' },
      walbeck: { a: 6376896, b: 6355834.8467, ellipseName: 'Walbeck' },
      WGS60: { a: 6378165, rf: 298.3, ellipseName: 'WGS 60' },
      WGS66: { a: 6378145, rf: 298.25, ellipseName: 'WGS 66' },
      WGS7: { a: 6378135, rf: 298.26, ellipseName: 'WGS 72' },
    },
    rt = (nt.WGS84 = { a: 6378137, rf: 298.257223563, ellipseName: 'WGS 84' });
  nt.sphere = { a: 6370997, b: 6370997, ellipseName: 'Normal Sphere (r=6370997)' };
  var at = {};
  ((at.wgs84 = { towgs84: '0,0,0', ellipse: 'WGS84', datumName: 'WGS84' }),
    (at.ch1903 = { towgs84: '674.374,15.056,405.346', ellipse: 'bessel', datumName: 'swiss' }),
    (at.ggrs87 = {
      towgs84: '-199.87,74.79,246.62',
      ellipse: 'GRS80',
      datumName: 'Greek_Geodetic_Reference_System_1987',
    }),
    (at.nad83 = { towgs84: '0,0,0', ellipse: 'GRS80', datumName: 'North_American_Datum_1983' }),
    (at.nad27 = {
      nadgrids: '@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat',
      ellipse: 'clrk66',
      datumName: 'North_American_Datum_1927',
    }),
    (at.potsdam = {
      towgs84: '598.1,73.7,418.2,0.202,0.045,-2.455,6.7',
      ellipse: 'bessel',
      datumName: 'Potsdam Rauenberg 1950 DHDN',
    }),
    (at.carthage = { towgs84: '-263.0,6.0,431.0', ellipse: 'clark80', datumName: 'Carthage 1934 Tunisia' }),
    (at.hermannskogel = {
      towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
      ellipse: 'bessel',
      datumName: 'Hermannskogel',
    }),
    (at.militargeographische_institut = {
      towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
      ellipse: 'bessel',
      datumName: 'Militar-Geographische Institut',
    }),
    (at.osni52 = {
      towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
      ellipse: 'airy',
      datumName: 'Irish National',
    }),
    (at.ire65 = {
      towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
      ellipse: 'mod_airy',
      datumName: 'Ireland 1965',
    }),
    (at.rassadiran = { towgs84: '-133.63,-157.5,-158.62', ellipse: 'intl', datumName: 'Rassadiran' }),
    (at.nzgd49 = {
      towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993',
      ellipse: 'intl',
      datumName: 'New Zealand Geodetic Datum 1949',
    }),
    (at.osgb36 = {
      towgs84: '446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894',
      ellipse: 'airy',
      datumName: 'Airy 1830',
    }),
    (at.s_jtsk = { towgs84: '589,76,480', ellipse: 'bessel', datumName: 'S-JTSK (Ferro)' }),
    (at.beduaram = { towgs84: '-106,-87,188', ellipse: 'clrk80', datumName: 'Beduaram' }),
    (at.gunung_segara = { towgs84: '-403,684,41', ellipse: 'bessel', datumName: 'Gunung Segara Jakarta' }),
    (at.rnb72 = {
      towgs84: '106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1',
      ellipse: 'intl',
      datumName: 'Reseau National Belge 1972',
    }));
  var ot = function (t, e, i, s, h, l, c) {
      var d = {};
      return (
        (d.datum_type = void 0 === t || 'none' === t ? o : 4),
        e &&
          ((d.datum_params = e.map(parseFloat)),
          (0 === d.datum_params[0] && 0 === d.datum_params[1] && 0 === d.datum_params[2]) || (d.datum_type = n),
          d.datum_params.length > 3 &&
            ((0 === d.datum_params[3] &&
              0 === d.datum_params[4] &&
              0 === d.datum_params[5] &&
              0 === d.datum_params[6]) ||
              ((d.datum_type = r),
              (d.datum_params[3] *= u),
              (d.datum_params[4] *= u),
              (d.datum_params[5] *= u),
              (d.datum_params[6] = d.datum_params[6] / 1e6 + 1)))),
        c && ((d.datum_type = a), (d.grids = c)),
        (d.a = i),
        (d.b = s),
        (d.es = h),
        (d.ep2 = l),
        d
      );
    },
    ht = {};
  function lt(t) {
    if (0 === t.length) return null;
    var e = '@' === t[0];
    return (
      e && (t = t.slice(1)),
      'null' === t
        ? { name: 'null', mandatory: !e, grid: null, isNull: !0 }
        : { name: t, mandatory: !e, grid: ht[t] || null, isNull: !1 }
    );
  }
  function ct(t) {
    return ((t / 3600) * Math.PI) / 180;
  }
  function ut(t, e, i) {
    return String.fromCharCode.apply(null, new Uint8Array(t.buffer.slice(e, i)));
  }
  function dt(t) {
    return t.map(function (t) {
      return [ct(t.longitudeShift), ct(t.latitudeShift)];
    });
  }
  function ft(t, e, i) {
    return {
      name: ut(t, e + 8, e + 16).trim(),
      parent: ut(t, e + 24, e + 24 + 8).trim(),
      lowerLatitude: t.getFloat64(e + 72, i),
      upperLatitude: t.getFloat64(e + 88, i),
      lowerLongitude: t.getFloat64(e + 104, i),
      upperLongitude: t.getFloat64(e + 120, i),
      latitudeInterval: t.getFloat64(e + 136, i),
      longitudeInterval: t.getFloat64(e + 152, i),
      gridNodeCount: t.getInt32(e + 168, i),
    };
  }
  function pt(t, e, i, s) {
    for (var n = e + 176, r = [], a = 0; a < i.gridNodeCount; a++) {
      var o = {
        latitudeShift: t.getFloat32(n + 16 * a, s),
        longitudeShift: t.getFloat32(n + 16 * a + 4, s),
        latitudeAccuracy: t.getFloat32(n + 16 * a + 8, s),
        longitudeAccuracy: t.getFloat32(n + 16 * a + 12, s),
      };
      r.push(o);
    }
    return r;
  }
  function mt(t, e) {
    if (!(this instanceof mt)) return new mt(t);
    e =
      e ||
      function (t) {
        if (t) throw t;
      };
    var i = K(t);
    if ('object' == typeof i) {
      var s = mt.projections.get(i.projName);
      if (s) {
        if (i.datumCode && 'none' !== i.datumCode) {
          var n = E(at, i.datumCode);
          n &&
            ((i.datum_params = i.datum_params || (n.towgs84 ? n.towgs84.split(',') : null)),
            (i.ellps = n.ellipse),
            (i.datumName = n.datumName ? n.datumName : i.datumCode));
        }
        ((i.k0 = i.k0 || 1), (i.axis = i.axis || 'enu'), (i.ellps = i.ellps || 'wgs84'), (i.lat1 = i.lat1 || i.lat0));
        var r,
          a,
          o,
          h,
          l,
          c,
          u,
          d = (function (t, e, i, s, n) {
            if (!t) {
              var r = E(nt, s);
              (r || (r = rt), (t = r.a), (e = r.b), (i = r.rf));
            }
            return (
              i && !e && (e = (1 - 1 / i) * t),
              (0 === i || Math.abs(t - e) < g) && ((n = !0), (e = t)),
              { a: t, b: e, rf: i, sphere: n }
            );
          })(i.a, i.b, i.rf, i.ellps, i.sphere),
          y =
            ((r = d.a),
            (a = d.b),
            d.rf,
            (o = i.R_A),
            (c = ((h = r * r) - (l = a * a)) / h),
            (u = 0),
            o ? ((h = (r *= 1 - c * (f + c * (p + c * m))) * r), (c = 0)) : (u = Math.sqrt(c)),
            { es: c, e: u, ep2: (h - l) / l }),
          x = (function (t) {
            return void 0 === t ? null : t.split(',').map(lt);
          })(i.nadgrids),
          v = i.datum || ot(i.datumCode, i.datum_params, d.a, d.b, y.es, y.ep2, x);
        (G(this, i),
          G(this, s),
          (this.a = d.a),
          (this.b = d.b),
          (this.rf = d.rf),
          (this.sphere = d.sphere),
          (this.es = y.es),
          (this.e = y.e),
          (this.ep2 = y.ep2),
          (this.datum = v),
          this.init(),
          e(null, this));
      } else e(t);
    } else e(t);
  }
  ((mt.projections = st), mt.projections.start());
  var gt = mt;
  function yt(t, e, i) {
    var s,
      n,
      r,
      a,
      o = t.x,
      h = t.y,
      l = t.z ? t.z : 0;
    if (h < -d && h > -1.001 * d) h = -d;
    else if (h > d && h < 1.001 * d) h = d;
    else {
      if (h < -d) return { x: -1 / 0, y: -1 / 0, z: t.z };
      if (h > d) return { x: 1 / 0, y: 1 / 0, z: t.z };
    }
    return (
      o > Math.PI && (o -= 2 * Math.PI),
      (n = Math.sin(h)),
      (a = Math.cos(h)),
      (r = n * n),
      {
        x: ((s = i / Math.sqrt(1 - e * r)) + l) * a * Math.cos(o),
        y: (s + l) * a * Math.sin(o),
        z: (s * (1 - e) + l) * n,
      }
    );
  }
  function xt(t, e, i, s) {
    var n,
      r,
      a,
      o,
      h,
      l,
      c,
      u,
      d,
      f,
      p,
      m,
      g,
      y,
      x,
      v = 1e-12,
      b = t.x,
      w = t.y,
      S = t.z ? t.z : 0;
    if (((n = Math.sqrt(b * b + w * w)), (r = Math.sqrt(b * b + w * w + S * S)), n / i < v)) {
      if (((y = 0), r / i < v)) return ((x = -s), { x: t.x, y: t.y, z: t.z });
    } else y = Math.atan2(w, b);
    ((a = S / r), (u = (o = n / r) * (1 - e) * (h = 1 / Math.sqrt(1 - e * (2 - e) * o * o))), (d = a * h), (g = 0));
    do {
      (g++,
        (l = (e * (c = i / Math.sqrt(1 - e * d * d))) / (c + (x = n * u + S * d - c * (1 - e * d * d)))),
        (m = (p = a * (h = 1 / Math.sqrt(1 - l * (2 - l) * o * o))) * u - (f = o * (1 - l) * h) * d),
        (u = f),
        (d = p));
    } while (m * m > 1e-24 && g < 30);
    return { x: y, y: Math.atan(p / Math.abs(f)), z: x };
  }
  function vt(t) {
    return t === n || t === r;
  }
  function bt(t, e, i) {
    if (
      (function (t, e) {
        return (
          t.datum_type === e.datum_type &&
          !(t.a !== e.a || Math.abs(t.es - e.es) > 5e-11) &&
          (t.datum_type === n
            ? t.datum_params[0] === e.datum_params[0] &&
              t.datum_params[1] === e.datum_params[1] &&
              t.datum_params[2] === e.datum_params[2]
            : t.datum_type !== r ||
              (t.datum_params[0] === e.datum_params[0] &&
                t.datum_params[1] === e.datum_params[1] &&
                t.datum_params[2] === e.datum_params[2] &&
                t.datum_params[3] === e.datum_params[3] &&
                t.datum_params[4] === e.datum_params[4] &&
                t.datum_params[5] === e.datum_params[5] &&
                t.datum_params[6] === e.datum_params[6]))
        );
      })(t, e)
    )
      return i;
    if (t.datum_type === o || e.datum_type === o) return i;
    var s = t.a,
      u = t.es;
    if (t.datum_type === a) {
      if (0 !== wt(t, !1, i)) return;
      ((s = h), (u = c));
    }
    var d = e.a,
      f = e.b,
      p = e.es;
    if (
      (e.datum_type === a && ((d = h), (f = l), (p = c)), u === p && s === d && !vt(t.datum_type) && !vt(e.datum_type))
    )
      return i;
    if (
      ((i = yt(i, u, s)),
      vt(t.datum_type) &&
        (i = (function (t, e, i) {
          if (e === n) return { x: t.x + i[0], y: t.y + i[1], z: t.z + i[2] };
          if (e === r) {
            var s = i[0],
              a = i[1],
              o = i[2],
              h = i[3],
              l = i[4],
              c = i[5],
              u = i[6];
            return {
              x: u * (t.x - c * t.y + l * t.z) + s,
              y: u * (c * t.x + t.y - h * t.z) + a,
              z: u * (-l * t.x + h * t.y + t.z) + o,
            };
          }
        })(i, t.datum_type, t.datum_params)),
      vt(e.datum_type) &&
        (i = (function (t, e, i) {
          if (e === n) return { x: t.x - i[0], y: t.y - i[1], z: t.z - i[2] };
          if (e === r) {
            var s = i[0],
              a = i[1],
              o = i[2],
              h = i[3],
              l = i[4],
              c = i[5],
              u = i[6],
              d = (t.x - s) / u,
              f = (t.y - a) / u,
              p = (t.z - o) / u;
            return { x: d + c * f - l * p, y: -c * d + f + h * p, z: l * d - h * f + p };
          }
        })(i, e.datum_type, e.datum_params)),
      (i = xt(i, p, d, f)),
      e.datum_type === a) &&
      0 !== wt(e, !0, i)
    )
      return;
    return i;
  }
  function wt(t, e, i) {
    if (null === t.grids || 0 === t.grids.length) return (console.log('Grid shift grids not found'), -1);
    var s = { x: -i.x, y: i.y },
      n = { x: Number.NaN, y: Number.NaN },
      r = [];
    t: for (var a = 0; a < t.grids.length; a++) {
      var o = t.grids[a];
      if ((r.push(o.name), o.isNull)) {
        n = s;
        break;
      }
      if ((o.mandatory, null !== o.grid))
        for (var h = o.grid.subgrids, l = 0, c = h.length; l < c; l++) {
          var u = h[l],
            d = (Math.abs(u.del[1]) + Math.abs(u.del[0])) / 1e4,
            f = u.ll[0] - d,
            p = u.ll[1] - d,
            m = u.ll[0] + (u.lim[0] - 1) * u.del[0] + d,
            g = u.ll[1] + (u.lim[1] - 1) * u.del[1] + d;
          if (!(p > s.y || f > s.x || g < s.y || m < s.x) && ((n = St(s, e, u)), !isNaN(n.x))) break t;
        }
      else if (o.mandatory) return (console.log("Unable to find mandatory grid '" + o.name + "'"), -1);
    }
    return isNaN(n.x)
      ? (console.log(
          "Failed to find a grid shift table for location '" + -s.x * x + ' ' + s.y * x + " tried: '" + r + "'",
        ),
        -1)
      : ((i.x = -n.x), (i.y = n.y), 0);
  }
  function St(t, e, i) {
    var s = { x: Number.NaN, y: Number.NaN };
    if (isNaN(t.x)) return s;
    var n = { x: t.x, y: t.y };
    ((n.x -= i.ll[0]), (n.y -= i.ll[1]), (n.x = X(n.x - Math.PI) + Math.PI));
    var r = Mt(n, i);
    if (e) {
      if (isNaN(r.x)) return s;
      ((r.x = n.x - r.x), (r.y = n.y - r.y));
      var a,
        o,
        h = 9;
      do {
        if (((o = Mt(r, i)), isNaN(o.x))) {
          console.log('Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.');
          break;
        }
        ((a = { x: n.x - (o.x + r.x), y: n.y - (o.y + r.y) }), (r.x += a.x), (r.y += a.y));
      } while (h-- && Math.abs(a.x) > 1e-12 && Math.abs(a.y) > 1e-12);
      if (h < 0) return (console.log('Inverse grid shift iterator failed to converge.'), s);
      ((s.x = X(r.x + i.ll[0])), (s.y = r.y + i.ll[1]));
    } else isNaN(r.x) || ((s.x = t.x + r.x), (s.y = t.y + r.y));
    return s;
  }
  function Mt(t, e) {
    var i,
      s = { x: t.x / e.del[0], y: t.y / e.del[1] },
      n = Math.floor(s.x),
      r = Math.floor(s.y),
      a = s.x - 1 * n,
      o = s.y - 1 * r,
      h = { x: Number.NaN, y: Number.NaN };
    if (n < 0 || n >= e.lim[0]) return h;
    if (r < 0 || r >= e.lim[1]) return h;
    i = r * e.lim[0] + n;
    var l = e.cvs[i][0],
      c = e.cvs[i][1];
    i++;
    var u = e.cvs[i][0],
      d = e.cvs[i][1];
    i += e.lim[0];
    var f = e.cvs[i][0],
      p = e.cvs[i][1];
    i--;
    var m = e.cvs[i][0],
      g = e.cvs[i][1],
      y = a * o,
      x = a * (1 - o),
      v = (1 - a) * (1 - o),
      b = (1 - a) * o;
    return ((h.x = v * l + x * u + b * m + y * f), (h.y = v * c + x * d + b * g + y * p), h);
  }
  function Ct(t, e, i) {
    var s,
      n,
      r,
      a = i.x,
      o = i.y,
      h = i.z || 0,
      l = {};
    for (r = 0; r < 3; r++)
      if (!e || 2 !== r || void 0 !== i.z)
        switch (
          (0 === r
            ? ((s = a), (n = -1 !== 'ew'.indexOf(t.axis[r]) ? 'x' : 'y'))
            : 1 === r
              ? ((s = o), (n = -1 !== 'ns'.indexOf(t.axis[r]) ? 'y' : 'x'))
              : ((s = h), (n = 'z')),
          t.axis[r])
        ) {
          case 'e':
          case 'n':
            l[n] = s;
            break;
          case 'w':
          case 's':
            l[n] = -s;
            break;
          case 'u':
            void 0 !== i[n] && (l.z = s);
            break;
          case 'd':
            void 0 !== i[n] && (l.z = -s);
            break;
          default:
            return null;
        }
    return l;
  }
  function Et(t) {
    var e = { x: t[0], y: t[1] };
    return (t.length > 2 && (e.z = t[2]), t.length > 3 && (e.m = t[3]), e);
  }
  function Dt(t) {
    if ('function' == typeof Number.isFinite) {
      if (Number.isFinite(t)) return;
      throw new TypeError('coordinates must be finite numbers');
    }
    if ('number' != typeof t || t != t || !isFinite(t)) throw new TypeError('coordinates must be finite numbers');
  }
  function At(t, e, i, s) {
    var o,
      h = void 0 !== (i = Array.isArray(i) ? Et(i) : { x: i.x, y: i.y, z: i.z, m: i.m }).z;
    if (
      ((function (t) {
        (Dt(t.x), Dt(t.y));
      })(i),
      t.datum &&
        e.datum &&
        (function (t, e) {
          return (
            ((t.datum.datum_type === n || t.datum.datum_type === r || t.datum.datum_type === a) &&
              'WGS84' !== e.datumCode) ||
            ((e.datum.datum_type === n || e.datum.datum_type === r || e.datum.datum_type === a) &&
              'WGS84' !== t.datumCode)
          );
        })(t, e) &&
        ((i = At(t, (o = new gt('WGS84')), i, s)), (t = o)),
      s && 'enu' !== t.axis && (i = Ct(t, !1, i)),
      'longlat' === t.projName)
    )
      i = { x: i.x * y, y: i.y * y, z: i.z || 0 };
    else if ((t.to_meter && (i = { x: i.x * t.to_meter, y: i.y * t.to_meter, z: i.z || 0 }), !(i = t.inverse(i))))
      return;
    if ((t.from_greenwich && (i.x += t.from_greenwich), (i = bt(t.datum, e.datum, i))))
      return (
        e.from_greenwich && (i = { x: i.x - e.from_greenwich, y: i.y, z: i.z || 0 }),
        'longlat' === e.projName
          ? (i = { x: i.x * x, y: i.y * x, z: i.z || 0 })
          : ((i = e.forward(i)), e.to_meter && (i = { x: i.x / e.to_meter, y: i.y / e.to_meter, z: i.z || 0 })),
        s && 'enu' !== e.axis ? Ct(e, !0, i) : (i && !h && delete i.z, i)
      );
  }
  var Ft = gt('WGS84');
  function Pt(t, e, i, s) {
    var n, r, a;
    return Array.isArray(i)
      ? ((n = At(t, e, i, s) || { x: NaN, y: NaN }),
        i.length > 2
          ? (void 0 !== t.name && 'geocent' === t.name) || (void 0 !== e.name && 'geocent' === e.name)
            ? 'number' == typeof n.z
              ? [n.x, n.y, n.z].concat(i.splice(3))
              : [n.x, n.y, i[2]].concat(i.splice(3))
            : [n.x, n.y].concat(i.splice(2))
          : [n.x, n.y])
      : ((r = At(t, e, i, s)),
        2 === (a = Object.keys(i)).length ||
          a.forEach(function (s) {
            if ((void 0 !== t.name && 'geocent' === t.name) || (void 0 !== e.name && 'geocent' === e.name)) {
              if ('x' === s || 'y' === s || 'z' === s) return;
            } else if ('x' === s || 'y' === s) return;
            r[s] = i[s];
          }),
        r);
  }
  function Tt(t) {
    return t instanceof gt ? t : t.oProj ? t.oProj : gt(t);
  }
  function It(t, e, i) {
    t = Tt(t);
    var s,
      n = !1;
    return (
      void 0 === e
        ? ((e = t), (t = Ft), (n = !0))
        : (void 0 !== e.x || Array.isArray(e)) && ((i = e), (e = t), (t = Ft), (n = !0)),
      (e = Tt(e)),
      i
        ? Pt(t, e, i)
        : ((s = {
            forward: function (i, s) {
              return Pt(t, e, i, s);
            },
            inverse: function (i, s) {
              return Pt(e, t, i, s);
            },
          }),
          n && (s.oProj = e),
          s)
    );
  }
  var _t = It,
    Rt = 6,
    Nt = 'AJSAJS',
    Bt = 'AFAFAF',
    kt = 65,
    zt = 73,
    Lt = 79,
    Ot = 86,
    Ht = 90,
    jt = {
      forward: qt,
      inverse: function (t) {
        var e = Gt(Xt(t.toUpperCase()));
        if (e.lat && e.lon) return [e.lon, e.lat, e.lon, e.lat];
        return [e.left, e.bottom, e.right, e.top];
      },
      toPoint: Vt,
    };
  function qt(t, e) {
    return (
      (e = e || 5),
      (function (t, e) {
        var i = '00000' + t.easting,
          s = '00000' + t.northing;
        return (
          t.zoneNumber +
          t.zoneLetter +
          ((f = t.easting),
          (p = t.northing),
          (m = t.zoneNumber),
          (g = Qt(m)),
          (y = Math.floor(f / 1e5)),
          (x = Math.floor(p / 1e5) % 20),
          (n = y),
          (r = x),
          (a = g),
          (o = a - 1),
          (h = Nt.charCodeAt(o)),
          (l = Bt.charCodeAt(o)),
          (c = h + n - 1),
          (u = l + r),
          (d = !1),
          c > Ht && ((c = c - Ht + kt - 1), (d = !0)),
          (c === zt || (h < zt && c > zt) || ((c > zt || h < zt) && d)) && c++,
          (c === Lt || (h < Lt && c > Lt) || ((c > Lt || h < Lt) && d)) && ++c === zt && c++,
          c > Ht && (c = c - Ht + kt - 1),
          u > Ot ? ((u = u - Ot + kt - 1), (d = !0)) : (d = !1),
          (u === zt || (l < zt && u > zt) || ((u > zt || l < zt) && d)) && u++,
          (u === Lt || (l < Lt && u > Lt) || ((u > Lt || l < Lt) && d)) && ++u === zt && u++,
          u > Ot && (u = u - Ot + kt - 1),
          String.fromCharCode(c) + String.fromCharCode(u)) +
          i.substr(i.length - 5, e) +
          s.substr(s.length - 5, e)
        );
        var n, r, a, o, h, l, c, u, d;
        var f, p, m, g, y, x;
      })(
        (function (t) {
          var e,
            i,
            s,
            n,
            r,
            a,
            o,
            h,
            l = t.lat,
            c = t.lon,
            u = 6378137,
            d = 0.00669438,
            f = 0.9996,
            p = Ut(l),
            m = Ut(c);
          ((h = Math.floor((c + 180) / 6) + 1), 180 === c && (h = 60));
          l >= 56 && l < 64 && c >= 3 && c < 12 && (h = 32);
          l >= 72 &&
            l < 84 &&
            (c >= 0 && c < 9
              ? (h = 31)
              : c >= 9 && c < 21
                ? (h = 33)
                : c >= 21 && c < 33
                  ? (h = 35)
                  : c >= 33 && c < 42 && (h = 37));
          ((o = Ut(6 * (h - 1) - 180 + 3)),
            (e = d / (1 - d)),
            (i = u / Math.sqrt(1 - d * Math.sin(p) * Math.sin(p))),
            (s = Math.tan(p) * Math.tan(p)),
            (n = e * Math.cos(p) * Math.cos(p)),
            (r = Math.cos(p) * (m - o)),
            (a =
              u *
              ((1 - d / 4 - (3 * d * d) / 64 - (5 * d * d * d) / 256) * p -
                ((3 * d) / 8 + (3 * d * d) / 32 + (45 * d * d * d) / 1024) * Math.sin(2 * p) +
                ((15 * d * d) / 256 + (45 * d * d * d) / 1024) * Math.sin(4 * p) -
                ((35 * d * d * d) / 3072) * Math.sin(6 * p))));
          var g =
              f *
                i *
                (r +
                  ((1 - s + n) * r * r * r) / 6 +
                  ((5 - 18 * s + s * s + 72 * n - 58 * e) * r * r * r * r * r) / 120) +
              5e5,
            y =
              f *
              (a +
                i *
                  Math.tan(p) *
                  ((r * r) / 2 +
                    ((5 - s + 9 * n + 4 * n * n) * r * r * r * r) / 24 +
                    ((61 - 58 * s + s * s + 600 * n - 330 * e) * r * r * r * r * r * r) / 720));
          l < 0 && (y += 1e7);
          return { northing: Math.round(y), easting: Math.round(g), zoneNumber: h, zoneLetter: Wt(l) };
        })({ lat: t[1], lon: t[0] }),
        e,
      )
    );
  }
  function Vt(t) {
    var e = Gt(Xt(t.toUpperCase()));
    return e.lat && e.lon ? [e.lon, e.lat] : [(e.left + e.right) / 2, (e.top + e.bottom) / 2];
  }
  function Ut(t) {
    return t * (Math.PI / 180);
  }
  function Kt(t) {
    return (t / Math.PI) * 180;
  }
  function Gt(t) {
    var e = t.northing,
      i = t.easting,
      s = t.zoneLetter,
      n = t.zoneNumber;
    if (n < 0 || n > 60) return null;
    var r,
      a,
      o,
      h,
      l,
      c,
      u,
      d,
      f,
      p = 0.9996,
      m = 6378137,
      g = 0.00669438,
      y = (1 - Math.sqrt(0.99330562)) / (1 + Math.sqrt(0.99330562)),
      x = i - 5e5,
      v = e;
    (s < 'N' && (v -= 1e7),
      (u = 6 * (n - 1) - 180 + 3),
      (r = 0.006739496752268451),
      (f =
        (d = v / p / 6367449.145945056) +
        ((3 * y) / 2 - (27 * y * y * y) / 32) * Math.sin(2 * d) +
        ((21 * y * y) / 16 - (55 * y * y * y * y) / 32) * Math.sin(4 * d) +
        ((151 * y * y * y) / 96) * Math.sin(6 * d)),
      (a = m / Math.sqrt(1 - g * Math.sin(f) * Math.sin(f))),
      (o = Math.tan(f) * Math.tan(f)),
      (h = r * Math.cos(f) * Math.cos(f)),
      (l = (0.99330562 * m) / Math.pow(1 - g * Math.sin(f) * Math.sin(f), 1.5)),
      (c = x / (a * p)));
    var b =
      f -
      ((a * Math.tan(f)) / l) *
        ((c * c) / 2 -
          ((5 + 3 * o + 10 * h - 4 * h * h - 9 * r) * c * c * c * c) / 24 +
          ((61 + 90 * o + 298 * h + 45 * o * o - 1.6983531815716497 - 3 * h * h) * c * c * c * c * c * c) / 720);
    b = Kt(b);
    var w,
      S =
        (c -
          ((1 + 2 * o + h) * c * c * c) / 6 +
          ((5 - 2 * h + 28 * o - 3 * h * h + 8 * r + 24 * o * o) * c * c * c * c * c) / 120) /
        Math.cos(f);
    if (((S = u + Kt(S)), t.accuracy)) {
      var M = Gt({
        northing: t.northing + t.accuracy,
        easting: t.easting + t.accuracy,
        zoneLetter: t.zoneLetter,
        zoneNumber: t.zoneNumber,
      });
      w = { top: M.lat, right: M.lon, bottom: b, left: S };
    } else w = { lat: b, lon: S };
    return w;
  }
  function Wt(t) {
    var e = 'Z';
    return (
      84 >= t && t >= 72
        ? (e = 'X')
        : 72 > t && t >= 64
          ? (e = 'W')
          : 64 > t && t >= 56
            ? (e = 'V')
            : 56 > t && t >= 48
              ? (e = 'U')
              : 48 > t && t >= 40
                ? (e = 'T')
                : 40 > t && t >= 32
                  ? (e = 'S')
                  : 32 > t && t >= 24
                    ? (e = 'R')
                    : 24 > t && t >= 16
                      ? (e = 'Q')
                      : 16 > t && t >= 8
                        ? (e = 'P')
                        : 8 > t && t >= 0
                          ? (e = 'N')
                          : 0 > t && t >= -8
                            ? (e = 'M')
                            : -8 > t && t >= -16
                              ? (e = 'L')
                              : -16 > t && t >= -24
                                ? (e = 'K')
                                : -24 > t && t >= -32
                                  ? (e = 'J')
                                  : -32 > t && t >= -40
                                    ? (e = 'H')
                                    : -40 > t && t >= -48
                                      ? (e = 'G')
                                      : -48 > t && t >= -56
                                        ? (e = 'F')
                                        : -56 > t && t >= -64
                                          ? (e = 'E')
                                          : -64 > t && t >= -72
                                            ? (e = 'D')
                                            : -72 > t && t >= -80 && (e = 'C'),
      e
    );
  }
  function Qt(t) {
    var e = t % Rt;
    return (0 === e && (e = Rt), e);
  }
  function Xt(t) {
    if (t && 0 === t.length) throw 'MGRSPoint coverting from nothing';
    for (var e, i = t.length, s = null, n = '', r = 0; !/[A-Z]/.test((e = t.charAt(r))); ) {
      if (r >= 2) throw 'MGRSPoint bad conversion from: ' + t;
      ((n += e), r++);
    }
    var a = parseInt(n, 10);
    if (0 === r || r + 3 > i) throw 'MGRSPoint bad conversion from: ' + t;
    var o = t.charAt(r++);
    if (o <= 'A' || 'B' === o || 'Y' === o || o >= 'Z' || 'I' === o || 'O' === o)
      throw 'MGRSPoint zone letter ' + o + ' not handled: ' + t;
    s = t.substring(r, (r += 2));
    for (
      var h = Qt(a),
        l = (function (t, e) {
          var i = Nt.charCodeAt(e - 1),
            s = 1e5,
            n = !1;
          for (; i !== t.charCodeAt(0); ) {
            if ((++i === zt && i++, i === Lt && i++, i > Ht)) {
              if (n) throw 'Bad character: ' + t;
              ((i = kt), (n = !0));
            }
            s += 1e5;
          }
          return s;
        })(s.charAt(0), h),
        c = (function (t, e) {
          if (t > 'V') throw 'MGRSPoint given invalid Northing ' + t;
          var i = Bt.charCodeAt(e - 1),
            s = 0,
            n = !1;
          for (; i !== t.charCodeAt(0); ) {
            if ((++i === zt && i++, i === Lt && i++, i > Ot)) {
              if (n) throw 'Bad character: ' + t;
              ((i = kt), (n = !0));
            }
            s += 1e5;
          }
          return s;
        })(s.charAt(1), h);
      c < Yt(o);

    )
      c += 2e6;
    var u = i - r;
    if (u % 2 != 0)
      throw (
        'MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters' +
        t
      );
    var d,
      f,
      p,
      m = u / 2,
      g = 0,
      y = 0;
    return (
      m > 0 &&
        ((d = 1e5 / Math.pow(10, m)),
        (f = t.substring(r, r + m)),
        (g = parseFloat(f) * d),
        (p = t.substring(r + m)),
        (y = parseFloat(p) * d)),
      { easting: g + l, northing: y + c, zoneLetter: o, zoneNumber: a, accuracy: d }
    );
  }
  function Yt(t) {
    var e;
    switch (t) {
      case 'C':
        e = 11e5;
        break;
      case 'D':
        e = 2e6;
        break;
      case 'E':
        e = 28e5;
        break;
      case 'F':
        e = 37e5;
        break;
      case 'G':
        e = 46e5;
        break;
      case 'H':
        e = 55e5;
        break;
      case 'J':
        e = 64e5;
        break;
      case 'K':
        e = 73e5;
        break;
      case 'L':
        e = 82e5;
        break;
      case 'M':
        e = 91e5;
        break;
      case 'N':
        e = 0;
        break;
      case 'P':
        e = 8e5;
        break;
      case 'Q':
        e = 17e5;
        break;
      case 'R':
        e = 26e5;
        break;
      case 'S':
        e = 35e5;
        break;
      case 'T':
        e = 44e5;
        break;
      case 'U':
        e = 53e5;
        break;
      case 'V':
        e = 62e5;
        break;
      case 'W':
        e = 7e6;
        break;
      case 'X':
        e = 79e5;
        break;
      default:
        e = -1;
    }
    if (e >= 0) return e;
    throw 'Invalid zone letter: ' + t;
  }
  function Zt(t, e, i) {
    if (!(this instanceof Zt)) return new Zt(t, e, i);
    if (Array.isArray(t)) ((this.x = t[0]), (this.y = t[1]), (this.z = t[2] || 0));
    else if ('object' == typeof t) ((this.x = t.x), (this.y = t.y), (this.z = t.z || 0));
    else if ('string' == typeof t && void 0 === e) {
      var s = t.split(',');
      ((this.x = parseFloat(s[0], 10)), (this.y = parseFloat(s[1], 10)), (this.z = parseFloat(s[2], 10) || 0));
    } else ((this.x = t), (this.y = e), (this.z = i || 0));
    console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
  }
  ((Zt.fromMGRS = function (t) {
    return new Zt(Vt(t));
  }),
    (Zt.prototype.toMGRS = function (t) {
      return qt([this.x, this.y], t);
    }));
  var Jt = Zt,
    $t = 1,
    te = 0.25,
    ee = 0.046875,
    ie = 0.01953125,
    se = 0.01068115234375,
    ne = 0.75,
    re = 0.46875,
    ae = 0.013020833333333334,
    oe = 0.007120768229166667,
    he = 0.3645833333333333,
    le = 0.005696614583333333,
    ce = 0.3076171875;
  function ue(t) {
    var e = [];
    ((e[0] = $t - t * (te + t * (ee + t * (ie + t * se)))), (e[1] = t * (ne - t * (ee + t * (ie + t * se)))));
    var i = t * t;
    return ((e[2] = i * (re - t * (ae + t * oe))), (i *= t), (e[3] = i * (he - t * le)), (e[4] = i * t * ce), e);
  }
  function de(t, e, i, s) {
    return ((i *= e), (e *= e), s[0] * t - i * (s[1] + e * (s[2] + e * (s[3] + e * s[4]))));
  }
  var fe = 20;
  function pe(t, e, i) {
    for (var s = 1 / (1 - e), n = t, r = fe; r; --r) {
      var a = Math.sin(n),
        o = 1 - e * a * a;
      if (((n -= o = (de(n, a, Math.cos(n), i) - t) * (o * Math.sqrt(o)) * s), Math.abs(o) < g)) return n;
    }
    return n;
  }
  var me = {
    init: function () {
      ((this.x0 = void 0 !== this.x0 ? this.x0 : 0),
        (this.y0 = void 0 !== this.y0 ? this.y0 : 0),
        (this.long0 = void 0 !== this.long0 ? this.long0 : 0),
        (this.lat0 = void 0 !== this.lat0 ? this.lat0 : 0),
        this.es &&
          ((this.en = ue(this.es)), (this.ml0 = de(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en))));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n = t.x,
        r = t.y,
        a = X(n - this.long0),
        o = Math.sin(r),
        h = Math.cos(r);
      if (this.es) {
        var l = h * a,
          c = Math.pow(l, 2),
          u = this.ep2 * Math.pow(h, 2),
          d = Math.pow(u, 2),
          f = Math.abs(h) > g ? Math.tan(r) : 0,
          p = Math.pow(f, 2),
          m = Math.pow(p, 2);
        ((e = 1 - this.es * Math.pow(o, 2)), (l /= Math.sqrt(e)));
        var y = de(r, o, h, this.en);
        ((i =
          this.a *
            (this.k0 *
              l *
              (1 +
                (c / 6) *
                  (1 -
                    p +
                    u +
                    (c / 20) * (5 - 18 * p + m + 14 * u - 58 * p * u + (c / 42) * (61 + 179 * m - m * p - 479 * p))))) +
          this.x0),
          (s =
            this.a *
              (this.k0 *
                (y -
                  this.ml0 +
                  ((o * a * l) / 2) *
                    (1 +
                      (c / 12) *
                        (5 -
                          p +
                          9 * u +
                          4 * d +
                          (c / 30) *
                            (61 +
                              m -
                              58 * p +
                              270 * u -
                              330 * p * u +
                              (c / 56) * (1385 + 543 * m - m * p - 3111 * p)))))) +
            this.y0));
      } else {
        var x = h * Math.sin(a);
        if (Math.abs(Math.abs(x) - 1) < g) return 93;
        if (
          ((i = 0.5 * this.a * this.k0 * Math.log((1 + x) / (1 - x)) + this.x0),
          (s = (h * Math.cos(a)) / Math.sqrt(1 - Math.pow(x, 2))),
          (x = Math.abs(s)) >= 1)
        ) {
          if (x - 1 > g) return 93;
          s = 0;
        } else s = Math.acos(s);
        (r < 0 && (s = -s), (s = this.a * this.k0 * (s - this.lat0) + this.y0));
      }
      return ((t.x = i), (t.y = s), t);
    },
    inverse: function (t) {
      var e,
        i,
        s,
        n,
        r = (t.x - this.x0) * (1 / this.a),
        a = (t.y - this.y0) * (1 / this.a);
      if (this.es)
        if (((i = pe((e = this.ml0 + a / this.k0), this.es, this.en)), Math.abs(i) < d)) {
          var o = Math.sin(i),
            h = Math.cos(i),
            l = Math.abs(h) > g ? Math.tan(i) : 0,
            c = this.ep2 * Math.pow(h, 2),
            u = Math.pow(c, 2),
            f = Math.pow(l, 2),
            p = Math.pow(f, 2);
          e = 1 - this.es * Math.pow(o, 2);
          var m = (r * Math.sqrt(e)) / this.k0,
            y = Math.pow(m, 2);
          ((s =
            i -
            (((e *= l) * y) / (1 - this.es)) *
              0.5 *
              (1 -
                (y / 12) *
                  (5 +
                    3 * f -
                    9 * c * f +
                    c -
                    4 * u -
                    (y / 30) *
                      (61 +
                        90 * f -
                        252 * c * f +
                        45 * p +
                        46 * c -
                        (y / 56) * (1385 + 3633 * f + 4095 * p + 1574 * p * f))))),
            (n = X(
              this.long0 +
                (m *
                  (1 -
                    (y / 6) *
                      (1 +
                        2 * f +
                        c -
                        (y / 20) *
                          (5 +
                            28 * f +
                            24 * p +
                            8 * c * f +
                            6 * c -
                            (y / 42) * (61 + 662 * f + 1320 * p + 720 * p * f))))) /
                  h,
            )));
        } else ((s = d * Q(a)), (n = 0));
      else {
        var x = Math.exp(r / this.k0),
          v = 0.5 * (x - 1 / x),
          b = this.lat0 + a / this.k0,
          w = Math.cos(b);
        ((e = Math.sqrt((1 - Math.pow(w, 2)) / (1 + Math.pow(v, 2)))),
          (s = Math.asin(e)),
          a < 0 && (s = -s),
          (n = 0 === v && 0 === w ? 0 : X(Math.atan2(v, w) + this.long0)));
      }
      return ((t.x = n), (t.y = s), t);
    },
    names: ['Fast_Transverse_Mercator', 'Fast Transverse Mercator'],
  };
  function ge(t) {
    var e = Math.exp(t);
    return (e = (e - 1 / e) / 2);
  }
  function ye(t, e) {
    ((t = Math.abs(t)), (e = Math.abs(e)));
    var i = Math.max(t, e),
      s = Math.min(t, e) / (i || 1);
    return i * Math.sqrt(1 + Math.pow(s, 2));
  }
  function xe(t) {
    var e = Math.abs(t);
    return (
      (e = (function (t) {
        var e = 1 + t,
          i = e - 1;
        return 0 === i ? t : (t * Math.log(e)) / i;
      })(e * (1 + e / (ye(1, e) + 1)))),
      t < 0 ? -e : e
    );
  }
  function ve(t, e) {
    for (var i, s = 2 * Math.cos(2 * e), n = t.length - 1, r = t[n], a = 0; --n >= 0; )
      ((i = s * r - a + t[n]), (a = r), (r = i));
    return e + i * Math.sin(2 * e);
  }
  function be(t, e, i) {
    for (
      var s,
        n,
        r = Math.sin(e),
        a = Math.cos(e),
        o = ge(i),
        h = (function (t) {
          var e = Math.exp(t);
          return (e + 1 / e) / 2;
        })(i),
        l = 2 * a * h,
        c = -2 * r * o,
        u = t.length - 1,
        d = t[u],
        f = 0,
        p = 0,
        m = 0;
      --u >= 0;

    )
      ((s = p), (n = f), (d = l * (p = d) - s - c * (f = m) + t[u]), (m = c * p - n + l * f));
    return [(l = r * h) * d - (c = a * o) * m, l * m + c * d];
  }
  var we = {
    init: function () {
      if (!this.approx && (isNaN(this.es) || this.es <= 0))
        throw new Error(
          'Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.',
        );
      (this.approx && (me.init.apply(this), (this.forward = me.forward), (this.inverse = me.inverse)),
        (this.x0 = void 0 !== this.x0 ? this.x0 : 0),
        (this.y0 = void 0 !== this.y0 ? this.y0 : 0),
        (this.long0 = void 0 !== this.long0 ? this.long0 : 0),
        (this.lat0 = void 0 !== this.lat0 ? this.lat0 : 0),
        (this.cgb = []),
        (this.cbg = []),
        (this.utg = []),
        (this.gtu = []));
      var t = this.es / (1 + Math.sqrt(1 - this.es)),
        e = t / (2 - t),
        i = e;
      ((this.cgb[0] = e * (2 + e * (-2 / 3 + e * (e * (116 / 45 + e * (26 / 45 + e * (-2854 / 675))) - 2)))),
        (this.cbg[0] = e * (e * (2 / 3 + e * (4 / 3 + e * (-82 / 45 + e * (32 / 45 + e * (4642 / 4725))))) - 2)),
        (i *= e),
        (this.cgb[1] = i * (7 / 3 + e * (e * (-227 / 45 + e * (2704 / 315 + e * (2323 / 945))) - 1.6))),
        (this.cbg[1] = i * (5 / 3 + e * (-16 / 15 + e * (-13 / 9 + e * (904 / 315 + e * (-1522 / 945)))))),
        (i *= e),
        (this.cgb[2] = i * (56 / 15 + e * (-136 / 35 + e * (-1262 / 105 + e * (73814 / 2835))))),
        (this.cbg[2] = i * (-26 / 15 + e * (34 / 21 + e * (1.6 + e * (-12686 / 2835))))),
        (i *= e),
        (this.cgb[3] = i * (4279 / 630 + e * (-332 / 35 + e * (-399572 / 14175)))),
        (this.cbg[3] = i * (1237 / 630 + e * (e * (-24832 / 14175) - 2.4))),
        (i *= e),
        (this.cgb[4] = i * (4174 / 315 + e * (-144838 / 6237))),
        (this.cbg[4] = i * (-734 / 315 + e * (109598 / 31185))),
        (i *= e),
        (this.cgb[5] = i * (601676 / 22275)),
        (this.cbg[5] = i * (444337 / 155925)),
        (i = Math.pow(e, 2)),
        (this.Qn = (this.k0 / (1 + e)) * (1 + i * (1 / 4 + i * (1 / 64 + i / 256)))),
        (this.utg[0] =
          e * (e * (2 / 3 + e * (-37 / 96 + e * (1 / 360 + e * (81 / 512 + e * (-96199 / 604800))))) - 0.5)),
        (this.gtu[0] =
          e * (0.5 + e * (-2 / 3 + e * (5 / 16 + e * (41 / 180 + e * (-127 / 288 + e * (7891 / 37800))))))),
        (this.utg[1] = i * (-1 / 48 + e * (-1 / 15 + e * (437 / 1440 + e * (-46 / 105 + e * (1118711 / 3870720)))))),
        (this.gtu[1] = i * (13 / 48 + e * (e * (557 / 1440 + e * (281 / 630 + e * (-1983433 / 1935360))) - 0.6))),
        (i *= e),
        (this.utg[2] = i * (-17 / 480 + e * (37 / 840 + e * (209 / 4480 + e * (-5569 / 90720))))),
        (this.gtu[2] = i * (61 / 240 + e * (-103 / 140 + e * (15061 / 26880 + e * (167603 / 181440))))),
        (i *= e),
        (this.utg[3] = i * (-4397 / 161280 + e * (11 / 504 + e * (830251 / 7257600)))),
        (this.gtu[3] = i * (49561 / 161280 + e * (-179 / 168 + e * (6601661 / 7257600)))),
        (i *= e),
        (this.utg[4] = i * (-4583 / 161280 + e * (108847 / 3991680))),
        (this.gtu[4] = i * (34729 / 80640 + e * (-3418889 / 1995840))),
        (i *= e),
        (this.utg[5] = i * (-20648693 / 638668800)),
        (this.gtu[5] = 0.6650675310896665 * i));
      var s = ve(this.cbg, this.lat0);
      this.Zb =
        -this.Qn *
        (s +
          (function (t, e) {
            for (var i, s = 2 * Math.cos(e), n = t.length - 1, r = t[n], a = 0; --n >= 0; )
              ((i = s * r - a + t[n]), (a = r), (r = i));
            return Math.sin(e) * i;
          })(this.gtu, 2 * s));
    },
    forward: function (t) {
      var e = X(t.x - this.long0),
        i = t.y;
      i = ve(this.cbg, i);
      var s = Math.sin(i),
        n = Math.cos(i),
        r = Math.sin(e),
        a = Math.cos(e);
      ((i = Math.atan2(s, a * n)), (e = Math.atan2(r * n, ye(s, n * a))), (e = xe(Math.tan(e))));
      var o,
        h,
        l = be(this.gtu, 2 * i, 2 * e);
      return (
        (i += l[0]),
        (e += l[1]),
        Math.abs(e) <= 2.623395162778
          ? ((o = this.a * (this.Qn * e) + this.x0), (h = this.a * (this.Qn * i + this.Zb) + this.y0))
          : ((o = 1 / 0), (h = 1 / 0)),
        (t.x = o),
        (t.y = h),
        t
      );
    },
    inverse: function (t) {
      var e,
        i,
        s = (t.x - this.x0) * (1 / this.a),
        n = (t.y - this.y0) * (1 / this.a);
      if (((n = (n - this.Zb) / this.Qn), (s /= this.Qn), Math.abs(s) <= 2.623395162778)) {
        var r = be(this.utg, 2 * n, 2 * s);
        ((n += r[0]), (s += r[1]), (s = Math.atan(ge(s))));
        var a = Math.sin(n),
          o = Math.cos(n),
          h = Math.sin(s),
          l = Math.cos(s);
        ((n = Math.atan2(a * l, ye(h, l * o))),
          (e = X((s = Math.atan2(h, l * o)) + this.long0)),
          (i = ve(this.cgb, n)));
      } else ((e = 1 / 0), (i = 1 / 0));
      return ((t.x = e), (t.y = i), t);
    },
    names: [
      'Extended_Transverse_Mercator',
      'Extended Transverse Mercator',
      'etmerc',
      'Transverse_Mercator',
      'Transverse Mercator',
      'Gauss Kruger',
      'Gauss_Kruger',
      'tmerc',
    ],
  };
  var Se = {
    init: function () {
      var t = (function (t, e) {
        if (void 0 === t) {
          if ((t = Math.floor((30 * (X(e) + Math.PI)) / Math.PI) + 1) < 0) return 0;
          if (t > 60) return 60;
        }
        return t;
      })(this.zone, this.long0);
      if (void 0 === t) throw new Error('unknown utm zone');
      ((this.lat0 = 0),
        (this.long0 = (6 * Math.abs(t) - 183) * y),
        (this.x0 = 5e5),
        (this.y0 = this.utmSouth ? 1e7 : 0),
        (this.k0 = 0.9996),
        we.init.apply(this),
        (this.forward = we.forward),
        (this.inverse = we.inverse));
    },
    names: ['Universal Transverse Mercator System', 'utm'],
    dependsOn: 'etmerc',
  };
  function Me(t, e) {
    return Math.pow((1 - t) / (1 + t), e);
  }
  var Ce = {
    init: function () {
      var t = Math.sin(this.lat0),
        e = Math.cos(this.lat0);
      ((e *= e),
        (this.rc = Math.sqrt(1 - this.es) / (1 - this.es * t * t)),
        (this.C = Math.sqrt(1 + (this.es * e * e) / (1 - this.es))),
        (this.phic0 = Math.asin(t / this.C)),
        (this.ratexp = 0.5 * this.C * this.e),
        (this.K =
          Math.tan(0.5 * this.phic0 + v) /
          (Math.pow(Math.tan(0.5 * this.lat0 + v), this.C) * Me(this.e * t, this.ratexp))));
    },
    forward: function (t) {
      var e = t.x,
        i = t.y;
      return (
        (t.y =
          2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * i + v), this.C) * Me(this.e * Math.sin(i), this.ratexp)) - d),
        (t.x = this.C * e),
        t
      );
    },
    inverse: function (t) {
      for (
        var e = t.x / this.C, i = t.y, s = Math.pow(Math.tan(0.5 * i + v) / this.K, 1 / this.C), n = 20;
        n > 0 && ((i = 2 * Math.atan(s * Me(this.e * Math.sin(t.y), -0.5 * this.e)) - d), !(Math.abs(i - t.y) < 1e-14));
        --n
      )
        t.y = i;
      return n ? ((t.x = e), (t.y = i), t) : null;
    },
  };
  var Ee = {
    init: function () {
      (Ce.init.apply(this),
        this.rc &&
          ((this.sinc0 = Math.sin(this.phic0)),
          (this.cosc0 = Math.cos(this.phic0)),
          (this.R2 = 2 * this.rc),
          this.title || (this.title = 'Oblique Stereographic Alternative')));
    },
    forward: function (t) {
      var e, i, s, n;
      return (
        (t.x = X(t.x - this.long0)),
        Ce.forward.apply(this, [t]),
        (e = Math.sin(t.y)),
        (i = Math.cos(t.y)),
        (s = Math.cos(t.x)),
        (n = (this.k0 * this.R2) / (1 + this.sinc0 * e + this.cosc0 * i * s)),
        (t.x = n * i * Math.sin(t.x)),
        (t.y = n * (this.cosc0 * e - this.sinc0 * i * s)),
        (t.x = this.a * t.x + this.x0),
        (t.y = this.a * t.y + this.y0),
        t
      );
    },
    inverse: function (t) {
      var e, i, s, n, r;
      if (
        ((t.x = (t.x - this.x0) / this.a),
        (t.y = (t.y - this.y0) / this.a),
        (t.x /= this.k0),
        (t.y /= this.k0),
        (r = ye(t.x, t.y)))
      ) {
        var a = 2 * Math.atan2(r, this.R2);
        ((e = Math.sin(a)),
          (i = Math.cos(a)),
          (n = Math.asin(i * this.sinc0 + (t.y * e * this.cosc0) / r)),
          (s = Math.atan2(t.x * e, r * this.cosc0 * i - t.y * this.sinc0 * e)));
      } else ((n = this.phic0), (s = 0));
      return ((t.x = s), (t.y = n), Ce.inverse.apply(this, [t]), (t.x = X(t.x + this.long0)), t);
    },
    names: [
      'Stereographic_North_Pole',
      'Oblique_Stereographic',
      'sterea',
      'Oblique Stereographic Alternative',
      'Double_Stereographic',
    ],
  };
  var De = {
    init: function () {
      ((this.x0 = this.x0 || 0),
        (this.y0 = this.y0 || 0),
        (this.lat0 = this.lat0 || 0),
        (this.long0 = this.long0 || 0),
        (this.coslat0 = Math.cos(this.lat0)),
        (this.sinlat0 = Math.sin(this.lat0)),
        this.sphere
          ? 1 === this.k0 &&
            !isNaN(this.lat_ts) &&
            Math.abs(this.coslat0) <= g &&
            (this.k0 = 0.5 * (1 + Q(this.lat0) * Math.sin(this.lat_ts)))
          : (Math.abs(this.coslat0) <= g && (this.lat0 > 0 ? (this.con = 1) : (this.con = -1)),
            (this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e))),
            1 === this.k0 &&
              !isNaN(this.lat_ts) &&
              Math.abs(this.coslat0) <= g &&
              Math.abs(Math.cos(this.lat_ts)) > g &&
              (this.k0 =
                (0.5 * this.cons * W(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts))) /
                Y(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))),
            (this.ms1 = W(this.e, this.sinlat0, this.coslat0)),
            (this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - d),
            (this.cosX0 = Math.cos(this.X0)),
            (this.sinX0 = Math.sin(this.X0))));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o = t.x,
        h = t.y,
        l = Math.sin(h),
        c = Math.cos(h),
        u = X(o - this.long0);
      return Math.abs(Math.abs(o - this.long0) - Math.PI) <= g && Math.abs(h + this.lat0) <= g
        ? ((t.x = NaN), (t.y = NaN), t)
        : this.sphere
          ? ((e = (2 * this.k0) / (1 + this.sinlat0 * l + this.coslat0 * c * Math.cos(u))),
            (t.x = this.a * e * c * Math.sin(u) + this.x0),
            (t.y = this.a * e * (this.coslat0 * l - this.sinlat0 * c * Math.cos(u)) + this.y0),
            t)
          : ((i = 2 * Math.atan(this.ssfn_(h, l, this.e)) - d),
            (n = Math.cos(i)),
            (s = Math.sin(i)),
            Math.abs(this.coslat0) <= g
              ? ((r = Y(this.e, h * this.con, this.con * l)),
                (a = (2 * this.a * this.k0 * r) / this.cons),
                (t.x = this.x0 + a * Math.sin(o - this.long0)),
                (t.y = this.y0 - this.con * a * Math.cos(o - this.long0)),
                t)
              : (Math.abs(this.sinlat0) < g
                  ? ((e = (2 * this.a * this.k0) / (1 + n * Math.cos(u))), (t.y = e * s))
                  : ((e =
                      (2 * this.a * this.k0 * this.ms1) /
                      (this.cosX0 * (1 + this.sinX0 * s + this.cosX0 * n * Math.cos(u)))),
                    (t.y = e * (this.cosX0 * s - this.sinX0 * n * Math.cos(u)) + this.y0)),
                (t.x = e * n * Math.sin(u) + this.x0),
                t));
    },
    inverse: function (t) {
      var e, i, s, n, r;
      ((t.x -= this.x0), (t.y -= this.y0));
      var a = Math.sqrt(t.x * t.x + t.y * t.y);
      if (this.sphere) {
        var o = 2 * Math.atan(a / (2 * this.a * this.k0));
        return (
          (e = this.long0),
          (i = this.lat0),
          a <= g
            ? ((t.x = e), (t.y = i), t)
            : ((i = Math.asin(Math.cos(o) * this.sinlat0 + (t.y * Math.sin(o) * this.coslat0) / a)),
              (e =
                Math.abs(this.coslat0) < g
                  ? this.lat0 > 0
                    ? X(this.long0 + Math.atan2(t.x, -1 * t.y))
                    : X(this.long0 + Math.atan2(t.x, t.y))
                  : X(
                      this.long0 +
                        Math.atan2(
                          t.x * Math.sin(o),
                          a * this.coslat0 * Math.cos(o) - t.y * this.sinlat0 * Math.sin(o),
                        ),
                    )),
              (t.x = e),
              (t.y = i),
              t)
        );
      }
      if (Math.abs(this.coslat0) <= g) {
        if (a <= g) return ((i = this.lat0), (e = this.long0), (t.x = e), (t.y = i), t);
        ((t.x *= this.con),
          (t.y *= this.con),
          (s = (a * this.cons) / (2 * this.a * this.k0)),
          (i = this.con * Z(this.e, s)),
          (e = this.con * X(this.con * this.long0 + Math.atan2(t.x, -1 * t.y))));
      } else
        ((n = 2 * Math.atan((a * this.cosX0) / (2 * this.a * this.k0 * this.ms1))),
          (e = this.long0),
          a <= g
            ? (r = this.X0)
            : ((r = Math.asin(Math.cos(n) * this.sinX0 + (t.y * Math.sin(n) * this.cosX0) / a)),
              (e = X(
                this.long0 +
                  Math.atan2(t.x * Math.sin(n), a * this.cosX0 * Math.cos(n) - t.y * this.sinX0 * Math.sin(n)),
              ))),
          (i = -1 * Z(this.e, Math.tan(0.5 * (d + r)))));
      return ((t.x = e), (t.y = i), t);
    },
    names: ['stere', 'Stereographic_South_Pole', 'Polar Stereographic (variant B)', 'Polar_Stereographic'],
    ssfn_: function (t, e, i) {
      return ((e *= i), Math.tan(0.5 * (d + t)) * Math.pow((1 - e) / (1 + e), 0.5 * i));
    },
  };
  var Ae = {
      init: function () {
        var t = this.lat0;
        this.lambda0 = this.long0;
        var e = Math.sin(t),
          i = this.a,
          s = 1 / this.rf,
          n = 2 * s - Math.pow(s, 2),
          r = (this.e = Math.sqrt(n));
        ((this.R = (this.k0 * i * Math.sqrt(1 - n)) / (1 - n * Math.pow(e, 2))),
          (this.alpha = Math.sqrt(1 + (n / (1 - n)) * Math.pow(Math.cos(t), 4))),
          (this.b0 = Math.asin(e / this.alpha)));
        var a = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)),
          o = Math.log(Math.tan(Math.PI / 4 + t / 2)),
          h = Math.log((1 + r * e) / (1 - r * e));
        this.K = a - this.alpha * o + ((this.alpha * r) / 2) * h;
      },
      forward: function (t) {
        var e = Math.log(Math.tan(Math.PI / 4 - t.y / 2)),
          i = (this.e / 2) * Math.log((1 + this.e * Math.sin(t.y)) / (1 - this.e * Math.sin(t.y))),
          s = -this.alpha * (e + i) + this.K,
          n = 2 * (Math.atan(Math.exp(s)) - Math.PI / 4),
          r = this.alpha * (t.x - this.lambda0),
          a = Math.atan(Math.sin(r) / (Math.sin(this.b0) * Math.tan(n) + Math.cos(this.b0) * Math.cos(r))),
          o = Math.asin(Math.cos(this.b0) * Math.sin(n) - Math.sin(this.b0) * Math.cos(n) * Math.cos(r));
        return (
          (t.y = (this.R / 2) * Math.log((1 + Math.sin(o)) / (1 - Math.sin(o))) + this.y0),
          (t.x = this.R * a + this.x0),
          t
        );
      },
      inverse: function (t) {
        for (
          var e = t.x - this.x0,
            i = t.y - this.y0,
            s = e / this.R,
            n = 2 * (Math.atan(Math.exp(i / this.R)) - Math.PI / 4),
            r = Math.asin(Math.cos(this.b0) * Math.sin(n) + Math.sin(this.b0) * Math.cos(n) * Math.cos(s)),
            a = Math.atan(Math.sin(s) / (Math.cos(this.b0) * Math.cos(s) - Math.sin(this.b0) * Math.tan(n))),
            o = this.lambda0 + a / this.alpha,
            h = 0,
            l = r,
            c = -1e3,
            u = 0;
          Math.abs(l - c) > 1e-7;

        ) {
          if (++u > 20) return;
          ((h =
            (1 / this.alpha) * (Math.log(Math.tan(Math.PI / 4 + r / 2)) - this.K) +
            this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(l)) / 2))),
            (c = l),
            (l = 2 * Math.atan(Math.exp(h)) - Math.PI / 2));
        }
        return ((t.x = o), (t.y = l), t);
      },
      names: ['somerc'],
    },
    Fe = 1e-7;
  var Pe = {
    init: function () {
      var t,
        e,
        i,
        s,
        n,
        r,
        a,
        o,
        h,
        l,
        c,
        u,
        f,
        p = 0,
        m = 0,
        x = 0,
        w = 0,
        S = 0,
        M = 0,
        C = 0;
      ((this.no_off =
        ((f = 'object' == typeof (u = this).PROJECTION ? Object.keys(u.PROJECTION)[0] : u.PROJECTION),
        'no_uoff' in u ||
          'no_off' in u ||
          -1 !== ['Hotine_Oblique_Mercator', 'Hotine_Oblique_Mercator_Azimuth_Natural_Origin'].indexOf(f))),
        (this.no_rot = 'no_rot' in this));
      var E = !1;
      'alpha' in this && (E = !0);
      var D = !1;
      if (
        ('rectified_grid_angle' in this && (D = !0),
        E && (C = this.alpha),
        D && (p = this.rectified_grid_angle * y),
        E || D)
      )
        m = this.longc;
      else if (
        ((x = this.long1),
        (S = this.lat1),
        (w = this.long2),
        (M = this.lat2),
        Math.abs(S - M) <= Fe ||
          (t = Math.abs(S)) <= Fe ||
          Math.abs(t - d) <= Fe ||
          Math.abs(Math.abs(this.lat0) - d) <= Fe ||
          Math.abs(Math.abs(M) - d) <= Fe)
      )
        throw new Error();
      var A = 1 - this.es;
      ((e = Math.sqrt(A)),
        Math.abs(this.lat0) > g
          ? ((o = Math.sin(this.lat0)),
            (i = Math.cos(this.lat0)),
            (t = 1 - this.es * o * o),
            (this.B = i * i),
            (this.B = Math.sqrt(1 + (this.es * this.B * this.B) / A)),
            (this.A = (this.B * this.k0 * e) / t),
            (n = (s = (this.B * e) / (i * Math.sqrt(t))) * s - 1) <= 0
              ? (n = 0)
              : ((n = Math.sqrt(n)), this.lat0 < 0 && (n = -n)),
            (this.E = n += s),
            (this.E *= Math.pow(Y(this.e, this.lat0, o), this.B)))
          : ((this.B = 1 / e), (this.A = this.k0), (this.E = s = n = 1)),
        E || D
          ? (E ? ((c = Math.asin(Math.sin(C) / s)), D || (p = C)) : ((c = p), (C = Math.asin(s * Math.sin(c)))),
            (this.lam0 = m - Math.asin(0.5 * (n - 1 / n) * Math.tan(c)) / this.B))
          : ((r = Math.pow(Y(this.e, S, Math.sin(S)), this.B)),
            (a = Math.pow(Y(this.e, M, Math.sin(M)), this.B)),
            (n = this.E / r),
            (h = (a - r) / (a + r)),
            (l = ((l = this.E * this.E) - a * r) / (l + a * r)),
            (t = x - w) < -Math.pi ? (w -= b) : t > Math.pi && (w += b),
            (this.lam0 = X(0.5 * (x + w) - Math.atan((l * Math.tan(0.5 * this.B * (x - w))) / h) / this.B)),
            (c = Math.atan((2 * Math.sin(this.B * X(x - this.lam0))) / (n - 1 / n))),
            (p = C = Math.asin(s * Math.sin(c)))),
        (this.singam = Math.sin(c)),
        (this.cosgam = Math.cos(c)),
        (this.sinrot = Math.sin(p)),
        (this.cosrot = Math.cos(p)),
        (this.rB = 1 / this.B),
        (this.ArB = this.A * this.rB),
        (this.BrA = 1 / this.ArB),
        this.A,
        this.B,
        this.no_off
          ? (this.u_0 = 0)
          : ((this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(s * s - 1) / Math.cos(C)))),
            this.lat0 < 0 && (this.u_0 = -this.u_0)),
        (n = 0.5 * c),
        (this.v_pole_n = this.ArB * Math.log(Math.tan(v - n))),
        (this.v_pole_s = this.ArB * Math.log(Math.tan(v + n))));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h,
        l = {};
      if (((t.x = t.x - this.lam0), Math.abs(Math.abs(t.y) - d) > g)) {
        if (
          ((e = 0.5 * ((r = this.E / Math.pow(Y(this.e, t.y, Math.sin(t.y)), this.B)) - (a = 1 / r))),
          (i = 0.5 * (r + a)),
          (n = Math.sin(this.B * t.x)),
          (s = (e * this.singam - n * this.cosgam) / i),
          Math.abs(Math.abs(s) - 1) < g)
        )
          throw new Error();
        ((h = 0.5 * this.ArB * Math.log((1 - s) / (1 + s))),
          (a = Math.cos(this.B * t.x)),
          (o = Math.abs(a) < Fe ? this.A * t.x : this.ArB * Math.atan2(e * this.cosgam + n * this.singam, a)));
      } else ((h = t.y > 0 ? this.v_pole_n : this.v_pole_s), (o = this.ArB * t.y));
      return (
        this.no_rot
          ? ((l.x = o), (l.y = h))
          : ((o -= this.u_0), (l.x = h * this.cosrot + o * this.sinrot), (l.y = o * this.cosrot - h * this.sinrot)),
        (l.x = this.a * l.x + this.x0),
        (l.y = this.a * l.y + this.y0),
        l
      );
    },
    inverse: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h = {};
      if (
        ((t.x = (t.x - this.x0) * (1 / this.a)),
        (t.y = (t.y - this.y0) * (1 / this.a)),
        this.no_rot
          ? ((i = t.y), (e = t.x))
          : ((i = t.x * this.cosrot - t.y * this.sinrot), (e = t.y * this.cosrot + t.x * this.sinrot + this.u_0)),
        (n = 0.5 * ((s = Math.exp(-this.BrA * i)) - 1 / s)),
        (r = 0.5 * (s + 1 / s)),
        (o = ((a = Math.sin(this.BrA * e)) * this.cosgam + n * this.singam) / r),
        Math.abs(Math.abs(o) - 1) < g)
      )
        ((h.x = 0), (h.y = o < 0 ? -d : d));
      else {
        if (
          ((h.y = this.E / Math.sqrt((1 + o) / (1 - o))), (h.y = Z(this.e, Math.pow(h.y, 1 / this.B))), h.y === 1 / 0)
        )
          throw new Error();
        h.x = -this.rB * Math.atan2(n * this.cosgam - a * this.singam, Math.cos(this.BrA * e));
      }
      return ((h.x += this.lam0), h);
    },
    names: [
      'Hotine_Oblique_Mercator',
      'Hotine Oblique Mercator',
      'Hotine_Oblique_Mercator_Azimuth_Natural_Origin',
      'Hotine_Oblique_Mercator_Two_Point_Natural_Origin',
      'Hotine_Oblique_Mercator_Azimuth_Center',
      'Oblique_Mercator',
      'omerc',
    ],
  };
  var Te = {
    init: function () {
      if (
        (this.lat2 || (this.lat2 = this.lat1),
        this.k0 || (this.k0 = 1),
        (this.x0 = this.x0 || 0),
        (this.y0 = this.y0 || 0),
        !(Math.abs(this.lat1 + this.lat2) < g))
      ) {
        var t = this.b / this.a;
        this.e = Math.sqrt(1 - t * t);
        var e = Math.sin(this.lat1),
          i = Math.cos(this.lat1),
          s = W(this.e, e, i),
          n = Y(this.e, this.lat1, e),
          r = Math.sin(this.lat2),
          a = Math.cos(this.lat2),
          o = W(this.e, r, a),
          h = Y(this.e, this.lat2, r),
          l = Y(this.e, this.lat0, Math.sin(this.lat0));
        (Math.abs(this.lat1 - this.lat2) > g ? (this.ns = Math.log(s / o) / Math.log(n / h)) : (this.ns = e),
          isNaN(this.ns) && (this.ns = e),
          (this.f0 = s / (this.ns * Math.pow(n, this.ns))),
          (this.rh = this.a * this.f0 * Math.pow(l, this.ns)),
          this.title || (this.title = 'Lambert Conformal Conic'));
      }
    },
    forward: function (t) {
      var e = t.x,
        i = t.y;
      Math.abs(2 * Math.abs(i) - Math.PI) <= g && (i = Q(i) * (d - 2 * g));
      var s,
        n,
        r = Math.abs(Math.abs(i) - d);
      if (r > g) ((s = Y(this.e, i, Math.sin(i))), (n = this.a * this.f0 * Math.pow(s, this.ns)));
      else {
        if ((r = i * this.ns) <= 0) return null;
        n = 0;
      }
      var a = this.ns * X(e - this.long0);
      return (
        (t.x = this.k0 * (n * Math.sin(a)) + this.x0),
        (t.y = this.k0 * (this.rh - n * Math.cos(a)) + this.y0),
        t
      );
    },
    inverse: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a = (t.x - this.x0) / this.k0,
        o = this.rh - (t.y - this.y0) / this.k0;
      this.ns > 0 ? ((e = Math.sqrt(a * a + o * o)), (i = 1)) : ((e = -Math.sqrt(a * a + o * o)), (i = -1));
      var h = 0;
      if ((0 !== e && (h = Math.atan2(i * a, i * o)), 0 !== e || this.ns > 0)) {
        if (((i = 1 / this.ns), (s = Math.pow(e / (this.a * this.f0), i)), -9999 === (n = Z(this.e, s)))) return null;
      } else n = -d;
      return ((r = X(h / this.ns + this.long0)), (t.x = r), (t.y = n), t);
    },
    names: [
      'Lambert Tangential Conformal Conic Projection',
      'Lambert_Conformal_Conic',
      'Lambert_Conformal_Conic_1SP',
      'Lambert_Conformal_Conic_2SP',
      'lcc',
      'Lambert Conic Conformal (1SP)',
      'Lambert Conic Conformal (2SP)',
    ],
  };
  var Ie = {
    init: function () {
      ((this.a = 6377397.155),
        (this.es = 0.006674372230614),
        (this.e = Math.sqrt(this.es)),
        this.lat0 || (this.lat0 = 0.863937979737193),
        this.long0 || (this.long0 = 0.4334234309119251),
        this.k0 || (this.k0 = 0.9999),
        (this.s45 = 0.785398163397448),
        (this.s90 = 2 * this.s45),
        (this.fi0 = this.lat0),
        (this.e2 = this.es),
        (this.e = Math.sqrt(this.e2)),
        (this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2))),
        (this.uq = 1.04216856380474),
        (this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa)),
        (this.g = Math.pow(
          (1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)),
          (this.alfa * this.e) / 2,
        )),
        (this.k = (Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa)) * this.g),
        (this.k1 = this.k0),
        (this.n0 = (this.a * Math.sqrt(1 - this.e2)) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2))),
        (this.s0 = 1.37008346281555),
        (this.n = Math.sin(this.s0)),
        (this.ro0 = (this.k1 * this.n0) / Math.tan(this.s0)),
        (this.ad = this.s90 - this.uq));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h = t.x,
        l = t.y,
        c = X(h - this.long0);
      return (
        (e = Math.pow((1 + this.e * Math.sin(l)) / (1 - this.e * Math.sin(l)), (this.alfa * this.e) / 2)),
        (i = 2 * (Math.atan((this.k * Math.pow(Math.tan(l / 2 + this.s45), this.alfa)) / e) - this.s45)),
        (s = -c * this.alfa),
        (n = Math.asin(Math.cos(this.ad) * Math.sin(i) + Math.sin(this.ad) * Math.cos(i) * Math.cos(s))),
        (r = Math.asin((Math.cos(i) * Math.sin(s)) / Math.cos(n))),
        (a = this.n * r),
        (o =
          (this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n)) /
          Math.pow(Math.tan(n / 2 + this.s45), this.n)),
        (t.y = (o * Math.cos(a)) / 1),
        (t.x = (o * Math.sin(a)) / 1),
        this.czech || ((t.y *= -1), (t.x *= -1)),
        t
      );
    },
    inverse: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h = t.x;
      ((t.x = t.y),
        (t.y = h),
        this.czech || ((t.y *= -1), (t.x *= -1)),
        (r = Math.sqrt(t.x * t.x + t.y * t.y)),
        (n = Math.atan2(t.y, t.x) / Math.sin(this.s0)),
        (s = 2 * (Math.atan(Math.pow(this.ro0 / r, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45)),
        (e = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(n))),
        (i = Math.asin((Math.cos(s) * Math.sin(n)) / Math.cos(e))),
        (t.x = this.long0 - i / this.alfa),
        (a = e),
        (o = 0));
      var l = 0;
      do {
        ((t.y =
          2 *
          (Math.atan(
            Math.pow(this.k, -1 / this.alfa) *
              Math.pow(Math.tan(e / 2 + this.s45), 1 / this.alfa) *
              Math.pow((1 + this.e * Math.sin(a)) / (1 - this.e * Math.sin(a)), this.e / 2),
          ) -
            this.s45)),
          Math.abs(a - t.y) < 1e-10 && (o = 1),
          (a = t.y),
          (l += 1));
      } while (0 === o && l < 15);
      return l >= 15 ? null : t;
    },
    names: ['Krovak', 'krovak'],
  };
  function _e(t, e, i, s, n) {
    return t * n - e * Math.sin(2 * n) + i * Math.sin(4 * n) - s * Math.sin(6 * n);
  }
  function Re(t) {
    return 1 - 0.25 * t * (1 + (t / 16) * (3 + 1.25 * t));
  }
  function Ne(t) {
    return 0.375 * t * (1 + 0.25 * t * (1 + 0.46875 * t));
  }
  function Be(t) {
    return 0.05859375 * t * t * (1 + 0.75 * t);
  }
  function ke(t) {
    return t * t * t * (35 / 3072);
  }
  function ze(t, e, i) {
    var s = e * i;
    return t / Math.sqrt(1 - s * s);
  }
  function Le(t) {
    return Math.abs(t) < d ? t : t - Q(t) * Math.PI;
  }
  function Oe(t, e, i, s, n) {
    var r, a;
    r = t / e;
    for (var o = 0; o < 15; o++)
      if (
        ((r += a =
          (t - (e * r - i * Math.sin(2 * r) + s * Math.sin(4 * r) - n * Math.sin(6 * r))) /
          (e - 2 * i * Math.cos(2 * r) + 4 * s * Math.cos(4 * r) - 6 * n * Math.cos(6 * r))),
        Math.abs(a) <= 1e-10)
      )
        return r;
    return NaN;
  }
  var He = {
    init: function () {
      this.sphere ||
        ((this.e0 = Re(this.es)),
        (this.e1 = Ne(this.es)),
        (this.e2 = Be(this.es)),
        (this.e3 = ke(this.es)),
        (this.ml0 = this.a * _e(this.e0, this.e1, this.e2, this.e3, this.lat0)));
    },
    forward: function (t) {
      var e,
        i,
        s = t.x,
        n = t.y;
      if (((s = X(s - this.long0)), this.sphere))
        ((e = this.a * Math.asin(Math.cos(n) * Math.sin(s))),
          (i = this.a * (Math.atan2(Math.tan(n), Math.cos(s)) - this.lat0)));
      else {
        var r = Math.sin(n),
          a = Math.cos(n),
          o = ze(this.a, this.e, r),
          h = Math.tan(n) * Math.tan(n),
          l = s * Math.cos(n),
          c = l * l,
          u = (this.es * a * a) / (1 - this.es);
        ((e = o * l * (1 - c * h * (1 / 6 - ((8 - h + 8 * u) * c) / 120))),
          (i =
            this.a * _e(this.e0, this.e1, this.e2, this.e3, n) -
            this.ml0 +
            ((o * r) / a) * c * (0.5 + ((5 - h + 6 * u) * c) / 24)));
      }
      return ((t.x = e + this.x0), (t.y = i + this.y0), t);
    },
    inverse: function (t) {
      ((t.x -= this.x0), (t.y -= this.y0));
      var e,
        i,
        s = t.x / this.a,
        n = t.y / this.a;
      if (this.sphere) {
        var r = n + this.lat0;
        ((e = Math.asin(Math.sin(r) * Math.cos(s))), (i = Math.atan2(Math.tan(s), Math.cos(r))));
      } else {
        var a = Oe(this.ml0 / this.a + n, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(a) - d) <= g) return ((t.x = this.long0), (t.y = d), n < 0 && (t.y *= -1), t);
        var o = ze(this.a, this.e, Math.sin(a)),
          h = ((o * o * o) / this.a / this.a) * (1 - this.es),
          l = Math.pow(Math.tan(a), 2),
          c = (s * this.a) / o,
          u = c * c;
        ((e = a - ((o * Math.tan(a)) / h) * c * c * (0.5 - ((1 + 3 * l) * c * c) / 24)),
          (i = (c * (1 - u * (l / 3 + ((1 + 3 * l) * l * u) / 15))) / Math.cos(a)));
      }
      return ((t.x = X(i + this.long0)), (t.y = Le(e)), t);
    },
    names: ['Cassini', 'Cassini_Soldner', 'cass'],
  };
  function je(t, e) {
    var i;
    return t > 1e-7 ? (1 - t * t) * (e / (1 - (i = t * e) * i) - (0.5 / t) * Math.log((1 - i) / (1 + i))) : 2 * e;
  }
  var qe = 0.3333333333333333,
    Ve = 0.17222222222222222,
    Ue = 0.10257936507936508,
    Ke = 0.06388888888888888,
    Ge = 0.0664021164021164,
    We = 0.016415012942191543;
  var Qe = {
    init: function () {
      var t,
        e = Math.abs(this.lat0);
      if (
        (Math.abs(e - d) < g
          ? (this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE)
          : Math.abs(e) < g
            ? (this.mode = this.EQUIT)
            : (this.mode = this.OBLIQ),
        this.es > 0)
      )
        switch (
          ((this.qp = je(this.e, 1)),
          (this.mmf = 0.5 / (1 - this.es)),
          (this.apa = (function (t) {
            var e,
              i = [];
            return (
              (i[0] = t * qe),
              (e = t * t),
              (i[0] += e * Ve),
              (i[1] = e * Ke),
              (e *= t),
              (i[0] += e * Ue),
              (i[1] += e * Ge),
              (i[2] = e * We),
              i
            );
          })(this.es)),
          this.mode)
        ) {
          case this.N_POLE:
          case this.S_POLE:
            this.dd = 1;
            break;
          case this.EQUIT:
            ((this.rq = Math.sqrt(0.5 * this.qp)), (this.dd = 1 / this.rq), (this.xmf = 1), (this.ymf = 0.5 * this.qp));
            break;
          case this.OBLIQ:
            ((this.rq = Math.sqrt(0.5 * this.qp)),
              (t = Math.sin(this.lat0)),
              (this.sinb1 = je(this.e, t) / this.qp),
              (this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1)),
              (this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * t * t) * this.rq * this.cosb1)),
              (this.ymf = (this.xmf = this.rq) / this.dd),
              (this.xmf *= this.dd));
        }
      else this.mode === this.OBLIQ && ((this.sinph0 = Math.sin(this.lat0)), (this.cosph0 = Math.cos(this.lat0)));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h,
        l,
        c,
        u = t.x,
        f = t.y;
      if (((u = X(u - this.long0)), this.sphere)) {
        if (
          ((r = Math.sin(f)),
          (c = Math.cos(f)),
          (s = Math.cos(u)),
          this.mode === this.OBLIQ || this.mode === this.EQUIT)
        ) {
          if ((i = this.mode === this.EQUIT ? 1 + c * s : 1 + this.sinph0 * r + this.cosph0 * c * s) <= g) return null;
          ((e = (i = Math.sqrt(2 / i)) * c * Math.sin(u)),
            (i *= this.mode === this.EQUIT ? r : this.cosph0 * r - this.sinph0 * c * s));
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
          if ((this.mode === this.N_POLE && (s = -s), Math.abs(f + this.lat0) < g)) return null;
          ((i = v - 0.5 * f),
            (e = (i = 2 * (this.mode === this.S_POLE ? Math.cos(i) : Math.sin(i))) * Math.sin(u)),
            (i *= s));
        }
      } else {
        switch (
          ((o = 0),
          (h = 0),
          (l = 0),
          (s = Math.cos(u)),
          (n = Math.sin(u)),
          (r = Math.sin(f)),
          (a = je(this.e, r)),
          (this.mode !== this.OBLIQ && this.mode !== this.EQUIT) || ((o = a / this.qp), (h = Math.sqrt(1 - o * o))),
          this.mode)
        ) {
          case this.OBLIQ:
            l = 1 + this.sinb1 * o + this.cosb1 * h * s;
            break;
          case this.EQUIT:
            l = 1 + h * s;
            break;
          case this.N_POLE:
            ((l = d + f), (a = this.qp - a));
            break;
          case this.S_POLE:
            ((l = f - d), (a = this.qp + a));
        }
        if (Math.abs(l) < g) return null;
        switch (this.mode) {
          case this.OBLIQ:
          case this.EQUIT:
            ((l = Math.sqrt(2 / l)),
              (i =
                this.mode === this.OBLIQ
                  ? this.ymf * l * (this.cosb1 * o - this.sinb1 * h * s)
                  : (l = Math.sqrt(2 / (1 + h * s))) * o * this.ymf),
              (e = this.xmf * l * h * n));
            break;
          case this.N_POLE:
          case this.S_POLE:
            a >= 0 ? ((e = (l = Math.sqrt(a)) * n), (i = s * (this.mode === this.S_POLE ? l : -l))) : (e = i = 0);
        }
      }
      return ((t.x = this.a * e + this.x0), (t.y = this.a * i + this.y0), t);
    },
    inverse: function (t) {
      ((t.x -= this.x0), (t.y -= this.y0));
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h,
        l,
        c,
        u = t.x / this.a,
        f = t.y / this.a;
      if (this.sphere) {
        var p,
          m = 0,
          y = 0;
        if ((i = 0.5 * (p = Math.sqrt(u * u + f * f))) > 1) return null;
        switch (
          ((i = 2 * Math.asin(i)),
          (this.mode !== this.OBLIQ && this.mode !== this.EQUIT) || ((y = Math.sin(i)), (m = Math.cos(i))),
          this.mode)
        ) {
          case this.EQUIT:
            ((i = Math.abs(p) <= g ? 0 : Math.asin((f * y) / p)), (u *= y), (f = m * p));
            break;
          case this.OBLIQ:
            ((i = Math.abs(p) <= g ? this.lat0 : Math.asin(m * this.sinph0 + (f * y * this.cosph0) / p)),
              (u *= y * this.cosph0),
              (f = (m - Math.sin(i) * this.sinph0) * p));
            break;
          case this.N_POLE:
            ((f = -f), (i = d - i));
            break;
          case this.S_POLE:
            i -= d;
        }
        e = 0 !== f || (this.mode !== this.EQUIT && this.mode !== this.OBLIQ) ? Math.atan2(u, f) : 0;
      } else {
        if (((o = 0), this.mode === this.OBLIQ || this.mode === this.EQUIT)) {
          if (((u /= this.dd), (f *= this.dd), (a = Math.sqrt(u * u + f * f)) < g))
            return ((t.x = this.long0), (t.y = this.lat0), t);
          ((n = 2 * Math.asin((0.5 * a) / this.rq)),
            (s = Math.cos(n)),
            (u *= n = Math.sin(n)),
            this.mode === this.OBLIQ
              ? ((o = s * this.sinb1 + (f * n * this.cosb1) / a),
                (r = this.qp * o),
                (f = a * this.cosb1 * s - f * this.sinb1 * n))
              : ((o = (f * n) / a), (r = this.qp * o), (f = a * s)));
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
          if ((this.mode === this.N_POLE && (f = -f), !(r = u * u + f * f)))
            return ((t.x = this.long0), (t.y = this.lat0), t);
          ((o = 1 - r / this.qp), this.mode === this.S_POLE && (o = -o));
        }
        ((e = Math.atan2(u, f)),
          (h = Math.asin(o)),
          (l = this.apa),
          (c = h + h),
          (i = h + l[0] * Math.sin(c) + l[1] * Math.sin(c + c) + l[2] * Math.sin(c + c + c)));
      }
      return ((t.x = X(this.long0 + e)), (t.y = i), t);
    },
    names: ['Lambert Azimuthal Equal Area', 'Lambert_Azimuthal_Equal_Area', 'laea'],
    S_POLE: 1,
    N_POLE: 2,
    EQUIT: 3,
    OBLIQ: 4,
  };
  function Xe(t) {
    return (Math.abs(t) > 1 && (t = t > 1 ? 1 : -1), Math.asin(t));
  }
  var Ye = {
    init: function () {
      Math.abs(this.lat1 + this.lat2) < g ||
        ((this.temp = this.b / this.a),
        (this.es = 1 - Math.pow(this.temp, 2)),
        (this.e3 = Math.sqrt(this.es)),
        (this.sin_po = Math.sin(this.lat1)),
        (this.cos_po = Math.cos(this.lat1)),
        (this.t1 = this.sin_po),
        (this.con = this.sin_po),
        (this.ms1 = W(this.e3, this.sin_po, this.cos_po)),
        (this.qs1 = je(this.e3, this.sin_po)),
        (this.sin_po = Math.sin(this.lat2)),
        (this.cos_po = Math.cos(this.lat2)),
        (this.t2 = this.sin_po),
        (this.ms2 = W(this.e3, this.sin_po, this.cos_po)),
        (this.qs2 = je(this.e3, this.sin_po)),
        (this.sin_po = Math.sin(this.lat0)),
        (this.cos_po = Math.cos(this.lat0)),
        (this.t3 = this.sin_po),
        (this.qs0 = je(this.e3, this.sin_po)),
        Math.abs(this.lat1 - this.lat2) > g
          ? (this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1))
          : (this.ns0 = this.con),
        (this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1),
        (this.rh = (this.a * Math.sqrt(this.c - this.ns0 * this.qs0)) / this.ns0));
    },
    forward: function (t) {
      var e = t.x,
        i = t.y;
      ((this.sin_phi = Math.sin(i)), (this.cos_phi = Math.cos(i)));
      var s = je(this.e3, this.sin_phi),
        n = (this.a * Math.sqrt(this.c - this.ns0 * s)) / this.ns0,
        r = this.ns0 * X(e - this.long0),
        a = n * Math.sin(r) + this.x0,
        o = this.rh - n * Math.cos(r) + this.y0;
      return ((t.x = a), (t.y = o), t);
    },
    inverse: function (t) {
      var e, i, s, n, r, a;
      return (
        (t.x -= this.x0),
        (t.y = this.rh - t.y + this.y0),
        this.ns0 >= 0
          ? ((e = Math.sqrt(t.x * t.x + t.y * t.y)), (s = 1))
          : ((e = -Math.sqrt(t.x * t.x + t.y * t.y)), (s = -1)),
        (n = 0),
        0 !== e && (n = Math.atan2(s * t.x, s * t.y)),
        (s = (e * this.ns0) / this.a),
        this.sphere
          ? (a = Math.asin((this.c - s * s) / (2 * this.ns0)))
          : ((i = (this.c - s * s) / this.ns0), (a = this.phi1z(this.e3, i))),
        (r = X(n / this.ns0 + this.long0)),
        (t.x = r),
        (t.y = a),
        t
      );
    },
    names: ['Albers_Conic_Equal_Area', 'Albers', 'aea'],
    phi1z: function (t, e) {
      var i,
        s,
        n,
        r,
        a = Xe(0.5 * e);
      if (t < g) return a;
      for (var o = t * t, h = 1; h <= 25; h++)
        if (
          ((a += r =
            ((0.5 * (n = 1 - (s = t * (i = Math.sin(a))) * s) * n) / Math.cos(a)) *
            (e / (1 - o) - i / n + (0.5 / t) * Math.log((1 - s) / (1 + s)))),
          Math.abs(r) <= 1e-7)
        )
          return a;
      return null;
    },
  };
  var Ze = {
    init: function () {
      ((this.sin_p14 = Math.sin(this.lat0)),
        (this.cos_p14 = Math.cos(this.lat0)),
        (this.infinity_dist = 1e3 * this.a),
        (this.rc = 1));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h = t.x,
        l = t.y;
      return (
        (s = X(h - this.long0)),
        (e = Math.sin(l)),
        (i = Math.cos(l)),
        (n = Math.cos(s)),
        (r = this.sin_p14 * e + this.cos_p14 * i * n) > 0 || Math.abs(r) <= g
          ? ((a = this.x0 + (1 * this.a * i * Math.sin(s)) / r),
            (o = this.y0 + (1 * this.a * (this.cos_p14 * e - this.sin_p14 * i * n)) / r))
          : ((a = this.x0 + this.infinity_dist * i * Math.sin(s)),
            (o = this.y0 + this.infinity_dist * (this.cos_p14 * e - this.sin_p14 * i * n))),
        (t.x = a),
        (t.y = o),
        t
      );
    },
    inverse: function (t) {
      var e, i, s, n, r, a;
      return (
        (t.x = (t.x - this.x0) / this.a),
        (t.y = (t.y - this.y0) / this.a),
        (t.x /= this.k0),
        (t.y /= this.k0),
        (e = Math.sqrt(t.x * t.x + t.y * t.y))
          ? ((n = Math.atan2(e, this.rc)),
            (i = Math.sin(n)),
            (a = Xe((s = Math.cos(n)) * this.sin_p14 + (t.y * i * this.cos_p14) / e)),
            (r = Math.atan2(t.x * i, e * this.cos_p14 * s - t.y * this.sin_p14 * i)),
            (r = X(this.long0 + r)))
          : ((a = this.phic0), (r = 0)),
        (t.x = r),
        (t.y = a),
        t
      );
    },
    names: ['gnom'],
  };
  var Je = {
    init: function () {
      this.sphere || (this.k0 = W(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
    },
    forward: function (t) {
      var e,
        i,
        s = t.x,
        n = t.y,
        r = X(s - this.long0);
      if (this.sphere)
        ((e = this.x0 + this.a * r * Math.cos(this.lat_ts)),
          (i = this.y0 + (this.a * Math.sin(n)) / Math.cos(this.lat_ts)));
      else {
        var a = je(this.e, Math.sin(n));
        ((e = this.x0 + this.a * this.k0 * r), (i = this.y0 + (this.a * a * 0.5) / this.k0));
      }
      return ((t.x = e), (t.y = i), t);
    },
    inverse: function (t) {
      var e, i;
      return (
        (t.x -= this.x0),
        (t.y -= this.y0),
        this.sphere
          ? ((e = X(this.long0 + t.x / this.a / Math.cos(this.lat_ts))),
            (i = Math.asin((t.y / this.a) * Math.cos(this.lat_ts))))
          : ((i = (function (t, e) {
              var i = 1 - ((1 - t * t) / (2 * t)) * Math.log((1 - t) / (1 + t));
              if (Math.abs(Math.abs(e) - i) < 1e-6) return e < 0 ? -1 * d : d;
              for (var s, n, r, a, o = Math.asin(0.5 * e), h = 0; h < 30; h++)
                if (
                  ((n = Math.sin(o)),
                  (r = Math.cos(o)),
                  (a = t * n),
                  (o += s =
                    (Math.pow(1 - a * a, 2) / (2 * r)) *
                    (e / (1 - t * t) - n / (1 - a * a) + (0.5 / t) * Math.log((1 - a) / (1 + a)))),
                  Math.abs(s) <= 1e-10)
                )
                  return o;
              return NaN;
            })(this.e, (2 * t.y * this.k0) / this.a)),
            (e = X(this.long0 + t.x / (this.a * this.k0)))),
        (t.x = e),
        (t.y = i),
        t
      );
    },
    names: ['cea'],
  };
  var $e = {
    init: function () {
      ((this.x0 = this.x0 || 0),
        (this.y0 = this.y0 || 0),
        (this.lat0 = this.lat0 || 0),
        (this.long0 = this.long0 || 0),
        (this.lat_ts = this.lat_ts || 0),
        (this.title = this.title || 'Equidistant Cylindrical (Plate Carre)'),
        (this.rc = Math.cos(this.lat_ts)));
    },
    forward: function (t) {
      var e = t.x,
        i = t.y,
        s = X(e - this.long0),
        n = Le(i - this.lat0);
      return ((t.x = this.x0 + this.a * s * this.rc), (t.y = this.y0 + this.a * n), t);
    },
    inverse: function (t) {
      var e = t.x,
        i = t.y;
      return (
        (t.x = X(this.long0 + (e - this.x0) / (this.a * this.rc))),
        (t.y = Le(this.lat0 + (i - this.y0) / this.a)),
        t
      );
    },
    names: ['Equirectangular', 'Equidistant_Cylindrical', 'eqc'],
  };
  var ti = {
    init: function () {
      ((this.temp = this.b / this.a),
        (this.es = 1 - Math.pow(this.temp, 2)),
        (this.e = Math.sqrt(this.es)),
        (this.e0 = Re(this.es)),
        (this.e1 = Ne(this.es)),
        (this.e2 = Be(this.es)),
        (this.e3 = ke(this.es)),
        (this.ml0 = this.a * _e(this.e0, this.e1, this.e2, this.e3, this.lat0)));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n = t.x,
        r = t.y,
        a = X(n - this.long0);
      if (((s = a * Math.sin(r)), this.sphere))
        Math.abs(r) <= g
          ? ((e = this.a * a), (i = -1 * this.a * this.lat0))
          : ((e = (this.a * Math.sin(s)) / Math.tan(r)),
            (i = this.a * (Le(r - this.lat0) + (1 - Math.cos(s)) / Math.tan(r))));
      else if (Math.abs(r) <= g) ((e = this.a * a), (i = -1 * this.ml0));
      else {
        var o = ze(this.a, this.e, Math.sin(r)) / Math.tan(r);
        ((e = o * Math.sin(s)),
          (i = this.a * _e(this.e0, this.e1, this.e2, this.e3, r) - this.ml0 + o * (1 - Math.cos(s))));
      }
      return ((t.x = e + this.x0), (t.y = i + this.y0), t);
    },
    inverse: function (t) {
      var e, i, s, n, r, a, o, h, l;
      if (((s = t.x - this.x0), (n = t.y - this.y0), this.sphere))
        if (Math.abs(n + this.a * this.lat0) <= g) ((e = X(s / this.a + this.long0)), (i = 0));
        else {
          var c;
          for (a = this.lat0 + n / this.a, o = (s * s) / this.a / this.a + a * a, h = a, r = 20; r; --r)
            if (
              ((h += l = (-1 * (a * (h * (c = Math.tan(h)) + 1) - h - 0.5 * (h * h + o) * c)) / ((h - a) / c - 1)),
              Math.abs(l) <= g)
            ) {
              i = h;
              break;
            }
          e = X(this.long0 + Math.asin((s * Math.tan(h)) / this.a) / Math.sin(i));
        }
      else if (Math.abs(n + this.ml0) <= g) ((i = 0), (e = X(this.long0 + s / this.a)));
      else {
        var u, d, f, p, m;
        for (a = (this.ml0 + n) / this.a, o = (s * s) / this.a / this.a + a * a, h = a, r = 20; r; --r)
          if (
            ((m = this.e * Math.sin(h)),
            (u = Math.sqrt(1 - m * m) * Math.tan(h)),
            (d = this.a * _e(this.e0, this.e1, this.e2, this.e3, h)),
            (f =
              this.e0 - 2 * this.e1 * Math.cos(2 * h) + 4 * this.e2 * Math.cos(4 * h) - 6 * this.e3 * Math.cos(6 * h)),
            (h -= l =
              (a * (u * (p = d / this.a) + 1) - p - 0.5 * u * (p * p + o)) /
              ((this.es * Math.sin(2 * h) * (p * p + o - 2 * a * p)) / (4 * u) +
                (a - p) * (u * f - 2 / Math.sin(2 * h)) -
                f)),
            Math.abs(l) <= g)
          ) {
            i = h;
            break;
          }
        ((u = Math.sqrt(1 - this.es * Math.pow(Math.sin(i), 2)) * Math.tan(i)),
          (e = X(this.long0 + Math.asin((s * u) / this.a) / Math.sin(i))));
      }
      return ((t.x = e), (t.y = i), t);
    },
    names: ['Polyconic', 'poly'],
  };
  var ei = {
    init: function () {
      ((this.A = []),
        (this.A[1] = 0.6399175073),
        (this.A[2] = -0.1358797613),
        (this.A[3] = 0.063294409),
        (this.A[4] = -0.02526853),
        (this.A[5] = 0.0117879),
        (this.A[6] = -0.0055161),
        (this.A[7] = 0.0026906),
        (this.A[8] = -0.001333),
        (this.A[9] = 67e-5),
        (this.A[10] = -34e-5),
        (this.B_re = []),
        (this.B_im = []),
        (this.B_re[1] = 0.7557853228),
        (this.B_im[1] = 0),
        (this.B_re[2] = 0.249204646),
        (this.B_im[2] = 0.003371507),
        (this.B_re[3] = -0.001541739),
        (this.B_im[3] = 0.04105856),
        (this.B_re[4] = -0.10162907),
        (this.B_im[4] = 0.01727609),
        (this.B_re[5] = -0.26623489),
        (this.B_im[5] = -0.36249218),
        (this.B_re[6] = -0.6870983),
        (this.B_im[6] = -1.1651967),
        (this.C_re = []),
        (this.C_im = []),
        (this.C_re[1] = 1.3231270439),
        (this.C_im[1] = 0),
        (this.C_re[2] = -0.577245789),
        (this.C_im[2] = -0.007809598),
        (this.C_re[3] = 0.508307513),
        (this.C_im[3] = -0.112208952),
        (this.C_re[4] = -0.15094762),
        (this.C_im[4] = 0.18200602),
        (this.C_re[5] = 1.01418179),
        (this.C_im[5] = 1.64497696),
        (this.C_re[6] = 1.9660549),
        (this.C_im[6] = 2.5127645),
        (this.D = []),
        (this.D[1] = 1.5627014243),
        (this.D[2] = 0.5185406398),
        (this.D[3] = -0.03333098),
        (this.D[4] = -0.1052906),
        (this.D[5] = -0.0368594),
        (this.D[6] = 0.007317),
        (this.D[7] = 0.0122),
        (this.D[8] = 0.00394),
        (this.D[9] = -0.0013));
    },
    forward: function (t) {
      var e,
        i = t.x,
        s = t.y - this.lat0,
        n = i - this.long0,
        r = (s / u) * 1e-5,
        a = n,
        o = 1,
        h = 0;
      for (e = 1; e <= 10; e++) ((o *= r), (h += this.A[e] * o));
      var l,
        c = h,
        d = a,
        f = 1,
        p = 0,
        m = 0,
        g = 0;
      for (e = 1; e <= 6; e++)
        ((l = p * c + f * d),
          (f = f * c - p * d),
          (p = l),
          (m = m + this.B_re[e] * f - this.B_im[e] * p),
          (g = g + this.B_im[e] * f + this.B_re[e] * p));
      return ((t.x = g * this.a + this.x0), (t.y = m * this.a + this.y0), t);
    },
    inverse: function (t) {
      var e,
        i,
        s = t.x,
        n = t.y,
        r = s - this.x0,
        a = (n - this.y0) / this.a,
        o = r / this.a,
        h = 1,
        l = 0,
        c = 0,
        d = 0;
      for (e = 1; e <= 6; e++)
        ((i = l * a + h * o),
          (h = h * a - l * o),
          (l = i),
          (c = c + this.C_re[e] * h - this.C_im[e] * l),
          (d = d + this.C_im[e] * h + this.C_re[e] * l));
      for (var f = 0; f < this.iterations; f++) {
        var p,
          m = c,
          g = d,
          y = a,
          x = o;
        for (e = 2; e <= 6; e++)
          ((p = g * c + m * d),
            (m = m * c - g * d),
            (g = p),
            (y += (e - 1) * (this.B_re[e] * m - this.B_im[e] * g)),
            (x += (e - 1) * (this.B_im[e] * m + this.B_re[e] * g)));
        ((m = 1), (g = 0));
        var v = this.B_re[1],
          b = this.B_im[1];
        for (e = 2; e <= 6; e++)
          ((p = g * c + m * d),
            (m = m * c - g * d),
            (g = p),
            (v += e * (this.B_re[e] * m - this.B_im[e] * g)),
            (b += e * (this.B_im[e] * m + this.B_re[e] * g)));
        var w = v * v + b * b;
        ((c = (y * v + x * b) / w), (d = (x * v - y * b) / w));
      }
      var S = c,
        M = d,
        C = 1,
        E = 0;
      for (e = 1; e <= 9; e++) ((C *= S), (E += this.D[e] * C));
      var D = this.lat0 + E * u * 1e5,
        A = this.long0 + M;
      return ((t.x = A), (t.y = D), t);
    },
    names: ['New_Zealand_Map_Grid', 'nzmg'],
  };
  var ii = {
    init: function () {},
    forward: function (t) {
      var e = t.x,
        i = t.y,
        s = X(e - this.long0),
        n = this.x0 + this.a * s,
        r = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + i / 2.5)) * 1.25;
      return ((t.x = n), (t.y = r), t);
    },
    inverse: function (t) {
      ((t.x -= this.x0), (t.y -= this.y0));
      var e = X(this.long0 + t.x / this.a),
        i = 2.5 * (Math.atan(Math.exp((0.8 * t.y) / this.a)) - Math.PI / 4);
      return ((t.x = e), (t.y = i), t);
    },
    names: ['Miller_Cylindrical', 'mill'],
  };
  var si = {
    init: function () {
      this.sphere
        ? ((this.n = 1),
          (this.m = 0),
          (this.es = 0),
          (this.C_y = Math.sqrt((this.m + 1) / this.n)),
          (this.C_x = this.C_y / (this.m + 1)))
        : (this.en = ue(this.es));
    },
    forward: function (t) {
      var e,
        i,
        s = t.x,
        n = t.y;
      if (((s = X(s - this.long0)), this.sphere)) {
        if (this.m)
          for (var r = this.n * Math.sin(n), a = 20; a; --a) {
            var o = (this.m * n + Math.sin(n) - r) / (this.m + Math.cos(n));
            if (((n -= o), Math.abs(o) < g)) break;
          }
        else n = 1 !== this.n ? Math.asin(this.n * Math.sin(n)) : n;
        ((e = this.a * this.C_x * s * (this.m + Math.cos(n))), (i = this.a * this.C_y * n));
      } else {
        var h = Math.sin(n),
          l = Math.cos(n);
        ((i = this.a * de(n, h, l, this.en)), (e = (this.a * s * l) / Math.sqrt(1 - this.es * h * h)));
      }
      return ((t.x = e), (t.y = i), t);
    },
    inverse: function (t) {
      var e, i, s;
      return (
        (t.x -= this.x0),
        (i = t.x / this.a),
        (t.y -= this.y0),
        (e = t.y / this.a),
        this.sphere
          ? ((e /= this.C_y),
            (i /= this.C_x * (this.m + Math.cos(e))),
            this.m ? (e = Xe((this.m * e + Math.sin(e)) / this.n)) : 1 !== this.n && (e = Xe(Math.sin(e) / this.n)),
            (i = X(i + this.long0)),
            (e = Le(e)))
          : ((e = pe(t.y / this.a, this.es, this.en)),
            (s = Math.abs(e)) < d
              ? ((s = Math.sin(e)),
                (i = X(this.long0 + (t.x * Math.sqrt(1 - this.es * s * s)) / (this.a * Math.cos(e)))))
              : s - g < d && (i = this.long0)),
        (t.x = i),
        (t.y = e),
        t
      );
    },
    names: ['Sinusoidal', 'sinu'],
  };
  var ni = {
    init: function () {},
    forward: function (t) {
      for (var e = t.x, i = t.y, s = X(e - this.long0), n = i, r = Math.PI * Math.sin(i); ; ) {
        var a = -(n + Math.sin(n) - r) / (1 + Math.cos(n));
        if (((n += a), Math.abs(a) < g)) break;
      }
      ((n /= 2), Math.PI / 2 - Math.abs(i) < g && (s = 0));
      var o = 0.900316316158 * this.a * s * Math.cos(n) + this.x0,
        h = 1.4142135623731 * this.a * Math.sin(n) + this.y0;
      return ((t.x = o), (t.y = h), t);
    },
    inverse: function (t) {
      var e, i;
      ((t.x -= this.x0),
        (t.y -= this.y0),
        (i = t.y / (1.4142135623731 * this.a)),
        Math.abs(i) > 0.999999999999 && (i = 0.999999999999),
        (e = Math.asin(i)));
      var s = X(this.long0 + t.x / (0.900316316158 * this.a * Math.cos(e)));
      (s < -Math.PI && (s = -Math.PI),
        s > Math.PI && (s = Math.PI),
        (i = (2 * e + Math.sin(2 * e)) / Math.PI),
        Math.abs(i) > 1 && (i = 1));
      var n = Math.asin(i);
      return ((t.x = s), (t.y = n), t);
    },
    names: ['Mollweide', 'moll'],
  };
  var ri = {
    init: function () {
      Math.abs(this.lat1 + this.lat2) < g ||
        ((this.lat2 = this.lat2 || this.lat1),
        (this.temp = this.b / this.a),
        (this.es = 1 - Math.pow(this.temp, 2)),
        (this.e = Math.sqrt(this.es)),
        (this.e0 = Re(this.es)),
        (this.e1 = Ne(this.es)),
        (this.e2 = Be(this.es)),
        (this.e3 = ke(this.es)),
        (this.sinphi = Math.sin(this.lat1)),
        (this.cosphi = Math.cos(this.lat1)),
        (this.ms1 = W(this.e, this.sinphi, this.cosphi)),
        (this.ml1 = _e(this.e0, this.e1, this.e2, this.e3, this.lat1)),
        Math.abs(this.lat1 - this.lat2) < g
          ? (this.ns = this.sinphi)
          : ((this.sinphi = Math.sin(this.lat2)),
            (this.cosphi = Math.cos(this.lat2)),
            (this.ms2 = W(this.e, this.sinphi, this.cosphi)),
            (this.ml2 = _e(this.e0, this.e1, this.e2, this.e3, this.lat2)),
            (this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1))),
        (this.g = this.ml1 + this.ms1 / this.ns),
        (this.ml0 = _e(this.e0, this.e1, this.e2, this.e3, this.lat0)),
        (this.rh = this.a * (this.g - this.ml0)));
    },
    forward: function (t) {
      var e,
        i = t.x,
        s = t.y;
      if (this.sphere) e = this.a * (this.g - s);
      else {
        var n = _e(this.e0, this.e1, this.e2, this.e3, s);
        e = this.a * (this.g - n);
      }
      var r = this.ns * X(i - this.long0),
        a = this.x0 + e * Math.sin(r),
        o = this.y0 + this.rh - e * Math.cos(r);
      return ((t.x = a), (t.y = o), t);
    },
    inverse: function (t) {
      var e, i, s, n;
      ((t.x -= this.x0),
        (t.y = this.rh - t.y + this.y0),
        this.ns >= 0
          ? ((i = Math.sqrt(t.x * t.x + t.y * t.y)), (e = 1))
          : ((i = -Math.sqrt(t.x * t.x + t.y * t.y)), (e = -1)));
      var r = 0;
      return (
        0 !== i && (r = Math.atan2(e * t.x, e * t.y)),
        this.sphere
          ? ((n = X(this.long0 + r / this.ns)), (s = Le(this.g - i / this.a)), (t.x = n), (t.y = s), t)
          : ((s = Oe(this.g - i / this.a, this.e0, this.e1, this.e2, this.e3)),
            (n = X(this.long0 + r / this.ns)),
            (t.x = n),
            (t.y = s),
            t)
      );
    },
    names: ['Equidistant_Conic', 'eqdc'],
  };
  var ai = {
    init: function () {
      this.R = this.a;
    },
    forward: function (t) {
      var e,
        i,
        s = t.x,
        n = t.y,
        r = X(s - this.long0);
      Math.abs(n) <= g && ((e = this.x0 + this.R * r), (i = this.y0));
      var a = Xe(2 * Math.abs(n / Math.PI));
      (Math.abs(r) <= g || Math.abs(Math.abs(n) - d) <= g) &&
        ((e = this.x0),
        (i =
          n >= 0 ? this.y0 + Math.PI * this.R * Math.tan(0.5 * a) : this.y0 + Math.PI * this.R * -Math.tan(0.5 * a)));
      var o = 0.5 * Math.abs(Math.PI / r - r / Math.PI),
        h = o * o,
        l = Math.sin(a),
        c = Math.cos(a),
        u = c / (l + c - 1),
        f = u * u,
        p = u * (2 / l - 1),
        m = p * p,
        y = (Math.PI * this.R * (o * (u - m) + Math.sqrt(h * (u - m) * (u - m) - (m + h) * (f - m)))) / (m + h);
      (r < 0 && (y = -y), (e = this.x0 + y));
      var x = h + u;
      return (
        (y = (Math.PI * this.R * (p * x - o * Math.sqrt((m + h) * (h + 1) - x * x))) / (m + h)),
        (i = n >= 0 ? this.y0 + y : this.y0 - y),
        (t.x = e),
        (t.y = i),
        t
      );
    },
    inverse: function (t) {
      var e, i, s, n, r, a, o, h, l, c, u, d;
      return (
        (t.x -= this.x0),
        (t.y -= this.y0),
        (u = Math.PI * this.R),
        (r = (s = t.x / u) * s + (n = t.y / u) * n),
        (u =
          (3 *
            ((n * n) / (h = -2 * (a = -Math.abs(n) * (1 + r)) + 1 + 2 * n * n + r * r) +
              ((2 * (o = a - 2 * n * n + s * s) * o * o) / h / h / h - (9 * a * o) / h / h) / 27)) /
          (l = (a - (o * o) / 3 / h) / h) /
          (c = 2 * Math.sqrt(-l / 3))),
        Math.abs(u) > 1 && (u = u >= 0 ? 1 : -1),
        (d = Math.acos(u) / 3),
        (i =
          t.y >= 0
            ? (-c * Math.cos(d + Math.PI / 3) - o / 3 / h) * Math.PI
            : -(-c * Math.cos(d + Math.PI / 3) - o / 3 / h) * Math.PI),
        (e =
          Math.abs(s) < g
            ? this.long0
            : X(this.long0 + (Math.PI * (r - 1 + Math.sqrt(1 + 2 * (s * s - n * n) + r * r))) / 2 / s)),
        (t.x = e),
        (t.y = i),
        t
      );
    },
    names: ['Van_der_Grinten_I', 'VanDerGrinten', 'vandg'],
  };
  var oi = {
    init: function () {
      ((this.sin_p12 = Math.sin(this.lat0)), (this.cos_p12 = Math.cos(this.lat0)));
    },
    forward: function (t) {
      var e,
        i,
        s,
        n,
        r,
        a,
        o,
        h,
        l,
        c,
        u,
        f,
        p,
        m,
        y,
        x,
        v,
        b,
        w,
        S,
        M,
        C,
        E = t.x,
        D = t.y,
        A = Math.sin(t.y),
        F = Math.cos(t.y),
        P = X(E - this.long0);
      return this.sphere
        ? Math.abs(this.sin_p12 - 1) <= g
          ? ((t.x = this.x0 + this.a * (d - D) * Math.sin(P)), (t.y = this.y0 - this.a * (d - D) * Math.cos(P)), t)
          : Math.abs(this.sin_p12 + 1) <= g
            ? ((t.x = this.x0 + this.a * (d + D) * Math.sin(P)), (t.y = this.y0 + this.a * (d + D) * Math.cos(P)), t)
            : ((b = this.sin_p12 * A + this.cos_p12 * F * Math.cos(P)),
              (v = (x = Math.acos(b)) ? x / Math.sin(x) : 1),
              (t.x = this.x0 + this.a * v * F * Math.sin(P)),
              (t.y = this.y0 + this.a * v * (this.cos_p12 * A - this.sin_p12 * F * Math.cos(P))),
              t)
        : ((e = Re(this.es)),
          (i = Ne(this.es)),
          (s = Be(this.es)),
          (n = ke(this.es)),
          Math.abs(this.sin_p12 - 1) <= g
            ? ((r = this.a * _e(e, i, s, n, d)),
              (a = this.a * _e(e, i, s, n, D)),
              (t.x = this.x0 + (r - a) * Math.sin(P)),
              (t.y = this.y0 - (r - a) * Math.cos(P)),
              t)
            : Math.abs(this.sin_p12 + 1) <= g
              ? ((r = this.a * _e(e, i, s, n, d)),
                (a = this.a * _e(e, i, s, n, D)),
                (t.x = this.x0 + (r + a) * Math.sin(P)),
                (t.y = this.y0 + (r + a) * Math.cos(P)),
                t)
              : ((o = A / F),
                (h = ze(this.a, this.e, this.sin_p12)),
                (l = ze(this.a, this.e, A)),
                (c = Math.atan((1 - this.es) * o + (this.es * h * this.sin_p12) / (l * F))),
                (w =
                  0 === (u = Math.atan2(Math.sin(P), this.cos_p12 * Math.tan(c) - this.sin_p12 * Math.cos(P)))
                    ? Math.asin(this.cos_p12 * Math.sin(c) - this.sin_p12 * Math.cos(c))
                    : Math.abs(Math.abs(u) - Math.PI) <= g
                      ? -Math.asin(this.cos_p12 * Math.sin(c) - this.sin_p12 * Math.cos(c))
                      : Math.asin((Math.sin(P) * Math.cos(c)) / Math.sin(u))),
                (f = (this.e * this.sin_p12) / Math.sqrt(1 - this.es)),
                (x =
                  h *
                  w *
                  (1 -
                    ((S = w * w) *
                      (y = (p = (this.e * this.cos_p12 * Math.cos(u)) / Math.sqrt(1 - this.es)) * p) *
                      (1 - y)) /
                      6 +
                    ((M = S * w) / 8) * (m = f * p) * (1 - 2 * y) +
                    ((C = M * w) / 120) * (y * (4 - 7 * y) - 3 * f * f * (1 - 7 * y)) -
                    ((C * w) / 48) * m)),
                (t.x = this.x0 + x * Math.sin(u)),
                (t.y = this.y0 + x * Math.cos(u)),
                t));
    },
    inverse: function (t) {
      var e, i, s, n, r, a, o, h, l, c, u, f, p, m, y, x, v, b, w, S, M, C, E;
      if (((t.x -= this.x0), (t.y -= this.y0), this.sphere)) {
        if ((e = Math.sqrt(t.x * t.x + t.y * t.y)) > 2 * d * this.a) return;
        return (
          (i = e / this.a),
          (s = Math.sin(i)),
          (n = Math.cos(i)),
          (r = this.long0),
          Math.abs(e) <= g
            ? (a = this.lat0)
            : ((a = Xe(n * this.sin_p12 + (t.y * s * this.cos_p12) / e)),
              (o = Math.abs(this.lat0) - d),
              (r =
                Math.abs(o) <= g
                  ? this.lat0 >= 0
                    ? X(this.long0 + Math.atan2(t.x, -t.y))
                    : X(this.long0 - Math.atan2(-t.x, t.y))
                  : X(this.long0 + Math.atan2(t.x * s, e * this.cos_p12 * n - t.y * this.sin_p12 * s)))),
          (t.x = r),
          (t.y = a),
          t
        );
      }
      return (
        (h = Re(this.es)),
        (l = Ne(this.es)),
        (c = Be(this.es)),
        (u = ke(this.es)),
        Math.abs(this.sin_p12 - 1) <= g
          ? ((a = Oe(((f = this.a * _e(h, l, c, u, d)) - (e = Math.sqrt(t.x * t.x + t.y * t.y))) / this.a, h, l, c, u)),
            (r = X(this.long0 + Math.atan2(t.x, -1 * t.y))),
            (t.x = r),
            (t.y = a),
            t)
          : Math.abs(this.sin_p12 + 1) <= g
            ? ((f = this.a * _e(h, l, c, u, d)),
              (a = Oe(((e = Math.sqrt(t.x * t.x + t.y * t.y)) - f) / this.a, h, l, c, u)),
              (r = X(this.long0 + Math.atan2(t.x, t.y))),
              (t.x = r),
              (t.y = a),
              t)
            : ((e = Math.sqrt(t.x * t.x + t.y * t.y)),
              (y = Math.atan2(t.x, t.y)),
              (p = ze(this.a, this.e, this.sin_p12)),
              (x = Math.cos(y)),
              (b = (-(v = this.e * this.cos_p12 * x) * v) / (1 - this.es)),
              (w = (3 * this.es * (1 - b) * this.sin_p12 * this.cos_p12 * x) / (1 - this.es)),
              (C =
                1 -
                (b *
                  (M = (S = e / p) - (b * (1 + b) * Math.pow(S, 3)) / 6 - (w * (1 + 3 * b) * Math.pow(S, 4)) / 24) *
                  M) /
                  2 -
                (S * M * M * M) / 6),
              (m = Math.asin(this.sin_p12 * Math.cos(M) + this.cos_p12 * Math.sin(M) * x)),
              (r = X(this.long0 + Math.asin((Math.sin(y) * Math.sin(M)) / Math.cos(m)))),
              (E = Math.sin(m)),
              (a = Math.atan2((E - this.es * C * this.sin_p12) * Math.tan(m), E * (1 - this.es))),
              (t.x = r),
              (t.y = a),
              t)
      );
    },
    names: ['Azimuthal_Equidistant', 'aeqd'],
  };
  var hi = {
      init: function () {
        ((this.sin_p14 = Math.sin(this.lat0)), (this.cos_p14 = Math.cos(this.lat0)));
      },
      forward: function (t) {
        var e,
          i,
          s,
          n,
          r,
          a,
          o,
          h = t.x,
          l = t.y;
        return (
          (s = X(h - this.long0)),
          (e = Math.sin(l)),
          (i = Math.cos(l)),
          (n = Math.cos(s)),
          ((r = this.sin_p14 * e + this.cos_p14 * i * n) > 0 || Math.abs(r) <= g) &&
            ((a = 1 * this.a * i * Math.sin(s)),
            (o = this.y0 + 1 * this.a * (this.cos_p14 * e - this.sin_p14 * i * n))),
          (t.x = a),
          (t.y = o),
          t
        );
      },
      inverse: function (t) {
        var e, i, s, n, r, a, o;
        return (
          (t.x -= this.x0),
          (t.y -= this.y0),
          (i = Xe((e = Math.sqrt(t.x * t.x + t.y * t.y)) / this.a)),
          (s = Math.sin(i)),
          (n = Math.cos(i)),
          (a = this.long0),
          Math.abs(e) <= g
            ? ((o = this.lat0), (t.x = a), (t.y = o), t)
            : ((o = Xe(n * this.sin_p14 + (t.y * s * this.cos_p14) / e)),
              (r = Math.abs(this.lat0) - d),
              Math.abs(r) <= g
                ? ((a = this.lat0 >= 0 ? X(this.long0 + Math.atan2(t.x, -t.y)) : X(this.long0 - Math.atan2(-t.x, t.y))),
                  (t.x = a),
                  (t.y = o),
                  t)
                : ((a = X(this.long0 + Math.atan2(t.x * s, e * this.cos_p14 * n - t.y * this.sin_p14 * s))),
                  (t.x = a),
                  (t.y = o),
                  t))
        );
      },
      names: ['ortho'],
    },
    li = 1,
    ci = 2,
    ui = 3,
    di = 4,
    fi = 5,
    pi = 6,
    mi = { AREA_0: 1, AREA_1: 2, AREA_2: 3, AREA_3: 4 };
  function gi(t, e, i, s) {
    var n;
    return (
      t < g
        ? ((s.value = mi.AREA_0), (n = 0))
        : ((n = Math.atan2(e, i)),
          Math.abs(n) <= v
            ? (s.value = mi.AREA_0)
            : n > v && n <= d + v
              ? ((s.value = mi.AREA_1), (n -= d))
              : n > d + v || n <= -(d + v)
                ? ((s.value = mi.AREA_2), (n = n >= 0 ? n - w : n + w))
                : ((s.value = mi.AREA_3), (n += d))),
      n
    );
  }
  function yi(t, e) {
    var i = t + e;
    return (i < -w ? (i += b) : i > +w && (i -= b), i);
  }
  var xi = {
      init: function () {
        ((this.x0 = this.x0 || 0),
          (this.y0 = this.y0 || 0),
          (this.lat0 = this.lat0 || 0),
          (this.long0 = this.long0 || 0),
          (this.lat_ts = this.lat_ts || 0),
          (this.title = this.title || 'Quadrilateralized Spherical Cube'),
          this.lat0 >= d - v / 2
            ? (this.face = fi)
            : this.lat0 <= -(d - v / 2)
              ? (this.face = pi)
              : Math.abs(this.long0) <= v
                ? (this.face = li)
                : Math.abs(this.long0) <= d + v
                  ? (this.face = this.long0 > 0 ? ci : di)
                  : (this.face = ui),
          0 !== this.es &&
            ((this.one_minus_f = 1 - (this.a - this.b) / this.a),
            (this.one_minus_f_squared = this.one_minus_f * this.one_minus_f)));
      },
      forward: function (t) {
        var e,
          i,
          s,
          n,
          r,
          a,
          o = { x: 0, y: 0 },
          h = { value: 0 };
        if (
          ((t.x -= this.long0),
          (e = 0 !== this.es ? Math.atan(this.one_minus_f_squared * Math.tan(t.y)) : t.y),
          (i = t.x),
          this.face === fi)
        )
          ((n = d - e),
            i >= v && i <= d + v
              ? ((h.value = mi.AREA_0), (s = i - d))
              : i > d + v || i <= -(d + v)
                ? ((h.value = mi.AREA_1), (s = i > 0 ? i - w : i + w))
                : i > -(d + v) && i <= -v
                  ? ((h.value = mi.AREA_2), (s = i + d))
                  : ((h.value = mi.AREA_3), (s = i)));
        else if (this.face === pi)
          ((n = d + e),
            i >= v && i <= d + v
              ? ((h.value = mi.AREA_0), (s = -i + d))
              : i < v && i >= -v
                ? ((h.value = mi.AREA_1), (s = -i))
                : i < -v && i >= -(d + v)
                  ? ((h.value = mi.AREA_2), (s = -i - d))
                  : ((h.value = mi.AREA_3), (s = i > 0 ? -i + w : -i - w)));
        else {
          var l, c, u, f, p, m;
          (this.face === ci
            ? (i = yi(i, +d))
            : this.face === ui
              ? (i = yi(i, +w))
              : this.face === di && (i = yi(i, -d)),
            (f = Math.sin(e)),
            (p = Math.cos(e)),
            (m = Math.sin(i)),
            (l = p * Math.cos(i)),
            (c = p * m),
            (u = f),
            this.face === li
              ? (s = gi((n = Math.acos(l)), u, c, h))
              : this.face === ci
                ? (s = gi((n = Math.acos(c)), u, -l, h))
                : this.face === ui
                  ? (s = gi((n = Math.acos(-l)), u, -c, h))
                  : this.face === di
                    ? (s = gi((n = Math.acos(-c)), u, l, h))
                    : ((n = s = 0), (h.value = mi.AREA_0)));
        }
        return (
          (a = Math.atan((12 / w) * (s + Math.acos(Math.sin(s) * Math.cos(v)) - d))),
          (r = Math.sqrt((1 - Math.cos(n)) / (Math.cos(a) * Math.cos(a)) / (1 - Math.cos(Math.atan(1 / Math.cos(s)))))),
          h.value === mi.AREA_1 ? (a += d) : h.value === mi.AREA_2 ? (a += w) : h.value === mi.AREA_3 && (a += 1.5 * w),
          (o.x = r * Math.cos(a)),
          (o.y = r * Math.sin(a)),
          (o.x = o.x * this.a + this.x0),
          (o.y = o.y * this.a + this.y0),
          (t.x = o.x),
          (t.y = o.y),
          t
        );
      },
      inverse: function (t) {
        var e,
          i,
          s,
          n,
          r,
          a,
          o,
          h,
          l,
          c,
          u,
          f,
          p = { lam: 0, phi: 0 },
          m = { value: 0 };
        if (
          ((t.x = (t.x - this.x0) / this.a),
          (t.y = (t.y - this.y0) / this.a),
          (i = Math.atan(Math.sqrt(t.x * t.x + t.y * t.y))),
          (e = Math.atan2(t.y, t.x)),
          t.x >= 0 && t.x >= Math.abs(t.y)
            ? (m.value = mi.AREA_0)
            : t.y >= 0 && t.y >= Math.abs(t.x)
              ? ((m.value = mi.AREA_1), (e -= d))
              : t.x < 0 && -t.x >= Math.abs(t.y)
                ? ((m.value = mi.AREA_2), (e = e < 0 ? e + w : e - w))
                : ((m.value = mi.AREA_3), (e += d)),
          (l = (w / 12) * Math.tan(e)),
          (r = Math.sin(l) / (Math.cos(l) - 1 / Math.sqrt(2))),
          (a = Math.atan(r)),
          (o = 1 - (s = Math.cos(e)) * s * (n = Math.tan(i)) * n * (1 - Math.cos(Math.atan(1 / Math.cos(a))))) < -1
            ? (o = -1)
            : o > 1 && (o = 1),
          this.face === fi)
        )
          ((h = Math.acos(o)),
            (p.phi = d - h),
            m.value === mi.AREA_0
              ? (p.lam = a + d)
              : m.value === mi.AREA_1
                ? (p.lam = a < 0 ? a + w : a - w)
                : m.value === mi.AREA_2
                  ? (p.lam = a - d)
                  : (p.lam = a));
        else if (this.face === pi)
          ((h = Math.acos(o)),
            (p.phi = h - d),
            m.value === mi.AREA_0
              ? (p.lam = -a + d)
              : m.value === mi.AREA_1
                ? (p.lam = -a)
                : m.value === mi.AREA_2
                  ? (p.lam = -a - d)
                  : (p.lam = a < 0 ? -a - w : -a + w));
        else {
          var g, y, x;
          ((l = (g = o) * g),
            (y = (l += (x = l >= 1 ? 0 : Math.sqrt(1 - l) * Math.sin(a)) * x) >= 1 ? 0 : Math.sqrt(1 - l)),
            m.value === mi.AREA_1
              ? ((l = y), (y = -x), (x = l))
              : m.value === mi.AREA_2
                ? ((y = -y), (x = -x))
                : m.value === mi.AREA_3 && ((l = y), (y = x), (x = -l)),
            this.face === ci
              ? ((l = g), (g = -y), (y = l))
              : this.face === ui
                ? ((g = -g), (y = -y))
                : this.face === di && ((l = g), (g = y), (y = -l)),
            (p.phi = Math.acos(-x) - d),
            (p.lam = Math.atan2(y, g)),
            this.face === ci
              ? (p.lam = yi(p.lam, -d))
              : this.face === ui
                ? (p.lam = yi(p.lam, -w))
                : this.face === di && (p.lam = yi(p.lam, +d)));
        }
        return (
          0 !== this.es &&
            ((c = p.phi < 0 ? 1 : 0),
            (u = Math.tan(p.phi)),
            (f = this.b / Math.sqrt(u * u + this.one_minus_f_squared)),
            (p.phi = Math.atan(Math.sqrt(this.a * this.a - f * f) / (this.one_minus_f * f))),
            c && (p.phi = -p.phi)),
          (p.lam += this.long0),
          (t.x = p.lam),
          (t.y = p.phi),
          t
        );
      },
      names: ['Quadrilateralized Spherical Cube', 'Quadrilateralized_Spherical_Cube', 'qsc'],
    },
    vi = [
      [1, 22199e-21, -715515e-10, 31103e-10],
      [0.9986, -482243e-9, -24897e-9, -13309e-10],
      [0.9954, -83103e-8, -448605e-10, -9.86701e-7],
      [0.99, -0.00135364, -59661e-9, 36777e-10],
      [0.9822, -0.00167442, -449547e-11, -572411e-11],
      [0.973, -0.00214868, -903571e-10, 1.8736e-8],
      [0.96, -0.00305085, -900761e-10, 164917e-11],
      [0.9427, -0.00382792, -653386e-10, -26154e-10],
      [0.9216, -0.00467746, -10457e-8, 481243e-11],
      [0.8962, -0.00536223, -323831e-10, -543432e-11],
      [0.8679, -0.00609363, -113898e-9, 332484e-11],
      [0.835, -0.00698325, -640253e-10, 9.34959e-7],
      [0.7986, -0.00755338, -500009e-10, 9.35324e-7],
      [0.7597, -0.00798324, -35971e-9, -227626e-11],
      [0.7186, -0.00851367, -701149e-10, -86303e-10],
      [0.6732, -0.00986209, -199569e-9, 191974e-10],
      [0.6213, -0.010418, 883923e-10, 624051e-11],
      [0.5722, -0.00906601, 182e-6, 624051e-11],
      [0.5322, -0.00677797, 275608e-9, 624051e-11],
    ],
    bi = [
      [-520417e-23, 0.0124, 121431e-23, -845284e-16],
      [0.062, 0.0124, -1.26793e-9, 4.22642e-10],
      [0.124, 0.0124, 5.07171e-9, -1.60604e-9],
      [0.186, 0.0123999, -1.90189e-8, 6.00152e-9],
      [0.248, 0.0124002, 7.10039e-8, -2.24e-8],
      [0.31, 0.0123992, -2.64997e-7, 8.35986e-8],
      [0.372, 0.0124029, 9.88983e-7, -3.11994e-7],
      [0.434, 0.0123893, -369093e-11, -4.35621e-7],
      [0.4958, 0.0123198, -102252e-10, -3.45523e-7],
      [0.5571, 0.0121916, -154081e-10, -5.82288e-7],
      [0.6176, 0.0119938, -241424e-10, -5.25327e-7],
      [0.6769, 0.011713, -320223e-10, -5.16405e-7],
      [0.7346, 0.0113541, -397684e-10, -6.09052e-7],
      [0.7903, 0.0109107, -489042e-10, -104739e-11],
      [0.8435, 0.0103431, -64615e-9, -1.40374e-9],
      [0.8936, 0.00969686, -64636e-9, -8547e-9],
      [0.9394, 0.00840947, -192841e-9, -42106e-10],
      [0.9761, 0.00616527, -256e-6, -42106e-10],
      [1, 0.00328947, -319159e-9, -42106e-10],
    ],
    wi = 0.8487,
    Si = 1.3523,
    Mi = x / 5,
    Ci = 1 / Mi,
    Ei = 18,
    Di = function (t, e) {
      return t[0] + e * (t[1] + e * (t[2] + e * t[3]));
    };
  var Ai = {
    init: function () {
      ((this.x0 = this.x0 || 0),
        (this.y0 = this.y0 || 0),
        (this.long0 = this.long0 || 0),
        (this.es = 0),
        (this.title = this.title || 'Robinson'));
    },
    forward: function (t) {
      var e = X(t.x - this.long0),
        i = Math.abs(t.y),
        s = Math.floor(i * Mi);
      s < 0 ? (s = 0) : s >= Ei && (s = 17);
      var n = { x: Di(vi[s], (i = x * (i - Ci * s))) * e, y: Di(bi[s], i) };
      return (t.y < 0 && (n.y = -n.y), (n.x = n.x * this.a * wi + this.x0), (n.y = n.y * this.a * Si + this.y0), n);
    },
    inverse: function (t) {
      var e = { x: (t.x - this.x0) / (this.a * wi), y: Math.abs(t.y - this.y0) / (this.a * Si) };
      if (e.y >= 1) ((e.x /= vi[18][0]), (e.y = t.y < 0 ? -d : d));
      else {
        var i = Math.floor(e.y * Ei);
        for (i < 0 ? (i = 0) : i >= Ei && (i = 17); ; )
          if (bi[i][0] > e.y) --i;
          else {
            if (!(bi[i + 1][0] <= e.y)) break;
            ++i;
          }
        var s = bi[i],
          n = (5 * (e.y - s[0])) / (bi[i + 1][0] - s[0]);
        ((n = (function (t, e, i, s) {
          for (var n = e; s; --s) {
            var r = t(n);
            if (((n -= r), Math.abs(r) < i)) break;
          }
          return n;
        })(
          function (t) {
            return (
              (Di(s, t) - e.y) /
              (function (t, e) {
                return t[1] + e * (2 * t[2] + 3 * e * t[3]);
              })(s, t)
            );
          },
          n,
          g,
          100,
        )),
          (e.x /= Di(vi[i], n)),
          (e.y = (5 * i + n) * y),
          t.y < 0 && (e.y = -e.y));
      }
      return ((e.x = X(e.x + this.long0)), e);
    },
    names: ['Robinson', 'robin'],
  };
  var Fi = {
      init: function () {
        this.name = 'geocent';
      },
      forward: function (t) {
        return yt(t, this.es, this.a);
      },
      inverse: function (t) {
        return xt(t, this.es, this.a, this.b);
      },
      names: ['Geocentric', 'geocentric', 'geocent', 'Geocent'],
    },
    Pi = 0,
    Ti = 1,
    Ii = 2,
    _i = 3,
    Ri = {
      h: { def: 1e5, num: !0 },
      azi: { def: 0, num: !0, degrees: !0 },
      tilt: { def: 0, num: !0, degrees: !0 },
      long0: { def: 0, num: !0 },
      lat0: { def: 0, num: !0 },
    };
  var Ni = {
    init: function () {
      if (
        (Object.keys(Ri).forEach(
          function (t) {
            if (void 0 === this[t]) this[t] = Ri[t].def;
            else {
              if (Ri[t].num && isNaN(this[t]))
                throw new Error('Invalid parameter value, must be numeric ' + t + ' = ' + this[t]);
              Ri[t].num && (this[t] = parseFloat(this[t]));
            }
            Ri[t].degrees && (this[t] = this[t] * y);
          }.bind(this),
        ),
        Math.abs(Math.abs(this.lat0) - d) < g
          ? (this.mode = this.lat0 < 0 ? Ti : Pi)
          : Math.abs(this.lat0) < g
            ? (this.mode = Ii)
            : ((this.mode = _i), (this.sinph0 = Math.sin(this.lat0)), (this.cosph0 = Math.cos(this.lat0))),
        (this.pn1 = this.h / this.a),
        this.pn1 <= 0 || this.pn1 > 1e10)
      )
        throw new Error('Invalid height');
      ((this.p = 1 + this.pn1),
        (this.rp = 1 / this.p),
        (this.h1 = 1 / this.pn1),
        (this.pfact = (this.p + 1) * this.h1),
        (this.es = 0));
      var t = this.tilt,
        e = this.azi;
      ((this.cg = Math.cos(e)), (this.sg = Math.sin(e)), (this.cw = Math.cos(t)), (this.sw = Math.sin(t)));
    },
    forward: function (t) {
      t.x -= this.long0;
      var e,
        i,
        s,
        n,
        r = Math.sin(t.y),
        a = Math.cos(t.y),
        o = Math.cos(t.x);
      switch (this.mode) {
        case _i:
          i = this.sinph0 * r + this.cosph0 * a * o;
          break;
        case Ii:
          i = a * o;
          break;
        case Ti:
          i = -r;
          break;
        case Pi:
          i = r;
      }
      switch (((e = (i = this.pn1 / (this.p - i)) * a * Math.sin(t.x)), this.mode)) {
        case _i:
          i *= this.cosph0 * r - this.sinph0 * a * o;
          break;
        case Ii:
          i *= r;
          break;
        case Pi:
          i *= -a * o;
          break;
        case Ti:
          i *= a * o;
      }
      return (
        (n = 1 / ((s = i * this.cg + e * this.sg) * this.sw * this.h1 + this.cw)),
        (e = (e * this.cg - i * this.sg) * this.cw * n),
        (i = s * n),
        (t.x = e * this.a),
        (t.y = i * this.a),
        t
      );
    },
    inverse: function (t) {
      ((t.x /= this.a), (t.y /= this.a));
      var e,
        i,
        s,
        n = { x: t.x, y: t.y };
      ((s = 1 / (this.pn1 - t.y * this.sw)),
        (e = this.pn1 * t.x * s),
        (i = this.pn1 * t.y * this.cw * s),
        (t.x = e * this.cg + i * this.sg),
        (t.y = i * this.cg - e * this.sg));
      var r = ye(t.x, t.y);
      if (Math.abs(r) < g) ((n.x = 0), (n.y = t.y));
      else {
        var a, o;
        switch (
          ((o = 1 - r * r * this.pfact),
          (o = (this.p - Math.sqrt(o)) / (this.pn1 / r + r / this.pn1)),
          (a = Math.sqrt(1 - o * o)),
          this.mode)
        ) {
          case _i:
            ((n.y = Math.asin(a * this.sinph0 + (t.y * o * this.cosph0) / r)),
              (t.y = (a - this.sinph0 * Math.sin(n.y)) * r),
              (t.x *= o * this.cosph0));
            break;
          case Ii:
            ((n.y = Math.asin((t.y * o) / r)), (t.y = a * r), (t.x *= o));
            break;
          case Pi:
            ((n.y = Math.asin(a)), (t.y = -t.y));
            break;
          case Ti:
            n.y = -Math.asin(a);
        }
        n.x = Math.atan2(t.x, t.y);
      }
      return ((t.x = n.x + this.long0), (t.y = n.y), t);
    },
    names: ['Tilted_Perspective', 'tpers'],
  };
  var Bi = {
      init: function () {
        if (
          ((this.flip_axis = 'x' === this.sweep ? 1 : 0),
          (this.h = Number(this.h)),
          (this.radius_g_1 = this.h / this.a),
          this.radius_g_1 <= 0 || this.radius_g_1 > 1e10)
        )
          throw new Error();
        if (((this.radius_g = 1 + this.radius_g_1), (this.C = this.radius_g * this.radius_g - 1), 0 !== this.es)) {
          var t = 1 - this.es,
            e = 1 / t;
          ((this.radius_p = Math.sqrt(t)), (this.radius_p2 = t), (this.radius_p_inv2 = e), (this.shape = 'ellipse'));
        } else ((this.radius_p = 1), (this.radius_p2 = 1), (this.radius_p_inv2 = 1), (this.shape = 'sphere'));
        this.title || (this.title = 'Geostationary Satellite View');
      },
      forward: function (t) {
        var e,
          i,
          s,
          n,
          r = t.x,
          a = t.y;
        if (((r -= this.long0), 'ellipse' === this.shape)) {
          a = Math.atan(this.radius_p2 * Math.tan(a));
          var o = this.radius_p / ye(this.radius_p * Math.cos(a), Math.sin(a));
          if (
            ((i = o * Math.cos(r) * Math.cos(a)),
            (s = o * Math.sin(r) * Math.cos(a)),
            (n = o * Math.sin(a)),
            (this.radius_g - i) * i - s * s - n * n * this.radius_p_inv2 < 0)
          )
            return ((t.x = Number.NaN), (t.y = Number.NaN), t);
          ((e = this.radius_g - i),
            this.flip_axis
              ? ((t.x = this.radius_g_1 * Math.atan(s / ye(n, e))), (t.y = this.radius_g_1 * Math.atan(n / e)))
              : ((t.x = this.radius_g_1 * Math.atan(s / e)), (t.y = this.radius_g_1 * Math.atan(n / ye(s, e)))));
        } else
          'sphere' === this.shape &&
            ((e = Math.cos(a)),
            (i = Math.cos(r) * e),
            (s = Math.sin(r) * e),
            (n = Math.sin(a)),
            (e = this.radius_g - i),
            this.flip_axis
              ? ((t.x = this.radius_g_1 * Math.atan(s / ye(n, e))), (t.y = this.radius_g_1 * Math.atan(n / e)))
              : ((t.x = this.radius_g_1 * Math.atan(s / e)), (t.y = this.radius_g_1 * Math.atan(n / ye(s, e)))));
        return ((t.x = t.x * this.a), (t.y = t.y * this.a), t);
      },
      inverse: function (t) {
        var e,
          i,
          s,
          n,
          r = -1,
          a = 0,
          o = 0;
        if (((t.x = t.x / this.a), (t.y = t.y / this.a), 'ellipse' === this.shape)) {
          this.flip_axis
            ? ((o = Math.tan(t.y / this.radius_g_1)), (a = Math.tan(t.x / this.radius_g_1) * ye(1, o)))
            : ((a = Math.tan(t.x / this.radius_g_1)), (o = Math.tan(t.y / this.radius_g_1) * ye(1, a)));
          var h = o / this.radius_p;
          if (((e = a * a + h * h + r * r), (s = (i = 2 * this.radius_g * r) * i - 4 * e * this.C) < 0))
            return ((t.x = Number.NaN), (t.y = Number.NaN), t);
          ((n = (-i - Math.sqrt(s)) / (2 * e)),
            (r = this.radius_g + n * r),
            (a *= n),
            (o *= n),
            (t.x = Math.atan2(a, r)),
            (t.y = Math.atan((o * Math.cos(t.x)) / r)),
            (t.y = Math.atan(this.radius_p_inv2 * Math.tan(t.y))));
        } else if ('sphere' === this.shape) {
          if (
            (this.flip_axis
              ? ((o = Math.tan(t.y / this.radius_g_1)), (a = Math.tan(t.x / this.radius_g_1) * Math.sqrt(1 + o * o)))
              : ((a = Math.tan(t.x / this.radius_g_1)), (o = Math.tan(t.y / this.radius_g_1) * Math.sqrt(1 + a * a))),
            (e = a * a + o * o + r * r),
            (s = (i = 2 * this.radius_g * r) * i - 4 * e * this.C) < 0)
          )
            return ((t.x = Number.NaN), (t.y = Number.NaN), t);
          ((n = (-i - Math.sqrt(s)) / (2 * e)),
            (r = this.radius_g + n * r),
            (a *= n),
            (o *= n),
            (t.x = Math.atan2(a, r)),
            (t.y = Math.atan((o * Math.cos(t.x)) / r)));
        }
        return ((t.x = t.x + this.long0), t);
      },
      names: ['Geostationary Satellite View', 'Geostationary_Satellite', 'geos'],
    },
    ki = 1.340264,
    zi = -0.081106,
    Li = 893e-6,
    Oi = 0.003796,
    Hi = Math.sqrt(3) / 2;
  var ji,
    qi = {
      init: function () {
        ((this.es = 0), (this.long0 = void 0 !== this.long0 ? this.long0 : 0));
      },
      forward: function (t) {
        var e = X(t.x - this.long0),
          i = t.y,
          s = Math.asin(Hi * Math.sin(i)),
          n = s * s,
          r = n * n * n;
        return (
          (t.x = (e * Math.cos(s)) / (Hi * (ki + 3 * zi * n + r * (7 * Li + 9 * Oi * n)))),
          (t.y = s * (ki + zi * n + r * (Li + Oi * n))),
          (t.x = this.a * t.x + this.x0),
          (t.y = this.a * t.y + this.y0),
          t
        );
      },
      inverse: function (t) {
        ((t.x = (t.x - this.x0) / this.a), (t.y = (t.y - this.y0) / this.a));
        var e,
          i,
          s,
          n,
          r = t.y;
        for (
          n = 0;
          n < 12 &&
          ((r -= s =
            (r * (ki + zi * (e = r * r) + (i = e * e * e) * (Li + Oi * e)) - t.y) /
            (ki + 3 * zi * e + i * (7 * Li + 9 * Oi * e))),
          !(Math.abs(s) < 1e-9));
          ++n
        );
        return (
          (i = (e = r * r) * e * e),
          (t.x = (Hi * t.x * (ki + 3 * zi * e + i * (7 * Li + 9 * Oi * e))) / Math.cos(r)),
          (t.y = Math.asin(Math.sin(r) / Hi)),
          (t.x = X(t.x + this.long0)),
          t
        );
      },
      names: ['eqearth', 'Equal Earth', 'Equal_Earth'],
    };
  function Vi(t) {
    const e = 6378137,
      i = 6356752.314245,
      s = Math.sqrt((e * e - i * i) / (e * e)),
      n = Math.PI;
    let r = (t[1] * n) / 180,
      a = (t[0] * n) / 180,
      o = t[2],
      h = e / Math.sqrt(1 - s * s * Math.sin(r) * Math.sin(r));
    return [
      (h + o) * Math.cos(r) * Math.cos(a),
      (h + o) * Math.cos(r) * Math.sin(a),
      (h * (1 - s * s) + o) * Math.sin(r),
    ];
  }
  if (
    ((_t.defaultDatum = 'WGS84'),
    (_t.Proj = gt),
    (_t.WGS84 = new _t.Proj('WGS84')),
    (_t.Point = Jt),
    (_t.toPoint = Et),
    (_t.defs = q),
    (_t.nadgrid = function (t, e) {
      var i = new DataView(e),
        s = (function (t) {
          var e = t.getInt32(8, !1);
          if (11 === e) return !1;
          ((e = t.getInt32(8, !0)),
            11 !== e && console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian'));
          return !0;
        })(i),
        n = (function (t, e) {
          return {
            nFields: t.getInt32(8, e),
            nSubgridFields: t.getInt32(24, e),
            nSubgrids: t.getInt32(40, e),
            shiftType: ut(t, 56, 64).trim(),
            fromSemiMajorAxis: t.getFloat64(120, e),
            fromSemiMinorAxis: t.getFloat64(136, e),
            toSemiMajorAxis: t.getFloat64(152, e),
            toSemiMinorAxis: t.getFloat64(168, e),
          };
        })(i, s),
        r = (function (t, e, i) {
          for (var s = 176, n = [], r = 0; r < e.nSubgrids; r++) {
            var a = ft(t, s, i),
              o = pt(t, s, a, i),
              h = Math.round(1 + (a.upperLongitude - a.lowerLongitude) / a.longitudeInterval),
              l = Math.round(1 + (a.upperLatitude - a.lowerLatitude) / a.latitudeInterval);
            (n.push({
              ll: [ct(a.lowerLongitude), ct(a.lowerLatitude)],
              del: [ct(a.longitudeInterval), ct(a.latitudeInterval)],
              lim: [h, l],
              count: a.gridNodeCount,
              cvs: dt(o),
            }),
              (s += 176 + 16 * a.gridNodeCount));
          }
          return n;
        })(i, n, s),
        a = { header: n, subgrids: r };
      return ((ht[t] = a), a);
    }),
    (_t.transform = At),
    (_t.mgrs = jt),
    (_t.version = '__VERSION__'),
    (ji = _t).Proj.projections.add(me),
    ji.Proj.projections.add(we),
    ji.Proj.projections.add(Se),
    ji.Proj.projections.add(Ee),
    ji.Proj.projections.add(De),
    ji.Proj.projections.add(Ae),
    ji.Proj.projections.add(Pe),
    ji.Proj.projections.add(Te),
    ji.Proj.projections.add(Ie),
    ji.Proj.projections.add(He),
    ji.Proj.projections.add(Qe),
    ji.Proj.projections.add(Ye),
    ji.Proj.projections.add(Ze),
    ji.Proj.projections.add(Je),
    ji.Proj.projections.add($e),
    ji.Proj.projections.add(ti),
    ji.Proj.projections.add(ei),
    ji.Proj.projections.add(ii),
    ji.Proj.projections.add(si),
    ji.Proj.projections.add(ni),
    ji.Proj.projections.add(ri),
    ji.Proj.projections.add(ai),
    ji.Proj.projections.add(oi),
    ji.Proj.projections.add(hi),
    ji.Proj.projections.add(xi),
    ji.Proj.projections.add(Ai),
    ji.Proj.projections.add(Fi),
    ji.Proj.projections.add(Ni),
    ji.Proj.projections.add(Bi),
    ji.Proj.projections.add(qi),
    (function (t) {
      let e = 0,
        i = 0;
      for (let s = 1; s <= 60; s++)
        ((e = s),
          (i = 32600 + s),
          t.defs(`EPSG:${i}`, `+proj=utm +zone=${e} +datum=WGS84 +units=m +no_defs`),
          (i = 32700 + s),
          t.defs(`EPSG:${i}`, `+proj=utm +zone=${e} +datum=WGS84 +units=m +south +no_defs`));
      e = 25;
      for (let s = 0; s <= 20; s++)
        ((e = 25 + s),
          (i = 4534 + s),
          t.defs(
            `EPSG:${i}`,
            `+proj=tmerc +lat_0=0 +lon_0=${75 + 3 * s} +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs`,
          ),
          (i = 4513 + s),
          t.defs(
            `EPSG:${i}`,
            `+proj=tmerc +lat_0=0 +lon_0=${75 + 3 * s} +k=1 +x_0=${e}500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs`,
          ));
      e = 13;
      for (let s = 0; s <= 10; s++)
        ((e = 13 + s),
          (i = 4502 + s),
          t.defs(
            `EPSG:${i}`,
            `+proj=tmerc +lat_0=0 +lon_0=${75 + 6 * s} +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs`,
          ),
          (i = 4491 + s),
          t.defs(
            `EPSG:${i}`,
            `+proj=tmerc +lat_0=0 +lon_0=${75 + 6 * s} +k=1 +x_0=${e}500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs`,
          ));
    })(_t),
    !t)
  )
    return function (t, e, i) {
      return It(t, e, i);
    };
  t.data?.type === s
    ? (function (t) {
        const e = t.data.srcCode,
          i = t.data.targetCode,
          s = t.data.metaOffset,
          n = t.data.wgs84Offset,
          r = t.data.isRTK,
          a = t.data.buffer,
          o = t.data.vertexNum;
        t.data.faceNum;
        const h = new Float32Array(a, 0, 3 * o);
        let l, c;
        for (let t = 0; t < o; t++) {
          const a = h[3 * t],
            o = h[3 * t + 1],
            u = h[3 * t + 2];
          r &&
            ((l = It(e, i, [a + s.x, o + s.y, u + s.z])),
            (c = Vi(l)),
            (h[3 * t] = c[0] - n.x),
            (h[3 * t + 1] = c[1] - n.y),
            (h[3 * t + 2] = c[2] - n.z));
        }
        postMessage({ index: t.data.index, buffer: h.buffer }, [h.buffer]);
      })(t)
    : (function (t) {
        const s = t.data.srcCode,
          n = t.data.targetCode,
          r = t.data.metaOffset,
          a = t.data.wgs84Offset,
          o = t.data.isRTK,
          h = t.data.hasSH,
          l = t.data.useLccCompress,
          c = t.data.quanBBox,
          u = (t) => {
            const e = t.byteLength / 32,
              i = new Float32Array(t),
              h = new Float32Array(3 * e);
            if (o) {
              let t,
                o,
                l,
                c,
                u,
                d = [0, 0, 0];
              for (let f = 0; f < e; ++f)
                ((l = i[8 * f + 0]),
                  (c = i[8 * f + 1]),
                  (u = i[8 * f + 2]),
                  (t = It(s, n, [l + r.x, c + r.y, u + r.z])),
                  (o = Vi(t)),
                  (d[0] = o[0] - a.x),
                  (d[1] = o[1] - a.y),
                  (d[2] = o[2] - a.z),
                  (h[3 * f + 0] = d[0]),
                  (h[3 * f + 1] = d[1]),
                  (h[3 * f + 2] = d[2]),
                  (i[8 * f + 0] = d[0]),
                  (i[8 * f + 1] = d[1]),
                  (i[8 * f + 2] = d[2]));
            } else
              for (let t = 0; t < e; ++t)
                ((h[3 * t + 0] = i[8 * t + 0]), (h[3 * t + 1] = i[8 * t + 1]), (h[3 * t + 2] = i[8 * t + 2]));
            return { pos: h };
          };
        if (t.data.type == e)
          if (l) {
            const { data: e, pos: i } = ((t, e) => {
              const { min: i, max: h } = e,
                l = t.byteLength / 16,
                c = new Uint32Array(t),
                u = new Uint32Array(6 * l),
                d = new Float32Array(u.buffer),
                f = new Float32Array(3 * l);
              let p, m, g, y, x, v, b, w, S, M;
              for (let t = 0; t < l; ++t)
                ((p = c[4 * t + 0]),
                  (m = c[4 * t + 1]),
                  (g = c[4 * t + 2]),
                  (y = c[4 * t + 3]),
                  (x = (32767 & p) / 32767),
                  (v = ((p >> 15) & 32767) / 32767),
                  (b = (((p >> 30) & 3) + ((16383 & m) << 2)) / 65535),
                  (x = x <= 1 ? x : 1),
                  (v = v <= 1 ? v : 1),
                  (b = b <= 1 ? b : 1),
                  (w = i.x * (1 - x) + h.x * x),
                  (S = i.y * (1 - v) + h.y * v),
                  (M = i.z * (1 - b) + h.z * b),
                  (f[3 * t + 0] = w),
                  (f[3 * t + 1] = S),
                  (f[3 * t + 2] = M),
                  (d[6 * t + 0] = w),
                  (d[6 * t + 1] = S),
                  (d[6 * t + 2] = M),
                  (u[6 * t + 3] = m),
                  (u[6 * t + 4] = g),
                  (u[6 * t + 5] = y));
              if (o) {
                let t,
                  e,
                  i,
                  o,
                  h,
                  c = [0, 0, 0];
                for (let u = 0; u < l; ++u)
                  ((i = f[3 * u + 0]),
                    (o = f[3 * u + 1]),
                    (h = f[3 * u + 2]),
                    (t = It(s, n, [i + r.x, o + r.y, h + r.z])),
                    (e = Vi(t)),
                    (c[0] = e[0] - a.x),
                    (c[1] = e[1] - a.y),
                    (c[2] = e[2] - a.z),
                    (f[3 * u + 0] = c[0]),
                    (f[3 * u + 1] = c[1]),
                    (f[3 * u + 2] = c[2]),
                    (d[6 * u + 0] = c[0]),
                    (d[6 * u + 1] = c[1]),
                    (d[6 * u + 2] = c[2]));
              }
              return { data: u, pos: f };
            })(t.data.buffer, c);
            postMessage({ index: t.data.index, dataBuffer: e.buffer, posBuffer: i.buffer }, [e.buffer, i.buffer]);
          } else {
            const { pos: e } = u(t.data.buffer);
            postMessage({ index: t.data.index, dataBuffer: t.data.buffer, posBuffer: e.buffer }, [
              t.data.buffer,
              e.buffer,
            ]);
          }
        if (t.data.type == i)
          if (h) {
            const {
              pos: e,
              sh: i,
              data: h,
            } = ((t) => {
              const e = 24,
                i = t.byteLength / 96,
                h = new Uint32Array(t),
                l = new Uint32Array(3 * i),
                c = new Uint32Array(8 * i),
                u = new Uint32Array(16 * i),
                d = new Float32Array(l.buffer),
                f = new Float32Array(c.buffer);
              for (let t = 0; t < i; ++t) {
                ((l[3 * t + 0] = h[t * e + 0]), (l[3 * t + 1] = h[t * e + 1]), (l[3 * t + 2] = h[t * e + 2]));
                for (let i = 0; i < 8; ++i) c[8 * t + i] = h[t * e + i];
                for (let i = 0; i < 16; ++i) u[16 * t + i] = h[t * e + 8 + i];
              }
              if (o) {
                let t,
                  o,
                  h,
                  l,
                  c,
                  u = [0, 0, 0];
                for (let p = 0; p < i; ++p)
                  ((h = d[3 * p + 0]),
                    (l = d[3 * p + 1]),
                    (c = d[3 * p + 2]),
                    (t = It(s, n, [h + r.x, l + r.y, c + r.z])),
                    (o = Vi(t)),
                    (u[0] = o[0] - a.x),
                    (u[1] = o[1] - a.y),
                    (u[2] = o[2] - a.z),
                    (d[3 * p + 0] = u[0]),
                    (d[3 * p + 1] = u[1]),
                    (d[3 * p + 2] = u[2]),
                    (f[p * e + 0] = u[0]),
                    (f[p * e + 1] = u[1]),
                    (f[p * e + 2] = u[2]));
              }
              return { pos: l, sh: u, data: c };
            })(t.data.buffer);
            postMessage({ index: t.data.index, dataBuffer: h.buffer, posBuffer: e.buffer, shBuffer: i.buffer }, [
              h.buffer,
              e.buffer,
              i.buffer,
            ]);
          } else {
            const { pos: e } = u(t.data.buffer);
            postMessage({ index: t.data.index, dataBuffer: t.data.buffer, posBuffer: e.buffer }, [
              t.data.buffer,
              e.buffer,
            ]);
          }
      })(t);
}
class Ls {
  type;
  buffer;
  size;
  meta;
  renderID;
  quanBBox;
  callback;
  isDeprecated = !1;
}
class Os extends Ne {
  #f = !1;
  #ht = 0;
  #lt = [];
  #ct = [];
  #ut = [];
  #ft = !0;
  #te = 0;
  constructor(t = 4) {
    super();
    for (let e = 0; e < t; ++e) {
      const t = we(zs);
      t ? (this.#lt.push(t), this.#ht++) : console.error('create worker failed !!!');
    }
    this.#lt.forEach((t) => {
      t.onmessage = (t) => {
        if (this.#f) return;
        const i = t.data.index,
          r = this.#ut[i];
        if (!r.isDeprecated)
          if (r.type === e) {
            const e = new Uint32Array(t.data.dataBuffer),
              i = new Float32Array(t.data.posBuffer);
            r.callback(e, i, void 0);
          } else if (r.type === s) {
            const e = new Uint32Array(t.data.dataBuffer),
              i = new Float32Array(t.data.posBuffer),
              s = r.meta.hasSH ? new Uint32Array(t.data.shBuffer) : void 0;
            r.callback(e, i, s);
          } else r.type === n && r.callback(t.data.buffer);
        ((this.#ut[i] = void 0), this.#te--, this.#te < this.#ht && (this.#ft = !0));
      };
    });
  }
  dispose() {
    ((this.#f = !0),
      this.#lt.forEach((t) => {
        t.terminate();
      }),
      (this.#ct = []),
      (this.#ut = []),
      (this.#lt = []),
      (this.#ht = 0),
      (this.#ft = !1));
  }
  #Ct() {
    if (this.#ft && 0 != this.#ct.length && 0 != this.#ht) {
      for (let t = 0; t < this.#ht && 0 !== this.#ct.length; ++t) {
        const e = t;
        if (this.#ut[e]) continue;
        const i = (this.#ut[e] = this.#ct.shift()),
          s = this.#lt[e],
          n = i.meta?.epsg > 0;
        let r = {};
        (n &&
          ((r.srcCode = i.meta.srcCode),
          (r.targetCode = i.meta.targetCode),
          (r.metaOffset = i.meta.metaOffset),
          (r.wgs84Offset = i.meta.wgs84Offset)),
          s.postMessage(
            {
              index: e,
              type: i.type,
              buffer: i.buffer,
              useLccCompress: i.meta.useLccCompress,
              hasSH: i.meta.hasSH,
              quanBBox: i.quanBBox,
              isRTK: n,
              ...r,
            },
            [i.buffer],
          ),
          this.#te++);
      }
      this.#ft = this.#te < this.#ht;
    }
  }
  update(t) {
    this.#f || this.#Ct();
  }
  decompress(t, i, r, a, o, h, l) {
    if (t !== e && t !== s && t !== n) return (console.error('unkonw type: ' + t), !1);
    let c = new Ls();
    return (
      (c.renderID = o),
      (c.type = t),
      (c.buffer = i),
      (c.size = r),
      (c.meta = a),
      (c.quanBBox = h),
      (c.callback = l),
      this.#ct.push(c),
      this.#ft && this.#Ct(),
      !0
    );
  }
  unload(t) {
    ((this.#ct = this.#ct.filter((e) => e.renderID !== t)),
      this.#ut.forEach((e) => {
        e?.renderID === t && (e.isDeprecated = !0);
      }));
  }
}
class Hs {
  #Re;
  #ln;
  #cn;
  #Mo;
  #Co;
  #Eo;
  #Do;
  #Ao;
  get rainbowTex() {
    return this.#cn;
  }
  get shTex() {
    return this.#Mo;
  }
  get indexHostTex() {
    return this.#Co;
  }
  get splatIndexTex() {
    return this.#Eo;
  }
  get renderState() {
    return this.#Ao;
  }
  constructor(t) {
    ((this.#Re = t),
      (this.#ln = this.#Re.renderLib),
      (this.#Do = this.#Re.scene.context),
      this.#Fo(),
      this.#xn(),
      this.#Po(),
      this.#To());
  }
  hasTexture(t) {
    return !!t && (t === this.#cn || t === this.#Mo || t === this.#Co || t === this.#Eo);
  }
  _dispose() {
    (this.#cn && (!this.#cn.isDestroyed() && this.#cn.destroy(), (this.#cn = void 0)),
      this.#Mo && (!this.#Mo.isDestroyed() && this.#Mo.destroy(), (this.#Mo = void 0)),
      this.#Eo && (!this.#Eo.isDestroyed() && this.#Eo.destroy(), (this.#Eo = void 0)),
      this.#Ao && (this.#Ao = void 0),
      (this.#Re = void 0),
      (this.#ln = void 0),
      (this.#Do = void 0));
  }
  #xn() {
    const t = new Image();
    ((t.src = w[1]),
      (t.onload = () => {
        this.#cn = new this.#ln.Texture({
          context: this.#Do,
          width: t.width,
          height: t.height,
          flipY: !1,
          skipColorSpaceConversion: !1,
          source: t,
          pixelDatatype: this.#ln.PixelDatatype.UNSIGNED_BYTE,
          pixelFormat: this.#ln.PixelFormat.RGBA,
          sampler: new this.#ln.Sampler({
            wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
            wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
            minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
            magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
          }),
        });
      }));
  }
  #Po() {
    if (this.#Mo) return;
    this.#Mo = new this.#ln.Texture({
      context: this.#Do,
      width: 1,
      height: 1,
      flipY: !1,
      skipColorSpaceConversion: !0,
      source: { arrayBufferView: new Float32Array(4) },
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: this.#ln.PixelFormat.RGBA,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
  }
  #Io() {
    if (this.#Co) return;
    this.#Co = new this.#ln.Texture({
      context: this.#Do,
      width: 1,
      height: 1,
      flipY: !1,
      skipColorSpaceConversion: !0,
      source: { arrayBufferView: new Float32Array(1) },
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: this.#ln.PixelFormat.RED,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
  }
  #To() {
    if (this.#Eo) return;
    this.#Eo = new this.#ln.Texture({
      context: this.#Do,
      width: 1,
      height: 1,
      flipY: !1,
      skipColorSpaceConversion: !0,
      source: { arrayBufferView: new Float32Array(4) },
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: this.#ln.PixelFormat.RGBA,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
  }
  #Fo() {
    this.#Ao = this.#ln.RenderState.fromCache({
      blending: this.#ln.BlendingState.ALPHA_BLEND,
      depthTest: { enabled: !0, func: this.#ln.WebGLConstants.ALWAYS },
      depthMask: !0,
      cull: { enabled: !1 },
    });
  }
  createUniform(t) {
    const {
        compressedScaleMin: e,
        compressedScaleMax: i,
        compressedSHMin: s,
        compressedSHMax: n,
        positionMin: r,
        positionMax: a,
      } = t,
      o = new ee(r.z, a.z);
    return {
      compressedSHMin: () => s,
      compressedSHMax: () => n,
      compressedScaleMax: () => i,
      compressedScaleMin: () => e,
      splatIndexesHost: () => {},
      splatData: () => {},
      shRawTexture: () => {},
      customColors: () => {},
      semanticColors: () => {},
      viewport: () => ({ x: 0, y: 0 }),
      cmrPos: () => ({ x: 0, y: 0, z: 0 }),
      scPos: () => ({ x: 0, y: 0, z: 0 }),
      heightRange: () => o,
      clipPlane: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      clipBoxMatrixInv: () => this.#ln.Matrix4.clone(this.#ln.Matrix4.IDENTITY),
      prj2ECEF: () => this.#ln.Matrix3.clone(this.#ln.Matrix3.IDENTITY),
      prj2ECEF_INV: () => this.#ln.Matrix3.clone(this.#ln.Matrix3.IDENTITY),
      use0: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      use1: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      use2: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      use3: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      vmat: () => this.#ln.Matrix4(),
      pmat: () => this.#ln.Matrix4(),
      czm_pickColor: () => {},
    };
  }
  createUniformCompress(t) {
    const { positionMin: e, positionMax: i } = t,
      s = new ee(e.z, i.z);
    return {
      lutScaleTexture: () => {},
      lutShTexture: () => {},
      semanticTexture: () => {},
      splatIndexesHost: () => {},
      splatData: () => {},
      shRawTexture: () => {},
      customColors: () => {},
      semanticColors: () => {},
      viewport: () => ({ x: 0, y: 0 }),
      cmrPos: () => ({ x: 0, y: 0, z: 0 }),
      scPos: () => ({ x: 0, y: 0, z: 0 }),
      heightRange: () => s,
      clipPlane: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      clipBoxMatrixInv: () => this.#ln.Matrix4.clone(this.#ln.Matrix4.IDENTITY),
      prj2ECEF: () => this.#ln.Matrix3.clone(this.#ln.Matrix3.IDENTITY),
      prj2ECEF_INV: () => this.#ln.Matrix3.clone(this.#ln.Matrix3.IDENTITY),
      use0: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      use1: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      use2: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      use3: () => ({ x: 0, y: 0, z: 0, w: 0 }),
      vmat: () => this.#ln.Matrix4(),
      pmat: () => this.#ln.Matrix4(),
      czm_pickColor: () => {},
    };
  }
}
class js {
  #Re;
  #ln;
  #Do;
  #Mn;
  #Cn;
  #En;
  #Dn;
  get semanticColorsTex() {
    return this.#Cn;
  }
  get lutScaleTex() {
    return this.#En;
  }
  get lutShTex() {
    return this.#Dn;
  }
  constructor(t) {
    ((this.#Re = t), (this.#ln = this.#Re.renderLib), (this.#Do = this.#Re.scene.context), this.#An());
  }
  dispose() {
    (this.#Cn != this.#Mn && this.#Fn(this.#Cn),
      this.#Fn(this.#Mn),
      (this.#Cn = void 0),
      (this.#Mn = void 0),
      this.#Fn(this.#En),
      this.#Fn(this.#Dn),
      (this.#En = void 0),
      (this.#Dn = void 0),
      (this.#Re = void 0),
      (this.#ln = void 0),
      (this.#Do = void 0));
  }
  #Fn(t) {
    t && !t.isDestroyed() && t.destroy();
  }
  #_o(t, e, i) {
    return new this.#ln.Texture({
      context: this.#Do,
      width: t,
      height: e,
      flipY: !1,
      skipColorSpaceConversion: !0,
      source: { arrayBufferView: i },
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: this.#ln.PixelFormat.RGBA,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
  }
  #An() {
    if (this.#Cn) return;
    const t = it.length,
      e = new Float32Array(1 * t * 4);
    for (let i = 0; i < 1 * t; ++i)
      ((e[i + 0] = it[i][0]), (e[i + 1] = it[i][1]), (e[i + 2] = it[i][2]), (e[i + 2] = 1));
    let i = this.#_o(t, 1, e);
    this.#Cn = this.#Mn = i;
  }
  updateSemanticColor(t) {
    const e = it.length,
      i = new Float32Array(1 * e * 4);
    for (let s = 0; s < 1 * e; ++s)
      s < t.length
        ? ((i[s + 0] = t[s][0]), (i[s + 1] = t[s][1]), (i[s + 2] = t[s][2]), (i[s + 2] = 1))
        : ((i[s + 0] = 0), (i[s + 1] = 0), (i[s + 2] = 0), (i[s + 2] = 1));
    let s = this.#_o(e, 1, i);
    (this.resetSemanticColor(), (this.#Cn = s));
  }
  resetSemanticColor() {
    this.#Cn != this.#Mn && (this.#Fn(this.#Cn), (this.#Cn = this.#Mn));
  }
  setLutScale(t) {
    if (this.#En) return void console.error('repeat creating lut-scale');
    const e = new Float32Array(t),
      i = e.length / 3;
    3 * i != e.length && console.error('lut-scale size error: ', i, e.length);
    const s = 1024,
      n = Math.ceil(i / s);
    let r = new Float32Array(s * n * 4);
    for (let t = 0; t < i; ++t)
      ((r[4 * t + 0] = e[3 * t + 0]), (r[4 * t + 1] = e[3 * t + 1]), (r[4 * t + 2] = e[3 * t + 2]), (r[4 * t + 3] = 1));
    this.#En = this.#_o(s, n, r);
  }
  setLutSH(t) {
    if (this.#Dn) return void console.error('repeat creating lut-sh');
    const e = new Float32Array(t),
      i = e.length / 3;
    3 * i != e.length && console.error('lut-sh size error: ', i, e.length);
    const s = i / 15;
    15 * s != i && console.error('lut-sh size error2: ', i, s);
    const n = 4096,
      r = Math.ceil(i / n);
    let a = new Float32Array(n * r * 4);
    for (let t = 0; t < i; ++t)
      ((a[4 * t + 0] = e[3 * t + 0]), (a[4 * t + 1] = e[3 * t + 1]), (a[4 * t + 2] = e[3 * t + 2]), (a[4 * t + 3] = 1));
    this.#Dn = this.#_o(n, r, a);
  }
}
class qs {
  static GlobalID = 0;
  #f = !1;
  #S;
  #tt = !1;
  #ti;
  #ln;
  #Do;
  #Ro;
  #No;
  #Pt;
  #Xe;
  #Bo = !0;
  #ko;
  #Pn;
  #Tn;
  #zo = !1;
  #Lo = !1;
  #or = !1;
  #nr = !0;
  #rr;
  #ar = et;
  #Oo = 0;
  #Ho = !1;
  #jo = [];
  #qo = void 0;
  _createVertexArray = !0;
  #Vo = void 0;
  #Uo = !1;
  #Ko = !1;
  #ir = !1;
  #Gn = new pt();
  #Wn = new pt();
  #Qn = 0;
  #Xn = new pt();
  #Yn = new pt();
  #Zn = 0;
  #Go = void 0;
  #Wo = void 0;
  #Qo = void 0;
  #Xo = void 0;
  hasUploadSH = !1;
  hasUploadSem = !1;
  node;
  #P;
  splatCount = 0;
  dimensions;
  dataDimensions;
  shDimensions;
  semDimensions;
  size = 0;
  #Yo;
  #Zo;
  #Jo;
  pos;
  indexes;
  distances;
  #$o;
  #zt = new ie();
  #th = !1;
  #eh;
  #ih;
  useLogDepth = !1;
  #sh;
  #nh = null;
  #rh;
  #ah;
  #oh;
  #hh;
  #lh = $;
  #In = 0;
  get id() {
    return this.#S;
  }
  get isEnvMesh() {
    return this.#Lo;
  }
  get flushID() {
    return this.#In;
  }
  get isInitialized() {
    return this.#Uo;
  }
  get isFirstSorted() {
    return this.#Uo;
  }
  get isCached() {
    return this.#Ko;
  }
  get isSorting() {
    return this.#ir;
  }
  get show() {
    return this.#Bo;
  }
  set show(t) {
    this.#Bo = !!t;
  }
  get cmrPos() {
    return this.#Gn.clone();
  }
  get sortCmrPosLast() {
    return this.#Gn.clone();
  }
  get sortTickLast() {
    return this.#Qn;
  }
  get sortCmrPosPending() {
    return this.#Xn;
  }
  get boundingSphere() {
    return this.#sh;
  }
  get isDispose() {
    return this.#f;
  }
  constructor(t, e) {
    if (
      ((this.#Pt = t),
      (this.#ln = this.#Pt.lccParam.renderLib),
      (this.#S = this.#ln.createGuid()),
      (this.#Xe = t.config),
      (this.#Pn = this.#Pt.resources),
      (this.#Tn = this.#Pt.resourcesScene),
      (this.#tt = this.#Pt.isRTK),
      (this.#ti = this.#Pt?.meta),
      (this.#Do = e.context),
      (this.#Oo = e.splatCount),
      (this.renderID = e?.renderID),
      (this.#Ro = e.data),
      (this.node = e?.node),
      (this.#Lo = e?.isEnv),
      (this.#Jo = e?.sh),
      (this.#or = this.#Xe.useLccCompress && !this.#Lo),
      (this._sp = void 0),
      (this._rs = void 0),
      (this.#Vo = this.#ln.Pass.CESIUM_3D_TILE),
      (this.#ih = new this.#ln.Matrix4()),
      (this.#ah = new this.#ln.Cartesian3()),
      (this._vs = void 0),
      (this._fs = void 0),
      (this.#eh = e?.matrix || new this.#ln.Matrix4()),
      (this.#Yo = e?.prj2ECEF || new this.#ln.Matrix3()),
      (this.#Zo = new this.#ln.Matrix3()),
      this.#ln.Matrix3.inverse(this.#Yo, this.#Zo),
      (this.#hh = e?.ndc2local || new this.#ln.Matrix4()),
      (this.#sh = null),
      (this.#ko = { position: 0 }),
      (this.splatCount = e?.splatCount),
      (this.dimensions = Et(this.splatCount, this.#Pt.config.TextureSize)),
      (this.semDimensions = Et(this.splatCount, this.#Pt.config.TextureSize)),
      this.#or)
    ) {
      const t = Math.ceil(1.5 * (this.splatCount + 1));
      ((this.dataDimensions = Et(t, this.#Pt.config.TextureSize)),
        (this.shDimensions = Et(this.splatCount, this.#Pt.config.TextureSize)));
    } else
      ((this.dataDimensions = Et(2 * this.splatCount, this.#Pt.config.TextureSize)),
        (this.shDimensions = Et(4 * this.splatCount, this.#Pt.config.TextureSize)));
    let i, s, n, r, a, o;
    ((this.size = this.#ch()),
      e?.isEnv
        ? ((this.#P = -1),
          this.#ti.compressInfo.positionMin &&
            this.#ti.compressInfo.positionMax &&
            this.#zt.set(this.#ti.compressInfo.positionMin, this.#ti.compressInfo.positionMax),
          (a = this.#ti.compressInfo.positionMin),
          (o = this.#ti.compressInfo.positionMax),
          (i = this.#ti.compressInfo.compressedEnvScaleMin || i),
          (s = this.#ti.compressInfo.compressedEnvScaleMax || s),
          (n = this.#ti.compressInfo.compressedEnvSHMin || n),
          (r = this.#ti.compressInfo.compressedEnvSHMax || n))
        : ((this.#P = this.node.level),
          this.#zt.copy(this.node.parent.getBBox()),
          (a = this.#ti.min),
          (o = this.#ti.max),
          (i = this.#ti.compressInfo.compressedScaleMin),
          (s = this.#ti.compressInfo.compressedScaleMax),
          (n = this.#ti.compressInfo.compressedSHMin),
          (r = this.#ti.compressInfo.compressedSHMax)));
    const h = this.dimensions.x * this.dimensions.y;
    e.pos &&
      ((this.pos = new Float32Array(e.pos.length)),
      this.pos.set(e.pos, 0),
      (this.distances = new Int32Array(this.splatCount)),
      (this.indexes = new Int32Array(this.splatCount)),
      (this.#$o = new Float32Array(4 * h)));
    const l = {
      compressedScaleMin: i,
      compressedScaleMax: s,
      compressedSHMin: n,
      compressedSHMax: r,
      positionMin: a,
      positionMax: o,
    };
    if (((this.#No = this.#or ? this.#Pn.createUniformCompress(l) : this.#Pn.createUniform(l)), this.#uh(), this.#ti)) {
      const t = this.#ln.Matrix4.getTranslation(this.#eh, new this.#ln.Cartesian3());
      if (this.#Lo) {
        const e = this.#ti.boundingBox,
          i = [10 * e.max[0], 10 * e.max[1], 10 * e.max[2]],
          s = [10 * e.min[0], 10 * e.min[1], 10 * e.min[2]];
        this.setBoundingVolume(t, { max: i, min: s });
      } else {
        const e = this.node?.parent?.getBBox();
        this.setBoundingVolume(t, { max: e.max?.toArray(), min: e.min?.toArray() });
      }
    }
    this.#yr(this.#Do);
  }
  #dh() {
    const t = this.node?.parent?.bounding;
    if (!this.#Lo && t) {
      const { up: e, right: i, down: s, left: n, upEC: r, rightEC: a, downEC: o, leftEC: h } = t,
        l = this.#ln.Cartesian3.dot(e, r),
        c = this.#ln.Cartesian3.dot(i, a),
        u = this.#ln.Cartesian3.dot(s, o),
        d = this.#ln.Cartesian3.dot(n, h),
        f = new this.#ln.Matrix4(e.x, e.y, e.z, -l, i.x, i.y, i.z, -c, s.x, s.y, s.z, -u, n.x, n.y, n.z, -d);
      return this.#ln.Matrix4.transpose(f, f);
    }
    return new this.#ln.Matrix4();
  }
  #uh() {
    ((this._vs = li(oi).vertexShaderSH), (this._fs = ci(oi).fragmentShader));
  }
  #fh(t, e, i) {
    const s = t.context,
      n = ['INSTANCED', 'HAS_NOT_ATTRIBUTE_POSITION', 'LccShader'];
    this.#tt && n.push('IS_RTK');
    const r = new this.#ln.ShaderSource({ defines: n, sources: [e] }),
      a = new this.#ln.ShaderSource({ defines: n, sources: [i] });
    ((this._sp = this.#ln.ShaderProgram.replaceCache({
      context: s,
      shaderProgram: this._sp,
      vertexShaderSource: r,
      fragmentShaderSource: a,
      attributeLocations: this.#ko,
    })),
      (this._rs = this.#Pn.renderState),
      (this.#ln.defined(this._pickId) && this._id === this.id) ||
        ((this._id = this.id),
        (this._pickId = this._pickId && this._pickId.destroy()),
        (this._pickId = s.createPickId({ primitive: this, id: this.id }))),
      (this.#zo = !0));
  }
  #ch() {
    const t = this.dimensions,
      e = this.dataDimensions,
      i = this.shDimensions;
    let s = 0,
      n = e.x * e.y * 16,
      r = t.x * t.y * 4,
      a = i.x * i.y * 16;
    return ((s = n + r), this.hasUploadSH && (s += a), s);
  }
  startSorting() {
    const t = this.#Pt.dynamicState.cmrPosLocal.clone(),
      e = this.#Pt.dynamicState.cmrForwardLocal.clone();
    (this.#Xn.copy(t), this.#Yn.copy(e), (this.#Zn = this.#Pt.dynamicState.tick), (this.#ir = !0));
  }
  endSorting() {
    ((this.#ir = !1),
      (this.#Uo = !0),
      this.#Gn.copy(this.#Xn),
      this.#Wn.copy(this.#Yn),
      (this.#Qn = this.#Zn),
      (this.#th = !0));
    for (let t = 0; t < this.splatCount; t++) this.#$o[4 * t] = this.indexes[t];
  }
  isCanShow() {
    if (!this.isFirstSorted) return !1;
    if (this.#Lo) return !0;
    const t = this.#Pt.config.MeshCanShowThreshold;
    return this.#Pt.dynamicState.cmrPosLocal.distanceToSquared(this.#Gn) < t * t;
  }
  checkNeedSort() {
    if (this.#ir) return !1;
    if (!this.isFirstSorted) return !0;
    if (this.#Lo && this.isFirstSorted) return !1;
    const t = this.#Pt.dynamicState.cmrPosLocal,
      e = this.#Pt.dynamicState.cmrForwardLocal,
      i = this.#Pt.config.CameraAngleChangedSortThreshold,
      s = this.#Pt.config.CameraPosChangedSortThreshold,
      n = t.distanceToSquared(this.#Gn),
      r = e.dot(this.#Wn);
    if (this.#Xe.enableDepthSorting) {
      if (n < s * s && r > i) return !1;
    } else if (n < s * s) return !1;
    const a = [0, 160, 320, 480, 640, 800, 960];
    return !(this.#Pt.dynamicState.tick - this.#Qn < a[Math.min(a.length - 1, this.node.level)]);
  }
  setModelMatrix(t) {
    t && (this.#eh = t);
  }
  setPrj2ECEFMatrix(t) {
    t && ((this.prj2ECEF = t), this.#ln.Matrix3.inverse(this.#Yo, this.#Zo));
  }
  setTranslation(t) {
    (this.#eh
      ? this.#ln.Matrix4.setTranslation(this.#eh, t, this.#eh)
      : (this.#eh = this.#ln.Matrix4.fromTranslation(t)),
      this.updateBoundingVolume(t, !1));
  }
  setRotation(t) {
    if (this.#eh) {
      const e = this.#ln.Matrix4.getTranslation(this.#eh, new this.#ln.Cartesian3()),
        i = this.#ln.Transforms.eastNorthUpToFixedFrame(e),
        s = this.#ln.Matrix3.multiply(
          this.#ln.Matrix4.getRotation(i, new this.#ln.Matrix3()),
          t,
          new this.#ln.Matrix3(),
        );
      this.#ln.Matrix4.setRotation(this.#eh, s, this.#eh);
    } else this.#eh = this.#ln.Matrix4.fromRotation(t);
  }
  setScale(t) {
    this.#eh
      ? (this.#ln.Matrix4.setScale(this.#eh, t, this.#eh), this.updateBoundingVolume(!1, t))
      : (this.#eh = this.#ln.Matrix4.fromScale(t));
  }
  setTranslationOffset(t) {
    if (this.#eh) {
      const e = this.#ln.Matrix4.fromTranslation(t);
      this.#ln.Matrix4.multiply(this.#eh, e, this.#eh);
      const i = this.#ln.Matrix4.getTranslation(this.#eh, new this.#ln.Cartesian3());
      this.updateBoundingVolume(i, !1);
    }
  }
  getTranslation() {
    return this.#eh ? this.#ln.Matrix4.getTranslation(this.#eh, new this.#ln.Cartesian3()) : null;
  }
  setBoundingVolume(t, e, i) {
    if (i) {
      const t = i.flat();
      let e = Math.max(t[0], t[3], t[6], t[9], t[12], t[15], t[18], t[21]),
        s = Math.max(t[1], t[4], t[7], t[10], t[13], t[16], t[19], t[22]),
        n = Math.max(t[2], t[5], t[8], t[11], t[14], t[17], t[20], t[23]),
        r = Math.min(t[0], t[3], t[6], t[9], t[12], t[15], t[18], t[21]),
        a = Math.min(t[1], t[4], t[7], t[10], t[13], t[16], t[19], t[22]),
        o = Math.min(t[2], t[5], t[8], t[11], t[14], t[17], t[20], t[23]),
        h = new this.#ln.Cartesian3((e + r) / 2, (s + a) / 2, (n + o) / 2);
      const l = Math.max(e - r, s - a, n - o);
      return ((this.#sh = new this.#ln.BoundingSphere(h, l / 2)), this.#sh);
    }
    if (e) {
      const i = 1,
        { max: s, min: n } = e,
        r = [(s[0] + n[0]) / 2, (s[1] + n[1]) / 2, (s[2] + n[2]) / 2 / i],
        a = s[0] - n[0],
        o = s[1] - n[1],
        h = s[2] - n[2],
        l = Math.ceil(Math.sqrt(a * a + o * o + h * h)),
        c = new this.#ln.Cartesian3(r[0], r[1], r[2]);
      this.#ln.Matrix3.multiplyByVector(this.#Yo, c, c);
      const u = new this.#ln.Cartesian3(t.x + c.x, t.y + c.y, t.z + c.z),
        d = this.#Lo ? l : l / 2;
      return (
        (this.#sh = new this.#ln.BoundingSphere(u, d)),
        (this.#nh = [c.x, c.y, c.z]),
        (this.#rh = 2 * d),
        (this.#ah = t),
        (this.#oh = this.#ln.Matrix4.getScale(this.#eh, new this.#ln.Cartesian3())),
        this.#sh
      );
    }
  }
  #ph() {
    const t = this.getTranslation(),
      e = this.#ln.Matrix4.getScale(this.#eh, new this.#ln.Cartesian3());
    (this.#ln.Cartesian3.distance(t, this.#ah) > 1e-6 || this.#ln.Cartesian3.distance(e, this.#oh) > 1e-6) &&
      this.#mh(t);
  }
  #mh() {
    if (this.#sh) {
      const t = this.#nh,
        e = this.#rh,
        i = this.getTranslation(),
        s = new this.#ln.Cartesian3(i.x + t[0], i.y + t[1], i.z + t[2]),
        n = this.#ln.Matrix4.getScale(this.#eh, new this.#ln.Cartesian3());
      ((this.#ah = i),
        (this.#oh = this.#ln.Matrix4.getScale(this.#eh, new this.#ln.Cartesian3())),
        (this.#sh = new this.#ln.BoundingSphere(s, (e / 2) * Math.max(n.x, n.y, n.z))));
    }
  }
  setPassIndex(t) {
    t > -1 && (this.#Vo = t);
  }
  getBBox() {
    return this.#zt;
  }
  intersectWithRay(t, e) {
    if (this.#Ro?.buffer?.byteLength < 1) return null;
    const i = new pt(),
      s = new pt(),
      n = new pt(),
      r = e * e;
    let a = -1;
    const o = new Float32Array(this.#Ro.buffer);
    for (let e = 0; e < this.splatCount; ++e) {
      const h = o[8 * e + 0],
        l = o[8 * e + 1],
        c = o[8 * e + 2],
        u = i.set(h, l, c),
        d = s.copy(u).sub(t.origin),
        f = d.dot(t.direction);
      if (f < 0 || f > t.length) continue;
      const p = n.copy(t.origin).addScaledVector(t.direction, f).sub(t.origin).sub(d);
      p.dot(p) > r || ((t.length = f), (a = f));
    }
    if (a < 0) return null;
    return { point: t.origin.clone().addScaledVector(t.direction, a), distance: a };
  }
  #gh(t) {
    const e = t.passes,
      i = this.#No,
      s = t.commandList;
    if (e.render || e.pick) {
      let t = this.#qo;
      (this.#ln.defined(t) || (t = this.#qo = new this.#ln.DrawCommand()),
        (t.pass = this.#Vo),
        this.#sh && (t.boundingVolume = this.#sh),
        (t.owner = this),
        (t.uniformMap = i),
        (t.vertexArray = this._va),
        (t.shaderProgram = this._sp),
        (t.renderState = this._rs),
        (t.modelMatrix = this.#eh),
        (t.pickId = 'czm_pickColor'),
        this.#Ho && ((t.count = 6 * this.#lh), (t.instanceCount = Math.ceil(this.#Oo / this.#lh))),
        s.push(t),
        e.pick);
    }
  }
  #yh(t) {
    let e = t.cache.lccMesh_indexBufferInstanced;
    if (this.#ln.defined(e)) return e;
    const i = new Uint16Array(6 * this.#lh);
    for (let t = 0; t < this.#lh; t++)
      ((i[6 * t + 0] = 4 * t + 0),
        (i[6 * t + 1] = 4 * t + 1),
        (i[6 * t + 2] = 4 * t + 2),
        (i[6 * t + 3] = 4 * t + 0),
        (i[6 * t + 4] = 4 * t + 2),
        (i[6 * t + 5] = 4 * t + 3));
    return (
      (e = this.#ln.Buffer.createIndexBuffer({
        context: t,
        typedArray: i,
        usage: this.#ln.BufferUsage.STATIC_DRAW,
        indexDatatype: this.#ln.IndexDatatype.UNSIGNED_SHORT,
      })),
      (e.vertexArrayDestroyable = !1),
      (t.cache.lccMesh_indexBufferInstanced = e),
      e
    );
  }
  #xh(t) {
    let e = t.cache.lccMesh_vertexBufferInstanced;
    if (this.#ln.defined(e)) return e;
    const i = new Float32Array(4 * this.#lh * 3);
    for (let t = 0; t < this.#lh; t++) i.set([1, 1, t, -1, 1, t, -1, -1, t, 1, -1, t], 4 * t * 3);
    return (
      (e = this.#ln.Buffer.createVertexBuffer({ context: t, typedArray: i, usage: this.#ln.BufferUsage.STATIC_DRAW })),
      (e.vertexArrayDestroyable = !1),
      (t.cache.lccMesh_vertexBufferInstanced = e),
      e
    );
  }
  #vh(t) {
    return [
      {
        index: 0,
        componentsPerAttribute: 3,
        componentDatatype: this.#ln.ComponentDatatype.FLOAT,
        vertexBuffer: this.#xh(t),
        normalize: !1,
        offsetInBytes: 0,
        strideInBytes: 0,
        instanceDivisor: 0,
      },
    ];
  }
  #bh(t, e) {
    return (
      (this._va = new this.#ln.VertexArray({ context: t, attributes: e, indexBuffer: this.#yh(t) })),
      (this._createVertexArray = !1),
      this._va
    );
  }
  #wh(t) {
    const e = this.dataDimensions.x,
      i = this.dataDimensions.y,
      s = new Float32Array(e * i * 4),
      n = new Uint32Array(s.buffer);
    for (let t = 0; t < this.#Ro.length; t++) n[t] = this.#Ro[t];
    this.#Ro = s;
    return new this.#ln.Texture({
      context: t,
      width: e,
      height: i,
      flipY: !1,
      skipColorSpaceConversion: !0,
      source: { arrayBufferView: s },
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: this.#ln.PixelFormat.RGBA,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
  }
  #Sh(t, e, i, s, n = 4) {
    const r = [],
      a = e.x;
    e.y;
    const o = Math.floor(t / a),
      h = t % a;
    if (o > 0) {
      const e = a * o * n;
      (r.push({ offsetX: 0, offsetY: 0, width: a, height: o, offsetCount: 0, count: e }),
        h > 0 && r.push({ offsetX: 0, OffsetY: o, width: h, height: 1, offsetCount: e, count: t * n }));
    } else r.push({ offsetX: 0, OffsetY: 0, width: h, height: 1, offsetCount: 0, count: t * n });
    for (; r.length > 0; ) {
      const t = r.shift(),
        { offsetX: e, offsetY: n, width: a, height: o, offsetCount: h, count: l } = t;
      i.copyFrom({
        xOffset: e,
        yOffset: n,
        source: { width: t.width, height: t.height, arrayBufferView: s.subarray(h, l) },
        skipColorSpaceConversion: !0,
        flipY: !1,
      });
    }
  }
  #Mh(t, e = 4, i) {
    const s = this.dimensions.x,
      n = this.dimensions.y;
    return new this.#ln.Texture({
      context: t,
      width: s,
      height: n,
      flipY: !1,
      skipColorSpaceConversion: !0,
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: 1 === e ? this.#ln.PixelFormat.RED : this.#ln.PixelFormat.RGBA,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
  }
  #Ch(t, e) {
    const i = this.dimensions.x,
      s = this.dimensions.y;
    return new this.#ln.Texture({
      context: t,
      width: i,
      height: s,
      flipY: !1,
      skipColorSpaceConversion: !0,
      source: { arrayBufferView: e },
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: this.#ln.PixelFormat.RGBA,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
  }
  #Eh(t) {
    if (!this.#$o) return;
    this.#In += 1;
    const e = this.#Qo,
      { x: i, y: s } = this.dimensions;
    e.copyFrom(
      {
        xOffset: 0,
        yOffset: 0,
        width: i,
        height: s,
        arrayBufferView: this.#$o,
        skipColorSpaceConversion: !0,
        source: { width: i, height: s, arrayBufferView: this.#$o },
        flipY: !1,
      },
      0,
      0,
    );
  }
  #Dh() {
    const t = this.#Pt.dynamicState;
    let e = et;
    if (!this.#Lo) {
      if (this.#nr) {
        ((this.#nr = !1), (this.#rr = t.tick));
        const e = this.node.parent,
          i = e.getNodeByLevel(e.initAroundLevel),
          s = this.node.points,
          n = i ? i.points : 0;
        if (0 != s && this.#P != e.totalLevel - 1) {
          const t = Math.ceil(ut.lerp(0, et, n / s));
          this.#ar = ut.clamp(t, 1, et);
        } else this.#ar = et;
      }
      if (1 == t.loadingSwitch && this.node.points > 10) {
        const i = (t.tick - this.#rr) / 1e3,
          s = ut.smoothstep(i, 0, 5),
          n = Math.ceil((et - this.#ar) * s);
        e = ut.clamp(this.#ar + n, 1, et);
      }
    }
    const i = t.useSH && this.hasUploadSH,
      s = t.clipBoxMatrixInv.toCesiumMatrix4(this.#ih),
      n = !(this.#Lo || t.pointsOnly || this.splatCount < 5e3) && t.useEdgeCrop;
    ((this.#No.use0 = function () {
      return { x: t.pointsOnly, y: i, z: t.useCustomColor, w: 0 };
    }),
      (this.#No.use1 = function () {
        return { x: t.useClipBox, y: t.clipBoxSide, z: 0, w: 0 };
      }),
      (this.#No.use2 = function () {
        return { x: t.alpha, y: n, z: t.useClipPlane, w: !(!t.useSemantic || !t.loadingReady) };
      }));
    const r = (t.loadingSplatDistance * t.loadingSplatDistance) / 100,
      a = (t.loadingPointDistance * t.loadingPointDistance) / 100,
      o = this.#Lo ? 0 : t.loadingSwitch;
    ((this.#No.use3 = function () {
      return { x: o, y: r, z: a, w: e };
    }),
      (this.#No.scPos = function () {
        return t.scenePositionLocal.clone();
      }),
      (this.#No.viewport = function () {
        return { x: t.viewport.x, y: t.viewport.y };
      }),
      (this.#No.cmrPos = function () {
        return t.cmrPosModelLocal.clone();
      }),
      (this.#No.clipPlane = function () {
        return t.clipPlane;
      }),
      (this.#No.clipBoxMatrixInv = function () {
        return s;
      }),
      this._rs !== t.renderState && ((this._rs = t.renderState), (this.#qo = void 0)),
      this.#Vo !== t.passIndex && (this.#Vo = t.passIndex));
  }
  #yr(t) {
    this.#Ko = !0;
    const e = this,
      i = (this.#Go = this.#wh(t)),
      s = (this.#Qo = this.#Ch(t, this.#$o)),
      n = this.#Pn.rainbowTex,
      r = this.#Tn.semanticColorsTex;
    let a;
    this.#Lo && this.#Jo ? (this.#Xo = a = this._setSHTexture(this.#Jo)) : (this.#Xo = a = this.#Pn.shTex);
    const o = new this.#ln.Matrix4(
      this.dimensions.x,
      this.dataDimensions.x,
      this.shDimensions.x,
      this.semDimensions.x,
      this.#zt.min.x - tt,
      this.#zt.min.y - tt,
      this.#zt.min.z - tt,
      0,
      this.#zt.max.x + tt,
      this.#zt.max.y + tt,
      this.#zt.max.z + tt,
      0,
      this.splatCount,
      this.#lh,
      0,
      this.#P,
    );
    this.#ln.Matrix4.transpose(o, o);
    const h = this.#Yo,
      l = this.#Zo,
      c = this.#dh();
    if (
      ((this.#No.pmat = () => c),
      (this.#No.czm_pickColor = () => e._pickId.color),
      (this.#No.vmat = () => o),
      (this.#No.prj2ECEF = () => h),
      (this.#No.prj2ECEF_INV = () => l),
      (this.#No.splatData = () => i),
      (this.#No.shRawTexture = () => a),
      (this.#No.customColors = () => n),
      (this.#No.semanticColors = () => r),
      (this.#No.splatIndexesHost = () => s),
      this.#No.lutScaleTexture)
    ) {
      const t = this.#Tn.lutScaleTex;
      this.#No.lutScaleTexture = () => t;
    }
    if (this.#No.lutShTexture) {
      const t = this.#Tn.lutShTex;
      this.#No.lutShTexture = () => t;
    }
    this.#No.semanticTexture && (this.#No.semanticTexture = () => {});
  }
  _setSemTexture(t) {
    this.isDestroyed() || this.hasUploadSem || ((this.hasUploadSem = !0), (this.#In += 1));
  }
  _setSHTexture(t) {
    if (this.isDestroyed()) return;
    if (this.hasUploadSH) return;
    ((this.hasUploadSH = !0), (this.#In += 1), (this.size = this.#ch()));
    const e = this.#Do,
      i = this.shDimensions.x,
      s = this.shDimensions.y,
      n = new Float32Array(i * s * 4),
      r = new Uint32Array(n.buffer),
      a = new Uint32Array(t);
    for (let t = 0; t < a.length; t++) r[t] = a[t];
    const o = new this.#ln.Texture({
      context: e,
      width: i,
      height: s,
      flipY: !1,
      skipColorSpaceConversion: !0,
      source: { arrayBufferView: n },
      pixelDatatype: this.#ln.PixelDatatype.FLOAT,
      pixelFormat: this.#ln.PixelFormat.RGBA,
      sampler: new this.#ln.Sampler({
        wrapS: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        wrapT: this.#ln.TextureWrap.CLAMP_TO_EDGE,
        minificationFilter: this.#ln.TextureMinificationFilter.NEAREST,
        magnificationFilter: this.#ln.TextureMagnificationFilter.NEAREST,
      }),
    });
    return ((this.#No.shRawTexture = () => o), o);
  }
  update(t) {
    this.isDestroyed() ||
      (this.show &&
        (this.isCached || this.#yr(t),
        this.isInitialized &&
          (this.#th && (this.#Eh(t.context), (this.#th = !1)),
          this.#ph(),
          this.#Dh(),
          (this.#Ho = t.context.instancedArrays),
          this._createVertexArray && ((this.#jo = this.#vh(t.context)), this.#bh(t.context, this.#jo)),
          this.#zo || this.#fh(t, this._vs, this._fs),
          this.#gh(t))));
  }
  isDestroyed() {
    return this.#f;
  }
  destroy() {
    if (!this.isDestroyed())
      return (
        (this.#f = !0),
        (this.#Ro = void 0),
        (this.distances = void 0),
        (this.indexes = void 0),
        (this.#$o = void 0),
        (this.pos = void 0),
        this.#Go && (!this.#Go.isDestroyed() && this.#Go.destroy(), (this.#Go = void 0)),
        this.#Wo &&
          this.#Wo !== this.#Pn.splatIndexTex &&
          (!this.#Wo.isDestroyed() && this.#Wo.destroy(), (this.#Wo = void 0)),
        this.#Qo && (!this.#Qo.isDestroyed() && this.#Qo.destroy(), (this.#Qo = void 0)),
        this.#Xo && this.#Xo !== this.#Pn.shTex && (!this.#Xo.isDestroyed() && this.#Xo.destroy(), (this.#Xo = void 0)),
        (this.#Pn = null),
        (this._pickId = this._pickId && this._pickId.destroy()),
        (this._sp = this._sp && this._sp.destroy()),
        (this._va = this._va && this._va.destroy()),
        this.#ln.destroyObject(this)
      );
  }
}
class Vs {
  #f = !1;
  #ln = void 0;
  #Do = void 0;
  #Pt = void 0;
  #G = void 0;
  #K = void 0;
  #jr = void 0;
  #$r;
  #Ah;
  #qr = [];
  #Ur = [];
  #Kr = [];
  #Wr = [];
  #Gr = [];
  #Qr = [];
  #Hr = void 0;
  #Or = void 0;
  #li;
  #Xr;
  constructor(t, e, i, s, n) {
    ((this.#li = t),
      (this.#ln = e),
      (this.#Pt = i),
      (this.#G = this.#Pt.gpuCache),
      (this.#K = this.#Pt.cpuCache),
      (this.#Do = i.lccParam.scene.context),
      (this.#$r = s),
      (this.#Xr = n),
      (this.#Or = new Ci(this.#Pt.config.CpuSortThreadNum)));
  }
  setModelMatrix(t) {
    t && (this.#$r = t);
  }
  setPrj2ECEFMatrix(t) {
    t && (this.#Ah = t);
  }
  #Jr() {
    if (this.#jr) return this.#jr;
    const t = this.#Pt.renderID,
      e = this.#Pt.meta,
      i = this.#K.queryEnv(t);
    if (!i || !e) return null;
    const { splatCounts: s, data: n, sh: r, pos: a } = i;
    return (
      (this.#jr = new qs(this.#Pt, {
        context: this.#Do,
        matrix: this.#$r,
        prj2ECEF: this.#Ah,
        node: i,
        splatCount: s,
        data: n,
        pos: a,
        sh: yt(r),
        isEnv: !0,
        meta: e,
        renderID: this.#li,
      })),
      this.#G.pushEnv(t, this.#jr),
      this.#jr
    );
  }
  getEnvMesh(t = !0) {
    return (this.#jr || this.#Jr(), this.#jr ? this.#jr : null);
  }
  getMesh(t, e = !0) {
    let i = this.#G.queryMesh(t.renderID, t.id);
    if (i && (!e || i.isInitialized)) return i;
  }
  clearCacheSHQueue() {
    this.#Ur = [];
  }
  pushCacheSHQueue(t) {
    this.#Ur.push(t);
  }
  clearCacheSemQueue() {
    this.#Kr = [];
  }
  pushCacheSemQueue(t) {
    this.#Kr.push(t);
  }
  pushCacheQueue(t) {
    this.#qr.push(t);
  }
  clearCacheQueue() {
    this.#qr = [];
  }
  pushSortQueue(t) {
    t.isSorting || (t.isFirstSorted, this.#Wr.push(t));
  }
  clearSortQueue() {
    ((this.#Wr = []), (this.#Gr = []));
  }
  update() {
    if (!this.#f) {
      this.#Or.update(this.#Xr);
      for (let t = 0; t < this.#qr.length && this.#Xr.isAvailable(); t++) {
        const i = this.#qr[t];
        if (!this.#G.hasMesh(i.renderID, i.id) && i?.isCache(e)) {
          const { data: t, sh: e, pos: s } = i.queryCache(),
            n = (t?.byteLength || 0) + (e?.byteLength || 0);
          ((this.#Xr.size += n), (this.#Xr.count += 1));
          const r = new qs(this.#Pt, {
            context: this.#Do,
            matrix: this.#$r,
            prj2ECEF: this.#Ah,
            splatCount: i.points,
            data: t,
            pos: s,
            sh: yt(e),
            node: i,
            renderID: this.#li,
          });
          this.#G.pushMesh(i.renderID, i.id, r, r.size);
        }
      }
      for (let t = 0; t < this.#Ur.length && this.#Xr.isAvailable(); ++t) {
        const e = this.#Ur[t],
          s = e.node;
        if (e.hasUploadSH || !s || !s.isCache(i)) continue;
        const { sh: n } = s.queryCache();
        ((this.#Xr.size += n.byteLength),
          (this.#Xr.count += 1),
          e._setSHTexture(n),
          this.#G.flushMesh(this.#li, s.id, e, e.size));
      }
      for (let t = 0; t < this.#Kr.length && this.#Xr.isAvailable(); ++t) {
        const e = this.#Kr[t],
          i = e.node;
        if (e.hasUploadSem || !i || !i.isCache(l)) continue;
        const { sem: s } = i.queryCache();
        ((this.#Xr.size += s.byteLength),
          (this.#Xr.count += 1),
          e._setSemTexture(s),
          this.#G.flushMesh(this.#li, i.id, e, e.size));
      }
      for (
        0 == this.#Qr.length && (this.#Qr = [...this.#Gr, ...this.#Wr]);
        this.#Qr.length > 0 && this.#Or.isReady();

      ) {
        let t = this.#Qr.shift();
        if (!t || t.isDispose || !t.checkNeedSort()) continue;
        const e = this.#Pt.dynamicState.cmrPosLocal,
          i = this.#Pt.dynamicState.cmrForwardLocal,
          s = new Mi();
        ((s.enableDepthSorting = this.#Pt.config.enableDepthSorting),
          (s.splatCount = t.splatCount),
          (s.camPos = { x: e.x, y: e.y, z: e.z }),
          (s.camForward = { x: i.x, y: i.y, z: i.z }),
          (s.distances = t.distances),
          (s.indexes = t.indexes),
          (s.transforms = t.pos),
          (s.mesh = t),
          (s.beginCallback = (t) => {
            t.mesh && !t.mesh.isDispose && t.mesh.startSorting();
          }),
          (s.endCalllback = (t) => {
            t.mesh &&
              !t.mesh.isDispose &&
              ((t.mesh.pos = t.transforms),
              (t.mesh.indexes = t.indexes),
              (t.mesh.distances = t.distances),
              t.mesh.endSorting());
          }),
          this.#Or.triggerSorting(s));
      }
    }
  }
  dispose() {
    this.#f ||
      ((this.#f = !0),
      (this.#Pt = void 0),
      (this.#G = void 0),
      (this.#K = void 0),
      (this.#Do = void 0),
      (this.#$r = void 0),
      this.#Or && (this.#Or.dispose(), (this.#Or = void 0)),
      this.#Hr && (this.#Hr.dispose(), (this.#Hr = void 0)),
      this.#jr && (this.#jr.destroy(), (this.#jr = void 0)));
  }
}
class Us extends Wt {
  static GlobalID = 0;
  #f = !1;
  #S;
  #ln;
  #Ye;
  #pa;
  #Re;
  #K;
  #G;
  #vt;
  #Ze;
  #ma;
  #Fh;
  #Ao;
  #Vo;
  #ga;
  #ya = [];
  #Xr;
  #Sa = !0;
  #Ea = new Ss();
  #Da = 0;
  #eh;
  #Ah;
  #Ph;
  #Xe = new kt();
  #Pt;
  #di = !1;
  #wa = !0;
  #va = new Fi();
  #Ma;
  #Ca = 0;
  #ba = !1;
  #Th = new pt();
  constructor(t) {
    (super(),
      (this.#S = Us.GlobalID++),
      (this.#Pt = t),
      (this.#Pt.renderID = this.#S),
      (this.#Re = this.#Pt.lccParam),
      (this.#Ye = this.#Pt.cameraMgr),
      (this.#K = this.#Pt.cpuCache),
      (this.#G = this.#Pt.gpuCache),
      (this.#vt = this.#Pt.collCache),
      (this.#Ze = this.#Pt.dataLoader),
      (this.#Xe = this.#Pt.config),
      (this.#ln = this.#Pt.lccParam.renderLib),
      (this.#Xr = new vi(this.#Pt.config.GpuMaxUploadCount, this.#Pt.config.GpuMaxUploadBytes)),
      (this.#eh = this.#Pt.modelMatrix),
      (this.#pa = new ai(this.#Pt, this.#Ye, this.#Ze)),
      (this.#Fh = zs()),
      (this.#Ao = this.#Pt.resources.renderState),
      (this.#Vo = this.#ln.Pass.CESIUM_3D_TILE),
      (this.#ma = new Vs(this.#S, this.#Re.renderLib, this.#Pt, this.#eh, this.#Xr)),
      (this.pointPrimitive = new this.#ln.PointPrimitiveCollection()),
      (this.#ga = new this.#ln.PrimitiveCollection({ destroyPrimitives: !1 })),
      this.#Re.scene.primitives.add(this.pointPrimitive),
      this.#Re.scene.primitives.add(this.#ga),
      (this.#Pt.resourcesScene = new js(this.#Re)));
  }
  get id() {
    return this.#S;
  }
  get root() {
    return this.#ga;
  }
  get distanceToCam() {
    if (!this.#di) return 1e6;
    return this.#pa.center.distanceToSquared(this.#Pt.dynamicState.cmrPosModelLocal);
  }
  get maxLoadSplatCount() {
    return this.#Xe.maxLoadSplatCount;
  }
  set maxLoadSplatCount(t) {
    (console.log('set max splats: ' + t), (this.#Xe.maxLoadSplatCount = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  get matrixWorld() {
    return new Ot().fromCesiumMatrix4(this.#eh);
  }
  get matrixWorldInverse() {
    return this.matrixWorld.invert();
  }
  get modelMatrix() {
    return this.#eh;
  }
  set modelMatrix(t) {
    this.#eh = t;
  }
  #Aa() {
    this.#Sa = !0;
  }
  clearRenderNextFrame() {
    this.#Sa = !1;
  }
  checkRenderNextFrame() {
    return this.#Sa;
  }
  #Ih() {
    return this.#ln.RenderState.fromCache({
      blending: this.#ln.BlendingState.ALPHA_BLEND,
      depthTest: { enabled: !0, func: this.#ln.WebGLConstants.ALWAYS },
      depthMask: !0,
      cull: { enabled: !1 },
      stencilTest: this.#ln.StencilConstants.setCesium3DTileBit(),
    });
  }
  setTranslation(t) {
    if (
      (this.modelMatrix
        ? this.#ln.Matrix4.setTranslation(this.modelMatrix, t, this.modelMatrix)
        : (this.modelMatrix = this.#ln.Matrix4.fromTranslation(t)),
      this.#Pt.isRTK)
    ) {
      (this.#ln.Matrix4.setTranslation(this.#Ah, t, this.#Ah), this.#Ph.fromCesiumMatrix4(this.#Ah).invert());
      const e = this.ecef2Prj(t);
      this.#Th.copy(e);
    }
    this.#pa.setConfigDirty();
  }
  setRotation(t) {
    if (this.modelMatrix) {
      const e = this.#ln.Matrix4.getTranslation(this.modelMatrix, new this.#ln.Cartesian3()),
        i = this.#ln.Transforms.eastNorthUpToFixedFrame(e),
        s = this.#ln.Matrix3.multiply(
          this.#ln.Matrix4.getRotation(i, new this.#ln.Matrix3()),
          t,
          new this.#ln.Matrix3(),
        );
      this.#ln.Matrix4.setRotation(this.modelMatrix, s, this.modelMatrix);
    } else this.modelMatrix = this.#ln.Matrix4.fromRotation(t);
    this.#pa.setConfigDirty();
  }
  setScale(t) {
    (this.modelMatrix
      ? this.#ln.Matrix4.setScale(this.modelMatrix, t, this.modelMatrix)
      : (this.modelMatrix = this.#ln.Matrix4.fromScale(t)),
      this.#pa.setConfigDirty());
  }
  setTranslationOffset(t) {
    if (this.modelMatrix) {
      let e = this.getTranslation();
      ((e.x += t.x), (e.y += t.y), (e.z += t.z), this.setTranslation(e));
    }
    this.#pa.setConfigDirty();
  }
  getTranslation() {
    return this.modelMatrix ? this.#ln.Matrix4.getTranslation(this.modelMatrix, new this.#ln.Cartesian3()) : null;
  }
  getInstancedMesh() {
    return this;
  }
  getEnvInstancedMesh() {
    return this;
  }
  getMeta() {
    if (this.#di) return this.#pa.metaJson;
    console.error('meta is not ready');
  }
  togglePointsDisplayMode() {
    ((this.#Xe.pointsOnly = !this.#Xe.pointsOnly), this.#Aa());
  }
  useEnvironment(t) {
    ((this.#Xe.useEnv = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  useShcoef(t, e) {
    ((this.#Xe.useSH = t),
      this.#pa.setConfigDirty(),
      this.#Aa(),
      this.#di
        ? t && this.#wa
          ? ((this.#wa = !1),
            this.#pa.loadSH(
              () => {},
              (t) => {
                e && e(t);
              },
              () => {
                console.error('load sh failed...');
              },
            ))
          : e && e(1)
        : console.error('meta is not ready'));
  }
  setSemantic(t) {
    ((this.#Xe.useSemantic = !!t), this.#Aa());
  }
  setSenmanticColor(t) {
    if (!Array.isArray(t) || 0 == t.length) return void console.error('set sem colors failed: error data structure');
    let e = !1;
    for (let i = 0; i < t.length; ++i) {
      const s = t[i];
      if (!Array.isArray(s) || 3 != s.length) {
        e = !0;
        break;
      }
    }
    e
      ? console.error('set sem colors failed: error data structure')
      : (this.#Pt.resourcesScene.updateSemanticColor(t), this.#Aa());
  }
  resetSemanticColor() {
    (this.#Pt.resourcesScene.resetSemanticColor(), this.#Aa());
  }
  setDepthSorting(t) {
    ((this.#Xe.enableDepthSorting = !!t), this.#Aa());
  }
  setVisible(t) {
    ((this.#Xe.visible = t), this.#Aa());
  }
  setPointsColor(t) {
    'default' === t || 'rainbow' === t
      ? ((this.#Xe.pointsColor = 'default' === t ? S : M), this.#Aa())
      : console.error('The input style is not supported.');
  }
  setAlpha(t) {
    ((t = ut.clamp(t, 0, 1)), (this.#Xe.alpha = t), this.#Aa());
  }
  setClipBox(t) {
    if (wt(t)) return (this.#va.reset(), (this.#Xe.useClipBox = !1), void this.#Aa());
    if (!(t && t.scale && t.rotation && t.position)) return void console.error('set failed !!!');
    const e = t.clipSide || 1,
      i = Ft('scale', t),
      s = Ft('rotation', t),
      n = Ft('position', t);
    i && s && n
      ? (this.#va.update(n, s, i, e), (this.#Xe.useClipBox = !0), this.#Aa())
      : console.error('set failed !!!');
  }
  setClipPlane(t, e) {
    if (wt(t)) return ((this.#Xe.useClipPlane = !1), void this.#Aa());
    Array.isArray(t) && 'number' == typeof e
      ? (this.#Pt.dynamicState.clipPlane.set(t[0], t[1], t[2], e), (this.#Xe.useClipPlane = !0), this.#Aa())
      : console.error('setClipPlane failed: param error');
  }
  setStartLod(t) {
    isNaN(t) || t < 0
      ? console.error('set failed !!!')
      : ((this.#Xe.MinLodUsed = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  getLodInfos() {
    return this.#pa.meta?.splats;
  }
  setEndLod(t) {
    isNaN(t) || t < 0
      ? console.error('set failed !!!')
      : ((this.#Xe.MaxLodUsed = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setMaxDistance(t) {
    isNaN(t) || t < 0
      ? console.error('set failed !!!')
      : ((this.#Xe.MaxDistaneLimit = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setMaxSplats(t) {
    isNaN(t) || t < 0
      ? console.error('set failed !!!')
      : (console.log('set max splats: ' + t), (this.#Xe.maxLoadSplatCount = t), this.#pa.setConfigDirty(), this.#Aa());
  }
  setMaxNodeSplats(t) {
    Ct(t) || t < 0
      ? console.error('set failed !!!')
      : (console.log('set max node splats: ' + t),
        (this.#Xe.LodLevelUpSpatsInNode = t),
        this.#pa.setConfigDirty(),
        this.#Aa());
  }
  getCurrentConfig() {
    return this.#Xe.getUserConfig();
  }
  setLodAutoLevelUp(t) {
    ((this.#Xe.useLodAutoOptimization = !!t), this.#pa.setConfigDirty(), this.#Aa());
  }
  getProjectionCoordinateSystemInfos() {
    const t = this.#Pt.meta;
    if (t) return { epsg: t?.epsg, offset: { x: t.offset[0], y: t.offset[1], z: t.offset[2] } };
  }
  updateCurrentConfig(t) {
    (this.#Xe.setUserConfig(t), this.#pa.setConfigDirty(), this.#Aa());
  }
  update(t) {
    if (this.#f) return;
    if (
      ((this.#ya = []),
      this.#ga.removeAll(),
      this.#Ia(t),
      this.#Xr.reset(),
      this.#ma.clearCacheQueue(),
      this.#ma.clearCacheSHQueue(),
      this.#ma.clearSortQueue(),
      this.#ma.clearCacheSemQueue(),
      this.#pa.update(t),
      !this.#di)
    )
      return;
    if ((this.#Ra(), this.#Xe.useLccCompress && !this.#Pt.resourcesScene.lutScaleTex)) return;
    this.#_a(t);
    const e = this.#pa.getRenderNodes();
    if ((this.#Na(e), this.#ka(), this.#Pt.dynamicState.useEnv)) {
      const t = this.#ma.getEnvMesh();
      t &&
        (t.isInitialized && this.#ba && (this.#ga.add(t), this.#ya.push(t)),
        t.checkNeedSort() && this.#ma.pushSortQueue(t));
    }
    (this.#ga._primitives.reverse(),
      this.#Ea.resize(this.#ya.length),
      this.#ya.forEach((t, e) => {
        (this.#Ea.setValue(e, t.id, t.flushID),
          t.isEnvMesh ||
            (this.#Xe.useSH && !t.hasUploadSH && this.#ma.pushCacheSHQueue(t),
            this.#Xe.useSemantic && this.#Xe.useLccCompress && !t.hasUploadSem && this.#ma.pushCacheSemQueue(t)));
      }));
    for (let t = this.#ya.length - 1; t >= 0; --t) {
      const e = this.#ya[t];
      if (!e.isEnvMesh) {
        const t = e.node;
        this.#G.touchMesh(t.renderID, t.id);
      }
    }
    (this.#ma.update(t),
      (this.#ga.show = this.#Xe.visible),
      this.#Ye.isCameraChanged && (this.#Da = 10),
      this.#Sa ||
        ((this.#Da > 0 ||
          this.#pa.isLoadingDirty ||
          this.#Xr.isChanged() ||
          this.#Ye.isCameraChanged ||
          this.#Ea.isChanged()) &&
          this.#Aa()),
      this.#Ea.backup(),
      (this.#Da = Math.max(0, this.#Da - 1)),
      this.#La());
  }
  load(t, e, i, s, n) {
    console.log('load ...');
    const r = { dataPath: t };
    ((r.metaSuccessFunc = (t) => {
      ((this.#di = !0), this.#_h(t), console.log('meta: ', t), this.#Ia(Date.now()));
    }),
      (r.successFunc = () => {
        (console.log('loading ready ...'), (this.#ba = !0), e && e(this));
      }),
      (r.progressFunc = (t) => {
        i && i(t);
      }),
      (r.failureFunc = () => {
        s && s();
      }),
      (r.checkFuncSplats = (t) => {
        if (!t) return !0;
        if (t.isColl) return !!t.isCacheData();
        if (t.isNode) {
          let e = this.#G.queryMesh(t.renderID, t.id);
          return !(!e || !e.isFirstSorted);
        }
        return (console.error('unknow chunk...(render)'), !0);
      }),
      'function' == typeof n && (r.preProcessFunc = n),
      this.#pa.load(r));
  }
  #_h(t) {
    !t.epsg || t.epsg < 1 ? (this.#Pt.isRTK = !1) : (this.#Pt.isRTK = !0);
    const { epsg: e, offset: i } = t;
    if (e > 0) {
      let s = `EPSG:${e}`,
        n = 'EPSG:4326',
        r = new pt().fromArray(i),
        a = this.#Fh(s, n, r.toArray()),
        o = this.#ln.Cartesian3.fromDegrees(a[0], a[1], a[2]);
      ((t.srcCode = s),
        (t.targetCode = n),
        (t.metaOffset = r),
        (t.wgs84BLH = new pt().fromArray(a)),
        (t.wgs84Offset = new pt().copy(o)),
        (t.ecefMatrix = this.#ln.Transforms.eastNorthUpToFixedFrame(o)),
        (t.prj2EcefMatrix = new Ot().fromCesiumMatrix4(t.ecefMatrix)),
        (t.prj2EcefMatrixInverse = t.prj2EcefMatrix.clone().invert()),
        (this.#eh = this.#ln.Matrix4.fromTranslation(o)),
        (this.#Ah = t.ecefMatrix),
        (this.#Ph = t.prj2EcefMatrixInverse),
        this.#Th.copy(r),
        this.#ma.setModelMatrix(this.#eh),
        this.#ma.setPrj2ECEFMatrix(this.#ln.Matrix4.getMatrix3(this.#Ah, new this.#ln.Matrix3())),
        this.#Rh());
    } else
      (this.#ma.setModelMatrix(this.#eh),
        (this.#Ah = this.#eh),
        this.#ma.setPrj2ECEFMatrix(this.#ln.Matrix4.getMatrix3(this.#Ah, new this.#ln.Matrix3())));
  }
  #Rh() {
    const { units: t, maxIndex: e } = this.#pa.getAllUnits();
    for (let e = 0; e < t.length; e++) {
      const i = t[e],
        s = i.getBBox(),
        { max: n, min: r } = s,
        a = new this.#ln.Cartesian3(r.x, r.y, r.z),
        o = new this.#ln.Cartesian3(n.x, r.y, r.z),
        h = new this.#ln.Cartesian3(n.x, n.y, r.z),
        l = new this.#ln.Cartesian3(r.x, n.y, r.z),
        c = this.prj2Ecef(a, !0),
        u = this.prj2Ecef(o, !0),
        d = this.prj2Ecef(h, !0),
        f = this.prj2Ecef(l, !0),
        p = this.#ln.Cartesian3.subtract(c, f, new this.#ln.Cartesian3());
      this.#ln.Cartesian3.normalize(p, p);
      const m = this.#ln.Cartesian3.subtract(c, u, new this.#ln.Cartesian3());
      this.#ln.Cartesian3.normalize(m, m);
      const g = new this.#ln.Cartesian3(-p.x, -p.y, -p.z),
        y = new this.#ln.Cartesian3(-m.x, -m.y, -m.z),
        x = new pt().copy(d).add(f).divideScalar(2).sub(this.getTranslation()),
        v = new pt().copy(c).add(u).divideScalar(2).sub(this.getTranslation()),
        b = new pt().copy(c).add(f).divideScalar(2).sub(this.getTranslation()),
        w = new pt().copy(u).add(d).divideScalar(2).sub(this.getTranslation());
      i.setBounding({
        up: p,
        right: m,
        down: g,
        left: y,
        e1: c,
        e2: u,
        e3: d,
        e4: f,
        upEC: x,
        downEC: v,
        leftEC: b,
        rightEC: w,
      });
    }
  }
  proj4(t, e, i) {
    return this.#Fh(t, e, i);
  }
  prj2Ecef(t, e = !0) {
    if (!this.#Pt.isRTK) return (console.log('lcc data is not rtk data.'), t);
    const i = [t.x, t.y, t.z];
    if (e) {
      const t = this.#Pt.meta.offset;
      ((i[0] += t[0]), (i[1] += t[1]), (i[2] += t[2]));
    }
    const s = this.#Pt.meta.srcCode,
      n = this.#Pt.meta.targetCode,
      r = this.#Fh(s, n, i);
    return this.#ln.Cartesian3.fromDegrees(r[0], r[1], r[2]);
  }
  ecef2Prj(t) {
    var e = this.#ln.Cartographic.fromCartesian(t);
    const i = [this.#ln.Math.toDegrees(e.longitude), this.#ln.Math.toDegrees(e.latitude), e.height],
      s = this.#Pt.meta.srcCode,
      n = this.#Pt.meta.targetCode,
      r = this.#Fh(n, s, i);
    return new pt().fromArray(r);
  }
  raycast(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.evt || Ct(t.evt.x) || Ct(t.evt.y) || Ct(t.maxDistance) || Ct(t.radius)) return null;
    if (t.maxDistance < 0 || t.radius < 0) return null;
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return this.raycastFromOrigin({
      origin: { x: s.x, y: s.y, z: s.z },
      direction: { x: n.x, y: n.y, z: n.z },
      maxDistance: t.maxDistance,
      radius: t.radius,
    });
  }
  raycastFromOrigin(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.origin || !t.direction || Ct(t.maxDistance) || Ct(t.radius)) return null;
    if (Ct(t.origin.x) || Ct(t.origin.y) || Ct(t.origin.z)) return null;
    if (Ct(t.direction.x) || Ct(t.direction.y) || Ct(t.direction.z)) return null;
    if (t.maxDistance < 0 || t.radius < 0) return null;
    const e = new pt(t.origin.x, t.origin.y, t.origin.z),
      i = new pt(t.direction.x, t.direction.y, t.direction.z).normalize(),
      s = new gi(e, i, t.maxDistance);
    let n, r;
    this.#Pt.isRTK
      ? ((n = s.clone().applyMatrix4(new Ot().copy(this.#Ph))),
        (r = s.clone().applyMatrix4(new Ot().copy(this.matrixWorldInverse))))
      : (n = r = s.clone().applyMatrix4(new Ot().copy(this.matrixWorldInverse)));
    const a = t.radius;
    let o = [];
    (this.#ya.forEach((t) => {
      if (t.isEnv) return;
      const e = t.getBBox(),
        i = n.intersectBox(e);
      if (!i) return;
      const s = this.#Ta(t.node.parent);
      o.push({ mesh: s || t, distance: i.distance });
    }),
      o.sort((t, e) => t.distance - e.distance));
    for (let t = 0; t < o.length; ++t) {
      let e = o[t].mesh.intersectWithRay(r, a);
      if (e) {
        const t = e.point;
        return (t.applyMatrix4(this.matrixWorld), { x: t.x, y: t.y, z: t.z });
      }
    }
    return null;
  }
  #Ta(t) {
    if (!t) return null;
    const e = t.nodes.length;
    for (let i = 0; i < e; i++) {
      const e = t.nodes[i];
      if (e) {
        const i = this.#G.queryMesh(t.renderID, e?.id, !1);
        if (i) return i;
      }
    }
    return null;
  }
  _paramToRay(t) {
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return new gi(s, n, t.maxDistance);
  }
  _paramToRayFromOrigin(t) {
    const e = new pt(t.origin.x, t.origin.y, t.origin.z),
      i = new pt(t.direction.x, t.direction.y, t.direction.z).normalize();
    return new gi(e, i, t.maxDistance);
  }
  intersectsRayExt(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.evt || Ct(t.evt.x) || Ct(t.evt.y) || Ct(t.maxDistance)) return null;
    if (t.maxDistance < 0) return null;
    if (!this.hasCollision()) return null;
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return this.intersectsRayFromOriginExt({
      origin: { x: s.x, y: s.y, z: s.z },
      direction: { x: n.x, y: n.y, z: n.z },
      maxDistance: t.maxDistance,
    });
  }
  intersectsRayFromOriginExt(t) {
    if (this.#f) return (console.error('The renderer had been dispose !!!'), null);
    if (!t || !t.origin || !t.direction || Ct(t.maxDistance)) return null;
    if (Ct(t.origin.x) || Ct(t.origin.y) || Ct(t.origin.z)) return null;
    if (Ct(t.direction.x) || Ct(t.direction.y) || Ct(t.direction.z)) return null;
    if (t.maxDistance < 0) return null;
    if (!this.hasCollision()) return null;
    const e = new pt(t.origin.x, t.origin.y, t.origin.z),
      i = new pt(t.direction.x, t.direction.y, t.direction.z).normalize();
    let s = new gi(e, i, t.maxDistance).clone();
    this.#Pt.isRTK ? s.applyMatrix4(new Ot().copy(this.#Ph)) : s.applyMatrix4(new Ot().copy(this.matrixWorldInverse));
    let n,
      r = s.origin;
    n =
      s.length === 1 / 0
        ? s.origin.clone().addScaledVector(s.direction, 1e5)
        : s.origin.clone().addScaledVector(s.direction, s.length);
    const a = new ie().setFromPoints([r, n]),
      o = this.#pa.getUnitsFromBBox(a.min, a.max);
    let h = [];
    for (let t = 0; t < o.length; ++t) {
      const e = o[t];
      if (!e || !e.coll) continue;
      const i = e.coll.queryCacheData();
      if (!i) continue;
      const n = s.intersectBox(e.getBBox());
      n && h.push({ ccd: i, distance: n.distance });
    }
    h.sort((t, e) => t.distance - e.distance);
    for (let t = 0; t < h.length; ++t) {
      const e = gs(h[t].ccd, s);
      if (!e) continue;
      let i, n;
      if (this.#Pt.isRTK) {
        const t = new Ot().fromCesiumMatrix4(this.#Ah);
        ((i = e.point), i.applyMatrix4(t), (n = e.normal), n.transformDirection(t));
      } else ((i = e.point), i.applyMatrix4(this.matrixWorld), (n = e.normal), n.transformDirection(this.matrixWorld));
      return { point: { x: i.x, y: i.y, z: i.z }, normal: { x: n.x, y: n.y, z: n.z } };
    }
    return null;
  }
  intersectsSphere(t) {
    let e = { hit: !1, delta: { x: 0, y: 0, z: 0 } };
    if (this.#f) return (console.error('The renderer had been dispose !!!'), e);
    if (!t || !t.center || Ct(t.radius)) return e;
    if (Ct(t.center.x) || Ct(t.center.y) || Ct(t.center.z)) return e;
    if (!this.hasCollision()) return e;
    let i = new pt(t.center.x, t.center.y, t.center.z);
    this.#Pt.isRTK ? i.applyMatrix4(new Ot().copy(this.#Ph)) : i.applyMatrix4(new Ot().copy(this.matrixWorldInverse));
    const s = new Qe(i, t.radius),
      n = new ie();
    s.getBoundingBox(n);
    const r = this.#pa.getUnitsFromBBox(n.min, n.max);
    let a = [];
    for (let t = 0; t < r.length; ++t) {
      const e = r[t];
      if (!e || !e.coll) continue;
      const i = e.coll.queryCacheData();
      i && a.push(i);
    }
    if (t.noDelta)
      for (let t = 0; t < a.length; ++t) {
        if (xs(a[t], s)) {
          e.hit = !0;
          break;
        }
      }
    else {
      let t = !1,
        i = new pt(0, 0, 0);
      for (let e = 0; e < a.length; ++e) {
        const n = a[e],
          { hit: r, delta: o } = vs(n, s);
        r && ((t = !0), i.add(o), s.translate(o));
      }
      if (t)
        if (this.#Pt.isRTK) {
          const t = new Ot().fromCesiumMatrix4(this.#Ah);
          i.transformDirectionWithoutNormlize(t);
        } else i.transformDirectionWithoutNormlize(this.matrixWorld);
      ((e.hit = t), (e.delta = { x: i.x, y: i.y, z: i.z }));
    }
    return e;
  }
  intersectsCapsule(t) {
    let e = { hit: !1, delta: { x: 0, y: 0, z: 0 } };
    if (this.#f) return (console.error('The renderer had been dispose !!!'), e);
    if (!t || !t.start || !t.end || Ct(t.radius)) return e;
    if (Ct(t.start.x) || Ct(t.start.y) || Ct(t.start.z)) return e;
    if (Ct(t.end.x) || Ct(t.end.y) || Ct(t.end.z)) return e;
    if (!this.hasCollision()) return e;
    const i = new Ot().copy(this.matrixWorldInverse),
      s = new pt(t.start.x, t.start.y, t.start.z),
      n = new pt(t.end.x, t.end.y, t.end.z);
    this.#Pt.isRTK ? (s.applyMatrix4(this.#Ph), n.applyMatrix4(this.#Ph)) : (s.applyMatrix4(i), n.applyMatrix4(i));
    const r = new Pi(s, n, t.radius),
      a = new ie();
    r.calAABB(a);
    const o = this.#pa.getUnitsFromBBox(a.min, a.max);
    let h = [];
    for (let t = 0; t < o.length; ++t) {
      const e = o[t];
      if (!e || !e.coll) continue;
      const i = e.coll.queryCacheData();
      i && h.push(i);
    }
    if (t.noDelta)
      for (let t = 0; t < h.length; ++t) {
        if (bs(h[t], r)) {
          e.hit = !0;
          break;
        }
      }
    else {
      let t = !1,
        i = new pt(0, 0, 0);
      for (let e = 0; e < h.length; ++e) {
        const s = h[e],
          { hit: n, delta: a } = ws(s, r);
        n && ((t = !0), i.add(a), r.translate(a));
      }
      if (t)
        if (this.#Pt.isRTK) {
          const t = new Ot().fromCesiumMatrix4(this.#Ah);
          i.transformDirectionWithoutNormlize(t);
        } else i.transformDirectionWithoutNormlize(this.matrixWorld);
      ((e.hit = t), (e.delta = { x: i.x, y: i.y, z: i.z }));
    }
    return e;
  }
  setRenderState(t) {
    if (!t) return;
    t.hasOwnProperty('passIndex') && t.passIndex !== this.#Vo && (this.#Vo = t.passIndex);
    let e = { ...this.#ln.RenderState.getState(this.#Ao), ...t };
    (delete e.passIndex, (this.#Ao = this.#ln.RenderState.fromCache(e)));
  }
  lowerToBottom() {
    this.#Re.scene.primitives.lowerToBottom(this.#ga);
  }
  raiseToTop() {
    this.#Re.scene.primitives.raiseToTop(this.#ga);
  }
  hasShcoef() {
    return !!this.#di && this.#pa.hasSH;
  }
  hasEnvironment() {
    return !!this.#di && this.#pa.hasEnvironment;
  }
  hasCollision() {
    return !!this.#di && this.#pa.hasColl;
  }
  getBounds() {
    if (!this.#di) return null;
    const t = this.getTranslation();
    let e = this.#pa.bbox;
    if (!e) return null;
    let i = e.min,
      s = e.max;
    return { min: { x: i.x, y: i.y, z: i.z }, max: { x: s.x, y: s.y, z: s.z }, origin: { x: t.x, y: t.y, z: t.z } };
  }
  #Fa(t) {
    const e = this.#Ye.projectionMatrix.clone().invert(),
      i = Pt(this.#Re.canvas, t.evt);
    i.applyMatrix4(e).applyMatrix4(this.#Ye.cam2WorldMatrix);
    const s = this.#Ye.position.clone(),
      n = i.sub(s).normalize();
    return new gi(s, n, t.maxDistance)
      .applyMatrix4(new Ot().copy(this.matrixWorld).invert())
      .intersectBox(this.#pa.bbox);
  }
  #Ia(t) {
    const e = this.#Re.canvas,
      i = this.#Pt.dynamicState,
      s = e.width,
      n = e.height,
      r = this.#Ye.fov,
      a = this.#Ye.projectionMatrix,
      o = this.#Ye.cam2WorldMatrix,
      h = this.matrixWorldInverse,
      l = new Ot().multiplyMatrices(h, o),
      c = this.#Ye.position,
      u = new pt(0, 0, -1).transformDirection(o),
      d = this.#Ye.position.clone().applyMatrix4(h),
      f = u.clone().transformDirection(h);
    if (
      ((i.focal = Math.max(s, n) / 2 / Math.tan((r / 2 / 180) * Math.PI)),
      (i.viewport.x = s),
      (i.viewport.y = n),
      i.cmrPos.copy(c),
      i.cmrForward.copy(u),
      i.cmrPosLocal.copy(d),
      i.cmrForwardLocal.copy(f),
      i.cmrProjMatrix.copy(a),
      i.cmr2LocalMatrix.copy(l),
      (i.frustum = new si()),
      i.frustum.setFromProjectionMatrix(a),
      this.#Pt.isRTK)
    ) {
      const t = this.ecef2Prj(c).sub(this.#Th),
        e = new Ot().multiplyMatrices(this.#Ph, o);
      (i.cmrPosModelLocal.copy(t),
        i.cmr2ModelLocalMatrix.copy(e),
        i.frustum.planes.forEach((t) => t.applyMatrix4(i.cmr2ModelLocalMatrix)),
        (i.ndc2local = e));
    } else
      (i.cmrPosModelLocal.copy(d),
        i.cmr2ModelLocalMatrix.copy(l),
        i.frustum.planes.forEach((t) => t.applyMatrix4(l)),
        (i.ndc2local = new Ot()));
    ((i.alpha = this.#Xe.alpha),
      (i.visible = this.#Xe.visible),
      (i.useEnv = this.#Xe.useEnv),
      (i.useSH = this.#Xe.useSH),
      (i.pointsOnly = this.#Xe.pointsOnly),
      (i.useCustomColor = !(this.#Xe.pointsColor !== M)),
      (i.clipBoxSide = this.#va.clipSide),
      i.clipBoxMatrixInv.copy(this.#va.matrixInverse),
      (i.renderState = this.#Ao),
      (i.passIndex = this.#Vo),
      (i.useEdgeCrop = this.#Xe.useEdgeCrop),
      (i.useClipPlane = this.#Xe.useClipPlane),
      (i.useClipBox = this.#Xe.useClipBox),
      (i.useSemantic = this.#Xe.useSemantic),
      (i.tick = t));
  }
  #_a(t) {
    this.#Pt.dynamicState.loadingReady = this.#ba;
  }
  #Ra() {
    if (!this.#Xe.useLccCompress) return;
    const t = this.#Pt.resourcesScene,
      e = this.#K.queryLut(this.#S, o),
      i = this.#K.queryLut(this.#S, h);
    (!t.lutScaleTex && e && t.setLutScale(e.data), !t.lutShTex && i && t.setLutSH(i.data));
  }
  #Na(t) {
    if (0 == t.length) return;
    const i = this.#pa.minLimitLod,
      s = this.#Xe.maxLoadSplatCount >= this.#Xe.TemporaryUnlimitReqiredSplatCount;
    for (let n = 0; n < t.length; ++n) {
      const r = t[n];
      if (!r || r.points < this.#Xe.MinValidSplatsInNode) continue;
      const a = r.parent,
        o = s ? 0 : this.#Xe.useLodAutoOptimization ? Math.min(r.level, i) : r.level,
        h = a.nodes.length;
      let l,
        c = this.#G.queryMesh(r.renderID, r.id);
      if (
        (c
          ? (c.checkNeedSort() && this.#ma.pushSortQueue(c), c.isCanShow() && (l = c))
          : r.isCache(e) && this.#ma.pushCacheQueue(r),
        !l)
      ) {
        let t = 0;
        for (let e = o; e < h; e++) {
          const i = a.nodes[e];
          if (!i || i.points < this.#Xe.MinValidSplatsInNode) continue;
          const s = this.#G.queryMesh(i.renderID, i.id);
          if (!s || !s.isInitialized) continue;
          const n = s.sortTickLast;
          n > t && ((t = n), (l = s));
        }
      }
      l &&
        (this.#ya.push(l),
        this.#ga.add(l),
        l != c && l.checkNeedSort() && !this.#Xe.useLodAutoOptimization && this.#ma.pushSortQueue(l));
    }
  }
  #ka() {
    if (this.#ba) return;
    const t = this.#pa.getLoadingNodes();
    for (let i = 0; i < t.length; ++i) {
      const s = t[i];
      if (!s) continue;
      let n = this.#G.queryMesh(s.renderID, s.id);
      !n && s.isCache(e) ? this.#ma.pushCacheQueue(s) : n && !n.isFirstSorted && this.#ma.pushSortQueue(n);
    }
  }
  #La() {
    let t = 0,
      e = 0,
      i = 1e9;
    this.#ya.forEach((s) => {
      ((t += s.splatCount), (e = Math.max(e, s.splatCount)), (i = Math.min(i, s.splatCount)));
    });
    const s = this.#Pt.performance;
    ((s.totalPoints = t),
      (s.maxPoints = e),
      (s.minPoints = i),
      (s.meshNum = this.#ya.length),
      (s.bwLimitCount = this.#Xr.limitCount),
      (s.bwLimitSize = this.#Xr.limitSize));
    const n = this.#Pt.dynamicState.tick;
    if ((void 0 === this.#Ma && (this.#Ma = n), n - this.#Ma > 2e3 && 325879 === this.#Ca)) {
      this.#Ma = n;
      let t = {};
      (console.log('perf: ', s),
        console.log(
          '  ',
          this.#ya.map((t) => t?.node?.level),
        ),
        console.log(
          '  ',
          this.#ya.map((t) => t?.node?.points),
        ),
        this.#ya.forEach((e, i) => {
          t[e?.node?.level] = (t[e?.node?.level] || 0) + e.splatCount;
        }),
        console.log('  ', t),
        325879 === this.#Ca && console.log('conf: ', this.#Pt.config),
        (this.#Ca = 0));
    }
  }
  _tD3qmTg9vF2jLmA9(t) {
    Ct(t) || (this.#Ca = t);
  }
  dispose() {
    if (this.#f) return;
    ((this.#f = !0),
      this.#ga && !this.#ga.isDestroyed() && (this.#Re.scene.primitives.remove(this.#ga), (this.#ga = void 0)),
      this.#ma.dispose());
    const t = [],
      e = [];
    (this.#pa.getAllNodeID(t),
      this.#pa.getAllCollID(e),
      this.#pa.dispose(),
      this.#K.clear(this.id, t),
      this.#G.clear(this.id, t),
      this.#vt?.clear(this.id, e),
      this.#Pt.resourcesScene.dispose(),
      (this.#Pt.resourcesScene = null));
  }
}
class Ks extends qe {
  isDispose = !1;
  #yo;
  #Re;
  #Ye;
  #K;
  #G;
  #vt;
  #Ze;
  #ae;
  #xo = [];
  #Pn;
  #vo;
  #oe;
  #bo;
  #ee;
  constructor(t, e, i) {
    (super(),
      (this.#yo = t),
      (this.#Re = e),
      (this.#bo = new Ns(e.canvas, e.scene.context._gl, e.appKey)),
      (e.waterMark = this.#bo),
      (this.#vo = new Bt(t, e.configExternal)),
      (this.#Pn = new Hs(e)),
      (this.#Ye = new ks(e)),
      (this.#K = new Yt(this.#vo.MaxCPUCacheSize, void 0)),
      (this.#G = new ye(this.#vo.MaxGPUCacheSize, (t, e, i) => {
        e && e.destroy();
      })),
      (this.#vt = new xe(this.#vo.MaxCPUCollCacheSize, void 0, this.#vo.MaxGPUCollCacheSize, (t, e, i) => {
        e && e.destroy();
      })),
      (this.#ae = new Os(this.#vo.DecompressThreadNum)),
      (this.#oe = new ze(this.#vo.CollBuildThreadNum)),
      (this.#ee = new Ie(v, this.#vo.LocalCacheNum, this.#K, this.#G, this.#vt, 'function' == typeof i)),
      (this.#ee.enabled = this.#Re.useIndexDB),
      this.#ee.setMaxIndexDBCacheSize(this.#vo.MaxIndexDBCacheSize),
      (this.#Ze = new je(this.#K, this.#oe, this.#ae, this.#ee, i, !0, !0)));
  }
  get wm() {
    return this.#bo;
  }
  createRenderer(t) {
    let e = new kt(this.#yo);
    ((e.useEnv = this.#Re.useEnv),
      (e.gpuAcceleration = this.#Re.gpuAcceleration),
      (e.pointsColor = this.#Re.pointsColor),
      (e.useLoadingEffect = this.#Re.useLoadingEffect),
      (e.loadingEffectCenter = this.#Re.loadingEffectCenter),
      this.#Re.useLccPerf && (e.enableDepthSorting = !0));
    let i = t.modelMatrix ? t.modelMatrix : this.#Re.renderLib.Matrix4.clone(this.#Re.renderLib.Matrix4.IDENTITY),
      s = new ni();
    ((s.config = e),
      (s.configCommon = this.#vo),
      (s.lccParam = this.#Re),
      (s.cpuCache = this.#K),
      (s.gpuCache = this.#G),
      (s.collCache = this.#vt),
      (s.dataLoader = this.#Ze),
      (s.resources = this.#Pn),
      (s.cameraMgr = this.#Ye),
      (s.platform = this.#yo),
      (s.localCacheMgr = this.#ee),
      (s.modelMatrix = i));
    let n = new Us(s);
    return (this.#xo.push(n), n);
  }
  update(t) {
    if (
      (this.#Ye._update(t),
      this.#K.update(t),
      this.#G.update(t),
      this.#vt.update(t),
      this.#Ze.update(t),
      this.#ae?.update(t),
      this.#oe.update(t),
      this.#ee.update(t),
      this.#xo.forEach((e) => {
        e.update(t);
      }),
      this.#xo.length > 1)
    ) {
      const t = this.#xo.map((t, e) => e);
      t.sort((t, e) => this.#xo[e].distanceToCam - this.#xo[t].distanceToCam);
      for (let e = 0; e < t.length; ++e) {
        const i = t[e];
        this.#xo[i].raiseToTop();
      }
    }
  }
  getAllRenderers() {
    return this.#xo;
  }
  destroyRenderer(t) {
    this.#xo.indexOf(t) < 0 ||
      (this.#Ze.unload(t.id),
      this.#ae.unload(t.id),
      this.#oe.unload(t.id),
      this.#ee.unload(t.id),
      (this.#xo = this.#xo.filter((e) => e !== t)),
      t?.dispose());
  }
  dispose() {
    this.isDispose ||
      (this.#xo.forEach((t) => {
        t.dispose();
      }),
      (this.#xo = []),
      this.#Ze.dispose(),
      this.#ae.dispose(),
      this.#oe.dispose(),
      this.#ee.update(),
      this.#G.dispose(),
      this.#K.dispose(),
      this.#vt.dispose(),
      this.#Ye._dispose(),
      this.#Pn._dispose(),
      (this.isDispose = !0));
  }
  raycast(t) {
    if (0 == this.#xo.length) return null;
    if (1 == this.#xo.length) return this.#xo[0].raycast(t);
    const e = [];
    return (
      this.#xo.forEach((i, s, n) => {
        let r = i._paramToRay(t),
          a = i.raycast(t);
        if (a) {
          let t = r.origin.distanceToSquared(new pt(a.x, a.y, a.z));
          e.push({ intersect: a, distance: t, renderIndex: s });
        }
      }),
      e.sort((t, e) => t.distance - e.distance),
      e.length > 0 ? e[0].intersect : null
    );
  }
  raycastFromOrigin(t) {
    if (0 == this.#xo.length) return null;
    if (1 == this.#xo.length) return this.#xo[0].raycastFromOrigin(t);
    const e = [];
    return (
      this.#xo.forEach((i, s, n) => {
        let r = i._paramToRayFromOrigin(t),
          a = i.raycastFromOrigin(t);
        if (a) {
          let t = r.origin.distanceToSquared(new pt(a.x, a.y, a.z));
          e.push({ intersect: a, distance: t, renderIndex: s });
        }
      }),
      e.sort((t, e) => t.distance - e.distance),
      e.length > 0 ? e[0].intersect : null
    );
  }
  clearIndexDB() {
    this.#ee.enabled && this.#ee.clearLCCIndexDB();
  }
}
class Gs {
  #f = !1;
  #Nh = null;
  #Bh = null;
  #kh;
  #Re;
  constructor(e, i) {
    if (
      (console.log('******************************************'),
      console.log('sdk version: ' + t),
      console.log('build time: ', '2025/10/22 18:29:03'),
      console.log('******************************************'),
      !e)
    )
      throw new Error('no params !');
    if ((e.appKey || console.warn('Warning: No appKey provided to the WebSDK!'), !e.scene))
      throw new Error('no scene !');
    if (!e.camera) throw new Error('no camera !');
    if (!e.canvas) throw new Error('no canvas !');
    if (!e.renderLib) throw new Error('no renderLib !');
    const s = new Rt(e.renderLib);
    if (s.libType === b) throw new Error('unknow engine type !');
    if (s.libType === x && !e.renderer) throw new Error('no renderer !');
    this.#Bh = e;
    const n = 'boolean' != typeof e.useEnv || e.useEnv,
      r = 'boolean' == typeof e.gpuAcceleration && e.gpuAcceleration,
      a = 'default' === e.pointsColor ? S : M,
      o = 'boolean' != typeof e.useIndexDB || e.useIndexDB,
      h = 'boolean' == typeof e.useLoadingEffect && e.useLoadingEffect,
      l = (function (t) {
        return (
          'object' == typeof t &&
          null != t &&
          'number' == typeof t.x &&
          'number' == typeof t.y &&
          'number' == typeof t.z
        );
      })((c = e.loadingEffectCenter))
        ? new pt(c.x, c.y, c.z)
        : null;
    var c;
    const u = 'boolean' == typeof e.writeDepth && e.writeDepth,
      d = 'boolean' == typeof e.useCorrectCoordSystem && e.useCorrectCoordSystem,
      f = 'boolean' == typeof e.useLccPerf && e.useLccPerf,
      p = 'boolean' != typeof e.useDefaultRenderLoop || e.useDefaultRenderLoop,
      m = new Nt();
    ((m.MaxCPUCacheSize = St(e.maxHostCacheSize, 10485760) ? e.maxHostCacheSize : void 0),
      (m.MaxGPUCacheSize = St(e.maxGpuCacheSize, 10485760) ? e.maxGpuCacheSize : void 0));
    let g = {
      scene: e.scene,
      camera: e.camera,
      canvas: e.canvas,
      renderLib: e.renderLib,
      renderer: e.renderer,
      modelMatrix: e.modelMatrix,
      useEnv: n,
      useIndexDB: o,
      useLccPerf: f,
      useLoadingEffect: h,
      loadingEffectCenter: l,
      gpuAcceleration: r,
      pointsColor: a,
      appKey: e.appKey,
      writeDepth: u,
      libType: s.libType,
      configExternal: m,
      useCorrectCoordSystem: d,
      useDefaultRenderLoop: p,
    };
    ((this.#Re = g),
      s.libType === x
        ? ((this.#Nh = new Bs(s, g, i)),
          (e.scene.onAfterRender = (t) => {
            (t.resetState(), this.#Nh && this.#Nh.wm.update(), t.resetState());
          }))
        : ((g.defaultSupportWebgl2 = 'function' == typeof e.renderLib?.FeatureDetection?.supportsWebgl2),
          (function (t = !0) {
            t || (oi.gl_FragColor = 'gl_FragColor');
          })(g.defaultSupportWebgl2),
          (this.#Nh = new Ks(s, g, i)),
          (this.#kh = e.scene.render),
          this.#zh(this.#Bh)));
  }
  #zh(t) {
    if (t?.scene) {
      const e = this.#Nh;
      (t.scene.postUpdate.addEventListener(function () {
        if (e && !e?.isDispose) {
          const i = Date.now();
          e.update(i);
          let s = !1;
          (e.getAllRenderers().forEach((t) => {
            t.checkRenderNextFrame() && ((s = !0), t.clearRenderNextFrame());
          }),
            s && t.scene.requestRender());
        }
      }),
        t.scene.postRender.addEventListener(function () {
          e.wm.update();
        }));
    }
  }
  #Lh(t) {
    ((t.scene.render = (() => this.#kh)()), (this.#kh = void 0));
  }
  load(t, e, i, s, n) {
    const r = t?.dataPath;
    if (this.#f || !r) return;
    let a = this.#Nh.createRenderer(t);
    return (a.load(r, e, i, s, n), a);
  }
  unload(t) {
    !this.#f && t && this.#Nh.destroyRenderer(t);
  }
  getAllRenderers() {
    return this.#f ? [] : this.#Nh.getAllRenderers();
  }
  setCamera(t) {
    t
      ? this.#Re.libType == x
        ? (this.#Re.camera = t)
        : console.error('This API is not supported yet.')
      : console.error('camera is null.');
  }
  update() {
    if (this.#f) return;
    const t = Date.now();
    this.#Nh.wm?.isVerifySig && this.#Nh.update(t);
  }
  dispose() {
    this.#f
      ? console.error('LccManager had been disposed !!!')
      : ((this.#f = !0),
        this.#kh && this.#Bh?.scene && this.#Lh(this.#Bh),
        this.#Bh?.scene?.onAfterRender && (this.#Bh.scene.onAfterRender = function () {}),
        this.#Nh.dispose(),
        (this.#Nh = null));
  }
  raycast(t) {
    return this.#f ||
      !t ||
      !t.evt ||
      Ct(t.evt.x) ||
      Ct(t.evt.y) ||
      Ct(t.maxDistance) ||
      Ct(t.radius) ||
      t.maxDistance < 0 ||
      t.radius < 0
      ? null
      : this.#Nh.raycast(t);
  }
  raycastFromOrigin(t) {
    return this.#f
      ? null
      : t && t.origin && t.direction && !Ct(t.maxDistance) && !Ct(t.radius)
        ? Ct(t.origin.x) ||
          Ct(t.origin.y) ||
          Ct(t.origin.z) ||
          Ct(t.direction.x) ||
          Ct(t.direction.y) ||
          Ct(t.direction.z) ||
          t.maxDistance < 0 ||
          t.radius < 0
          ? null
          : this.#Nh.raycastFromOrigin(t)
        : null;
  }
  clearIndexDB() {
    this.#Nh?.clearIndexDB();
  }
  static getVersion() {
    return t;
  }
}
let Ws = null;
const Qs = {
  load: function (t, e, i, s, n) {
    return (Ws || (Ws = new Gs(t, n)), Ws.load(t, e, i, s, n));
  },
  setCamera(t) {
    Ws?.setCamera(t);
  },
  update: function () {
    Ws?.update();
  },
  unload: function (t) {
    Ws?.unload(t);
  },
  dispose: function () {
    (Ws?.dispose(), (Ws = void 0));
  },
  raycast: function (t) {
    return Ws?.raycast(t);
  },
  raycastFromOrigin: function (t) {
    return Ws?.raycastFromOrigin(t);
  },
  clearIndexDB() {
    (console.log('LCCRender clear indexdb'), Ws?.clearIndexDB());
  },
  getVersion: () => Gs.getVersion(),
};
export { Qs as LCCRender };
